const _ = {
  T_50_XYL_2NBCL_BLOODMOON_SKYBOX: "月读天空背景",
  BR_WORKSHOP_INVALID_PERFORMANCE_COST: "场景资源过多，发布失败，请删减资源",
  BR_WORKSHOP_NO_PERMISSION_PUB_MONETIZATION_MAP: "没有权限使用会员系统相关的功能",
  T_12_I_GIFT_SENDER_BELL: "铃铛",
  T_12_L_ACCESSORY_COS_MOTORHELMET_DESC: "“复制人杀手”骑手佩戴的头盔，标识性极强的冷峻双色。[FFB300](不显示头盔)[-]",
  T_12_L_ACCESSORY_COS_SANTAHEAD: "圣诞银胡",
  T_12_L_COS_PINKMAN: "红粉暴龙",
  T_12_L_COS_POLAR: "圣诞白熊",
  T_12_L_COS_RENDER: "彩虹小暴龙",
  T_12_L_COS_TIGER: "侏罗纪之虎",
  T_12_L_MALE_BOTTOM_COS_ELF: "圣诞精灵（裤子）",
  T_12_L_MALE_COS_SANTA: "超进化版圣诞老人",
  T_12_L_MALE_HAIR_COS_ELF: "圣诞精灵（头饰）",
  T_12_L_MALE_SHOE_COS_ELF: "圣诞精灵（鞋子）",
  T_12_L_MALE_TOP_COS_ELF: "圣诞精灵（上衣）",
  T_12_O_CAT_NAME: "猫猫",
  T_12_O_M1014_CHRISTMAS_NAME: "大号礼物递送器",
  T_12_O_MACHETE_GOLD_NAME: "法老裁决",
  T_12_O_PET_TITLE: "宠物",
  T_12_Q_ITEM_AN94: "AN94",
  T_12_Q_ITEM_DOUBLEJUMPSHOE: "弹跳动力鞋",
  T_12_Q_ITEM_DOUBLEJUMPSHOE_DESC: "装配了科技动力装置的鞋，可以让你在空中二段跳跃",
  T_12_Q_ITEM_FLYSHOE: "喷气飞行鞋",
  T_12_Q_ITEM_FLYSHOE_DESC: "实施空中作战的辅助装备，但需要随时注意能量的消耗",
  T_12_Q_ITEM_STOCK1: "枪托Lv1",
  T_12_Q_ITEM_STOCK2: "枪托Lv2",
  T_12_Q_ITEM_STOCK3: "枪托Lv3",
  T_12_Q_ITEM_TREATMENTGUN: "治疗手枪",
  T_12_Q_ITEM_VEST4: "防爆甲",
  T_12_R_CHARACTER_GANGLEADER_NAME: "安东尼奥",
  T_12_R_CHARACTER_MONKEYGOD_NAME: "Wukong",
  T_12_R_EMOTE_SHOOTDANCE_NAME: "Shoot舞步",
  T_12_R_EMOTE_WAVE_NAME: "臂波浪",
  T_12_R_SKILL_NAME_GANGLEADER: "大佬气魄",
  T_12_R_SKILL_NAME_MONKEYGOD: "幻化术",
  T_13_I_COLLECTION_V_AMPHIBIAN: "水陆两栖车",
  T_13_I_COLLECTION_V_JEEP: "吉普车",
  T_13_I_COLLECTION_V_MONSTER: "大脚车",
  T_13_I_COLLECTION_V_MOTOBIKE: "摩托车",
  T_13_I_COLLECTION_V_ROADSTER: "跑车",
  T_13_I_COLLECTION_V_SUV: "SUV",
  T_13_I_COLLECTION_V_TUTU: "TuTu车",
  T_13_L_MALE_ACCESSORY_COS_BJD: "傀儡无心（面饰）",
  T_13_L_MALE_BOTTOM_COS_VALENTINE: "粉红甜心（裤子）",
  T_13_L_MALE_HAIR_COS_BJD: "傀儡无心（头饰）",
  T_13_L_MALE_TOP_COS_VALENTINE: "粉红甜心（上衣）",
  T_13_M_PVE_MATCH_SUMMARY_WEAPON: "武器",
  T_13_O_PETSKIN_OCELOT_CAT_NAME: "宠物皮肤：探险家喵喵",
  T_13_O_SCAR_VALENTINE_NAME: "丘比特之枪",
  T_13_R_CHARACTER_HACKERGIRL_NAME: "莫科",
  T_13_R_EMOTE_BABYSHARK_NAME: "鲨鱼宝宝操",
  T_13_R_EMOTE_BOMBSQUAD_NAME: "非日常俯卧撑",
  T_13_R_EMOTE_EGYPT_NAME: "法老舞步",
  T_13_R_PVE_WEAPON_SLOT: "武器槽位",
  T_13_R_PVE_WEAPONSKIN_RANGE: "射程",
  T_13_R_PVE_WEAPONSKIN_SPEED: "射速",
  T_13_R_SKILL_DESC_HACKERGIRL: "标记被角色击中的敌人，持续[FFB300]{0}秒[-]。标记信息将会同步给队友。",
  T_13_R_SKILL_NAME_HACKERGIRL: "黑客之眼",
  T_13_Z_KICKOFF_BAN: "屏蔽",
  T_13_Z_ROOM_MORNING: "白天",
  T_13_Z_ROOM_NIGHT: "黑夜",
  T_14_G_ITEM_KATANA: "武士刀",
  T_14_I_HEADPIC_SONGKRAN_NAME: "泼泼！",
  T_14_L_ACCESSORY_COS_EASTERHEAD2: "可爱立方体",
  T_14_L_COS_EASTER: "1937号观察员",
  T_14_L_FEMALE_SHOE_COS_FIREFIGHTERS: "消防卫兵（鞋子）",
  T_14_L_MALE_ACCESSORY_COS_EASTERRABBIT: "兔老大（面饰）",
  T_14_O_AK_WATERSPLASHING_NAME: "水花兄弟",
  T_14_O_DOG_NAME: "机械犬",
  T_14_O_PETSKIN_IRON_DOG_NAME: "宠物皮肤：钢铁犬",
  T_14_O_PETSKIN_LIGNTNING_DOG_NAME: "宠物皮肤：闪电犬",
  T_14_O_PETSKIN_MAGNETIC_DOG_NAME: "宠物皮肤：磁力犬",
  T_14_O_PETSKIN_NIGHT_CAT_NAME: "宠物皮肤：暗夜小猫",
  T_14_O_SCAR_BLOODMOON_NAME: "暗无天日",
  T_14_O_SCAR_SHARK_NAME: "巨齿鲨·撕咬",
  T_14_Q_ITEM_RGS50: "反载具榴弹",
  T_14_R_CHARACTER_SAMURAI_NAME: "夜神隼",
  T_14_R_SKILL_DESC_SAMURAI: "每降低最大血量的[FFB300]{0}%[-]，提升[FFB300]{1}%[-]护甲穿透率",
  T_14_R_SKILL_NAME_SAMURAI: "护甲穿透",
  T_15_L_MALE_ACCESSORY_COS_FAIM: "饥饿骑士（面饰）",
  T_15_L_MALE_ACCESSORY_COS_PESTILENCE: "瘟疫骑士（面饰）",
  T_15_L_MALE_BOTTOM_COS_FAIM: "饥饿骑士（裤子）",
  T_15_L_MALE_BOTTOM_COS_PESTILENCE: "瘟疫骑士（裤子）",
  T_15_L_MALE_SHOE_COS_FAIM: "饥饿骑士（鞋子）",
  T_15_L_MALE_SHOE_COS_PESTILENCE: "瘟疫骑士（鞋子）",
  T_15_L_MALE_TOP_COS_FAIM: "饥饿骑士（上衣）",
  T_15_L_MALE_TOP_COS_PESTILENCE: "瘟疫骑士（上衣）",
  T_15_L_TOP_COS_MOTHERSDAY: "炫妈",
  T_15_O_AN94_APOCALYPSE_NAME: "焚烧殆尽",
  T_15_O_BASEBALLBAT_VIKING_NAME: "维京之棍",
  T_15_O_M1014_APOCALYPSE_NAME: "死亡天启",
  T_15_O_M4A1_APOCALYPSE_NAME: "瘟疫劫难",
  T_15_O_PANTHER_NAME: "黑豹",
  T_15_O_PETSKIN_CAPTAIN_PANTHER_NAME: "队长",
  T_15_O_PETSKIN_GOLDEN_PANTHER_NAME: "黄金豹",
  T_15_O_PETSKIN_PURPLE_PANTHER_NAME: "主宰",
  T_15_O_SKS_DEATH_NAME: "死战不止",
  T_15_O_UMP_APOCALYPSE_NAME: "末日荒灾",
  T_15_Q_ITEM_CG15: "CG15",
  T_15_Q_ITEM_GATLING: "加特林",
  T_15_R_CHARACTER_AGENT_NAME: "劳拉",
  T_15_R_EMOTE_LETSGROOVE_NAME: "一起摇摆",
  T_15_R_SKILL_DESC_AGENT: "开镜时，射击精准度提升[FFB300]{0}%[-]",
  T_15_R_SKILL_NAME_AGENT: "精准射击",
  T_15_W_BACKPACK_MECHGIRL_NAME: "机甲包",
  T_16_B_ITEM_GRAPPLINGHOOK: "钩锁头",
  T_16_B_ITEM_GRAPPLINGHOOKGUN: "钩锁枪",
  T_16_L_MALE_COS_LEGO: "积木暴徒",
  T_16_L_MALE_SHOE_COS_SUMMER: "沙滩型男（鞋子）",
  T_16_P_MANUAL_MONSTER: "大脚车",
  T_16_P_MANUAL_MUSHROOM1: "1级蘑菇",
  T_16_P_MANUAL_MUSHROOM2: "2级蘑菇",
  T_16_P_MANUAL_MUSHROOM3: "3级蘑菇",
  T_16_P_MANUAL_MUSHROOM4: "4级蘑菇",
  T_16_P_MANUAL_ROADSTER_DESC: "帅气的跑车，血量较低，但速度非常迅猛，最多可乘坐2人。",
  T_16_P_MANUAL_STROP: "滑索",
  T_16_P_MANUAL_SUV: "皮卡",
  T_16_P_MANUAL_SUV_DESC: "Free Fire的代表载具！拥有中等血量，中等的最高速度，最多可乘坐2人。",
  T_16_P_MANUAL_TUTU_DESC: "血量较低，加速和爬坡能力偏弱，最多可乘坐3人。",
  T_16_P_MANUAL_WEAPON_AR: "步枪",
  T_16_P_MANUAL_WEAPON_BOMB: "投掷物",
  T_16_P_MANUAL_WEAPON_PISTOL: "手枪",
  T_16_P_MANUAL_WEAPON_SG: "霰弹枪",
  T_16_P_MANUAL_WEAPON_SMG: "冲锋枪",
  T_16_P_MANUAL_WEAPON_SR: "狙击枪",
  T_16_Q_MINISENTRY: "迷你哨塔",
  T_16_Q_MINISENTRY_DESC: "高科技材料制成的人工智能哨塔，会主动搜索并攻击一定范围内的敌人",
  T_16_R_EMOTE_DESERT_NAME: "愤怒之捶",
  T_16_R_EMOTE_EPHUNTER_NAME: "战舞",
  T_16_R_EMOTE_EPHUNTER2_NAME: "High Five",
  T_16_R_EMOTE_KICKTHEMOON_NAME: "Kick the moon",
  T_16_R_EMOTE_WIGGLEWALK_NAME: "Wiggle walk",
  T_16_W_AK_FIRE_NAME: "火之欣喜",
  T_16_W_SCAR_LLENN_NAME: "SCAR- Pink Devil",
  T_16_W_SCAR_WATER_NAME: "潺潺流动",
  T_16_Y_CHARACTER_HITMAN_NAME: "拉法尔",
  T_16_Y_PANDA_NAME: "熊猫",
  T_16_Y_PETSKIN_BROWN_PANDA_NAME: "野战熊猫",
  T_16_Y_PETSKIN_SKELETON_PANDA_NAME: "骷髅",
  T_16_Y_PETSKIN_THOR_PANDA_NAME: "雷霆",
  T_17_B_CS_MODE_NAME: "团队突袭",
  T_17_C_SKILL_NAME_PLAYBOY: "快速脱战",
  T_17_L_FEMALE_ACCESSORY_COS_JOKER_ROYAL: "贵族小丑（面饰）",
  T_17_L_FEMALE_ACCESSORY_COS_VAMPIRE: "暗夜贵妇（面饰）",
  T_17_L_FEMALE_BOTTOM_COS_VAMPIRE: "暗夜贵妇（裤子）",
  T_17_L_FEMALE_HAIR_COS_SELVEDGEWORK: "灵狐（头饰）",
  T_17_L_FEMALE_SHOE_COS_VAMPIRE: "暗夜贵妇（鞋子）",
  T_17_L_FEMALE_TOP_COS_VAMPIRE: "暗夜贵妇（上衣）",
  T_17_L_MALE_ACCESSORY_COS_VAMPIRE: "嗜血男爵（面饰）",
  T_17_L_MALE_BOTTOM_COS_BOSOZOKU: "无我狂徒（裤子）",
  T_17_L_MALE_BOTTOM_COS_VAMPIRE: "嗜血男爵（裤子）",
  T_17_L_MALE_HAIR_COS_FFUNIT: "神秘枪火（头饰）",
  T_17_L_MALE_SHOE_COS_INDEPENDENCE: "绅士之风（鞋子）",
  T_17_L_MALE_SHOE_COS_VAMPIRE: "嗜血男爵（鞋子）",
  T_17_L_MALE_TOP_COS_VAMPIRE: "嗜血男爵（上衣）",
  T_17_L_MALE_TOP_COS_YINYANG_GOLD: "阴阳白金（上衣）",
  T_17_O_PETSKIN_ANNIVERSARY_CAT_NAME: "宠物皮肤：喵喵公主",
  T_17_O_PETSKIN_EARTHDRAGON_SHIBA_NAME: "宠物皮肤：曲黄",
  T_17_O_PETSKIN_ELECTRICDRAGON_SHIBA_NAME: "宠物皮肤：曲蓝",
  T_17_O_PETSKIN_GREENDRAGON_SHIBA_NAME: "宠物皮肤：曲绿",
  T_17_O_SHIBA_NAME: "曲子",
  T_17_Q_FOLDWINGS: "滑翔翼",
  T_17_Q_FOLDWINGS_DESC: "可以在天空飞行的滑翔翼，用它从高处降落可以移动到更远的地方",
  T_17_Q_SUPERHEAT: "过热能量枪",
  T_17_R_EMOTE_PARTYDANCE_NAME: "Party Dance",
  T_17_W_FAMAS_VAMPIRE_NAME: "吸血鬼—FAMAS",
  T_17_W_SCAR_ASSASSIN_NAME: "火线刺客—SCAR",
  T_17_W_SCAR_PLAYBOY_NAME: "花花公子—SCAR",
  T_17_Y_CHARACTER_MADEMANA_NAME: "A124",
  T_17_Y_CHARACTER_PLAYBOY_NAME: "约瑟",
  T_17_Z_CS_NAME: "名字",
  T_17_Z_ROOM_JUMP_SWITCH: "跳跃高度",
  T_17_Z_ROOM_SPEED_SWITCH: "移动速度",
  T_18_B_THROWINGKNIFE_NAME: "FF Knife",
  T_18_C_DUMMY_NAME: "诱饵手榴弹",
  T_18_C_SKILL_DESC_DJMALE: "[FFB300]{1}米[-]的光环内移动速度提高[FFB300]{3}％[-] ，并在[FFB300]{0}秒[-]内每秒恢复[FFB300]{2}HP[-]。效果无法叠加。CD：[FFB300]{4}秒[-]。",
  T_18_C_SKILL_NAME_DJMALE: "激励旋律",
  T_18_C_SKILL_NAME_JUNKENGINEER: "Gear Recycle",
  T_18_L_COS_INDIANEWYEAR: "深海巨兽",
  T_18_L_HAIR_COS_HALLOWEEN2019: "不高兴",
  T_18_L_MALE_ACCESSORY_COS_BJD2_MAGMA: "红火烈焰(面饰)",
  T_18_O_FOX_NAME: "银狐",
  T_18_O_PETSKIN_BLACKFOX_NAME: "战狐",
  T_18_O_PETSKIN_BLUEFOX_NAME: "蓝狐",
  T_18_O_PETSKIN_HALLOWEEN_SHIBA_NAME: "宠物皮肤：熔岩南瓜",
  T_18_O_PETSKIN_PINKFOX_NAME: "红狐",
  T_18_O_PETSKIN_SPIRIT_PANTHER_NAME: "宠物皮肤：跃灵",
  T_18_U_WEAPON_M1887_NAME: "M1887",
  T_18_W_M4A1_FIRESKELETON_N: "火骷髅M4A1",
  T_18_W_UMP_GEISHA_N: "艺伎UMP",
  T_18_Y_CHARACTER_DJMALE_N: "Alok",
  T_18_Y_CHARACTER_JUNKENGINEER_N: "沙尼",
  T_19_B_HB_NAME: "磁浮滑板",
  T_19_C_ICE_GUN_NAME: "冰墙发射枪",
  T_19_C_SKILL_DESC_DEMOLITIONIST: "爆炸類武器傷害提升 [FFB300]{0}%[-]，範圍擴大 [FFB300]{1}%[-]。",
  T_19_C_SKILL_DESC_TOMBOY: "使用载具时，自身和队友每[FFB300]{0}秒[-]恢复[FFB300]{1}点[-]血量，最高到[FFB300]{2}[-]",
  T_19_C_SKILL_NAME_DEMOLITIONIST: "爆破的艺术",
  T_19_C_SKILL_NAME_TOMBOY: "车神庇佑",
  T_19_I_EVENT_INFI_ITEM: "无限",
  T_19_L_A_ICEFESTIVAL19_B: "狂笑麋鹿",
  T_19_L_F_S_ICEFESTIVAL: "白色圣诞（鞋子）",
  T_19_L_MALE_BOTTOM_COS_DISCOMAN: "复古歌手（裤子）",
  T_19_L_MALE_HAIR_COS_DISCOMAN: "复古歌手（头饰）",
  T_19_L_MALE_TOP_COS_DISCOMAN: "复古歌手（上衣）",
  T_19_O_PETSKIN_NAME: "宠物皮肤：默认皮肤",
  T_19_O_PETSKIN_PANDA_TRAPRAP_NAME: "宠物皮肤：嘻哈熊猫",
  T_19_O_PETSKIN_PANDA_WINTERFELL_NAME: "宠物皮肤：冬日熊猫",
  T_19_O_PETSKIN_ROBOT_PHARAOH_NAME: "宠物皮肤：守墓机器人",
  T_19_O_PETSKIN_ROBOT_SPRING_NAME: "宠物皮肤：春节滚滚",
  T_19_O_PETSKIN_ROBOT_WINTERFELL_NAME: "宠物皮肤：冰雪滚滚",
  T_19_O_PETSKIN_SHIBA_TRAPRAP_NAME: "宠物皮肤：嘻哈曲子",
  T_19_O_ROBOT_NAME: "滚滚",
  T_19_O_TDM_NAME: "团队死亡竞赛",
  T_19_R_EMOTE_MIGUEL_NAME: "Break dance",
  T_19_S_SECOND_WEAPON_TITLE: "副武器",
  T_19_S_VEST_TITLE: "防弹衣",
  T_19_U_DOUBLEMAGEZINE_ATTACHMENT_NAME: "双捆弹夹",
  T_19_W_GROZA_TAGGERCREW_N: "涂鸦主题GROZA",
  T_19_W_M60_ICEFESTIVAL_N: "冰雪节M60",
  T_19_W_MP40_PARK_N: "杀人游乐园MP40",
  T_19_W_SCAR_CNNEWYEAR19_N: "春节SCAR",
  T_19_X_PVE_SAMURAINAME: "守社武士",
  T_19_Y_CHARACTER_DEMOLITIONIST_N: "奥尔瓦罗",
  T_19_Y_CHARACTER_TOMBOY_N: "娜塔拉",
  T_20_C_INHALER_NAME: "治疗呼吸器",
  T_20_C_SKILL_DESC_PARKOURGUY: "使用枪械命中敌人可以少量恢复hp，击倒敌人可以恢复[FFB300]{0}%[-]的hp",
  T_20_C_SKILL_NAME_GRAFFITIST: "涂鸦庇护",
  T_20_C_SKILL_NAME_KELLY_AWAKENING: "燃烧疾跑",
  T_20_C_SKILL_NAME_PARKOURGUY: "持久突袭",
  T_20_L_A_APRILFOOL2020: "来打我呀",
  T_20_L_F_A_METALHEAD_RED: "赤备兜（面饰）",
  T_20_L_F_B_THAIGIRL: "恰可拉发特（裤子）",
  T_20_L_F_H_KILLERCUPID: "爱心射手（头饰）",
  T_20_L_F_H_THAIGIRL: "恰可拉发特（头饰）",
  T_20_L_F_S_THAIGIRL: "恰可拉发特（鞋子）",
  T_20_L_F_T_METALHEAD_RED: "赤备兜（上衣）",
  T_20_L_F_T_THAIGIRL: "恰可拉发特（上衣）",
  T_20_L_JEANDINO: "牛仔裤恐龙",
  T_20_L_M_A_METALHEAD_RED: "赤备战盔（面饰）",
  T_20_L_M_T_METALHEAD_RED: "赤备战盔（上衣）",
  T_20_L_M_T_STOCKING: "绝对绅士（上衣）",
  T_20_O_PETSKIN_LOVERFOX_NAME: "情人节狐狸",
  T_20_P_CHANNEL_G: "公会",
  T_20_P_WORLD_SSPEAKER: "喇叭",
  T_20_S_CSROOM_COIN: "初始金币",
  T_20_U_SHIELD_GUN_NAME: "护盾枪",
  T_20_W_AN94_METALHEAD_N: "孵化室金属脑壳主题AN94",
  T_20_W_P90_EVILBONE_N: "恶骨小队主题P90",
  T_20_Y_CHARACTER_GRAFFITIST_N: "斯蒂芬妮",
  T_20_Y_CHARACTER_KELLY_AWAKENING_N: "凯莉“闪电”",
  T_20_Y_CHARACTER_PARKOURGUY_N: "Jota",
  T_21_B_SMOKEGRENADE_DESC: "使用后可以产生遮蔽事件的烟雾，是打扰敌人进攻的利器",
  T_21_B_SMOKEGRENADE_NAME: "烟雾弹",
  T_21_C_AUTOPICKUP_AVERAGE: "默认",
  T_21_C_SKILL_DESC_KPOPSINGER: "救助友军时，会给予友军[FFB300]{0}HP[-]的护盾和[FFB300]{1}%[-]的移动速度，救起后增益效果会在[FFB300]{2}s[-]秒内递减。同时降低友军频死掉血速度[FFB300]{3}%[-]，技能效果不叠加。",
  T_21_C_SKILL_DESC_SOCCERSTAR: "每击杀1人，生命值最大值提升[FFB300]]{0}[-]，上限[FFB300]{1}[-]。",
  T_21_C_SKILL_NAME_KPOPSINGER: "治愈吟唱",
  T_21_C_SKILL_NAME_SOCCERSTAR: "帽子戏法",
  T_21_L_ANGELICAL: "翅膀恐龙",
  T_21_L_S_VNSLIPPER: "越南拖鞋",
  T_21_O_OTTER_NAME: "皮皮",
  T_21_O_PETSKIN_OTTER_GREY_NAME: "宠物皮肤：辐射皮皮",
  T_21_O_PETSKIN_OTTER_PINK_NAME: "宠物皮肤：嘤嘤皮皮",
  T_21_O_PETSKIN_OTTER_PURPLE_NAME: "宠物皮肤：暗夜皮皮",
  T_21_O_PETSKIN_ROBOT_DEATH_NAME: "宠物皮肤：死神滚滚",
  T_21_O_PETSKIN_SPINE_PANTHER_NAME: "宠物皮肤：朋克队长",
  T_21_R_EMOTE_SORROW_NAME: "Why? Oh Why?",
  T_21_U_WEAPON_THOMPSON_NAME: "Thompson",
  T_21_W_BACKPACK_SPINE_N: "脊椎朋克背包",
  T_21_W_BASEBALLPOLE_DEATH2020_N: "死神主题棒球棍",
  T_21_W_M79_RABBITKILLER_N: "复活节爱杀兔主题M79",
  T_21_W_PAN_VOLCANO_N: "熔岩主题平底锅",
  T_21_W_XM8_RAINBOW_N: "泼水节主题XM8",
  T_21_Y_CHARACTER_KPOPSINGER_N: "Kapella",
  T_21_Y_CHARACTER_SOCCERSTAR_N: "卢卡斯",
  T_22_C_BLT_NAME: "M82B",
  T_22_C_SKILL_DESC_DETECTIVE: "显示[FFB300]{0}米[-]内的敌人（不包括蹲、趴姿）位置 ，持续[FFB300]{1}秒[-]，队友共享效果，CD： [FFB300]{2}秒[-]。",
  T_22_C_SKILL_NAME_DETECTIVE: "足迹侦察",
  T_22_C_SKILL_NAME_STREAMERGUY: "万众瞩目",
  T_22_L_F_H_COLLEGE: "学生会副会长（头饰）",
  T_22_L_F_S_SUMMER20: "沫沫茶（鞋子）",
  T_22_L_M_A_GREENCOAT: "rapper草绿（面饰）",
  T_22_L_M_A_PINKFUR: "rapper皮草（面饰）",
  T_22_L_M_A_PLAGUE2: "瘟疫后传（面饰）",
  T_22_L_M_B_FAIM2: "饥饿后传（裤子）",
  T_22_L_M_B_GREENCOAT: "rapper草绿（裤子）",
  T_22_L_M_B_PINKFUR: "rapper皮草（裤子）",
  T_22_L_M_B_PLAGUE2: "瘟疫后传（裤子）",
  T_22_L_M_B_REDPANTS: "rapper藏蓝（裤子）",
  T_22_L_M_B_TIGERSTRIPE: "rapper虎皮（裤子）",
  T_22_L_M_H_COLLEGE: "学生会会长（头饰）",
  T_22_L_M_H_FAIM2: "饥饿后传（头饰）",
  T_22_L_M_H_GREENCOAT: "rapper草绿（头饰）",
  T_22_L_M_H_PINKFUR: "rapper皮草（头饰）",
  T_22_L_M_H_PLAGUE2: "瘟疫后传（头饰）",
  T_22_L_M_H_REDPANTS: "rapper藏蓝（头饰）",
  T_22_L_M_H_TIGERSTRIPE: "rapper虎皮（头饰）",
  T_22_L_M_S_FAIM2: "饥饿后传（鞋子）",
  T_22_L_M_S_PLAGUE2: "瘟疫后传（鞋子）",
  T_22_L_M_T_FAIM2: "饥饿后传（上衣）",
  T_22_L_M_T_GREENCOAT: "rapper草绿（上衣）",
  T_22_L_M_T_PINKFUR: "rapper皮草（上衣）",
  T_22_L_M_T_PLAGUE2: "瘟疫后传（上衣）",
  T_22_L_M_T_REDPANTS: "rapper藏蓝（上衣）",
  T_22_L_M_T_TIGERSTRIPE: "rapper虎皮（上衣）",
  T_22_LC_KAR98K_COLLEGE_N: "战争学院主题Kar98K",
  T_22_LC_PAN_CAPTAINBUBBLE_N: "夏日水泡船长主题平底锅",
  T_22_LC_SCAR_HERMIT_N: "修行者主题SCAR",
  T_22_LC_TREATMENTGUN_APOCALYPSE2_N: "EP天启死亡&战争主题治疗枪",
  T_22_O_HAWK_NAME: "天际",
  T_22_O_PETSKIN_FOX_APOCALYPSE_NAME: "宠物皮肤：灾狐",
  T_22_O_PETSKIN_HAWK_FIRE_NAME: "宠物皮肤：火鹰",
  T_22_O_PETSKIN_HAWK_NATURE_NAME: "宠物皮肤：森林之子",
  T_22_O_PETSKIN_SHIBA_SUMMER_NAME: "宠物皮肤：曲夏",
  T_22_Q_BOMB_PLIERS: "拆弹钳",
  T_22_R_EMOTE_SHIMMY_NAME: "Shimmy",
  T_22_U_GOLD_AWM_N: "AWM_Y",
  T_22_U_WPNSKN_BITE: "护甲穿透",
  T_22_U_WPNSKN_SPEED_RUN: "持枪移动力",
  T_22_Y_CHARACTER_DETECTIVE_N: "Clu",
  T_22_Y_CHARACTER_STREAMERGUY_N: "Wolfrahh",
  T_23_B_CARDIAC_NAME: "强心针",
  T_23_C_SKILL_NAME_HAYATO_AWAKENING: "拔刀格挡",
  T_23_C_SKILL_NAME_SWATGUY: "愤怒子弹",
  T_23_D_CHARACTER_HAYATO_AWAKENING_N: 'Hayato "Firebrand"',
  T_23_D_CHARACTER_SWATGUY_N: "Jai",
  T_23_L_F_B_GANGSTERRAP_GOLD: "匪帮说唱女裤子金",
  T_23_L_F_B_MIKOGIRL: "巫女裤子",
  T_23_L_F_B_NAVYGIRL: "海军服裤子",
  T_23_L_F_H_GANGSTERRAP_GOLD: "匪帮说唱女头饰金",
  T_23_L_F_H_MIKOGIRL: "巫女头饰",
  T_23_L_F_H_NAVYGIRL: "海军服头饰",
  T_23_L_F_S_MIKOGIRL: "巫女鞋子",
  T_23_L_F_S_ORDERCHALLENGER: "秩序挑战女鞋子",
  T_23_L_F_T_GANGSTERRAP_GOLD: "匪帮说唱女上衣金",
  T_23_L_F_T_MIKOGIRL: "巫女上衣",
  T_23_L_F_T_NAVYGIRL: "海军服上衣",
  T_23_L_M_A_GANGSTERRAP_GOLD: "匪帮说唱男面饰金",
  T_23_L_M_B_FOXGUY: "狐狸男裤子",
  T_23_L_M_B_GANGSTERRAP_GOLD: "匪帮说唱男裤子金",
  T_23_L_M_H_FOXGUY: "狐狸男头饰",
  T_23_LC_SKS_GEMINI_N: "双重人格主题枪械SKS",
  T_23_O_PENGUIN_NAME: "鹅子",
  T_23_O_PETSKIN_PENGUIN_A_NAME: "宠物皮肤：狂欢企鹅",
  T_23_O_PETSKIN_PENGUIN_C_NAME: "宠物皮肤：赛博鹅",
  T_23_O_PETSKIN_PENGUIN_G_NAME: "宠物皮肤：金鹅",
  T_23_T_ANNI3_LOBBY_NODENAME20: "团队突袭",
  T_23_T_ANNI3_LOBBY_NODENAME5: "角色",
  T_23_U_AUG: "AUG",
  T_23_Z_R_UID: "UID",
  T_24_AD_ADSPACE_WARNING: "警告",
  T_24_C_FLAMETHROWER_NAME: "喷火器",
  T_24_C_SKILL_DESC_PROFESSOR: "EP上限增加[FFB300]{0}[-]；切换到柔道大师时：[FFB300]{2}米[-]内我方EP转化提升[FFB300]{1}%[-]；切换到心理学时：每[FFB300]{4}秒[-]补充[FFB300]{5} EP[-]，上限[FFB300]{6}点[-]；切换CD：[FFB300]{3}秒[-]。",
  T_24_C_SKILL_NAME_PARTYGIRL: "派对舞王",
  T_24_C_SKILL_NAME_PROFESSOR: "多面精英",
  T_24_D_CHARACTER_PARTYGIRL_N: "Dasha",
  T_24_D_CHARACTER_PROFESSOR_N: "K",
  T_24_L_B_MAXPANTS: "MAX版N级裤子",
  T_24_L_H_PUMPKIN2020_A: "2020万圣节升级发型",
  T_24_L_T_TSHIRT_COMEDIAN: "泰国喜剧人T恤",
  T_24_LC_MP5_RICHBOXER_N: "百万拳霸主题MP5",
  T_24_LC_SCAR_PARTYGIRL_N: "特殊角色派对女孩主题SCAR",
  T_24_LC_SVD_WARRINGSTATES_N: "幕府大名主题SVD",
  T_24_U_M21A5: "Woodpecker",
  T_24_U_PARAFAL: "PARAFAL",
  T_24_V_TRAINING_AIMBOT_GAMESCORE: "总分",
  T_24_V_TRAINING_BOX_ATTACH: "配件",
  T_24_V_TRAINING_BOX_WEAPON: "武器",
  T_24_W_ARMORY: "武器",
  T_24_W_ARMOTY_MELEE: "近战武器",
  T_24_W_ARMOTY_PISTOL: "手枪",
  T_24_W_ARMOTY_RIFLE: "步枪",
  T_24_W_ARMOTY_SHOTGUN: "霰弹枪",
  T_24_W_ARMOTY_SNIPER: "狙击枪",
  T_24_W_ARMOTY_SPECIAL: "特殊武器",
  T_24_W_ARMOTY_SUBMACHINE: "冲锋枪",
  T_24_W_PETSKIN_PANDA_BOOYAHDAY_N: "宠物皮肤：Booyah熊猫",
  T_24_W_PETSKIN_RACCOON_BRIGHT_N: "宠物皮肤：火焰浣熊",
  T_24_W_PETSKIN_RACCOON_MECH_N: "宠物皮肤：摩登浣熊",
  T_24_W_PETSKIN_RACCOON_UNDEAD_N: "宠物皮肤：亡灵浣熊",
  T_24_W_RACCOON_N: "嘉奇",
  T_25_C_SKILL_NAME_BOUNTYHUNTER: "时空屏障",
  T_25_D_CHARACTER_BOUNTY_N: "Chrono",
  T_25_E_HUD_01: "方案1",
  T_25_E_HUD_02: "方案2",
  T_25_L_F_B_DEMONKILLER: "杀鬼队女裤子",
  T_25_L_F_H_DEMONKILLER: "杀鬼队女头饰",
  T_25_L_F_S_DEMONKILLER: "杀鬼队女鞋子",
  T_25_L_F_T_DEMONKILLER: "杀鬼队女上衣",
  T_25_L_HA_FP_EVIL: "25单品妆容8",
  T_25_L_M_H_ANIMEHAIR: "漫画少年发型",
  T_25_L_S_MAXSNEAKERS: "Max鞋子",
  T_25_LC_BASEBALLBAT_BOUNTY_N: "赏金猎人合作赛博朋克主题棒球棍",
  T_25_LC_GLOO_WINTERFEST2020_N: "冰雪节主题泡沫手雷",
  T_25_LC_M1887_WINTERFEST2020_N: "冰雪节主题M1887",
  T_25_LC_MACHETE_BOUNTY_N: "赏金猎人合作赛博朋克主题大砍刀",
  T_25_LC_P90_MUSICFALL_GREEN_N: "孵化室音陨主题绿色P90",
  T_25_LC_P90_MUSICFALL_RED_N: "孵化室音陨主题红色P90",
  T_25_LC_PAN_BOUNTY_N: "赏金猎人合作赛博朋克主题平底锅",
  T_25_R_LEGEND_REMIND: "提醒",
  T_25_U_MAG7: "MAG-7",
  T_25_U_SICKLE: "Scythe",
  T_25_U_VECTOR: "Vector",
  T_25_W_BABOON_N: "狒狒",
  T_25_W_PETSKIN_BABOON_FROZEN_N: "冻人酷狒",
  T_25_W_PETSKIN_BABOON_HELL_N: "地狱怒狒",
  T_25_W_PETSKIN_BABOON_PURE_N: "Petskin: Glacier Beaston",
  T_25_W_PETSKIN_PANTHER_WINTERFEST2020_N: "冰雪之豹",
  T_25_Z_R_SIMULATOR_OFF: "禁止",
  T_26_C_SKILL_DESC_SUPERSTAR: "向前发射一道音波，最远[FFB300]{0}米[-]。命中障碍后爆炸，对半径[FFB300]{1}米[-]内凝胶护盾每秒造成伤害，持续[FFB300]{2}秒[-]。CD：[FFB300]{3}秒[-]。",
  T_26_C_SKILL_NAME_SUPERSTAR: "音波爆破",
  T_26_D_CHARACTER_DELIVERY_N: "Shiro",
  T_26_D_CHARACTER_SUPERSTAR_N: "Skyler",
  T_26_ET_CELLPHONE_NAME: "个人UAV",
  T_26_L_A_FLAMING_PREM: "燃烧军团面饰",
  T_26_L_A_SANTAMODE: "雪人面饰",
  T_26_L_B_SANTAMODE: "雪人裤子",
  T_26_L_F_B_WATERFEST21_A: "21泼水节女裤子",
  T_26_L_F_H_WATERFEST21_A: "21泼水节女头饰",
  T_26_L_F_S_WATERFEST21_A: "21泼水节女鞋子",
  T_26_L_F_T_WATERFEST21_A: "21泼水节女上衣",
  T_26_L_M_A_EGGDAY2021: "镭光疯兔男面饰",
  T_26_L_M_B_EGGDAY2021: "镭光疯兔男裤子",
  T_26_L_M_B_PAIRING: "结对系统男裤子",
  T_26_L_M_B_WATERFEST21_A: "21泼水节男裤子",
  T_26_L_M_H_EGGDAY2021: "镭光疯兔男头饰",
  T_26_L_M_H_PAIRING: "结对系统男头饰",
  T_26_L_M_H_WATERFEST21_A: "21泼水节男头饰",
  T_26_L_M_S_EGGDAY2021: "镭光疯兔男鞋子",
  T_26_L_M_S_PAIRING: "结对系统男鞋子",
  T_26_L_M_S_WATERFEST21_A: "21泼水节男鞋子",
  T_26_L_M_T_EGGDAY2021: "镭光疯兔男上衣",
  T_26_L_M_T_PAIRING: "结对系统男上衣",
  T_26_L_M_T_WATERFEST21_A: "21泼水节男上衣",
  T_26_L_S_SANTAMODE: "雪人鞋子",
  T_26_L_T_SANTAMODE: "雪人上衣",
  T_26_LC_AWM_KOICARP_N: "春节主题AWM",
  T_26_LC_KATANA_VALENTINE2021_N: "情人节主题武士刀",
  T_26_LC_VEHICLE_ROADSTER_COBRA_N: "觉醒狂蟒主题跑车",
  T_26_P_SKILL_NAME_DELIVERY: "反击本能",
  T_26_V_TRAINING_BHH: "大头锤",
  T_26_V_TRAINING_DICE: "巨大骰子",
  T_26_W_DRAGON_N: "龙龙",
  T_26_W_PETSKIN_DRAGON_EVIL_N: "碧蓝幼龙",
  T_26_W_PETSKIN_DRAGON_GOLDEN_N: "电光幼龙",
  T_26_W_PETSKIN_DRAGON_PURPLE_N: "紫星幼龙",
  T_26_W_PETSKIN_PENGUIN_VALENTINE2021_N: "情人节的企鹅",
  T_26_XL_SETTING_TEAMMATE_INFO: "队友信息",
  T_26_YP_HISTORY_WIN: "胜利",
  T_26_YP_SOCIAL_GENDER_FEMALE: "女",
  T_26_YP_SOCIAL_GENDER_MALE: "男",
  T_26_YP_SOCIAL_NAME: "昵称",
  T_27_C_SKILL_DESC__RACERGIRL: "驾驶速度提高 [FFB300]{0}%[-]，在載具上，无法成为敌人的瞄准目标且自身傷害降低 [FFB300]{1}%[-]。",
  T_27_C_SKILL_DESC_BOUNTYHUNTER: "創造一個无法击穿的护盾，可抵擋[FFB300]{0}傷害[-]。无法从护盾内向外攻击；所有效果持續[FFB300]{1}秒[-]；冷卻時間：[FFB300]{2}秒[-]。",
  T_27_C_SKILL_DESC_FALCONER: "距离越远伤害越高，最高[FFB300]{0}%[-]；对被标记的敌人伤害提升[FFB300]{1}%[-]。",
  T_27_C_SKILL_DESC_HAYATO_AWAKENING: "觉醒效果：每降低最大血量的[FFB300]{0}%[-]，减免[FFB300]{1}%[-]正面受到的傷害。",
  T_27_C_SKILL_DESC_KELLY_AWAKENING: "觉醒效果：疾跑[FFB300]{0}秒[-]後獲得效果：[FFB300]{3}秒[-]內，命中敵人的前[FFB300]{2}[-]槍傷害為[FFB300]{1}%[-]",
  T_27_C_SKILL_NAME_FALCONER: "鹰眼",
  T_27_C_SKILL_NAME_XTREME: "极限操作",
  T_27_D_CHARACTER_ANDREW_AWAKENING_N: 'Andrew "the Fierce"',
  T_27_D_CHARACTER_FALCONER_N: "Maro",
  T_27_D_CHARACTER_XTREME_N: "Xenia",
  T_27_F_EAP_PKG3_D: "Battle in style!",
  T_27_HYL_SKILLBOARD_HP: "生命值",
  T_27_L_A_CARDBOARD_MID2: "纸箱老虎面饰",
  T_27_L_B_CARDBOARD_REG: "纸箱棕熊裤子",
  T_27_L_M_S_KAZAKHSTAN: "哈萨克斯坦男鞋子",
  T_27_L_S_CARDBOARD_REG: "纸箱棕熊鞋子",
  T_27_L_T_CARDBOARD_REG: "纸箱棕熊上衣",
  T_27_LC_VECTOR_FFWS2021_N: "FFWS银色子弹主题Vector",
  T_27_LC_VEHICLE_MONSTER_FFWS2021_N: "世界杯银色子弹主题大脚车",
  T_27_LC_VEHICLE_MOTOBIKE_BOXER_N: "终极斗士摩托车",
  T_27_LC_VEHICLE_ROADSTER_FASTBREAKING_N: "印尼开斋节主题跑车",
  T_27_LC_VEHICLE_SUV_DRAGON_N: "龙进化枪主题皮卡车",
  T_27_P_SKILL_NAME_HITMAN_RE: "隐匿杀手",
  T_27_R_EMOTE_GREETING_NAME: "打招呼",
  T_27_R_VEHICLE_ACCELERATION: "加速度",
  T_27_R_VEHICLE_HP: "耐久",
  T_27_R_VEHICLE_SPEED: "最大速度",
  T_27_U_KORD: "Kord",
  T_27_U_M1917: "M1917",
  T_27_U_SKILL_DESC_ANDREW_AWAKENING: "觉醒：护甲减伤效果增强[FFB300]{0}%[-]，[FFB300]{2}米[-]内每存在一位队友额外获得[FFB300]{1}%[-]的减伤收益。",
  T_27_U_SKILL_NAME_ANDREW_AWAKENING: "群狼",
  T_27_U_WSP: "USP-2",
  T_27_W_ALIEN_N: "歪歪",
  T_27_W_ARMOTY_DMR: "精准步枪",
  T_27_W_PETSKIN_ALIEN_CRYSTAL_N: "粉晶闪耀",
  T_27_W_PETSKIN_ALIEN_GAMER_N: "潮玩达人",
  T_27_W_PETSKIN_ALIEN_HIPSTER_N: "文艺青年",
  T_27_W_PETSKIN_DOG_FFWS2021_N: "银色子弹狗",
  T_27_W_PETSKIN_PANDA_FFWS2021_N: "银色子弹熊",
  T_27_XC_REPLAY_DIE: "死亡",
  T_27_XC_REPLAY_KILL: "击杀",
  T_27_XL_WEREWOLVES_INGAME_REPAIR: "修复",
  T_28_C_G_ICE_NAME: "冰冻手雷",
  T_28_C_SKILL_DESC_STREETBEAT: "移动射击时，移速提高[FFB300]{0}%[-]，精准提高[FFB300]{1}%[-]。",
  T_28_C_SKILL_NAME_STREETBEAT: "枪舞",
  T_28_D_CHARACTER_STREETBEAT_N: "D-bee",
  T_28_HI_UZI: "Uzi",
  T_28_L_B_BRJERSEY_A: "美洲杯23号裤子",
  T_28_L_B_BRJERSEY_B: "美洲杯10号裤子",
  T_28_L_B_BRJERSEY_C: "美洲杯24号裤子",
  T_28_L_B_BRJERSEY_D: "美洲杯30号裤子",
  T_28_L_B_BRJERSEY_E: "美洲杯1号裤子",
  T_28_L_B_BRJERSEY_F: "美洲杯20号裤子",
  T_28_L_F_B_FOURSYMBOLS_C: "四神兽朱雀裤子",
  T_28_L_F_H_FOURSYMBOLS_C: "四神兽朱雀头饰",
  T_28_L_F_HA_FOURSYMBOLS_C: "四神兽朱雀妆容",
  T_28_L_F_S_FOURSYMBOLS_C: "四神兽朱雀鞋子",
  T_28_L_F_T_FOURSYMBOLS_C: "四神兽朱雀上衣",
  T_28_L_HA_THUNDER: "闪电眼",
  T_28_L_M_A_SPORTSUIT: "白色潮服面饰",
  T_28_L_M_B_FOURSYMBOLS_D: "四神兽玄武裤子",
  T_28_L_M_B_SPORTSUIT: "白色潮服裤子",
  T_28_L_M_H_FOURSYMBOLS_D: "四神兽玄武头饰",
  T_28_L_M_H_SPORTSUIT: "白色潮服头饰",
  T_28_L_M_S_FOURSYMBOLS_D: "四神兽玄武鞋子",
  T_28_L_M_S_SPORTSUIT: "白色潮服鞋子",
  T_28_L_M_T_FALLWINTER: "秋冬街头男上衣",
  T_28_L_M_T_FOURSYMBOLS_D: "四神兽玄武上衣",
  T_28_L_M_T_SPORTSUIT: "白色潮服上衣",
  T_28_L_T_BRJERSEY_A: "美洲杯23号上衣",
  T_28_L_T_BRJERSEY_B: "美洲杯10号上衣",
  T_28_L_T_BRJERSEY_C: "美洲杯24号上衣",
  T_28_L_T_BRJERSEY_D: "美洲杯30号上衣",
  T_28_L_T_BRJERSEY_E: "美洲杯1号上衣",
  T_28_L_T_BRJERSEY_F: "美洲杯20号上衣",
  T_28_LC_AN94_CRIMSONBRIDE_N: "枪火新娘主题AN94",
  T_28_LC_GLOO_FALLWINTER_N: "巴西秋冬街头主题泡沫手雷",
  T_28_LC_GLOO_FOURSYMBOLS_N: "猎杀日3.0泡沫手雷",
  T_28_LC_KORD_SHINOBI_N: "穿越忍者主题Kord",
  T_28_LC_M21A5_FANTASYEYE_N: "全知魔族主题Woodpecker",
  T_28_LC_MAG7_WHITESHARK_N: "食人鲨主题MAG7",
  T_28_LC_PAN_FOURSYMBOLS_N: "猎杀日3.0四圣兽主题玄武平底锅",
  T_28_LC_VEHICLE_JEEP_FOURSYMBOLS_N: "猎杀日3.0四圣兽主题吉普车",
  T_28_T_WS_ITEM1: "方形木箱",
  T_28_T_WS_ITEM10: "渔村小屋",
  T_28_T_WS_ITEM11: "哨塔",
  T_28_T_WS_ITEM12: "警卫室",
  T_28_T_WS_ITEM13: "一层民居",
  T_28_T_WS_ITEM14: "二层民居1",
  T_28_T_WS_ITEM15: "二层民居2",
  T_28_T_WS_ITEM16: "心形沙雕",
  T_28_T_WS_ITEM17: "喷泉",
  T_28_T_WS_ITEM18: "樱花树",
  T_28_T_WS_ITEM19: "香蕉树",
  T_28_T_WS_ITEM2: "长木箱",
  T_28_T_WS_ITEM20: "马桶",
  T_28_T_WS_ITEM21: "围栏",
  T_28_T_WS_ITEM3: "灌木",
  T_28_T_WS_ITEM4: "草垛",
  T_28_T_WS_ITEM5: "损坏汽车",
  T_28_T_WS_ITEM6: "巴士",
  T_28_T_WS_ITEM7: "集装箱1",
  T_28_T_WS_ITEM8: "集装箱2",
  T_28_T_WS_ITEM9: "集装箱3",
  T_28_T_WS_TYPE1: "小型物体",
  T_28_T_WS_TYPE4: "装饰物",
  T_28_W_DUCK_N: "丫丫",
  T_28_W_PETSKIN_DRAGON_FOURSYMBOLS_N: "圣龙",
  T_28_W_PETSKIN_DUCK_ARMY_N: "武装丫",
  T_28_W_PETSKIN_DUCK_BLACK_N: "黑丫",
  T_28_W_PETSKIN_DUCK_SHINY_N: "炫彩丫",
  T_28_YF_AR15: "Kingfisher",
  T_29_C_SKILL_DESC_MOCO_AWAKENING: "觉醒：被击中的敌人移动时会延长标记的时间，最多延长[FFB300]{0}秒[-]。",
  T_29_C_SKILL_NAME_MOCO_AWAKENING: "黑客主宰",
  T_29_C_SKILL_NAME_MUSICBRO_BLACK: "节奏医生",
  T_29_C_SKILL_NAME_MUSICBRO_WHITE: "心跳节拍",
  T_29_D_CHARACTER_AMOCO_N: 'Moco "the TBD"',
  T_29_D_CHARACTER_MUSICBRO1_N: "Dimitri",
  T_29_D_CHARACTER_MUSICBRO2_N: "Thiva",
  T_29_HI_MINI14: "AC80",
  T_29_L_B_TRJERSEY: "土耳其球衣裤子",
  T_29_L_M_A_FALCONER_C: "氪金之王面饰",
  T_29_L_M_A_JUNGLE_GREEN: "巴西龟面饰",
  T_29_L_M_B_FALCONER_C: "氪金之王裤子",
  T_29_L_M_B_JUNGLE_GREEN: "巴西龟裤子",
  T_29_L_M_H_FALCONER_C: "氪金之王头饰",
  T_29_L_M_H_JUNGLE_GREEN: "巴西龟头饰",
  T_29_L_M_S_FALCONER_C: "氪金之王鞋子",
  T_29_L_M_S_JUNGLE_GREEN: "巴西龟鞋子",
  T_29_L_M_T_FALCONER_C: "氪金之王上衣",
  T_29_L_M_T_JUNGLE_GREEN: "巴西龟上衣",
  T_29_L_T_TRJERSEY: "土耳其球衣上衣",
  T_29_M_WS_ITEM22: "破碎箱",
  T_29_M_WS_ITEM23: "破碎围栏",
  T_29_M_WS_ITEM24: "出生点A",
  T_29_M_WS_ITEM25: "出生点B",
  T_29_M_WS_TYPE5: "交互物件",
  T_29_W_PETSKIN_BROWN_TIGER_N: "棕褐",
  T_29_W_PETSKIN_FIRE_TIGER_N: "炙热",
  T_29_W_PETSKIN_HAWK_MOCOMONTH_N: "MOCO鹰",
  T_29_W_PETSKIN_PANDA_MUSICFEST_N: "音乐熊猫",
  T_29_W_PETSKIN_WHITE_TIGER_N: "纯白",
  T_29_W_TIGER_NINJA_N: "忍虎",
  T_29_YF_MACHETE_MUSICFEST_N: "音乐节主题",
  T_29_YF_MAGEZINE_CHAIN_N: "链式弹夹",
  T_29_YF_MUZZLE_CRASH_N: "突击枪口",
  T_29_YF_MUZZLE_WIDE_N: "宽式枪口",
  T_29_YF_SPAS12_MOCOMONTH_N: "觉醒Moco二次元主题枪械SPAS12",
  T_29_YF_UZI_GOLDENWING_N: "金翼特派员主题UZI",
  T_29_YF_VEHICLE_MONSTER_SKELETONTRUCK_N: "骷髅/骨头主题大脚车皮肤",
  T_30_AD_RP_ROUNDEND: "回合结束",
  T_30_AD_TRAINING_SNOWBALL: "雪球",
  T_30_AD_TRAINING_SNOWBALL_DES: "打雪仗！冲啊！",
  T_30_C_SKILL_DESC_BOOYAHGUY: "受到攻击[FFB300]{0}秒[-]后开始恢复生命值，每秒回复[FFB300]{1}点[-]持续[FFB300]{2}秒[-]",
  T_30_C_SKILL_NAME_BOOYAHGUY: "强者生存",
  T_30_C_SKILL_NAME_MUERTOGUY: "记忆涟漪",
  T_30_D_CHARACTER_BOOYAHGUY_N: "Leon",
  T_30_D_CHARACTER_MUERTOGUY_N: "Hasen",
  T_30_JMF_SKILLCHIP_NAME_SWATGUY: "宰伊的技能芯片",
  T_30_L_A_BRMASCOT_ADULT: "愤怒鸡头套",
  T_30_L_A_BRMASCOT_KIDS: "稚嫩鸡头套",
  T_30_L_A_SUGARSKULL21_BANDANA: "拉美亡灵节面巾",
  T_30_L_B_BRFOOTBALL_BLACK: "CBF球衣裤子黑色",
  T_30_L_B_BRFOOTBALL_GREEN: "CBF球衣裤子绿色",
  T_30_L_B_BRFOOTBALL_GREY: "CBF球衣裤子灰色",
  T_30_L_B_BRUNIFORM: "CBF球衣裤子小鸡",
  T_30_L_F_A_SUGARSKULL21: "亡灵节传统女面饰",
  T_30_L_F_B_SUGARSKULL21: "亡灵节传统女裤子",
  T_30_L_F_B_THASIAN: "泰国日式女裤子",
  T_30_L_F_H_CATEARS: "泰国猫耳",
  T_30_L_F_H_SUGARSKULL21: "亡灵节传统女头饰",
  T_30_L_F_H_THASIAN: "泰国日式女头饰",
  T_30_L_F_S_SUGARSKULL21: "亡灵节传统女鞋子",
  T_30_L_F_S_THASIAN: "泰国日式女鞋子",
  T_30_L_F_T_SUGARSKULL21: "亡灵节传统女上衣",
  T_30_L_F_T_THASIAN: "泰国日式女上衣",
  T_30_L_H_CHILDRENSDAY_BLUE: "儿童节海豚头饰",
  T_30_L_H_CHILDRENSDAY_RED: "儿童节大象头饰",
  T_30_L_H_CLOWNHAT: "土耳其小丑帽",
  T_30_L_H_ZASCARF: "南非头巾",
  T_30_L_M_A_LIGHTFEST_GANGSTER: "排灯节黑帮男面饰",
  T_30_L_M_A_SUGARSKULL21: "亡灵节传统男面饰",
  T_30_L_M_B_LIGHTFEST_GANGSTER: "排灯节黑帮男裤子",
  T_30_L_M_B_PKCRICKET: "巴基斯坦板球服裤子",
  T_30_L_M_B_SUGARSKULL21: "亡灵节传统男裤子",
  T_30_L_M_B_SUGARSKULL21_CASUAL: "亡灵节潮服男裤子",
  T_30_L_M_B_THASIAN: "泰国日式男裤子",
  T_30_L_M_H_LIGHTFEST_GANGSTER: "排灯节黑帮男头饰",
  T_30_L_M_H_SUGARSKULL21: "亡灵节传统男头饰",
  T_30_L_M_H_SUGARSKULL21_CASUAL: "亡灵节潮服男头饰",
  T_30_L_M_H_THASIAN: "泰国日式男头饰",
  T_30_L_M_HA_BOOYAHDAY21_YELLOW: "传奇Booyahday妆容黄",
  T_30_L_M_S_LIGHTFEST_GANGSTER: "排灯节黑帮男鞋子",
  T_30_L_M_S_PKCRICKET: "巴基斯坦板球服鞋子",
  T_30_L_M_S_SUGARSKULL21: "亡灵节传统男鞋子",
  T_30_L_M_S_SUGARSKULL21_CASUAL: "亡灵节潮服男鞋子",
  T_30_L_M_S_THASIAN: "泰国日式男鞋子",
  T_30_L_M_T_LIGHTFEST_GANGSTER: "排灯节黑帮男上衣",
  T_30_L_M_T_PKCRICKET: "巴基斯坦板球服上衣",
  T_30_L_M_T_SUGARSKULL21: "亡灵节传统男上衣",
  T_30_L_M_T_SUGARSKULL21_CASUAL: "亡灵节潮服男上衣",
  T_30_L_M_T_THASIAN: "泰国日式男上衣",
  T_30_L_S_BRUNIFORM: "CBF球衣鞋子小鸡",
  T_30_L_T_BRFOOTBALL_BLACK: "CBF球衣上衣黑色",
  T_30_L_T_BRFOOTBALL_GREEN: "CBF球衣上衣绿色",
  T_30_L_T_BRFOOTBALL_GREY: "CBF球衣上衣灰色",
  T_30_L_T_BRUNIFORM: "CBF球衣上衣小鸡",
  T_30_M_WS_PARTY_MODE: "派对模式",
  T_30_R_EMOTE_BATTLEINSTYLE_NAME: "Battle In Style（占位，branding team有特殊需求，待确定）",
  T_30_R_EMOTE_BOOYAHDAY21_PROVOCATION_NAME: "挑衅",
  T_30_R_EMOTE_MAX_NAME: "Rapper舞蹈",
  T_30_R_LEGEND_HALO_NAME: "脚下光环",
  T_30_T_WS_DEFAULTDESCRIPTION: "只是又一张Free Fire的自定义地图",
  T_30_T_WS_ITEM26: "轮胎",
  T_30_T_WS_ITEM27: "轮胎堆A",
  T_30_T_WS_ITEM28: "轮胎堆B",
  T_30_T_WS_ITEM29: "轮胎堆C",
  T_30_T_WS_ITEM30: "碰碰车",
  T_30_T_WS_ITEM31: "水陆两用车",
  T_30_T_WS_ITEM32: "吉普车",
  T_30_T_WS_ITEM33: "垃圾桶",
  T_30_T_WS_ITEM34: "阴影",
  T_30_T_WS_ITEM35: "医疗帐篷",
  T_30_T_WS_ITEM36: "车库",
  T_30_T_WS_ITEM37: "彩绘墙",
  T_30_T_WS_ITEM38: "鸟居",
  T_30_T_WS_ITEM39: "铁台",
  T_30_T_WS_ITEM40: "货柜屋",
  T_30_T_WS_ITEM41: "拖车",
  T_30_T_WS_ITEM42: "墙壁A",
  T_30_T_WS_ITEM43: "墙壁B",
  T_30_T_WS_ITEM44: "墙壁C",
  T_30_T_WS_ITEM45: "墙壁D",
  T_30_T_WS_ITEM46: "墙壁E",
  T_30_T_WS_ITEM47: "墙壁F",
  T_30_U_ATTACHMENT_1: "护盾扩充器",
  T_30_U_ATTACHMENT_4: "全身护甲",
  T_30_U_ATTACHMENT_5: "过量夹层",
  T_30_U_ATTACHMENT_6: "防爆夹层",
  T_30_W_PETSKIN_BABOON_SUGARSKULL21_N: "狒狒拉美亡灵节主题皮肤",
  T_30_W_PETSKIN_PENGUIN_EVILRHYTHM_N: "企鹅MAX罪恶旋律主题皮肤",
  T_30_W_PETSKIN_RABBIT_BULLSEYE_N: "射击兔皮肤",
  T_30_W_PETSKIN_RABBIT_CLOWN_N: "小丑兔皮肤",
  T_30_W_PETSKIN_RABBIT_URBAN_N: "未来兔皮肤",
  T_30_W_PETSKIN_ROBOT_TRNAZAR_N: "机器人土耳其主题皮肤",
  T_30_W_PETSKIN_ROBOT_VNDRINK_N: "机器人Yomost合作款皮肤",
  T_30_W_RABBIT_N: "兔兔",
  T_30_XH_PCMAP_P17: "工厂",
  T_30_YF_GLOO_BOOYAHDAY21_N: "Booyahday泡沫手雷",
  T_30_YF_GRENADE_BOOYAHDAY21_N: "Booyahday手雷",
  T_30_YF_Healinggun_Sniper_N: "Heal Sniper",
  T_30_YF_MINI_LIGHTFEST_N: "印度排灯节主题枪械",
  T_30_YF_PARAFAL_ZATRIBAL_N: "南非风格主题枪械",
  T_30_YF_SCAR_LIGHTFEST_N: "印度排灯节主题枪械",
  T_30_YF_THOMPSON_SUGARSKULL21_N: "拉美亡灵节主题枪械",
  T_30_YF_VEHICLE_ROADSTER_EVILRHYTHM_N: "Max罪恶旋律主题跑车皮肤",
  T_31_C_SKILL_NAME_WINTERGUY: "风暴屏障",
  T_31_HQ_BASEBALLBAT_WINTERFEST21_N: "冰雪节主题棒球棍",
  T_31_HQ_GLOO_EAGLE_N: "中东主题泡沫手雷",
  T_31_HQ_HEALINGSNIPER_WINTERFEST21_N: "冰雪节主题枪械",
  T_31_HQ_KATANA_WINTERFEST21_N: "冰雪节主题武士刀",
  T_31_HQ_PAN_WINTERFEST21_N: "冰雪节主题平底锅",
  T_31_HQ_PETSKIN_OTTER_WINTERFEST21_N: "捕鱼高手",
  T_31_HQ_PETSKIN_PENGUIN_WINTERFEST21_N: "冰雪瓦哥",
  T_31_HQ_PETSKIN_YETI_GREEN_N: "德鲁伊之心",
  T_31_HQ_PETSKIN_YETI_RED_N: "火热心情",
  T_31_HQ_SICKLE_WINTERFEST21_N: "冰雪节主题镰刀",
  T_31_HQ_VEHICLE_MOTOBIKE_NEWYEAR21_N: "新年主题摩托皮肤",
  T_31_HQ_YETI_N: "雪怪",
  T_31_KK_WINTER_BUJIX: "补给箱",
  T_31_KK_WINTER_SANJITOU: "头盔",
  T_31_L_A_BDCRICKET: "孟加拉板球服面饰",
  T_31_L_A_WINTERFEST21: "冰雪节面巾",
  T_31_L_B_BDCRICKET: "孟加拉板球服裤子",
  T_31_L_B_MEJERSEY_10: "非洲杯球衣10裤子",
  T_31_L_B_MEJERSEY_11: "非洲杯球衣11裤子",
  T_31_L_B_MEJERSEY_13: "非洲杯球衣13裤子",
  T_31_L_B_MEJERSEY_18G: "非洲杯球衣18绿裤子",
  T_31_L_B_MEJERSEY_18R: "非洲杯球衣18红裤子",
  T_31_L_B_MEJERSEY_7: "非洲杯球衣7裤子",
  T_31_L_F_B_RUMUSICIAN: "Slava Marlow女裤子",
  T_31_L_F_B_THAGENT: "泰国明星女裤子",
  T_31_L_F_H_REGGAETON_HEADWEAR: "拉美歌手女头饰",
  T_31_L_F_H_RUMUSICIAN: "Slava Marlow女头饰",
  T_31_L_F_H_THAGENT: "泰国明星女头饰",
  T_31_L_F_HA_RUMUSICIAN: "Slava Marlow女妆容",
  T_31_L_F_S_RUMUSICIAN: "Slava Marlow女鞋子",
  T_31_L_F_S_THAGENT: "泰国明星女鞋子",
  T_31_L_F_T_RUMUSICIAN: "Slava Marlow女上衣",
  T_31_L_F_T_THAGENT: "泰国明星女上衣",
  T_31_L_HA_RUMUSICIAN_MU: "Slava Marlow妆容",
  T_31_L_HA_WINTERFEST21_BLUE: "拉美冰雪节妆容蓝",
  T_31_L_HA_WINTERFEST21_PINK: "拉美冰雪节妆容粉",
  T_31_L_M_A_REGGAETON_B: "豹纹头面饰",
  T_31_L_M_A_REGGAETON_P: "粉马甲面饰",
  T_31_L_M_A_RUMUSICIAN: "Slava Marlow男面饰",
  T_31_L_M_A_THAGENT: "泰国明星男面饰",
  T_31_L_M_B_PKCOSTUME: "巴基斯坦传统服饰裤子",
  T_31_L_M_B_REGGAETON_B: "豹纹头裤子",
  T_31_L_M_B_REGGAETON_P: "粉马甲裤子",
  T_31_L_M_B_RUMUSICIAN: "Slava Marlow男裤子",
  T_31_L_M_B_THAGENT: "泰国明星男裤子",
  T_31_L_M_H_GREENCAP: "巴基斯坦帽子",
  T_31_L_M_H_PKCOSTUME: "巴基斯坦传统服饰头饰",
  T_31_L_M_H_REGGAETON_B: "豹纹头头饰",
  T_31_L_M_H_REGGAETON_HEADWEAR: "拉美歌手男头饰",
  T_31_L_M_H_REGGAETON_P: "粉马甲头饰",
  T_31_L_M_H_RUMUSICIAN: "Slava Marlow男头饰",
  T_31_L_M_H_THAGENT: "泰国明星男头饰",
  T_31_L_M_S_PKCOSTUME: "巴基斯坦传统服饰鞋子",
  T_31_L_M_S_REGGAETON_B: "豹纹头鞋子",
  T_31_L_M_S_REGGAETON_P: "粉马甲鞋子",
  T_31_L_M_S_RUMUSICIAN: "Slava Marlow男鞋子",
  T_31_L_M_S_THAGENT: "泰国明星男鞋子",
  T_31_L_M_T_PKCOSTUME: "巴基斯坦传统服饰上衣",
  T_31_L_M_T_REGGAETON_B: "豹纹头上衣",
  T_31_L_M_T_REGGAETON_P: "粉马甲上衣",
  T_31_L_M_T_REGGAETON_TATOO: "拉美歌手纹身",
  T_31_L_M_T_RUMUSICIAN: "Slava Marlow男上衣",
  T_31_L_M_T_THAGENT: "泰国明星男上衣",
  T_31_L_S_BDCRICKET: "孟加拉板球服鞋子",
  T_31_L_T_BDCRICKET: "孟加拉板球服上衣",
  T_31_L_T_BRBANK: "Santander外套",
  T_31_L_T_MEJERSEY_10: "非洲杯球衣10上衣",
  T_31_L_T_MEJERSEY_11: "非洲杯球衣11上衣",
  T_31_L_T_MEJERSEY_13: "非洲杯球衣13上衣",
  T_31_L_T_MEJERSEY_18G: "非洲杯球衣18绿上衣",
  T_31_L_T_MEJERSEY_18R: "非洲杯球衣18红上衣",
  T_31_L_T_MEJERSEY_7: "非洲杯球衣7上衣",
  T_31_L_T_PKMOBILE: "Infinix T恤",
  T_31_L_T_REGGAETON_HOOD: "拉美歌手卫衣",
  T_31_MF_CHARACTER_WINTERGUY_N: "Nairi",
  T_31_R_EMOTE_FALCONER_NAME: "N0.1",
  T_31_RW_COMBINEMACHINE_2: "异枪双持激活器(高级版)",
  T_31_RW_VIBRATION_EXPLOSION: "爆炸振动",
  T_31_RW_VIBRATION_MELEEWEAPONS: "近战武器",
  T_31_RW_VIBRATION_OTHERWEAPONS: "其他武器",
  T_31_T_WS_1PLAYERTEAM: "单人小队",
  T_31_T_WS_2PLAYERTEAM: "双人小队",
  T_31_T_WS_3PLAYERTEAM: "三人小队",
  T_31_T_WS_4PLAYERTEAM: "四人小队",
  T_31_T_WS_5PLAYERTEAM: "五人小队",
  T_31_T_WS_6PLAYERTEAM: "六人小队",
  T_31_T_WS_BUFFTIME_TITLE: "刷新时间（秒）",
  T_31_T_WS_BUFFTYPE_AMMO: "弹药",
  T_31_T_WS_BUFFTYPE_ARMOR: "防具",
  T_31_T_WS_BUFFTYPE_HP: "生命",
  T_31_T_WS_BUFFTYPE_RANDOM: "随机",
  T_31_T_WS_BUFFTYPE_TITLE: "BUFF类型",
  T_31_T_WS_DESC48: "可用来进行空间传送的装置",
  T_31_T_WS_DESC49: "会发出钢琴声的音乐方块",
  T_31_T_WS_DESC51: "会发出鼓声的音乐方块",
  T_31_T_WS_DESC53: "会发出合成器声的音乐方块",
  T_31_T_WS_DESC59: "一个会周期性生成BUFF的装置，拾取后获得对应强化",
  T_31_T_WS_DRUMTYPE_CLAPS: "拍",
  T_31_T_WS_DRUMTYPE_HIHATS: "镲片",
  T_31_T_WS_DRUMTYPE_KICK: "底鼓",
  T_31_T_WS_DRUMTYPE_OPENHIHATS: "镲片B",
  T_31_T_WS_DRUMTYPE_RIDES: "叠音镲",
  T_31_T_WS_DRUMTYPE_SNARES: "小鼓",
  T_31_T_WS_EARLYSHRINK: "快速缩圈",
  T_31_T_WS_ITEM48: "传送门",
  T_31_T_WS_ITEM49: "乐符钢琴",
  T_31_T_WS_ITEM51: "乐符鼓",
  T_31_T_WS_ITEM53: "乐符合成器A",
  T_31_T_WS_ITEM55: "乐符合成器B",
  T_31_T_WS_ITEM57: "乐符合成器C",
  T_31_T_WS_ITEM59: "BUFF生成器",
  T_31_T_WS_LATESHRINK: "慢速缩圈",
  T_31_T_WS_ME_DAMAGE: "伤害量",
  T_31_T_WS_ME_DAMAGED: "受到伤害量",
  T_31_T_WS_ME_DEFAULTEPPERCENT: "初始EP值比例",
  T_31_T_WS_ME_DEFAULTSAFERADIUS: "初始安全区半径",
  T_31_T_WS_ME_EPQUICKRESTORE: "EP快速回复",
  T_31_T_WS_ME_FLOW: "模式流程",
  T_31_T_WS_ME_GENERALSETTING: "通用设置",
  T_31_T_WS_ME_INRANDOMSPAWN: "在出生点中随机",
  T_31_T_WS_ME_KILLSCORE: "击杀加分值",
  T_31_T_WS_ME_MAXEP: "EP上限",
  T_31_T_WS_ME_MAXHP: "生命上限",
  T_31_T_WS_ME_NEARTEAM: "队友附近",
  T_31_T_WS_ME_REBIRTH: "重生等待时间",
  T_31_T_WS_ME_REBIRTHLOCATION: "重生位置",
  T_31_T_WS_ME_SAFEZONESHRINKTIME: "开始缩圈时间",
  T_31_T_WS_ME_WINSCORE: "获胜分值",
  T_31_T_WS_MINIZONE: "小型战场",
  T_31_T_WS_MUSICTYPE_TITLE: "声音类型",
  T_31_T_WS_UNLIMITEDAMMO: "无限弹药",
  T_31_WT_WS_DESC1: "普普通通的正方形木箱，可以堆叠使用",
  T_31_WT_WS_DESC10: "破旧的木质小屋，有木阶梯可以上楼",
  T_31_WT_WS_DESC11: "破旧的小型哨塔，哨塔上有多个射击孔",
  T_31_WT_WS_DESC12: "小型的铁质警卫室，有门有窗",
  T_31_WT_WS_DESC13: "一层民房，有多个门窗",
  T_31_WT_WS_DESC14: "二层露天的大型民房",
  T_31_WT_WS_DESC15: "二层封闭的大型民房",
  T_31_WT_WS_DESC16: "装饰物-心形的沙雕",
  T_31_WT_WS_DESC17: "装饰物-喷泉",
  T_31_WT_WS_DESC18: "装饰物-开满樱花的樱花树",
  T_31_WT_WS_DESC19: "装饰物-没有香蕉的小型香蕉树",
  T_31_WT_WS_DESC2: "普普通通的长方形木箱，可以堆叠使用",
  T_31_WT_WS_DESC20: "白色马桶，可以用作室内家具",
  T_31_WT_WS_DESC21: "小型围栏，可以分隔区域",
  T_31_WT_WS_DESC22: "侧面木板可以被打碎的集装箱",
  T_31_WT_WS_DESC23: "可以被打碎的小型围栏",
  T_31_WT_WS_DESC24: "队伍A玩家的出生点。仅在基础模式下生效（CS/TDM/PARTY）",
  T_31_WT_WS_DESC25: "队伍B玩家的出生点。仅在基础模式下生效（CS/TDM/PARTY）",
  T_31_WT_WS_DESC26: "可以把玩家向面朝方向弹射小段距离的轮胎",
  T_31_WT_WS_DESC27: "可以把玩家向特定方向弹射小段距离的轮胎堆",
  T_31_WT_WS_DESC28: "可以把玩家向特定方向弹射中段距离的轮胎堆",
  T_31_WT_WS_DESC29: "可以把玩家向特定方向弹射大段距离的轮胎堆",
  T_31_WT_WS_DESC3: "红黄相间的灌木，可以点缀战场使用",
  T_31_WT_WS_DESC30: "一辆可以驾驶的碰碰车",
  T_31_WT_WS_DESC31: "一辆可以驾驶的水陆两栖车",
  T_31_WT_WS_DESC32: "一辆可以驾驶的吉普车",
  T_31_WT_WS_DESC33: "填满垃圾的垃圾桶，比人矮，可以充当掩体",
  T_31_WT_WS_DESC34: "半开放结构的小型观赛亭，金属质感",
  T_31_WT_WS_DESC35: "有两个门但没有窗户的中型医疗帐篷",
  T_31_WT_WS_DESC36: "半开放式的大型车库，由砖块搭建",
  T_31_WT_WS_DESC37: "砖块搭建的大型围墙，可以用于分隔区域",
  T_31_WT_WS_DESC38: "大型鸟居，可以充当地标",
  T_31_WT_WS_DESC39: "金属质感的大型平台，可以当作主要战场",
  T_31_WT_WS_DESC4: "普普通通的草垛，比人高，可以充当掩体",
  T_31_WT_WS_DESC40: "酷似房车结构的小型建筑，多门多窗",
  T_31_WT_WS_DESC41: "酷似房车结构的小型建筑，单门多窗",
  T_31_WT_WS_DESC42: "具有门结构的单面砖墙",
  T_31_WT_WS_DESC43: "普通单面砖墙",
  T_31_WT_WS_DESC44: "平整的直角砖墙",
  T_31_WT_WS_DESC45: "凹陷的直角砖墙",
  T_31_WT_WS_DESC46: "凹陷的直角砖墙",
  T_31_WT_WS_DESC47: "具有窗结构的直角砖墙",
  T_31_WT_WS_DESC5: "废旧的小轿车，比人略矮，可以充当掩体",
  T_31_WT_WS_DESC6: "小巴士，比人高，可以充当掩体",
  T_31_WT_WS_DESC7: "前后贯通的集装箱，可以分隔区域、构成通路",
  T_31_WT_WS_DESC8: "单侧贯通的集装箱，可以分隔区域",
  T_31_WT_WS_DESC9: "密闭的集装箱，可以分隔区域",
  T_31_YF_MAC10_N: "MAC10",
  T_31_YM_PIN_VEHICLE: "载具",
  T_31_Z_OB_UAV: "UAV",
  T_32_C_SKILL_DESC_YAKUZA: "快速向前方移动，持续[FFB300]{0}秒[-]，技能可以积攒使用的次数，最多积攒[FFB300]{2}次[-]，连续使用之间会有[FFB300]{3}秒[-]cd，cd：[FFB300]{1}秒[-]。",
  T_32_C_SKILL_NAME_YAKUZA: "急速冲锋",
  T_32_HQ_AUG_VNSTREET_N: "越南王室潮服主题枪械-AUG",
  T_32_HQ_BACKPACK_REDDRAGON_N: "红龙杀手主题背包",
  T_32_HQ_BLT_VALENTINE2022_N: "情人节主题枪械-BLT",
  T_32_HQ_GLOO_DUNHUANG_N: "赛博敦煌主题泡沫手雷-Gloo",
  T_32_HQ_GLOO_HURRICANE_2_N: "音乐飓风主题泡沫手雷-Gloo",
  T_32_HQ_GRENADE_HURRICANE_N: "音乐飓风主题手雷-Grenade",
  T_32_HQ_MAC10_DUNHUANG_N: "赛博敦煌主题枪械-Mac10",
  T_32_HQ_PETSKIN_DUCK_RED_N: "火红豆豆",
  T_32_HQ_PETSKIN_TORTOISE_BLUE_N: "赛博龟龟",
  T_32_HQ_PETSKIN_TORTOISE_GREEN_N: "蛙蛙龟",
  T_32_HQ_PETSKIN_TORTOISE_RED_N: "节庆龟龟",
  T_32_HQ_TORTOISE_N: "大眼仔",
  T_32_HQ_VEHICLE_ROADSTER_UNDERTAKER_N: "荧闪棺材主题跑车",
  T_32_L_F_A_PHARAOH: "街头法老女面饰",
  T_32_L_F_B_PHARAOH: "街头法老女裤子",
  T_32_L_F_H_PHARAOH: "街头法老女头饰",
  T_32_L_F_HA_PHARAOH: "街头法老女妆容",
  T_32_L_F_S_PHARAOH: "街头法老女鞋子",
  T_32_L_F_T_PHARAOH: "街头法老女上衣",
  T_32_L_M_A_JUNKFOOD: "快餐枪手男面饰",
  T_32_L_M_A_PHARAOH: "街头法老男面饰",
  T_32_L_M_B_JUNKFOOD: "快餐枪手男裤子",
  T_32_L_M_B_PHARAOH: "街头法老男裤子",
  T_32_L_M_H_JUNKFOOD: "快餐枪手男头饰",
  T_32_L_M_H_PHARAOH: "街头法老男头饰",
  T_32_L_M_S_JUNKFOOD: "快餐枪手男鞋子",
  T_32_L_M_S_PHARAOH: "街头法老男鞋子",
  T_32_L_M_T_JUNKFOOD: "快餐枪手男上衣",
  T_32_L_M_T_PHARAOH: "街头法老男上衣",
  T_32_L_T_WHITESWEATER: "高领白色毛衣",
  T_32_LC_NEWVAULT_EMOTE: "Emote",
  T_32_LO_WS_IMMORTAL: "无敌区",
  T_32_LO_WS_ITEM60: "管道",
  T_32_LO_WS_ITEM60_DESC: "可以通过的大型管道",
  T_32_LO_WS_ITEM61: "T型管道",
  T_32_LO_WS_ITEM61_DESC: "可以通过的T型管道",
  T_32_LO_WS_ITEM62: "十字管道",
  T_32_LO_WS_ITEM62_DESC: "可以通过的十型管道",
  T_32_LO_WS_ITEM63: "转折管道",
  T_32_LO_WS_ITEM63_DESC: "可以通过的直角管道",
  T_32_LO_WS_ITEM64: "小餐车",
  T_32_LO_WS_ITEM64_DESC: "停在路边的餐饮小车",
  T_32_LO_WS_ITEM65: "巨型蘑菇群",
  T_32_LO_WS_ITEM65_DESC: "奇异的巨型蘑菇，甚至可以承载人的重量",
  T_32_LO_WS_ITEM66: "晾衣架",
  T_32_LO_WS_ITEM66_DESC: "民居里常见的晾晒衣物的架子",
  T_32_LO_WS_ITEM67: "木板桥",
  T_32_LO_WS_ITEM67_DESC: "一块坚硬的长条木板，可以做成简易的桥让人通过",
  T_32_LO_WS_ITEM68: "屏风",
  T_32_LO_WS_ITEM68_DESC: "充满东方风韵的装饰物",
  T_32_LO_WS_ITEM69: "混凝土柱",
  T_32_LO_WS_ITEM69_DESC: "建筑工地常见的结构柱子",
  T_32_LO_WS_ITEM70: "仙人掌",
  T_32_LO_WS_ITEM70_DESC: "硕大的仙人掌，但似乎并不扎人",
  T_32_LO_WS_ITEM71: "枯木",
  T_32_LO_WS_ITEM71_DESC: "年老的树木，已经干枯到没有一片树叶",
  T_32_LO_WS_ITEM72: "宫灯",
  T_32_LO_WS_ITEM72_DESC: "某些地区庭院里常见的一种灯具",
  T_32_LO_WS_ITEM73: "路灯",
  T_32_LO_WS_ITEM73_DESC: "寻常道路边的路灯",
  T_32_LO_WS_ITEM74: "太阳能板",
  T_32_LO_WS_ITEM74_DESC: "能从太阳光中收集能源的装置",
  T_32_LO_WS_ITEM75: "空调 A",
  T_32_LO_WS_ITEM75_DESC: "炎热夏季带来清凉的电器",
  T_32_LO_WS_ITEM76: "螺旋桨机关",
  T_32_LO_WS_ITEM77: "平底锅机关",
  T_32_LO_WS_ITEM78: "方块机关",
  T_32_LO_WS_ITEM79: "圆环机关",
  T_32_LO_WS_ITEM80: "大锤机关",
  T_32_LO_WS_ITEM81: "移动平台",
  T_32_LO_WS_ITEM82: "移动靶子",
  T_32_LO_WS_ITEM83: "伸缩墙",
  T_32_LO_WS_ITEM84AMMO: "子弹掉落点",
  T_32_LO_WS_ITEM84AMMO_DESC: "放置后将会在放置点掉落所选的子弹",
  T_32_LO_WS_ITEM84AR: "防具掉落点",
  T_32_LO_WS_ITEM84AR_DESC: "放置后将会在放置点掉落所选级别的防具",
  T_32_LO_WS_ITEM84ARLV1: "一级防具",
  T_32_LO_WS_ITEM84ARLV2: "二级防具",
  T_32_LO_WS_ITEM84ARLV3: "三级防具",
  T_32_LO_WS_ITEM84CO: "消耗品掉落点",
  T_32_LO_WS_ITEM84CO_DESC: "放置后将会在放置点掉落所选的消耗品",
  T_32_LO_WS_ITEM84JA: "投掷物掉落点",
  T_32_LO_WS_ITEM84JA_DESC: "放置后将会在放置点掉落所选的投掷物",
  T_32_LO_WS_ITEM84TE: "瞄准镜掉落点",
  T_32_LO_WS_ITEM84TE_DESC: "放置后将会在放置点掉落所选的瞄准镜",
  T_32_LO_WS_ITEM84W: "武器掉落点",
  T_32_LO_WS_ITEM84W_DESC: "放置后将会在放置点掉落所选类型的武器",
  T_32_LO_WS_ITEM85: "死亡/无敌区",
  T_32_LO_WS_ITEM85_DESC: "玩家进入区域后，将会受到特殊效果，具有无敌与死亡两种效果。在基础模式下不生效（CS/TDM/PARTY）",
  T_32_LO_WS_ITEM85CP: "检查点",
  T_32_LO_WS_ITEM85CP_DESC: "用于构建竞速玩法的物件。玩家需要按顺序通过检查点后，终点才会生效。摆放后，死亡重生可以选择出生在上一个经过的检查点。在基础模式下不生效（CS/TDM/PARTY）",
  T_32_LO_WS_ITEM85TM: "终点",
  T_32_LO_WS_ITEM85TM_DESC: "用于构建竞速玩法的物件。玩家到达终点内则完成竞速目标。在基础模式下不生效（CS/TDM/PARTY）",
  T_32_LO_WS_ITEM86: "通用出生点",
  T_32_LO_WS_ITEM86_DESC: "不区分阵营的通用出生点，摆放后随机分配给各队伍。在基础模式下不生效（CS/TDM/PARTY）",
  T_32_LO_WS_ITEM86L: "大型出生点",
  T_32_LO_WS_ITEM86L_DESC: "推荐在竞速模式用的大型出生点，所有人玩家出生时排成一排。在基础模式下不生效（CS/TDM/PARTY）",
  T_32_LO_WS_ITEM87: "基础块",
  T_32_LO_WS_ITEM87_DESC: "可以随意调整大小的基础元件",
  T_32_LO_WS_ITEM88: "基础斜坡",
  T_32_LO_WS_ITEM88_DESC: "可以随意调整大小的基础斜坡元件",
  T_32_LO_WS_ITEMLINE: "直线位移",
  T_32_LO_WS_ITEMMOVE: "机关运动模式",
  T_32_LO_WS_ITEMROT: "变换",
  T_32_LO_WS_ITEMSCALE: "缩放",
  T_32_LO_WS_KILLZONE: "死亡区",
  T_32_LO_WS_LOOT_AMMOTYPE: "子弹类型",
  T_32_LO_WS_LOOT_ARTYPE: "防具类型",
  T_32_LO_WS_LOOT_COTYPE: "消耗品类型",
  T_32_LO_WS_LOOT_JATYPE: "投掷物类型",
  T_32_LO_WS_LOOT_RANDOM: "随机掉落",
  T_32_LO_WS_LOOT_TETYPE: "瞄准镜类型",
  T_32_LO_WS_LOOT_WEAPONTYPE: "掉落武器类型",
  T_32_LO_WS_SCALEX: "X轴长度",
  T_32_LO_WS_SCALEY: "Y轴长度",
  T_32_LO_WS_SCALEZ: "Z轴长度",
  T_32_LO_WS_TRIGGERH: "隐藏",
  T_32_LO_WS_TRIGGERHORP: "显示/隐藏触发器",
  T_32_LO_WS_TRIGGERP: "显示",
  T_32_LO_WS_TRIGGERTYPE: "触发器类型",
  T_32_M_WS_MODE_ANNIHILATE: "歼灭",
  T_32_M_WS_MODE_SCORE: "获得分数",
  T_32_M_WS_MODE_SPEED: "跑酷",
  T_32_M_WS_MULTIPLETEAMS: "Multi-Team Combat",
  T_32_M_WS_ROUNDS: "Rounds",
  T_32_R_EMOTE_HURRICANE_BLUE_NAME: "嗨舞和乐",
  T_32_RW_WEAPON_M1887TD_NAME: "3发子弹的1887",
  T_32_T_WS_ME_BLUECIRCLE: "毒圈",
  T_32_T_WS_ME_BLUECIRCLEDAMAGE: "毒圈伤害",
  T_32_T_WS_ME_BLUECIRCLESETTING: "毒圈设置",
  T_32_T_WS_ME_CUSTOM: "自定义模式",
  T_32_T_WS_ME_ENDTYPE1: "歼灭",
  T_32_T_WS_ME_ENDTYPE2: "积分",
  T_32_T_WS_ME_ENDTYPE3: "竞速",
  T_32_T_WS_ME_ENDTYPEDESC1: "最后一支幸存的队伍获胜",
  T_32_T_WS_ME_ENDTYPEDESC2: `积分模式，率先达到目标分数的队伍获得游戏胜利。
提供该玩法模式中的玩法规则设置，可以按照自己的需求编辑玩法参数，设置击杀得分。`,
  T_32_T_WS_ME_ENDTYPEDESC3: `跑酷玩法，第一支全员到达终点的队伍获胜。
提供该玩法模式中的玩法规则设置，可以按照自己的需求设置路径和终点物件等。`,
  T_32_T_WS_ME_MATCHTIME: "回合比赛阶段时间",
  T_32_T_WS_ME_MECHANIC: "模式机制",
  T_32_T_WS_ME_NEARCHECKPOINT: "检查点附近",
  T_32_T_WS_ME_PLAYERNUMLIMIT: "总人数不能超过12",
  T_32_T_WS_ME_PREGAMETIME: "回合准备阶段时间",
  T_32_T_WS_ME_RESPAWN: "重生",
  T_32_T_WS_ME_RESPAWNSETTING: "重生设置",
  T_32_T_WS_ME_ROUNDNUM: "回合数",
  T_32_T_WS_ME_ROUNDOPEN: "是否开启多回合",
  T_32_T_WS_ME_ROUNDRESET: "每回合重置内容",
  T_32_T_WS_ME_ROUNDSETTING: "回合设置",
  T_32_T_WS_ME_SAFEZONESHRINKTIME2: "缩圈时间",
  T_32_T_WS_ME_SCORESETTING: "积分设置",
  T_32_T_WS_ME_TEAMMATENUM: "每队人数",
  T_32_T_WS_ME_TEAMNUM: "队伍数量",
  T_32_T_WS_ME_TEAMSETTING: "队伍设置",
  T_32_U_ATTACHMENT_8: "背包扩容",
  "T_32_U_GOLD_FAMAS-I": "Famas-I",
  "T_32_U_GOLD_FAMAS-II": "Famas-II",
  "T_32_U_GOLD_FAMAS-III": "Famas-III",
  T_32_U_GOLD_HEATGUN_I: "过热枪-I",
  T_32_U_GOLD_HEATGUN_II: "过热枪-II",
  T_32_U_GOLD_HEATGUN_III: "过热枪-III",
  T_32_U_GOLD_KAR98K_I: "Kar98K-I",
  T_32_U_GOLD_KAR98K_II: "Kar98K-II",
  T_32_U_GOLD_KAR98K_III: "Kar98K-III",
  T_32_U_GOLD_M14_I: "M14-I",
  T_32_U_GOLD_M14_II: "M14-II",
  T_32_U_GOLD_M14_III: "M14-III",
  "T_32_U_GOLD_M4A1-I": "M4A1-I",
  "T_32_U_GOLD_M4A1-II": "M4A1-II",
  "T_32_U_GOLD_M4A1-III": "M4A1-III",
  T_32_U_GOLD_M60_I: "M60-I",
  T_32_U_GOLD_M60_II: "M60-II",
  T_32_U_GOLD_M60_III: "M60-III",
  T_32_U_GOLD_MP5_I: "MP5-I",
  T_32_U_GOLD_MP5_II: "MP5-II",
  T_32_U_GOLD_MP5_III: "MP5-III",
  T_32_U_GOLD_VSS_I: "VSS-I",
  T_32_U_GOLD_VSS_II: "VSS-II",
  T_32_U_GOLD_VSS_III: "VSS-III",
  T_32_U_REPLACER: "枪械升级器",
  T_32_WT_WS_BARRIER: "机关",
  T_32_WT_WS_BDS: "建筑物",
  T_32_WT_WS_MMINVALIDERROR: "无效的战场码",
  T_32_WT_WS_TRGS: "触发器",
  T_32_YF_CHARGESHOT_N: "蓄力霰弹枪",
  T_32_YF_GOLD_GROZA_N: "Groza-X",
  T_32_YF_GOLD_M249_N: "M249-X",
  T_32_YF_GOLD_SVD_N: "SVD-Y",
  T_32_YS_WEAPON_TAG_18: "额外伤害",
  T_32_YS_WEAPON_TAG_3: "射速",
  T_32_YS_WEAPON_TAG_36: "碎甲",
  T_32_YS_WEAPON_TAG_39: "可双持",
  T_32_YS_WEAPON_TAG_42: "冰墙",
  T_33_C_SKILL_DESC_GRAFFITIST: "涂鸦[FFB300]{0}米[-]区域，区域内投掷物无效同时我方在区域内每秒恢复头甲耐久[FFB300]{1}%[-]，子弹减伤[FFB300]{2}%[-]，持续{[FFB300]{3}秒[-]，效果不叠加，CD[FFB300]{4}秒[-]。",
  T_33_C_SKILL_DESC_HITMAN: "使用狙擊槍和精準步槍射擊時，附加消音效果且对擊倒的敵人流血速度提升[FFB300]{0}%[-]",
  T_33_C_SKILL_DESC_KENTA: "在身前形成[FFB300]{0}米[-]范围的护盾，减免[FFB300]{1}%[-]来自前方武器伤害，开枪状态下，伤害减免降低至[FFB300]{2}%[-]。持续时间[FFB300]{3}秒[-]。CD：[FFB300]{4}秒[-]。",
  T_33_C_SKILL_DESC_MADEMANA: "釋放直径为 [FFB300]{0} 公尺[-]的電磁波阻止敵人施放技能或其他讀取動作，無法中斷已施放的技能。造成 [FFB300]{3} [-]傷害，持續 [FFB300]{1} 秒[-]。冷卻時間：[FFB300]{2} 秒[-]。",
  T_33_C_SKILL_NAME_BODYGUARD: "冲锋突击",
  T_33_C_SKILL_NAME_KENTA: "剑气防御",
  T_33_C_SKILL_NAME_MADEMANA: "电磁脉冲波",
  T_33_DY_AXOLOTL_N: "Zasil",
  T_33_DY_PETSKIN_AXOLOTL_GREY_N: "甜甜蠑螈",
  T_33_DY_PETSKIN_DUCK_FFWS03_N: "FFWS豆豆博士",
  T_33_DY_PETSKIN_HAWK_FASTBREAKING22_N: "开斋节老鹰",
  T_33_HQ_BASEBALLBAT_APRILFOOL22_N: "库存武器愚人节法棍棒球棍",
  T_33_HQ_EMOTE_SONGKRAN_N: "泰国泼水节emote",
  T_33_HQ_G18_CYBERTHIEF_N: "赛博神偷主题枪械",
  T_33_HQ_GRENADE_CYBERTHIEF_N: "赛博神偷主题手雷",
  T_33_HQ_M14_SPIDERLILY_N: "彼岸花主题枪械",
  T_33_HQ_MAG7_FFUNIT2_N: "神秘组织2.0主题枪械",
  T_33_HQ_MP40_FFWS03_N: "FFWS电竞主题枪械",
  T_33_HQ_SCAR_FFWS03_N: "FFWS电竞主题枪械",
  T_33_HQ_SICKLE_FASTBREAKING22_N: "开斋节镰刀",
  T_33_HQ_THROWINGKNIFE_FFWS03_N: "FFWS电竞主题飞刀",
  T_33_HQ_VECTOR_CYBERTHIEF_N: "赛博神偷主题枪械",
  T_33_HQ_VEHICLE_JEEP_FASTBREAKING22_N: "开斋节Jeep皮肤",
  T_33_HQ_VEHICLE_MONSTER_LION_RED_N: "Monster Truck - Bonebruiser Scorch",
  T_33_HQ_VEHICLE_SUV_FFWS03_N: "FFWS主题皮卡皮肤",
  T_33_LO_WS_BHPARA_A: "主动攻击",
  T_33_LO_WS_BHPARA_ATKMODE: "攻击模式",
  T_33_LO_WS_BHPARA_GROUP: "阵营",
  T_33_LO_WS_BHPARA_NA: "不攻击",
  T_33_LO_WS_BHPARA_P: "被动攻击",
  T_33_LO_WS_DICE_DESC: "弹跳能力极佳的骰子，可以用于各种游戏",
  T_33_LO_WS_DICEVXZ: "水平弹跳速度",
  T_33_LO_WS_DICEVY: "垂直弹跳速度",
  T_33_LO_WS_DTOWER: "防御塔",
  T_33_LO_WS_DTOWER_DESC: "一定范围内会自动攻击敌人的防御建筑，血量归零会被摧毁。在基础模式下不生效（CS/TDM/PARTY）",
  T_33_LO_WS_FORT: "基地",
  T_33_LO_WS_FORT_DESC: "一定范围内会自动攻击敌人的要塞建筑，血量归零会被摧毁。在基础模式下不生效（CS/TDM/PARTY）",
  T_33_LO_WS_ITEM89: "大水罐",
  T_33_LO_WS_ITEM89_DESC: "巨大的储水建筑",
  T_33_LO_WS_ITEM90: "狗狗屋",
  T_33_LO_WS_ITEM90_DESC: "狗子的小屋",
  T_33_LO_WS_ITEM91: "公交站",
  T_33_LO_WS_ITEM91_DESC: "常见的公交车站",
  T_33_LO_WS_ITEM92: "涂鸦墙",
  T_33_LO_WS_ITEM92_DESC: "涂鸦的墙面",
  T_33_LO_WS_ITEM93: "草棚",
  T_33_LO_WS_ITEM93_DESC: "简易的草木建筑",
  T_33_LO_WS_ITEM94: "长椅",
  T_33_LO_WS_ITEM94_DESC: "公园长椅",
  T_33_LO_WS_ITEM95: "石拱桥",
  T_33_LO_WS_ITEM95_DESC: "石头造成的桥",
  T_33_LO_WS_ITEM96: "伞",
  T_33_LO_WS_ITEM96_DESC: "充满独特风韵的伞",
  T_33_LO_WS_ITEM97: "终点横幅",
  T_33_LO_WS_ITEM97_DESC: "标注终点的横幅",
  T_33_LO_WS_ITEM98: "广告牌",
  T_33_LO_WS_ITEM98_DESC: "常见的广告牌",
  T_33_LO_WS_PARA_DM: "攻击伤害",
  T_33_LO_WS_PARA_HP: "血量",
  T_33_LO_WS_PARA_RANGE: "索敌范围",
  T_33_LO_WS_PARA_SP: "移动速度",
  T_33_LO_WS_ZBPARA_AMOUNT: "每波僵尸数",
  T_33_LO_WS_ZBPARA_INTERVAL: "每波间隔时间（秒）",
  T_33_LO_WS_ZBPARA_ROUND: "波次",
  T_33_LO_WS_ZBSPAWNER: "僵尸生成点",
  T_33_LO_WS_ZBSPAWNER_DESC: "会根据设置自动生成僵尸。可以在拓展窗口规定僵尸的行为。在基础模式下不生效（CS/TDM/PARTY）",
  T_33_MF_CHARACTER_BLACKSMITH_N: "Kenta",
  T_33_PD_ZOMBIE_LEVELUP: "升级",
  T_33_RW_SKILL_DESC_GANGGIRL: "获得[FFB300]{0}%[-]射速，击中敌人时逐渐转化为移速，最多获得[FFB300]{1}%[-]移速，脱离战斗后重置。",
  T_33_RW_SKILL_NAME_GANGGIRL: "罪恶狂欢",
  T_33_WT_WS_BASICSET1: "基础设定",
  T_33_WT_WS_QCEPRTIP: "禁用/开启呼吸回血",
  T_33_WT_WS_SKILLSET_TAG: "无限技能",
  T_33_WT_WS_SKILLSET1: "技能设定",
  T_33_WT_WS_SKILLSET10: "时空屏障（Chrono）",
  T_33_WT_WS_SKILLSET11: "節奏狂潮（Skyler）",
  T_33_WT_WS_SKILLSET12: "極限執行者（Xayne）",
  T_33_WT_WS_SKILLSET13: "心跳節拍（Dimitri）",
  T_33_WT_WS_SKILLSET2: "被动技能",
  T_33_WT_WS_SKILLSET2_TIP: "禁用/开启被动技能",
  T_33_WT_WS_SKILLSET3: "主动技能（开启后可以在下方调整各角色的技能冷却）",
  T_33_WT_WS_SKILLSET3_TIP: "禁用/开启被动技能。若开启主动技能，则可以在下方按比例调整各主动技能的冷却时间",
  T_33_WT_WS_SKILLSET4: "幻化术（Wukong）",
  T_33_WT_WS_SKILLSET5: "仿生躯体（A124）",
  T_33_WT_WS_SKILLSET6: "旋律与你同在（ALOK）",
  T_33_WT_WS_SKILLSET7: "涂鸦庇护（Steffie）",
  T_33_WT_WS_SKILLSET8: "足迹侦察（clu）",
  T_33_WT_WS_SKILLSET9: "全面菁英（K）",
  T_33_WT_WS_UNIT_HPSECOND: "HP/秒",
  T_33_WT_WS_UNIT_METER: "米",
  T_33_WT_WS_UNIT_SECOND: "秒",
  T_33_YF_G36_N: "G36",
  T_33_YS_B_RAINCOAT: "雨衣娃娃裤子",
  T_33_YS_H_ONIGIRI: "饭团头饰",
  T_33_YS_H_RAINCOAT: "雨衣娃娃头饰",
  T_33_YS_HA_CRYINGFACE: "哭脸妆容",
  T_33_YS_M_H_FROGKING: "青蛙皇冠男头饰",
  T_33_YS_S_RAINCOAT: "雨衣娃娃鞋子",
  T_33_YS_T_BLACKHOLE: "深不可测上衣",
  T_33_YS_T_RAINCOAT: "雨衣娃娃上衣",
  T_33_YS_T_SOCCER_GREEN: "越南足球服绿上衣",
  T_33_YS_T_SOCCER_YELLOW: "越南足球服黄上衣",
  T_33_YS_T_WIFI: "wifi上衣",
  T_34_C_SKILL_DESC_STREAMERGUY: "击杀或被观战都会增加BUFF层数，每一层降低[FFB300]{0}%[-]被爆头伤害，上限[FFB300]{1}%[-]，提升[FFB300]{2}%[-]爆头伤害加成，上限[FFB300]{3}%[-]",
  T_34_C_SKILL_DESC_TRACKER: "释放感知无人机，冲向前方[FFB300]100米[-]内最近的敌人，释放范围[FFB300]{5}米[-]的脉冲，降低[FFB300]{0}%[-]的移动和[FFB300]{1}%[-]的射击速度，持续[FFB300]{3}秒[-]，造成[FFB300]{2}伤害[-]，cd：[FFB300]{4}秒[-]。",
  T_34_C_SKILL_NAME_TRACKER: "敌意威慑",
  T_34_DY_PETSKIN_SURFSHARK_ENERGY_N: "冲浪教练",
  T_34_DY_PETSKIN_SURFSHARK_SEA_N: "海之狂鲨",
  T_34_DY_PETSKIN_SURFSHARK_STORM_N: "风暴鲨王",
  T_34_DY_PETSKIN_TIGER_BIS_N: "虎虎生威",
  T_34_DY_SURFSHARK_N: "速度狂鲨",
  T_34_HQ_EMOTE_BIS_COMMAND_N: "BIS活动潮流数码主题蓝色emote",
  T_34_HQ_EMOTE_RAMPAGE4_BLUE_N: "猎杀日主题emote",
  T_34_HQ_EMOTE_RIDICULE_N: "拍屁股搞怪嘲讽emote",
  T_34_HQ_VEHICLE_SUV_CRAZYSCIENTIST_N: "疯狂科学家主题皮卡皮肤",
  T_34_HQ_VEHICLE_TUTU_WINTERDOG_N: "哈士奇冬装主题突突车皮肤",
  T_34_JL_EAGLE_RAMPAGE4_N: "猎杀日4.0天劫军团主题新材质枪械",
  T_34_JL_G36_MADBIONIC_N: "仿生暴走族主题枪械",
  T_34_JL_GRENADE_BIS_N: "BIS活动潮流数码主题手雷",
  T_34_JL_MACHETE_RAMPAGE4_N: "猎杀日4.0天劫军团主题主题大砍刀",
  T_34_JL_THROWINGKNIFE_BANANA_N: "香蕉飞刀",
  T_34_JL_UMP45_BIS_N: "BIS活动潮流数码主题枪械",
  T_34_LY_WS_ABS_DESC: "获得该数值的绝对值",
  T_34_LY_WS_ADD_DESC: "在列表尾部添加一个新元素",
  T_34_LY_WS_AUTO_A: "自动索敌",
  T_34_LY_WS_BOT: "普通僵尸",
  T_34_LY_WS_BOT_PATH: "行进路径",
  T_34_LY_WS_BOT_TYPE: "僵尸类型",
  T_34_LY_WS_BOT4: "斧头僵尸",
  T_34_LY_WS_BOT5: "投掷僵尸",
  T_34_LY_WS_BOT6: "自爆僵尸",
  T_34_LY_WS_BOT8: "盾牌僵尸",
  T_34_LY_WS_COL_DESC: "用于设置颜色",
  T_34_LY_WS_DEL_DESC: "删除列表中指定索引位置的元素",
  T_34_LY_WS_DF_PER: "防御百分比",
  T_34_LY_WS_FORT_INTERVAL: "攻击间隔时间（秒）",
  T_34_LY_WS_GET: "获取",
  T_34_LY_WS_GET_DESC: "获取列表中指定索引位置的元素值",
  T_34_LY_WS_GLEN_ARR_DESC: "获取当前列表的元素个数",
  T_34_LY_WS_GLEN_DESC: "获取字符串的长度",
  T_34_LY_WS_GVX: "获取向量X",
  T_34_LY_WS_GVX_DESC: "获取向量的第一个元素",
  T_34_LY_WS_GVY: "获取向量Y",
  T_34_LY_WS_GVY_DESC: "获取向量的第二个元素",
  T_34_LY_WS_GVZ: "获取向量Z",
  T_34_LY_WS_GVZ_DESC: "获取向量的第三个元素",
  T_34_LY_WS_INDEX: "索引",
  T_34_LY_WS_JOIN: "连接",
  T_34_LY_WS_NEG_DESC: "获得该数值的负值",
  T_34_LY_WS_PATH: "路径设置器",
  T_34_LY_WS_PATH_DESC: "放置后可增删节点，指定特殊生物行进路线。在基础模式下不生效（CS/TDM/PARTY）",
  T_34_LY_WS_POINT: "选点器",
  T_34_LY_WS_POINT_DESC: "可记录当前位置坐标信息。在基础模式下不生效（CS/TDM/PARTY）",
  T_34_LY_WS_RANGE_F: "远",
  T_34_LY_WS_RANGE_M: "中",
  T_34_LY_WS_RANGE_N: "近",
  T_34_LY_WS_RNDF_DESC: "在最大值和最小值之间随机生成一个小数",
  T_34_LY_WS_RNDI_DESC: "在最大值和最小值之间随机生成一个整数",
  T_34_LY_WS_SET: "修改",
  T_34_LY_WS_SET_DESC: "修改列表中指定索引位置的元素值",
  T_34_LY_WS_SQRT_DESC: "获得该数值的平方根",
  T_34_LY_WS_STRC_DESC: "把两个字符串连接在一起",
  T_34_LY_WS_SVX: "设置向量X",
  T_34_LY_WS_SVX_DESC: "设置向量的第一个元素",
  T_34_LY_WS_SVY: "设置向量Y",
  T_34_LY_WS_SVY_DESC: "设置向量的第二个元素",
  T_34_LY_WS_SVZ: "设置向量Z",
  T_34_LY_WS_SVZ_DESC: "设置向量的第三个元素",
  T_34_LY_WS_VADD: "向量加法",
  T_34_LY_WS_VADD_DESC: "将两个向量相加",
  T_34_LY_WS_VAL_DESC: "根据实际情况填入整数或小数",
  T_34_LY_WS_VANG_DESC: "计算两个向量的夹角",
  T_34_LY_WS_VCP: "向量叉乘",
  T_34_LY_WS_VCP_DESC: "计算两个向量的叉乘",
  T_34_LY_WS_VDIS_DESC: "计算两个向量的距离",
  T_34_LY_WS_VDP: "向量点乘",
  T_34_LY_WS_VDP_DESC: "计算两个向量的点乘",
  T_34_LY_WS_VFX1: "球体",
  T_34_LY_WS_VFX2: "光柱",
  T_34_LY_WS_VFX3: "圆环",
  T_34_LY_WS_VFX4: "轰",
  T_34_LY_WS_VFX5: "传送",
  T_34_LY_WS_VFX6: "治疗",
  T_34_LY_WS_VMOD_DESC: "对向量取模",
  T_34_LY_WS_VMUL: "向量乘法",
  T_34_LY_WS_VMUL_DESC: "计算向量数乘",
  T_34_LY_WS_VNOR_DESC: "对向量进行归一化",
  T_34_LY_WS_VSUB: "向量减法",
  T_34_LY_WS_VSUB_DESC: "将两个向量相减",
  T_34_M_WS_ANGLE: "旋转角度",
  T_34_M_WS_ARRAY: "列表",
  T_34_M_WS_ATT: "属性",
  T_34_M_WS_BOOL: "布尔",
  T_34_M_WS_COLORARRAY: "颜色数组",
  T_34_M_WS_COLOUR: "颜色",
  T_34_M_WS_CONFRONBANNER: "对抗横幅",
  T_34_M_WS_COORDINATE: "坐标",
  T_34_M_WS_CUSTOMINF: "自定义界面",
  T_34_M_WS_CUSTOMMODEDESC: `空模式，无任何游戏规则，可以完全自定义，创建和游玩自己的规则。
对于初次使用者难度较大。`,
  T_34_M_WS_DAMAGETYPE: "伤害类型",
  T_34_M_WS_DAMAGETYPEDESC: "目前系统定义的伤害类型",
  T_34_M_WS_DESCTEXT: "描述文本",
  T_34_M_WS_DURACTION: "持续时间",
  T_34_M_WS_ECAMODE: "自定义模式",
  T_34_M_WS_ENDPHASEDESC: "立刻结束当前阶段，进入下一个阶段",
  T_34_M_WS_ENTITY: "实体",
  T_34_M_WS_FLOAT: "小数",
  T_34_M_WS_GAME: "游戏",
  T_34_M_WS_GAMERESULTS: "游戏结果",
  T_34_M_WS_GETCONTROL2: "从玩家界面获取一个控件实体，从而修改该控件的属性（包含样式、颜色、内容等）",
  T_34_M_WS_HEIGHT: "高度",
  T_34_M_WS_HUDBUTTONWIDGET: "按钮控件",
  T_34_M_WS_HUDEMPTYWIDGET: "空节点",
  T_34_M_WS_HUDIMAGEWIDGET: "图像控件",
  T_34_M_WS_HUDINPUTWIDGET: "输入框控件",
  T_34_M_WS_HUDLABELWIDGET: "文本控件",
  T_34_M_WS_ICON: "图标",
  T_34_M_WS_ICON_AIM: "瞄准",
  T_34_M_WS_ICON_ARROW: "箭头",
  T_34_M_WS_ICON_BLAST: "爆炸",
  T_34_M_WS_ICON_CIRCULAR: "圆形",
  T_34_M_WS_ICON_CLOTH: "布",
  T_34_M_WS_ICON_COLLIMATION: "准星",
  T_34_M_WS_ICON_CORPSE: "僵尸",
  T_34_M_WS_ICON_CROSS: "十字",
  T_34_M_WS_ICON_DAY: "太阳",
  T_34_M_WS_ICON_DEFENSE: "防守",
  T_34_M_WS_ICON_DIALOGUE: "对话",
  T_34_M_WS_ICON_DIAMONDS: "钻石",
  T_34_M_WS_ICON_EXCLAMATIONMARK: "叹号",
  T_34_M_WS_ICON_FLAG: "旗帜",
  T_34_M_WS_ICON_FOLDER: "文件夹",
  T_34_M_WS_ICON_GLASSES: "眼睛",
  T_34_M_WS_ICON_GUN: "枪",
  T_34_M_WS_ICON_HEART: "心",
  T_34_M_WS_ICON_HEXAGON: "六边形",
  T_34_M_WS_ICON_HOURGLASS: "沙漏",
  T_34_M_WS_ICON_HOUSE: "房屋",
  T_34_M_WS_ICON_KEY: "钥匙",
  T_34_M_WS_ICON_LIGHTNING: "闪电",
  T_34_M_WS_ICON_LOCK: "锁",
  T_34_M_WS_ICON_LOOP: "循环",
  T_34_M_WS_ICON_MAGNIFIER: "放大镜",
  T_34_M_WS_ICON_MONEY: "钱",
  T_34_M_WS_ICON_MONTH: "月",
  T_34_M_WS_ICON_OPENFOLDER: "打开的文件夹",
  T_34_M_WS_ICON_PLUS: "加",
  T_34_M_WS_ICON_QUADRI: "四边形",
  T_34_M_WS_ICON_QUESTIONMARK: "问号",
  T_34_M_WS_ICON_RECYCLING: "回收",
  T_34_M_WS_ICON_REFRESH: "刷新",
  T_34_M_WS_ICON_REST: "休息",
  T_34_M_WS_ICON_RETURN: "返回",
  T_34_M_WS_ICON_RIGHTTRAPEZOID: "直角梯形",
  T_34_M_WS_ICON_SCISSORS: "剪刀",
  T_34_M_WS_ICON_SETUP: "设置",
  T_34_M_WS_ICON_SIGN: "标记",
  T_34_M_WS_ICON_SIGNOUT: "退出",
  T_34_M_WS_ICON_SQUARE: "正方形",
  T_34_M_WS_ICON_STAR: "星",
  T_34_M_WS_ICON_STONE: "石头",
  T_34_M_WS_ICON_SWIMMINGCIRCLE: "泳圈",
  T_34_M_WS_ICON_TAGGING: "标注",
  T_34_M_WS_ICON_THESWORD: "剑",
  T_34_M_WS_ICON_TRAPEZOID: "梯形",
  T_34_M_WS_ICON_TRASHCAN: "垃圾桶",
  T_34_M_WS_ICON_TRIANGLE: "三角形",
  T_34_M_WS_ICON_TROPHY: "奖杯",
  T_34_M_WS_ICON_UP: "点赞",
  T_34_M_WS_ICON_WRONG: "错",
  T_34_M_WS_ICON_YES: "对",
  T_34_M_WS_ICONNAME: "图标名称",
  T_34_M_WS_INT: "整数",
  T_34_M_WS_KILLZONE: "死亡区域",
  T_34_M_WS_LEFTCOLOR: "左边颜色",
  T_34_M_WS_LEFTTEAMINDEX: "左队索引",
  T_34_M_WS_LEFTTEAMSCORE: "左队得分",
  T_34_M_WS_LOCSWITCH: "本地化开关",
  T_34_M_WS_MAX: "最大值",
  T_34_M_WS_MIN: "最小值",
  T_34_M_WS_NUMBER: "数字",
  T_34_M_WS_OBJECT: "对象",
  T_34_M_WS_OPEN: "开启",
  T_34_M_WS_OPENSATUS: "打开状态",
  T_34_M_WS_PICTURE: "图像",
  T_34_M_WS_RANKARRAY: "排行数组",
  T_34_M_WS_RESULTS: "结果",
  T_34_M_WS_RIGHTCOLOR: "右边颜色",
  T_34_M_WS_RIGHTTEAMINDEX: "右队索引",
  T_34_M_WS_RIGHTTEAMSCORE: "右队得分",
  T_34_M_WS_ROUNDBANNER: "回合横幅",
  T_34_M_WS_ROUNDDESC: "回合描述",
  T_34_M_WS_ROUNDHUD: "回合数",
  T_34_M_WS_ROUNDPARAMS: "回合数数组",
  T_34_M_WS_SAME_NAME: "名称重复，请修改",
  T_34_M_WS_SCOREARRAY: "得分数组",
  T_34_M_WS_SCORINGTYPE: "积分类型",
  T_34_M_WS_SCORINGTYPEDECS: "玩家可以获得的积分类型，同时还支持自定义积分",
  T_34_M_WS_SCUFFLESCORING: "混战计分",
  T_34_M_WS_SETATTRIBUTES: "属性设置",
  T_34_M_WS_SHUT: "关闭",
  T_34_M_WS_SOUND: "音效",
  T_34_M_WS_SOUNDCLICK: "点击",
  T_34_M_WS_SOUNDDD: "滴滴声",
  T_34_M_WS_SOUNDFEMALEA: "受伤（女）",
  T_34_M_WS_SOUNDM: "枪声",
  T_34_M_WS_SOUNDMALEA: "受伤（男）",
  T_34_M_WS_SOUNDUAV: "爆炸",
  T_34_M_WS_ST_ASSISTCOUNT: "助攻数",
  T_34_M_WS_ST_CHECKPROGRESS: "检查点进度",
  T_34_M_WS_ST_DAMAGESUM: "伤害值",
  T_34_M_WS_ST_FINISHCOUNT: "目标达成数量",
  T_34_M_WS_ST_FINISHORDER: "目标达成顺序",
  T_34_M_WS_ST_FINISHTIME: "目标达成时间",
  T_34_M_WS_ST_KILLCOUNT: "击杀数",
  T_34_M_WS_ST_MAINSCORE: "主积分",
  T_34_M_WS_ST_RANKSCORE: "排名得分",
  T_34_M_WS_ST_SURVIVALDURACTION: "生存时长",
  T_34_M_WS_ST_UNKOWN: "未知",
  T_34_M_WS_STARTBANNER: "开局横幅",
  T_34_M_WS_STARTTIME: "开始时间",
  T_34_M_WS_STRING: "文本",
  T_34_M_WS_STUDIO: "编辑器",
  T_34_M_WS_TEAMARRAY: "队伍数组",
  T_34_M_WS_TEXTCONTENT: "文本内容",
  T_34_M_WS_THEMECOLOR: "主题颜色",
  T_34_M_WS_TIME: "倒计时HUD",
  T_34_M_WS_TITLETEXT: "标题文本",
  T_34_M_WS_TYPE: "类型",
  T_34_M_WS_UODATETYPE: "更新类型",
  T_34_M_WS_VARNAME: "变量名",
  T_34_M_WS_VECTOR: "向量",
  T_34_M_WS_VFX: "特效",
  T_34_M_WS_WIDTH: "宽度",
  T_34_MF_CHARACTER_TRACKER_N: "Homer",
  T_34_PD_FlagBattle_HYPE_1: "火",
  T_34_SP_WS_BLOCK1_NAME: "切换游戏阶段",
  T_34_SP_WS_BLOCK1_NAMEDESC: "切换游戏阶段，使游戏进入目标阶段（回合）。回合也有阶段索引，它是一种特殊的阶段",
  T_34_SP_WS_BLOCK1_PARAM1_NAMEDESC: "目标阶段索引",
  T_34_SP_WS_BLOCK10_NAME: "创建特效",
  T_34_SP_WS_BLOCK10_NAMEDESC: "使用指定的特效类型创建一个图标，有更多需要设置的属性时则通过实体进一步设置它的实体属性",
  T_34_SP_WS_BLOCK10_PARAM3_NAME: "特效类型",
  T_34_SP_WS_BLOCK10_PARAM3_NAMEDESC: "特效类型，玩家可以选择的特效种类",
  T_34_SP_WS_BLOCK12_NAME: "移除特效",
  T_34_SP_WS_BLOCK12_NAMEDESC: "移除指定的特效",
  T_34_SP_WS_BLOCK12_PARAM1_NAME: "特效实体",
  T_34_SP_WS_BLOCK12_PARAM1_NAMEDESC: "要移除的特效实体",
  T_34_SP_WS_BLOCK13_NAMEDESC: "通知客户端播放特效",
  T_34_SP_WS_BLOCK13_PARAM1_NAME: "玩家列表",
  T_34_SP_WS_BLOCK13_PARAM1_NAMEDESC: "接收消息的玩家",
  T_34_SP_WS_BLOCK13_PARAM2_NAME: "资源路径",
  T_34_SP_WS_BLOCK13_PARAM2_NAMEDESC: "资源路径, 内置资源in:path, 自定义资源out:path, 默认为空",
  T_34_SP_WS_BLOCK13_PARAM3_NAMEDESC: "叠加颜色，RGBA四通道，单通道取值范围0~255，存储在一个Int32中，默认为白色（255,255,255,255）",
  T_34_SP_WS_BLOCK13_PARAM4_NAME: "缩放",
  T_34_SP_WS_BLOCK13_PARAM4_NAMEDESC: "缩放大小，默认为1",
  T_34_SP_WS_BLOCK13_PARAM5_NAMEDESC: "显示位置，世界坐标，默认为Vector3(0)",
  T_34_SP_WS_BLOCK14_NAME: "播放音效",
  T_34_SP_WS_BLOCK14_NAMEDESC: "通知客户端播放音效",
  T_34_SP_WS_BLOCK15_NAME: "输出日志",
  T_34_SP_WS_BLOCK15_NAMEDESC: "将内容输出到日志界面",
  T_34_SP_WS_BLOCK2_NAMEDESC: "开启毒圈，玩家处于毒圈中时会持续受到伤害",
  T_34_SP_WS_BLOCK2_PARAM1_NAMEDESC: "毒圈的中心点位置",
  T_34_SP_WS_BLOCK2_PARAM2_NAME: "半径",
  T_34_SP_WS_BLOCK2_PARAM2_NAMEDESC: "毒圈的外围半径",
  T_34_SP_WS_BLOCK2_PARAM3_NAMEDESC: "等待缩圈时长，等待时间结束后会开始缩圈",
  T_34_SP_WS_BLOCK2_PARAM4_NAMEDESC: "缩圈持续时长，毒圈会在这个时间结束时缩到最小",
  T_34_SP_WS_BLOCK2_PARAM5_NAMEDESC: "缩圈伤害量大小",
  T_34_SP_WS_BLOCK3_NAMEDESC: "关闭毒圈，当毒圈内圈缩到最小后，整个毒圈半径范围内玩家都会持续受到伤害，关闭毒圈后玩家恢复安全",
  T_34_SP_WS_BLOCK4_NAMEDESC: "使用等待秒可以实现将后续的动作延迟到几秒后执行",
  T_34_SP_WS_BLOCK4_PARAM1_NAMEDESC: "需要等待的时长，单位毫秒",
  T_34_SP_WS_BLOCK5_NAMEDESC: "使用等待直到下一帧可以实现将后续的动作延迟到下一帧执行",
  T_34_SP_WS_BLOCK6_NAME: "创建自定义HUD",
  T_34_SP_WS_BLOCK6_NAMEDESC: "创建指定的自定义HUD",
  T_34_SP_WS_BLOCK6_PARAM1_NAMEDESC: "代码中是用来表示创建HUD实体的形参名称，其对应的局部变量值是创建HUD的实体",
  T_34_SP_WS_BLOCK6_PARAM2_NAME: "玩家",
  T_34_SP_WS_BLOCK6_PARAM2_NAMEDESC: "所属的玩家实体，只有该玩家可见",
  T_34_SP_WS_BLOCK6_PARAM3_NAMEDESC: "Hud唯一索引",
  T_34_SP_WS_BLOCK7_NAMEDESC: "创建内置游戏HUD，只有指定的玩家可以看到该HUD",
  T_34_SP_WS_BLOCK8_NAMEDESC: "移除内置游戏HUD, 移除后客户端不可见（隐藏或者销毁）",
  T_34_SP_WS_BLOCK8_PARAM1_NAME: "HUD实体",
  T_34_SP_WS_BLOCK8_PARAM1_NAMEDESC: "要移除的目标HUD实体",
  T_34_SP_WS_BLOCK9_NAMEDESC: "移除自定义HUD, 移除后客户端不可见（隐藏或者销毁）",
  T_34_T_WS_BLOCK1_NAMEDESC: "在游戏开始时触发 ",
  T_34_T_WS_BLOCK10_NAMEDESC: "在玩家死亡时触发",
  T_34_T_WS_BLOCK10_PARAM1_DESC: "触发死亡事件的玩家",
  T_34_T_WS_BLOCK13_NAMEDESC: "在玩家助攻时触发",
  T_34_T_WS_BLOCK13_PARAM2_DESC: "被击杀的玩家",
  T_34_T_WS_BLOCK14_NAMEDESC: "在玩家造成伤害时触发",
  T_34_T_WS_BLOCK14_PARAM2_DESC: "被伤害的玩家",
  T_34_T_WS_BLOCK14_PARAM3_DESC: "伤害类型",
  T_34_T_WS_BLOCK14_PARAM4_DESC: "造成的伤害量",
  T_34_T_WS_BLOCK15_NAMEDESC: "在玩家造成击杀时触发",
  T_34_T_WS_BLOCK15_PARAM2_DESC: "被击杀的玩家",
  T_34_T_WS_BLOCK15_PARAM3_DESC: "导致死亡的伤害类型",
  T_34_T_WS_BLOCK16_NAMEDESC: "在玩家加入游戏时触发",
  T_34_T_WS_BLOCK17_NAMEDESC: "在玩家复活时触发",
  T_34_T_WS_BLOCK18_NAMEDESC: "在队伍移除时触发",
  T_34_T_WS_BLOCK19_NAMEDESC: "在添加队伍时触发",
  T_34_T_WS_BLOCK2_NAMEDESC: "在游戏结束时触发 ",
  T_34_T_WS_BLOCK20_NAMEDESC: "当队伍团灭时触发",
  T_34_T_WS_BLOCK3_NAMEDESC: "在每一回合开始时触发",
  T_34_T_WS_BLOCK3_PARAM1_DESC: "回合索引，从0开始计算",
  T_34_T_WS_BLOCK3_PARAM1_NAME: "回合索引",
  T_34_T_WS_BLOCK4_NAMEDESC: "在每一回合结束时触发",
  T_34_T_WS_BLOCK5_NAMEDESC: "在每一阶段开始时触发",
  T_34_T_WS_BLOCK5_PARAM1_DESC: "阶段实体，从0开始计算",
  T_34_T_WS_BLOCK5_PARAM1_NAME: "阶段实体",
  T_34_T_WS_BLOCK6_NAMEDESC: "在每一阶段结束时触发",
  T_34_T_WS_BLOCK7_NAMEDESC: "在玩家退出时触发",
  T_34_T_WS_BLOCK7_PARAM1_DESC: "触发事件的玩家",
  T_34_T_WS_BLOCK7_PARAM1_NAME: "触发玩家",
  T_34_T_WS_BLOCK8_NAMEDESC: "在玩家积分改变时触发",
  T_34_T_WS_BLOCK8_PARAM2_DESC: "变化积分的类型",
  T_34_T_WS_BLOCK8_PARAM3_DESC: "积分变化后的积分值",
  T_34_T_WS_BLOCK9_NAMEDESC: "在队伍积分改变时触发",
  T_34_T_WS_BLOCK9_PARAM1_DESC: "触发事件的队伍",
  T_34_WT_WS_BORNENTITY_PARAM1: "出生点",
  T_34_WT_WS_BORNENTITY_PARAM2: "可用点坐标",
  T_34_WT_WS_BORNENTITY_PARAM3: "是否是默认出生点",
  T_34_WT_WS_BORNENTITY_PARAM4: "动态栅栏",
  T_34_WT_WS_BORNENTITY_PARAM5: "是否已被占用",
  T_34_WT_WS_CHECKPOINTENTITY_PARAM1: "检查点HUD",
  T_34_WT_WS_CHECKPOINTENTITY_PARAM2: "打开状态",
  T_34_WT_WS_DEADTRIGGERNTITY_PARAM1: "状态触发器",
  T_34_WT_WS_DEADTRIGGERNTITY_PARAM2: "是否为死亡触发器",
  T_34_WT_WS_ENTITY_PARAM1: "游戏实体",
  T_34_WT_WS_ENTITY_PARAM10: "队伍数",
  T_34_WT_WS_ENTITY_PARAM11: "队伍成员数",
  T_34_WT_WS_ENTITY_PARAM12: "回合装备重置",
  T_34_WT_WS_ENTITY_PARAM13: "是否启用毒圈",
  T_34_WT_WS_ENTITY_PARAM14: "毒圈大小",
  T_34_WT_WS_ENTITY_PARAM15: "开始缩圈时间",
  T_34_WT_WS_ENTITY_PARAM16: "缩圈持续时间",
  T_34_WT_WS_ENTITY_PARAM17: "毒圈伤害",
  T_34_WT_WS_ENTITY_PARAM18: "目标积分",
  T_34_WT_WS_ENTITY_PARAM19: "击杀分值",
  T_34_WT_WS_ENTITY_PARAM2: "是否处于非法状态",
  T_34_WT_WS_ENTITY_PARAM20: "复活类型",
  T_34_WT_WS_ENTITY_PARAM21: "回合积分排名维度（玩家）",
  T_34_WT_WS_ENTITY_PARAM22: "维度排序方式（玩家）",
  T_34_WT_WS_ENTITY_PARAM23: "回合积分排名维度（队伍）",
  T_34_WT_WS_ENTITY_PARAM24: "维度排序方式（队伍）",
  T_34_WT_WS_ENTITY_PARAM25: "积分排名维度（MVP）",
  T_34_WT_WS_ENTITY_PARAM26: "维度权重（MVP）",
  T_34_WT_WS_ENTITY_PARAM27: "回合排名分",
  T_34_WT_WS_ENTITY_PARAM28: "结算展示积分维度",
  T_34_WT_WS_ENTITY_PARAM29: "游戏总回合数",
  T_34_WT_WS_ENTITY_PARAM3: "游戏时间",
  T_34_WT_WS_ENTITY_PARAM4: "当前回合索引",
  T_34_WT_WS_ENTITY_PARAM5: "当前阶段索引",
  T_34_WT_WS_ENTITY_PARAM6: "模式模板ID",
  T_34_WT_WS_ENTITY_PARAM7: "是否开启玩家复活",
  T_34_WT_WS_ENTITY_PARAM8: "是否开启BOT复活",
  T_34_WT_WS_ENTITY_PARAM9: "复活时间",
  T_34_WT_WS_ENTITY1_NAME: "此实体",
  T_34_WT_WS_ENTITY1_NAMEDESC: "返回当前实体",
  T_34_WT_WS_ENTITY10_NAME: "移除图标",
  T_34_WT_WS_ENTITY10_NAMEDESC: "移除一个指定的图标",
  T_34_WT_WS_ENTITY10_PARAM1DESC: "指定一个希望移除的图标实体",
  T_34_WT_WS_ENTITY11_NAME: "移除文本",
  T_34_WT_WS_ENTITY11_NAMEDESC: "移除一个文本实体",
  T_34_WT_WS_ENTITY11_PARAM2ESC: "指定一个希望移除的文本实体",
  T_34_WT_WS_ENTITY12_NAMEDESC: "为指定玩家添加一个道具",
  T_34_WT_WS_ENTITY12_PARAM1DESC: "得到道具的玩家实体",
  T_34_WT_WS_ENTITY12_PARAM2DESC: "得到的具体道具ID",
  T_34_WT_WS_ENTITY12_PARAM2DESC3: "得到的道具数量",
  T_34_WT_WS_ENTITY12_PARAM3: "数量",
  T_34_WT_WS_ENTITY13_PARAM1: "类型",
  T_34_WT_WS_ENTITY13_PARAM2: "位置",
  T_34_WT_WS_ENTITY13_PARAM2DESC: "生成物件的坐标位置",
  T_34_WT_WS_ENTITY13_PARAM4: "物件",
  T_34_WT_WS_ENTITY14_NAME: "移除物件",
  T_34_WT_WS_ENTITY14_NAMEDESC: "移除一个指定物件",
  T_34_WT_WS_ENTITY14_PARAM1DESC: "删除的物件实体",
  T_34_WT_WS_ENTITY15_NAMEDESC: "获取所有玩家对象",
  T_34_WT_WS_ENTITY16_NAMEDESC: "获取所有队伍对象",
  T_34_WT_WS_ENTITY17_NAMEDESC: "为指定玩家回复指定血量，超过血量上限就回复到上限",
  T_34_WT_WS_ENTITY17_PARAM1DESC: "加减血量的玩家实体",
  T_34_WT_WS_ENTITY17_PARAM2DESC: "回复的血量值",
  T_34_WT_WS_ENTITY18_NAME: "获取随机出生点坐标",
  T_34_WT_WS_ENTITY18_NAMEDESC: "使指定玩家在一个随机出生点出生，并返回该出生坐标",
  T_34_WT_WS_ENTITY18_PARAM1DESC: "随机出生的玩家实体",
  T_34_WT_WS_ENTITY18_RETURNDESC: "该玩家随机分配到的位置坐标",
  T_34_WT_WS_ENTITY19_NAME: "获取玩家积分",
  T_34_WT_WS_ENTITY19_NAMEDESC: "获取指定玩家的某类积分分数",
  T_34_WT_WS_ENTITY19_PARAM1DESC: "获取该玩家实体的积分",
  T_34_WT_WS_ENTITY19_PARAM2DESC: "获取的积分类型",
  T_34_WT_WS_ENTITY19_RETURNDESC: "获取到的具体积分值",
  T_34_WT_WS_ENTITY2_NAME: "设置属性",
  T_34_WT_WS_ENTITY2_NAMEDESC: "设置一个游戏实体的属性值，需要该属性已经被定",
  T_34_WT_WS_ENTITY2_PARAM1: "实体",
  T_34_WT_WS_ENTITY2_PARAM1DESC: "设置该游戏实体的属性值",
  T_34_WT_WS_ENTITY2_PARAM3: "属性",
  T_34_WT_WS_ENTITY2_PARAM3DESC: "该游戏实体的某个属性",
  T_34_WT_WS_ENTITY2_PARAM4: "值",
  T_34_WT_WS_ENTITY2_PARAM4DESC: "设置的具体属性值。需要确保属性值前后类型一致，符合定义时要求的类型",
  T_34_WT_WS_ENTITY20_NAMEDESC: "设置指定玩家的某类积分分数",
  T_34_WT_WS_ENTITY20_PARAM1DESC: "设置该玩家实体的积分",
  T_34_WT_WS_ENTITY20_PARAM2DESC: "设置的积分类型",
  T_34_WT_WS_ENTITY20_PARAM3: "积分",
  T_34_WT_WS_ENTITY20_PARAM3DESC: "设置的积分值",
  T_34_WT_WS_ENTITY21_NAME: "获取队伍总积分",
  T_34_WT_WS_ENTITY21_NAMEDESC: "获取指定队伍的某类积分总分数",
  T_34_WT_WS_ENTITY21_PARAM1: "队伍",
  T_34_WT_WS_ENTITY21_PARAM1DESC: "获取该队伍实体的积分",
  T_34_WT_WS_ENTITY22_NAME: "设置队伍当前回合积分",
  T_34_WT_WS_ENTITY22_NAMEDESC: "设置指定队伍当前回合某类积分分数",
  T_34_WT_WS_ENTITY22_PARAM1DESC: "设置该队伍实体的积分",
  T_34_WT_WS_ENTITY23_NAME: "获取玩家回合分",
  T_34_WT_WS_ENTITY23_NAMEDESC: "获取指定玩家在某回合的某类积分总数",
  T_34_WT_WS_ENTITY23_PARAM1DESC: "获取该玩家实体的回合积分",
  T_34_WT_WS_ENTITY23_PARAM2: "回合",
  T_34_WT_WS_ENTITY23_PARAM2DESC: "获取该回合的回合积分",
  T_34_WT_WS_ENTITY24_NAME: "获取队伍回合分",
  T_34_WT_WS_ENTITY24_NAMEDESC: "获取指定队伍在某回合的某类积分总数",
  T_34_WT_WS_ENTITY25_NAME: "传送",
  T_34_WT_WS_ENTITY25_NAMEDESC: "传送指定玩家至指定位置",
  T_34_WT_WS_ENTITY25_PARAM1DESC: "进行传送的玩家实体",
  T_34_WT_WS_ENTITY25_PARAM2DESC: "玩家被传送到的具体位置坐标",
  T_34_WT_WS_ENTITY26_NAMEDESC: "使指定玩家对指定目标造成某类伤害。若不选择造成伤害的玩家，则目标受到来自系统的伤害",
  T_34_WT_WS_ENTITY26_PARAM2DESC: "受到伤害的游戏实体 ",
  T_34_WT_WS_ENTITY26_PARAM4DESC: "造成的伤害值",
  T_34_WT_WS_ENTITY28_NAMEDESC: "复活指定玩家",
  T_34_WT_WS_ENTITY28_PARAM1DESC: "复活的玩家实体",
  T_34_WT_WS_ENTITY3_NAMEDESC: "设置一个图元的类型",
  T_34_WT_WS_ENTITY3_PARAM1: "为",
  T_34_WT_WS_ENTITY4_NAME: "获取属性",
  T_34_WT_WS_ENTITY4_NAMEDESC: "获取一个对象的特定属性",
  T_34_WT_WS_ENTITY4_PARAM1DESC: "获取属性值的具体游戏实体",
  T_34_WT_WS_ENTITY4_RETURNDESC: "获取到的具体属性值",
  T_34_WT_WS_ENTITY5_NAMEDESC: "设置全体玩家是否可以移动",
  T_34_WT_WS_ENTITY6_NAME: "创建图标",
  T_34_WT_WS_ENTITY6_PARAM1: "图标",
  T_34_WT_WS_ENTITY6_PARAM1DESC: "显示在HUD上的图案，具有多种不同样式",
  T_34_WT_WS_ENTITY6_PARAM4DESC: "当前创建的图标实体",
  T_34_WT_WS_ENTITY7_NAMEDESC: "在指定玩家HUD上创建一个图标。若不选择玩家实体，则是为全体玩家创建HUD",
  T_34_WT_WS_ENTITY7_PARAM1: "玩家",
  T_34_WT_WS_ENTITY7_PARAM1DESC: "在该玩家HUD上创建图标",
  T_34_WT_WS_ENTITY8_NAME: "创建文本",
  T_34_WT_WS_ENTITY8_PARAM1: "文本",
  T_34_WT_WS_ENTITY8_PARAM1DESC: "该指令所创建的具体文本内容",
  T_34_WT_WS_ENTITY8_PARAM3DESC: "当前创建的文本实体",
  T_34_WT_WS_ENTITY9_NAMEDESC: "在指定玩家HUD上创建一条文本。若不选择玩家，则在所有玩家HUD上创建该文本",
  T_34_WT_WS_ENTITY9_PARAM1DESC: "在该玩家HUD上创建文本",
  T_34_WT_WS_ICONENTITY_PARAM1: "图标实体",
  T_34_WT_WS_ICONENTITY_PARAM2: "样式",
  T_34_WT_WS_ICONENTITY_PARAM3: "叠加色",
  T_34_WT_WS_ICONENTITY_PARAM4: "缩放",
  T_34_WT_WS_ICONENTITY_PARAM5: "显示位置",
  T_34_WT_WS_ICONENTITY_PARAM6: "跟随目标",
  T_34_WT_WS_ICONENTITY_PARAM7: "是否穿墙显示",
  T_34_WT_WS_ICONENTITY_PARAM8: "是否总在屏幕内",
  T_34_WT_WS_ONETEAM_TAG: "单队合作",
  T_34_WT_WS_PHASEENTITY_PARAM1: "阶段实体",
  T_34_WT_WS_PHASEENTITY_PARAM2: "阶段索引",
  T_34_WT_WS_PHASEENTITY_PARAM3: "开始时间",
  T_34_WT_WS_PHASEENTITY_PARAM4: "结束时间",
  T_34_WT_WS_PHASEENTITY_PARAM5: "持续时间",
  T_34_WT_WS_PLAYERENTITY_PARAM1: "玩家实体",
  T_34_WT_WS_PLAYERENTITY_PARAM10: "复活点",
  T_34_WT_WS_PLAYERENTITY_PARAM12: "伤害倍率",
  T_34_WT_WS_PLAYERENTITY_PARAM13: "人物模型",
  T_34_WT_WS_PLAYERENTITY_PARAM17: "身份",
  T_34_WT_WS_PLAYERENTITY_PARAM18: "当前血量",
  T_34_WT_WS_PLAYERENTITY_PARAM2: "血量最大值",
  T_34_WT_WS_PLAYERENTITY_PARAM3: "是否是AI",
  T_34_WT_WS_PLAYERENTITY_PARAM4: "玩家状态",
  T_34_WT_WS_PLAYERENTITY_PARAM5: "存活时间",
  T_34_WT_WS_PLAYERENTITY_PARAM6: "无敌",
  T_34_WT_WS_PLAYERENTITY_PARAM7: "所属队伍",
  T_34_WT_WS_PLAYERENTITY_PARAM8: "目标检查点ID",
  T_34_WT_WS_PLAYERENTITY_PARAM9: "出生点",
  T_34_WT_WS_PROCIRCLE_ICON: "图标",
  T_34_WT_WS_PVEDESC1: "比赛时间结束前由一名玩家到达终点即胜利，所有玩家同时阵亡即失败",
  T_34_WT_WS_PVEDESC2: "存活至比赛时间结束即胜利，所有玩家同时阵亡即失败",
  T_34_WT_WS_PVENAME1: "闯关生存",
  T_34_WT_WS_PVENAME2: "防守生存",
  T_34_WT_WS_RUNCHECKENTITY_PARAM1: "当前检查点ID",
  T_34_WT_WS_RUNCHECKENTITY_PARAM2: "竞速模式检查点序号",
  T_34_WT_WS_SKILLSET14: "剑气防御（Kenta）",
  T_34_WT_WS_TEAMENTITY_PARAM1: "队伍实体",
  T_34_WT_WS_TEAMENTITY_PARAM2: "是否团灭",
  T_34_WT_WS_TEAMENTITY_PARAM3: "所有队员",
  T_34_WT_WS_TRIGGERNTITY_PARAM1: "普通触发器",
  T_34_WT_WS_TRIGGERNTITY_PARAM2: "外观类型",
  T_34_WT_WS_TXTENTITY_PARAM1: "文本实体",
  T_34_WT_WS_TXTENTITY_PARAM2: "文字内容",
  T_34_WT_WS_VFXENTITY_PARAM1: "特效实体",
  T_34_WZ_WS_LOGIC10_NAME: "继续下一个",
  T_34_WZ_WS_LOGIC10_NAMEDESC: "跳过剩余的循环体内容，直接进入下一次循环",
  T_34_WZ_WS_LOGIC11_NAME: "返回",
  T_34_WZ_WS_LOGIC11_NAMEDESC: "结束当前执行过程，直接返回调用位置，可以携带数据一并返回",
  T_34_WZ_WS_LOGIC11_PARAM1_NAME: "返回值",
  T_34_WZ_WS_LOGIC11_PARAM1_NAMEDESC: "希望返回给调用的位置的数据",
  T_34_WZ_WS_LOGIC2_NAME: "比较",
  T_34_WZ_WS_LOGIC2_NAMEDESC: "使用指定方式对参数进行比较",
  T_34_WZ_WS_LOGIC2_PARAM1_NAME: "左值",
  T_34_WZ_WS_LOGIC2_PARAM1_NAMEDESC: "用来比较的左值",
  T_34_WZ_WS_LOGIC2_PARAM2_NAME: "比较方式",
  T_34_WZ_WS_LOGIC2_PARAM2_NAMEDESC: "比较方式，目前支持以下类型，>,>=,==,!=,<=,<,And(限定bool类型)，Or（限定bool类型）",
  T_34_WZ_WS_LOGIC2_PARAM3_NAME: "右值",
  T_34_WZ_WS_LOGIC2_PARAM3_NAMEDESC: "用来比较的右值",
  T_34_WZ_WS_LOGIC2_PARAM4_NAMEDESC: "比较结果",
  T_34_WZ_WS_LOGIC3_NAME: "非",
  T_34_WZ_WS_LOGIC3_NAMEDESC: "逻辑取非",
  T_34_WZ_WS_LOGIC3_PARAM1_NAMEDESC: "需要求非的数值",
  T_34_WZ_WS_LOGIC3_PARAM2_NAMEDESC: "求非的结果",
  T_34_WZ_WS_LOGIC4_NAME: "判空",
  T_34_WZ_WS_LOGIC4_NAMEDESC: "判断对象是否为空",
  T_34_WZ_WS_LOGIC4_PARAM1_NAME: "对象",
  T_34_WZ_WS_LOGIC4_PARAM1_NAMEDESC: "要判空的任意对象",
  T_34_WZ_WS_LOGIC4_PARAM2_NAMEDESC: "是否为空",
  T_34_WZ_WS_LOGIC5_NAME: "如果",
  T_34_WZ_WS_LOGIC5_NAMEDESC: "用以实现根据不同条件执行不同逻辑分支功能，含有子过程，其逻辑分支列表就是子过程列表",
  T_34_WZ_WS_LOGIC5_PARAM1_NAME: "值",
  T_34_WZ_WS_LOGIC5_PARAM1_NAMEDESC: "条件列表需求和子过程列表（逻辑分支列表）数量保持一致",
  T_34_WZ_WS_LOGIC6_NAME: "整数范围循环",
  T_34_WZ_WS_LOGIC6_NAMEDESC: "实现以步长z从x到y的范围循环，含有子过程，循环体就是子过程",
  T_34_WZ_WS_LOGIC6_PARAM1_NAMEDESC: "循环索引的名称，可以使用它获取到局部变量上的循环索引值",
  T_34_WZ_WS_LOGIC6_PARAM2_NAME: "起始值",
  T_34_WZ_WS_LOGIC6_PARAM2_NAMEDESC: "循环初始值",
  T_34_WZ_WS_LOGIC6_PARAM3_NAME: "结束值",
  T_34_WZ_WS_LOGIC6_PARAM3_NAMEDESC: "循环结束值",
  T_34_WZ_WS_LOGIC6_PARAM4_NAME: "步长",
  T_34_WZ_WS_LOGIC6_PARAM4_NAMEDESC: "循环步长，当起始值小于结束值时，步长应大于0，当起始值大于结束值时，步长应小于0",
  T_34_WZ_WS_LOGIC7_NAME: "逐个循环",
  T_34_WZ_WS_LOGIC7_NAMEDESC: "Enables traversal of a data container to extract each sub-element in it. The sub-process is the loop itself.",
  T_34_WZ_WS_LOGIC7_PARAM1_NAME: "元素",
  T_34_WZ_WS_LOGIC7_PARAM1_NAMEDESC: "遍历到子元素的名称，可以使用它获取到局部变量上的子元素值",
  T_34_WZ_WS_LOGIC7_PARAM3_NAME: "数据容器",
  T_34_WZ_WS_LOGIC7_PARAM3_NAMEDESC: "要遍历的数据容器，目前支持列表类型",
  T_34_WZ_WS_LOGIC8_NAME: "条件循环",
  T_34_WZ_WS_LOGIC8_NAMEDESC: "实现条件是否为真持续执行的循环，直到条件为假结束循环",
  T_34_WZ_WS_LOGIC8_PARAM1_NAME: "循环条件",
  T_34_WZ_WS_LOGIC8_PARAM1_NAMEDESC: "当条件为真则继续循环，条件为假则结束循环",
  T_34_WZ_WS_LOGIC9_NAME: "打断",
  T_34_WZ_WS_LOGIC9_NAMEDESC: "打断当前循环过程，退出循环",
  T_34_Y_B_DINOSAURS: "恐龙趣味裤子",
  T_34_YF_M24_N: "M24",
  T_34_YS_F_B_ANGEL_BW: "黑白天使换皮女裤子",
  T_34_YS_F_B_PANDACATTLE: "奶牛熊猫女裤子",
  T_34_YS_F_B_RAMPAGE4_RAIN: "猎杀日4.0雨女裤子",
  T_34_YS_F_H_RAMPAGE4_RAIN: "猎杀日4.0雨女头饰",
  T_34_YS_F_HA_RAMPAGE4_RAIN: "猎杀日4.0雨女妆容",
  T_34_YS_F_S_PANDACATTLE: "奶牛熊猫女鞋子",
  T_34_YS_F_S_RAMPAGE4_RAIN: "猎杀日4.0雨女鞋子",
  T_34_YS_F_T_PANDACATTLE: "奶牛熊猫女上衣",
  T_34_YS_F_T_RAMPAGE4_RAIN: "猎杀日4.0雨女上衣",
  T_34_YS_M_B_ANGEL_BW: "黑白天使换皮男裤子",
  T_34_YS_M_B_PANDACATTLE: "奶牛熊猫男裤子",
  T_34_YS_M_H_PANDACATTLE: "奶牛熊猫男头饰",
  T_34_YS_M_S_PANDACATTLE: "奶牛熊猫男鞋子",
  T_34_YS_M_T_PANDACATTLE: "奶牛熊猫男上衣",
  T_34_YZY_CHARACTER_RHYTHMGIRL_N: "A-Patroa",
  T_35_C_SKILL_DESC_BRAZILSOLDIER: "击倒敌人立即获得[FFB300]{0}点[-]能量",
  T_35_DY_PET_OWL_N: "猫头鹰",
  T_35_DY_PETSKIN_ALIEN_DIGITALUNIVERSE_N: "五周年莫尼",
  T_35_DY_PETSKIN_CATEAM_AXOLOTL_N: "CA蝾螈",
  T_35_DY_PETSKIN_CATEAM_HAWK_N: "CA猎隼",
  T_35_DY_PETSKIN_OWL_FIRE_N: "烈焰猫头鹰",
  T_35_DY_PETSKIN_OWL_NIGHT_N: "星空猫头鹰",
  T_35_DY_PETSKIN_OWL_STORM_N: "风暴猫头鹰",
  T_35_JL_KNOCKEDDOWN: "被击倒",
  T_35_JL_SKILL_DESC_CRAZYGIRL: "施放技能后，[FFB300]{1}秒[-]内，子弹命中冰墙可标记出冰墙[FFB300]{3}米[-]内的敌人，并且可穿透此冰墙对被标记的敌人射击，但伤害会有所衰减。最多会[FFB300]{0}个[-]冰墙生效。CD时间[FFB300]{2}秒[-]。爆炸类武器不生效。",
  T_35_JL_SKILL_NAME_CRAZYGIRL: "隔墙战栗",
  T_35_KY_INFECTION_MAPNAME: "机械废墟",
  T_35_M_WS_BUTTONCLICKDESC: "当对应按钮被点击时触发该事件，可以通过参数获取点击的玩家",
  T_35_M_WS_GETTEAMMATEPOS: "获得附近队友位置",
  T_35_M_WS_ROUND2: "当前波次",
  T_35_PD_Infection_HUMANSELECT: "选择武器",
  T_35_PD_INFECTION_MODENAME: "Droid Apocalypse",
  T_35_QX_WS_ICONTYPE_ITEM: "物品",
  T_35_QX_WS_ICONTYPE_NATURE: "自然",
  T_35_QX_WS_ICONTYPE_SHAPE: "形状",
  T_35_QX_WS_ICONTYPE_SYMBOL: "符号",
  T_35_QX_WS_SOUNDTYPE_WEAPON: "武器声",
  T_35_R_EMOTE_TAG_MUSIC_N: "音乐",
  T_35_RW_SKILL_DESC_Singers: "周围[FFB300]{0}米[-]内的友军可以使用EP阻挡[FFB300]{1}%[-]的伤害，其他友军因抵挡伤害而消耗的ep会补充给技能携带者。",
  T_35_RW_SKILL_NAME_Singers: "和平链接",
  T_35_SP_WS_COMMENTKEY_01: "难度适中",
  T_35_SP_WS_COMMENTKEY_02: "玩法新颖",
  T_35_SP_WS_COMMENTKEY_03: "玩法有趣",
  T_35_SP_WS_COMMENTKEY_04: "重复游玩性高",
  T_35_SP_WS_COMMENTKEY_05: "剧情优秀",
  T_35_SP_WS_COMMENTKEY_06: "平衡优秀",
  T_35_SP_WS_COMMENTKEY_07: "体验良好",
  T_35_SP_WS_COMMENTKEY_08: "自由度高",
  T_35_SP_WS_COMMENTKEY_09: "场景美观",
  T_35_SP_WS_COMMENTKEY_10: "难度过高",
  T_35_SP_WS_COMMENTKEY_11: "难度过低",
  T_35_SP_WS_COMMENTKEY_12: "玩法无趣",
  T_35_SP_WS_COMMENTKEY_13: "回合过多",
  T_35_SP_WS_COMMENTKEY_14: "平衡较差",
  T_35_SP_WS_COMMENTKEY_15: "体验较差",
  T_35_SP_WS_IMAGE03: "表面",
  T_35_SP_WS_IMAGE04: "边框",
  T_35_SY_CHARGESHOT_TEARS_N: "朱红之泪主题枪械A",
  T_35_SY_GRENADE_DIGITALUNIVERSE_01_N: "五周年数字宇宙主题手雷紫",
  T_35_SY_GRENADE_PIRATES_N: "太空海盗主题手雷",
  T_35_SY_GRENADE_RIDERS_N: "潮酷骑手主题手雷",
  T_35_SY_M24_KUN_N: "鲲主题枪械A",
  T_35_SY_SCAR_PARKOUR_N: "新手付费烈焰跑酷主题枪械B",
  T_35_SY_VEHICLE_JEEP_PANTOMIME_N: "绝命哑剧主题吉普车皮肤",
  T_35_SY_VEHICLE_MONSTER_DIGITALUNIVERSE_D: "这是五周年数字宇宙主题神秘商店填充大脚车皮肤",
  T_35_SY_VEHICLE_MOTOBIKE_DIGITALUNIVERSE_N: "五周年数字宇宙主题摩托车皮肤",
  T_35_WT_WS_PREFAB_MENUBAR_1: "结构及装饰",
  T_35_WT_WS_PREFAB_MENUBAR_1_1: "结构元件",
  T_35_WT_WS_PREFAB_MENUBAR_1_6: "杂项",
  T_35_WT_WS_PREFAB_MENUBAR_2: "建筑相关",
  T_35_WT_WS_PREFAB_MENUBAR_2_1: "大型建筑",
  T_35_WT_WS_PREFAB_MENUBAR_2_2: "中型房屋",
  T_35_WT_WS_PREFAB_MENUBAR_3: "带功能物件",
  T_35_WT_WS_PREFAB_MENUBAR_3_1: "模式必须",
  T_35_WT_WS_PREFAB_MENUBAR_3_6: "音乐物件",
  T_35_WT_WS_PVEMODE_TAG: "生存模式",
  T_35_WZY_WS_BECRE_NAMEDESC: "该对象被创建时触发",
  T_35_WZY_WS_BEKILL_NAMEDESC: "该对象被击杀时触发，可以通过[触发实体]判断凶手，也可以通过[伤害类型]确定击杀方式",
  T_35_WZY_WS_BEKILL_PARAM1_NAMEDESC: "触发事件的实体",
  T_35_WZY_WS_CREPROP_NAMEDESC: "在指定位置创建掉落物品，可以添加单个物品和一组物品。添加单个物品时，数量为该物品的数量；添加一组物品时，数量为与物品列表对应的数量列表。创建物品数量受到地图cost影响",
  T_35_WZY_WS_CREPROP_PARAM1_NAMEDESC: "掉落的道具组成的列表，也可以是单个道具",
  T_35_WZY_WS_CREPROP_PARAM2_NAMEDESC: "对应掉落道具列表的数量列表，也可以是单个道具的数量",
  T_35_WZY_WS_DAMTYPE_CAR: "汽车",
  T_35_WZY_WS_DAMTYPE_FALL: "摔伤",
  T_35_WZY_WS_DAMTYPE_FIREARMS: "枪械",
  T_35_WZY_WS_DAMTYPE_GRENADE: "手雷",
  T_35_WZY_WS_DAMTYPE_MELEE: "近战",
  T_35_WZY_WS_DAMTYPE_ZONE: "毒圈",
  T_35_WZY_WS_DELPROP_NAMEDESC: "删除指定玩家指定数量的道具",
  T_35_WZY_WS_ENTERTRIGGER_NAME: "进入触发器",
  T_35_WZY_WS_ENTERTRIGGER_NAMEDESC: "[触发实体]进入触发器时触发",
  T_35_WZY_WS_ENTITYPLAYER_DESC: "获得实体的绑定玩家，绑定玩家的实体只会和绑定玩家进行同步.没有绑定时是公开所有玩家进行同步",
  T_35_WZY_WS_FIGHTENTITY_NAME: "可战斗实体",
  T_35_WZY_WS_GETALLOB_NAMEDESC: "获取游戏内指定类型的所有物件，返回值是一个列表",
  T_35_WZY_WS_GETALLOB_PARAM1_NAMEDESC: "获取的物件类型",
  T_35_WZY_WS_HUDWIDGET_NAME: "UI控件",
  T_35_WZY_WS_HURT_NAMEDESC: "该对象受到伤害时触发，可以通过[触发实体]判断伤害来源",
  T_35_WZY_WS_ITEMSTYPE_NAMEDESC: "道具类型",
  T_35_WZY_WS_LEVELOBJECT_NAME: "关卡物件",
  T_35_WZY_WS_OBKILL_NAMEDESC: "该对象造成击杀时触发，可以通过[死亡实体]判断击杀对象类型",
  T_35_WZY_WS_OBKILL_PARAM1_NAMEDESC: "被击杀的实体",
  T_35_WZY_WS_ONHURT_NAMEDESC: "实体造成伤害时触发",
  T_35_WZY_WS_ONHURT_PARAM1_DESC: "造成伤害的实体",
  T_35_WZY_WS_ONHURT_PARAM1_NAME: "目标实体",
  T_35_WZY_WS_PREFABID_NAME: "模板ID",
  T_35_WZY_WS_PROPERTY_EPNOW: "当前EP",
  T_35_WZY_WS_PROPERTY_JUMP: "跳跃高度",
  T_35_WZY_WS_QUITTRIGGER_NAME: "退出触发器",
  T_35_WZY_WS_QUITTRIGGER_NAMEDESC: "[触发实体]退出触发器时触发",
  T_35_WZY_WS_REMOVEELEMENT_NAMEDESC: "从列表中移除指定元素，[列表]是要移除元素所在的列表， [元素]是要移除的元素",
  T_35_WZY_WS_REMOVEELEMENT_PARAM1_NAME: "元素值",
  T_35_WZY_WS_REMOVEELEMENT_PARAM1_NAMEDESC: "要移除的元素值",
  T_35_WZY_WS_ROUNDENTITY_NAME: "回合实体",
  T_35_WZY_WS_TOWER_PARAM1: "防御塔和基地",
  T_35_WZY_WS_TOWER_PARAM2: "阵营ID",
  T_35_WZY_WS_TOWER_PARAM3: "当前血量",
  T_35_WZY_WS_TOWER_PARAM4: "血量上限",
  T_35_WZY_WS_TOWER_PARAM5: "伤害",
  T_35_WZY_WS_TOWER_PARAM6: "攻击间隔",
  T_35_WZY_WS_TOWER_PARAM7: "攻击范围",
  T_35_WZY_WS_TOWER_PARAM8: "防御百分比",
  T_35_XYL_PDM_REVENGE: "复仇",
  T_35_XYL_WS_BISPARTERRE: "BIS主题花坛",
  T_35_XYL_WS_BISPARTERRE_DESC: "BIS主题的普通花坛",
  T_35_XYL_WS_BISWALL: "BIS主题墙壁",
  T_35_XYL_WS_BISWALL_DESC: "可以拼接的BIS主题墙壁",
  T_35_XYL_WS_BOTDROP: "是否开启战利品掉落",
  T_35_XYL_WS_CUSTOMTRIGGER: "自定义触发器",
  T_35_XYL_WS_CUSTOMTRIGGER_DESC: "放置一个玩家触碰后可以触发自定义效果的物件，效果需要玩家在脚本中编辑设置。在基础模式下不生效（CS/TDM/PARTY）",
  T_35_XYL_WS_DOUBLEDOOR: "双扇门",
  T_35_XYL_WS_DOUBLEDOOR_DESC: "略微错开的两扇门",
  T_35_XYL_WS_RESET: "是否每回合重置",
  T_35_XYL_WS_RESETN: "否",
  T_35_XYL_WS_RESETY: "是",
  T_35_XYL_WS_ROADBLOCK: "路障",
  T_35_XYL_WS_ROADBLOCK_DESC: "可以阻挡通行的普通路障",
  T_35_XYL_WS_STAIRS: "楼梯",
  T_35_XYL_WS_STAIRS_DESC: "可以拼接的楼梯",
  T_35_XYL_WS_STAIRSL: "楼梯平台B",
  T_35_XYL_WS_STAIRSL_DESC: "直角的楼梯平台，可以与楼梯组合使用",
  T_35_XYL_WS_STAIRSZ: "楼梯平台A",
  T_35_XYL_WS_STAIRSZ_DESC: "折返的楼梯平台，可以与楼梯组合使用",
  T_35_XYL_WS_TBOOTH: "电话亭",
  T_35_XYL_WS_TBOOTH_DESC: "马路边常见的电话亭",
  T_35_YF_PP19_N: "PP19",
  T_35_YS_A_CATEAM_HW: "CA球队换皮面饰",
  T_35_YS_A_CUBBY: "小熊换皮面饰",
  T_35_YS_F_A_PANTOMIME: "绝命哑剧女面饰",
  T_35_YS_F_A_RIDERS: "潮酷骑手女面饰",
  T_35_YS_F_B_DIGITALUNIVERSE2: "数字宇宙低级女裤子",
  T_35_YS_F_B_GOLDCHAIN: "裸奔金链女裤子",
  T_35_YS_F_B_PANTOMIME: "绝命哑剧女裤子",
  T_35_YS_F_B_RIDERS: "潮酷骑手女裤子",
  T_35_YS_F_H_BEAR_HW: "小熊女头饰",
  T_35_YS_F_H_DIGITALUNIVERSE2: "数字宇宙低级女头饰",
  T_35_YS_F_H_GOLDCHAIN: "裸奔金链女头饰",
  T_35_YS_F_H_PANTOMIME: "绝命哑剧女头饰",
  T_35_YS_F_H_RIDERS: "潮酷骑手女头饰",
  T_35_YS_F_HA_GOLDCHAIN: "裸奔金链女妆容",
  T_35_YS_F_S_DIGITALUNIVERSE2: "数字宇宙低级女鞋子",
  T_35_YS_F_S_GOLDCHAIN: "裸奔金链女鞋子",
  T_35_YS_F_S_PANTOMIME: "绝命哑剧女鞋子",
  T_35_YS_F_S_RIDERS: "潮酷骑手女鞋子",
  T_35_YS_F_T_DIGITALUNIVERSE2: "数字宇宙低级女上衣",
  T_35_YS_F_T_GOLDCHAIN: "裸奔金链女上衣",
  T_35_YS_F_T_PANTOMIME: "绝命哑剧女上衣",
  T_35_YS_F_T_RIDERS: "潮酷骑手女上衣",
  T_35_YS_ITEM_SUPERFAK: "强力医疗包",
  T_35_YS_M_A_GOLDCHAIN: "裸奔金链男面饰",
  T_35_YS_M_A_RIDERS: "潮酷骑手男面饰",
  T_35_YS_M_B_GOLDCHAIN: "裸奔金链男裤子",
  T_35_YS_M_B_RIDERS: "潮酷骑手男裤子",
  T_35_YS_M_H_BEAR_HW: "小熊男头饰",
  T_35_YS_M_H_GOLDCHAIN: "裸奔金链男头饰",
  T_35_YS_M_H_RIDERS: "潮酷骑手男头饰",
  T_35_YS_M_S_GOLDCHAIN: "裸奔金链男鞋子",
  T_35_YS_M_S_RIDERS: "潮酷骑手男鞋子",
  T_35_YS_M_T_GOLDCHAIN: "裸奔金链男上衣",
  T_35_YS_M_T_RIDERS: "潮酷骑手男上衣",
  T_35_YS_T_CHAMPION: "世界赛决赛冠军换皮上衣",
  T_35_YS_T_PAINTING: "画中画换皮上衣",
  T_35_YZY_CHARACTER_CRAZYGIRL_N: "Iris",
  T_35_YZY_CHARACTER_SINGERS_N: "J Biebs",
  T_36_JH_WS_BASEMONEY: "每回合开始时获得金币",
  T_36_JH_WS_CESAYCLOSE: "是否禁止手动关闭",
  T_36_JH_WS_CHOOSEEDITSHOP: "选择要编辑的商店",
  T_36_JH_WS_CHOOSESHOP: "选择商店",
  T_36_JH_WS_COINCOUNT: "货币数量",
  T_36_JH_WS_COINHUD: "是否显示金币数量",
  T_36_JH_WS_CRAFTSHOP: "编辑商店",
  T_36_JH_WS_CREATEGOLD: "金币生成器",
  T_36_JH_WS_CSHOPENTITY: "绑定商店实体",
  T_36_JH_WS_CSHOPHUD: "商店界面",
  T_36_JH_WS_CURRENTLIMIT: "当前总体限购",
  T_36_JH_WS_ECONOMIC: "经济系统",
  T_36_JH_WS_INGAMEECONOMI: "游戏经济",
  T_36_JH_WS_ITEMINDEXID: "商品编号",
  T_36_JH_WS_KILLMONEY: "击杀玩家获得金币",
  T_36_JH_WS_KILLMONEYTIP: "在闯关生存和防守生存模式中，为击杀丧尸获得金币数量",
  T_36_JH_WS_LISTINDEX: "货架列表",
  T_36_JH_WS_NULL: "空",
  T_36_JH_WS_NUMBER: "数量",
  T_36_JH_WS_OPTIONNAME: "启示录模式专用",
  T_36_JH_WS_REALSHOPENTITY: "商店实体",
  T_36_JH_WS_SEEORHIDE: "模型显隐",
  T_36_JH_WS_SHOPFRONT: "商店",
  T_36_JH_WS_SHOPITEMLIST: "商店货架",
  T_36_JH_WS_SHOPOPENCON: "打开状态",
  T_36_JH_WS_SSHOPNAME: "商店名字",
  T_36_JH_WS_TOTALLIMIT: "总体限购",
  T_36_JH_WS_TRIGGERWIDE: "感应范围",
  T_36_JH_WS_VENDMACHINE: "贩卖机",
  T_36_JH_WS_WINMONEY: "获胜队伍获得金币",
  T_36_JH_WS_WORTH: "价值",
  T_36_JL_FOREGRIP_MR_N: "射手步枪握把",
  T_36_JL_GOLD_SCAR_I_N: "SCAR-I",
  T_36_JL_GOLD_SCAR_II_N: "SCAR-II",
  T_36_JL_GOLD_SCAR_III_N: "SCAR-III",
  T_36_JL_STOCK_SG_N: "霰弹枪枪托",
  T_36_JL_STOCK_SR_N: "狙击枪枪托",
  T_36_KK_WS_MONTSTERDES: "高裝甲值，不容易被破壞，可以越過一些普通車輛無法越過的地形，最多乘載4人",
  T_36_M_WS_SETTEMPVAR: "设置临时变量",
  T_36_M_WS_TEMPVAR: "临时变量",
  T_36_SY_AK47_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_AN94_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_AR15_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_AUG_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_AWM_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_BLT_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_CHARGESHOT_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_EAGLE_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_FAMAS_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_G18_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_G36_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_GRENADE_FESTIVAL_TU_N: "土耳其共和日主题手雷",
  T_36_SY_GROZA_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_HAND_CANNON_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_HEALINGSNIPER_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_ICE_GUN_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_KAR98K_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_KORD_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_M1014_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_M14_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_M1873_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_M1887_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_M1917_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_M21A5_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_M24_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_M249_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_M4A1_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_M500_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_M60_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_M79_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_MAC10_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_MAG7_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_MINI_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_MP40_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_MP5_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_P90_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_PARAFAL_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_PP19_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_PP19_POLICEMAN_N: "现代辑魔警主题枪械",
  T_36_SY_SCAR_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_SKS_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_SPAS12_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_SUPERHEAT_GUN_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_SVD_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_THOMPSON_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_THROWINGKNIFE_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_THROWINGKNIFE_MENA_N: "中东北非主题飞刀",
  T_36_SY_TREATMENTGUN_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_UMP45_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_USP45_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_UZI_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_VECTOR_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_VEHICLE_MONSTER_TRUCK_BDK_N: "Booyah Day KOL主题大脚车皮肤",
  T_36_SY_VEHICLE_MOTOBIKE_SUGARSKULL22_N: "拉美亡灵节主题摩托车皮肤",
  T_36_SY_VEHICLE_ROADSTER_BDK_N: "Booyah Day KOL主题跑车皮肤",
  T_36_SY_VEHICLE_TUTU_POLICEMAN_N: "现代辑魔警主题三轮车皮肤",
  T_36_SY_VSS_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_SY_XM8_MAMBAS_N: "Mambas衔尾蛇换皮枪械",
  T_36_WZY_AFTERACCUMULATOR: "后置累加器",
  T_36_WZY_AVAILAB: "可用性",
  T_36_WZY_BACKANDFORTH: "来回",
  T_36_WZY_BASEMULTIPLIER: "基础系数",
  T_36_WZY_BASIC: "基础类型",
  T_36_WZY_BEFORACCUMULATOR: "前置累加器",
  T_36_WZY_CYLIC: "循环",
  T_36_WZY_GUNPRO_PARAM1: "基本伤害",
  T_36_WZY_GUNPRO_PARAM10: "开始扩散阈值",
  T_36_WZY_GUNPRO_PARAM11: "最大扩散阈值",
  T_36_WZY_GUNPRO_PARAM12: "连发间隔",
  T_36_WZY_GUNPRO_PARAM2: "弹夹子弹数量",
  T_36_WZY_GUNPRO_PARAM3: "初始弹夹数量",
  T_36_WZY_GUNPRO_PARAM4: "发射间隔",
  T_36_WZY_GUNPRO_PARAM7: "满伤害距离",
  T_36_WZY_GUNPRO_PARAM8: "最小伤害开始距离",
  T_36_WZY_GUNPRO_PARAM9: "最小伤害",
  T_36_WZY_MULTIPLIR: "连乘器",
  T_36_WZY_PRICE: "价格",
  T_36_WZY_SUMMULTIPLIER: "乘法累加器",
  T_36_WZY_WS_3DZOOM: "三维缩放",
  T_36_WZY_WS_ABSRES: "绝对值的结果",
  T_36_WZY_WS_ADDALLELE_NAMEDESC: "将[追加列表]中所有元素添加到[目标列表]尾部",
  T_36_WZY_WS_ADDALLELE_PARAM1_DESC: "增加元素的目标列表",
  T_36_WZY_WS_ADDALLELE_PARAM2_DESC: "追加的元素列表",
  T_36_WZY_WS_ADDCURR_NAMEDESC: "增加指定钱包中的一定数量的指定货币",
  T_36_WZY_WS_ADDCURR_PARAM1_NAME: "钱包",
  T_36_WZY_WS_ADDCURR_PARAM1_NAMEDESC: "需要增加货币的钱包",
  T_36_WZY_WS_ADDSUB: "加减数值",
  T_36_WZY_WS_AIENTITY: "AI实体",
  T_36_WZY_WS_ALLSHOP_DESC: "商店实体组成的列表",
  T_36_WZY_WS_ANGLE_DESC: "角度制的值",
  T_36_WZY_WS_ANYTYPE: "任意类型",
  T_36_WZY_WS_ARILEFT: "运算的左值",
  T_36_WZY_WS_ARIRES: "四则计算结果",
  T_36_WZY_WS_ARIRIGHT: "运算的右值",
  T_36_WZY_WS_ARITHMETIC_NAME: "四则运算",
  T_36_WZY_WS_ARITHMETIC_NAMEDESC: "基本四则运算，整数支持加、减、乘、除、余；小数支持加、减、乘、除",
  T_36_WZY_WS_ARRAY_DESC: "目标数组",
  T_36_WZY_WS_ARRCONELE_NAMEDESC: "判断一个列表中是否包含指定的元素，返回值是一个布尔值",
  T_36_WZY_WS_ARRCONELE_PARAM1_DESC: "指定的的列表",
  T_36_WZY_WS_ARRCONELE_PARAM2_DESC: "判断是否在列表中的元素",
  T_36_WZY_WS_ARRCONELERES: "判断列表中是否包含指定元素的结果，布尔值",
  T_36_WZY_WS_ATTACK: "边巡逻边攻击",
  T_36_WZY_WS_BEKNODOWN_NAMEDESC: "玩家被击倒进入跪地状态时触发",
  T_36_WZY_WS_BIGFLOAT: "大数",
  T_36_WZY_WS_BIGTOYBALL: "骰子",
  T_36_WZY_WS_BOOLLIST: "布尔列表",
  T_36_WZY_WS_CEIL_NAME_DESC: "对指定值按照向上取整方式取整",
  T_36_WZY_WS_CEIL_PARAM1_NAMEDESC: "进行向上取整的值",
  T_36_WZY_WS_CEILRES: "向上取整计算结果",
  T_36_WZY_WS_CHASEENT_NAMEDESC: "选择的AI实体无视距离专注追击实体, [目标实体]可以是任何实体，[目标实体]没有HP属性时，AI实体造成的伤害是0",
  T_36_WZY_WS_CHASEENT_PARAM1_NAMEDESC: "执行追击动作的单位实体",
  T_36_WZY_WS_CHASEENT_PARAM2_NAMEDESC: "任何实体，单位实体追击的目标",
  T_36_WZY_WS_CLONEOBJ_PARAM1_DESC: "克隆物件的模板，通过拾取器选择，克隆的物件属性和脚本和拾取器选择的物件实体一致",
  T_36_WZY_WS_CLONEOBJ_PARAM2_DESC: "克隆生成的物件实体",
  T_36_WZY_WS_CONDITION: "条件",
  T_36_WZY_WS_CONDITIONLIST: "条件列表",
  T_36_WZY_WS_CONOFHUD: "控件所在HUD实体",
  T_36_WZY_WS_CONTROL_DESC: "控件唯一索引",
  T_36_WZY_WS_COS_NAMEDESC: "求角度的余弦值",
  T_36_WZY_WS_COSRES: "角度的余弦值",
  T_36_WZY_WS_CREABLEOB: "可创建物件",
  T_36_WZY_WS_CREOBJ_NAMEDESC: "在指定位置创建一个物件实体，测试版本",
  T_36_WZY_WS_CREOBJ_PARAM1_DESC: "物件创建的位置坐标",
  T_36_WZY_WS_CREOBJ_PARAM2_DESC: "创建的物件类型",
  T_36_WZY_WS_CREOBJ_PARAM3_DESC: "创建的物件实体",
  T_36_WZY_WS_CREPROD_PARAM2_NAME: "货币",
  T_36_WZY_WS_CREPROD_PARAM4_NAME: "商品实体",
  T_36_WZY_WS_CREPROD_PARAM4_NAMEDESC: "创建的商品实体",
  T_36_WZY_WS_CREWALL_NAMEDESC: "创建钱包实体，[绑定玩家]是该钱包可见的玩家，[拥有者]是钱包的拥有者，若已存在钱包则无效",
  T_36_WZY_WS_CREWALL_PARAM1_NAME: "绑定玩家",
  T_36_WZY_WS_CREWALL_PARAM1_NAMEDESC: "钱包可见的玩家，不设置则公开",
  T_36_WZY_WS_CREWALL_PARAM2_NAMEDESC: "钱包的拥有者",
  T_36_WZY_WS_CREWALL_PARAM3_NAME: "钱包实体",
  T_36_WZY_WS_CREWALL_PARAM3_NAMEDESC: "创建的钱包实体",
  T_36_WZY_WS_CURRAMT: "货币数量",
  T_36_WZY_WS_DATA_TYPE1: "嵌入参数",
  T_36_WZY_WS_DATA_TYPE2: "基本和逻辑运算",
  T_36_WZY_WS_DATA_TYPE3: "列表操作",
  T_36_WZY_WS_DATA_TYPE4: "向量计算",
  T_36_WZY_WS_DESTITEM_NAME: "摧毁玩家物品",
  T_36_WZY_WS_DESTITEM_NAMEDESC: "摧毁指定玩家身上指定类型对应栏位的物品",
  T_36_WZY_WS_DESTITEM_PARAM1_NAMEDESC: "摧毁的物品类型，包括武器、防弹衣、头盔",
  T_36_WZY_WS_DESTITEM_PARAM2_NAMEDESC: "摧毁的物品在玩家该类型物品的栏位索引，武器为[1,3]，防弹衣、头盔默认为1",
  T_36_WZY_WS_DESTITEM_WHELOSTEQU: "死亡时是否遗失装备",
  T_36_WZY_WS_DESTOBJ: "可破坏物件",
  T_36_WZY_WS_DIRPOINT: "方向点",
  T_36_WZY_WS_DIRPOINTDESC: "构造的方向点",
  T_36_WZY_WS_ELEFINDRES: "列表中元素最先出现的位置索引",
  T_36_WZY_WS_ELEFIRINDEX_NAMEDESC: "获取列表中元素最先出现的位置索引，列表中无目标元素则返回-1",
  T_36_WZY_WS_ELEFIRINDEX_PARAM2_DESC: "获取位置索引的元素",
  T_36_WZY_WS_ELELASINDEX_NAMEDESC: "获取列表中元素最后出现的位置索引，列表中无目标元素则返回-1",
  T_36_WZY_WS_ELELINDRES: "列表中元素最后出现的位置索引",
  T_36_WZY_WS_ELEMENTSNUM: "数组中的元素个数",
  T_36_WZY_WS_ENTCOLLIDE_NAMEDESC: "[触发实体]与该机关碰撞时触发",
  T_36_WZY_WS_ENTCOLLIDE_PARAM1_NAMEDESC: "与该机关碰撞的实体",
  T_36_WZY_WS_ENTDRIVEH_NAMEDESC: "[触发实体]驾驶该载具时触发",
  T_36_WZY_WS_ENTDRIVEH_PARAM1_NAMEDESC: "驾驶该载具的实体",
  T_36_WZY_WS_ENTERTRI_NAMEDESC: "进入触发器时触发",
  T_36_WZY_WS_ENTERTRI_PARAM1_DESC: "进入的触发器",
  T_36_WZY_WS_ENTGETOFFVEH_NAMEDESC: "[触发实体]离开该载具时触发",
  T_36_WZY_WS_ENTGETOFFVEH_PARAM1_NAMEDESC: "离开该载具的实体",
  T_36_WZY_WS_ENTGETONVEH_NAMEDESC: "[触发实体]进入该载具时触发",
  T_36_WZY_WS_ENTGETONVEH_PARAM1_NAMEDESC: "进入该载具的实体",
  T_36_WZY_WS_ENTITY_TYPE1: "常用",
  T_36_WZY_WS_ENTITY_TYPE2: "属性操作",
  T_36_WZY_WS_ENTITY_TYPE3: "物件和道具",
  T_36_WZY_WS_ENTITY_TYPE4: "AI",
  T_36_WZY_WS_ENTITY2_PARAM4_DESC: "修改后的元素值",
  T_36_WZY_WS_ENTITY7_PARAM1_DESC: "目标玩家",
  T_36_WZY_WS_ENTITYLIST: "实体列表",
  T_36_WZY_WS_ENTKNOFLY_NAMEDESC: "[触发实体]被该轮胎击飞时触发",
  T_36_WZY_WS_ENTKNOFLY_PARAM1_NAMEDESC: "被轮胎击飞的实体",
  T_36_WZY_WS_ENTTP_NAMEDESC: "[触发实体]通过该传送门传送后触发事件",
  T_36_WZY_WS_ENTTP_PARAM1_NAMEDESC: "通过该传送门传送的实体",
  T_36_WZY_WS_EQUARMOR_PARAM2_DESC: "装备的防具类型，包括防弹衣、头盔、背包",
  T_36_WZY_WS_EQUWEAP_NAMEDESC: "当玩家成功装备武器时触发，[触发玩家]是成功装备武器的玩家，[武器实体]是玩家装备的武器",
  T_36_WZY_WS_EQUWEAP_PARAM2_DESC: "装备的武器实体",
  T_36_WZY_WS_EQUWEAP_PARAM2_NAME: "武器类型",
  T_36_WZY_WS_EULERANGLE: "旋转角",
  T_36_WZY_WS_FACECAMERA: "总是面向摄像机",
  T_36_WZY_WS_FLOATLIST: "小数列表",
  T_36_WZY_WS_FLOOR_NAME_DESC: "对指定值按照向下取整方式取整",
  T_36_WZY_WS_FLOOR_PARAM1_NAMEDESC: "进行向下取整的值",
  T_36_WZY_WS_FLOORRES: "向下取整计算结果",
  T_36_WZY_WS_FORMUENT: "可公式化属性实体",
  T_36_WZY_WS_FORMUFACT: "属性公式因子类型",
  T_36_WZY_WS_GAME_TYPE2: "玩法相关",
  T_36_WZY_WS_GAME_TYPE3: "特效相关",
  T_36_WZY_WS_GENENT_NAMEDESC: "当生成器生成单位时触发，[单位实体列表]是生成器生成的单位列表，[波数]是生成器该次生成的波数",
  T_36_WZY_WS_GENENT_PARAM1_NAME: "单位实体",
  T_36_WZY_WS_GENENT_PARAM1_NAMEDESC: "生成器生成的单位实体组成的列表",
  T_36_WZY_WS_GENENT_PARAM2_NAMEDESC: "生成器该次生成的波数",
  T_36_WZY_WS_GETALLSHOP_NAMEDESC: "获取游戏中所有的商店，返回值是一个商店实体组成的列表",
  T_36_WZY_WS_GETCOLOR_NAMEDESC: "通过RGB获取颜色值",
  T_36_WZY_WS_GETCURRAMT_NAMEDESC: "获取指定钱包中一种货币的数量",
  T_36_WZY_WS_GETCURRAMT_PARAM1_NAMEDESC: "获取货币数量的钱包",
  T_36_WZY_WS_GETCURRAMT_PARAM2_NAMEDESC: "获取货币数量的货币种类",
  T_36_WZY_WS_GETENTTYPE_NAMEDESC: "获取目标实体的实体类型",
  T_36_WZY_WS_GETENTTYPE_PARAM1_DESC: "获取类型的实体",
  T_36_WZY_WS_GETENTTYPERES: "目标实体的实体类型",
  T_36_WZY_WS_GETFOR_NAME: "获取方向坐标",
  T_36_WZY_WS_GETFOR_NAMEDESC: "获取指定方向点的方向向量",
  T_36_WZY_WS_GETFORRES: "方向点的方向向量",
  T_36_WZY_WS_GETMONEYENT_NAMEDESC: "获取钱包中某种货币类型的货币实体",
  T_36_WZY_WS_GETMONEYENT_PARAM1_DESC: "货币实体所在的钱包",
  T_36_WZY_WS_GETPOS_NAME: "获取位置坐标",
  T_36_WZY_WS_GETPOS_NAMEDESC: "获取指定方向点的位置坐标",
  T_36_WZY_WS_GETPOS_PARAM1_DESC: "指定的方向点",
  T_36_WZY_WS_GETPROP_PARAM2_NAME: "装备类型",
  T_36_WZY_WS_GETWALLET_NAME: "获取钱包",
  T_36_WZY_WS_GETWALLET_NAMEDESC: "获取所选拥有者实体的钱包",
  T_36_WZY_WS_GETWALLET_PARAM2_NAMEDESC: "是否存在绑定的钱包",
  T_36_WZY_WS_GETWALLETRES: "拥有者的钱包实体",
  T_36_WZY_WS_HUDCONTROL_DESC: "HUD控件实体",
  T_36_WZY_WS_HUDTYPE: "界面类型",
  T_36_WZY_WS_INCIDENT_TYPE1: "全局事件",
  T_36_WZY_WS_INCIDENT_TYPE2: "实体事件",
  T_36_WZY_WS_INDEX_DESC: "列表索引值，从0开始计算",
  T_36_WZY_WS_INTLIST: "整数列表",
  T_36_WZY_WS_JENTSUBCL_NAMEDESC: "判断实体类型是否是某一实体的子类，返回值是一个布尔值",
  T_36_WZY_WS_JENTSUBCL_PARAM2_NAMESESC: "属于选择的实体父类",
  T_36_WZY_WS_JENTSUBCLRES: "判断实体父类的结果",
  T_36_WZY_WS_JENTTYPE_NAMEDESC: "判断选择的实体是否是某一类型实体，返回值是一个布尔值",
  T_36_WZY_WS_JENTTYPE_PARAM1_NAMEDESC: "进行判断的实体",
  T_36_WZY_WS_JENTTYPE_PARAM2_NAMEDESC: "和选择的实体类型一致",
  T_36_WZY_WS_JENTTYPERES: "判断实体类型的结果",
  T_36_WZY_WS_JUSTPATROL: "只巡逻",
  T_36_WZY_WS_LEAVETRI_NAMEDESC: "离开触发器时触发",
  T_36_WZY_WS_LEAVETRI_PARAM1_DESC: "离开的触发器",
  T_36_WZY_WS_LEVELOBLIST: "物件列表",
  T_36_WZY_WS_LEVOBJSLIST: "当前游戏中所有地图物件的列表",
  T_36_WZY_WS_LEVOBTYPE: "物件类型",
  T_36_WZY_WS_LISTT: "任意列表",
  T_36_WZY_WS_LOGCONTEXT_DESC: "需要打印的内容",
  T_36_WZY_WS_LOGIC2_PARAM1_NAMEDESC: "连接的字符串左值",
  T_36_WZY_WS_LOGIC2_PARAM3_NAMEDESC: "连接的字符串右值",
  T_36_WZY_WS_LOGIC5_PARAM1_NAMEDESC: "要添加的元素值",
  T_36_WZY_WS_LOGOPER: "逻辑运算与、或，使用与算法的两个布尔值都为TRUE时结果为TRUE；使用或算法时的两个布尔值不都为FALSE时结果为TRUE",
  T_36_WZY_WS_LOOTPOINT: "掉落点",
  T_36_WZY_WS_MAINWEAP: "当前主武器",
  T_36_WZY_WS_MAX_DESC: "随机范围右区间（开区间）",
  T_36_WZY_WS_MIN_DESC: "随机范围左区间（闭区间）",
  T_36_WZY_WS_MODGUNPRO_PARAM1_NAME: "枪械实体",
  T_36_WZY_WS_MONENT: "货币实体",
  T_36_WZY_WS_MONTYPE: "货币类型",
  T_36_WZY_WS_MOVETO_NAMEDESC: "AI实体向目标点移动，可以通过[是否返回]选择是否到终点返回原处，也可以通过[是否攻击]选择是否在路径上索敌敌对目标",
  T_36_WZY_WS_MOVETO_PARAM1_NAMEDESC: "移动的AI实体",
  T_36_WZY_WS_MOVETO_PARAM2_NAMEDESC: "移动路径的终点",
  T_36_WZY_WS_MOVETO_PARAM3_NAMEDESC: "AI实体到达目标点后是否返回，true返回、false不返回",
  T_36_WZY_WS_MOVETO_PARAM4_NAME: "是否攻击",
  T_36_WZY_WS_MOVETO_PARAM4_NAMEDESC: "AI实体是否索敌路径上攻击范围内的敌对目标，true索敌、false不索敌",
  T_36_WZY_WS_MULVALUE: "向量数乘的值",
  T_36_WZY_WS_MULVEC: "进行数乘计算的向量",
  T_36_WZY_WS_NEGRES: "负值的结果",
  T_36_WZY_WS_NEUTRAL: "中立",
  T_36_WZY_WS_NEXTVAWE_NAMEDESC: "强制指定的生成器生成下一波，生成器包括僵尸生成器和掉落点",
  T_36_WZY_WS_NEXTVAWE_PARAM1_NAME: "生成器实体",
  T_36_WZY_WS_NEXTVAWE_PARAM1_NAMEDESC: "指定的生成器实体，包括僵尸生成器和掉落点",
  T_36_WZY_WS_OBJENT: "物件实体",
  T_36_WZY_WS_OBTITEM_NAMEDESC: "获得道具时触发，[道具类型]为获取的道具类型",
  T_36_WZY_WS_OBTWEAP_NAMEDESC: "获得武器时触发，[枪械实体]为获取的武器",
  T_36_WZY_WS_ONEWAY: "单向一次",
  T_36_WZY_WS_OPENSTATE: "开启状态",
  T_36_WZY_WS_OPERMETHOD_NAME: "运算方式",
  T_36_WZY_WS_OPERMETHOD_NAMEDESC: "四则运算类型，目前整数支持加、减、乘、除、余；小数支持加、减、乘、除",
  T_36_WZY_WS_OWNERENT_DESC: "需要获取钱包的实体",
  T_36_WZY_WS_PERCENTAGE: "百分比调整",
  T_36_WZY_WS_PLACOLLIDE_NAME: "玩家与机关碰撞时",
  T_36_WZY_WS_PLACOLLIDE_NAMEDESC: "玩家与机关碰撞时触发",
  T_36_WZY_WS_PLACOLLIDE_PARAM1_NAMEDESC: "与机关碰撞的玩家实体",
  T_36_WZY_WS_PLACOLLIDE_PARAM2_NAMEDESC: "玩家碰撞的物件实体",
  T_36_WZY_WS_PLADRIVEH_NAME: "玩家驾驶载具时",
  T_36_WZY_WS_PLADRIVEH_NAMEDESC: "玩家驾驶载具时触发",
  T_36_WZY_WS_PLADRIVEH_PARAM1_NAMEDESC: "驾驶载具的玩家",
  T_36_WZY_WS_PLADRIVEH_PARAM2_NAMEDESC: "玩家驾驶的载具实体",
  T_36_WZY_WS_PLAGETOFFVEH_NAME: "玩家离开载具时",
  T_36_WZY_WS_PLAGETOFFVEH_NAMEDESC: "玩家离开载具时触发",
  T_36_WZY_WS_PLAGETOFFVEH_PARAM1_NAMEDESC: "离开载具的玩家",
  T_36_WZY_WS_PLAGETOFFVEH_PARAM2_NAMEDESC: "玩家离开的载具实体",
  T_36_WZY_WS_PLAGETONVEH_NAME: "玩家进入载具时",
  T_36_WZY_WS_PLAGETONVEH_NAMEDESC: "玩家进入载具时触发",
  T_36_WZY_WS_PLAGETONVEH_PARAM2_NAMEDESC: "玩家进入的载具实体",
  T_36_WZY_WS_PLAKNOFLY_NAME: "玩家被轮胎击飞时",
  T_36_WZY_WS_PLAKNOFLY_NAMEDESC: "玩家被轮胎击飞时触发",
  T_36_WZY_WS_PLAKNOFLY_PARAM1_NAMEDESC: "被轮胎击飞的玩家",
  T_36_WZY_WS_PLAKNOFLY_PARAM2_NAMEDESC: "击飞玩家的物件实体",
  T_36_WZY_WS_PLATP_NAME: "玩家传送后",
  T_36_WZY_WS_PLATP_PARAM1_NAMEDESC: "使用传送门传送的玩家",
  T_36_WZY_WS_PLATP_PARAM2_NAMEDESC: "使用的传送门实体",
  T_36_WZY_WS_PLAYERLIST_DESC: "当前游戏中所有玩家的列表",
  T_36_WZY_WS_POINTPICKER: "路径点",
  T_36_WZY_WS_PORTALENT: "传送门实体",
  T_36_WZY_WS_PREFAB: "模板",
  T_36_WZY_WS_PRODLIST: "商品列表",
  T_36_WZY_WS_PRODSORT_PARAM3_NAME: "排序方式",
  T_36_WZY_WS_PROPMOD: "属性修改方式",
  T_36_WZY_WS_RANKABLEE: "可排名实体",
  T_36_WZY_WS_REDCURR_NAMEDESC: "消耗指定钱包中的一定数量的指定货币",
  T_36_WZY_WS_REDCURR_PARAM1_NAMEDESC: "需要消耗货币的钱包",
  T_36_WZY_WS_REDCURR_PARAM2_NAMEDESC: "消耗的货币种类",
  T_36_WZY_WS_REDCURR_PARAM3_NAMEDESC: "消耗货币的数量",
  T_36_WZY_WS_RNDFRES: "生成随机小数的结果",
  T_36_WZY_WS_RNDIRES: "生成随机整数的结果",
  T_36_WZY_WS_ROUND_NAME_DESC: "对指定值按照四舍五入方式取整",
  T_36_WZY_WS_ROUND_PARAM1_NAMEDESC: "进行四舍五入的值",
  T_36_WZY_WS_ROUNDRES: "四舍五入计算结果",
  T_36_WZY_WS_RUNAI_NAMEDESC: "选择的AI实体停止/执行默认的行为树",
  T_36_WZY_WS_RUNAI_PARAM1_NAMEDESC: "停止/执行默认行为树的单位实体",
  T_36_WZY_WS_SCOREABLEE: "可积分实体",
  T_36_WZY_WS_SCORECHANGE_NAMEDESC: "在积分改变时触发，[积分类型]是变化积分的类型，[积分]是变化后的积分值",
  T_36_WZY_WS_SETDIRPOINT_NAME: "构造方向点",
  T_36_WZY_WS_SETDIRPOINT_NAMESESC: "获取一个新构建的方向点，通过[位置]设置方向点的位置坐标，通过[朝向]设置方向点的方向向量",
  T_36_WZY_WS_SETDIRPOINT_PARAM1_NAMEDESC: "方向点的位置坐标",
  T_36_WZY_WS_SETDIRPOINT_PARAM2_NAME: "朝向",
  T_36_WZY_WS_SETDIRPOINT_PARAM2_NAMEDESC: "方向点的方向向量",
  T_36_WZY_WS_SETPATH_NAMEDESC: "AI实体按照指定路径点列表中顺序移动，可以选择移动方式有 循环，单次，来回，也可以选择是否在路径上索敌敌对目标",
  T_36_WZY_WS_SETPATH_PARAM2_NAMEDESC: "路径点组成的列表",
  T_36_WZY_WS_SETPATH_PARAM3_NAME: "移动方式",
  T_36_WZY_WS_SETPATH_PARAM3_NAMEDESC: "AI实体的移动方式，单次时AI到终点停止移动；循环时AI到路径点终点会寻路回到第一个点，来回时AI到达终点后按路径点倒序返回起点",
  T_36_WZY_WS_SHOPECON: "商店和经济",
  T_36_WZY_WS_SHOWFLO_NAMEDESC: "显示飘字提示，可以通过[文本]编辑飘字内容，通过[颜色]改变飘字文本颜色，通过[时长]控制飘字显示时间，单位为毫秒",
  T_36_WZY_WS_SHOWFLO_PARAM1_DESC: "飘字的文本",
  T_36_WZY_WS_SHOWFLO_PARAM2_DESC: "飘字的颜色",
  T_36_WZY_WS_SHOWFLO_PARAM3_DESC: "飘字的显示时长，单位为毫秒",
  T_36_WZY_WS_SIN_NAMEDESC: "求角度的正弦值",
  T_36_WZY_WS_SINRES: "角度的正弦值",
  T_36_WZY_WS_SKIPKNODOWN: "倒地是否直接死亡",
  T_36_WZY_WS_SQRTRES: "平方根的结果",
  T_36_WZY_WS_STRCONRES: "字符串连接结果",
  T_36_WZY_WS_STRINGLIST: "文本列表",
  T_36_WZY_WS_STRLEN: "字符串长度",
  T_36_WZY_WS_STRVAL: "字符串的值",
  T_36_WZY_WS_TAN_NAMEDESC: "求角度的正切值",
  T_36_WZY_WS_TANRES: "角度的正切值",
  T_36_WZY_WS_TEAMLIST: "队伍列表",
  T_36_WZY_WS_TEAMLIST_DESC: "当前游戏中所有队伍的列表",
  T_36_WZY_WS_TIMETWEENTIPS: "倒计时飘字提示实体",
  T_36_WZY_WS_TOSTRING_NAMEDESC: "将目标值转换成字符串",
  T_36_WZY_WS_TOSTRING_PARAM1_DESC: "要转字符串的目标值",
  T_36_WZY_WS_TOSTRINGRES: "转字符串的结果",
  T_36_WZY_WS_TOWERCAMP_DESC: "阵营编号和队伍编号一致，中立防御塔、基地对攻击范围内所有玩家、AI实例",
  T_36_WZY_WS_TRACURR_NAMEDESC: "将一个钱包中的一定数量某的指定货币转入另一个钱包",
  T_36_WZY_WS_TRACURR_PARAM1_NAMEDESC: "转出货币的钱包",
  T_36_WZY_WS_TRACURR_PARAM2_NAMEDESC: "交易货币的种类",
  T_36_WZY_WS_TRACURR_PARAM3_NAMEDESC: "交易货币的数量",
  T_36_WZY_WS_TRACURR_PARAM4_NAMEDESC: "转入货币的钱包",
  T_36_WZY_WS_TWEENTIPS: "飘字提示实体",
  T_36_WZY_WS_TYPEENUM: "类型枚举",
  T_36_WZY_WS_USEPROP_NAMEDESC: "当玩家使用物品时触发，[触发玩家]是使用物品的玩家，[道具类型]是玩家使用道具的类型",
  T_36_WZY_WS_USEPROP_PARAM2_DESC: "玩家使用的道具类型",
  T_36_WZY_WS_VECADDLEFT: "向量加法左值",
  T_36_WZY_WS_VECADDRES: "向量加法计算结果",
  T_36_WZY_WS_VECADDRIGHT: "向量加法右值",
  T_36_WZY_WS_VECANGLEFT: "向量夹角计算左值",
  T_36_WZY_WS_VECANGRES: "两向量的夹角",
  T_36_WZY_WS_VECANGRIGHT: "向量夹角计算右值",
  T_36_WZY_WS_VECCROLEFT: "向量叉乘左值",
  T_36_WZY_WS_VECCRORES: "向量叉乘结果",
  T_36_WZY_WS_VECCRORIGHT: "向量叉乘右值",
  T_36_WZY_WS_VECDISLEFT: "向量距离计算左值",
  T_36_WZY_WS_VECDISRES: "两向量的距离",
  T_36_WZY_WS_VECDISRIGHT: "向量距离计算右值",
  T_36_WZY_WS_VECDOCLEFT: "向量点乘左值",
  T_36_WZY_WS_VECDOCRES: "向量点乘计算结果",
  T_36_WZY_WS_VECDOCRIGHT: "向量点乘右值",
  T_36_WZY_WS_VECMULRES: "数乘向量计算结果",
  T_36_WZY_WS_VECNORRES: "标准化后的向量",
  T_36_WZY_WS_VECSIZERES: "向量的模长",
  T_36_WZY_WS_VECSUBLEFT: "向量减法左值",
  T_36_WZY_WS_VECSUBRES: "向量减法计算结果",
  T_36_WZY_WS_VECSUBRIGHT: "向量减法右值",
  T_36_WZY_WS_VECTORLIST: "向量列表",
  T_36_WZY_WS_VECX: "向量X分量",
  T_36_WZY_WS_VECY: "向量Y分量",
  T_36_WZY_WS_VECZ: "向量Z分量",
  T_36_WZY_WS_VEHENT: "载具实体",
  T_36_WZY_WS_WALLCONT: "钱包内容",
  T_36_WZY_WS_ZOMBIESPERWAVE: "持续",
  T_36_XYL_WS_AIBOT: "单位",
  T_36_XYL_WS_AIGENERATOR: "单位生成器",
  T_36_XYL_WS_AIGENERATOR_DESC: "可以持续生成指定单位（例如僵尸）的生成器",
  T_36_XYL_WS_AIWAVE: "每波生成单位数量",
  T_36_XYL_WS_ARROW: "方向指示牌",
  T_36_XYL_WS_ARROW_DESC: "可以指引方向的指示牌",
  T_36_XYL_WS_BREAKBOX: "破碎木箱",
  T_36_XYL_WS_BREAKBOX_DESC: "可以被攻击打碎的木箱",
  T_36_XYL_WS_FENCE: "栅栏",
  T_36_XYL_WS_FENCE_DESC: "子弹可以穿过的栅栏",
  T_36_XYL_WS_STAIRI: "楼梯平台C",
  T_36_XYL_WS_STAIRI_DESC: "直线的楼梯平台，可以与楼梯组合使用",
  T_36_XYL_WS_ZOMBIEAI: "僵尸",
  T_36_XYL_WS_ZOMBIEAI_DESC: "可以自定义类型的僵尸，可以被单位生成器获取并生成复制体",
  T_36_YF_CORRODE_GRENADE_N: "腐蚀手雷",
  T_36_YF_SETTING_TYPE3: "方案3",
  T_36_YS_B_BRFOOTBALL_BLUE01: "巴西CBF合作换皮球衣蓝色裤子",
  T_36_YS_B_BRFOOTBALL_YELLOW01: "巴西CBF合作换皮黄色球衣裤子",
  T_36_YS_F_A_GHOSTHUNTER: "泰国捉鬼队女面饰",
  T_36_YS_F_B_GHOSTHUNTER: "泰国捉鬼队女裤子",
  T_36_YS_F_H_GHOSTHUNTER: "泰国捉鬼队女头饰",
  T_36_YS_F_S_GHOSTHUNTER: "泰国捉鬼队女鞋子",
  T_36_YS_SETTING_GRENADE: "投掷物",
  T_36_YS_SETTING_MOVE: "移动",
  T_36_YS_T_BRFOOTBALL_BLUE01: "巴西CBF合作换皮球衣蓝色上衣",
  T_36_YS_T_BRFOOTBALL_YELLOW01: "巴西CBF合作换皮黄色球衣上衣",
  T_36_YZY_CHARACTER_GANGGIRL_N: "Luna",
  T_36_YZY_CHARACTER_YAKUZA_N: "Tatsuya",
  T_36_YZY_PET_WOLF_N: "魔灵狼",
  T_36_YZY_PETSKIN_AXOLOTL_GRIZA_N: "Griza蝾螈",
  T_36_YZY_PETSKIN_HAWK_BDK_N: "BDK猛禽",
  T_36_YZY_PETSKIN_WOLF_FIRE_N: "烈焰魔灵狼",
  T_36_YZY_PETSKIN_WOLF_SUGARSKULL22_N: "拉美亡灵节魔灵狼皮肤",
  T_36_YZY_PETSKIN_WOLF_WINTER_N: "寒霜魔灵狼",
  T_37_B_WS_HIDE: "躲猫猫",
  T_37_HZ_WS_CATMODEDESC1: "躲猫猫模式",
  T_37_JH_WS_CREATEGOLD_DESC: "一个能让玩家购买道具的自动贩卖机，在以下模式不生效（CS/TDM/PARTY/启示录）",
  T_37_JH_WS_NAME1: "飞刀（启示录）",
  T_37_JH_WS_NAME10: "M1887-X（启示录）",
  T_37_JH_WS_NAME11: "SPAS12（启示录）",
  T_37_JH_WS_NAME12: "M1014（启示录）",
  T_37_JH_WS_NAME13: "MP40（启示录）",
  T_37_JH_WS_NAME14: "MP5-III（启示录）",
  T_37_JH_WS_NAME15: "P90（启示录）",
  T_37_JH_WS_NAME16: "M60-III（启示录）",
  T_37_JH_WS_NAME17: "汤普森冲锋枪（启示录）",
  T_37_JH_WS_NAME18: "UMP（启示录）",
  T_37_JH_WS_NAME19: "SVD（启示录）",
  T_37_JH_WS_NAME2: "GROZA（启示录）",
  T_37_JH_WS_NAME20: "AWM（启示录）",
  T_37_JH_WS_NAME21: "M82B（启示录）",
  T_37_JH_WS_NAME22: "M249-X（启示录）",
  T_37_JH_WS_NAME23: "KAR98K-III（启示录）",
  T_37_JH_WS_NAME3: "AK47（启示录）",
  T_37_JH_WS_NAME4: "M4A1-III（启示录）",
  T_37_JH_WS_NAME5: "SCAR（启示录）",
  T_37_JH_WS_NAME6: "M14-III（启示录）",
  T_37_JH_WS_NAME7: "PARAFAL（启示录）",
  T_37_JH_WS_NAME8: "XM8（启示录）",
  T_37_JH_WS_NAME9: "MAG7（启示录）",
  T_37_JH_WS_VENDMACHINE_DESC: "可以在游戏中拾取的金币。在以下模式不生效（CS/TDM/PARTY/启示录）",
  T_37_JH_WS_X: "X轴",
  T_37_JH_WS_Y: "Y轴",
  T_37_JH_WS_Z: "Z轴",
  T_37_JL_FOOTBALL_TIE: "平局",
  T_37_JL_GOLD_M1014_I_N: "M1014-I",
  T_37_JL_GOLD_M1014_II_N: "M1014-II",
  T_37_JL_GOLD_M1014_III_N: "M1014-III",
  T_37_JL_M1216_N: "trogon",
  T_37_KK_WS_SNOWMAN: "雪人瓦哥",
  T_37_LC_BP_ENTRANCE_GIFT: "礼物",
  T_37_M_WS_MISSING: "已丢失",
  T_37_M_WS_NAMEERROR: "内容含有非法字符，请修改",
  T_37_PD_HuntingGround_BOSSTITLE: "剪刀屠夫",
  T_37_QL_JUMPPAD_DES: "使用跳板手雷在地面上建造一个气旋跳板，可将角色快速推向空中，且能够在空中开火",
  T_37_QL_JUMPPAD_NAME: "跳板手雷",
  T_37_R_TAILOR_LIMIT: "限时活动获取",
  T_37_RW_LOADOUT_BORNFIRETAG: "Get 2 Bonfires at the start of the match. Bonfire [FFBA00]regenerates 5 HP and 20 EP per second[-] (up to 10 seconds) for you and your teammates within the area. Bonfire effects do not stack.",
  T_37_RW_PROPCATAPULT_DESC: "折叠后的大炮，展开后可以用来把人发射出去，要小心不要把自己发射出安全区！",
  T_37_RW_PROPCATAPULT_NAME: "随身人间大炮",
  T_37_SP_WS_COLOR_02: "颜色",
  T_37_SP_WS_COLOR_03: "外观",
  T_37_SP_WS_LOG_ENTITY_IS_EMPTY: "获得或设置实体属性时实体为空",
  T_37_SP_WS_LOG_PHASE_END: "阶段{0}结束",
  T_37_SP_WS_LOG_PHASE_START: "阶段{0}开始",
  T_37_SP_WS_LOG_ROUND_END: "回合{0}结束",
  T_37_SP_WS_LOG_ROUND_START: "回合{0}开始",
  T_37_SP_WS_LOG_VAR_ASSIGNMENT_OPERATOR_MISMATCH: "变量赋值时类型不匹配。需求类型{0}，当前类型{1}",
  T_37_SP_WS_LOG_VAR_UNDEFINED_OR_OUT_OF_SCOPE: "局部变量{0}未定义或超出作用域",
  T_37_SP_WS_MAPACCESS_08: "编辑",
  T_37_SP_WS_RACEMODE_01: "倒计时模式",
  T_37_SP_WS_RACEMODE_02: "倒计时时长",
  T_37_SP_WS_RACEMODE_04: "模式开启时，当有一个队伍全员到达终点时，进入倒计时，倒计时结束时结算胜负",
  T_37_SY_AR15_KABUKI_N: "Kingfisher - Song of Hana",
  T_37_SY_BACKPACK_STRAW_N: "Backpack - Straw Hat",
  T_37_SY_GRENADE_FFWS2022_01_N: "Grenade - Navy Starsea",
  T_37_SY_GROUPANIM_BLACKHOLE_N: "Black Hole",
  T_37_SY_M1216_MAMBAS_N: "Trogon - Mamba Gnaw",
  T_37_SY_PET_FLYINGCREATURE_N: "传奇飞宠宠物",
  T_37_SY_PETSKIN_DUCK_WINTERFEST22_N: "拉美冰雪节宠物皮肤（鸭子）",
  T_37_SY_PETSKIN_FLYINGCREATURE_BLUE_N: "传奇飞宠蓝色皮肤",
  T_37_SY_PETSKIN_FLYINGCREATURE_ORANGE_N: "传奇飞宠星空材质皮肤",
  T_37_SY_PETSKIN_FLYINGCREATURE_PURPLE_N: "传奇飞宠火焰主题紫色品质皮肤",
  T_37_SY_PETSKIN_TORTOISE_SOCCER22_N: "足球主题宠物皮肤（乌龟）",
  T_37_SY_PETSKIN_YETI_NEWYEAR22_N: "俄罗斯新年主题雪怪皮肤",
  T_37_SY_VEHICLE_JEEP_WINTERFEST22_N: "Jeep - Rockin' Festival Ride",
  T_37_SY_VEHICLE_SUV_FFWS2022_N: "Pickup Truck - Starsea Beast",
  T_37_WT_WS_PVE2DESC: `僵尸生存玩法，在时间限制内消灭目标数量的僵尸或者存活到最后。
提供该玩法模式中的玩法规则设置，可以按照自己的需求设置僵尸，目标消灭的僵尸数等。`,
  T_37_WT_WS_RULEDESC: "击杀指定数量的僵尸获得胜利",
  T_37_WT_WS_RULETITLE: "通关目标",
  T_37_WT_WS_TXT1: "击杀僵尸",
  T_37_WT_WS_TXT1DESC: "开启后，击杀指定数量的僵尸获得胜利。关闭后，坚持存活到最后一秒获得胜利",
  T_37_WT_WS_TXT2: "击杀数量",
  T_37_WZY_FRIDPLA: "友好玩家",
  T_37_WZY_FRIDSIDE: "友好阵营",
  T_37_WZY_FRIDTEAM: "友好队伍",
  T_37_WZY_HOSTPLA: "敌对玩家",
  T_37_WZY_HOSTSIDE: "敌对阵营",
  T_37_WZY_WS_ACCFRAMES: "累计运行帧",
  T_37_WZY_WS_ADDITEMTOPROD_NAMEDESC: "添加物品到商品中，物品可以是单个物品或物品组成的列表，数量为单个物品的数量或对应的物品数量组成的列表",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM1_DESC: "添加物品的商品实体",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM2_DESC: "要添加的物品，可以是单个物品也可以是物品组成的列表",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM3_DESC: "添加的单个物品的数量或对应的物品数量组成的列表",
  T_37_WZY_WS_ADDLABEL_NAMEDESC: "为选择的实体添加标签",
  T_37_WZY_WS_ADDLABEL_PARAM1_DESC: "添加标签的实体",
  T_37_WZY_WS_ADDLABEL_PARAM2_DESC: "添加的标签文本",
  T_37_WZY_WS_AIMABLEENT: "可瞄准实体",
  T_37_WZY_WS_AIMASSISTTYPE: "辅助瞄准类型",
  T_37_WZY_WS_ALLOWDROP_NAME: "允许/禁止丢弃物品",
  T_37_WZY_WS_ALLOWDROP_NAMEDESC: "控制玩家是否可以丢弃物品",
  T_37_WZY_WS_ALLOWDROP_PARAM1_DESC: "控制能否丢弃物品的玩家实体",
  T_37_WZY_WS_ALLOWDROP_PARAM2_DESC: "布尔值，控制玩家是否可以丢弃物品",
  T_37_WZY_WS_ALLOWPICKUP_NAME: "允许/禁止拾取物品",
  T_37_WZY_WS_ALLOWPICKUP_NAMEDESC: "控制玩家是否可以拾取物品",
  T_37_WZY_WS_ALLOWPICKUP_PARAM1_DESC: "控制能否拾取物品的玩家实体",
  T_37_WZY_WS_ALLOWPICKUP_PARAM2_DESC: "布尔值，控制玩家是否可以拾取物品",
  T_37_WZY_WS_AMBIENTCOLOR: "环境光颜色",
  T_37_WZY_WS_AMRORTOOL: "装备修复",
  T_37_WZY_WS_ATTACK: "攻击",
  T_37_WZY_WS_BACKTONOR_NAMEDESC: "取消玩家的伪装状态，变回原形",
  T_37_WZY_WS_BACKTONOR_PARAM1_DESC: "取消伪装的玩家实体",
  T_37_WZY_WS_BALLADDV_NAMEDES: "为足球增加一个瞬时速度",
  T_37_WZY_WS_BALLADDV_PARAM1_DESC: "施加瞬时速度的足球",
  T_37_WZY_WS_BALLADDV_PARAM2_DESC: "施加的瞬时速度向量",
  T_37_WZY_WS_BALLKICKED_NAMEDESC: "足球被足球枪击打时触发，[玩家实体]为足球枪所属的玩家，[施加速度]为被足球枪击打后足球的瞬时速度",
  T_37_WZY_WS_BALLKICKED_PARAM1_DESC: "足球枪所属的玩家",
  T_37_WZY_WS_BALLKICKED_PARAM2_DESC: "足球在被击打后的瞬时速度向量",
  T_37_WZY_WS_BALLKNOCKED_NAMEDESC: "足球与实体碰撞且被施加速度时触发，[碰撞实体]为与足球碰撞的实体，[施加速度]为碰撞给足球增加的瞬时速度",
  T_37_WZY_WS_BALLKNOCKED_PARAM1_DESC: "与足球碰撞的实体",
  T_37_WZY_WS_BALLKNOCKED_PARAM2_DESC: "碰撞给足球施加的的瞬时速度向量",
  T_37_WZY_WS_BEAIMED_NAMEDESC: "实体被玩家瞄准时触发",
  T_37_WZY_WS_BEAIMED_PARAM1_DESC: "瞄准该实体的玩家",
  T_37_WZY_WS_BEHAVIORSTAT: "玩家行为状态",
  T_37_WZY_WS_BEHIT_PARAM1_DESC: "命中该实体的武器实体",
  T_37_WZY_WS_BLOODBARENT: "血条实体",
  T_37_WZY_WS_BOMBEND: "炸弹引爆前",
  T_37_WZY_WS_BOMBSTART: "炸弹提示",
  T_37_WZY_WS_CHANENT: "频道实体",
  T_37_WZY_WS_CHEER: "欢呼",
  T_37_WZY_WS_CHELABEL_NAMEDESC: "判断选择的实体是否包含指定的标签",
  T_37_WZY_WS_CHELABEL_PARAM1_DESC: "检查是否有标签的实体",
  T_37_WZY_WS_CHELABEL_PARAM2_DESC: "检查的标签文本",
  T_37_WZY_WS_CHELABELRES: "检查实体是否有标签的结果，布尔值",
  T_37_WZY_WS_CJERSEY_NAME: "更换球衣",
  T_37_WZY_WS_CJERSEY_PARAM1_DESC: "更换球衣的玩家",
  T_37_WZY_WS_CJERSEY_PARAM2: "球衣样式",
  T_37_WZY_WS_CJERSEY_PARAM2_DESC: "更换球衣的样式",
  T_37_WZY_WS_CJERSEY_PARAM3_DESC: "对应球衣样式的部位1的颜色",
  T_37_WZY_WS_CJERSEY_PARAM4_DESC: "对应球衣样式的部位2的颜色",
  T_37_WZY_WS_CJERSEY_PARAM5_DESC: "对应球衣样式的部位3的颜色",
  T_37_WZY_WS_CJERSEYTYPE1: "样式1",
  T_37_WZY_WS_CJERSEYTYPE2: "样式2",
  T_37_WZY_WS_CJERSEYTYPE3: "样式3",
  T_37_WZY_WS_CLEAR_ARR_DESC: "清空列表中所有元素",
  T_37_WZY_WS_CREABLEOB_DESC: "可动态创建物件类型",
  T_37_WZY_WS_CREPROD_NAMEDESC: "创建一个自定义商品，并返回商品实体，商品内容可以通过设置属性修改",
  T_37_WZY_WS_CRESHELVES_NAMEDESC: "创建一个自定义货架，并返回货架实体，货架内容可以通过设置属性修改",
  T_37_WZY_WS_CRESHELVES_PARAM1_DESC: "创建的货架实体",
  T_37_WZY_WS_CRESIDE_NAMEDESC: "创建一个阵营实体",
  T_37_WZY_WS_CRESIDE_PARAM1_DESC: "创建的阵营实体",
  T_37_WZY_WS_CRESTORE_NAMEDESC: "创建一个自定义商店，并返回商店实体，商店内容可以通过设置属性修改",
  T_37_WZY_WS_CRESTORE_PARAM2_DESC: "创建的商店实体",
  T_37_WZY_WS_CSKYBOX_NAMEDESC: "更换游戏的天空盒环境样式，可以选择白天、黄昏、黑夜",
  T_37_WZY_WS_CSKYBOX_PARAM1_DESC: "更换的天空盒样式，包括白天、黄昏、黑夜",
  T_37_WZY_WS_DARKNESS: "全局暗度",
  T_37_WZY_WS_DELENT_NAMEDESC: "删除指定的实体，目前支持图标实体、文本实体、HUD实体、特效实体、枪械实体、可创建物件实体等",
  T_37_WZY_WS_DELENT_PARAM1_DESC: "需要删除的实体",
  T_37_WZY_WS_DROP: "失误",
  T_37_WZY_WS_DROPITEMS_NAMEDESC: "玩家丢弃道具时触发，[道具类型]是丢弃的道具类型ID",
  T_37_WZY_WS_DROPITEMS_PARAM1_DESC: "丢弃道具的类型ID",
  T_37_WZY_WS_DROPWEAP_NAMEDESC: "玩家丢弃武器时触发，[武器实体]是丢弃的武器",
  T_37_WZY_WS_DROPWEAP_PARAM1_DESC: "丢弃的武器",
  T_37_WZY_WS_DUMMYLEOBJ: "普通关卡物件",
  T_37_WZY_WS_DUST: "黄昏",
  T_37_WZY_WS_EMPTYCH: "内置空频道",
  T_37_WZY_WS_EMPTYCH1: "空频道1",
  T_37_WZY_WS_EMPTYCH2: "空频道2",
  T_37_WZY_WS_EMPTYCH3: "空频道3",
  T_37_WZY_WS_EMPTYCH4: "空频道4",
  T_37_WZY_WS_EMPTYCH5: "空频道5",
  T_37_WZY_WS_EMPTYCH6: "空频道6",
  T_37_WZY_WS_ENTFILTER_NAMEDESC: "获取游戏中全部实体符合全部三个条件的实体组成的列表，包含、不包含、包含其一填入的是单个组件类型或组件类型组成的列表，返回值是符合条件的实体组成的列表",
  T_37_WZY_WS_ENTFILTER_PARAM1_DESC: "筛选出的实体需要包含该数组中的全部组件",
  T_37_WZY_WS_ENTFILTER_PARAM2_DESC: "筛选出的实体需要不包含该数组中的任意一组件",
  T_37_WZY_WS_ENTFILTER_PARAM3_DESC: "筛选出的实体需要包含该数组中的至少一个组件",
  T_37_WZY_WS_ENTITY2_PARAM3_DESC: "要修改的该实体属性类型",
  T_37_WZY_WS_ENTITY2_PARAM4_DESC: "修改后的属性值",
  T_37_WZY_WS_EXITCHAN_NAMEDESC: "指定的玩家退出当前所在频道，处于不在任何频道中的状态",
  T_37_WZY_WS_EXITCHAN_PARAM1_DESC: "退出当前频道的玩家",
  T_37_WZY_WS_FAKEENT: "伪装实体",
  T_37_WZY_WS_FIND_STR_DESC: "在字符串里查找指定文本的位置",
  T_37_WZY_WS_FINDSTR_PARAM1DESC: "要查找的字符",
  T_37_WZY_WS_FINDSTR_PARAM2DESC: "从起始位置查找字符串，从0开始",
  T_37_WZY_WS_FINDSTRRES: "第一个出现位置，从0开始",
  T_37_WZY_WS_FOGCOLOR: "雾气颜色",
  T_37_WZY_WS_FRICTIONCON: "普通摩擦系数",
  T_37_WZY_WS_FRICTIONIMP: "冲击摩擦系数",
  T_37_WZY_WS_FROMDEATH: "死亡复活",
  T_37_WZY_WS_FROMKNODOWN: "倒地复活",
  T_37_WZY_WS_GETCHAN_NAMEDESC: "获取指定玩家当前所在的频道",
  T_37_WZY_WS_GETCHAN_PARAM1_DESC: "获取频道的玩家实体",
  T_37_WZY_WS_GETCHANRES: "玩家当前所在的频道",
  T_37_WZY_WS_GETEMPTYCH_NAMEDES: "根据频道ID1-8，获取游戏开始时默认创建的空频道",
  T_37_WZY_WS_GETEMPTYCH_PARAM1_DESC: "内置空频道的ID",
  T_37_WZY_WS_GETEMPTYCH_RES: "获取的频道实体",
  T_37_WZY_WS_GETFAKEENT_NAMEDESC: "获取玩家的伪装实体",
  T_37_WZY_WS_GETFAKEENT_PARAM1_DESC: "获取伪装实体的物件",
  T_37_WZY_WS_GETGAMEENT_NAME: "获取全局实体",
  T_37_WZY_WS_GETGAMEENT_NAMEDESC: "获取该局游戏实体",
  T_37_WZY_WS_GETHOSTPLA_NAME: "获取可攻击玩家",
  T_37_WZY_WS_GETHOSTSIDE_PARAM1: "阵营实体",
  T_37_WZY_WS_GOAL_NAMEDESC: "足球进入球门时触发，[球门]是该足球进入的球门，[进球者]是最后一个接触该足球的玩家，[助攻者]是倒数第二个接触该足球的玩家",
  T_37_WZY_WS_GOAL_PARAM1_DESC: "该足球进入的球门",
  T_37_WZY_WS_GOAL_PARAM2_DESC: "最后一个接触该足球的玩家",
  T_37_WZY_WS_GOAL_PARAM3_DESC: "倒数第二个接触该足球的玩家",
  T_37_WZY_WS_HEARTBEAT: "心跳",
  T_37_WZY_WS_HEAVYWEAPON: "重武器",
  T_37_WZY_WS_HIHGSHOOTANGLE: "最小高射角度",
  T_37_WZY_WS_HOSTPLA: "可攻击玩家组成的列表",
  T_37_WZY_WS_HOSTSIDE: "可攻击阵营组成的列表",
  T_37_WZY_WS_HOSTTEAM: "可攻击队伍组成的列表",
  T_37_WZY_WS_ICON_CLOCK: "计时",
  T_37_WZY_WS_ICON_CLOTHES: "衣服",
  T_37_WZY_WS_ICON_QUIT: "出口",
  T_37_WZY_WS_INSERT_ARR_DESC: "在列表中指定索引的位置插入一个新元素",
  T_37_WZY_WS_INTERCEPT_STR_DESC: "从索引位置开始截取指定长度的字符串，长度缺省为截取到字符串结束",
  T_37_WZY_WS_INTERCEPTSTR_PARAM1DESC: "截取长度",
  T_37_WZY_WS_INTERCEPTSTRRES_DESC: "输出截取字符串",
  T_37_WZY_WS_INTORINTL: "整数或整数列表",
  T_37_WZY_WS_JOINSIDE_NAMEDESC: "玩家加入指定阵营",
  T_37_WZY_WS_JOINSIDE_PARAM2_DESC: "玩家加入的阵营",
  T_37_WZY_WS_JUMP: "跳跃",
  T_37_WZY_WS_LABEL: "标签",
  T_37_WZY_WS_LENSFLARE: "光晕强度",
  T_37_WZY_WS_LENTH: "长度",
  T_37_WZY_WS_LIGHTATTACK: "击中",
  T_37_WZY_WS_LIGHTCOLOR: "主光源颜色",
  T_37_WZY_WS_LIGHTINTENSITY: "主光源强度",
  T_37_WZY_WS_LOADSCENE_NAMEDESC: "加载新的场景",
  T_37_WZY_WS_LOADSCENE_PARAM1_DESC: "要加载的场景名字",
  T_37_WZY_WS_MOROBJECT: "可被变身物件",
  T_37_WZY_WS_MOVEAXISX: "X轴移动",
  T_37_WZY_WS_MOVEAXISY: "Y轴移动",
  T_37_WZY_WS_MOVEAXISZ: "Z轴移动",
  T_37_WZY_WS_MOVEDISTITLE: "移动距离",
  T_37_WZY_WS_MUTEQUICKCHAT_NAME: "开关快捷聊天",
  T_37_WZY_WS_MUTEQUICKCHAT_NAMEDESC: "开关玩家的快捷聊天，关闭时禁用快捷聊天HUD，不可以接受和发送快捷消息",
  T_37_WZY_WS_MUTEQUICKCHAT_PARAM1_DESC: "开关快捷聊天的玩家",
  T_37_WZY_WS_MUTEVOICE_NAME: "开关语音聊天",
  T_37_WZY_WS_MUTEVOICE_NAMEDESC: "开关玩家的语音聊天，关闭时禁用语音HUD，同时无法发送和接受语音消息",
  T_37_WZY_WS_MUTEVOICE_PARAM1_DESC: "开关语音聊天的玩家",
  T_37_WZY_WS_MUTEVOICE_PARAM2_DESC: "布尔值，True为关闭，False为开启",
  T_37_WZY_WS_NIGHTMODE: "夜晚模式",
  T_37_WZY_WS_ONAIM_NAMEDESC: "当玩家的准星瞄准一个可以瞄准的实体时触发，[目标实体]是被瞄准的实体，当没有瞄准对象时，返回参数为空",
  T_37_WZY_WS_ONAIM_PARAM1_NAME: "被瞄准的实体",
  T_37_WZY_WS_ONHIT_PARAM1_DESC: "被该武器命中的实体",
  T_37_WZY_WS_ONSCENELOADING_NAMEDESC: "场景加载成功时触发",
  T_37_WZY_WS_ONSCENELOADING_PARAM1_DESC: "字符串，加载的场景名字",
  T_37_WZY_WS_ONSCENESWITCH_NAMEDESC: "场景切换成功时触发",
  T_37_WZY_WS_ONSCENESWITCH_PARAM1_DESC: "字符串，切换后的场景名字",
  T_37_WZY_WS_OUTJERSEY_NAMEDESC: "将玩家的衣饰恢复成进入游戏的状态",
  T_37_WZY_WS_OUTJERSEY_PARAM1_DESC: "恢复默认衣饰的玩家",
  T_37_WZY_WS_PETSET: "宠物设定",
  T_37_WZY_WS_PETSKILL: "宠物技能",
  T_37_WZY_WS_PETSWITCH2: "宠物技能开关，控制宠物技能是否生效",
  T_37_WZY_WS_PLAMOVE_PARAM2_DESC: "布尔值，控制是否允许玩家移动",
  T_37_WZY_WS_PLAYERBEHAVIOR: "玩家行为类型",
  T_37_WZY_WS_PRESS: "弱点击",
  T_37_WZY_WS_PROGRESS: "当前进度值",
  T_37_WZY_WS_PROGRESSBAR: "进度HUD实体",
  T_37_WZY_WS_RANKDOWN: "降级",
  T_37_WZY_WS_REMLABEL_NAMEDESC: "为选择的实体移除标签",
  T_37_WZY_WS_REMLABEL_PARAM1_DESC: "移除的标签文本",
  T_37_WZY_WS_REPLACE_STR_DESC: "将字符串中的值替换成指定值",
  T_37_WZY_WS_REPLACESTR_PARAM1DESC: "需要被替换的字符",
  T_37_WZY_WS_REPLACESTR_PARAM2DESC: "用来替换的新字符",
  T_37_WZY_WS_REVERSE_ARR_DESC: "将列表内的所有元素进行翻转",
  T_37_WZY_WS_REVIVEHERE: "在该复活点复活的玩家",
  T_37_WZY_WS_REVIVEHERE_NAMEDESC: "玩家在该复活点复活时触发",
  T_37_WZY_WS_REVIVEWAYDESC: "玩家从哪种状态复活，包括倒地状态和死亡状态",
  T_37_WZY_WS_SATBEHAVIOR_NAMEDESC: "设置玩家的行为状态，行为包括移动、攻击、跳跃、冲刺，状态包括禁止、屏蔽、启用，禁止状态下HUD上按钮为禁止状态，禁止主动和被动的该行为；屏蔽状态下隐藏HUD上按钮，禁止主动该行为，允许被动的该行为；启用状态下显示HUD中按钮，允许主动和被动该行为",
  T_37_WZY_WS_SATBEHAVIOR_PARAM1_DESC: "设置行为状态的玩家",
  T_37_WZY_WS_SATBEHAVIOR_PARAM2_DESC: "玩家的行为，包括移动、攻击、跳跃、冲刺",
  T_37_WZY_WS_SATBEHAVIOR_PARAM3_DESC: "行为状态包括禁止、屏蔽、启用，屏蔽状态下隐藏HUD上按钮，禁止主动该行为，允许被动的该行为；启用状态下显示HUD中按钮，允许主动和被动该行为",
  T_37_WZY_WS_SETBALL_PARAM2_DESC: "设置足球的位置坐标",
  T_37_WZY_WS_SETBALL_PARAM3_DESC: "布尔值，是否保持足球设置前的速度",
  T_37_WZY_WS_SETPLAHOST_NAME: "设置玩家是否可攻击",
  T_37_WZY_WS_SETPLAHOST_NAMEDESC: "为[设置玩家]设置[目标玩家]是否可攻击，默认为取决于目标玩家所在队伍和阵营是否可攻击，玩家是否可攻击的优先级高于阵营和队伍",
  T_37_WZY_WS_SETPLAHOST_PARAM1_DESC: "为其设置敌意对象的玩家",
  T_37_WZY_WS_SETPLAHOST_PARAM2_DESC: "设置敌意对象的玩家",
  T_37_WZY_WS_SETPLAHOST_PARAM3: "是否可攻击",
  T_37_WZY_WS_SETPLAHOST_PARAM3_DESC: "是为可攻击；否为不可攻击；默认为取决于目标玩家所在队伍和阵营是否可攻击",
  T_37_WZY_WS_SETSIDEHOST_PARAM3_DESC: "是为可攻击；否为不可攻击",
  T_37_WZY_WS_SHADOWSTRENGTH: "阴影暗度",
  T_37_WZY_WS_SHOOTANGLE: "最小射门角度",
  T_37_WZY_WS_SKYBOX: "天空盒",
  T_37_WZY_WS_SKYBOXENT: "天空盒实体",
  T_37_WZY_WS_SKYBOXTYPE: "天空盒基础类型",
  T_37_WZY_WS_STEPPED: "踩机关",
  T_37_WZY_WS_SWCHAN_NAMEDESC: "切换玩家所在的语音聊天频道",
  T_37_WZY_WS_SWCHAN_PARAM1_DESC: "切换频道的玩家",
  T_37_WZY_WS_SWCHAN_PARAM2_DESC: "要切换到的频道",
  T_37_WZY_WS_SWITCHSCENE_NAMEDESC: "切换到指定的场景",
  T_37_WZY_WS_SWITCHSCENE_PARAM1_DESC: "切换到的场景名字",
  T_37_WZY_WS_TARGETSTR_DESC: "目标字符串",
  T_37_WZY_WS_TEAMASIDE: "队伍和阵营",
  T_37_WZY_WS_TELEPORTN_AUTO: "自动",
  T_37_WZY_WS_TELEPORTN_AVAILABLE: "是否可传送",
  T_37_WZY_WS_TELEPORTN_MANUAL: "手动",
  T_37_WZY_WS_TELEPORTN_NO: "否",
  T_37_WZY_WS_TELEPORTN_TITLE: "传送模式",
  T_37_WZY_WS_TELEPORTN_YES: "是",
  T_37_WZY_WS_TERRAINWET: "地面湿度",
  T_37_WZY_WS_TRANSFORM_NAMEDESC: "替换[玩家实体]的外形为选择的[场景物件]外形",
  T_37_WZY_WS_TRANSFORM_PARAM1_DESC: "替换外形的玩家实体",
  T_37_WZY_WS_TRANSFORM_PARAM2_DESC: "获取伪装实体的玩家",
  T_37_WZY_WS_TRANSP: "透明度",
  T_37_WZY_WS_UNLOADSCENE_NAMEDESC: "卸载指定的场景",
  T_37_WZY_WS_UNLOADSCENE_PARAM1_DESC: "要卸载的场景名字",
  T_37_WZY_WS_VFX1: "地面印记",
  T_37_WZY_WS_VFX2: "烟雾",
  T_37_WZY_WS_VFX3: "符咒爆炸",
  T_37_WZY_WS_VFX5: "冰冻",
  T_37_WZY_WS_VFX6: "灯光",
  T_37_WZY_WS_VFX7: "上升气流",
  T_37_WZY_WS_VFX8: "气体爆炸",
  T_37_WZY_WS_VISABLE: "可见性",
  T_37_WZY_WS_WEAOPEN: "是否显示",
  T_37_WZY_WS_WEAPONENT: "武器实体",
  T_37_WZY_WS_WEATARGETED: "是否可被辅助瞄准锁定",
  T_37_XYL_CUSTOMJERSEY: "球衣制造机",
  T_37_XYL_CUSTOMJERSEY_DESC: "可以通过球衣制造机制作自己喜欢的球衣",
  T_37_XYL_FOOTGUN: "足球枪",
  T_37_XYL_SOCCER: "足球",
  "T_37_XYL_SOCCER_ RADIUS": "足球半径",
  T_37_XYL_SOCCER_DESC: "可以自由调整的足球",
  T_37_XYL_SOCCER_HIGHT1: "普通射击角度",
  T_37_XYL_SOCCER_HIGHT2: "高射射击角度",
  T_37_XYL_SOCCER_RESET: "进球后复位时间（秒）",
  T_37_XYL_SOCCER_RESIST1: "足球阻力（普通状态）",
  T_37_XYL_SOCCER_RESIST2: "足球阻力（枪击状态）",
  T_37_XYL_SOCCERGOAL: "球门",
  T_37_XYL_SOCCERGOAL_DESC: "足球球门，将足球踢进门可以获得得分（仅积分模式生效）",
  T_37_XYL_SOCCERITEM: "足球道具点",
  T_37_XYL_SOCCERITEM_DESC: "放置后将生成选择的足球道具",
  T_37_XYL_SPAWN_PEOPLE: "容纳人数",
  T_37_XYL_WS_AIRCONDITIONER001: "空调B",
  T_37_XYL_WS_AMMUCHEST: "武器箱A",
  T_37_XYL_WS_BAFFLE001: "挡板A",
  T_37_XYL_WS_BARREL001: "木桶",
  T_37_XYL_WS_BARREL001_DES: "随处可见的圆木桶",
  T_37_XYL_WS_BOARD001: "广告牌B",
  T_37_XYL_WS_BOOK001: "书堆A",
  T_37_XYL_WS_BOOK002: "棋盘A",
  T_37_XYL_WS_BOUGAINVILLEA: "九重葛",
  T_37_XYL_WS_BOUGAINVILLEA_DES: "装饰物-九重葛",
  T_37_XYL_WS_BOX001: "纸箱堆A",
  T_37_XYL_WS_BOX002: "小箱子",
  T_37_XYL_WS_BUSHCOVER: "灌木丛",
  T_37_XYL_WS_BUSHCOVER_DES: "可以躲藏的灌木丛",
  T_37_XYL_WS_CABINET001: "柜子A",
  T_37_XYL_WS_CHAIR001: "椅子A",
  T_37_XYL_WS_COCONUTTREE: "椰子树",
  T_37_XYL_WS_COCONUTTREE_DES: "装饰物-椰子树",
  T_37_XYL_WS_COMPUTER001: "电脑A",
  T_37_XYL_WS_DAMAGERATIO: "受伤倍率",
  T_37_XYL_WS_FIREEX: "灭火器",
  T_37_XYL_WS_GUIDEPOSE: "指向标",
  T_37_XYL_WS_HUGEHOUSE001: "三层民房B",
  T_37_XYL_WS_HUGEHOUSE002: "二层民房B",
  T_37_XYL_WS_JACKSTRAW: "南瓜头稻草人",
  T_37_XYL_WS_LADDER001: "梯子A",
  T_37_XYL_WS_OILDRUM: "小油桶",
  T_37_XYL_WS_ORNAMENT001: "花盆A",
  T_37_XYL_WS_PACKBOX: "物资箱",
  T_37_XYL_WS_PILLA001: "水泥柱",
  T_37_XYL_WS_PRESENT: "圣诞礼盒",
  T_37_XYL_WS_PRESENT_DES: "装有礼品的圣诞节礼物盒",
  T_37_XYL_WS_PUMPKIN: "南瓜头B",
  T_37_XYL_WS_PUMPKINCUT: "南瓜头A",
  T_37_XYL_WS_PUMPKINCUT_DES: "万圣节常见的南瓜头",
  T_37_XYL_WS_ROADBLOCK001: "路障B",
  T_37_XYL_WS_SHELF001: "书架A",
  T_37_XYL_WS_SOFA001: "沙发A",
  T_37_XYL_WS_SPAWNTEAM: "所有队伍",
  T_37_XYL_WS_SUPPLYBOX: "弹药箱",
  T_37_XYL_WS_TABLE001: "桌子A",
  T_37_XYL_WS_TABLE002: "桌子B",
  T_37_XYL_WS_TARGET001: "靶子",
  T_37_XYL_WS_TEAMID_1: "1",
  T_37_XYL_WS_TEAMID_10: "10",
  T_37_XYL_WS_TEAMID_11: "11",
  T_37_XYL_WS_TEAMID_12: "12",
  T_37_XYL_WS_TEAMID_2: "2",
  T_37_XYL_WS_TEAMID_3: "3",
  T_37_XYL_WS_TEAMID_4: "4",
  T_37_XYL_WS_TEAMID_5: "5",
  T_37_XYL_WS_TEAMID_6: "6",
  T_37_XYL_WS_TEAMID_7: "7",
  T_37_XYL_WS_TEAMID_8: "8",
  T_37_XYL_WS_TEAMID_9: "9",
  T_37_XYL_WS_TELEPORTEND: "传送门终点",
  T_37_XYL_WS_TELEPORTNEW: "传送门A",
  T_37_XYL_WS_TELEPORTNEW_DESC: "可以传送到传送门终点位置的传送门",
  T_37_XYL_WS_TIRES001: "轮胎A",
  T_37_XYL_WS_TOOLRACK: "工具架",
  T_37_XYL_WS_WALL001: "围墙",
  T_37_XYL_WS_WOOD001: "木堆",
  T_37_XYL_WS_YELLOWDUCK001: "小黄鸭",
  T_37_XYL_WS_YELLOWDUCK001_DES: "充满气的小黄鸭泳圈",
  T_37_YM_BOMBSQUAD_DEFUSER: "拆弹器",
  T_37_YS_B_BRFOOTBALL_WHITE: "巴西CBF合作换皮球衣裤子",
  T_37_YS_F_B_VN_STREET: "越南名人合作步行街女裤子",
  T_37_YS_F_H_VN_STREET: "越南名人合作步行街女头饰",
  T_37_YS_F_S_VN_STREET: "越南名人合作步行街女鞋子",
  T_37_YS_F_T_VN_STREET: "越南名人合作步行街女上衣",
  T_37_YS_M_A_CRICKET_BLACK: "巴基斯坦板球运动员合作换装黑色男面饰",
  T_37_YS_M_A_THKOL: "泰国RUOK名人合作套装男面饰",
  T_37_YS_M_B_CRICKET_BLACK: "巴基斯坦板球运动员合作换装黑色男裤子",
  T_37_YS_M_B_SILVERERA: "闪银时代男裤子",
  T_37_YS_M_B_THKOL: "泰国RUOK名人合作套装男裤子",
  T_37_YS_M_H_SILVERERA: "闪银时代男头饰",
  T_37_YS_M_H_THKOL: "泰国RUOK名人合作套装男头饰",
  T_37_YS_M_S_CRICKET_BLACK: "巴基斯坦板球运动员合作换装黑色男鞋子",
  T_37_YS_M_S_SILVERERA: "闪银时代男鞋子",
  T_37_YS_M_S_THKOL: "泰国RUOK名人合作套装男鞋子",
  T_37_YS_M_T_CRICKET_BLACK: "巴基斯坦板球运动员合作换装黑色男上衣",
  T_37_YS_M_T_SILVERERA: "闪银时代男上衣",
  T_37_YS_M_T_THKOL: "泰国RUOK名人合作套装男上衣",
  T_37_YS_T_BRFOOTBALL_WHITE: "巴西CBF合作换皮球衣上衣",
  T_37_ZF_ROOM_UGC_MINPLAYER: "最小开局人数",
  T_38_BQ_SKILL_NAME_DUMMY1: "Stunt Double",
  T_38_BQ_SKILL_NAME_DUMMY2: "Shape Splitter",
  T_38_CJ_F_B_STREAMER_MUSIC: "泰国玩家投稿魅音女主播女裤子",
  T_38_CJ_F_H_STREAMER_MUSIC: "泰国玩家投稿魅音女主播女头饰",
  T_38_CJ_F_S_STREAMER_MUSIC: "泰国玩家投稿魅音女主播女鞋子",
  T_38_CJ_F_T_STREAMER_MUSIC: "泰国玩家投稿魅音女主播女上衣",
  T_38_JH_WS_CM1: "玩法规则清晰",
  T_38_JH_WS_CM2: "玩法规则不清晰",
  T_38_JH_WS_CM3: "中退频繁",
  T_38_JL_M79_AMMO_N: "M79专用榴弹",
  T_38_JMF_SKILLCHIP_NAME_SINGER: "J.Biebs' Microchip",
  T_38_M_WS_VECTOR2: "二维向量",
  T_38_R_TACTICS_N: "方案",
  T_38_RW_NIW_NIWNAME: "凝胶制造器",
  T_38_SP_WS_LOG_EXCEED_LIMIT_CALLSTACKCOUNTMAX: "图元堆栈层次过深，当前为{0}，超过上限{1}",
  T_38_SP_WS_LOG_EXCEED_LIMIT_CREATEITEMCOUNTMAXPERMATCHKEY: "创建道具数量{0}个，超过上限{1}个",
  T_38_SP_WS_LOG_EXCEED_LIMIT_DISPATCHEVENTMAXCOUNTPERFRAME: "同一帧内接收事件数量{0}个，超过上限{1}个",
  T_38_SP_WS_LOG_EXCEED_LIMIT_ENTITIESCREATEDPERFRAMEMAX: "单帧实体动态创建已达上限{0}，已拒绝{1}次创建",
  T_38_SP_WS_LOG_EXCEED_LIMIT_LISTINITLENGTHMAX: "列表初始容量为{0}，超过上限{1}，自动创建最大容量列表",
  T_38_SP_WS_LOG_EXCEED_LIMIT_LOOPTIMESMAX: "循环{0}次，超过上限{1}次，循环被中断",
  T_38_SP_WS_LOG_EXCEED_LIMIT_PERSCOPECOROUTINECONCURRENCYMAX: "一个协程域中的协程并发数量{0}个，超过上限{1}个",
  T_38_SP_WS_LOG_LIST_APPEND_IS_NIL: "列表添加元素失败，列表{0}为空",
  T_38_SP_WS_LOG_VAR_ARITHMETIC_FAILED: "四则运算时左右类型错误，左侧类型{0},右侧类型{1}",
  T_38_SP_WS_LOG_VAR_REPEATED_DEF_IN_SCOPE: "临时变量重复定义，变量名{0}",
  T_38_SP_WS_REVIEW_01: "Toxic",
  T_38_SP_WS_REVIEW_02: "Vulgar",
  T_38_SP_WS_REVIEW_03: "Insulting",
  T_38_SP_WS_REVIEW_04: "Extremely Toxic",
  T_38_SP_WS_REVIEW_05: "Threatening",
  T_38_SP_WS_REVIEW_06: "Disrespectful",
  T_38_SP_WS_REVIEW_07: "Under Review",
  T_38_SP_WS_REVIEW_08: "{0} name {1} does not comply with the rules. {2}.",
  T_38_SP_WS_REVIEW_09: "String",
  T_38_SP_WS_REVIEW_10: "Store",
  T_38_SP_WS_REVIEW_11: "Variable",
  T_38_SP_WS_REVIEW_12: "Function",
  T_38_SP_WS_REVIEW_13: "Object",
  T_38_SP_WS_REVIEW_14: "Go to definition.",
  T_38_SP_WS_REVIEW_15: "Go to Manage Objects.",
  T_38_SP_WS_REVIEW_16: "No redirection.",
  T_38_SP_WS_REVIEW_17: "地图名称",
  T_38_SP_WS_REVIEW_18: "地图描述",
  T_38_SP_WS_REVIEW_19: "地图封面",
  T_38_SP_WS_REVIEW_20: "Text contains sensitive words.",
  T_38_SP_WS_REVIEW_21: "Save failed. Unable to be reviewed.",
  T_38_SP_WS_REVIEW_22: "检测冷却中",
  T_38_SY_BASEBALLBAT_KITCHEN_N: "Bat - Mayhem",
  T_38_SY_CHARACTER_DESIGNER_N: "Santino",
  T_38_SY_PET_CACTUS_N: "Kactus",
  T_38_SY_PETSKIN_CACTUS_BLACK_N: "Pet Skin: Ghost Kactus",
  T_38_SY_PETSKIN_CACTUS_PINK_N: "Pet Skin: Neon Kactus",
  T_38_SY_PETSKIN_CACTUS_YELLOW_N: "Pet Skin: Palm Dream Kactus",
  T_38_SY_PETSKIN_FLYINGCREATURE_ES_N: "Pet Skin: Party Arvon",
  T_38_SY_PETSKIN_RACCOON_MO_N: "Pet Skin: Trendy Rockie",
  T_38_SY_SCAR_ELDERGODS_N: "SCAR - Nightfire Kami",
  T_38_SY_SICKLE_ES_N: "Scythe - Pop-Pow",
  T_38_SY_VEHICLE_SUV_KITCHEN_N: "Pickup Truck - Mochi Food Truck",
  T_38_WT_WS_MUITLEVEL: "多关卡",
  T_38_WT_WS_SKILLSET15: "戰爭顫慄（A124）",
  T_38_WT_WS_SKILLSET16: "感官衝擊（Homer）",
  T_38_WT_WS_SKILLSET17: "護盾穿透（Iris）",
  T_38_WT_WS_SKILLSET18: "急速衝鋒（Tatsuya）",
  T_38_WZY_WS_ACTIVEA: "场景中是否可用",
  T_38_WZY_WS_ACTIVEB: "是否开启逻辑更新",
  T_38_WZY_WS_ACTIVEVALUE: "活动状态",
  T_38_WZY_WS_AIR: "空气",
  T_38_WZY_WS_ALLOWMOVE: "是否允许移动",
  T_38_WZY_WS_AMMOAMOUNT: "子弹数量",
  T_38_WZY_WS_AMMONAME: "子弹实体",
  T_38_WZY_WS_ARMOR_DAMRED: "伤害减免系数",
  T_38_WZY_WS_ARMOR_DAMRED_EXP: "爆炸伤害减免系数",
  T_38_WZY_WS_ARMOR_DURABILITY: "当前耐久度",
  T_38_WZY_WS_ARMOR_DURABILITYMAX: "最大耐久度",
  T_38_WZY_WS_ARMOR_ISDAMAGE: "是否会破损",
  T_38_WZY_WS_ARMOR_ISDESTROY: "是否不会摧毁",
  T_38_WZY_WS_ARMOR_LEVEL: "等级",
  T_38_WZY_WS_ASSCONZOM: "对僵尸助攻数",
  T_38_WZY_WS_BAGNAME: "背包实体",
  T_38_WZY_WS_BAGSPACEEX: "额外背包空间",
  T_38_WZY_WS_BRIDGING: "桥接渲染组件",
  T_38_WZY_WS_BUBBLE: "泡泡",
  T_38_WZY_WS_CLEARBAG_NAMEDESC: "清空[玩家实体]背包中全部物品",
  T_38_WZY_WS_CLEARMAP_NAMEDESC: "清理地图中道具残留，包括地面可拾取道具、投掷物残留、快递盒",
  T_38_WZY_WS_CLEARPRO: "清除单个属性因子",
  T_38_WZY_WS_CLONEOBJ_NAMEDESC: "在[玩家实体]处，创建一个[场景物件]实体外形相同的分身，并返回创建的[伪装实体]",
  T_38_WZY_WS_COMPONENT: "组件基类",
  T_38_WZY_WS_COSTAMMO: "消耗弹药",
  T_38_WZY_WS_CRECREMA_NAMEDESC: "创建相机并返回[相机实体]，相机的属性可以在属性设置中更改",
  T_38_WZY_WS_CYCLES: "播放次数",
  T_38_WZY_WS_CYLINDERJUD_NAMEDESC: "判断[实体]位置是否在圆柱体范围内，[中心点]为圆柱体重心，[半径]为界面半径，[高]为圆柱的高，[旋转角]为绕中心点的三维旋转欧拉角",
  T_38_WZY_WS_CYLINDERJUD_RES: "布尔值，圆柱范围判定的结果",
  T_38_WZY_WS_DAMSUMZOM: "对僵尸伤害量",
  T_38_WZY_WS_DARKNESS: "黑暗",
  T_38_WZY_WS_DIFCOLOR: "表面颜色",
  T_38_WZY_WS_DIFTEXTURE: "表面贴图",
  T_38_WZY_WS_DRUMMUSIC: "鼓点音乐组件类型",
  T_38_WZY_WS_ENTITY_PLAYERDISDESC: "断开连接的玩家",
  T_38_WZY_WS_ENTITY_PLAYERRECDESC: "重新连接的玩家",
  T_38_WZY_WS_EUIANCHOR: "HUD锚点类型枚举",
  T_38_WZY_WS_FEATHER: "羽毛",
  T_38_WZY_WS_FLAMEAMMO: "喷火器子弹",
  T_38_WZY_WS_FLOWER: "花",
  T_38_WZY_WS_FOLLOW_NAMEDESC: "设置[实体]的位置始终跟随[跟随实体]，[偏移坐标]为跟随位置和跟随实体位置的相对坐标",
  T_38_WZY_WS_FOLLOWENT: "跟随实体",
  T_38_WZY_WS_GETCURCAM_NAMEDESC: "获取[玩家实体]当前使用的相机实体",
  T_38_WZY_WS_GETCURCAMDESC: "玩家当前使用的相机",
  T_38_WZY_WS_GETITEMNUM_NAMEDESC: "获取[玩家]拥有的指定[道具类型]的道具数量",
  T_38_WZY_WS_GETITEMNUM_RES: "玩家拥有的指定道具的数量",
  T_38_WZY_WS_GETVEC_NAME: "获得向量",
  T_38_WZY_WS_GETVEC_NAMEDESC: "通过坐标的X、Y、Z值获取向量",
  T_38_WZY_WS_GETVECRES: "根据X、Y、Z值获取的向量",
  T_38_WZY_WS_GHOST: "鬼魂",
  T_38_WZY_WS_GRENADEFROZENNAME: "冰冻手雷实体",
  T_38_WZY_WS_GRENADEFROZENPARAM1: "冰冻区域半径",
  T_38_WZY_WS_GRENADEFROZENPARAM2: "冰冻区域时长",
  T_38_WZY_WS_GRENADENAME: "手雷实体",
  T_38_WZY_WS_GRENADEPARAM1: "最小伤害",
  T_38_WZY_WS_GRENADEPARAM2: "最大伤害",
  T_38_WZY_WS_GRENADEPARAM4: "爆炸范围",
  T_38_WZY_WS_GRENADEPARAM5: "投掷速度",
  T_38_WZY_WS_GRENADEPARAM6: "爆炸延时",
  T_38_WZY_WS_GRENADEPARAM7: "对自己伤害系数",
  T_38_WZY_WS_GRENADEPARAM8: "对队友伤害系数",
  T_38_WZY_WS_GRENADEPARAM9: "对车辆伤害系数",
  T_38_WZY_WS_GUNFIRE: "枪火",
  T_38_WZY_WS_GUNPRO_PARAM2: "换弹速度",
  T_38_WZY_WS_GUNPRO_PARAM3: "击中身体伤害比例",
  T_38_WZY_WS_GUNPRO_PARAM4: "击中头部伤害比例",
  T_38_WZY_WS_GUNPRO_PARAM5: "击中四肢伤害比例",
  T_38_WZY_WS_GUNPRO_PARAM7: "额外伤害",
  T_38_WZY_WS_HELMET_NAME: "头盔实体",
  T_38_WZY_WS_ICON1: "皇冠",
  T_38_WZY_WS_ICON2: "决斗",
  T_38_WZY_WS_INITPOS: "复位位置",
  T_38_WZY_WS_ISRESET: "往复运动",
  T_38_WZY_WS_KILLCONZOM: "击杀僵尸数",
  T_38_WZY_WS_KILLENT_NAMEDESC: "击杀选择的[实体]，实体类型需要为可战斗实体，无视无敌状态",
  T_38_WZY_WS_LABELPARAM: "文本内容参数列表",
  T_38_WZY_WS_LEADMUSICA: "Lead1音乐组件类型",
  T_38_WZY_WS_LEADMUSICB: "Lead2音乐组件类型",
  T_38_WZY_WS_LEADMUSICC: "Lead3音乐组件类型",
  T_38_WZY_WS_LINE: "线",
  T_38_WZY_WS_LIQUID: "液体",
  T_38_WZY_WS_LOCALKEY: "本地化KEY",
  T_38_WZY_WS_LOCALPOS: "相对位置",
  T_38_WZY_WS_LOOKAT_NAMEDESC: "设置[实体]始终朝向[朝向实体]，[偏移坐标]为朝向位置和朝向实体位置的相对坐标",
  T_38_WZY_WS_MAINWEAPONA: "主武器1",
  T_38_WZY_WS_MAINWEAPONB: "主武器2",
  T_38_WZY_WS_MOTIONTIME: "移动时长",
  T_38_WZY_WS_MOTIONTYPE: "移动方式",
  T_38_WZY_WS_MUSHROOM_EPMODIFY: "EP修改值",
  T_38_WZY_WS_MUSHROOMNAME: "蘑菇实体",
  T_38_WZY_WS_OBFACTION: "观战阵营",
  T_38_WZY_WS_OBGLOBAL: "观战全体",
  T_38_WZY_WS_OBSERVER: "观战设定",
  T_38_WZY_WS_OBTEAM: "观战队伍",
  T_38_WZY_WS_OFFSETVEC: "偏移坐标",
  T_38_WZY_WS_ONBUY_NAMEDESC: "玩家在该商店中购买商品时触发，[玩家实体]时购买商品的玩家，[商品实体]是购买的商品",
  T_38_WZY_WS_ONEQUIPED_NAMEDESC: "被[玩家实体]装备时触发",
  T_38_WZY_WS_ONJUMP_NAMEDESC: "玩家在该商店中购买商品时触发，[玩家实体]时购买商品的玩家，[商品实体]是购买的商品",
  T_38_WZY_WS_ONLIE_NAMEDESC: "玩家成功完成趴下动作后触发",
  T_38_WZY_WS_ONRELOAD_NAMEDESC: "武器更换子弹时触发",
  T_38_WZY_WS_ONSPRINT_NAMEDESC: "玩家成功完成冲刺动作后触发",
  T_38_WZY_WS_ONSQUAT_NAMEDESC: "玩家成功完成蹲下动作后触发",
  T_38_WZY_WS_ONWAEPKILL_NAMEDESC: "武器击杀单位时触发，[击杀实体]为被击杀的单位",
  T_38_WZY_WS_ONWEAPDAMAGE_NAMEDESC: "武器对可战斗实体造成伤害时触发，[伤害对象]为受到伤害的可战斗实体，[伤害值]为此次伤害的值",
  T_38_WZY_WS_OWNER: "所有者",
  T_38_WZY_WS_PARAMLIST: "参数列表",
  T_38_WZY_WS_PARTICALMAP: "粒子贴图",
  T_38_WZY_WS_PAUSEMOTE_NAMEDESC: "对[玩家实体]暂停或恢复当前动作，[是否暂停]为布尔值，是为暂停，否为恢复",
  T_38_WZY_WS_PLAENTTRI_DESC: "玩家进入触发器时触发",
  T_38_WZY_WS_PLAQUITTRI_DESC: "家离开触发器时触发",
  T_38_WZY_WS_PLAYEMOTE_NAMEDESC: "[玩家实体]强制播放指定[动作]，播放一次动作后恢复",
  T_38_WZY_WS_PLAYSPEED: "播放速度百分比",
  T_38_WZY_WS_PREHUD_NAME: "预制图标",
  T_38_WZY_WS_QUITFACTION_NAMEDESC: "[玩家实体]退出当前所在的阵营",
  T_38_WZY_WS_RESETENT: "每回合重置组件",
  T_38_WZY_WS_RESUUID: "资源UUID",
  T_38_WZY_WS_RIMCOLOR: "边缘颜色",
  T_38_WZY_WS_RIMTEXTURE: "边缘贴图",
  T_38_WZY_WS_SECTORJUD_NAMEDESC: "判断[实体]位置是否在扇形柱体范围内，[中心点]为中截面圆心，[半径]为截面圆半径，[截取半径]为扇形截去的小扇形半径，高为立体图形的高，[角度]为扇形的角度，[方向角]为轴线的方向向量",
  T_38_WZY_WS_SECTORJUD_RES: "布尔值，扇形半径范围判定的结果",
  T_38_WZY_WS_SETACTIVE_NAMEDESC: "设置[目标实体]的活动状态，[活动状态]为一个布尔值，同时影响实体的可用性，可见性和碰撞体",
  T_38_WZY_WS_SETROUNDSCORE: "设置玩家回合积分",
  T_38_WZY_WS_SHOOTANGMAX: "射门最大角度",
  T_38_WZY_WS_SHOWMAPINFO: "同阵营显示地图信息",
  T_38_WZY_WS_SHOWNAMEHUD: "同阵营显示名字HUD",
  T_38_WZY_WS_SOUND1: "加速装置",
  T_38_WZY_WS_SOUND10: "阶段开始",
  T_38_WZY_WS_SOUND11: "僵尸背景",
  T_38_WZY_WS_SOUND12: "恐怖背景",
  T_38_WZY_WS_SOUND13: "变身音效",
  T_38_WZY_WS_SOUND14: "快速心跳音效",
  T_38_WZY_WS_SOUND15: "中速心跳音效",
  T_38_WZY_WS_SOUND16: "慢速心跳音效",
  T_38_WZY_WS_SOUND17: "暴走时间音效",
  T_38_WZY_WS_SOUND18: "点击音效",
  T_38_WZY_WS_SOUND19: "技能恢复音效",
  T_38_WZY_WS_SOUND2: "消失提示",
  T_38_WZY_WS_SOUND20: "加入游戏音效",
  T_38_WZY_WS_SOUND3: "视觉效果",
  T_38_WZY_WS_SOUND4: "夜晚虫鸣",
  T_38_WZY_WS_SOUND5: "打击（沉闷）",
  T_38_WZY_WS_SOUND6: "响应",
  T_38_WZY_WS_SOUND7: "发现惊喜",
  T_38_WZY_WS_SOUND8: "小鬼嬉闹",
  T_38_WZY_WS_SOUNDENT: "音乐实体",
  T_38_WZY_WS_SPAWNPOS: "旧出生点",
  T_38_WZY_WS_SPHERENAME: "基础球体",
  T_38_WZY_WS_SPHERERADIUS: "球体半径",
  T_38_WZY_WS_SPHERICALJUD_NAMEDESC: "判断[实体]位置是否在球型范围内，[中心点]和[半径]为判断的球体的球心和半径",
  T_38_WZY_WS_SPHERICALJUD_RES: "布尔值，球型范围判定的结果",
  T_38_WZY_WS_SQUAREJUD_NAMEDESC: "判断[实体]位置是否在立方体范围内，[中心点]为立方体重心，[长]、[宽]、[高]为立方体的长、宽、高，[旋转角]为绕中心点的三维旋转欧拉角",
  T_38_WZY_WS_SQUAREJUD_RES: "布尔值，立方体范围判定的结果",
  T_38_WZY_WS_STARTGENTIME: "开始生成时间",
  T_38_WZY_WS_STAYTIME: "停止时长",
  T_38_WZY_WS_SWITCHCAM_NAMEDESC: "将[玩家]的相机切换为[相机实体]，[切换模式]可以选择无动画或渐进式切换，[切换事件]为渐进模式的切换时间",
  T_38_WZY_WS_SWITCHCAM_PARAM3_DESC: "切换相机的模式，可以选择无动画或渐进模式",
  T_38_WZY_WS_SWITCHCAM_PARAM4_DESC: "渐进模式的切换时间，选择无动画时切换时间无效",
  T_38_WZY_WS_TEXTHUD: "文本HUD组件",
  T_38_WZY_WS_TEXTTYPE: "字号",
  T_38_WZY_WS_TEXTUREID: "贴图类型",
  T_38_WZY_WS_TRANDIST: "传递距离",
  T_38_WZY_WS_TWEENERENABLED: "是否启用UITweener脚本",
  T_38_WZY_WS_TYPELIST: "类型列表",
  T_38_WZY_WS_TYPELISTORLIST: "类型或类型列表",
  T_38_WZY_WS_VEST_NAME: "防弹衣实体",
  T_38_WZY_WS_VFX1: "躲藏者被击杀",
  T_38_WZY_WS_VFX10: "循环燃烧",
  T_38_WZY_WS_VFX11: "毒气",
  T_38_WZY_WS_VFX13: "爱心",
  T_38_WZY_WS_VFX15: "门",
  T_38_WZY_WS_VFX2: "暴走",
  T_38_WZY_WS_VFX3: "分身死亡",
  T_38_WZY_WS_VFX4: "射击反馈",
  T_38_WZY_WS_VFX5: "分身",
  T_38_WZY_WS_VFX6: "变身",
  T_38_WZY_WS_VFX7: "闪光弹烟火",
  T_38_WZY_WS_VFX8: "追尾",
  T_38_WZY_WS_VFX9: "火焰弹",
  T_38_WZY_WS_VFXENT: "特效实例",
  T_38_WZY_WS_VFXTYPEA_NAME: "可更换贴图特效",
  T_38_WZY_WS_VFXTYPEB_NAME: "不可更换贴图特效",
  T_38_WZY_WS_VISIBILITY: "可见基类",
  T_38_WZY_WS_VOLUME: "音量",
  T_38_WZY_WS_WEAPONGEN: "武器生成器",
  T_38_WZY_WS_WHECYCLE: "循环",
  T_38_XXJ_WS_BLOCKMODE: "遮蔽模式",
  T_38_XXJ_WS_CUSTOMCAMARA: "自定义相机",
  T_38_XXJ_WS_FFCLASSIC: "FF经典（射击）",
  T_38_XXJ_WS_FOV: "视野范围",
  T_38_XXJ_WS_FOVDESC: "视野范围为相机的观察角度",
  T_38_XXJ_WS_FPS: "第一人称（射击）",
  T_38_XXJ_WS_HORIZONTALANGLE: "水平角",
  T_38_XXJ_WS_INVISICAM: "半透明",
  T_38_XXJ_WS_OFFSET: "偏移量",
  T_38_XXJ_WS_ORTHOGRAPHIC: "正交",
  T_38_XXJ_WS_PERSPECTIVE: "透视",
  T_38_XXJ_WS_PROJECTIONMODE: "投影模式",
  T_38_XXJ_WS_STABLE: "固定",
  T_38_XXJ_WS_STARTCAMERA: "预设相机",
  T_38_XXJ_WS_STARTCAMERAMODE: "预设相机模式",
  T_38_XXJ_WS_THIRD: "追背",
  T_38_XXJ_WS_TOPVIEW: "俯视角",
  T_38_XXJ_WS_TPS: "第三人称",
  T_38_XXJ_WS_TRANSVERSE: "横向滚轴",
  T_38_XXJ_WS_VERTICALANGLE: "俯仰角",
  T_38_XXJ_WS_ZOOM: "推进",
  T_38_XYL_WS_AISTARTTIME: "开始生成时间（秒）",
  T_38_XYL_WS_ARMORDESTROY: "护甲伤害系数",
  T_38_XYL_WS_BONFIRE: "燃烧的火堆",
  T_38_XYL_WS_CANDLE01: "蜡烛A",
  T_38_XYL_WS_CANNON01: "机械大炮",
  T_38_XYL_WS_CLIPAMMOSIZE: "弹匣容量",
  T_38_XYL_WS_DAMAGEDTRUCK: "损毁的卡车",
  T_38_XYL_WS_DOLL01: "恐怖玩偶",
  T_38_XYL_WS_ENTERANCEHOUSE01: "小矮房A",
  T_38_XYL_WS_FENCE002: "栅栏B",
  T_38_XYL_WS_FIREWORK01: "烟花A",
  T_38_XYL_WS_GENERATOR: "生成器",
  T_38_XYL_WS_GRAVITY: "重力加速度",
  T_38_XYL_WS_GRAVITYAREA: "重力改变区",
  T_38_XYL_WS_GRAVITYAREA_DESC: "可以改变重力的区域",
  T_38_XYL_WS_HOLDWEAPON: "持枪状态",
  T_38_XYL_WS_INDOORFURNITURE: "室内家具",
  T_38_XYL_WS_LIGHTTUBE001: "长灯A",
  T_38_XYL_WS_LOVEBALLOON01: "情人节气球A",
  T_38_XYL_WS_LOVELAMP01: "情人节路灯",
  T_38_XYL_WS_LOVESIGN01: "情人节灯牌",
  T_38_XYL_WS_OILDRUM_DAMAGE: "油桶伤害倍率",
  T_38_XYL_WS_OUTDOORPROPS: "室外道具",
  T_38_XYL_WS_PIPEANDBOX: "管道和集装箱",
  T_38_XYL_WS_PLANT: "植物",
  T_38_XYL_WS_ROSE01: "一支玫瑰",
  T_38_XYL_WS_ROSEN: "玫瑰花坛",
  T_38_XYL_WS_SMALLBUILDING: "小型建筑",
  T_38_XYL_WS_SOFA002: "沙发B",
  T_38_XYL_WS_TOWNHOUSE01: "破旧的二层房屋",
  T_38_XYL_WS_TV001: "旧电视机",
  T_38_ZP_CC_EXCHANGESTATUS: "状态",
  T_39_BQ_SKILL_NAME_VILLAIN: "Crimson Crush",
  T_39_CJ_A_BURN: "泰国热门单品燃烧军团换皮面饰",
  T_39_HJ_WS_Arrow002: "箭头2",
  T_39_HJ_WS_LIKERATE2: "{0}分钟",
  T_39_HJ_WS_LIKERATE3: "{0}-{1}分钟",
  T_39_HJ_WS_SOUND10: "脚步提示",
  T_39_HJ_WS_SOUND11: "任务成功提示1",
  T_39_HJ_WS_SOUND13: "危险提示音1",
  T_39_HJ_WS_SOUND14: "危险提示音2",
  T_39_HJ_WS_SOUND15: "倒计时3",
  T_39_HJ_WS_SOUND16: "显示Tips提示",
  T_39_HJ_WS_SOUND17: "乌鸦叫的环境音",
  T_39_HJ_WS_SOUND18: "用传送点传送到错误区域的声音",
  T_39_HJ_WS_SOUND19: "用传送点传送到正确区域的声音",
  T_39_HJ_WS_SOUND2: "倒计时1",
  T_39_HJ_WS_SOUND20: "传送",
  T_39_HJ_WS_SOUND21: "电击",
  T_39_HJ_WS_SOUND23: "获得道具",
  T_39_HJ_WS_SOUND24: "电子梦幻可爱背景音乐",
  T_39_HJ_WS_SOUND25: "休闲游戏背景音乐",
  T_39_HJ_WS_SOUND4: "机械装置回声",
  T_39_HJ_WS_SOUND5: "蚊子",
  T_39_HJ_WS_SOUND6: "密集叮叮叮1",
  T_39_HJ_WS_SOUND7: "密集叮叮叮2",
  T_39_HJ_WS_SOUND8: "机关开启",
  T_39_HJ_WS_SOUND9: "充能1",
  T_39_HJ_WS_UNLIMITEDGLOOWALL: "无限凝胶护盾",
  T_39_HJ_WS_UNLIMITEDTHROWABLES: "无限投掷物",
  T_39_HQ_EVOGUN2_SOUNDEQUIP3: "特殊枪声",
  T_39_HQ_UGC_CUSTOMRES: "自定义资源",
  T_39_M_ACCOUNTID: "玩家账号",
  T_39_M_WS_BUTTON_DOUBLECLICKDESC: "当按钮双击时执行",
  T_39_MF_SKILLTAG_4: "移动",
  T_39_PD_HuntingGroundSnow_MYNAME: "黑衣人",
  T_39_QL_SKILL_OTHO_DES: "击倒敌人时，降低敌人[FFB300]{0}米[-]范围内敌人的[FFB300]{1}%[-]移速并且标记敌人，持续[FFB300]{2}秒[-]。被敌人击倒时，降低自身周围敌人移速并标记敌人。",
  T_39_QL_SKILL_WOLFRAHH_DES: "击倒敌人后进入高光状态，提升 [FFB300]{0}%[-]射速和[FFB300]{1}%[-]移速并快速衰减，持续[FFB300]{2}s[-]秒。高光状态下击倒敌人会刷新持续时间并且获得额外[FFB300]{3}%[-]攻速和[FFB300]{4}%[-]移速。",
  T_39_QL_SKILL_XAYNE_DES1: "使用后进入极限状态，获得[FFB300]{0}临时血量[-]持续[FFB300]{1}秒[-]，在技能持续期间生命恢复效果提升[FFB300]{2}%[-]，CD：[FFB300]{3}秒[-]。",
  T_39_RW_GM_DEFEAT: "失败",
  T_39_RW_SKILL_DESC_FORD: "当你受到伤害时，会在[FFB300]{0}秒[-]内每秒回复[FFB300]{1}血[-]，冷却时间：[FFB300]{2}秒[-]，释放主动技能后，这个技能会立刻重置",
  T_39_SP_WS_ITEMENTITY_01: "道具实体",
  T_39_SY_CHARACTER_ALVARO_AWAKENING_N: 'Alvaro "Rageblast"',
  T_39_SY_CHARACTER_VILLAIN_N: "Orion",
  T_39_SY_KATANA_FASTBREAKING23_N: "Katana - 1001 Nights",
  "T_39_SY_PETSKIN_FLYINGCREATURE_FB23 _N": "Pet skin: Green Imp Arvon",
  "T_39_SY_PETSKIN_TIGER_BDFEST _N": "Pet Skin: Royal Tig",
  "T_39_SY_PETSKIN_WOLF_SCARLET _N": "Pet Skin: Scorpio Fang",
  T_39_SY_VEHICLESKIN_MONSTER_TRUCK_FASTBREAKING23_N: "Monster Truck - Green Giant",
  T_39_SY_VEHICLESKIN_TUTU_BDFEST_N: "Tuk Tuk - Floral Chariot",
  T_39_WH_SKILL_DESC_GRENADESPLIT: "觉醒：手雷会在爆炸前[FFB300]{0}秒[-]时额外分裂出[FFB300]{1}颗[-]手雷，分裂手雷造成原手雷[FFB300]{2}%[-]的伤害。",
  T_39_WH_SKILL_NAME_GRENADESPLIT: "分裂手雷",
  T_39_WT_WS_EMPTYMAP_TAG: "空间开阔",
  T_39_WT_WS_FEMAPMODE: "模式标题",
  T_39_WT_WS_FEMAPTAG: "地图标签",
  T_39_WT_WS_MAPPLAYER: "对局人数",
  T_39_WT_WS_MEDENTERNUM: "匹配补人数量限制",
  T_39_WT_WS_MIDENTER: "中途补人",
  T_39_WT_WS_MIDENTERCOUNT: "累计匹配补人数量",
  T_39_WT_WS_MIDENTERTIME1: "匹配补人时间限制",
  T_39_WT_WS_MIDENTERTIME2: "匹配补人持续时长",
  T_39_WT_WS_MIDENTERTIMETIP: "对局前N秒开启中途补人。当地图人数不满时，外部玩家会在前N秒内匹配进入对局。超过N秒后则不再进行补人",
  T_39_WT_WS_MIDENTERTIP: "是否开启中途补人，开启后局外的匹配玩家能够加入该地图正在进行的对局",
  T_39_WT_WS_PLAYERCOUNT: "匹配开局人数",
  T_39_WT_WS_PLAYERCOUNTTIP: "匹配该地图开局时的玩家人数，开局后可以通过中途补人填满至地图最大人数",
  T_39_WT_WS_TAG1: "自由混战",
  T_39_WT_WS_TAG10: "简单易上手",
  T_39_WT_WS_TAG11: "中等难度",
  T_39_WT_WS_TAG12: "复杂具有深度",
  T_39_WT_WS_TAG13: "极具挑战性",
  T_39_WT_WS_TAG14: "逃出生天",
  T_39_WT_WS_TAG16: "VIP",
  T_39_WT_WS_TAG17: "自定义资源",
  T_39_WT_WS_TAG18: "解谜玩法",
  T_39_WT_WS_TAG19: "竞速玩法",
  T_39_WT_WS_TAG2: "枪战决斗",
  T_39_WT_WS_TAG20: "音乐主题",
  T_39_WT_WS_TAG21: "目标摧毁",
  T_39_WT_WS_TAG22: "探索玩法",
  T_39_WT_WS_TAG23: "PVE",
  T_39_WT_WS_TAG24: "PVP",
  T_39_WT_WS_TAG25: "派对游戏",
  T_39_WT_WS_TAG26: "团队竞技",
  T_39_WT_WS_TAG27: "塔防玩法",
  T_39_WT_WS_TAG28: "技巧训练",
  T_39_WT_WS_TAG3: "枪王之王",
  T_39_WT_WS_TAG4: "无限复活",
  T_39_WT_WS_TAG5: "狙击战",
  T_39_WT_WS_TAG6: "生存玩法",
  T_39_WT_WS_TAG7: "单人玩法",
  T_39_WT_WS_TAG8: "惊悚主题",
  T_39_WT_WS_TAG9: "休闲玩法",
  T_39_WT_WS_TAGMAXTIP: "至多选择{0}个标签",
  T_39_WT_WS_TAGTYPE1: "玩法特性",
  T_39_WT_WS_TAGTYPE2: "地图特性",
  T_39_WT_WS_TAGTYPE3: "模式特性",
  T_39_WT_WS_TAGTYPE4: "队伍规模",
  T_39_WZY_WS_ACCSPEED: "加速度",
  T_39_WZY_WS_ADDSCRIPT_NAMEDESC: "为[实体]添加指定[脚本名称]的脚本",
  T_39_WZY_WS_ASC: "升序",
  T_39_WZY_WS_ASCIGZERO: "升序忽略零值",
  T_39_WZY_WS_BALLISTMOVENT: "弹道运动实体",
  T_39_WZY_WS_BEUSED_NAMEDESC: "当该道具被[玩家实体]使用时触发",
  T_39_WZY_WS_BODYSCALE: "身体缩放",
  T_39_WZY_WS_BRAKETORQUE: "刹车马力",
  T_39_WZY_WS_CAMTRANTYPE: "相机切换动画类型",
  T_39_WZY_WS_CARVEHICLE: "四轮车",
  T_39_WZY_WS_CHECKSCRIPT_NAMEDESC: "检查[实体]是否存在指定[脚本名称]的脚本，返回值为布尔值",
  T_39_WZY_WS_CHECKSCRIPT_RES: "检查实体是否存在指定脚本的结果，布尔值",
  T_39_WZY_WS_COMBINEALL: "任意组合双持",
  T_39_WZY_WS_COMBINESELF: "和自己双持",
  T_39_WZY_WS_CONENAME: "基础圆锥",
  T_39_WZY_WS_COORSYS: "坐标系",
  T_39_WZY_WS_CRASHMAXD: "最大撞击伤害",
  T_39_WZY_WS_CRASHMIND: "最小撞击伤害",
  T_39_WZY_WS_CRAWLSPEED: "趴下移速百分比",
  T_39_WZY_WS_CREBALLISTMOV_NAMEDESC: "为[目标实体]创建弹道运动，可以设置目标实体的[初速度]、[加速度]、初速度方向累计的[最大距离]，并返回[弹道运动实体]",
  T_39_WZY_WS_CRETWEEN_NAME: "创建插值运动",
  T_39_WZY_WS_CRETWEEN_NAMEDESC: "为[实体]创建插值运动，实体的[属性]从[起始值]到[目标值]在[时间]内平滑运动，[方式]为运动的方式，包括单次、循环、往复，[曲线]为运动的曲线，并返回[插值运动实体]",
  T_39_WZY_WS_CURVE: "曲线",
  T_39_WZY_WS_CUSTRESULT: "自定义结算",
  T_39_WZY_WS_CYLINDERNAME: "基础柱体",
  T_39_WZY_WS_DEFAULT: "无动画（默认）",
  T_39_WZY_WS_DESC: "降序",
  T_39_WZY_WS_DIFFUSEALPHA: "表面透明度",
  T_39_WZY_WS_DISCONNECT: "断线",
  T_39_WZY_WS_DOUBLEJUMPSHOE_ENERGYRECOVERY: "每秒恢复能量",
  T_39_WZY_WS_DOUBLEJUMPSHOE_JUMCONSUME: "消耗能量",
  T_39_WZY_WS_DOUBLEJUMPSHOE_MAXJUMPH: "二段跳最大跳跃高度",
  T_39_WZY_WS_ENABLEJOIN: "允许中途加入",
  T_39_WZY_WS_ENDPOS: "终点坐标",
  T_39_WZY_WS_ENGINETORQUE: "引擎马力",
  T_39_WZY_WS_EXPLODED: "爆炸伤害",
  T_39_WZY_WS_FEELDSPEED: "倒地移速百分比",
  T_39_WZY_WS_FLASH_CFLASHTIME: "中心闪光时间",
  T_39_WZY_WS_FLASH_CRANGE: "中心范围",
  T_39_WZY_WS_FLASH_EFLASHTIME: "边缘闪光时间",
  T_39_WZY_WS_FLASH_HITEFFECTSWITCH: "闪光弹命中效果开关",
  T_39_WZY_WS_FLASH_RANGE: "爆炸范围",
  T_39_WZY_WS_FOLDWINGS_FALLSPEED: "结束滑行下降速度",
  T_39_WZY_WS_FOLDWINGS_FLYMAXH: "最大飞行高度",
  T_39_WZY_WS_FOLDWINGS_FLYSPEEDH: "滑行速度",
  T_39_WZY_WS_FOLDWINGS_FLYSPEEDV: "滑行下降速度",
  T_39_WZY_WS_FOLDWINGS_MINENDH: "最小结束高度",
  T_39_WZY_WS_FOLDWINGS_MINFLYH: "最小起飞高度",
  T_39_WZY_WS_FOLDWINGS_OVERHFALLSPEED: "超高之后的下落速度",
  T_39_WZY_WS_FOLDWINGS_TURNSPEED: "转弯速度",
  T_39_WZY_WS_FOLMOVENT: "位置跟随运动实体",
  T_39_WZY_WS_GETSKILLLIST_NAMEDESC: "获取[玩家实体]的技能列表",
  T_39_WZY_WS_HB_BOOSTCD: "冲刺冷却时间",
  T_39_WZY_WS_HB_BOOSTDURATION: "冲刺持续时间",
  T_39_WZY_WS_HB_BOOSTINITIAL: "上滑板后冲刺冷却时间",
  T_39_WZY_WS_HB_BOOSTINITIALSWITCH: "上滑板后冲刺冷却时间开关",
  T_39_WZY_WS_HB_BOOSTSPEED: "冲刺速度",
  T_39_WZY_WS_HB_HOVERBCD: "上滑板冷却时间",
  T_39_WZY_WS_HB_JUMPCD: "跳跃冷却时间",
  T_39_WZY_WS_HB_JUMPH: "滑板跳跃高度",
  T_39_WZY_WS_HEADSCALE: "头骨缩放",
  T_39_WZY_WS_HEADSHOTDESCALE: "爆头减伤率",
  T_39_WZY_WS_INTITALSPEED: "初速度",
  T_39_WZY_WS_INVENTORYBASE: "道具资产基类",
  T_39_WZY_WS_JETSHOE_BASEENERGYCOST: "每秒能量消耗",
  T_39_WZY_WS_JETSHOE_BASEHSPEED: "基础水平速度",
  T_39_WZY_WS_JETSHOE_BASEVSPEED: "基础垂直速度",
  T_39_WZY_WS_JETSHOE_DASHENERGYCOST: "每秒快跑能量消耗",
  T_39_WZY_WS_JETSHOE_DASHHSPEED: "快跑水平速度",
  T_39_WZY_WS_JETSHOE_RUSHDIS: "冲刺距离",
  T_39_WZY_WS_JETSHOE_RUSHENERGYCOST: "每秒冲刺能量消耗",
  T_39_WZY_WS_JETSHOE_RUSHVSPEED: "冲刺垂直速度",
  T_39_WZY_WS_JETSHOE_UPENERGYCOST: "每秒向上能量消耗",
  T_39_WZY_WS_LANDMINE_CANBEATTACK: "是否可被攻击",
  T_39_WZY_WS_LANDMINE_CANSELFTRIGGER: "是否能自身触发",
  T_39_WZY_WS_LANDMINE_CANTEAMTRIGGER: "是否队友能触发",
  T_39_WZY_WS_LANDMINE_CANVEHICLETRIGGER: "是否可载具触发",
  T_39_WZY_WS_LANDMINE_LIFETIME: "持续时间",
  T_39_WZY_WS_LANDMINE_STARTTIME: "启动时间",
  T_39_WZY_WS_LANDMINE_TRIGGERRADIUS: "触发半径",
  T_39_WZY_WS_LANDMINE_TRIGGERTIME: "触发时间",
  T_39_WZY_WS_LEAVE: "主动退出",
  T_39_WZY_WS_LIMBSCALE: "四肢缩放",
  T_39_WZY_WS_LISTLOCSTR: "本地化文本列表",
  T_39_WZY_WS_LOADRESULT_NAME: "上传结算信息",
  T_39_WZY_WS_LOADRESULT_NAMEDESC: "上传[玩家]的结算信息，包括[排名]、[结果]、[积分标题]、[积分值]，结果类型为int，1为胜利、2为失败、3为booyah、4为平局",
  T_39_WZY_WS_LOOKMOVENT: "注视跟随运动实体",
  T_39_WZY_WS_MAXCOUNT: "最大数量",
  T_39_WZY_WS_MAXDISTANCE: "最大距离",
  T_39_WZY_WS_MINISENTRY_ANGELDOWN: "炮塔俯角",
  T_39_WZY_WS_MINISENTRY_ANGELSPEED: "炮塔角速度",
  T_39_WZY_WS_MINISENTRY_ANGELUP: "炮塔仰角",
  T_39_WZY_WS_MINISENTRY_DAM: "炮塔伤害",
  T_39_WZY_WS_MINISENTRY_DEFENSE: "减伤率",
  T_39_WZY_WS_MINISENTRY_FIREANGLE: "开火角度",
  T_39_WZY_WS_MINISENTRY_HITCHANCE: "炮塔命中率",
  T_39_WZY_WS_MINISENTRY_INTERVAL: "炮塔攻击间隔",
  T_39_WZY_WS_MINISENTRY_MAXCOUNT: "最大炮塔数量",
  T_39_WZY_WS_MINISENTRY_RANGE: "炮塔攻击范围",
  T_39_WZY_WS_MOVEENT: "运动实体",
  T_39_WZY_WS_NOCOMBINE: "不可双持",
  T_39_WZY_WS_ONCE: "单次",
  T_39_WZY_WS_ONDROP_NAMEDESC: "当该道具被[玩家实体]丢弃时触发",
  T_39_WZY_WS_ONEQUIP_NAMEDESC: "当该道具被[玩家实体]装备时触发",
  T_39_WZY_WS_ONGRAPFIRE_NAMEDESC: "当钩锁枪发射时触发",
  T_39_WZY_WS_ONLANDSTART_NAMEDESC: "当地雷启动时触发",
  T_39_WZY_WS_ONLANDTRIGGER_NAMEDESC: "地雷被[触发玩家]触发时触发",
  T_39_WZY_WS_ONMOTIONPAUSE_NAMEDESC: "当运动实体暂停运动时触发",
  T_39_WZY_WS_ONMOTIONREATART_NAMEDESC: "当运动实体从暂停状态恢复运动时触发",
  T_39_WZY_WS_ONMOTIONSTART_NAMEDESC: "当运动实体开始运动时触发",
  T_39_WZY_WS_ONPICKUP_NAMEDESC: "当该道具被[玩家实体]拾取时触发",
  T_39_WZY_WS_ONTHROWHIT_NAMEDESC: "当投掷物命中时触发",
  T_39_WZY_WS_OPENATTACK: "是否开启攻击",
  T_39_WZY_WS_PAUSEMOV_NAMEDESC: "对运动实体或运动实体列表进行暂停",
  T_39_WZY_WS_PAUSESOUND_NAME: "暂停音效",
  T_39_WZY_WS_PAUSESOUND_NAMEDESC: "对音乐实体或音乐实体列表进行暂停",
  T_39_WZY_WS_PIANOTYPE: "音乐组件类型",
  T_39_WZY_WS_PINGPONG: "往复",
  T_39_WZY_WS_PLAYABLELIST: "运动实体列表",
  T_39_WZY_WS_PLAYINGSTATUE: "播放状态",
  T_39_WZY_WS_PLAYMOV_NAMEDESC: "对暂停状态的运动实体或运动实体列表进行恢复，可以选择继续播放或从头开始播放",
  T_39_WZY_WS_PLAYSOUND_NAME: "播放音效",
  T_39_WZY_WS_PLAYSOUND_NAMEDESC: "对暂停状态的音乐实体或音乐实体列表进行恢复，可以选择继续播放或从头开始播放",
  T_39_WZY_WS_PROCIRCLE_NAME: "准备等待进度圈",
  T_39_WZY_WS_RAYINSPCON_NAMEDESC: "从[起始坐标]处沿[方向]发射一条射线，检测射线在[距离]内命中的所有实体，返回[命中实体列表]和[命中坐标列表]",
  T_39_WZY_WS_RAYINSPSIN_NAMEDESC: "从[起始坐标]处沿[方向]发射一条射线，检测射线在[距离]内命中的第一个实体，返回[命中实体]和[命中坐标]",
  T_39_WZY_WS_REAHEALHP: "耐久恢复值",
  T_39_WZY_WS_REAHEALTIME: "生效时间间隔",
  T_39_WZY_WS_RELATCOORSYS: "相对坐标系",
  T_39_WZY_WS_REPAIRARM: "修复工具包",
  T_39_WZY_WS_REVERSE: "倒放",
  T_39_WZY_WS_RIMALPHA: "边缘透明度",
  T_39_WZY_WS_SCORENAME: "积分标题",
  T_39_WZY_WS_SENDSIGN_NAMEDESC: "向目标实体发射信号，上传的参数通过预定义信号参数定义，定义时选择实体类型会生成对应的接受信号事件",
  T_39_WZY_WS_SETFOLMOV_NAMEDESC: "为[目标实体]创建位置跟随运动，[跟随实体]为目标实体的跟随对象，[偏移坐标]为目标点和跟随实体的坐标偏移量，[坐标系]可以选择世界坐标系和基于跟随实体朝向的相对坐标系，创建运动后返回[位置跟随运动实体]",
  T_39_WZY_WS_SETLOOKMOV_NAMEDESC: "为[目标实体]创建注视跟随运动，[跟随实体]为目标实体的朝向对象，[偏移坐标]为实际点和跟随实体的坐标偏移量，[坐标系]可以选择世界坐标系和基于跟随实体朝向的相对坐标系，创建运动后返回[注视跟随运动实体]",
  T_39_WZY_WS_SHOE_FALLDAMSCALE: "掉落伤害百分比",
  T_39_WZY_WS_SHOE_MAXENERGY: "最大能量值",
  T_39_WZY_WS_SKILLLIST: "技能列表",
  T_39_WZY_WS_SKILLTYPE: "角色技能",
  T_39_WZY_WS_SMOKEG_EFFECTTIME: "烟雾特效持续时间",
  T_39_WZY_WS_SMOOTH: "渐进",
  T_39_WZY_WS_SOUNDENTL: "音效实体列表",
  T_39_WZY_WS_SOUNDENTLORSENT: "音效实体或列表",
  T_39_WZY_WS_SPRINTSPEED: "冲刺速度百分比",
  T_39_WZY_WS_SQUATSPEED: "蹲下移速百分比",
  T_39_WZY_WS_STARTCOO: "起始坐标",
  T_39_WZY_WS_STATE: "播放状态",
  T_39_WZY_WS_TARGETVAL: "目标值",
  T_39_WZY_WS_THROWSPEED: "Hook flying speed",
  T_39_WZY_WS_TOWER_PARAM10: "旋转角度",
  T_39_WZY_WS_TOWER_PARAM11: "防御塔状态",
  T_39_WZY_WS_TOWER_PARAM12: "名字拼接对象编号",
  T_39_WZY_WS_TOWER_PARAM9: "攻击目标",
  T_39_WZY_WS_TOWSPEED: "Player traveling speed",
  T_39_WZY_WS_TWEENCURVE_NAME: "自定义曲线",
  T_39_WZY_WS_TWEENCURVE_NAMEDESC: "自定义曲线，可以用于插值运动",
  T_39_WZY_WS_TWEENENT: "插值运动实体",
  T_39_WZY_WS_TWEENPLAYST_NAME: "播放方式",
  T_39_WZY_WS_TWEENPLAYST_NAMEDESC: "插值运动的播放方式",
  T_39_WZY_WS_TWEENSTYLE: "方式",
  T_39_WZY_WS_UNLOADSCRIPT_NAMEDESC: "为[实体]卸载指定[脚本名称]的脚本",
  T_39_WZY_WS_UPSET_NAMEDESC: "对列表中元素重新随机排序",
  T_39_WZY_WS_VISIBLEONBACK: "背在身上是否显示",
  T_39_WZY_WS_WEAPCOMBINET: "武器双持类型",
  T_39_WZY_WS_WEAPON_KNOCKDOWNDAM: "击中倒地者额外伤害",
  T_39_WZY_WS_WEAPON_ONCEAMMO: "单次发射子弹数量",
  T_39_WZY_WS_WEAREPLAY: "是否重新播放",
  T_39_WZY_WS_WORLDCOORSYS: "世界坐标系",
  T_39_XXJ_WS_ADDFRIEND: "加好友",
  T_39_XXJ_WS_ALLOWZ: "是否允许玩家X轴运动",
  T_39_XXJ_WS_BLOCKMODEDESC: "当相机与跟随对象中间有遮挡物时，相机的运动模式",
  T_39_XXJ_WS_CAMERADISTANCE: "相机距离目标的距离",
  T_39_XXJ_WS_CAMERATYPEDESC: "提供多种预设相机类型，以及自定义相机类型",
  T_39_XXJ_WS_CAMERAUSER: "正在使用该相机的玩家",
  T_39_XXJ_WS_CURENTCAMERA: "玩家正在使用的相机",
  T_39_XXJ_WS_DETAILS: "对局详情",
  T_39_XXJ_WS_FFECONOMY: "局外经济",
  T_39_XXJ_WS_FOCUSTARGET: "相机观察的目标",
  T_39_XXJ_WS_FOLLOWTARGET: "相机跟随的目标",
  T_39_XXJ_WS_GAMERESULT: "对局结果",
  T_39_XXJ_WS_GAMETITLE1: "对局标题1",
  T_39_XXJ_WS_GAMETITLE2: "对局标题2",
  T_39_XXJ_WS_GIFT: "送礼",
  T_39_XXJ_WS_HORIZONTALANGLEDESC: "相机在水平方向上的旋转角",
  T_39_XXJ_WS_INVISICAM: "透视",
  T_39_XXJ_WS_INVISICAMDESC: "当相机与跟随对象中间有遮挡物时，遮挡物将变为半透明",
  T_39_XXJ_WS_LEFTSCORE: "左边队伍得分",
  T_39_XXJ_WS_LIKE: "点赞",
  T_39_XXJ_WS_LOBBY: "回到大厅",
  T_39_XXJ_WS_MAINSCORENAME: "总积分名",
  T_39_XXJ_WS_MAINSCORENUM: "总积分数",
  T_39_XXJ_WS_MAPEVALUATE: "地图评价",
  T_39_XXJ_WS_MULTITEAMRESULTHUD: "多队结算界面",
  T_39_XXJ_WS_MVP1: "MVP标记1",
  T_39_XXJ_WS_MVP2: "MVP标记2",
  T_39_XXJ_WS_OFFSET2: "所观察点的偏移量",
  T_39_XXJ_WS_OFFSET2DESC: "一般指相机聚焦点相对于玩家原点位置的偏移量，不同相机类型具体含义不同",
  T_39_XXJ_WS_OFFSETDESC: "一般指相机位置相对于玩家原点位置的偏移量，不同相机类型具体含义不同",
  T_39_XXJ_WS_ORTHOGONAL: "正交",
  T_39_XXJ_WS_ORTHOGONALDESC: "相机观察对象时，远近物体大小一样",
  T_39_XXJ_WS_PERSPECTIVE: "透视",
  T_39_XXJ_WS_PERSPECTIVEDESC: "相机观察对象时，近大远小",
  T_39_XXJ_WS_PROJECTIONMODEDESC: "相机渲染画面时的成像方式",
  T_39_XXJ_WS_RANK1: "队伍排名",
  T_39_XXJ_WS_RANK2: "玩家排名",
  T_39_XXJ_WS_REPORT: "举报",
  T_39_XXJ_WS_REVIEW: "回看",
  T_39_XXJ_WS_RIGHTSCORE: "右边队伍得分",
  T_39_XXJ_WS_SCORENUM1: "积分1",
  T_39_XXJ_WS_SCORENUM2: "积分2",
  T_39_XXJ_WS_SCORENUM3: "积分3",
  T_39_XXJ_WS_SCORENUM4: "积分4",
  T_39_XXJ_WS_SCORENUM5: "积分5",
  T_39_XXJ_WS_SCORETITLELIST: "标题列表",
  T_39_XXJ_WS_SHARE: "分享",
  T_39_XXJ_WS_SPECTATORSWITCH: "观战开关",
  T_39_XXJ_WS_STABLE: "固定",
  T_39_XXJ_WS_STABLEDESC: "当相机与跟随对象中间有遮挡物时，相机不做任何变化",
  T_39_XXJ_WS_TEAMNAME1: "左边队伍名",
  T_39_XXJ_WS_TEAMNAME2: "右边队伍名",
  T_39_XXJ_WS_TEAMRANK: "队伍名次",
  T_39_XXJ_WS_TRANSITIONTIME: "相机切换动画的时间",
  T_39_XXJ_WS_TRANSITIONTYPE: "相机切换动画的类型",
  T_39_XXJ_WS_TWOTEAMRESULTHUD: "两队结算界面",
  T_39_XXJ_WS_VERTICALANGLEDESC: "相机在垂直方向上的旋转角",
  T_39_XXJ_WS_ZOOM: "推近",
  T_39_XXJ_WS_ZOOMDESC: "当相机与跟随对象中间有遮挡物时，相机将推近跟随对象",
  T_39_XYL_WS_LIGHTINTENSITY: "光照强度",
  T_39_XYL_WS_LIGHTRANGE: "光照范围",
  T_39_XYL_WS_POINTLIGHT: "点光源",
  T_39_XYL_WS_WATERZONE: "自定义水域",
  T_40_B_DISABLE_RECONNECT: "关闭断线重连",
  T_40_CJ_T_SHUTTLECOCK_BLACK: "印尼羽毛球(黑色)上衣",
  T_40_CJ_T_SHUTTLECOCK_RED2: "印尼羽毛球(红色)上衣",
  T_40_CJ_T_SHUTTLECOCK_REDBLACK: "印尼羽毛球(红黑色)上衣",
  T_40_CJ_T_SHUTTLECOCK_YELLOW: "印尼羽毛球(黄色)上衣",
  T_40_CJ_T_SPORTSWEAR_FIRE: "泰国长袖球衣上衣",
  T_40_DYEING_CLEAR: "清除染色状态",
  T_40_HJ_WS_EFFECT32: "跑鞋特效",
  T_40_HJ_WS_EFFECT33: "爆炸特效",
  T_40_HJ_WS_EFFECT34: "出生点特效",
  T_40_HJ_WS_EFFECT35: "激光特效",
  T_40_HJ_WS_EFFECT36: "武器子弹特效",
  T_40_HJ_WS_EFFECT37: "子弹命中特效",
  T_40_HJ_WS_EFFECT38: "武器开火特效",
  T_40_HJ_WS_EFFECT43: "蛛网特效",
  T_40_HJ_WS_EFFECT44: "技能释放特效",
  T_40_HJ_WS_SOUND69: "打开盒子",
  T_40_HJ_WS_SOUND70: "等级提升",
  T_40_HJ_WS_SOUND71: "满级",
  T_40_HJ_WS_SOUND72: "点击按钮",
  T_40_HJ_WS_SOUND73: "倒计时",
  T_40_HJ_WS_SOUND74: "哨子声",
  T_40_HJ_WS_SOUND75: "完成",
  T_40_HJ_WS_SOUND76: "前进",
  T_40_HJ_WS_SOUND77: "胜利",
  T_40_HJ_WS_SOUND78: "检查点",
  T_40_HJ_WS_SOUND79: "倒计时2",
  T_40_HJ_WS_SOUND80: "游戏开始",
  T_40_HJ_WS_SOUND81: "获得大量金币",
  T_40_HJ_WS_SOUND82: "获得金币",
  T_40_HJ_WS_SOUND83: "获得少量金币",
  T_40_HJ_WS_SOUND84: "加入战场",
  T_40_HJ_WS_SOUND85: "打开工会红包",
  T_40_HJ_WS_SOUND86: "喇叭声",
  T_40_HJ_WS_SOUND87: "击杀首领",
  T_40_HJ_WS_SOUND88: "打开箱子",
  T_40_HJ_WS_SOUND89: "元气弹技能",
  T_40_HJ_WS_SOUND90: "子弹命中",
  T_40_HJ_WS_SOUND91: "血池技能",
  T_40_HJ_WS_SOUND92: "点击禁用按钮",
  T_40_HJ_WS_SOUND93: "技能充能完成",
  T_40_HJ_WS_SOUND95: "激光技能",
  T_40_HJ_WS_SOUND96: "获得道具2",
  T_40_HJ_WS_SOUND97: "游戏结束2",
  T_40_HJ_WS_SOUND98: "击杀提示讯息",
  T_40_HJ_WS_SOUNDTYPE_BMG: "背景音乐",
  T_40_HJ_WS_SOUNDTYPE_INGAME: "游戏局内音效",
  T_40_HJ_WS_SOUNDTYPE_UI: "UI Weiget",
  T_40_JH_WS_MAPTAG1: "色彩游戏",
  T_40_JH_WS_MAPTAG10: "彩色躲猫猫",
  T_40_JH_WS_MAPTAG11: "周年庆游戏",
  T_40_JH_WS_MAPTAG12: "角色扮演",
  T_40_JH_WS_MAPTAG13: "模拟经营",
  T_40_JH_WS_MAPTAG14: "非对称竞技",
  T_40_JH_WS_MAPTAG15: "资源争夺战",
  T_40_JH_WS_MAPTAG16: "推车护送大作战",
  T_40_JH_WS_MAPTAG17: "官方地图",
  T_40_JH_WS_MAPTAG18: "迷你游戏",
  T_40_JH_WS_MAPTAG19: "竞速挑战",
  T_40_JH_WS_MAPTAG2: "喷色",
  T_40_JH_WS_MAPTAG20: "RougeLike",
  T_40_JH_WS_MAPTAG3: "色彩大作战",
  T_40_JH_WS_MAPTAG4: "彩色枪战",
  T_40_JH_WS_MAPTAG5: "彩色游乐场",
  T_40_JH_WS_MAPTAG6: "游乐场涂色大作战",
  T_40_JH_WS_MAPTAG7: "彩色派对游戏",
  T_40_JH_WS_MAPTAG8: "彩色跑酷",
  T_40_JH_WS_MAPTAG9: "蜘蛛跑酷",
  T_40_JH_WS_TAG30: "Tycoon",
  T_40_JH_WS_TAG31: "拆家大作战",
  T_40_JH_WS_TAG32: "Murder Mist",
  T_40_JH_WS_TAG33: "黎明杀机",
  T_40_JH_WS_TAG34: "Death Uprising",
  T_40_JH_WS_TAG35: "Fist Fight",
  T_40_JH_WS_TAG36: "Old Factory Roof",
  T_40_JH_WS_UGCTOKENNAME: "我的战场代币",
  T_40_L_QUICKMESSAGE_MODE2: "团队突袭",
  T_40_M_WS_HIS: "的",
  T_40_SP_WS_DYEING: "染色",
  T_40_SP_WS_DYEING_AREA: "区域染色",
  T_40_SP_WS_DYEING_COLOR: "颜色序号",
  T_40_SP_WS_DYEING_COUNT: "染色统计",
  T_40_SP_WS_DYEING_DIR: "射线方向",
  T_40_SP_WS_DYEING_DIS: "射线长度",
  T_40_SP_WS_DYEING_FIXEDDYEINGRANGE: "固定染色范围",
  T_40_SP_WS_DYEING_NORMAL: "法线",
  T_40_SP_WS_DYEING_PLANE: "平面范围染色",
  T_40_SP_WS_DYEING_POSITION: "坐标",
  T_40_SP_WS_DYEING_RANDOMDECAY: "随机染色概率衰减",
  T_40_SP_WS_DYEING_RANDOMRATIO: "随机染色概率",
  T_40_SP_WS_DYEING_RANGE: "染色范围",
  T_40_SP_WS_DYEING_STATE: "染色状态",
  T_40_SP_WS_FACTIONTIPS_11: "紫色",
  T_40_SP_WS_SHOE_CURENERGY: "当前能量值",
  T_40_SW_SKILL_Name_Nanoscientist: "Nano Lifeshield",
  T_40_SY_AK47_PENGUIN_W_N: "瓦哥主题枪皮 ",
  T_40_SY_CHARACTER_DJMALE_AWAKENING_N: "Alok觉醒",
  T_40_SY_CHARACTER_NANOSCIENTIST_N: "Sonia ",
  T_40_SY_FAMAS_PENGUIN_W_N: "瓦哥主题枪皮 ",
  T_40_SY_M1014_PENGUIN_W_N: "瓦哥主题枪皮 ",
  T_40_SY_M24_PENGUIN_W_N: "瓦哥主题枪皮 ",
  T_40_SY_MINI_PENGUIN_W_N: "瓦哥主题枪皮 ",
  T_40_SY_PET_PUG_N: "Pug",
  T_40_SY_PETSKIN_ALIEN_TIGHTGUY_N: "红与黑合作宠物外星人皮肤",
  T_40_SY_PETSKIN_FLYINGCREATURE_ME_N: "传奇飞宠皮肤 ME本地",
  T_40_SY_PETSKIN_PUG_BLACK_N: "宠物巴哥皮肤 金械危机",
  T_40_SY_PETSKIN_PUG_GREEN_N: "宠物巴哥皮肤绿色",
  T_40_SY_PETSKIN_PUG_ORANGE_N: "宠物巴哥皮肤橙色",
  T_40_SY_SCAR_PENGUIN_W_N: "瓦哥主题枪皮 ",
  T_40_SY_THOMPSON_PENGUIN_W_N: "瓦哥主题枪皮 ",
  T_40_SY_UMP45_PENGUIN_W_N: "瓦哥主题枪皮 ",
  T_40_SY_USP45_PENGUIN_W_N: "瓦哥主题枪皮 ",
  T_40_SY_UZI_PENGUIN_W_N: "瓦哥主题枪皮 ",
  T_40_V_WS_INPUT_TEXT_ACTIVE: "激活文本内容",
  T_40_V_WS_INPUT_TEXT_DEFAULT: "占位文本内容",
  T_40_W_DJMALE_AWAKENING_D: "觉醒：光环持续期间间隔[FFB300]{0}秒[-]在身后[FFB300]{1}米[-]生成持续[FFB300]{2}秒[-]的音符，队友拾取后获得等同光环的效果。",
  T_40_W_DJMALE_AWAKENING_N: "旋律激荡",
  T_40_W_NURSE_D: "将自身给予的[FFB300]{0}%[-]单体治疗量扩散给范围[FFB300]{1}米[-]内的队友。",
  T_40_WH_MP_BOXING_NAME: "拳击擂台赛",
  T_40_WH_MP_C_PACK: "赃物背包",
  T_40_WH_MP_EXCH_COIN: "现金",
  T_40_WH_MP_EXCH_TEMPCOIN: "赃款",
  T_40_WH_MP_PAYCHECK: "工资",
  T_40_WT_SKILL_DESC_MUSICBRO_BLACK: "扶起队友的速度加快[FFB300]{0}%[-]，cd[FFB300]{3}s[-]秒；扶起的队友[FFB300]{1}秒[-]内回复[FFB300]{2} 点[-]HP。",
  T_40_WT_SKILL_DESC_MUSICBRO_WHITE2: "生成一个半径为[FFB300]{0}米[-]的光环，光环内友军每秒恢复[FFB300]{1}点[-]hp，且自动扶起倒地队友；光环持续[FFB300]{2}秒[-]，扶起队友效果受到其他技能加成，cd：[FFB300]{3}秒[-]。",
  T_40_WT_WS_ICONENTITY_PARAM6: "显示方式",
  T_40_WZY_WS_CUSTOMTRIGGER_CAPSULE: "胶囊体",
  T_40_WZY_WS_CUSTOMTRIGGER_HEIGHT: "高",
  T_40_WZY_WS_CUSTOMTRIGGER_RADIUS: "半径",
  T_40_WZY_WS_CUSTOMTRIGGER_SPHERE: "球体",
  T_40_WZY_WS_FONT_FF_CN_T: "FZLanTingHei-R-BIG5",
  T_40_WZY_WS_FONT_HINDSILIGURI: "Hind Siliguri",
  T_40_WZY_WS_FONT_NOTONASTALIQURDU: "Noto Nastaliq Urdu（待翻译）",
  T_40_WZY_WS_FONT_NOTOSANS: "GFF Devanagari",
  T_40_WZY_WS_FONT_SIMPBDO: "Simplified Arabic",
  T_40_WZY_WS_FONT_SUPERMARKET: "supermarket",
  T_40_WZY_WS_ICONENTITY_COLOR: "颜色",
  T_40_WZY_WS_ICONENTITY_FILLED: "进度模式",
  T_40_WZY_WS_ICONENTITY_ICONTYPE: "图片资源",
  T_40_WZY_WS_ICONENTITY_NAME: "图标物件",
  T_40_WZY_WS_ICONENTITY_RENDERTYPE: "显示方式",
  T_40_WZY_WS_ICONENTITY_SIMPLE: "简单模式",
  T_40_WZY_WS_ICONENTITY_SLICED: "九宫模式",
  T_40_WZY_WS_ICONENTITY_TILED: "平铺模式",
  T_40_WZY_WS_NEWMAPTAG: "新地图标识",
  T_40_WZY_WS_NEWVFX1: "光环",
  T_40_WZY_WS_NEWVFX10: "符咒",
  T_40_WZY_WS_NEWVFX11: "冰冻区域",
  T_40_WZY_WS_NEWVFX12: "冷气",
  T_40_WZY_WS_NEWVFX13: "雪花",
  T_40_WZY_WS_NEWVFX14: "火焰",
  T_40_WZY_WS_NEWVFX15: "光束",
  T_40_WZY_WS_NEWVFX16: "毒气扩散",
  T_40_WZY_WS_NEWVFX17: "毒气",
  T_40_WZY_WS_NEWVFX18: "爆炸火光",
  T_40_WZY_WS_NEWVFX19: "光效",
  T_40_WZY_WS_NEWVFX2: "气泡",
  T_40_WZY_WS_NEWVFX20: "星星",
  T_40_WZY_WS_NEWVFX3: "烟尘",
  T_40_WZY_WS_NEWVFX4: "石子飞溅",
  T_40_WZY_WS_NEWVFX5: "线条",
  T_40_WZY_WS_NEWVFX6: "闪烁",
  T_40_WZY_WS_NEWVFX7: "圆环",
  T_40_WZY_WS_NEWVFX8: "上升粒子",
  T_40_WZY_WS_NEWVFX9: "烟雾",
  T_40_WZY_WS_PRESENTTXT_FONTSIZE: "字体尺寸",
  T_40_WZY_WS_PRESENTTXT_FONTSTYLE: "字体风格",
  T_40_WZY_WS_TEXTENTITY_FONTTYPE: "字体",
  T_40_WZY_WS_TEXTENTITY_NAME: "文本物件",
  T_40_WZY_WS_UIFONT_LATIN: "Agency FB",
  T_40_WZY_WS_UIFONT_LATIN_BOLD: "GFF Latin",
  T_40_XXJ_WS_ACTIONHUD: "交互按钮界面实体组件",
  T_40_XXJ_WS_ACTIVEINHIERARCHY_DESCKEY: "在场景中是否可用。只读，取决于ActiveParent以及ActiveSelf。",
  T_40_XXJ_WS_ACTIVEPARENT_DESCKEY: "所有父节点是否都可用。只读。对玩家不可见。",
  T_40_XXJ_WS_ACTIVEPARENT_NAMEKEY: "父节点是否可用",
  T_40_XXJ_WS_ACTIVESELF_DESCKEY: "打开状态为true时则显示，否则关闭",
  T_40_XXJ_WS_ACTIVESELF1_DESCKEY: "自身是否可用。在场景中是否可用需要使用ActiveInHierarchy。只读，通过API设置。",
  T_40_XXJ_WS_ADDORREMOVECAMERACULLINGMASK_DESCKEY: "设置相机CullingMask对某层是否可见",
  T_40_XXJ_WS_ADDTOKENATPOSITION_DESCKEY: "在某地生成token",
  T_40_XXJ_WS_ADDTOKENTOPLAYER_DESCKEY: "给玩家添加可拾取物",
  T_40_XXJ_WS_AFORWARD_DESCKEY: "玩家当前的朝向",
  T_40_XXJ_WS_AFORWARD_NAMEKEY: "朝向",
  T_40_XXJ_WS_AIREALATTACKENTITY_DESCKEY: "AI攻击实体",
  T_40_XXJ_WS_AITARGET_DESCKEY: "攻击者",
  T_40_XXJ_WS_ALIGNMENT_DESCKEY: "对齐方式",
  T_40_XXJ_WS_ALIGNMENT_NAMEKEY: "水平对齐",
  T_40_XXJ_WS_ALIGNMENTVERTICAL_NAMEKEY: "垂直对齐",
  T_40_XXJ_WS_ALPHA_DESCKEY: "透明度",
  T_40_XXJ_WS_AMMOINCLIP_DESCKEY: "当前余弹量",
  T_40_XXJ_WS_AMMOINCLIP_NAMEKEY: "当前余弹量",
  T_40_XXJ_WS_ANCHORMAX: "锚点最大值",
  T_40_XXJ_WS_ANCHORMIN: "锚点最小值",
  T_40_XXJ_WS_APOSITION_DESCKEY: "玩家当前的位置",
  T_40_XXJ_WS_APOSITION_NAMEKEY: "位置",
  T_40_XXJ_WS_ARMORHUD_NAMEKEY: "防具hud开关",
  T_40_XXJ_WS_ASSETCONFIGID_NAMEKEY: "资产配置ID",
  T_40_XXJ_WS_ASSETID_NAMEKEY: "资产ID",
  T_40_XXJ_WS_ATTACKENTITY_NAMEKEY: "攻击目标",
  T_40_XXJ_WS_ATTACKGRENADE_NAMEKEY: "攻击投掷物HUD开关",
  T_40_XXJ_WS_ATTACKTARGET_DESCKEY: "被AI攻击的对象",
  T_40_XXJ_WS_ATTACKTARGET_NAMEKEY: "被AI攻击的对象",
  T_40_XXJ_WS_AVAILABLEPOSVEC3_DESCKEY: "当前可分配的出生点点位坐标",
  T_40_XXJ_WS_AVAILABLEPOSVEC3_NAMEKEY: "可用点坐标",
  T_40_XXJ_WS_BACKGROUND_DESCKEY: "底图",
  T_40_XXJ_WS_BACKGROUND_NAMEKEY: "底图",
  T_40_XXJ_WS_BAGHUD_NAMEKEY: "背包hud开关",
  T_40_XXJ_WS_BGALPHA_NAMEKEY: "背景透明度",
  T_40_XXJ_WS_BGCOLOR_DESCKEY: "背景颜色",
  T_40_XXJ_WS_BGCOLOR_NAMEKEY: "背景颜色",
  T_40_XXJ_WS_BGFILL_DESCKEY: "是否进行背景填充",
  T_40_XXJ_WS_BGFILL_NAMEKEY: "背景填充",
  T_40_XXJ_WS_BGNAME_DESCKEY: "背景名称",
  T_40_XXJ_WS_BGNAME_NAMEKEY: "背景名称",
  T_40_XXJ_WS_BGSIZEDELTA_DESCKEY: "背景尺寸",
  T_40_XXJ_WS_BGSIZEDELTA_NAMEKEY: "背景尺寸",
  T_40_XXJ_WS_BLUE: "蓝色",
  T_40_XXJ_WS_BODY_DESCKEY: "躯干",
  T_40_XXJ_WS_BODY_NAMEKEY: "躯干",
  T_40_XXJ_WS_BONESCALE_NAMEKEY: "骨骼缩放",
  T_40_XXJ_WS_BORNPOSITIONVEC3_DESCKEY: "玩家的出生点",
  T_40_XXJ_WS_BORNPOSITIONVEC3_NAMEKEY: "出生点",
  T_40_XXJ_WS_BOTH: "男女皆可",
  T_40_XXJ_WS_BUTTONNAME: "按钮控件名",
  T_40_XXJ_WS_CAMERA_DESCKEY: "相机",
  T_40_XXJ_WS_CAMERADIR_DESCKEY: "客户端相机朝向",
  T_40_XXJ_WS_CAMERAPOS_DESCKEY: "客户端相机位置",
  T_40_XXJ_WS_CAMERARAYCASTHUD_DESCKEY: "客户端相机射线检测",
  T_40_XXJ_WS_CAMERARAYCASTHUD_NAMEKEY: "相机射线检测",
  T_40_XXJ_WS_CANCELDRAGIFFITS_DESCKEY: "当刚好合适视口时则退出拖拽",
  T_40_XXJ_WS_CANCELDRAGIFFITS_NAMEKEY: "当刚好合适视口时则退出拖拽",
  T_40_XXJ_WS_CAPSULEHEIGHT_DESCKEY: "胶囊体两端半球球心之间的距离，该值不小于球体两倍半径",
  T_40_XXJ_WS_CELLSIZE_DESCKEY: "子项格子的宽高 ",
  T_40_XXJ_WS_CELLSIZE_NAMEKEY: "子项格子宽高",
  T_40_XXJ_WS_CELLVALUE: "读取表某一单元格的内容，返回Object",
  T_40_XXJ_WS_CENTER_DESCKEY: "小地图中心对应的世界坐标，默认为0",
  T_40_XXJ_WS_CENTER_NAMEKEY: "小地图中心",
  T_40_XXJ_WS_CENTEROFFSET_DESCKEY: "按钮的位置偏移",
  T_40_XXJ_WS_CENTEROFFSET_NAMEKEY: "位置偏移",
  T_40_XXJ_WS_CENTEROFMASS_DESCKEY: "重心坐标，相对于本地坐标系",
  T_40_XXJ_WS_CENTEROFMASS_NAMEKEY: "重心坐标（相对于本地坐标系）",
  T_40_XXJ_WS_CENTRALLINEACTIVE_DESCKEY: "是否显示中间线",
  T_40_XXJ_WS_CENTRALLINEACTIVE_NAMEKEY: "是否显示中间线",
  T_40_XXJ_WS_CENTRALLINEPOS_DESCKEY: "中间线位置[0,1]",
  T_40_XXJ_WS_CENTRALLINEPOS_NAMEKEY: "中间线位置",
  T_40_XXJ_WS_CHASERANGE: "追击范围",
  T_40_XXJ_WS_CHASETARGET_DESCKEY: "被AI追击的对象",
  T_40_XXJ_WS_CHASETARGET_NAMEKEY: "被AI追击的对象",
  T_40_XXJ_WS_CHILD_DESCKEY: "子节点实体",
  T_40_XXJ_WS_CHILDINDEX_NAMEKEY: "在所属父节点的第几个孩子",
  T_40_XXJ_WS_CHITPOS_DESCKEY: "相机射线击中位置",
  T_40_XXJ_WS_CHOOSECARHUD: "选择卡牌HUD实体",
  T_40_XXJ_WS_CLAMP_DESCKEY: "如果参数位于最小数值和最大数值之间的数值范围内，则该函数将返回参数值；如果参数大于范围，该函数将返回最大数值；如果参数小于范围，该函数将返回最小数值",
  T_40_XXJ_WS_CLEARALLCHILDREN_DESCKEY: "仅支持具有Transform组件的实体，目前限制为所有物件",
  T_40_XXJ_WS_CLICKSIZE_DESCKEY: "点击区域大小",
  T_40_XXJ_WS_CLICKSIZE_NAMEKEY: "ClickSize",
  T_40_XXJ_WS_CLIPPINGTYPE_DESCKEY: "裁切类型",
  T_40_XXJ_WS_CLIPPINGTYPE_NAMEKEY: "裁切类型",
  T_40_XXJ_WS_CLONEENT_D: "克隆选中的实体及其属性，保持原父节点。如果选择的是LevelObject则基于CreateLevelObject",
  T_40_XXJ_WS_CLOTHES_DESCKEY: "服装列表",
  T_40_XXJ_WS_CLOTHID_DESCKEY: "服装ID",
  T_40_XXJ_WS_CLOTHID_NAMEKEY: "服装ID",
  T_40_XXJ_WS_CLOTHID1_DESCKEY: "服装ID",
  T_40_XXJ_WS_COL_DESC: "要读取的列",
  T_40_XXJ_WS_COLNAME_DESC: "要读取的列名",
  T_40_XXJ_WS_COLOR_DESCKEY: "颜色",
  T_40_XXJ_WS_COLOR_NAMEKEY: "颜色",
  T_40_XXJ_WS_COLOR1_DESCKEY: "叠加颜色，RGBA四通道，单通道取值范围0~255，存储在一个Int32中，默认为白色（255,255,255,255）",
  T_40_XXJ_WS_COLOR2_DESCKEY: "进度条颜色",
  T_40_XXJ_WS_COLOR3_DESCKEY: "描述RGBA颜色的类型，每个通道取值范围0~255",
  T_40_XXJ_WS_COLOR4_DESCKEY: "文本颜色",
  T_40_XXJ_WS_COLOR5_DESCKEY: "HUD颜色",
  T_40_XXJ_WS_COLOR6_DESCKEY: "光照颜色",
  T_40_XXJ_WS_COLORA_DESCKEY: "颜色的A值",
  T_40_XXJ_WS_COLORB_DESCKEY: "颜色的B值",
  T_40_XXJ_WS_COLORBAR_NAMEKEY: "进度条颜色",
  T_40_XXJ_WS_COLORDRUM_DESCKEY: "染色桶",
  T_40_XXJ_WS_COLORDRUM_NAMEKEY: "染色桶",
  T_40_XXJ_WS_COLORG_DESCKEY: "颜色的G值",
  T_40_XXJ_WS_COLORGETCHANNEL_DESCKEY: "取得颜色(RGBA)值通道",
  T_40_XXJ_WS_COLORGUN: "彩虹喷漆枪",
  T_40_XXJ_WS_COLORGUN_01: "彩虹喷漆枪（红）",
  T_40_XXJ_WS_COLORGUN_02: "彩虹喷漆枪（黄）",
  T_40_XXJ_WS_COLORGUN_03: "彩虹喷漆枪（蓝）",
  T_40_XXJ_WS_COLORGUN_04: "彩虹喷漆枪（绿）",
  T_40_XXJ_WS_COLORGUN_05: "彩虹喷漆枪（紫）",
  T_40_XXJ_WS_COLORR_DESCKEY: "颜色的R值",
  T_40_XXJ_WS_COLORTEXT_NAMEKEY: "文本颜色",
  T_40_XXJ_WS_COLVALUE: "表某一列的内容",
  T_40_XXJ_WS_COMMONHUDSWITCHCONTROLLER_DESCKEY: "通用HUD开关HUD实体",
  T_40_XXJ_WS_COMMONHUDSWITCHCONTROLLER_NAMEKEY: "通用HUD开关HUD实体",
  T_40_XXJ_WS_CONSTRAINT_DESCKEY: "限制 ",
  T_40_XXJ_WS_CONSTRAINT_NAMEKEY: "限制",
  T_40_XXJ_WS_CONSTRAINTCOUNT_DESCKEY: "限制数量",
  T_40_XXJ_WS_CONSTRAINTCOUNT_NAMEKEY: "限制数量",
  T_40_XXJ_WS_CONTENTORIGIN_DESCKEY: "初始方向",
  T_40_XXJ_WS_CONTENTORIGIN_NAMEKEY: "初始方向",
  T_40_XXJ_WS_CONTENTORIGIN2_DESCKEY: "滚动起点，默认为左上角",
  T_40_XXJ_WS_CREATEMAPBITENTITY_DESCKEY: "为某个物件在地图上生成像素图，生成像素为静态，不会跟随物件移动。",
  T_40_XXJ_WS_CREATEMAPICONENTITY_DESCKEY: "创建小地图图标",
  T_40_XXJ_WS_CREATETIMESTAMPLOCSTRING_DESCKEY: "定义一个时间戳本地化字符串",
  T_40_XXJ_WS_CREATEUIWIDGET_D: "在指定自定义HUD和指定父控件下创建自定义UI控件",
  T_40_XXJ_WS_CREEP_NAMEKEY: "爬行HUD开关",
  T_40_XXJ_WS_CROUCH_DESCKEY: "true时则显示，否则关闭",
  T_40_XXJ_WS_CROUCH_NAMEKEY: "蹲下HUD开关",
  T_40_XXJ_WS_CULLINGMASK_DESCKEY: "相机的渲染层遮罩，可以通过可见性层级筛选相机的渲染对象",
  T_40_XXJ_WS_CULLINGMASK_NAMEKEY: "渲染层遮罩",
  T_40_XXJ_WS_CUSTOMCLOTHCHESTID_DESCKEY: "上身ID",
  T_40_XXJ_WS_CUSTOMCLOTHCHESTID_NAMEKEY: "上身",
  T_40_XXJ_WS_CUSTOMCLOTHFACEID_DESCKEY: "妆容ID",
  T_40_XXJ_WS_CUSTOMCLOTHFEETID_DESCKEY: "鞋ID",
  T_40_XXJ_WS_CUSTOMCLOTHFEETID_NAMEKEY: "鞋",
  T_40_XXJ_WS_CUSTOMCLOTHHAIRID_DESCKEY: "头饰ID",
  T_40_XXJ_WS_CUSTOMCLOTHHAIRID_NAMEKEY: "头饰",
  T_40_XXJ_WS_CUSTOMCLOTHHEADADDITIVEID_DESCKEY: "脸饰ID",
  T_40_XXJ_WS_CUSTOMCLOTHHEADADDITIVEID_NAMEKEY: "脸饰",
  T_40_XXJ_WS_CUSTOMCLOTHLEGSID_DESCKEY: "下身ID",
  T_40_XXJ_WS_CUSTOMCLOTHLEGSID_NAMEKEY: "下身",
  T_40_XXJ_WS_CUSTOMCLOTHMAKEUP_NAMEKEY: "妆容",
  T_40_XXJ_WS_CUSTOMCLOTHSETID_DESCKEY: "套装ID",
  T_40_XXJ_WS_CUSTOMCLOTHSETID_NAMEKEY: "连体衣",
  T_40_XXJ_WS_CUSTOMXY_DESCKEY: "XY方向拖拽分量",
  T_40_XXJ_WS_CUSTOMXY_NAMEKEY: "XY拖拽量",
  T_40_XXJ_WS_DB: "读取数据库表值",
  T_40_XXJ_WS_DB_DESC: "读取数据库某个表中某个标识符对应的值",
  T_40_XXJ_WS_DBDELETE_DESC: "删除数据库某个表中某个标识符对应的值",
  T_40_XXJ_WS_DBKEY_DESCKEY: "用于标识数据的自定义名",
  T_40_XXJ_WS_DBKEY_NAMEKEY: "标识符",
  T_40_XXJ_WS_DBTABLENAME: "数据库表名",
  T_40_XXJ_WS_DBTABLENAME_DESC: "数据库中表名",
  T_40_XXJ_WS_DBVALUE_DESCKEY: "写入的值",
  T_40_XXJ_WS_DBWRITE: "写入数据库表值",
  T_40_XXJ_WS_DBWRITE_DESC: "写入数据库某个表中某个标识符对应的值",
  T_40_XXJ_WS_DEFENCEGRENADE_NAMEKEY: "防御投掷物HUD开关",
  T_40_XXJ_WS_DEFULT: "默认",
  T_40_XXJ_WS_DELETELEADERBOARD_DESC: "删除数据库某个排行榜表中某个Key对应的值",
  T_40_XXJ_WS_DELETELEADERBOARD2_DESC: "删除数据库某个排行榜表中某个名次对应的值",
  T_40_XXJ_WS_DEPTH: "HUD层级",
  T_40_XXJ_WS_DEPTH_D: "Hud的基础层级",
  T_40_XXJ_WS_DICTANDLIST: "列表和字典",
  T_40_XXJ_WS_DICVALUE_DESCKEY: "目标字典的值",
  T_40_XXJ_WS_DIFFUSEALPHA_DESCKEY: "表面透明度",
  T_40_XXJ_WS_DIR_DESCKEY: "向量",
  T_40_XXJ_WS_DIRECTPOSVEC3_DESCKEY: "提供的点，可用于复活点等用途",
  T_40_XXJ_WS_DIRECTPOSVEC3_NAMEKEY: "点坐标",
  T_40_XXJ_WS_DISABLEALL: "全部取消勾选",
  T_40_XXJ_WS_DISABLECOLOR_NAMEKEY: "禁用色",
  T_40_XXJ_WS_DISTANT_DESCKEY: "相机射线检测的距离",
  T_40_XXJ_WS_DISTANT_NAMEKEY: "射线距离",
  T_40_XXJ_WS_DRAGEFFECT_DESCKEY: "支持多种拖动效果",
  T_40_XXJ_WS_DRAGEFFECT_NAMEKEY: "拖动效果",
  T_40_XXJ_WS_DRIVER_DESCKEY: "载具驾驶者",
  T_40_XXJ_WS_DRIVER_NAMEKEY: "驾驶者",
  T_40_XXJ_WS_EDITVALUE_DESCKEY: "修改值",
  T_40_XXJ_WS_EFFECTACTIVE_DESCKEY: "显示特效",
  T_40_XXJ_WS_EFFECTACTIVE_NAMEKEY: "显示特效",
  T_40_XXJ_WS_EFFECTCOLOR_NAMEKEY: "特效颜色",
  T_40_XXJ_WS_EFFECTENTITY_DESCKEY: "特效实体表示一个显示的特效",
  T_40_XXJ_WS_EFFECTENTITYGENERATOR_DESCKEY: "特效物件",
  T_40_XXJ_WS_EMOTIONHUD_NAMEKEY: "表情hud开关",
  T_40_XXJ_WS_ENABLEALL: "全部勾选",
  T_40_XXJ_WS_ENABLELOGIC_DESCKEY: "是否开启逻辑更新，关闭时，该实体上的图元会停止每帧更新",
  T_40_XXJ_WS_ENABLEWEAPONSKINPROP_DESCKEY: "写入枪皮对武器的属性时，武器的基本值会受枪皮影响",
  T_40_XXJ_WS_ENABLEWEAPONSKINPROP_NAMEKEY: "写入枪皮属性",
  T_40_XXJ_WS_ENTITY_DESCKEY: "实体是所有组件的载体，组件必须附加到实体上才能产生实例",
  T_40_XXJ_WS_ENTITY_NAMEKEY: "实体类",
  T_40_XXJ_WS_ENTITY1_DESCKEY: "实体基础组件，所有组件都会组合该组件",
  T_40_XXJ_WS_ENTITYVARNAME_DESCKEY: "玩家变身的对象",
  T_40_XXJ_WS_ENTITYVARNAME11_DESCKEY: "代码中是用来表示新增自定义UI控件实体的形参名称，其对应的局部变量值是新增自定义UI控件的实体",
  T_40_XXJ_WS_ENTITYVARNAME12_DESCKEY: "实体变量名",
  T_40_XXJ_WS_ENTITYVARNAME13_DESCKEY: "代码中是用来表示创建图标实体的形参名称，其对应的局部变量值是创建图标的实体",
  T_40_XXJ_WS_EPITEMHUD_NAMEKEY: "EP hud开关",
  T_40_XXJ_WS_EULERANGLES_DESCKEY: "旋转欧拉角",
  T_40_XXJ_WS_FACINFECTION: "阵营（感染模式）",
  T_40_XXJ_WS_FACINFECTION_DESC: "玩家的阵营，1 人类，2 僵尸",
  T_40_XXJ_WS_FEMALE: "女",
  T_40_XXJ_WS_FILLDIRECTION_DESCKEY: "排列方向 ",
  T_40_XXJ_WS_FILLDIRECTION_NAMEKEY: "排列方向",
  T_40_XXJ_WS_FIRE_NAMEKEY: "开火HUD开关",
  T_40_XXJ_WS_FLOATVALUE_DESCKEY: "FloatValue",
  T_40_XXJ_WS_FOLLOWTARGET_DESCKEY: "跟随的目标实体，默认为空",
  T_40_XXJ_WS_FONTSIZE_DESCKEY: "相对位置",
  T_40_XXJ_WS_FONTSIZE_NAMEKEY: "字体大小",
  T_40_XXJ_WS_FONTSTYLE_DESCKEY: "字体风格",
  T_40_XXJ_WS_FOOTBALLGLOOWALL: "足球凝胶护盾",
  T_40_XXJ_WS_FORMATSTYLE_DESCKEY: "格式化样式",
  T_40_XXJ_WS_FORWARD_DESCKEY: "玩家的朝向",
  T_40_XXJ_WS_FORWARD1_DESCKEY: "被传送的朝向",
  T_40_XXJ_WS_FREE_DESCKEY: "由玩家控制，自由移动的相机",
  T_40_XXJ_WS_FREE_NAMEKEY: "自由相机",
  T_40_XXJ_WS_GENDER: "性别",
  T_40_XXJ_WS_GENDER_DESCKEY: "性別",
  T_40_XXJ_WS_GENDERTYPE_DESCKEY: "性别枚举",
  T_40_XXJ_WS_GETCAMERACULLINGMASK_DESCKEY: "获取相机CullingMask",
  T_40_XXJ_WS_GETCHILDBYINDEX_DESCKEY: "仅支持具有Transform组件的实体，目前限制为所有物件",
  T_40_XXJ_WS_GETCHILDREN_DESCKEY: "仅支持具有Transform组件的实体，目前限制为所有物件",
  T_40_XXJ_WS_GETPARENT_DESCKEY: "仅支持具有Transform组件的实体，目前限制为所有物件",
  T_40_XXJ_WS_GETPLAYERCLOTHIDBYWARDROBETYPE_DESCKEY: "获取玩家服装ID",
  T_40_XXJ_WS_GETPLAYERRANK: "获取玩家排名",
  T_40_XXJ_WS_GETPLAYERRANK_D: "获取玩家游戏总排名",
  T_40_XXJ_WS_GETPLAYERROUNDRANK: "获取玩家回合排名",
  T_40_XXJ_WS_GETPLAYERROUNDRANK_D: "获取玩家指定回合排名 ",
  T_40_XXJ_WS_GETPLAYERTOKENNUM_DESCKEY: "查找玩家token数据",
  T_40_XXJ_WS_GETPLAYERWEAPONSKINIDBYWEAPONID_DESCKEY: "获取玩家枪皮",
  T_40_XXJ_WS_GETRANDOMSPAWNPOSVEC3_DESCKEY: "获取当前可用没有完全占满的随机出生点内可用坐标",
  T_40_XXJ_WS_GETSCENESKYBOX_DESCKEY: "获取场景的天空盒",
  T_40_XXJ_WS_GETSERVERREGION_DESCKEY: "获取服务器区域",
  T_40_XXJ_WS_GETSERVERTIME_DESCKEY: "获取服务器时间戳",
  T_40_XXJ_WS_GETTEAMMATENEARPOSVEC3_DESCKEY: "获得队友附近位置，会规避开无法站立玩家的位置",
  T_40_XXJ_WS_GETTEAMRANK: "获取队伍排名",
  T_40_XXJ_WS_GETTEAMRANK_D: "获取队伍游戏总排名",
  T_40_XXJ_WS_GETTEAMROUNDRANK: "获取队伍回合排名 ",
  T_40_XXJ_WS_GETTEAMROUNDRANK_D: "获取队伍指定回合排名 ",
  T_40_XXJ_WS_GREEN: "绿色",
  T_40_XXJ_WS_HALFEXTENTS_DESCKEY: "盒型三条边尺寸的一半",
  T_40_XXJ_WS_HEAD_DESCKEY: "头部",
  T_40_XXJ_WS_HEAD_NAMEKEY: "头部",
  T_40_XXJ_WS_HEARTBEATEFFECTHUD_DESCKEY: "屏幕心跳特效实体",
  T_40_XXJ_WS_HEARTBEATEFFECTHUD_NAMEKEY: "屏幕心跳特效实体",
  T_40_XXJ_WS_HEIGHT_DESCKEY: "高度",
  T_40_XXJ_WS_HINTBUTTONHUD_DESCKEY: "提示按钮",
  T_40_XXJ_WS_HINTBUTTONHUD_NAMEKEY: "提示按钮",
  T_40_XXJ_WS_HITPOINTEFFECT_DESCKEY: "目标点显示的对象",
  T_40_XXJ_WS_HITPOINTEFFECT_NAMEKEY: "目标点对象",
  T_40_XXJ_WS_HITPOS_DESCKEY: "命中点",
  T_40_XXJ_WS_HORIZONTALBAR_DESCKEY: "水平显示类型",
  T_40_XXJ_WS_HORIZONTALBAR_NAMEKEY: "水平显示类型",
  T_40_XXJ_WS_HOSTENTITYFOLLOW_DESCKEY: "跟随其他对象的实体",
  T_40_XXJ_WS_HOSTENTITYLOOK_DESCKEY: "注视其他对象的实体",
  T_40_XXJ_WS_HPITEMHUD_NAMEKEY: "血条hud开关",
  T_40_XXJ_WS_HUDEMPTYPANEL_DESCKEY: "Hud输入实体，玩家通过Hud编辑器编辑的Hud",
  T_40_XXJ_WS_HUDEMPTYPANEL_NAMEKEY: "HudEmptyPanel实体组件",
  T_40_XXJ_WS_HUDENTITY_DESCKEY: "所属Hud实体",
  T_40_XXJ_WS_HUDGRID_DESCKEY: "Hud输入实体，玩家通过Hud编辑器编辑的Hud",
  T_40_XXJ_WS_HUDGRID_NAMEKEY: "网格实体组件",
  T_40_XXJ_WS_HUDPANEL_DESCKEY: "Hud输入实体，玩家通过Hud编辑器编辑的Hud",
  T_40_XXJ_WS_HUDPANEL_NAMEKEY: "面板实体组件",
  T_40_XXJ_WS_HUDSCROLLVIEW_DESCKEY: "Hud输入实体，玩家通过Hud编辑器编辑的Hud",
  T_40_XXJ_WS_HUDSCROLLVIEW_NAMEKEY: "滚动视图实体组件",
  T_40_XXJ_WS_HUMANMODELID_NAMEKEY: "人形模型ID",
  T_40_XXJ_WS_ICON_DESCKEY: "图标资源名",
  T_40_XXJ_WS_ICON_NAMEKEY: "图标",
  T_40_XXJ_WS_ICON1_DESCKEY: "选择图标",
  T_40_XXJ_WS_ICONENTITY_DESCKEY: "图标实体表示一个显示的图标",
  T_40_XXJ_WS_ICONPATH_DESCKEY: "资源路径, 内置资源in:path, 自定义资源out:path, 默认为空",
  T_40_XXJ_WS_ICONSPRITENAME_DESCKEY: "图标名称",
  T_40_XXJ_WS_ICONSPRITENAME_NAMEKEY: "图标名称",
  T_40_XXJ_WS_ICONTYPE_DESCKEY: "资源路径, 默认为空",
  T_40_XXJ_WS_INCLUDETRIGGER_DESCKEY: "是否可以扫描出触发器",
  T_40_XXJ_WS_INDEX_DESCKEY: "子节点在父节点下的索引",
  T_40_XXJ_WS_INITIALVALUE_NAMEKEY: "初始值[0, 1](瞬切)",
  T_40_XXJ_WS_INTVALUE_DESCKEY: "IntValue",
  T_40_XXJ_WS_IS3D: "3D音效",
  T_40_XXJ_WS_ISBILLBOARD_DESCKEY: "总是面向摄像机",
  T_40_XXJ_WS_ISBOLD_NAMEKEY: "加粗",
  T_40_XXJ_WS_ISBYORDER_D: "检测玩家是否按顺序触发levelobeject",
  T_40_XXJ_WS_ISFEBUTTON_NAMEKEY: "是否是FE的按钮",
  T_40_XXJ_WS_ISHIT_DESCKEY: "相机射线是否击中对象",
  T_40_XXJ_WS_ISINCULLINGMASK_DESCKEY: "是否对某层可见",
  T_40_XXJ_WS_ISITALIC_NAMEKEY: "斜体",
  T_40_XXJ_WS_ISSHOWSCAN_DESCKEY: "是否被扫描标记",
  T_40_XXJ_WS_ISSHOWSCAN_NAMECKEY: "是否被扫描标记",
  T_40_XXJ_WS_ISSHOWTAG_DESCKEY: "是否被标记按钮标记",
  T_40_XXJ_WS_ISTRIGGER: "是否是触发器",
  T_40_XXJ_WS_ISUNDERLINE_NAMEKEY: "下划线",
  T_40_XXJ_WS_ITEMID_DESCKEY: "实体对应的itemID",
  T_40_XXJ_WS_ITEMID_NAMEKEY: "道具ID",
  T_40_XXJ_WS_ITEMID1_DESCKEY: "道具ID(当版本只有武器ID)",
  T_40_XXJ_WS_ITEMID2_DESCKEY: "武器对应的道具id",
  T_40_XXJ_WS_ITEMID3_DESCKEY: "道具ID",
  T_40_XXJ_WS_JAILBREAKAREA_DESCKEY: "JailBreakArea",
  T_40_XXJ_WS_JAILBREAKAREA_NAMEKEY: "JailBreakArea",
  T_40_XXJ_WS_JUMP_NAMEKEY: "跳HUD开关",
  T_40_XXJ_WS_KEY_DESCKEY: "键值",
  T_40_XXJ_WS_KEY_NAMEKEY: "键",
  T_40_XXJ_WS_KEYNAME_DESCKEY: "遍历到键的名称，可以使用它获取到局部变量上的键值",
  T_40_XXJ_WS_KILLINGTIPS_NAMEKEY: "击杀提示hud开关",
  T_40_XXJ_WS_LABELCOLOR_NAMEKEY: "文本颜色",
  T_40_XXJ_WS_LANDMINEOBJ: "地雷创建后的对象",
  T_40_XXJ_WS_LAYERMASK_DESCKEY: "碰撞层级蒙版，未选择的层级将不参与扫描，留空表示所有层级都参与扫描",
  T_40_XXJ_WS_LAYERSEDIT: "层级管理",
  T_40_XXJ_WS_LAYERSETTING: "可见性层级设置",
  T_40_XXJ_WS_LAYERTYPE_DESCKEY: "相机射线检测的碰撞层遮罩",
  T_40_XXJ_WS_LAYERTYPE_NAMEKEY: "层级",
  T_40_XXJ_WS_LAYOUTTYPE_DESCKEY: "布局类型",
  T_40_XXJ_WS_LAYOUTTYPE_NAMEKEY: "布局类型",
  T_40_XXJ_WS_LEADERBOARDBUTTONHUD: "打开计分板按钮hud组件",
  T_40_XXJ_WS_LEADERBOARDBUTTONHUD_D: "打开计分板按钮hud实体，修改实体属性则影响对应UI上的显示内容",
  T_40_XXJ_WS_LEADERBOARDNAME: "排行榜表名",
  T_40_XXJ_WS_LEADERBOARDNAME_DESC: "数据库中排行榜表名",
  T_40_XXJ_WS_LEAVEACCELERATION_DESCKEY: "离开荡摆的加速度",
  T_40_XXJ_WS_LEAVEACCELERATION_NAMEKEY: "离开荡摆的加速度",
  T_40_XXJ_WS_LEFTARM_DESCKEY: "左臂",
  T_40_XXJ_WS_LEFTARM_NAMEKEY: "左臂",
  T_40_XXJ_WS_LEFTCOLOR_DESCKEY: "左边颜色",
  T_40_XXJ_WS_LEFTCOLOR_NAMEKEY: "左侧颜色",
  T_40_XXJ_WS_LEFTEFFECTACTIVE_DESCKEY: "是否显示左侧特效",
  T_40_XXJ_WS_LEFTEFFECTACTIVE_NAMEKEY: "是否显示左侧特效",
  T_40_XXJ_WS_LEFTFOOT_DESCKEY: "左脚",
  T_40_XXJ_WS_LEFTFOOT_NAMEKEY: "左脚",
  T_40_XXJ_WS_LEFTHAND_DESCKEY: "左手",
  T_40_XXJ_WS_LEFTHAND_NAMEKEY: "左手",
  T_40_XXJ_WS_LEFTICON_DESCKEY: "左侧图标",
  T_40_XXJ_WS_LEFTICON_NAMEKEY: "左侧图标",
  T_40_XXJ_WS_LEFTLEG_DESCKEY: "左腿",
  T_40_XXJ_WS_LEFTLEG_NAMEKEY: "左腿",
  T_40_XXJ_WS_LEFTSCORETEXT_DESCKEY: "左侧得分文本",
  T_40_XXJ_WS_LEFTSCORETEXT_NAMEKEY: "左侧得分文本",
  T_40_XXJ_WS_LEFTTEXT_DESCKEY: "左侧文本",
  T_40_XXJ_WS_LEFTTEXT_NAMEKEY: "左侧文本",
  T_40_XXJ_WS_LERP_DESCKEY: "t是夹在0到1之间。当t=0时，返回from。当t=1时，返回to。当t=0.5时放回from和to之间的平均数",
  T_40_XXJ_WS_LEVELOBJECT: "关卡物件",
  T_40_XXJ_WS_LINESPACING_NAMEKEY: "行间距",
  T_40_XXJ_WS_LISTFINDMAX_DESCKEY: "比较列表中的值，返回其中最大的那个",
  T_40_XXJ_WS_LISTFINDMIN_DESCKEY: "比较列表中的值，返回其中最小的那个",
  T_40_XXJ_WS_LISTORMAP_NAMEKEY: "列表或字典",
  T_40_XXJ_WS_LOCALPOSITION: "本地位置",
  T_40_XXJ_WS_LOCALROTA: "本地旋转欧拉角",
  T_40_XXJ_WS_LOCALROTATIONQ: "本地旋转四元数",
  T_40_XXJ_WS_LOCALSACLE: "本地缩放",
  T_40_XXJ_WS_LOCSWITCH_NAMEKEY: "本地化开关",
  T_40_XXJ_WS_LOOPRANGE_DESCKEY: "要遍历的容器",
  T_40_XXJ_WS_MALE: "男",
  T_40_XXJ_WS_MAPCLEAR_DESCKEY: "清除字典",
  T_40_XXJ_WS_MAPGETLENGTH_DESCKEY: "获得Map长度",
  T_40_XXJ_WS_MAPGETVALUE_DESCKEY: "获取字典元素中指定键的值",
  T_40_XXJ_WS_MAPREMOVEVALUE_DESCKEY: "移除字典指定键值对",
  T_40_XXJ_WS_MAPSETVALUE_DESCKEY: "设置字典中指定键的值",
  T_40_XXJ_WS_MAPSIZE_DESCKEY: "小地图尺寸大小，宽高相同",
  T_40_XXJ_WS_MAPSIZE_NAMEKEY: "地图尺寸大小",
  T_40_XXJ_WS_MAPT: "字典模板",
  T_40_XXJ_WS_MAPT_D: "字典数据模板，可通过T1、T2指定内容的类型",
  T_40_XXJ_WS_MAPVALUE_D: "字典数据容器，数据元素是一对Key、Value",
  T_40_XXJ_WS_MAPVALUE_DESCKEY: "目标字典",
  T_40_XXJ_WS_MAPVALUE_NAMEKEY: "字典",
  T_40_XXJ_WS_MASKNAME_DESCKEY: "遮罩类型是遮罩时选用的图片名称",
  T_40_XXJ_WS_MASKNAME_NAMEKEY: "遮罩类型",
  T_40_XXJ_WS_MASS_DESCKEY: "质量(kg)",
  T_40_XXJ_WS_MASS_NAMEKEY: "质量(kg)",
  T_40_XXJ_WS_MAX_DESCKEY: "比较2个数的值，返回其中最大的那个",
  T_40_XXJ_WS_MAXLENGTH_NAMEKEY: "最大长度",
  T_40_XXJ_WS_MAXNUM_DESCKEY: "最大值",
  T_40_XXJ_WS_MAXWIDGETID_DESCKEY: "当前最大控件ID",
  T_40_XXJ_WS_MAXWIDGETID_NAMEKEY: "当前最大WidgetID",
  T_40_XXJ_WS_MEDICALPROPSHUD_NAMEKEY: "医疗道具hud开关",
  T_40_XXJ_WS_MIN_DESCKEY: "比较2个数的值，返回其中最小的那个",
  T_40_XXJ_WS_MINIMAP_NAMEKEY: "小地图实体组件",
  T_40_XXJ_WS_MINIMAPBIT_NAMEKEY: "小地图像素实体组件",
  T_40_XXJ_WS_MINIMAPICON_NAMEKEY: "小地图Icon实体组件",
  T_40_XXJ_WS_MINMAPHUD_NAMEKEY: "小地图hud开关",
  T_40_XXJ_WS_MINNUM_DESCKEY: "最小值",
  T_40_XXJ_WS_MOMENTUMAMOUNT_DESCKEY: "惯性因子，值越大滚动时惯性越大",
  T_40_XXJ_WS_MOMENTUMAMOUNT_NAMEKEY: "惯性因子",
  T_40_XXJ_WS_MOVINGJOYSTICK_NAMEKEY: "移动摇杆HUD开关",
  T_40_XXJ_WS_MRESULT_DESCKEY: "比赛结果",
  T_40_XXJ_WS_NEWENTITY_D: "使用后创建的新道具实体(可能为空)",
  T_40_XXJ_WS_NEWMAP_DESCKEY: "构造新字典",
  T_40_XXJ_WS_NEWMAP_NAMEKEY: "构造新字典",
  T_40_XXJ_WS_NORMAL1_DESCKEY: "命中法线",
  T_40_XXJ_WS_NORMALIZEDPOSITION_DESCKEY: "HUD位置[0,1]",
  T_40_XXJ_WS_NORMALIZEDPOSITION_NAMEKEY: "HUD位置",
  T_40_XXJ_WS_NUMLIST_DESCKEY: "应当传入元素为数字的列表",
  T_40_XXJ_WS_OBJECT_DESCKEY: "喷漆枪命中的物件",
  T_40_XXJ_WS_OBSOLETE: "已废弃，为保险起见请替换该图元",
  T_40_XXJ_WS_OFFSET_DESCKEY: "显示位置,当有跟随目标时是相对目标原点的偏移,当没有跟随目标时是屏幕坐标,默认为Vector3(0)",
  T_40_XXJ_WS_OFFSET2_DESCKEY: "屏幕坐标,默认为Vector3(0)",
  T_40_XXJ_WS_OFFSET3_DESCKEY: "显示位置，当有跟随目标时是相对目标原点的偏移，当没有跟随目标时是世界坐标，默认为Vector3(0)",
  T_40_XXJ_WS_OFFSET4_DESCKEY: "显示位置(锚点为右上角）",
  T_40_XXJ_WS_OFFSETLEFTRIGHT_DESCKEY: "水平偏移量",
  T_40_XXJ_WS_OFFSETLEFTRIGHT_NAMEKEY: "水平方向偏移量",
  T_40_XXJ_WS_OFFSETUPDOWN_DESCKEY: "垂直偏移量",
  T_40_XXJ_WS_OFFSETUPDOWN_NAMEKEY: "垂直方向偏移量",
  T_40_XXJ_WS_OK_DESCKEY: "转化成功",
  T_40_XXJ_WS_ONAISTARTATTACK_DESCKEY: "当对象进入攻击范围时触发该事件",
  T_40_XXJ_WS_ONAISTARTCHASE_DESCKEY: "当对象进入追击范围时触发该事件",
  T_40_XXJ_WS_ONAISTOPATTACK_DESCKEY: "当对象离开攻击范围时触发该事件",
  T_40_XXJ_WS_ONAISTOPCHASE_DESCKEY: "当对象离开追击范围时触发该事件",
  T_40_XXJ_WS_ONCLIENTCAMERARAYCAST_DESCKEY: "通过客户端点击事件触发相机射线检测",
  T_40_XXJ_WS_ONCOLLISION_D: "只有挂载了Collider组件的实体支持该事件",
  T_40_XXJ_WS_ONSPRAYENTITY_DESCKEY: "当喷漆枪命中对象时触发该事件",
  T_40_XXJ_WS_ONSTOPFIRE_DESCKEY: "停止开火时",
  T_40_XXJ_WS_ONSWITCHPLAYERAREA_DESCKEY: "玩家切换场景区域时",
  T_40_XXJ_WS_OPENSTATE_DESCKEY: "打开状态为true时则显示，否则关闭",
  T_40_XXJ_WS_OPENSTATE_NAMEKEY: "打开状态",
  T_40_XXJ_WS_ORANGE: "橙色",
  T_40_XXJ_WS_ORDER_DESC: "排行榜中的名次",
  T_40_XXJ_WS_ORDER1: "起始名次",
  T_40_XXJ_WS_ORDER2: "结束名次",
  T_40_XXJ_WS_ORIGINAL: "保持原逻辑",
  T_40_XXJ_WS_OVERFLOW_NAMEKEY: "溢出方式",
  T_40_XXJ_WS_OVERLOADPLAYERWEAPONSKIN_DESCKEY: "玩家配置优先时，玩家身上的枪皮配置会覆盖武器本身的枪皮属性",
  T_40_XXJ_WS_OVERLOADPLAYERWEAPONSKIN_NAMEKEY: "玩家枪皮优先",
  T_40_XXJ_WS_OWNER_DESCKEY: "拥有该实体的玩家",
  T_40_XXJ_WS_OWNERSUBLEVELGUID_DESCKEY: "所属的子场景GUID",
  T_40_XXJ_WS_OWNERSUBLEVELGUID_NAMEKEY: "所属的子场景GUID",
  T_40_XXJ_WS_PARENT_DESCKEY: "父节点实体",
  T_40_XXJ_WS_PARENT_NAMEKEY: "父节点",
  T_40_XXJ_WS_PARENTENTITYID_NAMEKEY: "父节点控件EntityID",
  T_40_XXJ_WS_PARENTWIDGETFILEID_DESCKEY: "父节点控件FileID",
  T_40_XXJ_WS_PASSENGERS_DESCKEY: "载具上所有乘客",
  T_40_XXJ_WS_PASSENGERS_NAMEKEY: "乘客",
  T_40_XXJ_WS_PHYSICALLAYER: "物理层级",
  T_40_XXJ_WS_PHYSICALLAYERMATRIX: "物理层级矩阵",
  T_40_XXJ_WS_PHYSICALTIP1: "重复命名",
  T_40_XXJ_WS_PHYSICALTIP2: "删除某层级名，在物理层级矩阵、层级枚举中不可见该层级，但该层级中的实体对象不会改变",
  T_40_XXJ_WS_PHYSICS: "物理",
  T_40_XXJ_WS_PICKUPLISTHUD_NAMEKEY: "拾取列表hud开关",
  T_40_XXJ_WS_PLAYABLE_DESCKEY: "可播放实体",
  T_40_XXJ_WS_PLAYABLELOOKAT_DESCKEY: "一对象的正面始终朝向另一对象",
  T_40_XXJ_WS_PLAYABLEPOSFOLLOW_DESCKEY: "一对象跟着另一对象",
  T_40_XXJ_WS_PLAYABLETRAJECTORY_DESCKEY: "弹道动画是对弹道运动的模拟动画",
  T_40_XXJ_WS_PLAYER1_DESCKEY: "接收消息的玩家",
  T_40_XXJ_WS_PLAYERAVATAR_DESCKEY: "玩家绑定的AVATAR",
  T_40_XXJ_WS_PLAYERAVATARINFO_DESCKEY: "玩家装备的服饰",
  T_40_XXJ_WS_PLAYERAVATARINFO_NAMEKEY: "玩家服饰",
  T_40_XXJ_WS_PLAYERHUDSWITCHTYPE_DESCKEY: "玩家界面类型",
  T_40_XXJ_WS_PLAYERHUDSWITCHTYPE_NAMEKEY: "玩家界面类型",
  T_40_XXJ_WS_PLAYERIDINFAC: "玩家在阵营中的序号",
  T_40_XXJ_WS_PLAYERLOG_DESCKEY: "要记录上报的玩家",
  T_40_XXJ_WS_PLAYERREMOVETOKEN_DESCKEY: "消耗某玩家token",
  T_40_XXJ_WS_PLAYERSKILLS_DESCKEY: "玩家技能列表",
  T_40_XXJ_WS_PLAYERSTATETYPE_DESCKEY: "玩家状态类型，活跃、击倒、死亡",
  T_40_XXJ_WS_PLAYSPEED_DESCKEY: "播放速度",
  T_40_XXJ_WS_PLAYSPEED_NAMEKEY: "播放速度",
  T_40_XXJ_WS_PLAYSPEED1_DESCKEY: "例如1.25表示正常速度的1.25倍",
  T_40_XXJ_WS_POS_DESCKEY: "被传送点的坐标",
  T_40_XXJ_WS_PRESENTEFFECTTEXTYPE_DESCKEY: "特效贴图类型",
  T_40_XXJ_WS_PRESSEDCOLOR_NAMEKEY: "按压色",
  T_40_XXJ_WS_PROCESSCTLFORLOOPRANGE_DESCKEY: "实现对一个容器的遍历，获取到每一对键值对，含有子过程，循环体就是子过程",
  T_40_XXJ_WS_PROCESSCTLFORLOOPRANGE_NAMEKEY: "字典循环访问",
  T_40_XXJ_WS_PROGRESS_DESCKEY: "进度[0,1]",
  T_40_XXJ_WS_PROGRESS_NAMEKEY: "进度[0,1]",
  T_40_XXJ_WS_PROGRESSSKILLBUTTONHUD_DESCKEY: "进度技能按钮",
  T_40_XXJ_WS_PROGRESSSKILLBUTTONHUD_NAMEKEY: "进度技能按钮",
  T_40_XXJ_WS_QUATERNION: "旋转四元数",
  T_40_XXJ_WS_QUICKCHATHUD_NAMEKEY: "快速短语hud开关",
  T_40_XXJ_WS_QUICKCHATSHOWHUD_NAMEKEY: "队伍列表旁message hud开关",
  T_40_XXJ_WS_RADIUS_DESCKEY: "胶囊体两端半球的半径",
  T_40_XXJ_WS_READCELL: "读取表某一单元格的内容",
  T_40_XXJ_WS_READCSV: "读取表内容",
  T_40_XXJ_WS_READCSV_DESC: "读取整张表的内容，返回二维数组",
  T_40_XXJ_WS_READCSVCELL: "通过行数和列名读取表某一单元格的内容",
  T_40_XXJ_WS_READCSVCOL_DESC: "读取整张表某一列的内容，返回数组",
  T_40_XXJ_WS_READCSVROW_DESC: "读取整张表的某一行内容，返回数组",
  T_40_XXJ_WS_READLEADERBOARD: "读取数据库中排行榜表值",
  T_40_XXJ_WS_READLEADERBOARD_DESC: "读取数据库中个排行榜表中某个标识符对应的值",
  T_40_XXJ_WS_READLEADERBOARD2: "根据名次区间读取数据库中排行榜表值",
  T_40_XXJ_WS_READLEADERBOARD2_DESC: "读取数据库某个排行榜表中从某名次到某名次之间的值",
  T_40_XXJ_WS_RED: "红色",
  T_40_XXJ_WS_RELOAD: "换弹",
  T_40_XXJ_WS_RENDERTYPE_DESCKEY: "显示方式",
  T_40_XXJ_WS_RESETPLAYERCLOTHES_DESCKEY: "恢复玩家默认服装",
  T_40_XXJ_WS_RESETPLAYERWEAPONSKINBYWEAPONID_DESCKEY: "恢复玩家默认枪皮",
  T_40_XXJ_WS_RESTRICTWITHINPANEL_DESCKEY: "拖拽是否被限制在视口内，默认选中",
  T_40_XXJ_WS_RESTRICTWITHINPANEL_NAMEKEY: "是否限制拖拽",
  T_40_XXJ_WS_RESULT_DESCKEY: "返回读取的结果",
  T_40_XXJ_WS_RESULT_NAMEKEY: "结果",
  T_40_XXJ_WS_RESULT1_DESCKEY: "是否在列表中找到最大数字",
  T_40_XXJ_WS_RESULT2_DESCKEY: "是否在列表中找到最小数字",
  T_40_XXJ_WS_RESULTVALUE_DESCKEY: "列表中找到最小数字",
  T_40_XXJ_WS_RESULTVALUE1_DESCKEY: "列表中找到最大数字",
  T_40_XXJ_WS_REVIVEPOSITIONVEC3_DESCKEY: "玩家的复活点，如果没有检查点记录则使用出生点，否则使用检查点",
  T_40_XXJ_WS_REVIVEPOSITIONVEC3_NAMEKEY: "复活点",
  T_40_XXJ_WS_RIGHTARM_DESCKEY: "右臂",
  T_40_XXJ_WS_RIGHTARM_NAMEKEY: "右臂",
  T_40_XXJ_WS_RIGHTCOLOR_DESCKEY: "右边颜色",
  T_40_XXJ_WS_RIGHTCOLOR_NAMEKEY: "右侧颜色",
  T_40_XXJ_WS_RIGHTEFFECTACTIVE_DESCKEY: "是否显示右侧特效",
  T_40_XXJ_WS_RIGHTEFFECTACTIVE_NAMEKEY: "是否显示右侧特效",
  T_40_XXJ_WS_RIGHTFOOT_DESCKEY: "右脚",
  T_40_XXJ_WS_RIGHTFOOT_NAMEKEY: "右脚",
  T_40_XXJ_WS_RIGHTHAND_DESCKEY: "右手",
  T_40_XXJ_WS_RIGHTHAND_NAMEKEY: "右手",
  T_40_XXJ_WS_RIGHTICON_DESCKEY: "右侧图标",
  T_40_XXJ_WS_RIGHTICON_NAMEKEY: "右侧图标",
  T_40_XXJ_WS_RIGHTLEG_DESCKEY: "右腿",
  T_40_XXJ_WS_RIGHTLEG_NAMEKEY: "右腿",
  T_40_XXJ_WS_RIGHTSCORETEXT_DESCKEY: "右侧得分文本",
  T_40_XXJ_WS_RIGHTSCORETEXT_NAMEKEY: "右侧得分文本",
  T_40_XXJ_WS_RIGHTTEXT_DESCKEY: "右侧文本",
  T_40_XXJ_WS_RIGHTTEXT_NAMEKEY: "右侧文本",
  T_40_XXJ_WS_RIGIDBODY_DESCKEY: "刚体组件",
  T_40_XXJ_WS_RIGIDBODY_NAMEKEY: "刚体组件",
  T_40_XXJ_WS_RIGIDBODYTYPE_DESCKEY: "刚体类型枚举",
  T_40_XXJ_WS_RIGIDBODYTYPE_NAMEKEY: "刚体类型枚举",
  T_40_XXJ_WS_ROW_DECS: "要读取的行数",
  T_40_XXJ_WS_ROWVALUE: "表某一行的内容",
  T_40_XXJ_WS_SCALE_DESCKEY: "设置物件缩放值",
  T_40_XXJ_WS_SCALE_NAMEKEY: "缩放值",
  T_40_XXJ_WS_SCALE0_DESCKEY: "世界坐标系中缩放尺寸",
  T_40_XXJ_WS_SCALE1_DESCKEY: "缩放大小，默认为1",
  T_40_XXJ_WS_SCALECALUE_DESCKEY: "缩放值",
  T_40_XXJ_WS_SCENENAME_DESCKEY: "区域名字",
  T_40_XXJ_WS_SCOREBARHUD_DESCKEY: "比分条",
  T_40_XXJ_WS_SCOREBARHUD_NAMEKEY: "比分条",
  T_40_XXJ_WS_SCROLLDIRECTION_DESCKEY: "支持多种滚动方向",
  T_40_XXJ_WS_SCROLLDIRECTION_NAMEKEY: "滚动方向",
  T_40_XXJ_WS_SCROLLWHEELFACTOR_DESCKEY: "滚轮因子，值越大滚动越快",
  T_40_XXJ_WS_SCROLLWHEELFACTOR_NAMEKEY: "滚轮因子",
  T_40_XXJ_WS_SETCAMERACULLINGMASK_DESCKEY: "设置相机CullingMask",
  T_40_XXJ_WS_SETGLOBAL: "设置全局",
  T_40_XXJ_WS_SETPARENT_D: "仅支持具有Transform组件的实体",
  T_40_XXJ_WS_SETPLAYERCLOTHIDBYWARDROBETYPE_DESCKEY: "设置玩家服装ID",
  T_40_XXJ_WS_SETPLAYERCLOTHIDS_DESCKEY: "批量修改玩家服饰",
  T_40_XXJ_WS_SETPLAYERFORWAR: "设置玩家朝向",
  T_40_XXJ_WS_SETPLAYERHUBSWITCH_DESCKEY: "设置玩家界面开关",
  T_40_XXJ_WS_SETPLAYERWEAPONSKINIDBYWEAPONID_DESCKEY: "设定玩家枪皮",
  T_40_XXJ_WS_SHOWHITPOINTEFFECT_DESCKEY: "是否在目标点显示对象",
  T_40_XXJ_WS_SHOWHITPOINTEFFECT_NAMEKEY: "显示目标点对象",
  T_40_XXJ_WS_SHOWPLAYER: "展示对象",
  T_40_XXJ_WS_SINGLELEADERBOARDHUD: "单人比赛详情HUD实体组件",
  T_40_XXJ_WS_SINGLELEADERBOARDHUD_D: "单队比赛详情HUD实体，修改实体属性则影响对应UI上的显示内容",
  T_40_XXJ_WS_SIZEDELTA: "控件与锚框尺寸差",
  T_40_XXJ_WS_SKELETON: "骨骼",
  T_40_XXJ_WS_SKELETON_D: "用来访问蒙皮骨骼的节点",
  T_40_XXJ_WS_SKELETONPART_NAMEKEY: "骨架部位",
  T_40_XXJ_WS_SKILLBUTTONHUD: "技能按钮HUD实体",
  T_40_XXJ_WS_SLOT_DESCKEY: "武器槽位",
  T_40_XXJ_WS_SMOOTHDRAGSTART_DESCKEY: "勾选时拖拽开始会有缓动，不勾选则开始拖动就是鼠标移动的速度",
  T_40_XXJ_WS_SMOOTHDRAGSTART_NAMEKEY: "是否有缓动",
  T_40_XXJ_WS_SOFTNESS_DESCKEY: "边缘柔和单位",
  T_40_XXJ_WS_SOFTNESS_NAMEKEY: "边缘柔和单位",
  T_40_XXJ_WS_SOUNDNTITY_NAMEKEY: "音效实体",
  T_40_XXJ_WS_SPACE_DESCKEY: "子项格子间距 ",
  T_40_XXJ_WS_SPACE_NAMEKEY: "子项格子间距",
  T_40_XXJ_WS_SPAWNPOSVEC3_DESCKEY: "AI的出生点坐标",
  T_40_XXJ_WS_SPAWNPOSVEC3_NAMEKEY: "出生点坐标",
  T_40_XXJ_WS_SPEED_DESCKEY: "速度",
  T_40_XXJ_WS_SPEED_NAMEKEY: "移动速度",
  T_40_XXJ_WS_SPEEDUP_NAMEKEY: "疾跑HUD开关",
  T_40_XXJ_WS_SPHERERADIUS_DESCKEY: "球形半径",
  T_40_XXJ_WS_SPRAYCOLOR_DESCKEY: "喷漆颜色",
  T_40_XXJ_WS_SPRAYCOLOR_NAMEKEY: "喷漆颜色",
  T_40_XXJ_WS_SPRAYRESULTHUD_DESCKEY: "喷漆结算",
  T_40_XXJ_WS_SPRAYRESULTHUD_NAMEKEY: "喷漆结算",
  T_40_XXJ_WS_SPRAYRIFLE_DESCKEY: "喷漆枪（步枪）",
  T_40_XXJ_WS_SPRAYRIFLE_NAMEKEY: "喷漆枪（步枪）",
  T_40_XXJ_WS_SPRAYRIFLE_NAMEKEY_01: "初始速度",
  T_40_XXJ_WS_SPRITEFLIP_NAMEKEY: "贴图翻转",
  T_40_XXJ_WS_SPRITEID: "图集精灵资产ID",
  T_40_XXJ_WS_SPRITEID_D: "用以描述图集精灵资产的ID",
  T_40_XXJ_WS_SPRITETYPE_NAMEKEY: "贴图类型",
  T_40_XXJ_WS_STARGETENTITY_DESCKEY: "被生成静态像素的目标实体",
  T_40_XXJ_WS_STARTPOSITION_D: "形状的几何中心的世界坐标",
  T_40_XXJ_WS_STAY_D: "是否保留子节点当前世界位置、旋转和缩放，一般为true，UI设置该项无效",
  T_40_XXJ_WS_STRING_NAMEKEY: "字符串",
  T_40_XXJ_WS_STRING2FLOAT_DESCKEY: "字符串转浮点数",
  T_40_XXJ_WS_STRING2INT_DESCKEY: "字符串转整形",
  T_40_XXJ_WS_STYLE_DESCKEY: "插值运动播放的方式，可选单次、循环、往复",
  T_40_XXJ_WS_SWITCHPLAYERAREA_DESCKEY: "切换玩家区域",
  T_40_XXJ_WS_SWITCHVALUE_DESCKEY: "开关值",
  T_40_XXJ_WS_SWITCHWEAPONBYSLOT_DESCKEY: "根据槽位切换玩家武器",
  T_40_XXJ_WS_SWITCHWEAPONEQUIPSLOT_DESCKEY: "切换道具槽位",
  T_40_XXJ_WS_SWITCHWEAPONEQUIPSLOT_NAMEKEY: "切换道具槽位",
  T_40_XXJ_WS_TABLENAME_DESC: "显示表名，实际上是UUID",
  T_40_XXJ_WS_TABLEVALUE: "表的内容，二维数组",
  T_40_XXJ_WS_TAGSLIST_DESCKEY: "标签列表",
  T_40_XXJ_WS_TARGET_DESCKEY: "生成地图像素的目标实体，默认为空",
  T_40_XXJ_WS_TARGET_NAMEKEY: "生成地图像素的目标实体",
  T_40_XXJ_WS_TARGETATK_DESCKEY: "攻击目标",
  T_40_XXJ_WS_TARGETENTITY_DESCKEY: "目标实体",
  T_40_XXJ_WS_TARGETENTITY_NAMEKEY: "实体",
  T_40_XXJ_WS_TARGETENTITY1_DESCKEY: "自定义函数所在的实体",
  T_40_XXJ_WS_TARGETENTITYAPLAYER_DESCKEY: "被AI攻击的对象",
  T_40_XXJ_WS_TARGETENTITYFOLLOW_DESCKEY: "跟随的目标实体",
  T_40_XXJ_WS_TARGETENTITYITEM_DESCKEY: "道具实体(可能为空)",
  T_40_XXJ_WS_TARGETENTITYLOOK_DESCKEY: "注视的目标实体",
  T_40_XXJ_WS_TARGETENTITYSOUND_DESCKEY: "需要被暂停的音效实体",
  T_40_XXJ_WS_TARGETENTITYSOUND2_DESCKEY: "被暂停后需要继续播放的音效实体",
  T_40_XXJ_WS_TARGETENTITYSOUND3_DESCKEY: "要移除的音效实体",
  T_40_XXJ_WS_TEAMMATESINFO_NAMEKEY: "队友信息HUD开关",
  T_40_XXJ_WS_TELEPORTA_D: "将玩家传送至指定位置，并设置其朝向",
  T_40_XXJ_WS_TEXT_NAMEKEY: "提示文字",
  T_40_XXJ_WS_TEXTCOLOR_NAMEKEY: "提示文字颜色",
  T_40_XXJ_WS_TEXTENTITY_DESCKEY: "文本实体表示一个显示的文本",
  T_40_XXJ_WS_TEXTKEY_DESCKEY: "所要显示的文本key",
  T_40_XXJ_WS_TEXTKEY_NAMEKEY: "文本key",
  T_40_XXJ_WS_TIMESTAMP_DESCKEY: "时间戳",
  T_40_XXJ_WS_TIMESTAMPFORMATSTYLE_DESCKEY: "时间戳格式化显示样式",
  T_40_XXJ_WS_TIMESTAMPFORMATSTYLE_NAMEKEY: "时间戳格式化显示样式",
  T_40_XXJ_WS_TIMESTAMPLOCSTRING_DESCKEY: "时间戳本地化字符串",
  T_40_XXJ_WS_TIMESTAMPLOCSTRING_NAMEKEY: "时间戳本地化字符串",
  T_40_XXJ_WS_TIPHUD_DESCKEY: "提示",
  T_40_XXJ_WS_TIPHUD_NAMEKEY: "提示",
  T_40_XXJ_WS_TOKENCOUNT_DESCKEY: "可拾取物数量",
  T_40_XXJ_WS_TOKENID_DESCKEY: "可拾取物ID",
  T_40_XXJ_WS_TOWSPEED_DESCKEY: "牵引玩家速度",
  T_40_XXJ_WS_TRANSITIONTYPE_NAMEKEY: "翻译类型",
  T_40_XXJ_WS_TWEENENTITY_DESCKEY: "插值动画实体",
  T_40_XXJ_WS_TYPE_DESCKEY: "描述类型的类型，当使用Typeof时返回该类型",
  T_40_XXJ_WS_TYPE_NAMEKEY: "刚体类型",
  T_40_XXJ_WS_TYPE2_DESCKEY: "不同类型刚体功能不同",
  T_40_XXJ_WS_TYPE3_DESCKEY: "目前版本中暂只有基础货币",
  T_40_XXJ_WS_USEDEPTHMAP_DESCKEY: "是否启用小地图深度图显示模式",
  T_40_XXJ_WS_USEDEPTHMAP_NAMEKEY: "深度图开关",
  T_40_XXJ_WS_USEGRAVITY_DESCKEY: "是否受重力",
  T_40_XXJ_WS_USEGRAVITY_NAMEKEY: "是否受重力",
  T_40_XXJ_WS_UUID_DESCKEY: "唯一标识",
  T_40_XXJ_WS_UUID_NAMEKEY: "玩家唯一标识符",
  T_40_XXJ_WS_VALUE_DESCKEY: "值",
  T_40_XXJ_WS_VALUE_NAMEKEY: "值",
  T_40_XXJ_WS_VALUE01_NAMEKEY: "值[0, 1]",
  T_40_XXJ_WS_VALUE1_DESCKEY: "第一个值",
  T_40_XXJ_WS_VALUE2_DESCKEY: "第二个值",
  T_40_XXJ_WS_VALUE6_DESCKEY: "值[0, 1]",
  T_40_XXJ_WS_VALUEA_DESCKEY: "开始值",
  T_40_XXJ_WS_VALUEB_DESCKEY: "目标值",
  T_40_XXJ_WS_VALUENAME_DESCKEY: "遍历到值的名称，可以使用它获取到局部变量上的值",
  T_40_XXJ_WS_VALUET_DESCKEY: "0到1之间,插值进度",
  T_40_XXJ_WS_VARTYPE_NAMEKEY: "变量类型",
  T_40_XXJ_WS_VERTICALBAR_DESCKEY: "垂直显示类型",
  T_40_XXJ_WS_VERTICALBAR_NAMEKEY: "垂直显示类型",
  T_40_XXJ_WS_VISIBILITYLAYER_DESCKEY: "物件可见性层级",
  T_40_XXJ_WS_VISIBILITYLAYER_NAMEKEY: "物件可见性层级",
  T_40_XXJ_WS_WARDROBETYPE_DESCKEY: "服饰分为套装、头饰、面饰、妆容、上身装、下身装、鞋这几种类型",
  T_40_XXJ_WS_WARDROBETYPE_NAMEKEY: "服饰类型",
  T_40_XXJ_WS_WARDROBETYPE6_DESCKEY: "服装槽位",
  T_40_XXJ_WS_WEAPONHUD_NAMEKEY: "武器栏hud开关",
  T_40_XXJ_WS_WEAPONSKINID_DESCKEY: "枪皮ID",
  T_40_XXJ_WS_WEAPONSKINID_NAMEKEY: "枪皮ID",
  T_40_XXJ_WS_WEAPONSKINID1_DESCKEY: "枪皮的ID",
  T_40_XXJ_WS_WEAPONSKINID6_DESCKEY: "玩家枪皮",
  T_40_XXJ_WS_WIDGETTYPEENUM: "控件类型枚举",
  T_40_XXJ_WS_WIDTH_DESCKEY: "宽度",
  T_40_XXJ_WS_WORDWRAP_NAMEKEY: "自动换行",
  T_40_XXJ_WS_WRITELEADERBOARD: "写入数据库中排行榜表值",
  T_40_XXJ_WS_WRITELEADERBOARD_DESC: "写入数据库某个排行榜表中某个Key对应的值",
  T_40_XYL_WS_BUMPERFACTORY: "碰碰车厂",
  T_40_XYL_WS_BURNDAMAGE: "燃烧伤害",
  T_40_XYL_WS_BURNINTERVAL: "燃烧伤害间隔（秒）",
  T_40_XYL_WS_BURNTIME: "爆炸后燃烧时间",
  T_40_XYL_WS_COLORFULSKY: "彩色魔方天空",
  T_40_XYL_WS_CRANEMACHINE: "娃娃机",
  T_40_XYL_WS_CRASHMAXDAMAGE: "撞击最大伤害",
  T_40_XYL_WS_CRASHMAXSPEED: "撞击伤害速度上限",
  T_40_XYL_WS_CRASHMESS: "撞击时质量参数",
  T_40_XYL_WS_CRASHMINDAMAGE: "撞击最小伤害",
  T_40_XYL_WS_DISPLAYBOARD: "展示牌",
  T_40_XYL_WS_EXPLODEDAMAGE: "爆炸伤害",
  T_40_XYL_WS_EXPLODEDELAY: "爆炸延迟时间",
  T_40_XYL_WS_EXPLODERANGE: "爆炸范围",
  T_40_XYL_WS_FERRISWHEEL: "摩天轮",
  T_40_XYL_WS_FOODTRUCK002: "小餐车B",
  T_40_XYL_WS_GEARSHIFTDELAY: "档位切换时间（秒）",
  T_40_XYL_WS_ICAROUSEL001: "旋转木马组件A",
  T_40_XYL_WS_ICAROUSEL002: "旋转木马组件B",
  T_40_XYL_WS_ICAROUSEL003: "旋转木马台",
  T_40_XYL_WS_ICEDANCEDOOL: "蓝色娃娃",
  T_40_XYL_WS_IDLEBRAKEINPUT: "无操控停车马力比例",
  T_40_XYL_WS_LOLLIPOP: "巨大棒棒糖",
  T_40_XYL_WS_NEWHOOKGUN: "强力钩锁枪",
  T_40_XYL_WS_OPENSWING: "开启摆荡按钮",
  T_40_XYL_WS_OPENTRACTION: "开启牵引按钮",
  T_40_XYL_WS_PODIUM: "领奖台",
  T_40_XYL_WS_SKYCITY: "城市",
  T_40_XYL_WS_SKYSCRAPER_A001: "高楼A组件A",
  T_40_XYL_WS_SKYSCRAPER_A002: "高楼A组件B",
  T_40_XYL_WS_SKYSCRAPER_A003: "高楼A组件C",
  T_40_XYL_WS_SKYSCRAPER_B001: "高楼B组件A",
  T_40_XYL_WS_SKYSCRAPER_B002: "高楼B组件B",
  T_40_XYL_WS_SKYSCRAPER_B003: "高楼B组件C",
  T_40_XYL_WS_SKYSCRAPER_C001: "高楼C组件A",
  T_40_XYL_WS_SKYSCRAPER_C002: "高楼C组件B",
  T_40_XYL_WS_SKYSCRAPER_C003: "高楼C组件C",
  T_40_XYL_WS_SKYSCRAPER_D001: "高楼D组件A",
  T_40_XYL_WS_SKYSCRAPER_D002: "高楼D组件B",
  T_40_XYL_WS_SKYSCRAPER_D003: "高楼D组件C",
  T_40_XYL_WS_SKYSCRAPER_E001: "高楼E组件A",
  T_40_XYL_WS_SKYSCRAPER_E002: "高楼E组件B",
  T_40_XYL_WS_SKYSCRAPER_E003: "高楼E组件C",
  T_40_XYL_WS_STEERANGLE: "高速最大转向角",
  T_40_XYL_WS_STEERSPEED: "高速转向时最大速度",
  T_40_XYL_WS_SWINGSPEED: "摆荡速度",
  T_40_XYL_WS_TARGETOBJECT: "运动锚点",
  T_40_XYL_WS_TRACTIONSPEED: "牵引速度",
  T_40_XYL_WS_TRIGGERCAPSULE: "自定义胶囊体触发器",
  T_40_XYL_WS_TRIGGERSPHERE: "自定义球体触发器",
  T_40_ZQ_WS_COMPONENT_CUSTOMOBJECT: "自定义物件",
  T_40_ZQ_WS_COMPONENT_CUSTOMOBJECT_DESC: "一个空白物件组件，可以配合渲染器组件、碰撞器组件等使用。",
  T_40_ZQ_WS_COMPONENT_CUSTOMRENDER: "自定义渲染组件",
  T_40_ZQ_WS_COMPONENT_CUSTOMRENDER_DESC: "自定义渲染组件，用于使用自定义模型资源进行呈现",
  T_41_B_SKILL_DESC_ASSASSINGIRL: "你造成的标记会附加赏金效果，击杀赏金标记的玩家可获得[FFB300]{0}FF代币[-]。击杀敌人将额外获得[FFB300]100FF代币[-]。可在BR代币生成器中额外获得[FFB300]{1}FF代币[-]。",
  T_41_B_SKILL_NAME_ASSASSINGIRL: "赏金标记",
  T_41_CJ_A_ESPORTS_TH: "泰国电竞面饰",
  T_41_CJ_B_ESPORTS_TH: "泰国电竞裤子",
  T_41_CJ_H_ESPORTS_TH: "泰国电竞头饰",
  T_41_CJ_S_ESPORTS_TH: "泰国电竞鞋子",
  T_41_CJ_T_ESPORTS_TH: "泰国电竞上衣",
  T_41_CJ_T_FFSI: "泰国FFSI冠军球衣换皮上衣",
  T_41_CJ_T_FOOTBALL_EU01: "欧洲哈萨克斯坦换皮球衣上衣上衣",
  T_41_CJ_T_FOOTBALL_EU02: "欧洲土耳其换皮球衣上衣上衣",
  T_41_CJ_T_FOOTBALL_EU03: "欧洲葡萄牙换皮球衣上衣上衣",
  T_41_CJ_T_FOOTBALL_EU04: "欧洲西班牙换皮球衣上衣上衣",
  T_41_H_CHARACTER_ASSASSINGIRL_N: "赏金女角色",
  T_41_LXW_TabName_Items: "道具",
  T_41_R_CD_COIL: "缩圈",
  T_41_SJ_WS_SPECIALITEM_ENABLE_DES: "是否启用此装置",
  T_41_SJ_WS_SPECIALITEM_NAME: "特殊装置",
  T_41_SW_SKILL_DESC_DELIVERY: "受到来自[FFB300]{0}米[-]范围内敌人的伤害时，将其标记[FFB300]{1}秒[-]，最多可以标记[FFB300]{2}名[-]敌人，标记信息队友可见。",
  T_41_SW_SKILL_DESC_GANGLEADER: "开局额外拥有[FFB300]{0}点[-]护盾，在脱战后自动回复。",
  T_41_SW_SKILL_DESC_JUNKENGINEER: "使用主动技能时，会对周围[FFB300]{0}米[-]的友军提供[FFB300]{1}点[-]护盾，并在[FFB300]{2}秒[-]后开始衰减。当玩家拥有Shani的护盾时，无法再次获得。冷却：[FFB300]{3}秒[-]",
  T_41_SW_SKILL_DESC_WINTERGUY: "放置的凝膠護盾受到伤害时会恢复每秒[FFB300]{0}点[-]的耐久度；在冰墙修复时会对周围[FFB300]{1}米[-]的友军提供每秒[FFB300]{2}血量[-]恢复，每个冰墙最多能对一个友军提供[FFB300]{3}血量[-]。",
  T_41_SY_PETSKIN_CACTUS_SUGARSKULL23_N: "拉美亡灵节主题宠物皮肤",
  T_41_SY_PETSKIN_HAWK_INKPAINTING_N: "赛博水墨主题宠物皮肤",
  T_41_WCL_CREDITSCORE_PENALTY_HISTORY_TYPE: "类型",
  T_41_WT_SKILL_DESC_FIREBOY: "释放一道持续时间为[FFB300]{0}秒的[-]的火墙，火墙宽[FFB300]{1}米[-]并以[FFB300]{2}米每秒[-]的速度向前移动最多[FFB300]{3}秒[-]，期间二次释放可以使火墙停在原地。触碰到火焰的[FFB300]敌人（或凝胶护盾）[-]会立即受到[FFB300]{4}（{5}）点伤害[-]，然后每秒受到[FFB300]{6}（{7}）点伤害[-]，持续[FFB300]{8}秒[-]。冷却时间[FFB300]{9}秒[-].技能最多积攒[FFB300]{10}次[-]，两次释放的冷却时间为[FFB300]{11}秒[-]",
  T_41_WT_SKILL_NAME_FIREBOY: "烈焰屏障",
  T_41_WZY_WS_CHARGEMAX: "凝胶生成器充能上限",
  T_41_WZY_WS_CROSSBOWNAME: "弩",
  T_41_WZY_WS_DECELERATIONRATIO: "水域减速百分比",
  T_41_WZY_WS_DEICEWALLPARAM1: "反制区域半径",
  T_41_WZY_WS_DEICEWALLPARAM2: "反制区域时长",
  T_41_WZY_WS_EXPPERCHIP: "升级芯片提供经验",
  T_41_WZY_WS_EXPPERDAMAGE: "每点伤害提供经验",
  T_41_WZY_WS_EXPPERMOVEMILE: "移动每米提供经验",
  T_41_WZY_WS_EXPPERSECOND: "每秒提供经验",
  T_41_WZY_WS_GRENADEEXPTIME: "爆炸延时",
  T_41_WZY_WS_GRENADELAUNCHNAME: "爆炸投掷物",
  T_41_WZY_WS_GRENADEMAX: "最大伤害",
  T_41_WZY_WS_GRENADEMIN: "最小伤害",
  T_41_WZY_WS_GRENADERANGE: "爆炸范围",
  T_41_WZY_WS_GRENADERATIOCEHICLE: "对车辆伤害系数",
  T_41_WZY_WS_GRENADERATIOSELF: "对自身伤害系数",
  T_41_WZY_WS_GRENADERATIOTEAMMATE: "对队友伤害系数",
  T_41_WZY_WS_GRENADTHROWSPEED: "投掷速度",
  T_41_WZY_WS_HANDCANNONNAME: "手持炮",
  T_41_XXJ_WS_ACCELERATION: "加速度",
  T_41_XXJ_WS_ACCELERATION_D: "产生指定大小的加速度",
  T_41_XXJ_WS_ACTION: "行为节点",
  T_41_XXJ_WS_ACTION_D: "行为节点",
  T_41_XXJ_WS_ADDHP: "治疗物",
  T_41_XXJ_WS_ADDPLAYERMAXHP: "增加最大血量",
  T_41_XXJ_WS_AICASTSKILL_D: "AI释放技能",
  T_41_XXJ_WS_AIMASSISTCENTEROFFSET: "可被辅助瞄准中心偏移量",
  T_41_XXJ_WS_AIMASSISTDISTANCE: "可被辅助瞄准距离",
  T_41_XXJ_WS_AIMASSISTENTITY: "可被辅助瞄准实体",
  T_41_XXJ_WS_AIMASSISTENTITY_D: "可以被辅助瞄准的实体",
  T_41_XXJ_WS_AISKILLTYPE: "僵尸技能类型",
  T_41_XXJ_WS_AISKILLTYPE_D: "僵尸技能类型",
  T_41_XXJ_WS_ALLITEMGOODSTYPE: "所有物品",
  T_41_XXJ_WS_ALLITEMGOODSTYPE_D: "所有物品",
  T_41_XXJ_WS_AMMOCLIPSIZE: "弹匣数量修正",
  T_41_XXJ_WS_AMMOCLIPSIZE_D: "弹夹子弹数量",
  T_41_XXJ_WS_ANCHORPOSITION_D: "相对于父节点的锚点坐标",
  T_41_XXJ_WS_ANGLE_D: "Z轴旋转角度",
  T_41_XXJ_WS_ANGULARDRAG: "转动阻力系数",
  T_41_XXJ_WS_ANGULARVELOCITY: "角速度（rad/s，世界坐标系）",
  T_41_XXJ_WS_ANIMATIONCLIP: "动画状态",
  T_41_XXJ_WS_ANIMATIONCONTROLLER: "动画控制器",
  T_41_XXJ_WS_ANIMATIONCONTROLLERABLE: "动画实体",
  T_41_XXJ_WS_ANIMATIONCONTROLLERABLE_D: "管理动画控制器与资源",
  T_41_XXJ_WS_ANIMATIONCONTROLLERRESUUID: "动画状态机资源UUID",
  T_41_XXJ_WS_ANIMATIONOVERRIDELOOPTYPE: "循环类型枚举",
  T_41_XXJ_WS_ANIMATIONSTATE: "动画状态",
  T_41_XXJ_WS_ARITHMETICTYPE_D: "运算方式，所有类型都支持赋值，数字类型还支持自加、自减、自乘、自除",
  T_41_XXJ_WS_ATTACHMENT: "配件道具",
  T_41_XXJ_WS_ATTACHMENT_D: "配件道具",
  T_41_XXJ_WS_ATTACHTARGET: "绑定的对象",
  T_41_XXJ_WS_BAG: "背包",
  T_41_XXJ_WS_BAG_D: "背包组件",
  T_41_XXJ_WS_BANNERID: "横幅ID",
  T_41_XXJ_WS_BANNERID_D: "横幅ID",
  T_41_XXJ_WS_BEHAVIOURTREE: "行为树",
  T_41_XXJ_WS_BEHAVIOURTREE_D: "行为树",
  T_41_XXJ_WS_BEHAVIOURTREEATTACHABLE: "可挂载行为树实体",
  T_41_XXJ_WS_BEHAVIOURTREEATTACHABLE_D: "可挂载行为树实体",
  T_41_XXJ_WS_BEHAVIOURTREENODE: "行为树自定义节点",
  T_41_XXJ_WS_BEHAVIOURTREENODE_D: "行为树自定义节点",
  T_41_XXJ_WS_BODY: "身体",
  T_41_XXJ_WS_BORDERLR: "左右边界",
  T_41_XXJ_WS_BORDERLR_D: "BorderLR",
  T_41_XXJ_WS_BORDERTB: "上下边界",
  T_41_XXJ_WS_BORDERTB_D: "上下边界",
  T_41_XXJ_WS_BRPEAKRANK: "BR巅峰段位",
  T_41_XXJ_WS_BRPEAKRANK_D: "BR巅峰段位",
  T_41_XXJ_WS_BRRANK: "BR段位",
  T_41_XXJ_WS_BRRANK_D: "BR段位",
  T_41_XXJ_WS_BTCUSTOMNODETYPE: "行为树节点类型",
  T_41_XXJ_WS_BTCUSTOMNODETYPE_D: "行为树节点类型",
  T_41_XXJ_WS_BTREE: "行为树",
  T_41_XXJ_WS_BTREENODESTATE: "行为树节点运行状态",
  T_41_XXJ_WS_BTREENODESTATE_D: "行为树节点运行状态",
  T_41_XXJ_WS_BUFFABLEENTITY: "能够使用FFBuff系统的实体",
  T_41_XXJ_WS_BUFFABLEENTITY_D: "可以添加buff,移除buff,获得已加的buff列表",
  T_41_XXJ_WS_BUILDINGICEWALL: "冰墙",
  T_41_XXJ_WS_CAMOUFLAGE: "功能型道具",
  T_41_XXJ_WS_CAMOUFLAGE_D: "滑板、迷彩....",
  T_41_XXJ_WS_CAPICITY_D: "初始容量",
  T_41_XXJ_WS_CENTERINVISIBLE: "中心不可见",
  T_41_XXJ_WS_CENTERINVISIBLE_D: "中心不可见",
  T_41_XXJ_WS_COLOR: "颜色",
  T_41_XXJ_WS_COLOR_D: "颜色",
  T_41_XXJ_WS_CONDITION: "条件节点",
  T_41_XXJ_WS_CONDITION_D: "条件是特殊的Bool类型",
  T_41_XXJ_WS_CONDITION1_D: "条件节点",
  T_41_XXJ_WS_CONSTRAIN: "刚体约束",
  T_41_XXJ_WS_CONSTRAIN_D: "对刚体施加的限制，是RigidbodyConstrainType的集合",
  T_41_XXJ_WS_COUNT_D: "数量",
  T_41_XXJ_WS_CROSSBOW_D: "十字弩",
  T_41_XXJ_WS_CSPEAKRANK: "CS巅峰段位",
  T_41_XXJ_WS_CSPEAKRANK_D: "CS巅峰段位",
  T_41_XXJ_WS_CSRANK: "CS段位",
  T_41_XXJ_WS_CSRANK_D: "CS段位",
  T_41_XXJ_WS_CSVNAME_D: "模式对应SceneData下的csv文件，以.csv结尾，表头全部使用小写",
  T_41_XXJ_WS_CURCAPACITY: "已占用空间",
  T_41_XXJ_WS_CURPROGRESS: "当前进度",
  T_41_XXJ_WS_CURRENTCLIP: "当前动画片段",
  T_41_XXJ_WS_CURRENTCLIPPROGRESS: "当前动画片段播放进度",
  T_41_XXJ_WS_CURRENTSTATE: "当前动画状态",
  T_41_XXJ_WS_CUSTOMHUDID: "自定义界面ID",
  T_41_XXJ_WS_CUSTOMHUDID_D: "用以描述自定义界面资产的ID",
  T_41_XXJ_WS_DASHATTACK: "冲撞攻击",
  T_41_XXJ_WS_DEBUG: "开启调试",
  T_41_XXJ_WS_DEBUG_D: "修复",
  T_41_XXJ_WS_DECELERATIONRATIO_D: "减速百分比：水域物件开放水中移速减缓百分比（范围暂定为0~100）",
  T_41_XXJ_WS_DEPTH_D: "深度",
  T_41_XXJ_WS_DRAG: "移动阻力系数",
  T_41_XXJ_WS_DRAG_D: "系数越大，运动速度衰减的越快",
  T_41_XXJ_WS_DUMMY: "假人",
  T_41_XXJ_WS_ENABLEENERGYSAVINGMODE: "是否开启低帧率模式",
  T_41_XXJ_WS_ENABLEENERGYSAVINGMODE_D: "开启低帧率模式，游戏将以15FPS运行，否则30FPS",
  T_41_XXJ_WS_ENTITYLIST: "返回创建的实体列表",
  T_41_XXJ_WS_ENTITYNAME: "物件名称",
  T_41_XXJ_WS_ENTITYNAME_D: "玩家自定义的物件名称",
  T_41_XXJ_WS_ENTITYORPREFABID_D: "逻辑实体或者PrefabID",
  T_41_XXJ_WS_EQUIPANDBAG: "防具与背包",
  T_41_XXJ_WS_EQUIPMENTSLOT: "装备栏槽位枚举",
  T_41_XXJ_WS_EQUIPMENTSLOT_D: "装备栏槽位枚举",
  T_41_XXJ_WS_EXPLODE: "自爆",
  T_41_XXJ_WS_EXPLOSIVEWEAPON_D: "爆破武器",
  T_41_XXJ_WS_FASTAUTORELOADSPEED: "自动换弹速度",
  T_41_XXJ_WS_FILEID: "内部ID",
  T_41_XXJ_WS_FILEID_D: "控件在Prefab中的内部ID",
  T_41_XXJ_WS_FILLAMOUNT: "填充值",
  T_41_XXJ_WS_FILLAMOUNT_D: "填充值",
  T_41_XXJ_WS_FILLDIR: "填充方向",
  T_41_XXJ_WS_FILLDIR_D: "填充方向",
  T_41_XXJ_WS_FILLDIR_D1: "填充方向枚举",
  T_41_XXJ_WS_FILLTYPE: "填充类型",
  T_41_XXJ_WS_FILLTYPE_D: "填充类型",
  T_41_XXJ_WS_FILLTYPE_D1: "填充类型枚举",
  T_41_XXJ_WS_FINDSTRAIGHTPATH_D: "寻路",
  T_41_XXJ_WS_FINISH: "完成",
  T_41_XXJ_WS_FIREINTERVAL: "发射间隔",
  T_41_XXJ_WS_FIREINTERVAL_D: "攻击间隔",
  T_41_XXJ_WS_FLIP: "翻转方式",
  T_41_XXJ_WS_FLIP_D: "翻转方式",
  T_41_XXJ_WS_FLYBOMBBEE: "飞行僵尸",
  T_41_XXJ_WS_FORCE: "线性力",
  T_41_XXJ_WS_FORCE_D: "产生指定大小的力",
  T_41_XXJ_WS_FORCETYPE: "施力类型",
  T_41_XXJ_WS_FORCETYPE_D: "刚体受力的几种不同效果。注意只对Dynamic类型的刚体有效",
  T_41_XXJ_WS_FREEZEALL: "限制所有轴的平移和旋转",
  T_41_XXJ_WS_FREEZEPOSITION: "限制所有轴的平移",
  T_41_XXJ_WS_FREEZEPOSITIONX: "限制X轴方向平移",
  T_41_XXJ_WS_FREEZEPOSITIONY: "限制Y轴方向平移",
  T_41_XXJ_WS_FREEZEPOSITIONZ: "限制Z轴方向平移",
  T_41_XXJ_WS_FREEZEROTATION: "限制所有轴的旋转",
  T_41_XXJ_WS_FREEZEROTATIONX: "限制X轴方向旋转",
  T_41_XXJ_WS_FREEZEROTATIONY: "限制Y轴方向旋转",
  T_41_XXJ_WS_FREEZEROTATIONZ: "限制Z轴方向旋转",
  T_41_XXJ_WS_FULLDAMAGEDISTANCE: "满伤害距离",
  T_41_XXJ_WS_FULLDAMAGEDISTANCE_D: "满伤害距离",
  T_41_XXJ_WS_GAMEID_D: "任务ID",
  T_41_XXJ_WS_GIVEJAILBREAKITEM_D: "GiveJailBreakItem",
  T_41_XXJ_WS_GRADIENT: "渐变",
  T_41_XXJ_WS_GRADIENT_D: "渐变",
  T_41_XXJ_WS_GRADIENTBOTTOM: "底部渐变色",
  T_41_XXJ_WS_GRADIENTBOTTOM_D: "底部渐变色",
  T_41_XXJ_WS_GRADIENTBOTTOMALPHA: "底部透明度",
  T_41_XXJ_WS_GRADIENTBOTTOMALPHA_D: "底部透明度",
  T_41_XXJ_WS_GRADIENTTOP: "顶部渐变色",
  T_41_XXJ_WS_GRADIENTTOP_D: "顶部渐变色",
  T_41_XXJ_WS_GRADIENTTOPALPHA: "顶部透明度",
  T_41_XXJ_WS_GRADIENTTOPALPHA_D: "顶部透明度",
  T_41_XXJ_WS_GRAPHID: "脚本ID",
  T_41_XXJ_WS_GRAPHID_D: "用以描述脚本资产的ID",
  T_41_XXJ_WS_GRENADEDEICEWALL_D: " 反制冰墙手雷组件",
  T_41_XXJ_WS_GRENADEEXPLOSIONTIME_D: "爆炸延时",
  T_41_XXJ_WS_GRENADELAUNCHER_D: "投掷物道具",
  T_41_XXJ_WS_GRENADEMAXDAMAGE_D: "最大伤害",
  T_41_XXJ_WS_GRENADEMINDAMAGE_D: "最小伤害",
  T_41_XXJ_WS_GRENADERANGE_D: "爆炸范围",
  T_41_XXJ_WS_GRENADERATIOSELF_D: "自己伤害系数",
  T_41_XXJ_WS_GRENADERATIOTEAMMATE_D: "队友伤害系数",
  T_41_XXJ_WS_GRENADERATIOVEHICLE_D: "车辆伤害系数",
  T_41_XXJ_WS_GRENADETHROWSPEED_D: "投掷速度",
  T_41_XXJ_WS_GRENADEWEAPON: "投掷物道具基类",
  T_41_XXJ_WS_GRENADEWEAPON_D: "投掷物道具基类",
  T_41_XXJ_WS_HANDCANNON_D: "投掷物道具",
  T_41_XXJ_WS_HEAD: "头",
  T_41_XXJ_WS_HEADID: "头像ID",
  T_41_XXJ_WS_HEADID_D: "头像ID",
  T_41_XXJ_WS_HEAVYWEAPON_D: "重武器",
  T_41_XXJ_WS_HELMET_D: "当前头盔",
  T_41_XXJ_WS_HELMET1_D: "头盔",
  T_41_XXJ_WS_HELMET2_D: "头盔实体",
  T_41_XXJ_WS_HITBODYPART_D: "伤害部位",
  T_41_XXJ_WS_HITBPDYPART: "击中部位",
  T_41_XXJ_WS_HITENTITY_D: "击中实体",
  T_41_XXJ_WS_HOSTHUDENTITY_D: "所在HUD实体",
  T_41_XXJ_WS_HUD3DCONTAINER: "3D内容装载器",
  T_41_XXJ_WS_HUD3DCONTAINER_D: "Hud3DContainer实体，玩家通过Hud编辑器编辑的Hud",
  T_41_XXJ_WS_HUDGRID: "自定义Layout(Panel)控件",
  T_41_XXJ_WS_HUDLAYOUT: "布局控件",
  T_41_XXJ_WS_HUDLAYOUT_D: "Hud输入实体，玩家通过Hud编辑器编辑的Hud",
  T_41_XXJ_WS_HUDPROFILEINFO: "自定义头像控件",
  T_41_XXJ_WS_HUDPROFILEINFO_D: "HudProfileInfo实体，玩家通过Hud编辑器编辑的Hud",
  T_41_XXJ_WS_HUDTEXTURE: "贴图控件",
  T_41_XXJ_WS_HUDTEXTURE_D: "HudTexture实体，玩家通过Hud编辑器编辑的Hud",
  T_41_XXJ_WS_HUDTRANSFORM: "UITransform控件组件",
  T_41_XXJ_WS_HUDTRANSFORM_D: "UITransform控件实体",
  T_41_XXJ_WS_IMPULSE: "冲击",
  T_41_XXJ_WS_IMPULSE_D: "产生指定大小的冲击",
  T_41_XXJ_WS_INITIALWORLDPOS: "初始世界坐标",
  T_41_XXJ_WS_INTERNALBUFFTYPE: "Buff枚举",
  T_41_XXJ_WS_INTERNALBUFFTYPE_D: "对应BuffData.csv中Id列，增加新项前请和GPP确认是否适用",
  T_41_XXJ_WS_INVERTFILL: "反向填充",
  T_41_XXJ_WS_INVERTFILL_D: "反向填充",
  T_41_XXJ_WS_ISLOOP: "是否循环",
  T_41_XXJ_WS_ISLOOP_D: "是否循环，默认为False",
  T_41_XXJ_WS_ISNAVMESHSTATIC: "静态生成NavMesh",
  T_41_XXJ_WS_ISNAVMESHSTATIC_D: "仅用于静态加载物件时，判断是静态生成NavMesh",
  T_41_XXJ_WS_ISSUCCESS_D: "是否成功摧毁",
  T_41_XXJ_WS_ITEMENTITY_D: "道具实体",
  T_41_XXJ_WS_ITEMID: "ItemID",
  T_41_XXJ_WS_ITEMID_D: "ItemID",
  T_41_XXJ_WS_ITEMID_D1: "附件对应的道具id",
  T_41_XXJ_WS_ITEMLIST: "道具列表",
  T_41_XXJ_WS_ITEMTYPE_D: "ItemType",
  T_41_XXJ_WS_JUMPATTACK: "跳斩",
  T_41_XXJ_WS_LANDMINE: "地雷",
  T_41_XXJ_WS_LENGTH: "片段长度",
  T_41_XXJ_WS_LENGTH_D: "进度条长度，目前默认值为prefab上UI的长度",
  T_41_XXJ_WS_LIMB: "四肢",
  T_41_XXJ_WS_LISTLENGTHOVERLIMIT: "列表长度超过容量，元素添加失败",
  T_41_XXJ_WS_LISTT_INTERNALBUFFTYPE: "Buff列表",
  T_41_XXJ_WS_LOOP: "循环",
  T_41_XXJ_WS_LOOP_D: "循环",
  T_41_XXJ_WS_MAXCAPACITY: "空间",
  T_41_XXJ_WS_MAXCAPACITY_D: "背包空间",
  T_41_XXJ_WS_MAXPROGRESS: "最大进度",
  T_41_XXJ_WS_MELEEWEAPON_D: "近战武器",
  T_41_XXJ_WS_MINDAMAGEDISTANCE: "最小伤害开始距离",
  T_41_XXJ_WS_MINDAMAGEDISTANCE_D: "最小伤害开始距离",
  T_41_XXJ_WS_MINISENTRY: "自动炮塔",
  T_41_XXJ_WS_NAME: "名字",
  T_41_XXJ_WS_NAME_D: "技能按钮名字，用于OnClick事件发送时传参，所以要保证唯一性",
  T_41_XXJ_WS_NAME1_D: "商品名字",
  T_41_XXJ_WS_NAME2_D: "货架名字",
  T_41_XXJ_WS_NAME3_D: "商店名字",
  T_41_XXJ_WS_NICKNAME: "昵称",
  T_41_XXJ_WS_NICKNAME_D: "玩家的昵称",
  T_41_XXJ_WS_NOCHANGE: "不变",
  T_41_XXJ_WS_NONE: "无限制",
  T_41_XXJ_WS_NONE1: "无",
  T_41_XXJ_WS_OFFSET: "偏移值",
  T_41_XXJ_WS_OFFSET_D: "偏移",
  T_41_XXJ_WS_OFFSET1_D: "写入的偏移值",
  T_41_XXJ_WS_ONCE: "单次",
  T_41_XXJ_WS_ONCE_D: "单次",
  T_41_XXJ_WS_ONHIDE: "当界面被关闭时",
  T_41_XXJ_WS_ONHIDE_D: "当界面被关闭时",
  T_41_XXJ_WS_ONNODEENTER_D: "当节点进入时",
  T_41_XXJ_WS_ONSHOW: "当界面被打开时",
  T_41_XXJ_WS_ONSHOW_D: "当界面被打开时",
  T_41_XXJ_WS_ONSYNCINPUTTEXT_D: "当输入框变化时触发",
  T_41_XXJ_WS_PERSONALUAV: "个人uav",
  T_41_XXJ_WS_PINID: "纪念章ID",
  T_41_XXJ_WS_PINID_D: "纪念章ID",
  T_41_XXJ_WS_PLAYERBAG: "玩家背包实体",
  T_41_XXJ_WS_PLAYERBAG_D: "玩家背包实体",
  T_41_XXJ_WS_PLAYERBAGENTITY: "玩家背包",
  T_41_XXJ_WS_PLAYERBAGENTITY_D: "玩家背包",
  T_41_XXJ_WS_PLAYERSPEEDFACTORAIMING: "开镜移动速度修正系数",
  T_41_XXJ_WS_PLAYERSPEEDFACTORFIRING: "射击时的玩家速度影响",
  T_41_XXJ_WS_PLAYERSPEEDFACTORFIRING_D: "射击时的玩家速度影响",
  T_41_XXJ_WS_PREFABID: "预置体资产ID",
  T_41_XXJ_WS_PREFABID_D: "用以描述预置资产体的ID",
  T_41_XXJ_WS_PREFABID1_D: "来自此模板ID所代表的HUD模板实体创建",
  T_41_XXJ_WS_PRIMARYWEAPON1_D: "主武器1",
  T_41_XXJ_WS_PRIMARYWEAPON2_D: "主武器2",
  T_41_XXJ_WS_PROFILEINFO: "玩家名片",
  T_41_XXJ_WS_PROFILEINFO_D: "玩家简介信息",
  T_41_XXJ_WS_PROGRESSICON_D: "进度图标",
  T_41_XXJ_WS_PROGRESSICONSPRITENAME: "进度图标名",
  T_41_XXJ_WS_QUITJAILBREAKMINIGAME_D: "QuitJailBreakMiniGame",
  T_41_XXJ_WS_RANGE: "射程",
  T_41_XXJ_WS_RANGE_D: "攻击范围",
  T_41_XXJ_WS_RANGE_D1: "爆炸范围",
  T_41_XXJ_WS_RANGE_D2: "炮塔范围",
  T_41_XXJ_WS_READCSVDATAALLOVERMODE_D: "读取整张表的内容，返回二维数组",
  T_41_XXJ_WS_READCSVDATACELLOVERMODE_D: "读取表某一单元格的内容",
  T_41_XXJ_WS_READCSVDATACOLOVERMODE_D: "读取整张表某一列的内容，返回数组",
  T_41_XXJ_WS_READCSVDATAROWOVERMODE_D: "读取整张表的某一行内容，返回数组",
  T_41_XXJ_WS_READDBACCUMULATEDDATA: "读取累计数据库表值",
  T_41_XXJ_WS_READDBACCUMULATEDDATA_D: "读取累计数据库某个表中某个Key对应的值",
  T_41_XXJ_WS_RECOVERPLAYERHP: "持续恢复血量",
  T_41_XXJ_WS_RELOADSPEED: "换弹夹速度",
  T_41_XXJ_WS_RELOADSPEED_D: "换弹速度（基础速度*系数）",
  T_41_XXJ_WS_RESOURCEID: "资源UUID",
  T_41_XXJ_WS_RESOURCEID_D: "资源UUID",
  T_41_XXJ_WS_RESUUID: "资源ID",
  T_41_XXJ_WS_RESUUID_D: "指定要渲染的资源UUID",
  T_41_XXJ_WS_RIGIDBODYCONSTRAINTYPE: "刚体约束类型",
  T_41_XXJ_WS_RIGIDBODYCONSTRAINTYPE_D: "每种限制以bit标记位定义，可以组合使用",
  T_41_XXJ_WS_ROTATION: "旋转",
  T_41_XXJ_WS_ROTATION_D: "世界坐标系中的旋转角，XYZ分量分别是偏航角、俯仰角、翻滚角",
  T_41_XXJ_WS_ROTATION1_D: "旋转",
  T_41_XXJ_WS_RUNNING: "运行中",
  T_41_XXJ_WS_SCALE: "缩放",
  T_41_XXJ_WS_SCALE_D: "缩放",
  T_41_XXJ_WS_SCALE1_D: "沿着某个轴缩放，可以三个轴组合",
  T_41_XXJ_WS_SCATTERMAX: "最大扩散阈值",
  T_41_XXJ_WS_SCATTERMAX_D: "开始散射阈值",
  T_41_XXJ_WS_SCATTERMOVE1: "移动情况下扩散大小",
  T_41_XXJ_WS_SCATTERRECOVERSPEED: "散射恢复速度",
  T_41_XXJ_WS_SCATTERRECOVERSPEED_D: "散射恢复速度",
  T_41_XXJ_WS_SCATTERSPEED: "扩散增加速度",
  T_41_XXJ_WS_SCATTERSPEED_D: "扩散增加速度(0.1 = 每多一次连发准星扩大10%)",
  T_41_XXJ_WS_SCATTERSPEEDCROUCHCREEP: "蹲下,趴下减少散射",
  T_41_XXJ_WS_SECONDARYWEAPON_D: "副武器",
  T_41_XXJ_WS_SHADERNAME: "Shader名称",
  T_41_XXJ_WS_SHADERNAME_D: "Shader名称",
  T_41_XXJ_WS_SHIELDBROKEN: "破盾攻击",
  T_41_XXJ_WS_SHIELDUP: "举盾攻击",
  T_41_XXJ_WS_SHOCKWAVE: "冲击波",
  T_41_XXJ_WS_SHOWNAME: "显示昵称",
  T_41_XXJ_WS_SHOWNAME_D: "显示昵称",
  T_41_XXJ_WS_SHOWPIN: "显示纪念章",
  T_41_XXJ_WS_SHOWPIN_D: "显示纪念章",
  T_41_XXJ_WS_SHOWRANK: "显示段位",
  T_41_XXJ_WS_SHOWRANK_D: "显示段位",
  T_41_XXJ_WS_SHOWTYPE: "样式",
  T_41_XXJ_WS_SHOWTYPE_D: "样式",
  T_41_XXJ_WS_SHRINKSPEED: "收敛速度",
  T_41_XXJ_WS_SIGHTAIMASSIST: "允许开镜时辅助瞄准",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTFALLOFF: "辅助瞄准距离衰减影响系数(0-1)",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOCOEF: "辅助瞄准距离优先影响系数(>=1)",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOMAX: "辅助瞄准距离优先最大距离",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOMIN: "辅助瞄准距离优先最小距离",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIORITY: "允许辅助瞄准距离优先",
  T_41_XXJ_WS_SIGHTAIMASSISTSNAPRANGE: "辅助瞄准准星屏幕范围吸引比率(0-1)",
  T_41_XXJ_WS_SIGHTAMPLIFYRATIO: "瞄准镜名义放大倍率",
  T_41_XXJ_WS_SIGHTFOVAMPLIFYRATIO: "FOV放大倍率",
  T_41_XXJ_WS_SIGHTROTSENSITIVENESS: "瞄镜旋转敏感度系数",
  T_41_XXJ_WS_SIGHTSHOOTMINDAMAGE: "瞄镜最小伤害距离修正系数X",
  T_41_XXJ_WS_SIGHTUIACTIONEXPAND: "瞄镜UI射击放大时间(s)",
  T_41_XXJ_WS_SIGHTUIACTIONRATIO: "瞄镜射击UI放大倍率",
  T_41_XXJ_WS_SIGHTUIACTIONRECOVERY: "瞄镜UI射击恢复时间(s)",
  T_41_XXJ_WS_SPEED: "播放速度",
  T_41_XXJ_WS_SPEEQUIP: "功能型装备",
  T_41_XXJ_WS_SPEITEM: "特殊道具",
  T_41_XXJ_WS_STATICGRAPHID: "静态脚本ID",
  T_41_XXJ_WS_STATICGRAPHID_D: "用以描述静态脚本资产的ID",
  T_41_XXJ_WS_STATICWAINING: "静态刚体类型修改失败",
  T_41_XXJ_WS_TARGETTREE: "行为树实体",
  T_41_XXJ_WS_TARGETTREE_D: "行为树实体",
  T_41_XXJ_WS_TEAMINDEX: "队伍序号",
  T_41_XXJ_WS_TEAMINDEX_D: "队伍的索引，和房间中队伍索引一致",
  T_41_XXJ_WS_TEAMINDEX_D1: "队伍阵营序号",
  T_41_XXJ_WS_TEMPLATEPREFABID: "模板的prefabID",
  T_41_XXJ_WS_TEXT_D: "文本内容",
  T_41_XXJ_WS_TEXTURENAME: "Texture名称",
  T_41_XXJ_WS_TEXTURENAME_D: "Texture名称",
  T_41_XXJ_WS_THROWATTACK: "手雷",
  T_41_XXJ_WS_TICKINTERVAL: "刷新间隔",
  T_41_XXJ_WS_TICKINTERVAL_D: "刷新间隔,数字越大刷新越慢",
  T_41_XXJ_WS_TOGGLESPECIALITEMSTATE_D: "开启玩家背包内的特殊装置",
  T_41_XXJ_WS_UVRECTWH: "UV宽高",
  T_41_XXJ_WS_UVRECTWH_D: "UV宽高",
  T_41_XXJ_WS_UVRECTXY: "UV偏移量",
  T_41_XXJ_WS_UVRECTXY_D: "UV偏移量",
  T_41_XXJ_WS_VELOCITY: "线速度",
  T_41_XXJ_WS_VELOCITY_D: "刚体的速度尽量不要直接修改，而是通过施力相关API修改。",
  T_41_XXJ_WS_VEST_D: "当前防弹衣",
  T_41_XXJ_WS_VEST1_D: "背心",
  T_41_XXJ_WS_WIDGETID: "控件ID",
  T_41_XXJ_WS_WIDGETID_D: "用以描述自定义界面资产中的控件的ID，必须和CustomHudID一起才能唯一确定一个控件ID",
  T_41_XXJ_WS_WINDATTACK: "旋风斩",
  T_41_XXJ_WS_WRITEDBACCUMULATEDDATAOFFSET: "写入累计数据库表偏移值",
  T_41_XXJ_WS_WRITEDBACCUMULATEDDATAOFFSET_D: "写入累计数据库某个表中某个Key对应的偏移值",
  T_41_XXJ_WS_ZONEDURATION_D: "冰冻区域时长",
  T_41_XXJ_WS_ZONEDURATION1_D: "反制区域时长",
  T_41_XXJ_WS_ZONERADIUS_D: "冰冻区域半径",
  T_41_XXJ_WS_ZONERADIUS1_D: "反制区域半径",
  T_41_XYL_WS_BOT12: "钻地怪",
  T_41_XYL_WS_BOT9: "变异投掷僵尸",
  T_41_XYL_WS_ITEM262: "冰冻的金属板A",
  T_41_XYL_WS_ITEM263: "冰冻的集装箱",
  T_41_XYL_WS_ITEM264: "冰冻的物资箱",
  T_41_XYL_WS_ITEM265: "冰冻的铁门",
  T_41_XYL_WS_ITEM266: "冰冻的集装箱B",
  T_41_XYL_WS_ITEM267: "冰冻的石块A",
  T_41_XYL_WS_ITEM268: "冰冻的石块B",
  T_41_XYL_WS_ITEM269: "冰冻的石块C",
  T_41_XYL_WS_ITEM270: "冰冻的石块D",
  T_41_XYL_WS_ITEM271: "废弃地铁车厢",
  T_41_XYL_WS_MODELMATCHNAME: "创作者大赛",
  T_41_XYL_WS_NAVMESH: "动态Navmesh",
  T_41_XYL_WS_REFCUBE: "镜面方块",
  T_41_XYL_WS_SNOWSKY: "极地星空",
  T_41_XYL_WS_TOYCUBE: "乐园方块",
  T_42_CJ_F_B_VOCATIONAL: "电影4-kings工程师女裤子",
  T_42_CJ_F_H_VOCATIONAL: "电影4-kings工程师女头饰",
  T_42_CJ_F_S_VOCATIONAL: "电影4-kings工程师女鞋子",
  T_42_CJ_F_T_VOCATIONAL: "电影4-kings工程师女上衣",
  T_42_CJ_HA_THUNDER_GOLD: "泰国闪电眼睛妆容",
  T_42_CJ_M_B_VOCATIONAL: "电影4-kings工程师男裤子",
  T_42_CJ_M_H_VOCATIONAL: "电影4-kings工程师男头饰",
  T_42_CJ_M_S_VOCATIONAL: "电影4-kings工程师男鞋子",
  T_42_CJ_M_T_VOCATIONAL: "电影4-kings工程师男上衣",
  T_42_H_CHARACTER_SUPERTEEN_N: "Igni",
  T_42_H_GLOO_EVOTIGER_N: "升级枪老虎主题泡沫手雷",
  T_42_H_GRENADE_SMUDGE_N: "写意潮服主题手雷",
  T_42_H_M1917_EMPIRE_N: "帝国暴君主题枪械（M1917）",
  T_42_HJ_WS_VFX_INK: "水墨",
  T_42_JH_WS_BANMATCHMAKING: "地图不允许匹配",
  T_42_JH_WS_BANROOMCREATE: "不允许创建房间",
  T_42_JH_WS_FPS: "第一人称射击",
  T_42_JH_WS_SKILLSETALOKAWAKEN: "派对嗨歌（ALOK）",
  T_42_JH_WS_SKILLSETFIREWALL: "火墙（异能少年）",
  T_42_JH_WS_SKILLSETSANTINO: "替身假人(圣提诺)",
  T_42_JH_WS_SKILLSETSONIA: "奈米护盾(Sonia)",
  T_42_JH_WS_TAG1: "冰雪大乱斗",
  T_42_JH_WS_TAG10: "无限飞车",
  T_42_JH_WS_TAG11: "极限飙车",
  T_42_JH_WS_TAG12: "赛车竞速",
  T_42_JH_WS_TAG13: "该地图不上热门栏位",
  T_42_JH_WS_TAG14: "战地",
  T_42_JH_WS_TAG15: "僵尸大战",
  T_42_JH_WS_TAG16: "RAMPAGE：致敬经典",
  T_42_JH_WS_TAG2: "社交岛1.0",
  T_42_JH_WS_TAG3: "社交岛2.0",
  T_42_JH_WS_TAG4: "一起来玩吧",
  T_42_JH_WS_TAG5: "Ruin Survivor",
  T_42_JH_WS_TAG6: "猎杀时刻",
  T_42_JH_WS_TAG7: "百慕大：猎杀时刻",
  T_42_JH_WS_TAG8: "起床战争2.0",
  T_42_JH_WS_TAG9: "赏金追猎",
  T_42_RW_PORTALSFORPERSONAL_DESC: "可以随地打开一个传送门，快速转移！",
  T_42_RW_PORTALSPERSONAL_NAME: " 便携传送门",
  T_42_SJ_WS_ACCESSORIESITEM: "装备配件道具",
  T_42_SJ_WS_AUTOPLAY: "自动播放",
  T_42_SJ_WS_CLIMB: "翻越",
  T_42_SJ_WS_CLOCK_EVENTS: "事件集合",
  T_42_SJ_WS_CLOCK_IS_COUNTDOWN: "是否为倒计时",
  T_42_SJ_WS_CLOCK_LOOP_COUNT: "循环次数",
  T_42_SJ_WS_CLOCK_PAUSE_EVENT: "暂停事件",
  T_42_SJ_WS_CLOCK_START_EVENT: "开始事件",
  T_42_SJ_WS_CLOCK_START_TIME: "倒计时开始时间",
  T_42_SJ_WS_CLOCK_STATE: "定时器状态",
  T_42_SJ_WS_CLOCK_STOP_EVENT: "停止事件",
  T_42_SJ_WS_DAMRATIOHEAD: "爆头伤害系数变化",
  T_42_SJ_WS_DAMRATIOLIMB: "四肢伤害系数变化",
  T_42_SJ_WS_DAMREDUCEXPLODE: "额外爆炸减伤系数（总上限为75%）",
  T_42_SJ_WS_DRIVE: "驾驶",
  T_42_SJ_WS_ENTITYITEXT_DEPTH: "显示层级",
  T_42_SJ_WS_EXTRABAGCAPACITY: "额外背包空间",
  T_42_SJ_WS_EXTRAHPRATIO: "玩家血量倍率",
  T_42_SJ_WS_GETOFF_DRIVE: "离开载具",
  T_42_SJ_WS_GETON_DRIVE: "进入载具",
  T_42_SJ_WS_KNIFEITEM: "飞刀",
  T_42_SJ_WS_KNIFEITEMPICK: "飞刀(可拾取)",
  T_42_SJ_WS_MARKBTNHUD: "标记按钮hud开关",
  T_42_SJ_WS_MARKBTNHUD_D: "可开启/关闭标记按钮",
  T_42_SJ_WS_MAXDISTANCE: "最大距离",
  T_42_SJ_WS_MAXDURARATIO: "耐久上限倍率",
  T_42_SJ_WS_MICBTNHUD: "语音(麦克风)按钮hud开关",
  T_42_SJ_WS_MICBTNHUD_D: "可开启/关闭语音（麦克风）按钮",
  T_42_SJ_WS_MINDISTANCE: "最小距离",
  T_42_SJ_WS_OPE_VEHICLE: "操作载具",
  T_42_SJ_WS_PLANE_DESC: "可以随意调整大小的基础面片",
  T_42_SJ_WS_PLANENAME: "基础面",
  T_42_SJ_WS_PRIORITY: "优先级",
  T_42_SJ_WS_REPLACEPRIORITY: "替换优先级",
  T_42_SJ_WS_SETBTNHUD: "设置按钮hud开关",
  T_42_SJ_WS_SETBTNHUD_D: "可开启/关闭设置按钮",
  T_42_SJ_WS_SIGNALBTNHUD: "网络按钮hud开关",
  T_42_SJ_WS_SIGNALBTNHUD_D: "可开启/关闭网络信号按钮",
  T_42_SJ_WS_SPEAKERBTNHUD: "喇叭按钮hud开关",
  T_42_SJ_WS_SPEAKERBTNHUD_D: "可开启/关闭载具喇叭按钮",
  T_42_SJ_WS_START_TIME: "开始时间（秒）",
  T_42_SW_SKILL_DESC_ARMSDEALER: "能额外携带[FFB300]{0}[-]背包空间的子弹，不包括榴弹枪子弹（步枪子弹：[FFB300]{1}发[-]，冲锋枪子弹：[FFB300]{2}发[-]，狙击枪子弹：[FFB300]{3}发[-]，霰弹枪子弹：[FFB300]{4}发[-]。）",
  T_42_SW_SKILL_DESC_Bodyguard: "每次对敌人造成伤害时，敌人会受到减疗效果[FFB300]{1}%[-]，最多[FFB300]{2}%[-]，持续[FFB300]{3}秒[-]。换弹速度提升[FFB300]{0}%[-]。",
  T_42_SW_SKILL_DESC_Playboy: "每[FFB300]{0}秒[-]获得一个免疫妨碍效果的护盾，当受到妨碍效果时，会触发护盾的保护免疫妨碍效果并且增加跑速[FFB300]{1}%[-]持续[FFB300]{2}秒[-]。",
  T_42_SW_SKILL_DESC_SwatGuy: "击倒敌人和使用主动技能时，自动恢复弹夹内[FFB300]{0}%[-]的子弹",
  T_42_SW_SKILL_NAME_Playboy: "金钱庇护",
  T_42_SY_BACKPACK_EMPIRE_N: "帝国暴君主题背包",
  T_42_SY_PETSKIN_RABBIT_WINTERFEST23_N: "拉美冰雪节主题宠物皮肤",
  T_42_SY_VEHICLESKIN_MOTOBIKE_URBAN_BW_N: "日常黑白潮服主题摩托车皮肤",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_AFF_N: "【橙】Bull合作跑车-A款FF涂装版",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_ASILVER_N: "【橙】Bull合作跑车-A款原色银",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_VBLACK_N: "【橙】Bull合作跑车-V款原色黑",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_VRED_N: "【橙】Bull合作跑车-V款原色红",
  T_42_TYC_CST_LOSE_MONEY_1: "失败时获得金币数量",
  T_42_TYC_CST_LOSE_MONEY_2: "连续失败2次时获得金币数量",
  T_42_TYC_CST_LOSE_MONEY_3: `连续失败3次时获得金币数量
`,
  T_42_WH_ITEM_HEALUAV: "治疗无人机",
  T_42_WH_ITEM_HEALUAV_DESC: "使用后创建一个向前飞行的无人机对下方区域的己方玩家进行持续治疗",
  T_42_WH_ITEM_SKILLCARD: "技能： {0}",
  T_42_WH_ITEM_SKILLCARD_DESC: `使用后释放[ffba00] {0}[-]的主动技能[ffba00] {1}[-]
 {2}`,
  T_42_XXJ_WS_AMMOTYPE: "子弹类型",
  T_42_XXJ_WS_AMMOTYPE_D: "子弹类型",
  T_42_XXJ_WS_ASSETCONFIGID: "皮肤ID",
  T_42_XXJ_WS_ASSETCONFIGID_D: "皮肤",
  T_42_XXJ_WS_ATTACKSTATUS: "攻击状态",
  T_42_XXJ_WS_AUTOPLAY: "创建时播放",
  T_42_XXJ_WS_AUTOPLAY_D: "创建时播放",
  T_42_XXJ_WS_AVATARABLE: "可修改外观实体组件",
  T_42_XXJ_WS_AVATARABLE_D: "按照各部件配置换装",
  T_42_XXJ_WS_AVATARRESUUID: "Avatar资源UUID",
  T_42_XXJ_WS_AXISANGLETOQUATERNION_D: "将轴角表示的旋转转化为四元数",
  T_42_XXJ_WS_B_D: "颜色的B值",
  T_42_XXJ_WS_BASEVALUE_D: "对数运算的底数",
  T_42_XXJ_WS_BEZIERCURVE: "贝塞尔曲线",
  T_42_XXJ_WS_BEZIERCURVE_D: "贝塞尔曲线",
  T_42_XXJ_WS_BOTDIFFICULTY: "Bot难度枚举",
  T_42_XXJ_WS_BOUNCE_COMBINE: "弹力组合方式",
  T_42_XXJ_WS_BOUNCINES: "弹力",
  T_42_XXJ_WS_BTREEID: "行为树文件ID",
  T_42_XXJ_WS_BTREEID_D: "行为树ID",
  T_42_XXJ_WS_CANPURCHAS: "能否购买",
  T_42_XXJ_WS_CANPURCHAS_D: "能否购买",
  T_42_XXJ_WS_CLIMBSTATUS: "翻越行为",
  T_42_XXJ_WS_CLOCK: "计时器物件",
  T_42_XXJ_WS_CLOCK_D: "计时器物件",
  T_42_XXJ_WS_CLOCK_D1: "计时",
  T_42_XXJ_WS_CONTAINER: "容器",
  T_42_XXJ_WS_CONTROLPOINTS: "ControlPoints",
  T_42_XXJ_WS_CONTROLPOINTS_D: "ControlPoints",
  T_42_XXJ_WS_COROUTINEID: "协程句柄",
  T_42_XXJ_WS_COROUTINEID_D: "指代某个协程的句柄，可以进行一些句柄操作",
  T_42_XXJ_WS_CREATESELFRELATIVE_D: "创建SeflRelative",
  T_42_XXJ_WS_CREATESELFRELATIVEFRAME_D: "创建SeflRelative",
  T_42_XXJ_WS_CREATESOUND: "创建音效",
  T_42_XXJ_WS_CREATESOUND_D: "播放指定的音效，有更多需要设置的属性时则通过实体进一步设置它的实体属性",
  T_42_XXJ_WS_CUSTOMMISSIONCOMPLETE_D: "完成自定义任务",
  T_42_XXJ_WS_DAMAGELIST_D: "伤害分段列表",
  T_42_XXJ_WS_DAMAGERATIOHEAD_D: "打头的伤害比例",
  T_42_XXJ_WS_DAMAGEREDUCTIONFACTOREXPLODE_D: "爆炸伤害减免系数",
  T_42_XXJ_WS_DEFAULT_PHYMAT: "默认物理材质",
  T_42_XXJ_WS_DEFAULTFIST_D: "默认拳头",
  T_42_XXJ_WS_DELTA: "Delta",
  T_42_XXJ_WS_DELTA_D: "Delta",
  T_42_XXJ_WS_DELTATIME: "逻辑帧间隔",
  T_42_XXJ_WS_DELTATIME_D: "GS两次逻辑帧更新间隔",
  T_42_XXJ_WS_DEPTH: "层级",
  T_42_XXJ_WS_DEPTH_D: "Icon显示层级",
  T_42_XXJ_WS_DISABLEPICKUPITEMS: "禁止拾取物品列表",
  T_42_XXJ_WS_DISABLEPICKUPITEMS_D: "禁止拾取物品列表",
  T_42_XXJ_WS_DRIVER: "驾驶员座位",
  T_42_XXJ_WS_DRIVINGSTATUS: "驾驶",
  T_42_XXJ_WS_DURATION_D1: "计时的时长，单位秒",
  T_42_XXJ_WS_DURATION_D2: "持续时间，以秒为单位",
  T_42_XXJ_WS_DURATION_D3: "Duration",
  T_42_XXJ_WS_DURATION_D4: "无敌效果持续时长（单位s）",
  T_42_XXJ_WS_DURATIONTIMES: "计时长度",
  T_42_XXJ_WS_DURATIONTIMES_D: "持续时间，以秒为单位",
  T_42_XXJ_WS_DYNAMIC_FRICTION: "动摩擦力",
  T_42_XXJ_WS_EASY: "容易的",
  T_42_XXJ_WS_ENDTIMES: "结束时间",
  T_42_XXJ_WS_ENDTIMES_D: "计时结束时间，以秒为单位",
  T_42_XXJ_WS_ENERGYTHRESHOLD: "全局能量阈值",
  T_42_XXJ_WS_ENTITYVARNAME_D: "SelfRelative实体实体",
  T_42_XXJ_WS_EQUIPMENTATTACHMENT_D: "装备配件道具",
  T_42_XXJ_WS_EULERANGLETOQUATERNION_D: "将给定欧拉角转化为四元数",
  T_42_XXJ_WS_EXPONENTIATION_D: "求幂运算",
  T_42_XXJ_WS_EXTRABAGCAPACITY_D: "额外背包空间",
  T_42_XXJ_WS_FIST: "拳头",
  T_42_XXJ_WS_FONTTYPE: "字体枚举",
  T_42_XXJ_WS_FONTTYPE_D: "字体枚举",
  T_42_XXJ_WS_FORCESYNCVALUE: "强制同步GS状态",
  T_42_XXJ_WS_FORCESYNCVALUE_D: "ForceSyncValue",
  T_42_XXJ_WS_FORCESYNCVALUE_D1: "GS强制同步位置信息",
  T_42_XXJ_WS_FORCESYNCVALUE1: "GS强制同步位置信息",
  T_42_XXJ_WS_FORMULABLEENTITY_D: "可公式化属性的实体",
  T_42_XXJ_WS_FORWARD_D: "方向向量",
  T_42_XXJ_WS_FRICTION_COMBINE: "摩擦力组合方式",
  T_42_XXJ_WS_FUNCPOINT: "函数指针",
  T_42_XXJ_WS_FUNCPOINT_D: "函数指针指向某个函数实例，用以实现虚函数或者委托机制",
  T_42_XXJ_WS_GETMAPID_D: "获取场景地图ID",
  T_42_XXJ_WS_GETOFFVEHICLESTATUS: "离开载具",
  T_42_XXJ_WS_GETONASDRIVERSTATUS: "进入载具(司机)",
  T_42_XXJ_WS_GETONASPASSENGERSTATUS: "进入载具(乘客)",
  T_42_XXJ_WS_GETPLAYERTOKENCOUNTTODAY_D: "查找玩家今日token数据",
  T_42_XXJ_WS_GRAVITY: "全局重力",
  T_42_XXJ_WS_HANDHELDITEM: "当前手持物品",
  T_42_XXJ_WS_HANDHELDITEM_D: "当前手持物品",
  T_42_XXJ_WS_HARD: "困难的",
  T_42_XXJ_WS_HASCOMPONENT_D: "是否存在组件",
  T_42_XXJ_WS_HEIGHTLIST_D: "高度分段列表",
  T_42_XXJ_WS_INDEXLIST_D: "访问字符串的index列表",
  T_42_XXJ_WS_INSCENE: "在场景中",
  T_42_XXJ_WS_INSCENE_D: "在场景中",
  T_42_XXJ_WS_IS3D_D: "是否是3D音乐",
  T_42_XXJ_WS_ISCOUNTDOWN_D: "倒计时或正计时",
  T_42_XXJ_WS_ISLOOP: "是否循环",
  T_42_XXJ_WS_ISLOOP_D: "IsLoop",
  T_42_XXJ_WS_ISREPLAY_D: "是否从头开始",
  T_42_XXJ_WS_ISSWITCH_D: "为真的时候可以和相对运动组合，为假的时候可以和绝对运动组合",
  T_42_XXJ_WS_JEEP: "Jeep",
  T_42_XXJ_WS_JUMPSTATUS: "跳跃状态",
  T_42_XXJ_WS_LEFTVALUE: "左值",
  T_42_XXJ_WS_LEFTVALUE_D: "底数",
  T_42_XXJ_WS_LOGARITHM_D: "求对数算",
  T_42_XXJ_WS_LOOPABLE: "可循环组件",
  T_42_XXJ_WS_LOOPABLE_D: "可循环组件",
  T_42_XXJ_WS_MAPGETALLKEYS_D: "获取字典的所有key",
  T_42_XXJ_WS_MAPVALUE_D: "目标字典",
  T_42_XXJ_WS_MARKBTNHUD: "标记按钮hud开关",
  T_42_XXJ_WS_MATHE: "常数e",
  T_42_XXJ_WS_MATHPI: "常数pi",
  T_42_XXJ_WS_MAXDISTANCE_D: "最大距离",
  T_42_XXJ_WS_MICROPHONEBTNHUD: "语音(麦克风)按钮hud开关",
  T_42_XXJ_WS_MINDISTANCE_D: "最小距离",
  T_42_XXJ_WS_MISSIONID_D: "任务ID",
  T_42_XXJ_WS_MISSIONPROGRESS_D: "完成进度，不允许为负数",
  T_42_XXJ_WS_MODERATE: "中等难度",
  T_42_XXJ_WS_MONSTERTRUCK: "MonsterTruck",
  T_42_XXJ_WS_MOTORBIKE: "Motorbike",
  T_42_XXJ_WS_MOVEMENTSTATUS: "移动状态",
  T_42_XXJ_WS_MULTIPLYQUATERNION_D: "两四元数相乘（表示旋转叠加）",
  T_42_XXJ_WS_NORMAL: "正常的",
  T_42_XXJ_WS_OBSOLETE: "已废弃",
  T_42_XXJ_WS_OPENPLAYERVIEW: "开启玩家视角",
  T_42_XXJ_WS_OPENPLAYERVIEW_D: "开启玩家视角",
  T_42_XXJ_WS_ORIGINWEAPONTYPE: "武器类型",
  T_42_XXJ_WS_ORIGINWEAPONTYPE_D: "武器类型",
  T_42_XXJ_WS_OVERLOADPLAYERSKIN: "玩家配置优先",
  T_42_XXJ_WS_PARAMSARRAY: "参数列表",
  T_42_XXJ_WS_PARAMSARRAY_D: "参与输出的参数列表，需要和格式描述中的%v个数保持一致",
  T_42_XXJ_WS_PARAMSARRAY_D1: "传递给自定义函数的实参列表",
  T_42_XXJ_WS_PARTVISABLEMASK1: "部件显示掩码1",
  T_42_XXJ_WS_PARTVISABLEMASK2: "部件显示掩码2",
  T_42_XXJ_WS_PARTVISABLEMASK3: "部件显示掩码3",
  T_42_XXJ_WS_PARTVISABLEMASK4: "部件显示掩码4",
  T_42_XXJ_WS_PASSENGER1: "乘客1座位",
  T_42_XXJ_WS_PASSENGER2: "乘客2座位",
  T_42_XXJ_WS_PASSENGER3: "乘客3座位",
  T_42_XXJ_WS_PHYMAT: "物理材质",
  T_42_XXJ_WS_PLAYABLEENTITIES_D: "实体",
  T_42_XXJ_WS_PLAYABLERELATIVEFRAME: "相对自身每帧运动",
  T_42_XXJ_WS_PLAYABLERELATIVEFRAME_D: "相对自身每帧运动",
  T_42_XXJ_WS_PLAYABLESELFRELATIVE: "相对自身运动",
  T_42_XXJ_WS_PLAYABLESELFRELATIVE_D: "相对自身进行的运动",
  T_42_XXJ_WS_PLAYER_D: "需要上车的玩家",
  T_42_XXJ_WS_PLAYERBEHAVIOR: "玩家行为属性同步实体",
  T_42_XXJ_WS_PLAYERBEHAVIOR_D: "玩家行为属性同步实体",
  T_42_XXJ_WS_PRIORITY_D: "优先级",
  T_42_XXJ_WS_PROPID_D: "属性ID",
  T_42_XXJ_WS_QUATERNION: "四元数",
  T_42_XXJ_WS_QUATERNION_D: "四元数是一个特殊的四维向量，仅用于表示旋转",
  T_42_XXJ_WS_QUATERNIONTOAXISANGLE_D: "将四元数转化为轴角表示",
  T_42_XXJ_WS_QUATERNIONTOEULERANGLE_D: "将给定四元数转化为欧拉角，若传入的四元数不合法，返回(0,0,0)",
  T_42_XXJ_WS_REPEATTIMES_D: "播放次数，默认为1",
  T_42_XXJ_WS_RESETPLAYABLE_D: "重置",
  T_42_XXJ_WS_RIGHTVALUE: "右值",
  T_42_XXJ_WS_RIGHTVALUE_D: "指数",
  T_42_XXJ_WS_SEATTYPE: "载具座位枚举",
  T_42_XXJ_WS_SEPSTR_D: "用于分隔的字符串",
  T_42_XXJ_WS_SETPLAYERFALLINGDAMAGE_D: "设置玩家坠落伤害",
  T_42_XXJ_WS_SETTINGSBTNHUD: "设置按钮hud开关",
  T_42_XXJ_WS_SHOWPOSITION: "显示位置",
  T_42_XXJ_WS_SHOWPOSITION_D: "显示位置",
  T_42_XXJ_WS_SIGNALICOHUD: "网络按钮hud开关",
  T_42_XXJ_WS_SIMPLE: "简单的",
  T_42_XXJ_WS_SLERPQUATERNION_D: "从A到B进行四元数球形插值",
  T_42_XXJ_WS_SOUNDENTITY_D: "音效实体表示一个播放的音效",
  T_42_XXJ_WS_SPEAKERBTNHUD: "喇叭按钮hud开关",
  T_42_XXJ_WS_SPLITSTRING_D: "用某字符串作为分隔符，将字符串切割为一个切片",
  T_42_XXJ_WS_SPORTSCAR: "跑车",
  T_42_XXJ_WS_SPRINTSTATUS: "冲刺状态",
  T_42_XXJ_WS_SRCVAL_D: "起始值",
  T_42_XXJ_WS_STARTTICKCOUNT: "GS开始tick的时刻",
  T_42_XXJ_WS_STARTTICKCOUNT_D: "GS开始tick的时刻",
  T_42_XXJ_WS_STARTTIME_D: "开始时间",
  T_42_XXJ_WS_STARTTIME_D1: "启动时间",
  T_42_XXJ_WS_STATE_D: "玩家状态，活跃、击倒、死亡",
  T_42_XXJ_WS_STATE_D1: "判断该音效是否在播放中",
  T_42_XXJ_WS_STATIC_FRICTION: "静摩擦力",
  T_42_XXJ_WS_STRELEMS_D: "目标字符串集合",
  T_42_XXJ_WS_STRINGFINDAT_D: "根据index列表，返回最终合体字符串",
  T_42_XXJ_WS_STRINGJOIN_D: "以指定标识符链接字符串",
  T_42_XXJ_WS_STRINGLOWER_D: "字符串字符全转换为小写",
  T_42_XXJ_WS_STRINGSTRIP_D: "移除字符串两侧空白字符",
  T_42_XXJ_WS_STRINGUPPER_D: "字符串字符全转换为大写",
  T_42_XXJ_WS_STYLE_D: "DestVal",
  T_42_XXJ_WS_SUV: "Suv",
  T_42_XXJ_WS_SWITCH: "Switch",
  T_42_XXJ_WS_SWITCH_D: "为真的时候可以和相对运动组合，为假的时候必须和绝对运动组合否则属性会不正确生效",
  T_42_XXJ_WS_TARGETENTITY_D: "TargetEntity",
  T_42_XXJ_WS_TEAMROUNDSCOREBANNERHUD: "队伍回合得分横幅",
  T_42_XXJ_WS_TEAMSEQ_D: "队伍序号，对应队伍实体中的队伍序号属性",
  T_42_XXJ_WS_TEMPORARYSHIELD: "临时护盾值",
  T_42_XXJ_WS_TEMPORARYSHIELD_D: "临时护盾值",
  T_42_XXJ_WS_TEXT_D: "需要进行脏字过滤的原文本",
  T_42_XXJ_WS_THREESTATESWITCH: "三态开关",
  T_42_XXJ_WS_THROWINGKNIFE_D: "飞刀(可拾取)",
  T_42_XXJ_WS_THROWINGKNIFEBR_D: "飞刀",
  T_42_XXJ_WS_TUKTUK: "TukTuk",
  T_42_XXJ_WS_TWOTEAMLEADERBOARDHUD: "两队比赛详情",
  T_42_XXJ_WS_UNIQUEID: "UniqueID",
  T_42_XXJ_WS_UNIQUEID_D: "UniqueID",
  T_42_XXJ_WS_VALUE_D: "求的值",
  T_42_XXJ_WS_VECTOR3TOEULERANGLES_D: "方向向量转欧拉角",
  T_42_XXJ_WS_VEHICLEID: "载具ID",
  T_42_XXJ_WS_VEHICLESKINID: "车皮id",
  T_42_XXJ_WS_VERYHARD: "非常困难",
  T_42_XXJ_WS_VOLUME_D: "音量大小，默认为50",
  T_42_XXJ_WS_WEAPONTYPE_D: "武器的主类型",
  T_42_XXJ_WS_WORKSHOPCODE: "战场码",
  T_42_XXJ_WS_WORKSHOPCODE_D: "数据库对应的战场码",
  T_42_XXJ_WS_WORLDPOSITION: "世界坐标",
  T_42_XXJ_WS_WORLDPOSITION_D: "世界坐标",
  T_42_XYL_WS_ITEM275: "军用油罐",
  T_42_XYL_WS_ITEM276: "沙袋A",
  T_42_XYL_WS_ITEM277: "沙袋B",
  T_42_XYL_WS_ITEM278: "沙袋C",
  T_42_XYL_WS_ITEM279: "一个沙袋",
  T_42_XYL_WS_ITEM280: "双层别墅",
  T_42_XYL_WS_ITEM281: "军火工厂",
  T_42_XYL_WS_ITEM282: "石墙A",
  T_42_XYL_WS_ITEM283: "石墙B",
  T_42_XYL_WS_ITEM284: "石墙C",
  T_42_XYL_WS_ITEM285: "石墙D",
  T_42_XYL_WS_ITEM286: "军用物资箱A",
  T_42_XYL_WS_ITEM287: "铜币",
  T_42_XYL_WS_ITEM288: "银币",
  T_42_XYL_WS_ITEM289: "金币",
  T_42_XYL_WS_ITEM290: "钻石",
  T_42_XYL_WS_ITEM291: "碎钻",
  T_42_XYL_WS_ITEM292: "红宝石",
  T_42_XYL_WS_ITEM293: "绿宝石",
  T_42_XYL_WS_ITEM294: "蓝宝石",
  T_42_XYL_WS_ITEM295: "警告标识",
  T_42_XYL_WS_ITEM297: "废墟",
  T_42_XYL_WS_ITEM297TRUE: "控制装置",
  T_42_XYL_WS_ITEM298: "物资箱B",
  T_42_XYL_WS_ITEM299: "雪堆",
  T_42_XYL_WS_ITEM300: "高科技墙壁A",
  T_42_XYL_WS_ITEM301: "高科技墙壁B",
  T_42_XYL_WS_ITEM302: "冰雪石块F",
  T_42_XYL_WS_ITEM303: "冰雪石块E",
  T_42_XYL_WS_ITEM304: "高科技平台A",
  T_42_XYL_WS_ITEM305: "高科技楼梯A",
  T_42_XYL_WS_ITEM306: "勘探灯A",
  T_42_XYL_WS_ITEM307: "废墟挡板A",
  T_42_XYL_WS_ITEM308: "废墟挡板B",
  T_42_XYL_WS_ITEM309: "废墟钢铁支架A",
  T_42_XYL_WS_ITEM310: "废墟石块A",
  T_42_XYL_WS_ITEM311: "废墟石块B",
  T_42_XYL_WS_ITEM312: "废墟石块C",
  T_42_XYL_WS_ITEM313: "探照灯A",
  T_42_XYL_WS_ITEM314: "废墟钢筋A",
  T_42_XYL_WS_LOGICALOBJECT: "逻辑",
  T_42_XYL_WS_THEMEHIGHTECH: "高科技",
  T_42_XYL_WS_THEMEICE: "冰雪",
  T_42_XYL_WS_THEMEMILITARY: "军事",
  T_42_XYL_WS_THEMEOBJECTS: "主题物件",
  T_42_XYL_WS_TIMERCONTINUE: "计时器继续事件",
  T_42_XYL_WS_TIMERCYCLE: "循环次数",
  T_42_XYL_WS_TIMERDOWN: "倒计时",
  T_42_XYL_WS_TIMEREND: "计时器结束事件",
  T_42_XYL_WS_TIMEREVENT: "自定义事件",
  T_42_XYL_WS_TIMEREVENT1: "计时器控制",
  T_42_XYL_WS_TIMEREVENT2: "计时器事件流",
  T_42_XYL_WS_TIMERORDER: "计时方式",
  T_42_XYL_WS_TIMERPAUSE: "计时器暂停事件",
  T_42_XYL_WS_TIMERSTART1: "计时器启动时间",
  T_42_XYL_WS_TIMERSTART2: "计时器启动事件",
  T_42_XYL_WS_TIMERUP: "正计时",
  T_42_XYL_WS_TRIGGERTIME_MS: "触发时间（毫秒）",
  T_42_ZZ_GUILDWAR_AIRCRAFTDESC: "可多人使用的飞行器",
  T_42_ZZ_GUILDWAR_PERSONALSCORE: "个人积分",
  T_42_ZZ_GUILDWAR_SCORE: "积分",
  T_43_B_SKILL_DESC_MONKEYGOD: "变成树丛，持续[FFB300]{1}秒[-] ，冷却时间：[FFB300]{0}秒[-]。当悟空进行攻击或受到伤害时，将解除变身。若成功击倒玩家将重置冷却时间。",
  T_43_B_SKILL_DESC_Nanoscientist: "受到致死伤害时展开纳米护盾短暂免疫死亡，免疫伤害[FFB300]{0}s[-]，期间无法攻击或移动，随后生成[FFB300]{1}点[-]临时护盾，持续[FFB300]{2}s[-]。护盾消失时死亡。冷却时间：[FFB300]{3}s[-]。",
  T_43_B_SKILL_DESC_ORION: "用[FFB300]{0}点[-]猩红能量替换了EP。消耗[FFB300]{1}点[-]，将自身变为无法攻击且不受到任何伤害的形态，并每秒吸取周围[FFB300]{3}米[-]范围内的敌人[FFB300]{4}点[-]生命值，持续[FFB300]{2}秒[-]，期间自身减速[FFB300]{6}%[-]。冷却时间：[FFB300]{5}秒[-]。",
  T_43_CJ_F_A_RACER: "F1冠军队女面饰",
  T_43_CJ_F_B_RACER: "F1冠军队女裤子",
  T_43_CJ_F_H_RACER: "F1冠军队女头饰",
  T_43_CJ_F_HA_RACER: "F1冠军队女妆容",
  T_43_CJ_F_S_RACER: "F1冠军队女鞋子",
  T_43_CJ_F_T_RACER: "F1冠军队女上衣",
  T_43_CJ_M_A_RACER: "F1冠军队男面饰",
  T_43_CJ_M_B_MACHINERY: "机械降临男裤子",
  T_43_CJ_M_B_RACER: "F1冠军队男裤子",
  T_43_CJ_M_H_MACHINERY: "机械降临男头饰",
  T_43_CJ_M_H_RACER: "F1冠军队男头饰",
  T_43_CJ_M_HA_MACHINERY: "机械降临男妆容",
  T_43_CJ_M_S_MACHINERY: "机械降临男鞋子",
  T_43_CJ_M_S_RACER: "F1冠军队男鞋子",
  T_43_CJ_M_T_MACHINERY: "机械降临男上衣",
  T_43_CJ_M_T_RACER: "F1冠军队男上衣",
  T_43_H_CHARACTER_GEEK_N: "Geek ",
  T_43_H_VSK94_MAMBAS_N: "熟练度衔尾蛇主题",
  T_43_HJ_WS_OPTION8: "其他",
  T_43_HJ_WS_TEXTURE_BAMBOO: "竹子",
  T_43_HJ_WS_TEXTURE_BEACH: "沙滩",
  T_43_HJ_WS_TEXTURE_BRICK1: "砖墙A",
  T_43_HJ_WS_TEXTURE_BRICK2: "砖墙B",
  T_43_HJ_WS_TEXTURE_BRICK3: "砖墙C",
  T_43_HJ_WS_TEXTURE_CEMENT: "水泥地板",
  T_43_HJ_WS_TEXTURE_CEMENT2: "水泥",
  T_43_HJ_WS_TEXTURE_CRYSTAL: "水晶",
  T_43_HJ_WS_TEXTURE_GLASSLAND1: "草地A",
  T_43_HJ_WS_TEXTURE_GLASSLAND2: "草地B",
  T_43_HJ_WS_TEXTURE_ICE: "冰块",
  T_43_HJ_WS_TEXTURE_IRON: "铁地板",
  T_43_HJ_WS_TEXTURE_IRON2: "集装箱",
  T_43_HJ_WS_TEXTURE_LAVA: "岩浆",
  T_43_HJ_WS_TEXTURE_MARBLE: "大理石地板",
  T_43_HJ_WS_TEXTURE_NONE: "空",
  T_43_HJ_WS_TEXTURE_STONE: "石头",
  T_43_HJ_WS_TEXTURE_TEXTILE1: "桌布A",
  T_43_HJ_WS_TEXTURE_TEXTILE2: "桌布B",
  T_43_HJ_WS_TEXTURE_WOOD: "木头",
  T_43_HJ_WS_TEXTURE_WOODEN: "木地板A",
  T_43_HJ_WS_TEXTURE_WOODEN2: "木地板B",
  T_43_JH_WS_MAPTAG1: "新手友好",
  T_43_JH_WS_MAPTAG10: "新内容无聊",
  T_43_JH_WS_MAPTAG11: "奖励感不足",
  T_43_JH_WS_MAPTAG12: "奖励平衡失调",
  T_43_JH_WS_MAPTAG13: "进度感不明显",
  T_43_JH_WS_MAPTAG14: "对新手不友好",
  T_43_JH_WS_MAPTAG15: "新手引导混乱",
  T_43_JH_WS_MAPTAG16: "缺少新手引导",
  T_43_JH_WS_MAPTAG17: "中退的玩家多",
  T_43_JH_WS_MAPTAG18: "操作繁琐",
  T_43_JH_WS_MAPTAG19: "用户界面混乱",
  T_43_JH_WS_MAPTAG2: "喜欢新内容",
  T_43_JH_WS_MAPTAG20: "地图设计差",
  T_43_JH_WS_MAPTAG21: "爽快射击",
  T_43_JH_WS_MAPTAG22: "快节奏战斗",
  T_43_JH_WS_MAPTAG23: "开放世界探险",
  T_43_JH_WS_MAPTAG24: "剧情丰富",
  T_43_JH_WS_MAPTAG25: "成长系统",
  T_43_JH_WS_MAPTAG26: "运动模拟",
  T_43_JH_WS_MAPTAG27: "合作任务",
  T_43_JH_WS_MAPTAG28: "社交互动",
  T_43_JH_WS_MAPTAG29: "丰富副本",
  T_43_JH_WS_MAPTAG3: "玩家活跃",
  T_43_JH_WS_MAPTAG30: "自由探索",
  T_43_JH_WS_MAPTAG31: "挑战排名",
  T_43_JH_WS_MAPTAG32: "挑战成就",
  T_43_JH_WS_MAPTAG33: "货币兑换系统",
  T_43_JH_WS_MAPTAG4: "地图设计精致",
  T_43_JH_WS_MAPTAG40: "奖励多",
  T_43_JH_WS_MAPTAG41: "局内成长体验好",
  T_43_JH_WS_MAPTAG42: "Hot Training Grounds",
  T_43_JH_WS_MAPTAG43: "Hot Solo Tower",
  T_43_JH_WS_MAPTAG44: "Hot War Zone",
  T_43_JH_WS_MAPTAG5: "卡顿",
  T_43_JH_WS_MAPTAG6: "团队合作困难",
  T_43_JH_WS_MAPTAG7: "BUG多",
  T_43_JH_WS_MAPTAG8: "更新频率低",
  T_43_JH_WS_MAPTAG9: "局内活动乏味",
  T_43_JH_WS_SKILLSETAUTOPATHBOMB: "蜘蛛陷阱（Ryden）",
  T_43_SJ_WS_AIRDROP_ITEMS: "空投箱投放道具",
  T_43_SJ_WS_AIRDROP_NAME: "空投箱",
  T_43_SJ_WS_AIRDROP_TIME: "空投箱投放时间",
  T_43_SJ_WS_AIRDROP_UI_ITEM: "投放物品",
  T_43_SJ_WS_ANITRIGGER_AUTO: "是否自动播放",
  T_43_SJ_WS_ANITRIGGER_CENTER: "是否使用中心点播放",
  T_43_SJ_WS_ANITRIGGER_CLIP: "动画名",
  T_43_SJ_WS_ANITRIGGER_LOOP: "是否循环播放",
  T_43_SJ_WS_ANITRIGGER_NAME: "动画触发器界面组件",
  T_43_SJ_WS_RESET_ROUND: "每回合是否重置",
  T_43_SJ_WS_START_DROPTIME: "开始掉落时间（毫秒）",
  T_43_SJ_WS_TRIGGER_ANIMA: "动画触发器",
  T_43_SY_PETSKIN_AXOLOTL_WATERFEST24_N: "泰国泼水节主题宠物皮肤（蝾螈）(本地设计）",
  T_43_SY_VEHICLESKIN_MOTOBIKE_FIGHTER_N: "街头格斗争霸赛主题摩托车皮肤",
  T_43_WH_ITEM_SUPPLYBOX_DESC: "补充战斗中急需的弹药及医疗物资",
  T_43_WH_ITEM_SUPPLYBOX_NAME: "补给箱",
  T_43_WT_SKILL_DESC_DUMMY_REWORK: "生成一个自动前进的假人，持续[FFB300]{0}[-]秒，拥有[FFB300]{1}[-]点HP。当假人存在时，可再次使用技能，立即和假人调换位置。传送至多使用[FFB300]{2}[-]次，距离超过[FFB300]{3}[-]米将无法传送，且不能在[FFB300]{4}[-]秒内连续使用位置调换。假人被击毁时会标记击毁假人的玩家持续[FFB300]{5}[-]秒。技能冷却时间[FFB300]{6}[-]秒",
  T_43_WT_W_VSK94: "VSK94",
  T_43_XXJ_WS_ACTIVITYSKILL: "角色技能伤害",
  T_43_XXJ_WS_AIRDROP: "空投砸中伤害，僵尸自杀伤害",
  T_43_XXJ_WS_ALPHA: "透明度",
  T_43_XXJ_WS_ALPHA_D: "范围0~1，整体HUD的透明度",
  T_43_XXJ_WS_ANIMATIONCTRLID: "动画控制器资产ID",
  T_43_XXJ_WS_ANIMATIONCTRLID_D: "用以描述动画控制器资产的ID",
  T_43_XXJ_WS_AUDIOID: "音频资产ID",
  T_43_XXJ_WS_AUDIOID_D: "用以描述音频资产的ID",
  T_43_XXJ_WS_BACKGRCOLOR: "背景颜色",
  T_43_XXJ_WS_BACKGRCOLOR_D: "生命值边框和虚化底部的颜色",
  T_43_XXJ_WS_BURNING: "载具爆炸后燃烧伤害",
  T_43_XXJ_WS_CSVID: "配置表资产ID",
  T_43_XXJ_WS_CSVID_D: "用以描述配置表资产的ID",
  T_43_XXJ_WS_CURRENTHP: "生命值当前量",
  T_43_XXJ_WS_CURRENTHP_D: "生命值当前量",
  T_43_XXJ_WS_DAMAGEMAKER_D: "造成伤害的游戏实体",
  T_43_XXJ_WS_DAMAGEZONE: "伤害区伤害",
  T_43_XXJ_WS_DEFAULT: "缺省",
  T_43_XXJ_WS_DEFAULT_D: "默认",
  T_43_XXJ_WS_EFFECTID: "特效资产ID",
  T_43_XXJ_WS_EFFECTID_D: "用以描述特效资产的ID",
  T_43_XXJ_WS_FIGHTINGENTITY_D: "可战斗实体，能够进行攻击、受击、击杀等",
  T_43_XXJ_WS_FOLLOWTARGET: "跟随目标",
  T_43_XXJ_WS_FOLLOWTARGET_D: "必须跟随一个带有transform的entity",
  T_43_XXJ_WS_GAINHPCOLOR: "增加生命值颜色",
  T_43_XXJ_WS_GAINHPCOLOR_D: "生命值增加时，增加部分短暂地显示出这个颜色",
  T_43_XXJ_WS_ISNOFALLDAMAGE: "是否坠落时免伤",
  T_43_XXJ_WS_ISOPENTWEEN: "启用生命值变化效果",
  T_43_XXJ_WS_ISOPENTWEEN_D: "启用时，血量变化才会有不同颜色表现",
  T_43_XXJ_WS_KNOCKDOWN_D1: "玩家处于击倒状态",
  T_43_XXJ_WS_KNOCKDOWN_D2: "在被击杀时对击倒状态的处理方式设置",
  T_43_XXJ_WS_KNOCKDOWN_D3: "复活源类型, 玩家从倒地状态复活",
  T_43_XXJ_WS_KNOCKDOWNSTATE: "击倒设置",
  T_43_XXJ_WS_KNOCKDOWNSTATETYPE: "击倒状态处理方式枚举",
  T_43_XXJ_WS_KNOCKDOWNSTATETYPE_D: "击倒状态处理方式，保持缺省逻辑，跳过倒地状态，强制倒地状态",
  T_43_XXJ_WS_LEVEL: "等级",
  T_43_XXJ_WS_LEVEL_D: "等级",
  T_43_XXJ_WS_LEVEL_D1: "表示当前的僵尸等级",
  T_43_XXJ_WS_LINESPACING: "生命值隔断线间距",
  T_43_XXJ_WS_LINESPACING_D: "每两个隔断线之间的生命值量 <=0 则不显示",
  T_43_XXJ_WS_LOSEHPCOLOR: "失去生命值颜色",
  T_43_XXJ_WS_LOSEHPCOLOR_D: "生命值减少时，失去的部分短暂地显示这个颜色",
  T_43_XXJ_WS_MAINCOLOR: "主要颜色",
  T_43_XXJ_WS_MAINCOLOR_D: "生命值、等级和描边的颜色",
  T_43_XXJ_WS_MINISENTRY: "防御塔伤害",
  T_43_XXJ_WS_MINISENTRYATTACKTARGETTYPE_D: "防御塔攻击目标类型枚举",
  T_43_XXJ_WS_MISSILEEXPLODE: "类导弹武器伤害",
  T_43_XXJ_WS_MUSTKNOCKDOWN: "强制击倒",
  T_43_XXJ_WS_MUSTKNOCKDOWN_D: "强制击倒",
  T_43_XXJ_WS_OFFSET: "偏移位置",
  T_43_XXJ_WS_OFFSET_D: "相对于跟随目标的偏移",
  T_43_XXJ_WS_OILDRUMEXPLODE: "油桶爆炸伤害",
  T_43_XXJ_WS_ONCONTROLLERCOLLIDERHIT_D: "只有当控制器主动发生运动时才会触发",
  T_43_XXJ_WS_PLAYER_D: "游戏中的玩家实体，每位用户一个",
  T_43_XXJ_WS_PLAYERHEADHUD: "角色跟随头顶描述",
  T_43_XXJ_WS_PLAYERHEADHUD_D: "角色跟随头顶描述",
  T_43_XXJ_WS_PLAYERNAME: "名称",
  T_43_XXJ_WS_PLAYERNAME_D: "表示当前血条拥有者的名字信息",
  T_43_XXJ_WS_PLAYERORVEHICLE: "玩家或载具实体",
  T_43_XXJ_WS_PLAYERORVEHICLE_D: "指代玩家实体、载具实体类型的别名",
  T_43_XXJ_WS_SCALE: "缩放",
  T_43_XXJ_WS_SCALE_D: "决定整体HUD缩放大小,字体也一同缩放",
  T_43_XXJ_WS_SHOWDAMAGENUMBER: "显示伤害跳字",
  T_43_XXJ_WS_SHOWDAMAGENUMBER_D: "默认为true， 开启FF伤害跳字",
  T_43_XXJ_WS_SKIPKNOCKDOWN: "跳过击倒",
  T_43_XXJ_WS_SKIPKNOCKDOWN_D: "跳过击倒状态，直接死亡",
  T_43_XXJ_WS_SKIPSTAGGERANIMATION: "跳过坠落时的僵直动画",
  T_43_XXJ_WS_TEAM_D: "（已废弃，请使用TeamSeq）",
  T_43_XXJ_WS_TERRAIN: "地面组件",
  T_43_XXJ_WS_TERRAIN_D: "地面组件，无法修改任何属性，仅用于检测函数",
  T_43_XXJ_WS_TOTALHP: "生命值总量",
  T_43_XXJ_WS_TOTALHP_D: "生命值总量",
  T_43_XXJ_WS_TWEENENTITY: "插值运动实体",
  T_43_XXJ_WS_VEHICLEEXPLODE: "载具爆炸伤害",
  T_43_XXJ_WS_WIDTH: "显示长度",
  T_43_XXJ_WS_WIDTH_D: "血条部分在画面上显示的长度",
  T_43_XXJ_WS_ZOMBIE: "僵尸伤害",
  T_43_XYL_WS_DROIDFIST: "拳头（启示录）",
  T_43_XYL_WS_DROIDFLAME: "喷火器（启示录）",
  T_43_XYL_WS_JAPANESE: "日式",
  T_43_YU_WS_ADDGAMEEVENTLOGMAP_D: "自定义比赛埋点日志，用于用户体验数据分析",
  T_43_YU_WS_AIRDROPSTATE: "空投箱掉状态 1:准备 2:掉落中 3:着地",
  T_43_YU_WS_AIRDROPSTATE_D: "空投箱掉状态 1:准备 2:掉落中 3:着地",
  T_43_YU_WS_ANIMATIONCLIPID: "自定义动画资源ID",
  T_43_YU_WS_ANIMATIONCLIPID_D: "自定义动画资源ID",
  T_43_YU_WS_ASKBUYTARGET: "请求购买目标",
  T_43_YU_WS_ASKBUYTARGET_D: "想指定目标，发送请求购买消息",
  T_43_YU_WS_ASKEDLIST: "被请求的物品",
  T_43_YU_WS_ASKEDLIST_D: "被请求的物品列表",
  T_43_YU_WS_BACKGROUNDCOLOR1: "背景颜色1",
  T_43_YU_WS_BACKGROUNDCOLOR1_D: "上面背景颜色",
  T_43_YU_WS_BACKGROUNDCOLOR2: "背景颜色2",
  T_43_YU_WS_BACKGROUNDCOLOR2_D: "下面背景颜色",
  T_43_YU_WS_BATCHCOMBINERENDER: "合并子物件节点",
  T_43_YU_WS_BINDMONEYENTITYLIST: "绑定的货币实体列表",
  T_43_YU_WS_BINDMONEYENTITYLIST_D: "绑定的货币实体列表",
  T_43_YU_WS_BINDWALLETENTITYID: "绑定的钱包实体ID",
  T_43_YU_WS_BINDWALLETENTITYID_D: "绑定的钱包实体ID",
  T_43_YU_WS_CENTEROFFSET: "中心点偏移",
  T_43_YU_WS_CENTEROFFSET_D: "胶囊体碰撞盒的偏移值",
  T_43_YU_WS_COLLECTIONID: "藏品资产ID",
  T_43_YU_WS_COLLECTIONID_D: "藏品ID，用于资源信息收集",
  T_43_YU_WS_CREATEAIRDROPENTITY_D: "创建空投箱",
  T_43_YU_WS_CREATEUGCDAMAGENUM_D: "创建伤害跳字",
  T_43_YU_WS_CROSSPLATFORM_D: "选中后,如果在服务端调用,则发送给客户端,客户端调用则发送给服务端",
  T_43_YU_WS_CSROUNDRESULTHUD: "回合结果HUD",
  T_43_YU_WS_CSROUNDRESULTHUD_D: "每回合结束，展示结果",
  T_43_YU_WS_CURRENTEMOTECLIP: "当前播放的Emote动画资源ID",
  T_43_YU_WS_CURRENTEMOTECLIP_D: "当前播放的Emote动画资源ID",
  T_43_YU_WS_DAMAGE_D: "缩圈伤害量大小",
  T_43_YU_WS_DICTIONARY: "字典",
  T_43_YU_WS_DIRECTIONRULERHUD: "罗盘",
  T_43_YU_WS_DIRECTIONRULERHUD_D: "顶部罗盘",
  T_43_YU_WS_DOTWEEN_D: "是否执行补间动画",
  T_43_YU_WS_DROPITEMS_D: "空投箱携带物品",
  T_43_YU_WS_DURATION: "恢复速度（毫秒）",
  T_43_YU_WS_ENERGY: "能量(EP)恢复量",
  T_43_YU_WS_ENERGY_D: "EP修改值",
  T_43_YU_WS_EPHYSXPOSE_CREEPING: "趴",
  T_43_YU_WS_EPHYSXPOSE_CROUCHING: "蹲",
  T_43_YU_WS_EPHYSXPOSE_DASHING: "快速移动",
  T_43_YU_WS_EPHYSXPOSE_STANDING: "站立",
  T_43_YU_WS_EVENTID: "事件ID",
  T_43_YU_WS_EVENTID_D: "指代某个事件",
  T_43_YU_WS_FACTION: "阵营",
  T_43_YU_WS_FACTION_D: "阵营实体",
  T_43_YU_WS_FACTION_D1: "向阵营请救帮助购买",
  T_43_YU_WS_FINALRADIUS_D: "毒圈的最终半径",
  T_43_YU_WS_FIRSTAIDKIT: "医疗包",
  T_43_YU_WS_FIRSTAIDKIT_D: "医疗包",
  T_43_YU_WS_FIRSTPERSONMODEL: "新版第一人称视角相机",
  T_43_YU_WS_FIRSTPERSONMODEL_D: "新版第一人称视角相机",
  T_43_YU_WS_FONTCOLOR_D: "字体颜色",
  T_43_YU_WS_FONTSIZE_D: "字体大小",
  T_43_YU_WS_FORBIDEN: "禁用",
  T_43_YU_WS_FORBIDEN_D: "禁用Hud请求购买",
  T_43_YU_WS_FREEZINGTIME: "冰冻时间",
  T_43_YU_WS_FREEZINGTIME_D: "命中玩家后造成的冻结时间",
  T_43_YU_WS_GRAVITY: "自身受到的重力加速度",
  T_43_YU_WS_GRAVITY_D: "该重力加速度仅作用于该玩家控制器",
  T_43_YU_WS_HANDCATAPULT: "随身人间大炮",
  T_43_YU_WS_HANDCATAPULT_D: "随身人间大炮",
  T_43_YU_WS_HEALTH: "生命恢复量",
  T_43_YU_WS_HEALTH_D: "耐久恢复值",
  T_43_YU_WS_HEIGHT: "总高度，包括上下半球",
  T_43_YU_WS_HELPEDPLAYER_D: "被帮助的玩家玩家",
  T_43_YU_WS_HELPPLAYER_D: "帮助购买的玩家",
  T_43_YU_WS_HORIZONTALMAXANGLE: "右侧射界角度",
  T_43_YU_WS_HORIZONTALMINANGLE: "左侧射界角度",
  T_43_YU_WS_HUDTOGGLE: "HudToggle实体组件",
  T_43_YU_WS_HUDTOGGLE_D: "HudToggle实体，玩家通过Hud编辑器编辑的Hud",
  T_43_YU_WS_INHALER: "呼吸器",
  T_43_YU_WS_INHALER_D: "呼吸器",
  T_43_YU_WS_INITRADIUS_D: "毒圈的初始半径",
  T_43_YU_WS_INT64: "64位整数",
  T_43_YU_WS_INT64_D: "整数类型，64位带符号整型",
  T_43_YU_WS_ISAPPLYSHADOW: "投影",
  T_43_YU_WS_ISBOTTOMCOLLIDING: "底部是否发生了触碰",
  T_43_YU_WS_ISCURRENTEMOTELOOP: "当前播放的Emote动画是否循环",
  T_43_YU_WS_ISCURRENTEMOTELOOP_D: "当前播放的Emote动画是否循环",
  T_43_YU_WS_ISSIDECOLLIDING: "侧边是否发生了触碰",
  T_43_YU_WS_ISSLIDING: "是否正在滑落",
  T_43_YU_WS_ISTOPCOLLIDING: "上部是否发生了触碰",
  T_43_YU_WS_ITEM331: "高科技-设备A",
  T_43_YU_WS_ITEM332: "高科技-石块A",
  T_43_YU_WS_ITEM333: "高科技-屏幕A",
  T_43_YU_WS_ITEM334: "高科技-容器A",
  T_43_YU_WS_ITEM335: "高科技-集装箱A",
  T_43_YU_WS_ITEM336: "高科技-石沙发A",
  T_43_YU_WS_ITEM337: "高科技-交换机A",
  T_43_YU_WS_ITEM338: "高科技-高科技管道A",
  T_43_YU_WS_ITEM339: "高科技-金属平台A",
  T_43_YU_WS_ITEM340: "高科技-桌子A",
  T_43_YU_WS_ITEM341: "高科技-桌子B",
  T_43_YU_WS_ITEM342: "高科技-桌子C",
  T_43_YU_WS_ITEM343: "高科技-电脑A",
  T_43_YU_WS_ITEM344: "石头A",
  T_43_YU_WS_ITEM345: "石头B",
  T_43_YU_WS_ITEM346: "石头C",
  T_43_YU_WS_ITEM347: "石头D",
  T_43_YU_WS_ITEM348: "石头E",
  T_43_YU_WS_ITEM349: "石头F",
  T_43_YU_WS_ITEM350: "石头G",
  T_43_YU_WS_ITEM351: "日式-门帘A",
  T_43_YU_WS_ITEM352: "日式-门帘B",
  T_43_YU_WS_ITEM353: "日式-门帘C",
  T_43_YU_WS_ITEM354: "日式-楼梯组件A",
  T_43_YU_WS_ITEM355: "日式-围栏组件A",
  T_43_YU_WS_ITEM356: "日式-围栏组件B",
  T_43_YU_WS_ITEM357: "日式-围栏组件C",
  T_43_YU_WS_ITEM358: "日式-平台组件C",
  T_43_YU_WS_ITEM359: "日式-围墙组件B",
  T_43_YU_WS_ITEM360: "日式-大门组件B",
  T_43_YU_WS_ITEM361: "高科技-墙体组件D",
  T_43_YU_WS_ITEM362: "高科技-墙体组件B",
  T_43_YU_WS_ITEM363: "高科技-直角脚踢组件",
  T_43_YU_WS_LEFTCOLOR: "左边颜色",
  T_43_YU_WS_LEFTCOLOR_D: "左边颜色",
  T_43_YU_WS_LEFTPLAYERARRAY: "左边玩家数组",
  T_43_YU_WS_LEFTPLAYERARRAY_D: "左边玩家数组",
  T_43_YU_WS_LEFTSCORE: "左边得分",
  T_43_YU_WS_LEFTSCORE_D: "左边得分",
  T_43_YU_WS_LEFTSCOREAFTER: "左边最后得分",
  T_43_YU_WS_LEFTSCOREAFTER_D: "左边最后得分，用于播放得分切换动画",
  T_43_YU_WS_LEVELOBJECTID: "物件ID",
  T_43_YU_WS_LEVELOBJECTID_D: "描述物件的类型，需通过SceneEditPrefab配置表解析后再加载",
  T_43_YU_WS_LOCALPOSITION_D: "本地坐标系中的坐标",
  T_43_YU_WS_LOCALPOSITION_D1: "相对位置",
  T_43_YU_WS_LOCALPOSITION_D2: "相对于右下角锚点的位置",
  T_43_YU_WS_LOCALPOSITION_D3: "相对于锚点的位置",
  T_43_YU_WS_LOCALROTATION_D: "本地坐标系中的旋转角，XYZ分量分别是偏航角、俯仰角、翻滚角",
  T_43_YU_WS_LOCALROTATIONQ_D: "本地坐标系中的四元数",
  T_43_YU_WS_LOCALSCALE_D: "世界坐标系中缩放尺寸",
  T_43_YU_WS_MASS: "质量",
  T_43_YU_WS_MATERIALS: "材质列表",
  T_43_YU_WS_MATERIALS_D: "渲染要使用的材质列表",
  T_43_YU_WS_MAXSPEED: "最大绝对运动速度",
  T_43_YU_WS_MAXSPEED_D: "达到最大速度后，载具不会再提供马力，但载具可能超过该最大速度（例如通过下坡）",
  T_43_YU_WS_MESHID: "网格资产",
  T_43_YU_WS_MESHID_D: "用以描述网格资产的类型",
  T_43_YU_WS_MESHID1: "模型网格",
  T_43_YU_WS_MESHID1_D: "渲染要使用的模型网格",
  T_43_YU_WS_MINMOVEDISTANCE: "最小移动距离",
  T_43_YU_WS_MINMOVEDISTANCE_D: "小于该值的移动不会被执行。如非特殊需求建议保持为0",
  T_43_YU_WS_MODULE_AI: "AI",
  T_43_YU_WS_MODULE_AIRDROP: "空投",
  T_43_YU_WS_MODULE_ANIMATION: "动画",
  T_43_YU_WS_MODULE_AVATAR: "头像",
  T_43_YU_WS_MODULE_BASEATTRIBUTES: "基础属性",
  T_43_YU_WS_MODULE_BEHAVIOURTREE: "行为树",
  T_43_YU_WS_MODULE_BUFF: "BUFF",
  T_43_YU_WS_MODULE_CAMERA: "摄像机",
  T_43_YU_WS_MODULE_CHATCHANNEL: "聊天频道",
  T_43_YU_WS_MODULE_CHECKPOINT: "检查点",
  T_43_YU_WS_MODULE_COLLECTION: "藏品",
  T_43_YU_WS_MODULE_COMBAT: "战斗",
  T_43_YU_WS_MODULE_COMPONENT: "组件",
  T_43_YU_WS_MODULE_CONVERT: "转化",
  T_43_YU_WS_MODULE_CUSTOMIZEROOMPARAMETERS: "自定义房间参数",
  T_43_YU_WS_MODULE_DATABASE: "数据存储",
  T_43_YU_WS_MODULE_DYEING: "染色",
  T_43_YU_WS_MODULE_DYNAMICNAVMESH: "动态Navmesh",
  T_43_YU_WS_MODULE_ECONOMY: "经济",
  T_43_YU_WS_MODULE_FF_PLATFORM: "FF平台",
  T_43_YU_WS_MODULE_FOOTBALL: "足球",
  T_43_YU_WS_MODULE_FRAMERATEMODE: "帧率模式",
  T_43_YU_WS_MODULE_GAMERESULT: "积分与结算",
  T_43_YU_WS_MODULE_GLOBAL: "全局",
  T_43_YU_WS_MODULE_GLOBALSCRIPTS: "脚本-Global",
  T_43_YU_WS_MODULE_HANGUPANDCHEAT: "挂机与作弊",
  T_43_YU_WS_MODULE_HUD: "界面",
  T_43_YU_WS_MODULE_INPUTSYSTEM: "输入系统",
  T_43_YU_WS_MODULE_ITEMS: "物品",
  T_43_YU_WS_MODULE_LEVELOBJECT: "关卡物件",
  T_43_YU_WS_MODULE_LIST: "列表",
  T_43_YU_WS_MODULE_MAP: "字典",
  T_43_YU_WS_MODULE_MATCHING: "匹配",
  T_43_YU_WS_MODULE_MATH: "数学",
  T_43_YU_WS_MODULE_MECHANISM: "机制参数",
  T_43_YU_WS_MODULE_MINIMAP: "小地图",
  T_43_YU_WS_MODULE_MORPH: "玩家变身",
  T_43_YU_WS_MODULE_OTHER: "其他",
  T_43_YU_WS_MODULE_PET: "宠物",
  T_43_YU_WS_MODULE_PHYSICS: "物理",
  T_43_YU_WS_MODULE_PLAYABLE: "可播放",
  T_43_YU_WS_MODULE_PLAYER: "玩家",
  T_43_YU_WS_MODULE_PLAYERSCRIPTS: "脚本-Player",
  T_43_YU_WS_MODULE_PRESETCHARACTER: "预设角色 PresetCharacter",
  T_43_YU_WS_MODULE_PROFILE: "调试",
  T_43_YU_WS_MODULE_PROPERTYFORMULA: "属性公式",
  T_43_YU_WS_MODULE_SAFEZONE: "安全区",
  T_43_YU_WS_MODULE_SCENE: "场景",
  T_43_YU_WS_MODULE_SKILL: "技能",
  T_43_YU_WS_MODULE_STATICSCRIPTS: "静态脚本",
  T_43_YU_WS_MODULE_STATISTICALREPORT: "数据上报",
  T_43_YU_WS_MODULE_STDLIBRARY: "STD库",
  T_43_YU_WS_MODULE_STRINGS: "字符串",
  T_43_YU_WS_MODULE_TEAM: "队伍",
  T_43_YU_WS_MODULE_WORKFLOW: "流程",
  T_43_YU_WS_MONEYICON: "货币图标",
  T_43_YU_WS_MONEYICON_D: "货币图标",
  T_43_YU_WS_MONEYICONCOLOR: "货币图标颜色",
  T_43_YU_WS_MONEYICONCOLOR_D: "货币图标颜色",
  T_43_YU_WS_MOVESAFEZONE_D: "将毒圈平滑的从起点移动至终点，处于毒圈内的玩家会受到指定伤害",
  T_43_YU_WS_NEWVECTOR2: "构造二维向量",
  T_43_YU_WS_NEWVECTOR2_D: "获取一个新构造的二维向量",
  T_43_YU_WS_OFFSET_D: "相对于目标实体的世界位置偏移量",
  T_43_YU_WS_ONSHOPREQUESTFILLED_D: "当玩家请求购买被满足时",
  T_43_YU_WS_ONSHOPREQUESTPURCHASE_D: "当商店有玩家请求他人购买商品时",
  T_43_YU_WS_ONTOGGLECHANGE_D: "当Toggle控件状态变化时触发",
  T_43_YU_WS_OPENSTATE: "打开状态",
  T_43_YU_WS_OPENSTATE_D: "打开状态为true时则显示，否则关闭",
  T_43_YU_WS_PACEMAKER: "急救针",
  T_43_YU_WS_PACEMAKER_D: "急救针",
  T_43_YU_WS_PARAMS_D: "参数列表",
  T_43_YU_WS_PARENT_D: "序列化时记录的是entityID",
  T_43_YU_WS_PHYSICALCCT: "带物理效果的玩家控制器",
  T_43_YU_WS_PHYSICALCCT_D: "带物理效果的玩家控制器",
  T_43_YU_WS_PLAYER_D: "购买购买商品的玩家",
  T_43_YU_WS_PLAYERDATAID: "自定义角色资源ID",
  T_43_YU_WS_PLAYERDATAID_D: "自定义角色资源ID",
  T_43_YU_WS_PLAYERPHYSXPOSETYPE: "玩家姿态枚举",
  T_43_YU_WS_POSITION: "位置",
  T_43_YU_WS_POSITION_D: "世界坐标系中的坐标",
  T_43_YU_WS_POSITION_D1: "世界坐标系中的坐标,只有3D音乐有效",
  T_43_YU_WS_PRESSEDSPRITE: "按下图片",
  T_43_YU_WS_PRESSEDSPRITE_D: "按下图片",
  T_43_YU_WS_PRESSEDSPRITETYPE: "按下图片类型",
  T_43_YU_WS_PRESSEDSPRITETYPE_D: "按下图片类型",
  T_43_YU_WS_PRETIME: "使用所需时间（毫秒）",
  T_43_YU_WS_RADIUS: "上下半球的半径",
  T_43_YU_WS_RANDOMRANGE_D: "确定位置后，根据随机范围再次修正位置",
  T_43_YU_WS_REQUESTPURCHASETYPE: "请求购买类型",
  T_43_YU_WS_REQUESTPURCHASETYPE_D: "商店请求购买",
  T_43_YU_WS_REQUESTTYPE: "请求类型",
  T_43_YU_WS_REQUESTTYPE_D: "当前Hud玩家请求目标的类型",
  T_43_YU_WS_RESPLAYERUUID: "玩家资源ID",
  T_43_YU_WS_RESPLAYERUUID_D: "玩家资源ID",
  T_43_YU_WS_RESUUID: "资源UUID",
  T_43_YU_WS_RESUUID_D: "指定要渲染的Batch资源UUID",
  T_43_YU_WS_RIGHTCOLOR: "右边颜色",
  T_43_YU_WS_RIGHTCOLOR_D: "右边颜色",
  T_43_YU_WS_RIGHTPLAYERARRAY: "右边玩家数组",
  T_43_YU_WS_RIGHTPLAYERARRAY_D: "右边玩家数组",
  T_43_YU_WS_RIGHTSCORE: "右边得分",
  T_43_YU_WS_RIGHTSCORE_D: "右边得分",
  T_43_YU_WS_RIGHTSCOREAFTER: "右边最后得分",
  T_43_YU_WS_RIGHTSCOREAFTER_D: "右边最后得分，用于播放得分切换动画",
  T_43_YU_WS_ROTATIONQ_D: "世界坐标系中的四元数",
  T_43_YU_WS_ROUNDINFOHUD: "回合信息HUD",
  T_43_YU_WS_ROUNDINFOHUD_D: "回合开始展示的信息",
  T_43_YU_WS_SELECTEDCOLOR: "选中图片颜色",
  T_43_YU_WS_SELECTEDCOLOR_D: "选中图片颜色",
  T_43_YU_WS_SELECTEDSPRITE: "选中图片",
  T_43_YU_WS_SELECTEDSPRITE_D: "选中图片",
  T_43_YU_WS_SELECTEDTYPE: "选中图片类型",
  T_43_YU_WS_SELECTEDTYPE_D: "选中图片类型",
  T_43_YU_WS_SHADOWCOLOR: "投影颜色",
  T_43_YU_WS_SHADOWOFFSET: "投影偏移量",
  T_43_YU_WS_SHOWTAG: "是否显示队伍或阵营的标记点",
  T_43_YU_WS_SHOWTAG_D: "是否显示队伍或阵营的标记点",
  T_43_YU_WS_SHRINKDURATION_D: "缩圈持续时长",
  T_43_YU_WS_SIMPLERENDER_D: "桥接渲染组件，用于使用内置模型资源进行呈现",
  T_43_YU_WS_SKINWIDTH: "皮肤厚度",
  T_43_YU_WS_SKINWIDTH_D: "允许潜入改胶囊体的深度。可以防止角色被卡住或抖动",
  T_43_YU_WS_SLOPELIMIT: "最大上坡角度",
  T_43_YU_WS_SLOPELIMIT_D: "放置在超过该角度的坡面上，会向下滑动",
  T_43_YU_WS_SPEED: "出膛速度",
  T_43_YU_WS_STARTDROPTIME_D: "空投箱掉落时间 ms",
  T_43_YU_WS_STARTPOS_D: "毒圈的起始位置",
  T_43_YU_WS_STATICICONCOLORS: "在某刻度上显示的icon叠加色",
  T_43_YU_WS_STATICICONCOLORS_D: "在某刻度上显示的icon叠加色",
  T_43_YU_WS_STATICICONS: "在某刻度上显示的icon样式",
  T_43_YU_WS_STATICICONS_D: "在某刻度上显示的icon样式",
  T_43_YU_WS_STEPOFFSET: "步距垂直偏移",
  T_43_YU_WS_STEPOFFSET_D: "只有超过该高度的障碍物才会有阻挡效果",
  T_43_YU_WS_SUBTITLE: "副标题",
  T_43_YU_WS_SUBTITLE_D: "副标题",
  T_43_YU_WS_TARGET: "目标实体",
  T_43_YU_WS_TARGET_D: "需要弹伤害跳字的目标实体",
  T_43_YU_WS_TARGETICONCOLORS: "标记目标显示的icon的叠加色",
  T_43_YU_WS_TARGETICONCOLORS_D: "标记目标显示的icon的叠加色",
  T_43_YU_WS_TARGETICONS: "标记目标显示的icon样式",
  T_43_YU_WS_TARGETICONS_D: "标记目标显示的icon样式",
  T_43_YU_WS_TARGETPOS_D: "毒圈的终点位置",
  T_43_YU_WS_TEAM: "队伍",
  T_43_YU_WS_TEAM_D: "游戏中的队伍实体，每支队伍一个",
  T_43_YU_WS_TEAM_D1: "向队伍请救帮助购买",
  T_43_YU_WS_TIMEOFSTAY_D: "停留时长，单位毫秒",
  T_43_YU_WS_TITLE: "主标题",
  T_43_YU_WS_TITLE_D: "主标题",
  T_43_YU_WS_TRANSFORM_D: "位置旋转缩放和父子关系记录",
  T_43_YU_WS_UNSELECTEDCOLOR: "未选中图片颜色",
  T_43_YU_WS_UNSELECTEDCOLOR_D: "未选中图片颜色",
  T_43_YU_WS_UNSELECTEDSPRITE: "未选中图片",
  T_43_YU_WS_UNSELECTEDSPRITE_D: "未选中图片",
  T_43_YU_WS_UNSELECTEDTYPE: "未选中图片类型",
  T_43_YU_WS_UNSELECTEDTYPE_D: "未选中图片类型",
  T_43_YU_WS_USEPHYSICALCCT: "是否使用带物理效果的玩家控制器",
  T_43_YU_WS_VALUE_D: "显示的跳字内容",
  T_43_YU_WS_VECTOR2ADD: "二维向量相加",
  T_43_YU_WS_VECTOR2GETX: "二维向量取X分量",
  T_43_YU_WS_VECTOR2GETY: "二维向量取Y分量",
  T_43_YU_WS_VECTOR2SCALE: "二维向量缩放",
  T_43_YU_WS_VECTOR2SETX: "二维向量设置X分量",
  T_43_YU_WS_VECTOR2SETY: "二维向量设置Y分量",
  T_43_YU_WS_VECTOR2SUB: "二维向量相减",
  T_43_YU_WS_VELOCITY: "当前绝对速度",
  T_43_YU_WS_VERTICALMAXANGLE: "最大俯角",
  T_43_YU_WS_VERTICALMINANGLE: "最小仰角",
  T_43_YU_WS_VISIBILITY_D: "表示是否可以设置可见性",
  T_43_YU_WS_VISIBLE_D: "是否可见，当不可见时客户端停止渲染目标",
  T_43_YU_WS_X: "X",
  T_43_YU_WS_X_D: "X",
  T_43_YU_WS_Y: "Y",
  T_43_YU_WS_Y_D: "Y",
  T_43_ZY_WS_ITEM319: "高科技-墙体组件A",
  T_43_ZY_WS_ITEM320: "高科技-墙体组件C",
  T_43_ZY_WS_ITEM321: "高科技-窗户组件",
  T_43_ZY_WS_ITEM322: "高科技-门组件",
  T_43_ZY_WS_ITEM323: "高科技-屋顶直角组件",
  T_43_ZY_WS_ITEM324: "高科技-屋顶圆角组件",
  T_43_ZY_WS_ITEM325: "高科技-脚踢组件",
  T_43_ZY_WS_ITEM326: "高科技-圆角脚踢组件",
  T_43_ZY_WS_ITEM327: "高科技-楼梯组件",
  T_43_ZY_WS_ITEM328: "高科技-装饰组件A",
  T_43_ZY_WS_ITEM329: "高科技-建筑A",
  T_43_ZY_WS_ITEM330: "高科技-建筑B",
  T_44_CJ_M_B_SPORT_TH: "泰国运动（本地设计）男裤子",
  T_44_CJ_M_H_SPORT_TH: "泰国运动（本地设计）男头饰",
  T_44_CJ_M_S_SPORT_TH: "泰国运动（本地设计）男鞋子",
  T_44_CJ_M_T_SPORT_TH: "泰国运动（本地设计）男上衣",
  T_44_CJ_W_AIRBURST: "M590",
  T_44_H_CHARACTER_DUALMAN_N: "Dualman",
  T_44_H_M24_ONIMUSHA_N: "幻灵鬼火主题枪械",
  T_44_H_USP45_CARNIVORE_N: "肉食植物主题枪械",
  T_44_H_VEHICLESKIN_MOTOBIKE_COLLAGE_N: "炫酷拼贴主题摩托车",
  "T_44_HH_GOLD_AUG-I": "AUG-I",
  "T_44_HH_GOLD_AUG-II": "AUG-II",
  "T_44_HH_GOLD_AUG-III": "AUG-III",
  T_44_JH_WS_CLHALF1: "强制按最小开局人数匹配",
  T_44_JH_WS_HALFWAYKEY1: "优先满员开局",
  T_44_PD_PVE_DRAGON_NAME: "巨龙",
  T_44_QL_GRENADE_DRAGON: "龙焰手雷",
  T_44_QL_GRENADE_DRAGON_DES: "会在落点连续爆炸3次的冰冻手雷",
  T_44_QL_JUMPSHOESX: "推进鞋",
  T_44_QL_JUMPSHOESX_DES: "装备后在跳跃状态下再次跳跃可以进行空中的二段冲刺",
  T_44_SJ_WS_SAFEZONE_CLOSE_TIME: "安全区消失时间",
  T_44_SJ_WS_SAFEZONE_CLOSE_TIME_D: "安全区消失时间，安全区消失时间小于生效时间时不生成安全区",
  T_44_SJ_WS_SAFEZONE_COLOR: "安全区特效颜色",
  T_44_SJ_WS_SAFEZONE_DAMAGE_TIME: "伤害时间间隔",
  T_44_SJ_WS_SAFEZONE_DAMAGE_TIME_D: "伤害时间间隔",
  T_44_SJ_WS_SAFEZONE_DAMAGE_VALUE: "每次伤害量",
  T_44_SJ_WS_SAFEZONE_DAMAGE_VALUE_D: "对毒圈内的玩家单次的伤害量",
  T_44_SJ_WS_SAFEZONE_DESC: "可摆放的毒圈物件",
  T_44_SJ_WS_SAFEZONE_END_RADIUS: "毒圈结束圈半径",
  T_44_SJ_WS_SAFEZONE_END_RADIUS_D: "毒圈结束圈半径",
  T_44_SJ_WS_SAFEZONE_LIVE_PLAYERS: "安全区内玩家列表",
  T_44_SJ_WS_SAFEZONE_LIVE_PLAYERS_D: "获得安全区内的玩家列表",
  T_44_SJ_WS_SAFEZONE_NAME: "毒圈",
  T_44_SJ_WS_SAFEZONE_SHRINKTIME: "缩圈用时（秒）",
  T_44_SJ_WS_SAFEZONE_SHRINKTIME_D: "缩圈用时",
  T_44_SJ_WS_SAFEZONE_START_RADIUS: "毒圈起始圈半径",
  T_44_SJ_WS_SAFEZONE_START_RADIUS_D: "毒圈起始圈半径",
  T_44_SJ_WS_SAFEZONE_START_SHRINKTIME: "开始缩圈时间",
  T_44_SJ_WS_SAFEZONE_START_SHRINKTIME_D: "开始缩圈时间",
  T_44_SJ_WS_SAFEZONE_STARTTIME: "安全区生效时间",
  T_44_SJ_WS_SAFEZONE_STARTTIME_D: "安全区在局内每回合出现的时间，默认为 0",
  T_44_WT_W_FGG: "火焰榴弹枪",
  T_44_WT_W_REWORKHEAT_NAME_X: "PLASMA-X",
  T_44_XXJ_WS_ACTIVATEDALPHA: "激活透明度",
  T_44_XXJ_WS_ACTIVATEDALPHA_D: "激活透明度",
  T_44_XXJ_WS_ACTIVESKILLBTNHUD: "主动技能按钮hud开关",
  T_44_XXJ_WS_ADDCOMPONENT_D: "添加组件到实体上，仅支持用户自定义组件（当组件已存在时不会重复添加）",
  T_44_XXJ_WS_ALLMEMBERS: "所有成员",
  T_44_XXJ_WS_ALLOWPRESSEDOUTSIDE: "区域外保持触发",
  T_44_XXJ_WS_ALLOWPRESSEDOUTSIDE_D: "区域外保持触发",
  T_44_XXJ_WS_ARROWIMAGE: "方向箭头图片",
  T_44_XXJ_WS_ARROWIMAGE_D: "方向箭头图片",
  T_44_XXJ_WS_ARROWOFFSET: "方向箭头偏移",
  T_44_XXJ_WS_ARROWOFFSET_D: "方向箭头偏移",
  T_44_XXJ_WS_ARROWSIZE: "方向箭头尺寸",
  T_44_XXJ_WS_ARROWSIZE_D: "方向箭头尺寸",
  T_44_XXJ_WS_AUTOPLAY_D: "创建后自动播放",
  T_44_XXJ_WS_BACKGROUNDIMAGE: "底座图片",
  T_44_XXJ_WS_BACKGROUNDIMAGE_D: "底座图片",
  T_44_XXJ_WS_BACKGROUNDRADIUS: "底座半径",
  T_44_XXJ_WS_BACKGROUNDRADIUS_D: "底座半径",
  T_44_XXJ_WS_BAGSKINID: "背包皮肤ID",
  T_44_XXJ_WS_BAGSKINID_D: "背包皮肤ID",
  T_44_XXJ_WS_BONEPOSITION: "骨骼位置",
  T_44_XXJ_WS_BONEPOSITION_D: "骨骼节点的世界坐标",
  T_44_XXJ_WS_CCTMOVE: "将角色控制器位移一次",
  T_44_XXJ_WS_COLLIDER: "碰撞",
  T_44_XXJ_WS_COLLIDERCOLLECTION: "碰撞盒集",
  T_44_XXJ_WS_COLLIDERCOLLECTION_D: "用于描述碰撞形状的组件",
  T_44_XXJ_WS_COLOR: "颜色",
  T_44_XXJ_WS_CONTENT: "内容",
  T_44_XXJ_WS_CONTENT_D: "钱包内容是一堆货币",
  T_44_XXJ_WS_CONTEXT_D: "需要打印的内容",
  T_44_XXJ_WS_CROSSHAIRSHUD: "准星hud开关",
  T_44_XXJ_WS_CURVE_D: "Curve",
  T_44_XXJ_WS_EFFECTCOLOR_D: "表面贴图颜色",
  T_44_XXJ_WS_ENABLE: "是否启用",
  T_44_XXJ_WS_ENTITY_D: "实体",
  T_44_XXJ_WS_GETBAGSKINID_D: "获取玩家身上的背包皮肤配置",
  T_44_XXJ_WS_GETFACTION_D: "获取阵营",
  T_44_XXJ_WS_GETLOADEDSCENE_D: "获取当前已加载且未卸载的场景名列表",
  T_44_XXJ_WS_GETLOCALPLAYER_D: "获取当前客户端所属玩家",
  T_44_XXJ_WS_GROUPID: "GroupID",
  T_44_XXJ_WS_GROUPID_D: "内部逻辑使用",
  T_44_XXJ_WS_HUDJOYSTICK: "HudJoystick实体组件",
  T_44_XXJ_WS_HUDJOYSTICK_D: "Joystick实体，玩家通过Hud编辑器编辑的Hud",
  T_44_XXJ_WS_HUDTOUCHPAD: "HudTouchPad实体组件",
  T_44_XXJ_WS_HUDTOUCHPAD_D: "HudTouchPad实体，玩家通过Hud编辑器编辑的Hud",
  T_44_XXJ_WS_HUDWIDGETORCUSTOMHUD: "hud或hud控件 ",
  T_44_XXJ_WS_ICON: "图标",
  T_44_XXJ_WS_ICONISALWAYSSHOWN: "标记点始终显示在标尺上",
  T_44_XXJ_WS_ICONISALWAYSSHOWN_D: "标记点始终显示在标尺上",
  T_44_XXJ_WS_INACTIVATEDALPHA: "未激活透明度",
  T_44_XXJ_WS_INACTIVATEDALPHA_D: "未激活透明度",
  T_44_XXJ_WS_INVOKE_ARGS_MISMATCH: "调用时实参与形参数量不匹配，预期是{0}，实际是{1}",
  T_44_XXJ_WS_ISDYNAMICOBSTACLE: "是动态阻挡",
  T_44_XXJ_WS_ISDYNAMICOBSTACLE_D: "是否是NavMesh的动态阻挡",
  T_44_XXJ_WS_ISEND: "isEnd",
  T_44_XXJ_WS_ISEND_D: "isEnd",
  T_44_XXJ_WS_ISSERVERDRIVEN: "是否由服务器驱动",
  T_44_XXJ_WS_ISSERVERDRIVEN_D: "注意如果为false，则自定义物件无法由API驱动",
  T_44_XXJ_WS_ISSUC_D: "返回执行结果",
  T_44_XXJ_WS_JOYSTICKCAPDRAGRADIUS: "操纵杆拖拽半径",
  T_44_XXJ_WS_JOYSTICKCAPDRAGRADIUS_D: "操纵杆拖拽半径",
  T_44_XXJ_WS_JOYSTICKCAPIMAGE: "操纵杆图片",
  T_44_XXJ_WS_JOYSTICKCAPIMAGE_D: "操纵杆图片",
  T_44_XXJ_WS_JOYSTICKCAPRADIUS: "操纵杆半径",
  T_44_XXJ_WS_JOYSTICKCAPRADIUS_D: "操纵杆半径",
  T_44_XXJ_WS_LISTT_PLAYERSKILLID: "人物技能ID列表",
  T_44_XXJ_WS_LOOPTYPE_D: "循环类型",
  T_44_XXJ_WS_MIDGAMEEXITCONFIG: "中途退出配置",
  T_44_XXJ_WS_MOUNTABLE: "可以挂载子节点的实体",
  T_44_XXJ_WS_MOUNTABLE_D: "可以挂载子节点的实体",
  T_44_XXJ_WS_MOVEMENT: "位移",
  T_44_XXJ_WS_NAME_D: "名称",
  T_44_XXJ_WS_NATURALCONST: "自然常数",
  T_44_XXJ_WS_NATURALCONST_D: "自然常数枚举，减少重复定义",
  T_44_XXJ_WS_NOTIFYICONANIMATION_D: "播放icon动画效果",
  T_44_XXJ_WS_OFFSET_D: "底座默认偏移量",
  T_44_XXJ_WS_ONFIRE_D: "每一次子弹发射、出拳、近战攻击都可触发该事件",
  T_44_XXJ_WS_ONPLAYERSTANDUP_D: "当玩家从趴下/蹲下,站起时触发该事件",
  T_44_XXJ_WS_ONSTARTFIRE_D: "当玩家按下开火键时触发该事件",
  T_44_XXJ_WS_OPTION: "选项",
  T_44_XXJ_WS_PASSIVESKILLHUD: "被动技能UI开关",
  T_44_XXJ_WS_PHYSICALMOVER: "物理移动平台",
  T_44_XXJ_WS_PHYSICALMOVER_D: "该平台上的玩家会自动跟随移动和旋转",
  T_44_XXJ_WS_PHYSICALOBJECT: "物理对象",
  T_44_XXJ_WS_PHYSICALOBJECT_D: "可以对其施力",
  T_44_XXJ_WS_PI: "Π",
  T_44_XXJ_WS_PI_D: "Π，圆周率",
  T_44_XXJ_WS_PLAYERS: "玩家列表",
  T_44_XXJ_WS_PLAYERS_D: "玩家列表",
  T_44_XXJ_WS_PLAYERSKILLID: "人物技能ID",
  T_44_XXJ_WS_PLAYERSKILLID_D: "人物技能ID，对应于AvatarSkill.csv配置表",
  T_44_XXJ_WS_PREPHYSXPOSE_D: "玩家站起之前上一个姿态",
  T_44_XXJ_WS_PRINT: "打印",
  T_44_XXJ_WS_PRINTERROR: "打印报错",
  T_44_XXJ_WS_PRINTERROR_D: "将目标数据以报错形式打印到控制台",
  T_44_XXJ_WS_PRINTWARNING: "打印警告",
  T_44_XXJ_WS_PRINTWARNING_D: "将目标数据以警告形式打印到控制台",
  T_44_XXJ_WS_PRIORITIZEPLAYERSKIN: "玩家局外的皮肤配置优先",
  T_44_XXJ_WS_PRIORITIZEPLAYERSKIN_D: "玩家局外的皮肤配置优先",
  T_44_XXJ_WS_READCSVROWBYKEY_D: "通过列数和目标值读取表某一行单元格的内容",
  T_44_XXJ_WS_REMOVEBAGSKINID_D: "使玩家身上的背包皮肤配置为空",
  T_44_XXJ_WS_REMOVECOMPONENT_D: "从实体上移除组件，仅支持用户自定义组件",
  T_44_XXJ_WS_RESETBAGSKINID_D: "重置玩家身上的背包皮肤配置：恢复为玩家局外的背包皮肤配置",
  T_44_XXJ_WS_SETBAGSKINID_D: "设置玩家身上的背包皮肤配置",
  T_44_XXJ_WS_SETPARENTCLIENT_D: "支持Transform,SkeletonPart,Player,MountPoint组件的实体",
  T_44_XXJ_WS_SHOWBACKGROUND: "显示背景",
  T_44_XXJ_WS_SKINID_D: "背包皮肤ID,背包自身的皮肤配置",
  T_44_XXJ_WS_SPEED_D: "播放速度",
  T_44_XXJ_WS_TARGET: "目标对象",
  T_44_XXJ_WS_TARGET_D: "目标对象",
  T_44_XXJ_WS_TITLE: "标题",
  T_44_XXJ_WS_TYPEID_D: "组件类型ID, 仅支持用户自定义组件",
  T_44_XXJ_WS_UPLOADMATCHRESULT_D: "上传自定义结算信息",
  T_44_XXJ_WS_WARNINGCSVTYPE: "类型不匹配，无法正确读取表格内容",
  T_44_XXJ_WS_X_D: "X轴坐标",
  T_44_XXJ_WS_Y_D: "Y轴坐标",
  T_44_XYL_WS_CTZSAFEZONE: "自定义安全区",
  T_44_XYL_WS_CTZSAFEZONEDESC: "可以按照摆放位置和属性设置，生成安全区的起点和终点的装置",
  T_44_XYL_WS_HEMISPHERICALSHELL: "基础半球壳",
  T_44_XYL_WS_QUARTERCYLINDER: "基础1/4圆柱",
  T_44_XYL_WS_SQUAREPYRAMID: "基础四棱锥",
  T_44_XYL_WS_TORUS: "基础圆环",
  T_44_XYL_WS_TRIANGULARPYRAMID: "基础三棱锥",
  T_44_YU_WS_ADDGAMEEVENTLOGMAP: "自定义比赛埋点日志",
  T_44_YU_WS_ADDUSEREVENTLOGMAP: "用户埋点日志",
  T_44_YU_WS_ADDUSEREVENTLOGMAP_D: "自定义比赛埋点日志，用于用户体验数据分析",
  T_44_YU_WS_ITEM366: "军事-墙体组件A",
  T_44_YU_WS_ITEM367: "军事-墙体组件B",
  T_44_YU_WS_ITEM368: "军事-墙体组件C",
  T_44_YU_WS_ITEM369: "军事-墙体组件D",
  T_44_YU_WS_ITEM370: "军事-窗户组件A",
  T_44_YU_WS_ITEM371: "军事-窗户组件B",
  T_44_YU_WS_ITEM372: "军事-窗户组件C",
  T_44_YU_WS_ITEM373: "军事-门组件A",
  T_44_YU_WS_ITEM374: "军事-门组件B",
  T_44_YU_WS_ITEM375: "军事-屋顶直角组件A",
  T_44_YU_WS_ITEM376: "军事-屋顶直角组件B",
  T_44_YU_WS_ITEM377: "军事-楼梯组件A",
  T_44_YU_WS_ITEM378: "军事-楼梯组件B",
  T_44_YU_WS_ITEM379: "军事-立柱A",
  T_44_YU_WS_ITEM380: "军事-扶手组件A",
  T_45_C_WEAPON_CUST_ENTRANCE: "自定义",
  T_45_CJ_TREATMENTGUN_Y_N: "治疗手枪-Y",
  T_45_H_CHARACTER_ELECTRICGIRL_N: "Electricgirl",
  T_45_H_EMOTE_MVPDANCE_N: "夺冠庆祝Emote",
  "T_45_HH_GOLD_MAC10-I": "MAC10-I",
  "T_45_HH_GOLD_MAC10-II": "MAC10-II",
  "T_45_HH_GOLD_MAC10-III": "MAC10-III",
  T_45_HJ_CAMERA_INSPECTOR: "武器检视",
  T_45_HL_Moderation_fail_1: "很遗憾，您提交的项目未通过审核",
  T_45_HL_Moderation_fail_2: "涉及",
  T_45_HL_Moderation_fail_3: "涉及",
  T_45_HL_Moderation_fail_Location_1: "游戏内容",
  T_45_HL_Moderation_fail_reason_1: "有害内容",
  T_45_HL_Moderation_fail_reason_10: "违反社区准则",
  T_45_HL_Moderation_fail_reason_11: "影响游戏内经济或侵犯虚拟财产",
  T_45_HL_Moderation_fail_reason_2: "不当内容",
  T_45_HL_Moderation_fail_reason_3: "政治敏感",
  T_45_HL_Moderation_fail_reason_4: "虚假信息",
  T_45_HL_Moderation_fail_reason_5: "版权侵犯",
  T_45_HL_Moderation_fail_reason_6: "隐私侵犯",
  T_45_HL_Moderation_fail_reason_7: "安全问题",
  T_45_HL_Moderation_fail_reason_8: "仇恨言论",
  T_45_HL_Moderation_fail_reason_9: "垃圾信息",
  T_45_HL_Moderation_fail_reason_999: "其他问题",
  T_45_JH_WS_CLEMPTYOBJECT: "关卡物件组",
  T_45_JH_WS_PETSWITCH1: "在对局中是否显示宠物",
  T_45_QL_CSFPP_DES: "你将以第一人称的游戏视角进行CS模式规则下的对抗，目标是歼灭所有对手",
  T_45_QL_CSFPP_NAME: "第一人称CS模式",
  T_45_QL_CSFPP_RANKNAME: "第一人称模式",
  T_45_SJ_WS_REVIEW_23: "游戏内容",
  T_45_SJ_WS_REVIEW_24: "{0}涉及{1}",
  T_45_SJ_WS_REVIEW_25: "{0}{1}涉及{2}",
  T_45_SJ_WS_REVIEW_26: "[FFBA00]查看详细违规记录  >>[-]",
  T_45_SJ_WS_REVIEW_27: "审核失败",
  T_45_SJ_WS_REVIEW_28: "审核信息",
  T_45_SJ_WS_REVIEW_29: "共有{0}项内容涉及违规",
  T_45_SJ_WS_REVIEW_31: "未通过审核",
  T_45_SJ_WS_REVIEW_32: "异常原因导致审核失败",
  T_45_SJ_WS_REVIEW_TITLE: "违规详细信息",
  T_45_SJ_WS_VAULTTRIGGER_DES: "可触发翻越障碍物",
  T_45_SJ_WS_VAULTTRIGGER_DISTANCE: "翻越距离",
  T_45_SJ_WS_VAULTTRIGGER_DISTANCE_DES: "该属性可以改变玩家翻越动作的距离",
  T_45_SJ_WS_VAULTTRIGGER_HEIGHT: "翻越高度",
  T_45_SJ_WS_VAULTTRIGGER_HEIGHT_DES: "该值会控制玩家翻越时身体上下移动的高度",
  T_45_SJ_WS_VAULTTRIGGER_NAME: "翻越触发器",
  T_45_TYC_CL_TEMPLATE_WS: `歼灭玩法，在混乱的战斗中消灭所有的敌对队伍来获得胜利。
提供该玩法模式中的玩法规则设置，可以按照自己的需求编辑玩法参数。`,
  T_45_W_SPEEDMODE_FLIGHT_N: "飞行载具",
  T_45_XXJ_WS_ACTIONTYPE_D: "0为自动攻击，1为防御攻击，2为完全不攻击",
  T_45_XXJ_WS_ADDFRIEND: "添加好友",
  T_45_XXJ_WS_API: "API",
  T_45_XXJ_WS_AUTO: "全自动",
  T_45_XXJ_WS_BASEDATA: "基础数据",
  T_45_XXJ_WS_BOTH: "双端",
  T_45_XXJ_WS_BYHIERARCHY: "按层级结构排序",
  T_45_XXJ_WS_BYPRIORITYHIGHTOLOW: "按优先级从高到低",
  T_45_XXJ_WS_BYPRIORITYLOWTOHIGH: "按优先级从低到高",
  T_45_XXJ_WS_CAMERA: "相机",
  T_45_XXJ_WS_CAMERATYPE: "相机类型",
  T_45_XXJ_WS_CENTERINVISIBLE: "中心不可见",
  T_45_XXJ_WS_CLIENT: "客户端",
  T_45_XXJ_WS_COLLIDERID: "碰撞资源ID",
  T_45_XXJ_WS_COLLIDERID_D: "碰撞资源ID",
  T_45_XXJ_WS_COMPONENT: "组件",
  T_45_XXJ_WS_CURRENTCAMERA: "当前相机",
  T_45_XXJ_WS_CUSTOMPUSHFORCE: "自定义推力",
  T_45_XXJ_WS_DOUBLE: "双发",
  T_45_XXJ_WS_DUMP: "扔",
  T_45_XXJ_WS_ENABLEMOVEINMIDAIR: "空中是否可移动",
  T_45_XXJ_WS_ENABLEROTATEWITHGRAVITY: "是否跟随重力旋转朝向",
  T_45_XXJ_WS_ENUM: "枚举",
  T_45_XXJ_WS_EVENT: "事件",
  T_45_XXJ_WS_FILLAMOUNT: "填充值",
  T_45_XXJ_WS_FILLDIR: "填充方向",
  T_45_XXJ_WS_FIRETYPE: "开火类型",
  T_45_XXJ_WS_FIRETYPE_D: "开火类型",
  T_45_XXJ_WS_FIXEDDELTATIME: "固定帧更新间隔",
  T_45_XXJ_WS_FIXEDDELTATIME_D: "固定帧更新间隔，以毫秒为单位",
  T_45_XXJ_WS_FORWARD: "前方",
  T_45_XXJ_WS_FORWARD_D: "本地坐标轴z轴朝向",
  T_45_XXJ_WS_FUNCTIONTYPE: "功能类型",
  T_45_XXJ_WS_FUNCTIONTYPE_D: "功能类型",
  T_45_XXJ_WS_GETLOCALAIMDIRECTION_D: "本地玩家的瞄准方向",
  T_45_XXJ_WS_GETLOCALTIMESTAMP_D: "获取本地时间戳",
  T_45_XXJ_WS_GRADIENT: "渐变",
  T_45_XXJ_WS_GRADIENTBOTTOM: "底部渐变色",
  T_45_XXJ_WS_GRADIENTBOTTOMALPHA: "底部透明度",
  T_45_XXJ_WS_GRADIENTTOP: "顶部渐变色",
  T_45_XXJ_WS_GRADIENTTOPALPHA: "顶部透明度",
  T_45_XXJ_WS_HITPOSITION_D: "子弹击中部位的世界坐标",
  T_45_XXJ_WS_HUDSOCIALBUTTONWIDGET: "社交功能按钮控件",
  T_45_XXJ_WS_INVERTFILL: "反向填充",
  T_45_XXJ_WS_ISGROUNDED: "是否着地",
  T_45_XXJ_WS_ISSILENCE: "是否消音",
  T_45_XXJ_WS_ISSILENCE_D: "是否消音",
  T_45_XXJ_WS_ISSINGLESHOT: "是否单发",
  T_45_XXJ_WS_ISSINGLESHOT_D: "是否单发",
  T_45_XXJ_WS_JUMPHEIGHT: "跳跃高度",
  T_45_XXJ_WS_JUMPHEIGHT_D: "跳跃高度",
  T_45_XXJ_WS_LAYOUTSORTTYPE: "布局排序类型",
  T_45_XXJ_WS_LIGHT_D: "灯光",
  T_45_XXJ_WS_LOCAL: "本地",
  T_45_XXJ_WS_MAXMULTIJUMPNUM: "最大连续跳跃次数 ",
  T_45_XXJ_WS_MODULE: "模组",
  T_45_XXJ_WS_NONE: "没有",
  T_45_XXJ_WS_ONBEFOREHURT_D: "实体每次造成伤害前执行",
  T_45_XXJ_WS_ONDISABLE_D: "在实体不可用后执行",
  T_45_XXJ_WS_ONEACHLOOP_D: "当 可播放实体 每次循环，音效特效等实体只在客户端生效",
  T_45_XXJ_WS_ONENABLE_D: "在实体可用后执行",
  T_45_XXJ_WS_ONFIXEDUPDATE_D: "固定帧更新时，30FPS",
  T_45_XXJ_WS_ONFRIENDRELATIONCHANGE_D: "客户端事件：当好友信息更新时玩家新增、删除好友时触发",
  T_45_XXJ_WS_ONGAMEPAUSE_D: "调用游戏暂停API后，游戏暂停了，会触发该事件",
  T_45_XXJ_WS_ONGAMERESUME_D: "调用游戏恢复API后，游戏从暂停变成恢复会触发该事件",
  T_45_XXJ_WS_ONPLAYERSTOPDASH_D: "当玩家结束冲刺时",
  T_45_XXJ_WS_ONPLAYERSTOPSWIMSURFING_D: "当玩家结束使用水上滑板时",
  T_45_XXJ_WS_ONPLAYERSWIMSURFING_D: "当玩家使用水上滑板时",
  T_45_XXJ_WS_PHYSICALLAYER_D: "自定义物理层级，取值0~31",
  T_45_XXJ_WS_PLATFORMTYPE: "平台类型",
  T_45_XXJ_WS_PLATFORMTYPE_D: "平台类型",
  T_45_XXJ_WS_PLAYER: "玩家",
  T_45_XXJ_WS_PLAYERCCT: "用于FF角色的角色控制器",
  T_45_XXJ_WS_PLAYERCCT_D: "带物理效果的角色控制器，仅用于FF角色",
  T_45_XXJ_WS_PRIORITY: "优先级",
  T_45_XXJ_WS_REMAINMULTINUM: "剩余可连续跳跃次数 ",
  T_45_XXJ_WS_REPORT: "举报",
  T_45_XXJ_WS_RIGHT: "右方",
  T_45_XXJ_WS_RIGHT_D: "本地坐标轴x轴朝向",
  T_45_XXJ_WS_SERVER: "服务端",
  T_45_XXJ_WS_SINGLE: "单发",
  T_45_XXJ_WS_SOCIALBUTTONSTYLETYPE: "按钮样式",
  T_45_XXJ_WS_SOCIALBUTTONSTYLETYPE_D: "按钮样式",
  T_45_XXJ_WS_SOCIALBUTTONTYPE: "按钮类型",
  T_45_XXJ_WS_SOCIALBUTTONTYPE_D: "按钮类型",
  T_45_XXJ_WS_SORTTYPE_D: "排序方式：升序忽略零值、降序、升序",
  T_45_XXJ_WS_SPEEDWHILEAIMING: "开镜移速倍率",
  T_45_XXJ_WS_SPEEDWHILEAIMING_D: "开镜移速倍率",
  T_45_XXJ_WS_STRINGORLOCSTRING: "字符串或本地化字符串",
  T_45_XXJ_WS_TRIPLE: "三连发",
  T_45_XXJ_WS_UP: "上方",
  T_45_XXJ_WS_UP_D: "本地坐标轴y轴朝向",
  T_45_XXJ_WS_USECUSTOMPUSHFORCE: "是否使用自定义推力大小",
  T_45_XXJ_WS_Z: "Z",
  T_45_XXJ_WS_Z_D: "Z",
  T_45_ZD_VEHICLEDROP_R_DESC: "Throw a signal flare towards the designated area to summon a random vehicle",
  T_45_ZD_VEHICLEDROP_R_NAME: "Mystery Vehicle",
  T_46_H_CHARACTER_MISCHIEFGIRL_N: "乐子女角色名称",
  T_46_HJ_SHARE_GAMEDURATION: "游玩时长",
  T_46_HJ_WS_SHAREBY: "由 {0}",
  T_46_HJ_WS_SHAREGAMEMODE: "游戏模式",
  T_46_HJ_WS_SHARETEAM: "队伍",
  T_46_HJ_WS_SHARETEAMVS: "{0}对决{1}",
  T_46_HX_B_SCHOOL_VN: "越南开学季校服裤子",
  T_46_HX_H_SCHOOL_VN: "越南开学季校服头饰",
  T_46_HX_S_SCHOOL_VN: "越南开学季校服鞋子",
  T_46_HX_T_SCHOOL_VN: "越南开学季校服上衣",
  T_46_JH_WS_CLGUIDE_TUTORIAL: "教程",
  T_46_LYF_RANKBOARD_TIPS_OTHERS: "其他 ",
  T_46_XXJ_WS_ACTUALPOSITION: "实际位置",
  T_46_XXJ_WS_ADDSPECIALFOLLOW_D: "添加AOI特别关注，实现视距外AOI同步",
  T_46_XXJ_WS_APPEARANCE: "外观",
  T_46_XXJ_WS_APPEARANCERES: "外观资源",
  T_46_XXJ_WS_BECOME: "成为会员",
  T_46_XXJ_WS_BRAKETORQUE_D: "使用倒车/刹车键时，载具获得的马力",
  T_46_XXJ_WS_CAMERAVIEWINGANGLERESTRICTIONTYPE: "镜头转动角度限制类型",
  T_46_XXJ_WS_CLEANSPECIALFOLLOW_D: "清空指定目标的全部AOI特别关注",
  T_46_XXJ_WS_CRASHMAXDAMAGE_D: "用于撞人的伤害计算，最高伤害",
  T_46_XXJ_WS_CRASHMAXSPEED: "撞击伤害速度上限",
  T_46_XXJ_WS_CRASHMAXSPEED_D: "用于撞人的伤害计算，超过该速度后，伤害也不会提升",
  T_46_XXJ_WS_CRASHMESSFACTOR: "撞击质量参数",
  T_46_XXJ_WS_CRASHMESSFACTOR_D: "用于撞人的伤害计算，运用伤害公式的参数",
  T_46_XXJ_WS_CRASHMINDAMAGE_D: "用于撞人的伤害计算，最低伤害",
  T_46_XXJ_WS_DB_OVERLIMIT_D: "数据存储读写频次超出限制",
  T_46_XXJ_WS_DB_PARAMERROR_D: "参数异常",
  T_46_XXJ_WS_DB_TIMEOUT_D: "数据存储超时，现在主要针对读取操作",
  T_46_XXJ_WS_DELTA: "目标旋转角，四元数",
  T_46_XXJ_WS_EDITNPCCOLLIDERTIPS: "编辑外观",
  T_46_XXJ_WS_ENDVALUE_D: "DestVal",
  T_46_XXJ_WS_ENGINETORQUE_D: "使用油门键时，载具获得的马力",
  T_46_XXJ_WS_ERRORCODE_D: "错误码枚举",
  T_46_XXJ_WS_EULARANGLETOVECTOR3: "欧拉角转方向向量",
  T_46_XXJ_WS_EULARANGLETOVECTOR3_D: "欧拉角转方向向量",
  T_46_XXJ_WS_EXPIRE: "会员到期",
  T_46_XXJ_WS_FEMALEAVATAR: "女性角色",
  T_46_XXJ_WS_GETPREMIUMEXPIREDATE: "获取会员到期时间",
  T_46_XXJ_WS_HASSPECIALFOLLOW_D: "判断是否存在AOI特别关注",
  T_46_XXJ_WS_HELICOPTER: "直升机",
  T_46_XXJ_WS_HELICOPTER_D: "直升机载具",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLE: "高速转向限制",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLE_D: "在高速状态下，最大转向角度",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLEATSPEED: "高速转向限制速度阈值",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLEATSPEED_D: "高速最大转向角度应用的速度阈值",
  T_46_XXJ_WS_IDLE: "待机动画",
  T_46_XXJ_WS_IDLEBRAKEINPUT: "无操控停车马力比例",
  T_46_XXJ_WS_IDLEBRAKEINPUT_D: "未对载具进行操控时，以IdleBrakeInput乘以BrakeTorque对载具进行减速",
  T_46_XXJ_WS_INTTOFLOAT: "整数转浮点",
  T_46_XXJ_WS_INTTOFLOAT_D: "整型转浮点",
  T_46_XXJ_WS_ISPREMIUM: "判断玩家是否是会员",
  T_46_XXJ_WS_LEADERBOARDNAME_D: "数据库中表名",
  T_46_XXJ_WS_MALEAVATAR: "男性角色",
  T_46_XXJ_WS_MODULE_AICHARACTOR: "智能角色",
  T_46_XXJ_WS_NEWUMAAPPEARANCE: "新建UMA外观",
  T_46_XXJ_WS_NONE_D: "没有错误",
  T_46_XXJ_WS_NPC: "NPC",
  T_46_XXJ_WS_NPC_D: "NPC物件",
  T_46_XXJ_WS_NPCCOLLIDERTIPS: "建议：人形NPC的碰撞一般为高1.4米，半径0.25米的胶囊体；宠物NPC的碰撞一般为高1米，半径0.4米的胶囊体",
  T_46_XXJ_WS_OBSERVER_D: "特别关注的观察者",
  T_46_XXJ_WS_ONPLAYERENTERPREMIUMCENTER: "进入会员中心时",
  T_46_XXJ_WS_ONPLAYERLEAVEPREMIUMCENTER: "离开会员中心时",
  T_46_XXJ_WS_OPENPREMIUMCENTER: "唤起会员中心",
  T_46_XXJ_WS_PERSONA: "智能体",
  T_46_XXJ_WS_PERSONACENTER: "智能体管理中心",
  T_46_XXJ_WS_PET: "宠物",
  T_46_XXJ_WS_PLAYERORTRANSFORM: "玩家或Transform实体",
  T_46_XXJ_WS_PLAYERORTRANSFORM_D: "指代玩家实体、Transform实体类型的别名",
  T_46_XXJ_WS_PREMIUM: "会员",
  T_46_XXJ_WS_PREMIUMSTATUS: "会员变化状态",
  T_46_XXJ_WS_PROXYOBSERVER: "观察者代理",
  T_46_XXJ_WS_PROXYOBSERVER_D: "观察者代理",
  T_46_XXJ_WS_REMOVESPECIALFOLLOW_D: "移除AOI特别关注，取消视距外AOI同步",
  T_46_XXJ_WS_RENEWAL: "会员续费",
  T_46_XXJ_WS_ROTATEVECTOR: "根据四元数旋转向量",
  T_46_XXJ_WS_ROTATEVECTOR_D: "根据四元数旋转向量",
  T_46_XXJ_WS_SKIN: "服饰",
  T_46_XXJ_WS_STARTVALUE_D: "SrcVal",
  T_46_XXJ_WS_STATUS: "状态",
  T_46_XXJ_WS_SWITCHUSERPROXYOBSERVER_D: "切换User的代理观察者",
  T_46_XXJ_WS_TARGET_D: "特别关注的目标",
  T_46_XXJ_WS_USER_D: "玩家",
  T_46_XXJ_WS_VALUE: "值",
  T_46_XXJ_WS_VALUE_D: "向量",
  T_46_XYL_WS_CTZSAFEZONEEND: "安全区终点",
  T_46_XYL_WS_RESOURCETYPE1: "基础元件",
  T_46_XYL_WS_RESOURCETYPE1_1: "几何体",
  T_46_XYL_WS_RESOURCETYPE1_2: "视听效果",
  T_46_XYL_WS_RESOURCETYPE2: "场景道具",
  T_46_XYL_WS_RESOURCETYPE2_2: "战斗物资",
  T_46_XYL_WS_RESOURCETYPE3: "自然",
  T_46_XYL_WS_RESOURCETYPE4: "模块化构件",
  T_46_XYL_WS_TYPEOTHERPROP: "其他摆件",
  T_46_XYL_WS_TYPEOTHERPROPBOX: "箱体",
  T_47_CJ_FOREGRIP_SOFT_N: "轻量化战术握把",
  T_47_CJ_MAGEZINE_FAST_N: "快速扩容弹匣",
  T_47_CJ_STOCK_FAST_N: "高性能枪托",
  T_47_GT_WS_USERMANUAL: "用户手册",
  T_47_HJ_WS_VFX_FOG: "云雾特效",
  T_47_HJ_WS_VFX_LIGHTING: "光线特效",
  T_47_HJ_WS_VFX_TRAILING: "拖尾特效",
  T_47_HL_CL_CREATOR_LABEL1: "社区创作者",
  T_47_HL_CL_MAP_LABEL1: "社区创作者作品",
  T_47_JH_WS_MODERATION_REASON12: "赌博内容",
  T_47_RW_NB_GP_GAMEAFFIX_HINT1: "火影忍者联动",
  T_47_SD_RES_MATERIAL: "材质文件",
  T_47_SD_RES_MESH: "网格",
  T_47_SD_WS_MAPTAG_AI: "智能生成地图",
  T_47_WT_W_NB_GP_KA_EXPLODE_DESC: "投掷后会固定在落点，经过延迟发生火属性爆炸，并造成燃烧伤害",
  T_47_WT_W_NB_GP_KA_EXPLODE_NAME: "爆炸苦无",
  T_47_WT_W_NB_GP_KA_THUNDER_DESC: "投掷后会固定在落点，经过延迟发生雷属性爆炸，并造成雷电麻痹",
  T_47_WT_W_NB_GP_KA_THUNDER_NAME: "雷电苦无",
  T_47_WT_W_NB_GP_KA_WIND_DESC: "投掷后会固定在落点，经过延迟发生风属性爆炸，并朝爆炸中心造成减速",
  T_47_WT_W_NB_GP_KA_WIND_NAME: "风遁苦无",
  T_47_WT_W_NB_GP_SRK_HEAVY_DESC: `用于中远距离作战的手里剑忍具，一次攻击投掷1发，伤害较高，飞行速度较快
`,
  T_47_WT_W_NB_GP_SRK_HEAVY_NAME: `重型手里剑
`,
  T_47_WT_W_NB_GP_SRK_LIGHT_DESC: `用于近中距离作战的手里剑忍具，一次攻击投掷3发，伤害较低，具有两种攻击模式
`,
  T_47_WT_W_NB_GP_SRK_LIGHT_NAME: `轻型手里剑
`,
  T_47_XXJ_WS_ACTION: "Persona行为",
  T_47_XXJ_WS_AOISETTING: "区域过滤选项",
  T_47_XXJ_WS_BAGSKINTYPE: "背包皮肤类型",
  T_47_XXJ_WS_CLEARMEMORY: "清除记忆",
  T_47_XXJ_WS_CLNPC: "完全体NPC",
  T_47_XXJ_WS_CLOTHTYPE: "皮肤类型",
  T_47_XXJ_WS_COMMON_ERROR: "通用错误",
  T_47_XXJ_WS_CONTENT: "内容",
  T_47_XXJ_WS_CREATERANDOMSEED: "创建随机种子",
  T_47_XXJ_WS_ELAPSEDPERCENTAGE: "已过百分比",
  T_47_XXJ_WS_ENABLEUGCFOGFEATURE: "开启雾效特性",
  T_47_XXJ_WS_ENABLEUGCLIGHTROTATEFEATURE: "开启主光源旋转角度特性",
  T_47_XXJ_WS_ERRORCODE: "错误码",
  T_47_XXJ_WS_EXPONENTIAL: "指数雾效",
  T_47_XXJ_WS_EXPONENTIALSQUARED: "指数平方雾效",
  T_47_XXJ_WS_FAILED_INVALIDALLIDSONCREATE: "创建房间失败：无有效PersonaIDs",
  T_47_XXJ_WS_FOG: "雾效功能开关",
  T_47_XXJ_WS_FOGDENSITY: "指数雾的密度",
  T_47_XXJ_WS_FOGENDDISTANCE: "线性雾的结束距离",
  T_47_XXJ_WS_FOGMODE: "雾效模式",
  T_47_XXJ_WS_FOGMODETYPE: "雾效基础类型",
  T_47_XXJ_WS_FOGSTARTDISTANCE: "线性雾的起始距离",
  T_47_XXJ_WS_HEIGHTSCALE: "高度缩放",
  T_47_XXJ_WS_ISVISIBLE: "打开状态",
  T_47_XXJ_WS_JOINNEWTEAM: "加入新队伍",
  T_47_XXJ_WS_JOINTEAM: "加入队伍",
  T_47_XXJ_WS_LIGHTROTATE: "主光源旋转角度",
  T_47_XXJ_WS_LINEAR: "线性雾效",
  T_47_XXJ_WS_LLMCHATHUD: "Persona聊天界面",
  T_47_XXJ_WS_NEWTEAM: "新队伍",
  T_47_XXJ_WS_NEXT: "获取下一个随机数",
  T_47_XXJ_WS_NPC_TIP: "支持编辑NPC的外观，并且让NPC播放动画",
  T_47_XXJ_WS_OBSERVERS: "观察者列表",
  T_47_XXJ_WS_ONHUDSENDMESSAGETOPERSONA: "当玩家通过内置界面给Persona发送用户消息时",
  T_47_XXJ_WS_ONPREMIUMCHANGE: "当会员信息改变时",
  T_47_XXJ_WS_ONRECEIVEACTIONFROMPERSONA: "当收到Persona触发的行为时",
  T_47_XXJ_WS_ONRECEIVECONTENTFROMPERSONA: "当收到Persona消息内容时",
  T_47_XXJ_WS_ONRECEIVEFINISHFROMPERSONA: "当收到Persona消息结束时",
  T_47_XXJ_WS_ONRECEIVESTATUSFROMPERSONA: "当收到Persona消息状态码时",
  T_47_XXJ_WS_PARTICLESID: "粒子资产ID",
  T_47_XXJ_WS_PERSONAAVATAR: "Persona头像",
  T_47_XXJ_WS_PERSONAID: "智能体ID",
  T_47_XXJ_WS_PERSONANICKNAME: "Persona昵称",
  T_47_XXJ_WS_PLAYERORNPC: "玩家或NPC",
  T_47_XXJ_WS_PREMIUM_CLOSED: "商业化服务关闭",
  T_47_XXJ_WS_RANDOM: "随机数生成器",
  T_47_XXJ_WS_SEED: "种子",
  T_47_XXJ_WS_SENDER: "发送者",
  T_47_XXJ_WS_SETPERSONAOBSERVER: "设置Persona观察者",
  T_47_XXJ_WS_SETPLAYERCANQUITMIDWAY: "设置玩家是否可以中途退出",
  T_47_XXJ_WS_SHOULDREPLY: "是否回复",
  T_47_XXJ_WS_SHOWSYSTEMREPLY: "显示系统消息回复",
  T_47_XXJ_WS_SPOTANGLE: "聚光锥的角度以度为单位",
  T_47_XXJ_WS_SPOTLIGHT: "聚光灯",
  T_47_XXJ_WS_SYSTEMMESSAGETOPERSONA: "给Persona发送系统消息 ",
  T_47_XXJ_WS_SYSTEMMESSAGETOPERSONASTREAM: "流式给Persona发送系统消息",
  T_47_XXJ_WS_TARGETTEAM: "目标队伍",
  T_47_XXJ_WS_THISENTITY: "此实体",
  T_47_XXJ_WS_USERAVATAR: "用户头像 ",
  T_47_XXJ_WS_USERMESSAGETOPERSONA: "给Persona发送用户消息 ",
  T_47_XXJ_WS_USERMESSAGETOPERSONASTREAM: "流式给Persona发送用户消息",
  T_47_XXJ_WS_USERNICKNAME: "用户昵称 ",
  T_47_XXJ_WS_VEHICLESKINTYPE: "载具皮肤类型",
  T_47_XXJ_WS_WEAPONSKINTYPE: "枪械皮肤类型",
  T_47_XYL_NB_UGC_EFFECT001: "螺旋丸特效",
  T_47_XYL_NB_UGC_EFFECT002: "千鸟特效",
  T_47_XYL_NB_UGC_EFFECT003: "樱花冲特效",
  T_47_XYL_NB_UGC_EFFECT004: "火遁 · 豪火球之术特效",
  T_47_XYL_NB_UGC_EFFECT005: "水遁 · 水龙弹之术特效",
  T_47_XYL_NB_UGC_EFFECT006: "风遁大突破特效",
  T_47_XYL_NB_UGC_EFFECT007: "尾兽玉特效",
  T_47_XYL_NB_UGC_EFFECT008: "秽土转生咒文特效",
  T_47_XYL_UGC_CRAFTLANDSHOP: "资源库",
  T_47_XYL_UGC_DONKEYCART: "驴车",
  T_47_XYL_UGC_SPOTLIGHT: "聚光灯",
  T_47_XYL_UGC_SPOTLIGHTANGLE: "光照角度",
  T_48_H_EMOTE_WATERFEST25_N: "泰国泼水节主题Emote",
  T_48_H_VEHICLESKIN_MOTOBIKE_WATERFEST25_N: "泰国泼水节主题 摩托车皮肤 ",
  T_48_HJ_AC_STATENOTEXIST: "动画控制器中不存在状态{0}",
  T_48_HL_CODESCRIPT: "脚本文件",
  T_48_HL_GLOBAL_VAR: "全局变量名称",
  T_48_HL_GRAPH: "图元",
  T_48_HL_HUD: "HUD",
  T_48_HL_LEADERBOARD_NAME: "排行榜",
  T_48_HL_LOCAL_VAR: "本地变量名称",
  T_48_HL_LOCALIZATION: "本地化名称",
  T_48_HL_OPEN_ATTRIBUTES: "开放属性名称",
  T_48_HX_A_WATERFEST25: "泰国泼水节休闲服装面饰",
  T_48_HX_B_WATERFEST25: "泰国泼水节休闲服装裤子",
  T_48_HX_F_B_BLACKDRESS: "泰国泼水节黑神女裤子",
  T_48_HX_F_H_BLACKDRESS: "泰国泼水节黑神女头饰",
  T_48_HX_F_HA_BLACKDRESS: "泰国泼水节黑神女妆容",
  T_48_HX_F_S_BLACKDRESS: "泰国泼水节黑神女鞋子",
  T_48_HX_F_T_BLACKDRESS: "泰国泼水节黑神女上衣",
  T_48_HX_H_WATERFEST25: "泰国泼水节休闲服装头饰",
  T_48_HX_HA_WATERFEST25: "泰国泼水节休闲服装妆容",
  T_48_HX_M_A_BLACKDRESS: "泰国泼水节黑神男面饰",
  T_48_HX_M_B_BLACKDRESS: "泰国泼水节黑神男裤子",
  T_48_HX_M_H_BLACKDRESS: "泰国泼水节黑神男头饰",
  T_48_HX_M_HA_BLACKDRESS: "泰国泼水节黑神男妆容",
  T_48_HX_M_S_BLACKDRESS: "泰国泼水节黑神男鞋子",
  T_48_HX_M_T_BLACKDRESS: "泰国泼水节黑神男上衣",
  T_48_HX_S_WATERFEST25: "泰国泼水节休闲服装鞋子",
  T_48_HX_T_WATERFEST25: "泰国泼水节休闲服装上衣",
  T_48_JH_WS_STRINGDESC: '输入一段文本，也可以输入其他字符串。部分控件支持富文本显示。使用富文本为文字添加颜色的格式为：[#XXXXXX]开头，此处"#XXXXXX"为需要显示的颜色。中间输入需要显示的文本，并以[-]结尾。使用时需确保已将相关控件的文本颜色设置为白色。',
  T_48_M_WS_P_ICON: "头像",
  T_48_META_API_10001: "通过ID查找实体",
  T_48_META_API_10001_P0: "实体ID",
  T_48_META_API_1098: "批量读取数据库表值",
  T_48_META_API_1098_D: "批量读取指定数据表中多个数据，输入的玩家唯一ID列表与标识符列表是一一对应关系",
  T_48_META_API_1098_P1: "玩家账号列表",
  T_48_META_API_1098_P1_D: "玩家唯一ID列表，会读取标识符列表中索引相同的标识符对应的数据",
  T_48_META_API_1098_P2: "标识符列表",
  T_48_META_API_1098_P2_D: "标识符列表，会读取玩家唯一ID列表中索引相同的玩家唯一ID对应的数据",
  T_48_META_API_1098_P5: "状态码列表",
  T_48_META_API_1098_P5_D: "状态码列表",
  T_48_META_API_1105: "开始播放剧情",
  T_48_META_API_1105_D: "使触发玩家开始播放指定剧情对话",
  T_48_META_API_1105_P1_D: "剧情对话ID",
  T_48_META_API_1108: "获取客户端语言",
  T_48_META_API_1500_P0: "Vector",
  T_48_META_API_1505_P1: "Z",
  T_48_META_API_3300: "设置动画身体部位的权重",
  T_48_META_API_3300_D: "设置目标身体部位在与其他低优先级动画叠加播放时的权重",
  T_48_META_API_3300_P0_D: "身体部位所属的可添加动画控制器组件",
  T_48_META_API_3300_P1: "部位名字",
  T_48_META_API_3300_P1_D: "身体部位名",
  T_48_META_API_3300_P2: "权重",
  T_48_META_API_3300_P2_D: "权重，取值范围[0, 1]，表示与低优先级动画的混合程度",
  T_48_META_API_3315: "播放角色动画片段",
  T_48_META_API_3315_D: "播放角色动画片段，可以选择是否覆盖游戏默认动画",
  T_48_META_API_3315_P3: "覆盖gameplay的控制",
  T_48_META_API_3315_P3_D: "是否覆盖游戏默认动画",
  T_48_META_API_3316: "停止动画",
  T_48_META_API_3316_D: "停止播放目标指定状态下的动画",
  T_48_META_API_90_P1: "能否中途退出",
  T_48_META_API_93: "创建沿路径运动",
  T_48_META_API_93_D: "创建一个沿路径插值运动，会使目标沿指定路径进行运动",
  T_48_META_API_93_P1: "路径",
  T_48_META_API_93_P1_D: "进行运动的路径",
  T_48_META_API_93_P3_D: "速度大小",
  T_48_META_API_93_P4: "始终面向切线",
  T_48_META_API_93_P4_D: "是否面朝运动方向，目标被其他手段强制修改朝向后该属性值保持不变",
  T_48_META_API_96: "创建预制体实例",
  T_48_META_API_96_D: "创建预制体实例，可以选择是否异步处理",
  T_48_META_API_96_P2: "是否异步",
  T_48_META_API_96_P2_D: "是否异步",
  T_48_META_EVT_3140: "当改变队伍时",
  T_48_META_EVT_3140_D: "在当前实体改变队伍时触发",
  T_48_META_EVT_3140_P0: "前队伍",
  T_48_META_EVT_3140_P0_D: "改变前所在队伍",
  T_48_META_EVT_3140_P1: "现队伍",
  T_48_META_EVT_3140_P1_D: "改变后所在队伍",
  T_48_META_EVT_3141: "当剧情对话开始时",
  T_48_META_EVT_3141_D: "在剧情对话开始播放时触发",
  T_48_META_EVT_3141_P1: "剧情对话ID",
  T_48_META_EVT_3141_P1_D: "剧情对话ID",
  T_48_META_EVT_3142: "当剧情对话结束时",
  T_48_META_EVT_3142_D: "在剧情对话结束时触发",
  T_48_META_EVT_3142_P0_D: "触发玩家",
  T_48_META_EVT_3142_P1_D: "剧情对话ID",
  T_48_META_EVT_3143: "当触发剧情对话选项时",
  T_48_META_EVT_3143_D: "在剧情对话中选择了选项后触发",
  T_48_META_EVT_3143_P1_D: "剧情对话ID",
  T_48_META_EVT_3143_P2: "选项ID",
  T_48_META_EVT_3143_P2_D: "被选择的选项ID",
  T_48_META_TYP_409_I10: "换队失败-无效的目标队伍",
  T_48_META_TYP_409_I11: "换队失败-死亡玩家不允许换队",
  T_48_META_TYP_409_I12: "换队失败-不允许在载具中换队",
  T_48_META_TYP_409_I7: "换队失败-模式不支持",
  T_48_META_TYP_409_I8: "换队失败-当前已经在目标队伍中",
  T_48_META_TYP_409_I9: "换队失败-无效的对象",
  T_48_META_TYP_41_I19: "禁用碰撞盒",
  T_48_META_TYP_417: "粒子效果",
  T_48_META_TYP_428: "玩家变身后或NPC服饰",
  T_48_META_TYP_431: "沿路径运动",
  T_48_META_TYP_431_I1: "路径",
  T_48_META_TYP_432: "自定义曲线路径路点",
  T_48_META_TYP_432_I0: "翻滚角",
  T_48_META_TYP_432_I1: "切线",
  T_48_META_TYP_433: "自定义曲线路径类型",
  T_48_META_TYP_433_I0: "直线",
  T_48_META_TYP_433_I1: "平滑",
  T_48_META_TYP_433_I2: "自定义",
  T_48_META_TYP_434: "自定义曲线路径",
  T_48_META_TYP_434_I2: "是否闭环",
  T_48_META_TYP_434_I3: "路点",
  T_48_META_TYP_437_I5: "积分类型名数组",
  T_48_META_TYP_437_I6: "左边积分数组",
  T_48_META_TYP_437_I7: "右边积分数组",
  T_48_META_TYP_438_I1: "分组玩家数组",
  T_48_META_TYP_438_I2: "分组排名数组",
  T_48_META_TYP_438_I3: "分组得分数组",
  T_48_META_TYP_438_I4: "积分类型名数组",
  T_48_META_TYP_438_I5: "分组颜色数组",
  T_48_META_TYP_438_I6: "玩家积分数组",
  T_48_META_TYP_439: "组合",
  T_48_META_TYP_442_I1: "左边得分",
  T_48_META_TYP_442_I10: "右边死亡图标",
  T_48_META_TYP_442_I2: "右边得分",
  T_48_META_TYP_442_I3: "左边存活人数",
  T_48_META_TYP_442_I4: "右边存活人数",
  T_48_META_TYP_442_I5: "左边死亡人数",
  T_48_META_TYP_442_I6: "右边死亡人数",
  T_48_META_TYP_442_I7: "左边存活图标",
  T_48_META_TYP_442_I8: "右边存活图标",
  T_48_META_TYP_442_I9: "左边死亡图标",
  T_48_META_TYP_444: "语言类型",
  T_48_META_TYP_444_I0: "英语",
  T_48_META_TYP_444_I1: "简体中文",
  T_48_META_TYP_444_I10: "法语",
  T_48_META_TYP_444_I11: "德语",
  T_48_META_TYP_444_I12: "土耳其语",
  T_48_META_TYP_444_I13: "印地语",
  T_48_META_TYP_444_I14: "日语",
  T_48_META_TYP_444_I15: "罗马尼亚语",
  T_48_META_TYP_444_I16: "阿拉伯语",
  T_48_META_TYP_444_I17: "缅甸语",
  T_48_META_TYP_444_I18: "乌尔都语",
  T_48_META_TYP_444_I19: "孟加拉语",
  T_48_META_TYP_444_I2: "繁体中文",
  T_48_META_TYP_444_I3: "泰语",
  T_48_META_TYP_444_I4: "越南语",
  T_48_META_TYP_444_I5: "印度尼西亚语",
  T_48_META_TYP_444_I6: "葡萄牙语",
  T_48_META_TYP_444_I7: "西班牙语",
  T_48_META_TYP_444_I8: "俄语",
  T_48_META_TYP_444_I9: "韩语",
  T_48_SD_ERROR_DIVISOR: "除数不能为0 ",
  T_48_SD_ERROR_KEY_NOTINMAP: "指定的key在Map中不存在：{0}",
  T_48_SD_ERROR_LIST_OUTRANGE: "List下标超出范围：{0} ",
  T_48_SD_SK_WARNING: "没有在{0}中找到{1} ",
  T_48_TYC_WS_WARNING_SERVER_DRIVEN_DISABLED: "UGC角色控制器{0}的属性“允许服务器驱动”未启用，所以相关的服务端API没有生效",
  T_48_XXJ_WS_PARENTERROR: "设置父节点失败",
  T_48_XXJ_WS_PERFORMANCE: "游戏表现",
  T_48_XXJ_WS_TANGENT: "切线",
  T_48_XXJ_WS_WAYPOINT: "路点",
  T_48_XYL_UGC_COMPOSITEOJBECTLIST: "组合物件列表",
  T_48_XYL_UGC_CUSTOMIZEMINIMAP: "使用自定义小地图",
  T_48_XYL_UGC_HIDEMINIMAP: "隐藏小地图",
  T_48_XYL_WS_BASICCUSTOMSURFACE: "基础自定义曲面",
  T_48_XYL_WS_BASICCYLINDERCUTOUT: "基础曲面椎体",
  T_48_XYL_WS_BASICHEMISPHERE: "基础实心半球体",
  T_48_XYL_WS_BASICQUARTERROUNDEDTORUS: "基础1/4圆角圆环",
  T_48_XYL_WS_BASICQUARTERTORUS: "基础1/4直角圆环",
  T_48_XYL_WS_BASICROUNDEDTORUS: "基础圆角圆环",
  T_48_XYL_WS_BASICTRIANGLE: "基础等边直角三角面",
  T_48_XYL_WS_MAPPLAYERSTIPS: "对局人数=队伍数量×每队对人，对局总人数越多对局匹配时间越长",
  T_48_XYL_WS_MAPPLAYERSWARNING: "高对局人数会导致匹配时间较长",
  T_49_HL_CL_CREATOR_LABEL2: "Craftland 社区天才",
  T_49_HL_CL_MAPS_LABEL2: "地图比赛优胜者",
  T_49_HL_CL_MAPS_LABEL3: "玩法比赛优胜者",
  T_49_HX_T_TUNG: "tungtungtung主题套装",
  T_49_HZY_CONTROLLER_TRAJECTORY: "弹道运动",
  T_49_JH_WS_SKILLKASSIE: "生命连结（Kassie）",
  T_49_JH_WS_SKILLKODA: "极光视界（Koda）",
  T_49_JH_WS_SKILLOSCAR: "英雄冲撞（Oscar）",
  T_49_LXW_EIGHTHB_EDIT_AITRAIN_ENTRANCE: "AI生成",
  T_49_META_API_10065: "切换自定义相机",
  T_49_META_API_10067: "获取当前自定义相机",
  T_49_META_API_10069: "创建自定义相机",
  T_49_META_API_10070: "设置自定义相机层遮罩",
  T_49_META_API_10070_D: "设置目标相机的渲染层遮罩，通过列表可以设置相机对所有可见性层级的可见性",
  T_49_META_API_10071: "获取自定义相机层遮罩",
  T_49_META_API_10071_D: "获取目标相机的渲染层遮罩",
  T_49_META_API_10072: "设置自定义相机指定层遮罩",
  T_49_META_API_10072_D: "设置目标相机对具体某一可见性层级的可见性",
  T_49_META_API_10073: "截屏",
  T_49_META_API_10073_D: "截屏（内部测试用）",
  T_49_META_API_106: "获取服务器时间戳(Ms)",
  T_49_META_API_106_D: "获取服务器的时间戳，精确到毫秒级",
  T_49_META_API_107: "时间戳本地化字符串(Ms)",
  T_49_META_API_107_D: "将毫秒级的时间戳按照一些格式转化成字符串",
  T_49_META_API_107_P0: "时间戳(Ms)",
  T_49_META_API_107_P0_D: "精确到毫秒级的时间戳",
  T_49_META_API_108: "三维向量线性插值",
  T_49_META_API_108_D: "从A到B进行三维向量线性插值",
  T_49_META_API_1089_P2: "请求ID",
  T_49_META_API_109: "设置Persona上下文",
  T_49_META_API_109_D: "更新当前Room中指定Persona的模型上下文，执行后覆盖原有的上下文。上下文会影响Persona对当前对话的背景、历史或者一些固定参数的认知。",
  T_49_META_API_109_P1: "上下文",
  T_49_META_API_109_P1_D: "上下文详情",
  T_49_META_API_110: "对Persona的回复内容进行反馈",
  T_49_META_API_110_D: "对Persona的回复内容进行反馈，用于优化我们的模型",
  T_49_META_API_110_P1: "是否喜欢",
  T_49_META_API_110_P1_D: "对回复表达认可或者不认可，True为喜欢",
  T_49_META_API_1109: "设置本地玩家的位置",
  T_49_META_API_1109_D: "当玩家使用经典角色时，使用该API可以设置玩家的位置",
  T_49_META_API_1109_P0_D: "目标位置",
  T_49_META_API_111: "三维向量球形插值",
  T_49_META_API_111_D: "从A到B进行三维向量球形插值，用于旋转向量",
  T_49_META_API_1110: "设置本地玩家的朝向",
  T_49_META_API_1110_D: "当玩家使用经典角色时，使用该API可以设置玩家的朝向",
  T_49_META_API_1110_P0_D: "面向的方向向量",
  T_49_META_API_112: "清除Persona指定回复之后的记忆",
  T_49_META_API_112_D: "将Persona的记忆回滚到指定的回复ID之前，即指定回复ID后，这条回复以及之后的对话记忆都会被清除",
  T_49_META_API_113: "播放一次性音效",
  T_49_META_API_113_D: "播放一次性音效，支持设置音量",
  T_49_META_API_113_P0_D: "要播放的音效资源ID",
  T_49_META_API_113_P1: "音量",
  T_49_META_API_113_P1_D: "音效的播放音量，范围0-1",
  T_49_META_API_97: "创建骨骼部位注视控制器",
  T_49_META_API_97_D: "创建骨骼部位注视控制器实体后，可以通过该实体控制指定的骨骼部位，使其始终朝向某个目标",
  T_49_META_API_97_P0_D: "骨骼部位注视控制器实体，销毁（Destroy）该实体后，注视会停止",
  T_49_META_API_97_P1_D: "受到控制的骨骼部位",
  T_49_META_API_97_P2_D: "注视的目标",
  T_49_META_API_98: "向量投影",
  T_49_META_API_98_D: "计算A向量到B向量的投影",
  T_49_META_API_99: "获取本地时间戳(Ms)",
  T_49_META_API_99_D: "获取本地的时间戳，精确到毫秒级",
  T_49_META_EVT_16_P1_D: "从0开始，所有上行的请求都会占用，例如创建房间，清除记忆等",
  T_49_META_EVT_16_P2: "回复ID",
  T_49_META_EVT_16_P2_D: "每次完整的回复会具有独立的ID",
  T_49_META_TYP_122_I19: "自定义材质",
  T_49_META_TYP_122_I19_D: "支持将天空盒换为自定义材质",
  T_49_META_TYP_14_I78_D: "通过该属性可以获取/设置玩家所在客户端此时正在渲染画面的相机实体。注意：相机实体的本质是对客户端相机控制的配置数据。",
  T_49_META_TYP_335_I9: "已播放时间（ms）",
  T_49_META_TYP_335_I9_D: "音效已经播放的毫秒数，且该属性只能通过客户端获取",
  T_49_META_TYP_409_I13: "LLM_请求成功",
  T_49_META_TYP_409_I13_D: "LLM_OK",
  T_49_META_TYP_409_I14: "LLM_请求失败",
  T_49_META_TYP_409_I14_D: "LLM_FAILED",
  T_49_META_TYP_409_I15: "LLM_请求超时",
  T_49_META_TYP_409_I15_D: "LLM_TIMEOUT",
  T_49_META_TYP_409_I16: "LLM_Persona或Room无效",
  T_49_META_TYP_409_I16_D: "LLM_Persona或Room无效",
  T_49_META_TYP_409_I17: "LLM_对话轮数已达上限",
  T_49_META_TYP_409_I17_D: "LLM_对话轮数已达上限",
  T_49_META_TYP_409_I18: "LLM_包含恶意信息",
  T_49_META_TYP_409_I18_D: "LLM_请求过于频繁",
  T_49_META_TYP_409_I19: "LLM_请求过于频繁",
  T_49_META_TYP_409_I19_D: "LLM_FREQUENT_REQUEST",
  T_49_META_TYP_441: "演出资源ID",
  T_49_META_TYP_445: "播放控制器ID",
  T_49_META_TYP_446: "可挂载播放控制器的实体组件",
  T_49_META_TYP_446_I0: "播放控制器",
  T_49_META_TYP_447: "骨骼控制器",
  T_49_META_TYP_448: "骨骼注视控制器",
  T_49_META_TYP_448_I0: "控制目标",
  T_49_META_TYP_448_I1: "注视目标",
  T_49_META_TYP_449: "自定义相机",
  T_49_META_TYP_449_I2: "正交尺寸",
  T_49_META_TYP_449_I2_D: "正交尺寸控制了相机能看到的区域大小",
  T_49_META_TYP_450: "时间戳本地化字符串(Ms)",
  T_49_META_TYPE_449_D: "自定义相机是完全由开发者控制的相机，而相机决定了玩家在体验游戏时所看到的显示内容",
  T_49_META_TYPE_450_D: "对毫秒级时间戳进行文本格式化",
  T_49_SD_SEARCH_ICONDESC: "智能联想结果",
  T_49_SD_SEARCHKEY_ACTION: "行为",
  T_49_SD_SEARCHKEY_ANICLIPID: "自定义动画资源ID",
  T_49_SD_SEARCHKEY_AS: "为",
  T_49_SD_SEARCHKEY_ATTACHMENTENUM: "配置道具ID",
  T_49_SD_SEARCHKEY_AUDIOENUM: "音效类型",
  T_49_SD_SEARCHKEY_BAGSKINID: "背包皮肤ID",
  T_49_SD_SEARCHKEY_BEZIER: "贝塞尔曲线",
  T_49_SD_SEARCHKEY_BOOL: "布尔",
  T_49_SD_SEARCHKEY_BREAK: "中断循环",
  T_49_SD_SEARCHKEY_BTREEID: "行为树",
  T_49_SD_SEARCHKEY_BUTTONCLICK: "当按钮点击时",
  T_49_SD_SEARCHKEY_BUTTONDOUBLECLICK: "当按钮双击时",
  T_49_SD_SEARCHKEY_BUTTONPRESS: "当按钮按下时",
  T_49_SD_SEARCHKEY_BUTTONRELEASE: "当按钮抬起时",
  T_49_SD_SEARCHKEY_CLOTHENUM: "服装类型",
  T_49_SD_SEARCHKEY_COLOR: "颜色",
  T_49_SD_SEARCHKEY_COMMENT: "注释",
  T_49_SD_SEARCHKEY_COMPARER: "等于大于小于不等于",
  T_49_SD_SEARCHKEY_COMPONENTENUM: "组件基类类型",
  T_49_SD_SEARCHKEY_CONCANT: "连接",
  T_49_SD_SEARCHKEY_CONTINUE: "继续下一个",
  T_49_SD_SEARCHKEY_CUSTOMHUD: "自定义界面",
  T_49_SD_SEARCHKEY_CUSTOMHUDWIDGET: "自定义界面控件",
  T_49_SD_SEARCHKEY_DYNAMICITEMENUM: "可创建物件类型",
  T_49_SD_SEARCHKEY_E: "常数e",
  T_49_SD_SEARCHKEY_EFFECTENUM: "特效类型",
  T_49_SD_SEARCHKEY_ENTITY: "选择场景物件",
  T_49_SD_SEARCHKEY_FLOAT: "小数",
  T_49_SD_SEARCHKEY_FOR: "索引",
  T_49_SD_SEARCHKEY_FOREACH: "对于每一个",
  T_49_SD_SEARCHKEY_FUNCTION: "功能",
  T_49_SD_SEARCHKEY_GETCSV: "读取表",
  T_49_SD_SEARCHKEY_GETREGISTERED: "根据key获取已注册资产",
  T_49_SD_SEARCHKEY_GETVALUE: "获取属性",
  T_49_SD_SEARCHKEY_GLOBALVARGET: "获得全局变量",
  T_49_SD_SEARCHKEY_GLOBALVARSET: "设置全局变量",
  T_49_SD_SEARCHKEY_IF: "如果",
  T_49_SD_SEARCHKEY_IFELSE: "如果否则",
  T_49_SD_SEARCHKEY_IMGENUM: "图片类型",
  T_49_SD_SEARCHKEY_INT: "整数",
  T_49_SD_SEARCHKEY_INTERNALHUD: "内置界面类型",
  T_49_SD_SEARCHKEY_ITEMENUM: "道具类型",
  T_49_SD_SEARCHKEY_LISTAPPEND: "追加列表",
  T_49_SD_SEARCHKEY_LISTAPPENDRANGE: "追加多条元素",
  T_49_SD_SEARCHKEY_LISTCLEAR: "清空列表",
  T_49_SD_SEARCHKEY_LISTCLONE: "克隆列表",
  T_49_SD_SEARCHKEY_LISTCONTAIN: "是否包含指定元素",
  T_49_SD_SEARCHKEY_LISTCREATE: "创建列表",
  T_49_SD_SEARCHKEY_LISTDELETE: "删除列表",
  T_49_SD_SEARCHKEY_LISTGET: "获取列表",
  T_49_SD_SEARCHKEY_LISTINDEXOF: "获取元素最先出现位置",
  T_49_SD_SEARCHKEY_LISTINSERT: "列表插入",
  T_49_SD_SEARCHKEY_LISTLASTINDEXOF: "获取元素最后出现位置",
  T_49_SD_SEARCHKEY_LISTLENGTH: "列表长度",
  T_49_SD_SEARCHKEY_LISTREVERSE: "翻转列表元素",
  T_49_SD_SEARCHKEY_LISTSET: "修改列表",
  T_49_SD_SEARCHKEY_LISTSHUFFLE: "打乱列表元素",
  T_49_SD_SEARCHKEY_LOCALKEY: "本地化KEY",
  T_49_SD_SEARCHKEY_LOCALVAR: "局部变量",
  T_49_SD_SEARCHKEY_LOGICAL: "且或",
  T_49_SD_SEARCHKEY_LOGINFO: "打印提示",
  T_49_SD_SEARCHKEY_MAPALLKEYS: "获取字典所有key",
  T_49_SD_SEARCHKEY_MAPCLEAR: "清除字典",
  T_49_SD_SEARCHKEY_MAPCONTAIN: "字典是否存在key",
  T_49_SD_SEARCHKEY_MAPCREATE: "构造新字典",
  T_49_SD_SEARCHKEY_MAPGET: "按key获取字典值",
  T_49_SD_SEARCHKEY_MAPLENGTH: "获得Map长度",
  T_49_SD_SEARCHKEY_MAPREMOVE: "移除字典值",
  T_49_SD_SEARCHKEY_MAPSET: "修改字典值",
  T_49_SD_SEARCHKEY_MATH: "加减乘除",
  T_49_SD_SEARCHKEY_NEWLIST: "构造列表",
  T_49_SD_SEARCHKEY_NULL: "空",
  T_49_SD_SEARCHKEY_NUMTOSTRING: "数字转字符串",
  T_49_SD_SEARCHKEY_PARTICLESENUM: "粒子参数文件枚举",
  T_49_SD_SEARCHKEY_PERSONA: "智能体",
  T_49_SD_SEARCHKEY_PI: "常数pi",
  T_49_SD_SEARCHKEY_PLAYERDATAID: "自定义角色资源ID",
  T_49_SD_SEARCHKEY_PLAYERSKILLENUM: "人物技能类型",
  T_49_SD_SEARCHKEY_PREEFFECT: "特效贴图类型",
  T_49_SD_SEARCHKEY_PREFAB: "预制件",
  T_49_SD_SEARCHKEY_RAWID: "资源收集",
  T_49_SD_SEARCHKEY_READSTATIS: "读取累计数据",
  T_49_SD_SEARCHKEY_RESOURCEENUM: "资源UUID",
  T_49_SD_SEARCHKEY_RETURN: "返回",
  T_49_SD_SEARCHKEY_SCENEENUM: "场景文件",
  T_49_SD_SEARCHKEY_SCRIPTID: "脚本",
  T_49_SD_SEARCHKEY_SETVALUE: "设置属性",
  T_49_SD_SEARCHKEY_SPECIALITEMENUM: "特殊道具ID枚举",
  T_49_SD_SEARCHKEY_TEXT: "文本",
  T_49_SD_SEARCHKEY_TEXTUREID: "贴图类型",
  T_49_SD_SEARCHKEY_THISENTITY: "此实体",
  T_49_SD_SEARCHKEY_TIMELINE: "时间线",
  T_49_SD_SEARCHKEY_TYPEENUM: "任意类型",
  T_49_SD_SEARCHKEY_V2VCREATE: "构造二维向量",
  T_49_SD_SEARCHKEY_V2VGET: "获取二维向量分量",
  T_49_SD_SEARCHKEY_V2VOPERATION: "二维向量运算 加减乘 点乘 距离 夹角",
  T_49_SD_SEARCHKEY_V2VSET: "设置二维向量分量",
  T_49_SD_SEARCHKEY_V3VCREATE: "构造三维向量",
  T_49_SD_SEARCHKEY_V3VGET: "获取三维向量分量",
  T_49_SD_SEARCHKEY_V3VOPERATION: "三维向量运算 加减乘 点乘 叉乘 距离 夹角",
  T_49_SD_SEARCHKEY_V3VSET: "设置三维向量分量",
  T_49_SD_SEARCHKEY_VEHICLEENUM: "车皮ID",
  T_49_SD_SEARCHKEY_WEAPONSKINENUM: "枪皮类型",
  T_49_SD_SEARCHKEY_WHILE: "条件循环",
  T_49_SD_SEARCHKEY_WRITESTATIS: "写入累计数据偏移值",
  T_49_SD_SEARCHKEY_WRITESTATISCROSS: "按战场码写入累计数据偏移值",
  T_49_XXJ_WS_DURATIONS: "时长（秒）",
  T_49_XXJ_WS_EDITPERFORMANCE: "编辑演出",
  T_49_XXJ_WS_PERFORMANCE: "演出",
  T_49_XXJ_WS_PERFORMANCE_DELETE: "删除演出",
  T_49_XXJ_WS_PERFORMANCE_DELETECONFIRM: "删除后无法恢复，是否确认删除？",
  T_49_XXJ_WS_PERFORMANCE_EDITING: "正在编辑{0}",
  T_49_XXJ_WS_PERFORMANCE_NAME_EXCEPTION: "演出名重复，请修改后重试~",
  T_49_XXJ_WS_PERFORMANCENAME: "演出名称",
  T_49_XXJ_WS_TIMELINE_ADD_KEYFRAME: "添加关键帧",
  T_49_XXJ_WS_TIMELINE_ADD_SUB_TRACK: "添加子轨道",
  T_49_XXJ_WS_TIMELINE_ADD_TRACK: "添加轨道",
  T_49_XXJ_WS_TIMELINE_DEL_TRACK: "删除轨道",
  T_49_XXJ_WS_TIMELINE_ENTITY_TRACK: "演员轨道",
  T_49_XXJ_WS_TIMELINE_EVENT_TRACK: "事件轨道",
  T_49_XXJ_WS_TIMELINE_EXISTED_KEYFRAME: "已存在关键帧",
  T_49_XXJ_WS_TIMELINE_EXISTED_TRACK: "已存在对应的演员轨道",
  T_49_XXJ_WS_TIMELINE_FRAME_SETTING: "内容",
  T_49_XXJ_WS_TIMELINE_NAME_EXCEPTION: "存在重复的轨道名，请修改后重试~",
  T_49_XXJ_WS_TIMELINE_OPEN_RECORD: "请先开启录制状态，或选中关键帧",
  T_49_XXJ_WS_TIMELINE_RECORDING: "录制中...",
  T_49_XXJ_WS_TIMELINE_REMOVE_KEYFRAME: "删除关键帧",
  T_49_XXJ_WS_TIMELINE_SCENE_EDIT_MODE: "场景视图",
  T_49_XXJ_WS_TIMELINE_SELECT_OBJECT_TIP: "请选择一个物件创建轨道，或直接点击添加轨道按钮",
  T_49_XXJ_WS_TIMELINE_SELECT_OBJECT_TIP_1: "请点击添加轨道按钮创建轨道",
  T_49_XXJ_WS_TIMELINE_SUB_TRACK_TITLE: "子轨道",
  T_49_XXJ_WS_TIMELINE_TRACK: "轨道",
  T_49_XXJ_WS_TIMELINE_TRACK_EDIT_MODE: "轨道视图",
  T_49_XYL_WS_DAILYPROPS: "日常摆件",
  T_49_XYL_WS_STOREGAMPLAY: "玩法",
  T_49_YU_QCITEM_ALL_11: "Tung Tung Tung Sahur",
  T_50_H_M4A1_VA_N: "大活动反派学院主题枪皮M4A1",
  T_50_H_MACHETE_VA_N: "大活动反派学院主题砍刀",
  T_50_HJ_LEADERBOARD_SETTING_HEADER: "排行榜表头",
  T_50_HJ_OVERFLOW_RESIZEFREELY: "溢出文本框",
  T_50_HJ_OVERFLOW_RESIZEHEIGHT: "自动换行",
  T_50_HJ_OVERFLOW_SHRINKCONTENT: "缩小字体",
  T_50_HJ_SEARCHKEY_TUPLECREATE: "构造Tuple",
  T_50_HJ_SEARCHKEY_TUPLEGET: "获取Tuple元素",
  T_50_HJ_SEARCHKEY_TUPLESET: "设置Tuple元素",
  T_50_HJ_TEXTOBGJ_H: "高度",
  T_50_HJ_TEXTOBGJ_OVERFLOW: "文本溢出时的处理方式",
  T_50_HJ_TEXTOBGJ_W: "宽度",
  T_50_HZY_REVIEW_TEXTOBJ: "文本物件内容",
  T_50_JH_WS_HIDEMAPERROR: "在没有自定义封面时无法隐藏场景缩略图",
  T_50_JH_WS_HIDEMAPTIP: "隐藏场景缩略图时，小地图将不再作为地图封面。",
  T_50_JH_WS_HIDEMINIMAP: "隐藏场景缩略图",
  T_50_META_API_10073_P0: "文件名",
  T_50_META_API_10073_P0_D: "文件名",
  T_50_META_API_10073_P1_D: "执行结果，参见StatusCode枚举",
  T_50_META_API_1102: "读取普通数据库某列值",
  T_50_META_API_1102_D: "读取数据库普通表中Key对应的某列值",
  T_50_META_API_1102_P3: "列索引",
  T_50_META_API_1102_P3_D: "数据库表的列索引，0为第一列",
  T_50_META_API_1106: "创建演出",
  T_50_META_API_1106_D: "创建演出实体",
  T_50_META_API_1106_P0_D: "演出资源",
  T_50_META_API_1111: "读取数据库中排行榜关联表值",
  T_50_META_API_1111_D: "读取数据库中排行榜表和关联表中某个Key对应的值的组合",
  T_50_META_API_1111_P5: "关联表状态码",
  T_50_META_API_1111_P5_D: "关联表错误码",
  T_50_META_API_1112: "根据名次区间读取数据库中排行榜表及关联表值",
  T_50_META_API_1112_D: "读取数据库排行榜表中从某名次到某名次之间的值.再根据得到的key从关联表中读取值，然后组合起来",
  T_50_META_API_1112_P6: "关联表状态码",
  T_50_META_API_1112_P6_D: "关联表错误码",
  T_50_META_API_1113: "写入数据库中排行榜表和关联表值",
  T_50_META_API_1113_D: "写入数据库某个排行榜表和关联表中某个Key对应的值",
  T_50_META_API_1113_P5: "关联表状态码",
  T_50_META_API_1113_P5_D: "关联表错误码",
  T_50_META_API_114_D: "创建指定的自定义UI",
  T_50_META_API_114_P0_D: "代码中是用来表示创建UI实体的形参名称，其对应的局部变量值是创建UI的实体",
  T_50_META_API_114_P1_D: "所属的玩家实体，只有该玩家可见",
  T_50_META_API_114_P2: "自定义UI资产ID",
  T_50_META_API_114_P2_D: "自定义UI资产ID",
  T_50_META_API_115_D: "创建指定的自定义UI",
  T_50_META_API_116: "设置物件高亮",
  T_50_META_API_116_D: "设置物件高亮状态，可能受其他Ingame逻辑影响而表现异常",
  T_50_META_API_116_P0_D: "目标物件",
  T_50_META_API_116_P1_D: "高亮状态",
  T_50_META_API_117: "位运算",
  T_50_META_API_117_D: "按位与/或/异或/左移/右移",
  T_50_META_API_117_P0_D: "左操作数",
  T_50_META_API_117_P1_D: "右操作数",
  T_50_META_API_117_P2_D: "操作类型",
  T_50_META_API_118: "按位非",
  T_50_META_API_118_D: "按位非",
  T_50_META_API_118_P0_D: "操作数",
  T_50_META_API_119: "按位列表转整数",
  T_50_META_API_119_D: "将列表元素全部按位或，转换为整数",
  T_50_META_API_119_P0: "按位数组",
  T_50_META_API_119_P0_D: "按位数组",
  T_50_META_API_120: "按位整数转列表",
  T_50_META_API_120_D: "将整数Bit位上为1的值转换到列表中",
  T_50_META_API_120_P0_D: "整数",
  T_50_META_API_121: "四元数夹角",
  T_50_META_API_121_D: "计算两个四元数之间的夹角",
  T_50_META_API_121_P0_D: "四元数1",
  T_50_META_API_121_P1_D: "四元数2",
  T_50_META_API_122: "四元数点积",
  T_50_META_API_122_D: "计算两个四元数之间的点积",
  T_50_META_API_123: "四元数求逆",
  T_50_META_API_123_D: "计算四元数的逆",
  T_50_META_API_123_P0_D: "四元数",
  T_50_META_API_124: "四元数从方向到方向的旋转",
  T_50_META_API_124_D: "计算从from到to的旋转四元数",
  T_50_META_API_124_P0_D: "起点",
  T_50_META_API_124_P1_D: "终点",
  T_50_META_API_125: "四元数朝向旋转",
  T_50_META_API_125_D: "计算从from到to的旋转四元数，最大旋转角度为maxDegreesDelta",
  T_50_META_API_125_P0: "从",
  T_50_META_API_125_P0_D: "起始四元数",
  T_50_META_API_125_P1: "到",
  T_50_META_API_125_P1_D: "目标四元数",
  T_50_META_API_125_P2: "最大角度增量",
  T_50_META_API_125_P2_D: "最大旋转角度",
  T_50_META_API_126: "获取陀螺仪位姿",
  T_50_META_API_126_D: "设备在三维空间中的 姿态（Orientation），表示绕三个轴的旋转角度",
  T_50_META_API_127: "获取陀螺仪重力加速度",
  T_50_META_API_127_D: "设备中传感器检测到的 重力分量",
  T_50_META_API_128: "获取陀螺仪旋转速率",
  T_50_META_API_128_D: "指设备的 旋转速率，它是一个与设备方向传感器相关的术语，主要用于描述设备在三维空间中的旋转变化速率",
  T_50_META_API_129: "获取陀螺仪精准旋转速率",
  T_50_META_API_129_D: "用于描述设备的旋转速率，但它会去除掉 设备传感器中的偏差（bias）或噪声，从而提供更准确的旋转速率数据",
  T_50_META_API_130: "获取陀螺仪用户加速度",
  T_50_META_API_130_D: "设备的加速度中 去除了重力分量 的部分，也就是设备由于用户动作或外力产生的加速度",
  T_50_META_API_131: "获取当前触控信息",
  T_50_META_API_131_D: "获取指定索引的屏幕触摸信息（位置、变化位移、变化时间）",
  T_50_META_API_131_P0_D: "分配各触碰点的ID，从0开始",
  T_50_META_API_131_P1_D: "触摸位置",
  T_50_META_API_131_P2: "相对上一帧的位移",
  T_50_META_API_131_P2_D: "相对上一帧的位移",
  T_50_META_API_131_P3: "相对上一帧的时间",
  T_50_META_API_131_P3_D: "相对上一帧的时间",
  T_50_META_API_132: "获取当前触控总数",
  T_50_META_API_132_D: "获取当前屏幕触摸点数量",
  T_50_META_API_133: "震动设备",
  T_50_META_API_133_D: "使设备震动一次",
  T_50_META_API_134_D: "通知目标玩家设备播放音频",
  T_50_META_API_134_P0_D: "目标玩家",
  T_50_META_API_134_P1_D: "音频资源",
  T_50_META_API_134_P2_D: "播放速度（有效值在0.1~3之间，1为正常，小于1减慢，大于1加速）",
  T_50_META_API_135_D: "播放一次性音频",
  T_50_META_API_135_P0_D: "音频资源",
  T_50_META_API_135_P1_D: "播放速度",
  T_50_META_API_136: "字符串格式化",
  T_50_META_API_136_D: "格式化字符串",
  T_50_META_API_136_P0_D: "格式字符串（使用golang格式控制符）",
  T_50_META_API_136_P1: "参数数组",
  T_50_META_API_136_P1_D: "参数列表",
  T_50_META_API_137: "粘贴组件",
  T_50_META_API_137_D: "复制或添加组件数据",
  T_50_META_API_137_P0: "源实体",
  T_50_META_API_137_P0_D: "源实体",
  T_50_META_API_137_P1_D: "目标实体",
  T_50_META_API_137_P2: "组件类型",
  T_50_META_API_137_P2_D: "组件类型",
  T_50_META_API_137_P3: "是否成功",
  T_50_META_API_137_P3_D: "是否成功",
  T_50_META_API_138: "下一帧复活",
  T_50_META_API_138_D: "在下一帧复活",
  T_50_META_API_139: "下一帧击杀",
  T_50_META_API_139_D: "在下一帧杀死战斗实体",
  T_50_META_API_139_P0_D: "战斗实体",
  T_50_META_API_140: "下一帧退出游戏",
  T_50_META_API_140_D: "在下一帧退出游戏",
  T_50_META_API_141: "获取麦克风音量",
  T_50_META_API_141_D: "获取麦克风音量，玩家没开麦克风或者没开权限时会返回状态",
  T_50_META_API_141_P0: "音量",
  T_50_META_API_141_P0_D: "麦克风音量",
  T_50_META_API_141_P1_D: "麦克风状态是否开启",
  T_50_META_API_142: "获取画面质量",
  T_50_META_API_142_D: "获取当前渲染质量（枚举：Low/Medium/High/Ultra）",
  T_50_META_API_143: "获取渲染分辨率",
  T_50_META_API_143_D: "获取当前渲染分辨率",
  T_50_META_API_144: "将CustomPlayer绑定到玩家",
  T_50_META_API_144_D: "动态设置某个玩家所绑定的受控对象，覆盖之前的绑定关系，失败返回false",
  T_50_META_API_144_P0: "要绑定的CustomPlayer",
  T_50_META_API_144_P0_D: "将该CustomPlayer绑定到玩家后，可自动同步位置朝向等数据",
  T_50_META_API_144_P1_D: "目标玩家",
  T_50_META_API_145: "将CustomPlayer从玩家身上解绑",
  T_50_META_API_145_D: "解除绑定关系，失败返回false",
  T_50_META_API_145_P0: "要解绑的CustomPlayer",
  T_50_META_API_145_P0_D: "将该对象的绑定关系清空，解绑后不再自动同步位置朝向等数据",
  T_50_META_API_146_P0_D: "自定义玩家",
  T_50_META_API_147: "对于已经绑定好的对象，设置状态数据",
  T_50_META_API_147_D: "设置后会自动上传服务器并同步给所有客户端，失败返回false",
  T_50_META_API_147_P0: "要设置的CustomPlayer",
  T_50_META_API_147_P1: "状态",
  T_50_META_API_147_P1_D: "通常用于保存动画状态，通过GetCustomPlayerState获取同步来的状态",
  T_50_META_API_148: "对于已经绑定好的对象，获取状态数据",
  T_50_META_API_148_D: "该状态数据自动同步自服务器，失败返回false",
  T_50_META_API_148_P0: "目标CustomPlayer",
  T_50_META_API_148_P1: "状态",
  T_50_META_API_148_P1_D: "通过SetCustomPlayerState设置状态",
  T_50_META_API_149: "设置玩家之间距离语音音量",
  T_50_META_API_149_D: "设置玩家之间的距离动态调整语音音量",
  T_50_META_API_149_P0: "距离列表",
  T_50_META_API_149_P0_D: "距离区间的列表，与音量列表元素一一对应",
  T_50_META_API_149_P1: "音量列表",
  T_50_META_API_149_P1_D: "音量列表，与距离区间的列表元素一一对应",
  T_50_META_API_150: "获取好友列表",
  T_50_META_API_150_D: "获取玩家的好友ID列表",
  T_50_META_API_151: "获取默认界面信息",
  T_50_META_API_151_D: "获取玩家默认UI的位置",
  T_50_META_API_151_P0_D: "默认界面",
  T_50_META_API_151_P1_D: "开启状态",
  T_50_META_API_151_P2_D: "UI位置",
  T_50_META_API_151_P3: "尺寸",
  T_50_META_API_151_P3_D: "UI大小",
  T_50_META_API_152: "广播自定义事件",
  T_50_META_API_152_D: "广播自定义事件，任意实体都可以收到（监听到）该事件",
  T_50_META_API_153: "发送自定义事件",
  T_50_META_API_153_D: "将自定义事件发送给指定实体",
  T_50_META_EVT_17: "当屏幕触控开始时",
  T_50_META_EVT_17_D: "屏幕触摸开始事件",
  T_50_META_EVT_17_P0: "触控索引",
  T_50_META_EVT_17_P0_D: "触摸点索引",
  T_50_META_EVT_17_P1_D: "触摸位置",
  T_50_META_EVT_18: "当屏幕触控结束时",
  T_50_META_EVT_18_D: "屏幕触摸结束事件",
  T_50_META_EVT_18_P0: "触控索引",
  T_50_META_EVT_18_P0_D: "触摸点索引",
  T_50_META_EVT_18_P1_D: "触摸位置",
  T_50_META_EVT_19: "当收到创建Persona聊天房间结果时",
  T_50_META_EVT_19_D: "当创建Persona聊天房间失败时会收到对应结果",
  T_50_META_EVT_19_P1: "聊天房间ID",
  T_50_META_EVT_19_P1_D: "房间ID",
  T_50_META_EVT_20: "当玩家退出或玩家比赛结束时",
  T_50_META_EVT_20_D: "在玩家退出或玩家比赛结束时触发",
  T_50_META_TYP_11_I44: "玩家之间的距离动态调整语音音量",
  T_50_META_TYP_11_I44_D: "玩家之间的距离动态调整语音音量",
  T_50_META_TYP_22_I9_D: "用于创建该UI的资产ID",
  T_50_META_TYP_244_I12_D: "文本框宽度",
  T_50_META_TYP_244_I13_D: "文本框高度",
  T_50_META_TYP_244_I14_D: "溢出类型",
  T_50_META_TYP_335_I10_D: "播放速度（有效值>0，默认值1）",
  T_50_META_TYP_409_I20: "创建文件失败",
  T_50_META_TYP_409_I20_D: "IO操作失败，创建文件发生异常",
  T_50_META_TYP_409_I21: "文件名无效",
  T_50_META_TYP_409_I21_D: "IO操作失败，文件名无效",
  T_50_META_TYP_448_I0_D: `被控制的骨骼部位
`,
  T_50_META_TYP_448_I1_D: "骨骼始终注视的目标",
  T_50_META_TYP_451: "溢出类型",
  T_50_META_TYP_451_D: "文字溢出时的处理方式",
  T_50_META_TYP_452: "自定义UI资产ID",
  T_50_META_TYP_452_D: "用以描述自定义Hud资产的ID",
  T_50_META_TYP_453: "渲染质量",
  T_50_META_TYP_453_D: "渲染质量枚举",
  T_50_META_TYPE_448_D: "该实体用于控制目标骨骼使用注视某个对象",
  T_50_SD_WS_MAPTAG_AI3DGEN: "3D物件生成地图",
  T_50_SD_WS_MAPTAG_AIRACING: "竞速智能生成地图",
  T_50_XXJ_WS_ANIMATIONSTATENAME: "动画状态名枚举",
  T_50_XXJ_WS_DISABLEFOOTSTEP: "关闭脚步震动提示",
  T_50_XXJ_WS_NOPERFORMANCE: "目前没有演出文件",
  T_50_XXJ_WS_PERFORMANCE_BATETIPS: "测试版本",
  T_50_XXJ_WS_PERFORMANCE_BATETIPS_DESC: "亲爱的创作者，演出编辑器目前正处于开发测试阶段，可能会出现许多bug或者缺少重要功能，请谨慎使用",
  T_50_XXJ_WS_PERFORMANCE_NEW: "新增演出",
  T_50_XXJ_WS_TIMELINE_ADD_KEYCLIP: "添加关键片段",
  T_50_XXJ_WS_TIMELINE_ALONGPATH_TRACK: "路径运动轨道",
  T_50_XXJ_WS_TIMELINE_ANIMATION_CLIP: "动画",
  T_50_XXJ_WS_TIMELINE_ANIMATION_TRACK: "动画轨道",
  T_50_XXJ_WS_TIMELINE_AUDIO_TRACK: "音频轨道",
  T_50_XXJ_WS_TIMELINE_CLIP_LOOP_TYPE_HOLD: "维持",
  T_50_XXJ_WS_TIMELINE_CLIP_LOOP_TYPE_LOOPFOREVER: "永远循环",
  T_50_XXJ_WS_TIMELINE_DURATION: "总时长 : {0}秒",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_AVATAR: "动画与模型不匹配",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_CLIP_OVERLAP: "关键片段存在覆盖",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_ENTITY_MISSING: "绑定的实体丢失",
  T_50_XXJ_WS_TIMELINE_NAME_EMPTY: "轨道名不能为空",
  T_50_XXJ_WS_TIMELINE_NPC_TRACK: "NPC轨道",
  T_50_XXJ_WS_TIMELINE_PROP_TRACK: "属性轨道",
  T_50_XXJ_WS_TIMELINE_REMOVE_KEYCLIP: "删除关键片段",
  T_50_XXJ_WS_TIMELINE_TIME_SUFFIX: "{0}s",
  T_50_XXJ_WS_TIMELINE_TRACK_MAX_LIMIT: "轨道数量超出限制",
  T_50_XYL_WS_AIGETERATESHOW: "积木组合",
  T_50_YU_F_B_VA_WITCH: "反派学院大活动巫师女女裤子",
  T_50_YU_F_H_VA_WITCH: "反派学院大活动巫师女女头饰",
  T_50_YU_F_HA_VA_WITCH: "反派学院大活动巫师女女妆容",
  T_50_YU_F_S_VA_WITCH: "反派学院大活动巫师女女鞋子",
  T_50_YU_F_T_VA_WITCH: "反派学院大活动巫师女女上衣",
  T_50_ZCS_CLCUSTOMEVE_CUSTOMEVENT: "自定义事件",
  T_51_GT_WS_BASIC: "基础",
  T_51_GT_WS_GLOBALEVENT: "全局事件",
  T_51_GT_WS_PRIVATEEVENT: "私有事件",
  T_51_GT_WS_STORY: "剧情",
  T_51_GT_WS_UI: "界面",
  T_51_JH_WS_MINTIP1: "当匹配时最小开局人数设置过高时，可能导致匹配成功率降低",
  T_51_META_API_1114: "给Persona发送用户消息并触发语音回复",
  T_51_META_API_1114_D: "给persona发送用户消息，并且会收到语音回复",
  T_51_META_API_1114_P2_D: "是否自动播放，为True时，收到语音回复会立即播放，否则需要用API播放",
  T_51_META_API_1115: "给Persona发送系统消息并触发语音回复",
  T_51_META_API_1115_D: "给persona发送系统消息，并且会收到语音回复",
  T_51_META_API_1116: "播放Persona已缓存的语音消息",
  T_51_META_API_1116_D: "播放已缓存的persona语音回复，至多缓存10条",
  T_51_META_API_144_P2_D: "是否成功执行",
  T_51_META_API_154: "获取类型名",
  T_51_META_API_154_D: "返回目标对象的类型名称",
  T_51_META_API_154_P0_D: "要获取类型名称的目标对象",
  T_51_META_API_155: "获取包围盒",
  T_51_META_API_155_D: "获取场景物件的BoundingBox",
  T_51_META_API_155_P0_D: "要获取边界框的场景物件",
  T_51_META_API_155_P1_D: "边界框的中心点",
  T_51_META_API_155_P2: "尺寸",
  T_51_META_API_155_P2_D: "边界框的尺寸",
  T_51_META_API_156: "创建实体",
  T_51_META_API_156_D: "创建实体. 可以指定owner（具体玩家客户端），配合API：AddComponent，可以定向给某端同步数据",
  T_51_META_API_156_P0_D: "创建的实体对象",
  T_51_META_API_156_P1_D: "要创建的自定义组件类型",
  T_51_META_API_156_P2_D: "实体的所有者",
  T_51_META_API_156_P3: "标志",
  T_51_META_API_156_P3_D: "实体标志，详见枚举EntityFlag，可以组合",
  T_51_META_API_157: "设置材质属性",
  T_51_META_API_157_D: "通过该API可以修改对象的材质的部分属性",
  T_51_META_API_157_P0_D: "要设置材质属性的目标对象",
  T_51_META_API_157_P1: "目标属性",
  T_51_META_API_157_P1_D: "要设置的属性名称",
  T_51_META_API_157_P2: "属性值",
  T_51_META_API_157_P2_D: "要设置的属性值",
  T_51_META_API_157_P3: "是否成功",
  T_51_META_API_157_P3_D: "设置是否成功",
  T_51_META_API_158: "清除材质属性",
  T_51_META_API_158_D: "清除设置的属性",
  T_51_META_API_158_P0_D: "要清除材质属性的目标对象",
  T_51_META_EVT_21: "当自定义属性改变时",
  T_51_META_EVT_21_D: "当开启变化监测的自定义属性变化时，会收到该事件。需注意，一帧内对自定义属性修改多次时，该事件仅触发一次；在服务器修改自定义属性，事件将发送给双端；但在客户端修改本地实体的自定义属性，事件仅会发送给本地",
  T_51_META_EVT_21_P0: "属性索引",
  T_51_META_EVT_21_P0_D: "属性的索引值",
  T_51_META_EVT_21_P1_D: "属性的新值",
  T_51_META_EVT_22: "当自定义玩家状态改变时",
  T_51_META_EVT_22_D: "当自定义玩家状态改变时会触发该事件",
  T_51_META_EVT_22_P0: "最新的CustomPlayerState",
  T_51_META_EVT_22_P0_D: "自定义玩家状态",
  T_51_META_EVT_23: "当收到Persona的语音回复时",
  T_51_META_EVT_23_D: "当收到persona的语音回复时触发该事件",
  T_51_META_EVT_24: "当来自Persona的语音回复播放结束时",
  T_51_META_EVT_24_D: "当Persona的语音回复播放完毕时触发该事件",
  T_51_META_TYP_14_I79: "绑定的自定义玩家",
  T_51_META_TYP_14_I79_D: "当绑定了某个CustomPlayer时，会隐藏经典角色模型，将目标对象的位置朝向等数据作为自身数据同步",
  T_51_META_TYP_15_I6: "显示队友名",
  T_51_META_TYP_15_I6_D: "场景中是否在队友头顶显示名字",
  T_51_META_TYP_247_I31: "求助",
  T_51_META_TYP_247_I31_D: "求助UI开关",
  T_51_META_TYP_247_I32: "放弃存活",
  T_51_META_TYP_247_I32_D: "放弃UI开关",
  T_51_META_TYP_247_I33: "攻击2",
  T_51_META_TYP_247_I33_D: "攻击2UI开关",
  T_51_META_TYP_247_I34: "双持武器",
  T_51_META_TYP_247_I34_D: "双持武器UI开关",
  T_51_META_TYP_247_I35: "水上滑板",
  T_51_META_TYP_247_I35_D: "水上滑板UI开关",
  T_51_META_TYP_313_I2_D: "腐蚀手雷腐蚀区域每秒的伤害值",
  T_51_META_TYP_409_I22: "参数错误",
  T_51_META_TYP_409_I22_D: "PARAM_ERROR",
  T_51_META_TYP_440_I1_D: "演出资源ID",
  T_51_META_TYP_454: "材质属性",
  T_51_META_TYP_454_D: "材质属性值，用于设置物体的材质属性",
  T_51_META_TYP_455: "实体标志",
  T_51_META_TYP_455_D: "用于指定实体的属性标志，可以组合使用",
  T_51_META_TYP_455_I0_D: "默认属性",
  T_51_META_TYP_455_I1: "静态",
  T_51_META_TYP_455_I1_D: "静态实体",
  T_51_META_TYP_455_I2: "本地",
  T_51_META_TYP_455_I2_D: "本地实体",
  T_51_META_TYP_455_I3: "仅渲染",
  T_51_META_TYP_455_I3_D: "仅渲染",
  T_51_MX_WS_ACTION_BITE: "酥脆咬一口",
  T_51_MX_WS_ACTION_BOUNCE: "弹簧蹦跳",
  T_51_MX_WS_ACTION_DOOR_CREAK: "嘎吱开关门",
  T_51_MX_WS_ACTION_FALL_HIT: "摔地重击",
  T_51_MX_WS_ACTION_GULP: "紧张吞咽",
  T_51_MX_WS_ACTION_RUNAWAY_DUST: "逃跑烟尘",
  T_51_MX_WS_ACTION_RUNNING_STEPS: "急促小跑",
  T_51_MX_WS_ACTION_SPIN_LOOP: "呼啦旋转",
  T_51_MX_WS_ACTION_STOMACH_GROWL: "肚子咕噜",
  T_51_MX_WS_AMBIENT_BIRDS: "环境鸟鸣",
  T_51_MX_WS_AMBIENT_CAFE_AMBIENCE: "咖啡馆氛围",
  T_51_MX_WS_AMBIENT_CLASSROOM_OFFICE: "教室氛围",
  T_51_MX_WS_AMBIENT_NIGHT_CRICKETS: "夜虫鸣",
  T_51_MX_WS_AMBIENT_RAIN: "环境雨声",
  T_51_MX_WS_AMBIENT_STREET_TRAFFIC: "街道车流",
  T_51_MX_WS_AMBIENT_WAVES: "海浪拍岸",
  T_51_MX_WS_ATMOSPHERE_APPLAUSE_LAUGH: "观众掌声笑声",
  T_51_MX_WS_ATMOSPHERE_BASS_DRUM: "低音鼓",
  T_51_MX_WS_ATMOSPHERE_BELL: "钟声",
  T_51_MX_WS_ATMOSPHERE_JINGLE: "小铃叮铃",
  T_51_MX_WS_ATMOSPHERE_WIND: "风呼啸",
  T_51_MX_WS_COMEDY_AIR_WHIP: "空气呼啪",
  T_51_MX_WS_COMEDY_CAMERA_CLICK: "相机咔嚓",
  T_51_MX_WS_COMEDY_FAIL_WAHWAH: "失败哇哇",
  T_51_MX_WS_COMEDY_FART: "滑稽放屁",
  T_51_MX_WS_COMEDY_FUNNY_LAUGH: "滑稽大笑",
  T_51_MX_WS_COMEDY_HEAD_SLAP: "拍脑门啪",
  T_51_MX_WS_COMEDY_IDEA_DING: "灵感叮",
  T_51_MX_WS_COMEDY_RECORD_SCRATCH: "唱片刹停",
  T_51_MX_WS_COMEDY_VICTORY_DING: "胜利叮咚",
  T_51_MX_WS_EMOTION_AWKWARD: "冷场尴尬",
  T_51_MX_WS_EMOTION_BLINK_SWITCH: "表情咔哒切换",
  T_51_MX_WS_EMOTION_CONFIDENT_VICTORY: "得意登登",
  T_51_MX_WS_EMOTION_CONFUSED: "疑惑嗯咦",
  T_51_MX_WS_EMOTION_HAPPY_NOTIFICATION: "开心提示",
  T_51_MX_WS_EMOTION_HEARTBEAT_LOVE: "心动扑通",
  T_51_MX_WS_EMOTION_PHONE_VIBRATION: "手机短震",
  T_51_MX_WS_EMOTION_SIGH_SAD: "失落叹气",
  T_51_MX_WS_EMOTION_SNORT: "鼻息喷气",
  T_51_MX_WS_EMOTION_SPARKLE: "星光叮铃",
  T_51_MX_WS_EMOTION_SURPRISE_SHOCK: "惊吓滑稽",
  T_51_MX_WS_EMOTION_TEETH_CHATTER: "牙齿打颤",
  T_51_MX_WS_FANTASY_MAGIC_CAST: "魔法释放",
  T_51_MX_WS_FANTASY_TRANSFORM: "变身旋转",
  T_51_MX_WS_FX_EXPLOSION: "爆炸冲击",
  T_51_MX_WS_FX_FIRE_BURN: "火焰噼啪",
  T_51_MX_WS_FX_ICE_CRACK: "冰霜碎裂",
  T_51_MX_WS_FX_LIGHTNING: "闪电电弧",
  T_51_MX_WS_FX_SPLASH: "水花溅起",
  T_51_MX_WS_MECHANIC_BOX_OPEN: "开箱开封",
  T_51_MX_WS_MECHANIC_GEAR_SPIN: "齿轮转动",
  T_51_MX_WS_MECHANIC_LOCK_UNLOCK: "锁扣解锁",
  T_51_MX_WS_MECHANIC_OPEN_CLOSE: "抽屉柜门开合",
  T_51_MX_WS_MECHANIC_POURING: "倒水入杯",
  T_51_MX_WS_RHYTHM_BREAK_BEAT: "节奏断点",
  T_51_MX_WS_RHYTHM_CLAP: "掌声拍手",
  T_51_MX_WS_RHYTHM_DRUM_BEAT: "鼓点节拍",
  T_51_MX_WS_SOUNDTYPE_INTERACTION: "趣味互动",
  T_51_MX_WS_TRANSITION_GLITCH: "数码故障电音",
  T_51_MX_WS_TRANSITION_POPUP: "弹窗跳出",
  T_51_MX_WS_TRANSITION_REVERSE_SUCTION: "倒吸回卷",
  T_51_MX_WS_TRANSITION_WHOOSH: "呼啸掠过",
  T_51_MX_WS_TRANSPORT_AIRCRAFT: "飞行器风切",
  T_51_MX_WS_TRANSPORT_BIKE_SKATE: "轮滑摩擦",
  T_51_MX_WS_TRANSPORT_CAR_DRIVE: "汽车引擎行驶",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_HIGHACCEL: "汽车引擎高加速",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_HIGHDECEL: "汽车引擎高减速",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOOP: "汽车引擎循环",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOWACCEL: "汽车引擎低加速",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOWDECEL: "汽车引擎低减速",
  T_51_MX_WS_TRANSPORT_STREAM_FLOW: "湍急水流",
  T_51_MX_WS_TRANSPORT_TRAIN_BEEP: "列车过站",
  T_51_MX_WS_UI_ACHIEVEMENT_UNLOCK: "成就解锁",
  T_51_MX_WS_UI_BUTTON_CLICK: "按钮点击",
  T_51_MX_WS_UI_CANCEL: "取消提示",
  T_51_MX_WS_UI_CONFIRM: "确认提示",
  T_51_MX_WS_UI_LIST_SCROLL: "列表滑动",
  T_51_MX_WS_UI_LOADING: "加载进度流",
  T_51_TYC_API_OUTLINE: "设置实体描边",
  T_51_TYC_API_OUTLINE_ALPHA: "描边透明度",
  T_51_TYC_API_OUTLINE_ALPHA_D: "输入值在0~1之间，对应完全透明到完全不透明",
  T_51_TYC_API_OUTLINE_COLOR: "描边颜色",
  T_51_TYC_API_OUTLINE_COLOR_D: "描边绘制采用的颜色",
  T_51_TYC_API_OUTLINE_D: `指定一个实体，使其边缘高亮，支持的类型包括
玩家（Player）
自定义物件（CustomRender）
NPC和自定义外观（Appearance）
内置物件（BasicAppearance）`,
  T_51_TYC_API_OUTLINE_TARGET: "目标实体",
  T_51_TYC_API_OUTLINE_TARGET_D: "将要设为描边对象的实体",
  T_51_TYC_API_OUTLINE_TOPMOST: "穿透显示",
  T_51_TYC_API_OUTLINE_TOPMOST_D: "让描边效果穿过所有物体，始终显示在最顶层",
  T_51_TYC_API_OUTLINE_WIDTH: "描边宽度",
  T_51_TYC_API_OUTLINE_WIDTH_D: "输入值在0~1之间，对应无描边效果到最宽描边效果",
  T_51_XJ_WS_BASIC_SETTING: "基础设置",
  T_51_XJ_WS_GAME_START_TIME_UNIT: "秒",
  T_51_XJ_WS_GMSTART_TIME: "游戏开始准备时间",
  T_51_ZCS_SPAWNPOINT_NAME: "出生点移动锁定",
  T_OB47_M_WS_READ: "只读信息",
  TXT_AVATAR_FEMALE_JACKET_BLACK: "黑色皮夹克(女)",
  TXT_AVATAR_FEMALE_PANTS_MARIO: "猎菇者 ",
  TXT_AVATAR_FEMALE_SHOE_COS_HOODSHIRT_BLACK: "无名之黑(鞋)",
  TXT_AVATAR_FEMALE_SHORTPANT_COS_GSL_BLACK: "GSL电竞短裤（女）",
  TXT_AVATAR_FEMALE_SKIRT_COS_GSL_BLACK: "GSL电竞裙（女）",
  TXT_AVATAR_FEMALE_TOP_COS_HOODSHIRT_BLACK: "无名之黑(上装)",
  TXT_AVATAR_FEMALE_TOP_COS_SONGKRAN_2018: "白蓮情焰",
  TXT_AVATAR_FEMALE_TSHIRT_MARIO: "蘑菇与玫瑰 ",
  TXT_AVATAR_FEMALE_VEST_COS_GSL_BLACK: "GSL电竞背心（女）",
  TXT_AVATAR_MALE_BOTTOM_COS_CNY_RED: "恭喜发财",
  TXT_AVATAR_MALE_BOTTOM_COS_GANGS_BLACK: "黑色运动裤（男）",
  TXT_AVATAR_MALE_BOTTOM_COS_MOB_YELLOW: "盗猎者 ",
  TXT_AVATAR_MALE_BOTTOM_COS_OUTDOOR_BLACK: "户外下装",
  TXT_AVATAR_MALE_PANTS_MARIO: "妈妈咪呀 ",
  TXT_AVATAR_MALE_SHOE_COS_CANVAS_BLACK: "户外帆布鞋",
  TXT_AVATAR_MALE_SHOE_RED: "红色靴子(男)",
  TXT_AVATAR_MALE_TOP_COS_CNY_RED: "花开富贵",
  TXT_AVATAR_MALE_TOP_COS_GANGS_BLACK: "黑色运动上装（男）",
  TXT_AVATAR_MALE_TOP_COS_HOODIE_BRICKR: "卫衣（砖红）",
  TXT_AVATAR_MALE_TOP_COS_HOODSHIRT_BLACK: "酷霸之黑(上装)",
  TXT_AVATAR_MALE_TOP_COS_MOB_DGREEN: "帮派狂徒上衣 ",
  TXT_AVATAR_MALE_TOP_COS_OUTDOOR_GREY: "户外上装",
  TXT_AVATAR_MALE_TSHIRT_MARIO: "水管工的罗曼蒂克上衣 ",
  TXT_AVATAR_OB10_LZW_FEMALE_TOP_COS_SPONSOR: "Sponsor Jacket (F)",
  TXT_AVATAR_OB10_LZW_MALE_HAIR_COS_CLOWN: "诡夜小丑（面具）",
  TXT_AVATAR_OB10_LZW_MALE_TOP_COS_SPONSOR: "Sponsor Jacket (M)",
  TXT_AVATAR_OB10_LZW_TOP_SLEEVELESS: "无袖拉链衫（绿）",
  TXT_AVATAR_OB11_LZW_COS_NYARUKO: "血舌之神的化身",
  TXT_AVATAR_OB11_LZW_MALE_ACCESSORY_COS_ZOMBIE: "杀戮鬼（面饰）",
  TXT_AVATAR_OB11_LZW_MALE_TOP_COS_PINK_JAZZ: "Jazz Tattoo",
  "TXT_AVATAR_OB7_LZW_FEMALE_A-SKIRT_BLACK": "释放真我",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_CNY_RED_OBT7TH: "维多利亚",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_DOWNJACKET_OBT7TH: "灵能之翼",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_JAPANESESTYLE_PINK: "桃色",
  TXT_AVATAR_OB7_LZW_FEMALE_SHOE_COS_JAPANESESTYLE_PINK: "红樱",
  TXT_AVATAR_OB7_LZW_FEMALE_SHOE_SPORTS_08: "冰爽",
  TXT_AVATAR_OB7_LZW_FEMALE_SHORTPANTS_FLAP_BLUE: "蓝洞",
  TXT_AVATAR_OB7_LZW_FEMALE_TOP_COS_JAPANESESTYLE_PINK: "千本樱",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_BATTLE_BROWN: "三角洲",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_DOWNJACKET_OBT7TH: "天人",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_JAPANESESTYLE_PURPLE: "影舞者",
  TXT_AVATAR_OB7_LZW_MALE_HOODIE_ZIPPER_GREY: "战象",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_CASUAL: "石灰岩",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_JAPANESESTYLE_PURPLE: "黑祸",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_TECHWEAR_OBT7TH: "玄铁星",
  TXT_AVATAR_OB7_LZW_MALE_SHORTPANTS_FLAP_BLUE: "蓝晶",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_BATTLE_BROWN: "战争终结",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_CASUAL: "明日之星",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_JAPANESESTYLE_PURPLE: "天下布武",
  TXT_AVATAR_OB8_LZW_BALLPANTS_WHITE: "白色旋风",
  TXT_AVATAR_OB8_LZW_FEMALE_BOTTOM_COS_BASEBALL_GREEN: "花式开球（下装）",
  TXT_AVATAR_OB8_LZW_FEMALE_TOP_ASUS_JACKET: "Asus限量夹克（女）",
  TXT_AVATAR_OB8_LZW_FEMALE_TOP_COS_BASEBALL_GREEN: "花式开球（上装）",
  TXT_AVATAR_OB8_LZW_MALE_BOTTOM_COS_BASEBALL_YELLOW: "全民职棒（下装）",
  "TXT_AVATAR_OB8_LZW_MALE_HAIR_COS_HIP-HOP": "嘻哈达人（头部）",
  TXT_AVATAR_OB8_LZW_MALE_SHOE_COS_BASEBALL_YELLOW: "全民职棒（鞋子）",
  TXT_AVATAR_OB8_LZW_MALE_TOP_ASUS_JACKET: "Asus限量夹克（男）",
  TXT_AVATAR_OB8_LZW_MALE_TOP_COS_BASEBALL_YELLOW: "全民职棒（上装）",
  TXT_AVATAR_OB8_LZW_MALE_TOP_COS_DINOSAUR_GREEN: "泡泡龙",
  TXT_AVATAR_OB8_LZW_SHOE_SOCCER_SILVER: "胜利者银靴",
  TXT_AVATAR_OB8_LZW_TSHIRT_ENGLAND_B: "三狮军团",
  TXT_AVATAR_OB9_LZW_MALE_ACCESSORY_COS_TUXEDO: "狂气贵公子（面具）",
  TXT_AVATAR_OB9_LZW_MALE_HAIR_COS_TUXEDO: "狂气贵公子（头部）",
  TXT_AVATAR_PARACHUTE_8: "笑脸",
  TXT_AVATAR_SHIRT_PLAID_2: "周二红",
  TXT_AVATAR_SHOES_1: "球鞋(白)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_2: "校园制服(海棠)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_3: "水手服（红）",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_4: "校园制服(菊花)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_5: "校园制服(紫罗兰)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_6: "校园制服(茉莉)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_7: "青兰制服（上衣）",
  TXT_AVATAR_TSHIRT_WEEK_007: "热情周日",
  TXT_BANNER_NAME_MISHA: "速度",
  TXT_CHARACTER_ADAM_NAME: "亚当",
  TXT_CHARACTER_BODYGUARD_NAME: "尼基塔",
  TXT_CHARACTER_COP_NAME: "安德鲁",
  TXT_CHARACTER_EVA_NAME: "夏娃",
  TXT_CHARACTER_NURSE_NAME: "奥利维亚",
  TXT_CHARACTER_RACERGIRL_NAME: "米莎 ",
  TXT_CHARACTER_RUNNER_NAME: "凯莉",
  TXT_CHARACTER_SEAMAN_NAME: "福特",
  TXT_CLAN_NAME: "名称",
  TXT_COLLECTION_DESCRIPTION: "描述",
  TXT_COLLECTION_HEADPORTRAIT: "头像",
  TXT_INVENTORY_TITLE_EQUIPMENT: "装备",
  TXT_ITEM_AK: "AK",
  TXT_ITEM_ARAMMO: "步枪子弹",
  TXT_ITEM_AWM: "AWM",
  TXT_ITEM_BAG1: "背包Lv1",
  TXT_ITEM_BAG2: "背包Lv2",
  TXT_ITEM_BAG3: "背包Lv3",
  TXT_ITEM_BASEBALLPOLE: "棒球棍",
  TXT_ITEM_BOWAMMO: "箭矢",
  TXT_ITEM_CHANGUO: "平底锅",
  TXT_ITEM_CROSSBOW: "十字弩",
  TXT_ITEM_DESC_FLASH: "战术性投掷武器，可以让一定范围内的敌人陷入短暂失明",
  TXT_ITEM_EAGLE: "Desert Eagle",
  TXT_ITEM_FAK: "急救包",
  TXT_ITEM_FAMAS: "FAMAS",
  TXT_ITEM_FIST: "拳击",
  TXT_ITEM_FLASH: "闪光弹",
  TXT_ITEM_FOREGRIP1: "握把Lv1",
  TXT_ITEM_FOREGRIP2: "握把Lv2",
  TXT_ITEM_FOREGRIP3: "握把Lv3",
  TXT_ITEM_G18: "G18",
  TXT_ITEM_GRENADE: "手雷",
  TXT_ITEM_GROZA: "GROZA",
  TXT_ITEM_HANDCANNON: "手炮",
  TXT_ITEM_HEATSIGHT: "热成像瞄镜",
  TXT_ITEM_HELMET1: "头盔Lv1",
  TXT_ITEM_HELMET2: "头盔Lv2",
  TXT_ITEM_HELMET3: "头盔Lv3",
  TXT_ITEM_HGAMMO: "手枪子弹",
  TXT_ITEM_KAR98K: "Kar98k",
  TXT_ITEM_LANUNCHERAMMO: "M79榴弹",
  TXT_ITEM_M1014: "M1014",
  TXT_ITEM_M14: "M14",
  TXT_ITEM_M1873: "M1873",
  TXT_ITEM_M249: "M249",
  TXT_ITEM_M4A1: "M4A1",
  TXT_ITEM_M500: "M500",
  TXT_ITEM_M79: "M79",
  TXT_ITEM_MACHETE: "大砍刀",
  TXT_ITEM_MAGEZINE1: "弹匣Lv1",
  TXT_ITEM_MAGEZINE2: "弹匣Lv2",
  TXT_ITEM_MAGEZINE3: "弹匣Lv3",
  TXT_ITEM_MP40: "MP40",
  TXT_ITEM_MP5: "MP5",
  TXT_ITEM_MUZZLE1: "枪口Lv1",
  TXT_ITEM_MUZZLE2: "枪口Lv2",
  TXT_ITEM_MUZZLE3: "枪口Lv3",
  TXT_ITEM_SCAR: "SCAR",
  TXT_ITEM_SGAMMO: "霰弹枪子弹",
  TXT_ITEM_SIGHT2: "2倍瞄准镜",
  TXT_ITEM_SIGHT4: "4倍瞄准镜",
  TXT_ITEM_SILENCER1: "消音器",
  TXT_ITEM_SKS: "SKS",
  TXT_ITEM_SMGAMMO: "冲锋枪子弹",
  TXT_ITEM_SNAMMO: "狙击枪子弹",
  TXT_ITEM_SPAS12: "SPAS12",
  TXT_ITEM_SVD: "SVD",
  TXT_ITEM_UMP: "UMP",
  TXT_ITEM_USP: "USP",
  TXT_ITEM_VEST1: "防弹衣Lv1",
  TXT_ITEM_VEST2: "防弹衣Lv2",
  TXT_ITEM_VEST3: "防弹衣Lv3",
  TXT_ITEM_VSS: "VSS",
  TXT_ITEM_XM8: "XM8",
  TXT_MATCHRESULT_TITLE: "比赛结果",
  TXT_MESSAGEBOX_ERROR: "错误",
  TXT_OB10_HQW_ITEM_BIPOD: "折叠支架",
  TXT_OB10_HQW_ITEM_M60: "M60",
  TXT_OB10_JRW_CAMOUFLAGE_OILDRUM_NAME: "油桶",
  TXT_OB10_JRW_CHARACTER_BRAZILSOLDIER_NAME: "米高",
  TXT_OB10_JRW_SKILL_NAME_BRAZILSOLDIER: "杀戮冲动",
  TXT_OB10_ZXR_BASEBALLBAT_CORN_NAME: "烤玉米棒",
  TXT_OB10_ZXR_GRENADESKIN_RANGE: "爆炸范围",
  TXT_OB10_ZXR_MACHETE_RANKMASTER_NAME: "赤焰处决者",
  TXT_OB11_HQW_ITEM_MGL140: "MGL140",
  TXT_OB11_HQW_ITEM_P90: "P90",
  TXT_OB11_HQW_LANDMINE: "感应地雷",
  TXT_OB11_HQW_LANDMINE_DESC: "可以布置在地上的感应地雷，敌人靠近就会爆炸，注意自己不要踩到",
  TXT_OB11_JRW_CHARACTER_RICHGIRL_NAME: "卡洛琳",
  TXT_OB11_JRW_EMOTE_CLAP_NAME: "鼓掌",
  TXT_OB11_JRW_EMOTE_DAB_NAME: "DAB",
  TXT_OB11_JRW_EMOTE_FUNKYCHICKEN_NAME: "搞笑鸡",
  TXT_OB11_JRW_EMOTE_HELLO_NAME: "hello！",
  TXT_OB11_JRW_EMOTE_LOL_NAME: "大笑",
  TXT_OB11_JRW_EMOTE_PROVOKE_NAME: "挑衅",
  TXT_OB11_JRW_SKILL_DESC_RICHGIRL: "持霰弹枪时移动速度提升[FFB300]{0}%[-]",
  TXT_OB11_JRW_SKILL_NAME_RICHGIRL: "身手敏捷",
  TXT_OB11_ZXR_SCAR_CHEETAH_NAME: "猎豹冲刺·牙",
  TXT_OB11_ZXR_SCAR_TOPGAMER_NAME: "来自未来",
  TXT_OB16_Q_ITEM_ARMORREPAIR: "防具修理包",
  TXT_OB5_HISTORY_HEADSHOOT: "爆头",
  TXT_OB5_HISTORY_LIVE: "存活",
  TXT_OB7_JRW_CHARACTER_FOODIEBOY_NAME: "马克西姆",
  TXT_OB7_JRW_SKILL_DESC_FOODIEBOY: "吃蘑菇和医疗包的时间减少[FFB300]{0}%[-]。",
  TXT_OB7_JRW_SKILL_NAME_FOODIEBOY: "风卷残云",
  TXT_OB7_ZC_CLAN_NICKNAME: "昵称",
  TXT_OB7_ZJS_HISTORY_TIME: "时间",
  TXT_OB8_HQW_NEWLOADOUT_BONFIRE: "篝火棒",
  TXT_OB8_JYF_PARACHUTE_THUNDER_NAME: "雷电",
  TXT_OB8_SQ_CHARACTER_THAIBOXER_NAME: "查拉",
  TXT_OB8_SQ_SKILL_DESC_THAIBOXER: "拳头攻击伤害提升[FFB300]{0}%[-]。",
  TXT_OB8_SQ_SKILL_NAME_THAIBOXER: "至上拳术",
  TXT_OB8_ZXR_AWM_CAMO_NAME: "青之粒子",
  TXT_OB8_ZXR_G18_CAMO_NAME: "量子破碎",
  TXT_OB8_ZXR_M249_CAMO_NAME: "森林之王",
  TXT_OB8_ZXR_M79_CAMO_NAME: "轰天雷",
  TXT_OB8_ZXR_USP_CAMO_NAME: "雪豹",
  TXT_OB9_JRW_CHARACTER_ARMSDEALER_NAME: "帕洛玛",
  TXT_OB9_JRW_SKILL_NAME_ARMSDEALER: "有容乃大",
  TXT_OB9_JYF_SKYBOARD_BOOYAH_NAME: "BOOYAH",
  TXT_OB9_SQ_ITEM_GLOOSHIELD: "凝胶护盾",
  TXT_OB9_ZXR_AK47_DIGI_CAMO_NAME: "草原掠食者",
  TXT_OB9_ZXR_FAMAS_RED_NAME: "赤鲨",
  TXT_OB9_ZXR_G18_CAMO_02_NAME: "黄色猎豹",
  TXT_OB9_ZXR_GROZA_CAMO_NAME: "苍炎",
  TXT_OB9_ZXR_M1014_CAMO_02_NAME: "午夜迷情",
  TXT_OB9_ZXR_M14_CAMO_NAME: "灵魂之血",
  TXT_OB9_ZXR_M1873_NAME: "深海凝视",
  TXT_OB9_ZXR_MACHETE_FISH_NAME: "可怜的鱼",
  TXT_OB9_ZXR_MP5_CAMO_NAME: "无差别收割机",
  TXT_OB9_ZXR_SCAR_CAMO_BLUE_NAME: "量子冲击",
  TXT_OB9_ZXR_SKS_CAMO_NAME: "荒野杀机",
  TXT_OPTION_HIGH_BRIGHTNESS: "明亮",
  TXT_PLAYER_RANK: "排名",
  TXT_ROOM_LOBBY_ID: "ID",
  TXT_ROOM_MAP_PARADISE: "百慕大",
  TXT_SETTING_CHANGEWEAPON: "快速换枪按钮",
  TXT_SETTING_OB4_NOTREAL: "黑墨",
  TXT_SKILL_DESC_COP: "防弹装备受损比例降低[FFB300]{0}%[-]。",
  TXT_SKILL_DESC_RUNNER: "快跑速度提高[FFB300]{0}%[-]。",
  TXT_SKILL_NAME_COP: "护甲精通",
  TXT_SKILL_NAME_NURSE: "治愈之手",
  TXT_SKILL_NAME_RACERGIRL: "风驰电掣 ",
  TXT_SKILL_NAME_RUNNER: "急速冲刺",
  TXT_SKILL_NAME_SEAMAN: "钢铁意志",
  TXT_TUTORIAL_HUD: "界面",
  TXT_TUTORIAL_HUD_LABEL10: "冲刺",
  TXT_TUTORIAL_PICKUP_LABEL0: "武器",
  T_34_M_WS_VFXTYPE: "特效类型枚举",
  T_40_XXJ_WS_MONSTERATTACKTARGETTYPE_NAMEKEY: "怪物攻击目标类型枚举（删除，可回收复用）",
  T_40_XXJ_WS_PLAYERUISWITCHTYPE_NAMEKEY: "玩家界面类型",
  T_41_XXJ_WS_MONSTERSKILLTYPE: "怪物技能类型",
  T_45_META_WS_DESCRIPTIVECOLOR: "描述性颜色",
  T_45_META_WS_GAMETIME: "游戏时间",
  T_45_META_WS_PROPERTY: "属性",
  T_45_XXJ_WS_UISOCIALBUTTONSTYLETYPE: "按钮样式",
  T_45_XXJ_WS_UISOCIALBUTTONTYPE: "按钮类型",
  T_46_META_WS_A_A: "颜色的A值",
  T_46_META_WS_A_ACCELERATION: "加速度",
  T_46_META_WS_A_ACCOUNTID: "玩家账号",
  T_46_META_WS_A_ACTIONTYPE: "攻击模式",
  T_46_META_WS_A_ACTIVE: "是否活动",
  T_46_META_WS_A_ANGLE: "夹角",
  T_46_META_WS_A_ANY: "至少包含",
  T_46_META_WS_A_APPEARANCEGROUP: "外观组",
  T_46_META_WS_A_ASSERTIONEXPRESSION: "断言表达式",
  T_46_META_WS_A_ATTACHMENT: "配件",
  T_46_META_WS_A_ATTACHMENTS: "配件列表",
  T_46_META_WS_A_ATTACKABLE: "可攻击",
  T_46_META_WS_A_ATTACKER: "造成伤害的实体",
  T_46_META_WS_A_ATTACKTARGET: "攻击目标",
  T_46_META_WS_A_AUTOPLAY: "立即播放",
  T_46_META_WS_A_AXIS: "旋转轴",
  T_46_META_WS_A_B: "B",
  T_46_META_WS_A_BASE: "底数",
  T_46_META_WS_A_BOUNDTARGET: "绑定目标",
  T_46_META_WS_A_BTREE: "行为树",
  T_46_META_WS_A_BUFF: "BuffId",
  T_46_META_WS_A_CAMERA: "相机",
  T_46_META_WS_A_CAPICITY: "列表容量",
  T_46_META_WS_A_CENTER: "中心点",
  T_46_META_WS_A_CHANGEROTATION: "是否改变朝向",
  T_46_META_WS_A_CHANNEL: "频道实体",
  T_46_META_WS_A_CHASEENEMY: "自动索敌",
  T_46_META_WS_A_CHILD: "子节点",
  T_46_META_WS_A_COLOR: "叠加色",
  T_46_META_WS_A_COLUMN: "列数",
  T_46_META_WS_A_COLUMNNAME: "列名",
  T_46_META_WS_A_COMEBACK: "巡逻方式",
  T_46_META_WS_A_COMPONENT: "组件类型ID",
  T_46_META_WS_A_CONTENT: "内容",
  T_46_META_WS_A_COORDINATESYSTEM: "坐标系",
  T_46_META_WS_A_COUNT: "数量",
  T_46_META_WS_A_COUNTS: "数量列表",
  T_46_META_WS_A_CREATEDENTITY: "创建的实体",
  T_46_META_WS_A_CROSSPLATFORM: "是否跨端",
  T_46_META_WS_A_CULLINGMASK: "层遮罩",
  T_46_META_WS_A_CURVE: "曲线",
  T_46_META_WS_A_CUSTOMTAG: "自定义标签",
  T_46_META_WS_A_CUTRADIUS: "截取半径",
  T_46_META_WS_A_DAMAGE: "伤害量",
  T_46_META_WS_A_DAMAGESEGMENTS: "伤害分段",
  T_46_META_WS_A_DEGREE: "角度",
  T_46_META_WS_A_DELTA: "差值",
  T_46_META_WS_A_DEPTH: "距屏幕距离",
  T_46_META_WS_A_DESTVAL: "目标值",
  T_46_META_WS_A_DIFFICULTY: "难度",
  T_46_META_WS_A_DIRECTION: "方向",
  T_46_META_WS_A_DISABLE: "是否关闭",
  T_46_META_WS_A_DISPLACEMENT: "位移",
  T_46_META_WS_A_DISTANCE: "距离",
  T_46_META_WS_A_DIVINGMAXSPEED: "垂直下降时最大水平垂直速度",
  T_46_META_WS_A_DOTWEEN: "执行补间动画",
  T_46_META_WS_A_DURATION: "持续时间(s)",
  T_46_META_WS_A_EMOTE: "Emote类型",
  T_46_META_WS_A_ENABLE: "启用默认行为逻辑",
  T_46_META_WS_A_ENDAREACENTER: "结束区域中心",
  T_46_META_WS_A_ENDAREARANGE: "结束区域范围",
  T_46_META_WS_A_ENDPOSITION: "终点",
  T_46_META_WS_A_ENDRANK: "结束名次",
  T_46_META_WS_A_EQUIPMENTS: "武器或装备",
  T_46_META_WS_A_EVENTID: "自定义事件ID",
  T_46_META_WS_A_EXPONENT: "指数",
  T_46_META_WS_A_FACTION: "阵营",
  T_46_META_WS_A_FACTORTYPE: "属性因子类型",
  T_46_META_WS_A_FILTERTYPE: "筛选类型",
  T_46_META_WS_A_FINALRADIUS: "最终半径",
  T_46_META_WS_A_FINDVALUE: "要查找字符串",
  T_46_META_WS_A_FIXEDRANGE: "固定区域",
  T_46_META_WS_A_FOLLOWTARGET: "跟随对象",
  T_46_META_WS_A_FONTCOLOR: "字体颜色",
  T_46_META_WS_A_FONTSIZE: "字体大小",
  T_46_META_WS_A_FOOTBALL: "足球",
  T_46_META_WS_A_FORCE: "力矢量",
  T_46_META_WS_A_FORCEDPARACHUTEHEIGHT: "强制开伞高度",
  T_46_META_WS_A_FORCEMODE: "施力类型",
  T_46_META_WS_A_FORWARD: "朝向",
  T_46_META_WS_A_G: "G",
  T_46_META_WS_A_GAMEID: "任务ID",
  T_46_META_WS_A_HALFEXTENTS: "尺寸（一半）",
  T_46_META_WS_A_HEIGHT: "高度",
  T_46_META_WS_A_HEIGHTSEGMENTS: "高度分段",
  T_46_META_WS_A_HITDISTANCE: "命中距离",
  T_46_META_WS_A_HITDISTANCES: "命中距离",
  T_46_META_WS_A_HITENTITIES: "命中实体",
  T_46_META_WS_A_HITENTITY: "命中实体",
  T_46_META_WS_A_HITNORMAL: "命中点表面法线",
  T_46_META_WS_A_HITNORMALS: "命中点表面法线",
  T_46_META_WS_A_HITPOINTS: "命中点",
  T_46_META_WS_A_HITPOSITION: "命中点",
  T_46_META_WS_A_INCLUDETRIGGER: "包含触发器",
  T_46_META_WS_A_INDEX: "索引",
  T_46_META_WS_A_INDEXS: "索引列表",
  T_46_META_WS_A_INITIALVELOCITY: "初速度",
  T_46_META_WS_A_INITRADIUS: "初始半径",
  T_46_META_WS_A_INWALLET: "转入钱包",
  T_46_META_WS_A_ISBOTTOMCOLLIDING: "底部是否有触碰",
  T_46_META_WS_A_ISEXIST: "是否存在",
  T_46_META_WS_A_ISLOOP: "是否循环",
  T_46_META_WS_A_ISMAPPEDINSCREEN: "是否映射在屏幕内",
  T_46_META_WS_A_ISPAUSE: "暂停",
  T_46_META_WS_A_ISSIDECOLLIDING: "侧面是否有触碰",
  T_46_META_WS_A_ISSUCCESS: "是否成功",
  T_46_META_WS_A_ISTOPCOLLIDING: "顶部是否有触碰",
  T_46_META_WS_A_ITEM: "物品",
  T_46_META_WS_A_ITEMID: "ItemID",
  T_46_META_WS_A_ITEMS: "物品列表",
  T_46_META_WS_A_ITEMTYPE: "ItemType",
  T_46_META_WS_A_JERSEYTYPE: "衣服样式",
  T_46_META_WS_A_KEEPVELOCITY: "保持速度",
  T_46_META_WS_A_KEY: "键",
  T_46_META_WS_A_KEYCOLUMN: "列数",
  T_46_META_WS_A_KEYS: "字段名列表",
  T_46_META_WS_A_LAYER: "可见性层级",
  T_46_META_WS_A_LAYERMASK: "层遮罩",
  T_46_META_WS_A_LEFT: "左值",
  T_46_META_WS_A_LEFTVALUE: "列表",
  T_46_META_WS_A_LENGTH: "长度",
  T_46_META_WS_A_LEVELOBJECT: "物件ID",
  T_46_META_WS_A_LOG: "日志",
  T_46_META_WS_A_LOOKATTARGET: "注视目标",
  T_46_META_WS_A_LOOPTYPE: "循环类型",
  T_46_META_WS_A_MAINCOLOR1: "主色一",
  T_46_META_WS_A_MAINCOLOR2: "主色二",
  T_46_META_WS_A_MAPCODE: "战场码",
  T_46_META_WS_A_MAPPEDPOSITION: "映射位置",
  T_46_META_WS_A_MAX: "最大值",
  T_46_META_WS_A_MAXDISPLACEMENT: "最大位移",
  T_46_META_WS_A_MAXDISTANCE: "探测距离",
  T_46_META_WS_A_MIN: "最小值",
  T_46_META_WS_A_MISSIONID: "MissionID",
  T_46_META_WS_A_MISSIONPROGRESS: "MissionProgress",
  T_46_META_WS_A_MODIFYTYPE: "修改方式",
  T_46_META_WS_A_MONEYTYPE: "货币类型",
  T_46_META_WS_A_MUST: "必须包含",
  T_46_META_WS_A_NAME: "名字",
  T_46_META_WS_A_NEWVALUE: "要替换的新字符串",
  T_46_META_WS_A_NODE: "行为树节点",
  T_46_META_WS_A_NORMAL: "法向",
  T_46_META_WS_A_NOT: "必须不包含",
  T_46_META_WS_A_OBSERVER: "观察者",
  T_46_META_WS_A_OFFSET: "偏移",
  T_46_META_WS_A_OLDVALUE: "要替换的老字符串",
  T_46_META_WS_A_OPERATIOMETHOD: "运算方式",
  T_46_META_WS_A_OPTIONS: "选项",
  T_46_META_WS_A_OTHERCOLOR: "配色",
  T_46_META_WS_A_OUTFIT: "服饰",
  T_46_META_WS_A_OUTFITS: "服装列表",
  T_46_META_WS_A_OUTWALLET: "转出钱包",
  T_46_META_WS_A_OWNER: "所属者",
  T_46_META_WS_A_PARACHUTINGMAXSPEED: "开伞时最大水平垂直速度",
  T_46_META_WS_A_PARAMS: "参数列表",
  T_46_META_WS_A_PARENT: "父节点",
  T_46_META_WS_A_PARENTWIDGET: "父控件",
  T_46_META_WS_A_PATH: "路径",
  T_46_META_WS_A_PATHPOINTS: "寻路点",
  T_46_META_WS_A_PHASEINDEX: "阶段索引",
  T_46_META_WS_A_PLATFORM: "平台",
  T_46_META_WS_A_PLAYER: "玩家",
  T_46_META_WS_A_PLAYSPEED: "播放速度",
  T_46_META_WS_A_POSITION: "位置",
  T_46_META_WS_A_POSITIONS: "目标点集合",
  T_46_META_WS_A_POSTION: "位置",
  T_46_META_WS_A_PREFAB: "预制体ID",
  T_46_META_WS_A_PROPERTY: "属性",
  T_46_META_WS_A_PROPERTYID: "属性",
  T_46_META_WS_A_PURSUITTARGET: "追击目标",
  T_46_META_WS_A_R: "R",
  T_46_META_WS_A_RADIUS: "半径",
  T_46_META_WS_A_RANDOMDECAY: "随机衰减系数",
  T_46_META_WS_A_RANDOMRANGE: "随机范围",
  T_46_META_WS_A_RANDOMRATIO: "随机系数",
  T_46_META_WS_A_RANGE: "范围",
  T_46_META_WS_A_RANK: "名次",
  T_46_META_WS_A_REALCOIN: "真实货币",
  T_46_META_WS_A_REALNUMBER: "实数",
  T_46_META_WS_A_RESET: "重置",
  T_46_META_WS_A_RESOURCE: "资源",
  T_46_META_WS_A_RESULT: "结果",
  T_46_META_WS_A_RIGHT: "右值",
  T_46_META_WS_A_RIGHTVALUE: "列表",
  T_46_META_WS_A_ROTATION: "旋转",
  T_46_META_WS_A_ROW: "行数",
  T_46_META_WS_A_SAMPLEPOINT: "采样点",
  T_46_META_WS_A_SCALE: "缩放",
  T_46_META_WS_A_SCENEID: "场景ID",
  T_46_META_WS_A_SCORE: "积分值",
  T_46_META_WS_A_SCORENAME: "积分标题",
  T_46_META_WS_A_SCREENPOSITION: "屏幕坐标",
  T_46_META_WS_A_SCRIPT: "脚本ID",
  T_46_META_WS_A_SEAT: "座位",
  T_46_META_WS_A_SEP: "分隔标识符",
  T_46_META_WS_A_SEPSTR: "分隔符",
  T_46_META_WS_A_SHEETNAME: "表名",
  T_46_META_WS_A_SHOPITEM: "商品",
  T_46_META_WS_A_SHOWBACKGROUND: "显示背景",
  T_46_META_WS_A_SHOWMATCHRESULT: "显示结算信息",
  T_46_META_WS_A_SHOWMESSAGEWHENCANCEL: "取消时显示弹窗",
  T_46_META_WS_A_SKILL: "技能",
  T_46_META_WS_A_SKILLS: "玩家技能列表",
  T_46_META_WS_A_SKILLTARGET: "技能目标",
  T_46_META_WS_A_SKIN: "背包皮肤",
  T_46_META_WS_A_SLOT: "槽位",
  T_46_META_WS_A_SRCVAL: "起始值",
  T_46_META_WS_A_SRCVALUE: "起始值",
  T_46_META_WS_A_STARTAREACENTER: "起始区域中心",
  T_46_META_WS_A_STARTAREARANGE: "起始区域范围",
  T_46_META_WS_A_STARTINDEX: "起始位置",
  T_46_META_WS_A_STARTPOSITION: "起点",
  T_46_META_WS_A_STARTRANK: "起始名次",
  T_46_META_WS_A_STATE: "动画状态",
  T_46_META_WS_A_STATUS: "状态",
  T_46_META_WS_A_STATUSCODE: "状态码",
  T_46_META_WS_A_STYLE: "风格",
  T_46_META_WS_A_SURFINGMAXSPEED: "滑翔时最大水平垂直速度",
  T_46_META_WS_A_TARGET: "目标",
  T_46_META_WS_A_TARGETPOSITION: "终点",
  T_46_META_WS_A_TEAMSEQ: "队伍",
  T_46_META_WS_A_THRESHOLD: "阈值",
  T_46_META_WS_A_TIMESTAMP: "时间戳",
  T_46_META_WS_A_TIPS: "提示",
  T_46_META_WS_A_TITLE: "标题",
  T_46_META_WS_A_TOKENCOUNT: "数量",
  T_46_META_WS_A_TOKENID: "TokenID",
  T_46_META_WS_A_TORQUE: "力矩",
  T_46_META_WS_A_TOUCHPOINT: "触点",
  T_46_META_WS_A_TRANSITIONTIME: "切换时间(ms)",
  T_46_META_WS_A_TRANSITIONTYPE: "切换方式",
  T_46_META_WS_A_TRIGGER: "触发器",
  T_46_META_WS_A_TYPE: "类型",
  T_46_META_WS_A_UI: "所属Hud实体",
  T_46_META_WS_A_UIID: "Hud唯一索引",
  T_46_META_WS_A_UPWARD: "正上方对应的方向",
  T_46_META_WS_A_VALUE: "值",
  T_46_META_WS_A_VALUEA: "左值",
  T_46_META_WS_A_VALUEB: "右值",
  T_46_META_WS_A_VALUES: "值列表",
  T_46_META_WS_A_VALUET: "插值",
  T_46_META_WS_A_VALUETYPE: "值类型",
  T_46_META_WS_A_VEHICLE: "载具",
  T_46_META_WS_A_VEHICLESKIN: "车皮",
  T_46_META_WS_A_VELOCITY: "速度",
  T_46_META_WS_A_VELOCITYXZ: "向量XZ",
  T_46_META_WS_A_VELOCITYY: "向量Y",
  T_46_META_WS_A_VISIBLE: "是否可见",
  T_46_META_WS_A_WAITTIME: "等待时长(s)",
  T_46_META_WS_A_WALLET: "钱包",
  T_46_META_WS_A_WEAPON: "武器",
  T_46_META_WS_A_WEAPONSKIN: "枪皮",
  T_46_META_WS_A_WIDGETID: "控件唯一索引",
  T_46_META_WS_A_WIDGETTYPE: "控件类型",
  T_46_META_WS_A_WIDTH: "宽度",
  T_46_META_WS_A_WORLDPOSITION: "世界坐标",
  T_46_META_WS_A_WORLDPOSITIONSTAYS: "是否保持世界位置",
  T_46_META_WS_A_X: "X",
  T_46_META_WS_A_Y: "Y",
  T_46_META_WS_ABS: "绝对值",
  T_46_META_WS_ACOS: "Acos",
  T_46_META_WS_ADDAOISPECIALFOLLOW: "添加AOI特别关注",
  T_46_META_WS_ADDATTACHMENTS: "添加武器配件",
  T_46_META_WS_ADDBUFF: "添加buff",
  T_46_META_WS_ADDCOMPONENT: "添加组件",
  T_46_META_WS_ADDFOOTBALLVELOCITY: "给球加速度",
  T_46_META_WS_ADDFORCE: "施力",
  T_46_META_WS_ADDFORCEATPOSITION: "在某点施力",
  T_46_META_WS_ADDFORMULAPROPERTYFACTOR: "增加公式化属性因子",
  T_46_META_WS_ADDGAMEEVENTLOG: "添加游戏埋点日志",
  T_46_META_WS_ADDHP: "给玩家加血量",
  T_46_META_WS_ADDITEM: "添加物品",
  T_46_META_WS_ADDITEMINSCENE: "在场景中创建物品",
  T_46_META_WS_ADDITEMTOSHOPITEM: "添加物品到商品",
  T_46_META_WS_ADDMONEY: "增加货币",
  T_46_META_WS_ADDSCRIPT: "添加脚本",
  T_46_META_WS_ADDTAG: "添加标签",
  T_46_META_WS_ADDTOKEN: "增加token",
  T_46_META_WS_ADDTORQUE: "施加扭矩",
  T_46_META_WS_ADDUSEREVENTLOG: "添加用户埋点日志",
  T_46_META_WS_ANGEL: "向量夹角",
  T_46_META_WS_APPEND: "追加列表元素",
  T_46_META_WS_APPENDRANGE: "追加列表",
  T_46_META_WS_APPLYQUITMIDWAYUICONFIG: "应用中退界面配置",
  T_46_META_WS_ASIN: "Asin",
  T_46_META_WS_ASSERT: "发送断言结果",
  T_46_META_WS_ASSISTPLAYER: "助攻玩家",
  T_46_META_WS_ATAN2: "Atan2",
  T_46_META_WS_ATTACKER: "攻击者",
  T_46_META_WS_ATTACKTARGET: "攻击目标",
  T_46_META_WS_AXISANGLETOQUATERNION: "轴角转四元数",
  T_46_META_WS_BOXCAST: "盒形检测",
  T_46_META_WS_BOXOVERLAP: "盒形重叠检测",
  T_46_META_WS_BUTTONNAME: "按钮控件名",
  T_46_META_WS_C_ACTIONTYPE: "攻击模式",
  T_46_META_WS_C_AIMABLE: "可被瞄准的实体组件",
  T_46_META_WS_C_AIMASSISTABLE: "可被辅助瞄准实体",
  T_46_META_WS_C_AIMASSISTTYPE: "瞄准辅助类型",
  T_46_META_WS_C_AIRDROP: "空投箱",
  T_46_META_WS_C_AMMO: "子弹组件",
  T_46_META_WS_C_AMMOTYPE: "子弹类型",
  T_46_META_WS_C_AMPHIBIAN: "两栖/机枪摩托",
  T_46_META_WS_C_ANIMATIONCLIP: "动画片段",
  T_46_META_WS_C_ANIMATIONCLIPID: "动画资源ID",
  T_46_META_WS_C_ANIMATIONCONTROLLER: "动画控制器",
  T_46_META_WS_C_ANIMATIONCONTROLLERATTACHABLE: "可挂载动画控制器的实体组件",
  T_46_META_WS_C_ANIMATIONCONTROLLERID: "动画控制器ID",
  T_46_META_WS_C_ANIMATIONSTATE: "动画状态",
  T_46_META_WS_C_ANIMATIONTRIGGER: "动画触发器",
  T_46_META_WS_C_APPEARENCE: "换装组件",
  T_46_META_WS_C_ASSETCONFIGID: "资产配置ID",
  T_46_META_WS_C_ASSETID: "资产ID",
  T_46_META_WS_C_ATTACHMENT: "配件道具",
  T_46_META_WS_C_ATTACKABLETYPE: "可攻击类型",
  T_46_META_WS_C_AUDIOID: "音频ID",
  T_46_META_WS_C_BACKPACK: "背包组件",
  T_46_META_WS_C_BACKPACKSKINID: "背包皮肤ID",
  T_46_META_WS_C_BASEDATAALIAS: "基础数据类型别名",
  T_46_META_WS_C_BASICAPPEARANCE: "基础外观",
  T_46_META_WS_C_BASICCYLINDER: "基础圆锥或圆柱",
  T_46_META_WS_C_BASICSCALABLE: "基础方块或斜坡",
  T_46_META_WS_C_BASICSPHERE: "基础球体",
  T_46_META_WS_C_BATCHCOMBINERENDER: "合并子物件节点渲染组件",
  T_46_META_WS_C_BEVTREE: "行为树",
  T_46_META_WS_C_BEVTREEATTACHABLE: "可挂载行为树实体",
  T_46_META_WS_C_BEVTREECUSTOMNODE: "行为树自定义节点",
  T_46_META_WS_C_BEVTREEID: "行为树资产ID",
  T_46_META_WS_C_BEVTREENODESTATUS: "行为树节点运行状态",
  T_46_META_WS_C_BEVTREENODETYPE: "行为树节点类型",
  T_46_META_WS_C_BEZIERCURVE: "贝塞尔曲线",
  T_46_META_WS_C_BOOL: "布尔",
  T_46_META_WS_C_BOTDIFFICULTYTYPE: "Bot难度枚举",
  T_46_META_WS_C_BOUNCINGTIRE: "弹跳轮胎",
  T_46_META_WS_C_BUFFABLE: "能够使用FFBuff系统的实体",
  T_46_META_WS_C_BUFFGENERATOR: "Buff生成器",
  T_46_META_WS_C_BUFFTYPE: "Buff类型",
  T_46_META_WS_C_BUILTINRENDER: "桥接渲染组件",
  T_46_META_WS_C_BUILTINUI: "内置界面组件",
  T_46_META_WS_C_BUILTINUITYPE: "内置界面类型枚举",
  T_46_META_WS_C_CAMERA: "相机",
  T_46_META_WS_C_CAMERABLOCKMODE: "相机遮蔽模式",
  T_46_META_WS_C_CAMERAPROJECTIONMODE: "相机投影模式",
  T_46_META_WS_C_CAMERARAYCASTUI: "相机射线检测",
  T_46_META_WS_C_CAMERATRANSITIONTYPE: "相机切换动画类型",
  T_46_META_WS_C_CAMERATYPE: "相机视角类型",
  T_46_META_WS_C_CAMERAVIEWINGANGLERESTRICTIONTYPE: "镜头转动角度限制类型",
  T_46_META_WS_C_CAPSULETRIGGER: "胶囊体触发器",
  T_46_META_WS_C_CAR: "车组件",
  T_46_META_WS_C_CHARACTERCONTROLLER: "角色控制器",
  T_46_META_WS_C_CHATCHANNEL: "聊天频道",
  T_46_META_WS_C_CHATCHANNELTYPE: "语音频道枚举",
  T_46_META_WS_C_CHECKPOINTTRIGGER: "竞速模式检查点组件",
  T_46_META_WS_C_COINGENERATOR: "金币生成器组件",
  T_46_META_WS_C_COLLECTIONID: "藏品资产ID",
  T_46_META_WS_C_COLLIDER: "碰撞",
  T_46_META_WS_C_COLLIDERCOLLECTION: "碰撞形状",
  T_46_META_WS_C_COLLIDERCOLLECTIONID: "碰撞形状ID",
  T_46_META_WS_C_COLORDRUM: "染色桶",
  T_46_META_WS_C_COMBATABLE: "可战斗实体组件",
  T_46_META_WS_C_COMPONENT: "组件基类",
  T_46_META_WS_C_CONDITION: "条件",
  T_46_META_WS_C_CONTAINER: "实体容器",
  T_46_META_WS_C_COORDINATESYSTEMTYPE: "坐标系",
  T_46_META_WS_C_CROSSBOW: "弓箭道具",
  T_46_META_WS_C_CSVID: "配置表ID",
  T_46_META_WS_C_CUSTOMIZETRIGGER: "触发器",
  T_46_META_WS_C_CUSTOMLEVELOBJECT: "自定义物件",
  T_46_META_WS_C_CUSTOMPATH: "自定义路径",
  T_46_META_WS_C_CUSTOMUI: "自定义UI",
  T_46_META_WS_C_CUSTOMUIID: "自定义界面ID",
  T_46_META_WS_C_CUSTOMUIORWIDGET: "UI或UI控件",
  T_46_META_WS_C_CUSTOMUIWIDGETID: "自定义界面控件ID",
  T_46_META_WS_C_DAMAGEDBODYPARTTYPE: "击中身体部位类型",
  T_46_META_WS_C_DAMAGETYPE: "伤害类型枚举",
  T_46_META_WS_C_DEATHORINVINCIBILITYTRIGGER: "死亡或无敌触发器",
  T_46_META_WS_C_DESTRUCTIBLELEVELOBJECT: "可破坏物件",
  T_46_META_WS_C_DICE: "骰子组件",
  T_46_META_WS_C_DOUBLEJUMPSHOES: "双跳鞋",
  T_46_META_WS_C_DRUMMUSIC: "鼓点音乐组件",
  T_46_META_WS_C_DUALWIELDWEAPONTYPE: "武器双持类型",
  T_46_META_WS_C_DUMMYLEVELOBJECT: "普通关卡物件",
  T_46_META_WS_C_DYNAMICCREATELEVELOBJECTTYPE: "可动态创建物件类型",
  T_46_META_WS_C_DYNAMICFENCE: "动态栅栏",
  T_46_META_WS_C_EFFECT: "特效实体组件",
  T_46_META_WS_C_EFFECTCONTAINER: "特效物件",
  T_46_META_WS_C_EFFECTID: "特效ID",
  T_46_META_WS_C_EMOTETYPE: "Emote类型",
  T_46_META_WS_C_ENDPOINTTRIGGER: "终点组件",
  T_46_META_WS_C_ENTITY: "实体类",
  T_46_META_WS_C_ENTITYORPREFABID: "逻辑实体或者PrefabID",
  T_46_META_WS_C_EQUIPMENTATTACHMENT: "装备配件道具",
  T_46_META_WS_C_EQUIPMENTSLOTTYPE: "装备栏槽位类型",
  T_46_META_WS_C_EQUIPMENTTYPE: "装备类型",
  T_46_META_WS_C_EVENTID: "事件ID",
  T_46_META_WS_C_FACTION: "阵营",
  T_46_META_WS_C_FILLDIRECTIONTYPE: "填充方向类型",
  T_46_META_WS_C_FILLTYPE: "填充类型",
  T_46_META_WS_C_FIRETYPE: "开火类型",
  T_46_META_WS_C_FLOAT: "浮点数",
  T_46_META_WS_C_FOLDWING: "折叠翼",
  T_46_META_WS_C_FOLLOW: "位置跟随动画实体",
  T_46_META_WS_C_FONTTYPE: "字体枚举",
  T_46_META_WS_C_FOOTBALL: "足球",
  T_46_META_WS_C_FORCETYPE: "刚体施力类型",
  T_46_META_WS_C_FORMULABLE: "可公式化属性的实体组件",
  T_46_META_WS_C_FRAMESELFRELATIVE: "相对自身每帧运动",
  T_46_META_WS_C_GAMERESULTTYPE: "比赛结果类型",
  T_46_META_WS_C_GENDERTYPE: "性别",
  T_46_META_WS_C_GENERALSPAWNPOINT: "通用出生点",
  T_46_META_WS_C_GRENADEDEICEWALL: "反制冰墙手雷组件",
  T_46_META_WS_C_GRENADEFLASHBANG: "闪光弹",
  T_46_META_WS_C_GRENADEFROZEN: "冰冻手雷组件",
  T_46_META_WS_C_GRENADELAUNCHER: "榴弹发射器发射的道具",
  T_46_META_WS_C_GRENADESMOKE: "烟雾弹",
  T_46_META_WS_C_GRENADEWEAPON: "投掷物道具基类",
  T_46_META_WS_C_GRID: "网格",
  T_46_META_WS_C_HANDCANNON: "榴弹道具",
  T_46_META_WS_C_HELMET: "头盔",
  T_46_META_WS_C_HIERARCHICAL: "可以挂载子节点的实体",
  T_46_META_WS_C_HOOKGUN: "钩锁枪",
  T_46_META_WS_C_HORIZALINE: "急救针",
  T_46_META_WS_C_HUDTRANSFORM_DEPRECATED: "UITransform控件组件",
  T_46_META_WS_C_HUMANMODELID: "人形模型ID",
  T_46_META_WS_C_ICEWALL: "冰墙(凝胶手雷)",
  T_46_META_WS_C_ICEWALLCREATED: "冰墙(凝胶手雷)创建后的对象",
  T_46_META_WS_C_ICEWALLMAKER: "凝胶生成器",
  T_46_META_WS_C_ICON: "图标实体组件",
  T_46_META_WS_C_ICONTYPE: "图标类型",
  T_46_META_WS_C_INHALER: "呼吸器",
  T_46_META_WS_C_INT: "整数",
  T_46_META_WS_C_INT64: "64位整数",
  T_46_META_WS_C_INTEGERMAPTEMPLATE: "整数Map",
  T_46_META_WS_C_INTORINTLIST: "整数或整数列表",
  T_46_META_WS_C_INVENTORYTYPE: "物品类型枚举（待废弃）",
  T_46_META_WS_C_ITEMBASE: "道具资产基类",
  T_46_META_WS_C_ITEMCONTAINER: "实体容器",
  T_46_META_WS_C_ITEMID: "道具ID",
  T_46_META_WS_C_ITEMIDTYPE: "物品枚举",
  "T_46_META_WS_C_JERSEY STYLE": "球衣样式",
  T_46_META_WS_C_JERSEYMACHINE: "换衣机",
  T_46_META_WS_C_JETSHOES: "喷气鞋",
  T_46_META_WS_C_KEYBOARD: "琴键",
  T_46_META_WS_C_KNOCKDOWNTYPE: "击倒状态处理方式枚举",
  T_46_META_WS_C_LANDMINE: "地雷",
  T_46_META_WS_C_LANDMINECREATED: "地雷创建后的对象",
  "T_46_META_WS_C_LAUNCH PAD LEVEL OBJECT": "随身人间大炮LevelObj",
  T_46_META_WS_C_LAUNCHPAD: "随身人间大炮",
  T_46_META_WS_C_LAYOUTSORTTYPE: "布局排序类型",
  T_46_META_WS_C_LEAD1MUSIC: "离合器1音乐组件",
  T_46_META_WS_C_LEAD2MUSIC: "离合器2音乐组件",
  T_46_META_WS_C_LEAD3MUSIC: "离合器3音乐组件",
  T_46_META_WS_C_LEVELOBJECTID: "物件ID",
  T_46_META_WS_C_LEVELOBJECTTYPE: "关卡物件类型",
  T_46_META_WS_C_LIST: "列表",
  T_46_META_WS_C_LISTORMAP: "列表或字典",
  T_46_META_WS_C_LISTT: "列表模板",
  T_46_META_WS_C_LISTT_BOOL: "布尔列表",
  T_46_META_WS_C_LISTT_CONDITION: "条件列表",
  T_46_META_WS_C_LISTT_ENTITY: "实体列表",
  T_46_META_WS_C_LISTT_FLOAT: "小数列表",
  T_46_META_WS_C_LISTT_INT: "整数列表",
  T_46_META_WS_C_LISTT_ITEMGOODSIDTYPE: "物品列表",
  T_46_META_WS_C_LISTT_LEVELOBJECT: "关卡物件列表",
  T_46_META_WS_C_LISTT_LOCKEY: "本地化文本列表",
  T_46_META_WS_C_LISTT_PLAYABLE: "Playable列表",
  T_46_META_WS_C_LISTT_PLAYER: "玩家列表",
  T_46_META_WS_C_LISTT_SKILLID: "技能ID列表",
  T_46_META_WS_C_LISTT_SOUNDEFFECT: "音效实体列表",
  T_46_META_WS_C_LISTT_STRING: "字符串列表",
  T_46_META_WS_C_LISTT_TEAM: "队伍列表",
  T_46_META_WS_C_LISTT_TYPE: "类型列表",
  T_46_META_WS_C_LISTT_VECTOR3: "三维向量列表",
  T_46_META_WS_C_LOCKEY: "本地化字符串",
  T_46_META_WS_C_LOOKAT: "注视跟随动画实体",
  T_46_META_WS_C_LOOPABLE: "Loopable",
  T_46_META_WS_C_LOOPTYPE: "循环类型",
  T_46_META_WS_C_LOOTAMMOTYPE: "Loot点子弹类型",
  T_46_META_WS_C_LOOTARMOR: "Loot点防具",
  T_46_META_WS_C_LOOTARMORTYPE: "Loot点护甲类型",
  T_46_META_WS_C_LOOTCONSUMABLE: "Loot点道具",
  T_46_META_WS_C_LOOTCONSUMABLETYPE: "Loot点消耗品类型",
  T_46_META_WS_C_LOOTIAMMO: "Loot点子弹",
  T_46_META_WS_C_LOOTITEMBOXSOCCER: "Loot点足球组件",
  T_46_META_WS_C_LOOTSCOPE: "Loot点倍镜",
  T_46_META_WS_C_LOOTSCOPETYPE: "Loot点倍镜类型",
  T_46_META_WS_C_LOOTSOCCERTYPE: "Loot点足球物件",
  T_46_META_WS_C_LOOTTHROWABLE: "Loot点投掷物",
  T_46_META_WS_C_LOOTTHROWABLETYPE: "Loot点投掷物类型",
  T_46_META_WS_C_LOOTWEAPON: "Loot点武器",
  T_46_META_WS_C_LOOTWEAPONTYPE: "Loot点武器类型",
  T_46_META_WS_C_LOWGRAVITY: "低重力区",
  T_46_META_WS_C_MAP: "字典",
  T_46_META_WS_C_MAPT: "字典模板",
  T_46_META_WS_C_MATERIALID: "材质资产ID",
  T_46_META_WS_C_MEDKIT: "医疗包",
  T_46_META_WS_C_MESHID: "网格资产ID",
  T_46_META_WS_C_MIDGAMEEXITCONFIG: "中途退出配置",
  T_46_META_WS_C_MINIMAP: "小地图实体组件",
  T_46_META_WS_C_MINIMAPICON: "小地图Icon实体组件",
  T_46_META_WS_C_MINIMAPPIXELRENDERER: "小地图像素实体组件",
  T_46_META_WS_C_MINISENTRY: "炮塔道具",
  T_46_META_WS_C_MINISENTRYATTACKRANGETYPE: "防御塔攻击范围类型",
  T_46_META_WS_C_MINISENTRYCREATED: "炮塔道具放置后对象",
  T_46_META_WS_C_MONEY: "货币实体组件",
  T_46_META_WS_C_MONEYTYPE: "货币类型枚举",
  T_46_META_WS_C_MONSTER: "怪物组件",
  T_46_META_WS_C_MONSTERSPAWN: "僵尸生成器",
  T_46_META_WS_C_MONSTERTYPE: "怪物类型",
  T_46_META_WS_C_MORPHABLEOBJECT: "可被变身物件",
  T_46_META_WS_C_MORPHOBJECT: "玩家变身伪装组件",
  T_46_META_WS_C_MOTOBIKE: "摩托车",
  T_46_META_WS_C_MOVEPLATFORM: "移动平台",
  T_46_META_WS_C_MOVEPLATFORMTYPE: "可移动平台类型",
  T_46_META_WS_C_MUSHROOM: "蘑菇组件",
  T_46_META_WS_C_NATURALCONSTANTTYPE: "自然常数",
  T_46_META_WS_C_NPC: "NPC物件",
  T_46_META_WS_C_NUMBER: "数字",
  T_46_META_WS_C_OBJECT: "对象",
  T_46_META_WS_C_OILDRUM: "油桶",
  T_46_META_WS_C_OUTFITID: "服饰ID",
  T_46_META_WS_C_OUTFITSLOTTYPE: "服装槽位枚举",
  T_46_META_WS_C_PATHPOINT: "路径点",
  T_46_META_WS_C_PATROLSTYLETYPE: "巡逻风格枚举",
  T_46_META_WS_C_PATROLTYPE: "巡逻方式枚举",
  T_46_META_WS_C_PERSONA: "智能体",
  T_46_META_WS_C_PHASE: "阶段实体组件",
  T_46_META_WS_C_PHYSICALMOVER: "物理移动平台",
  T_46_META_WS_C_PHYSICALOBJECT: "物理对象",
  T_46_META_WS_C_PLATFORMTYPE: "平台类型",
  T_46_META_WS_C_PLAYABLE: "Playable",
  T_46_META_WS_C_PLAYABLEORPLAYABLES: "Playable或Playable数组",
  T_46_META_WS_C_PLAYER: "玩家实体组件",
  T_46_META_WS_C_PLAYERBACKPACK: "玩家背包实体",
  T_46_META_WS_C_PLAYERBEHAVIORSTATUSTYPE: "玩家行为状态类型",
  T_46_META_WS_C_PLAYERBEHAVIORTYPE: "玩家行为类型",
  T_46_META_WS_C_PLAYERCCT: "用于FF角色的角色控制器",
  T_46_META_WS_C_PLAYERDATAID: "预设角色类型",
  T_46_META_WS_C_PLAYERORTRANSFORM: "玩家或Transform实体",
  T_46_META_WS_C_PLAYERORVEHICLE: "玩家或载具实体",
  T_46_META_WS_C_PLAYEROUTFIT: "玩家服饰",
  T_46_META_WS_C_PLAYERPOSETYPE: "玩家姿态枚举",
  T_46_META_WS_C_PLAYERREVIVESOURCETYPE: "玩家复活来源类型",
  T_46_META_WS_C_PLAYERSTATETYPE: "玩家状态类型枚举",
  T_46_META_WS_C_POINTLIGHT: "点光源",
  T_46_META_WS_C_PORTAL: "传送门",
  T_46_META_WS_C_PREFABID: "预置体ID",
  T_46_META_WS_C_PRESENTEFFECTGENERATOR_DEPRECATED: "特效物件",
  T_46_META_WS_C_PRESENTEFFECTTEXTURETYPE_DEPRECATED: "特效贴图类型枚举",
  T_46_META_WS_C_PROFILEPICTUREWIDGET: "个人信息",
  T_46_META_WS_C_PROPERTY: "属性",
  T_46_META_WS_C_PROPERTYFORMULA: "属性公式组件",
  T_46_META_WS_C_PROPERTYFORMULAFACTORTYPE: "公式化属性公式因子类型",
  T_46_META_WS_C_PROPERTYMODIFYTYPE: "属性修改方式类型",
  T_46_META_WS_C_QUATERNION: "四元数",
  T_46_META_WS_C_RANKABLE: "可排名实体组件",
  T_46_META_WS_C_RAYCASTLAYERTYPE: "射线检测类型枚举",
  T_46_META_WS_C_REPAIRKIT: "护甲修理包",
  T_46_META_WS_C_RESETABLE: "每回合重置组件",
  T_46_META_WS_C_RIGIDBODY: "刚体",
  T_46_META_WS_C_RIGIDBODYCONSTRAINTYPE: "刚体运动限制",
  T_46_META_WS_C_RIGIDBODYTYPE: "刚体类型",
  T_46_META_WS_C_ROUND: "回合实体组件",
  T_46_META_WS_C_SAFEZONE: "毒圈",
  T_46_META_WS_C_SCOREABLE: "可积分实体组件",
  T_46_META_WS_C_SCRIPTID: "脚本ID",
  T_46_META_WS_C_SEATTYPE: "载具座位枚举",
  T_46_META_WS_C_SELFRELATIVE: "相对自身运动",
  T_46_META_WS_C_SHOP: "商店实体组件",
  T_46_META_WS_C_SHOPITEM: "商品实体组件",
  T_46_META_WS_C_SHOPSHELF: "商店货架组件",
  T_46_META_WS_C_SKATEBOARD: "滑板",
  T_46_META_WS_C_SKELETON: "骨架",
  T_46_META_WS_C_SKELETONPART: "骨架部位",
  T_46_META_WS_C_SKILLID: "技能ID",
  T_46_META_WS_C_SKYBLASTER: "飞行器",
  T_46_META_WS_C_SKYBOX: "天空盒",
  T_46_META_WS_C_SKYBOXTYPE: "天空盒基础类型",
  T_46_META_WS_C_SOCIALISLANDSNOWBALL: "社交岛雪球",
  T_46_META_WS_C_SORTTYPE: "排序方式枚举",
  T_46_META_WS_C_SOUNDDRUMTYPE: "鼓点音乐",
  T_46_META_WS_C_SOUNDEFFECT: "音效实体组件",
  T_46_META_WS_C_SOUNDEFFECTORSOUNDEFFECTLIST: "SoundEntity或SoundEntity数组",
  T_46_META_WS_C_SOUNDEFFECTTYPE: "音效类型",
  T_46_META_WS_C_SOUNDLEAD1TYPE: "Lead1音乐类型",
  T_46_META_WS_C_SOUNDLEAD2TYPE: "Lead2音乐类型",
  T_46_META_WS_C_SOUNDLEAD3TYPE: "Lead3音乐类型",
  T_46_META_WS_C_SOUNDPIANOTYPE: "琴键音乐类型",
  T_46_META_WS_C_SPAWN: "生成器实体组件",
  T_46_META_WS_C_SPAWNABLE: "单位生成器支持的单位实体组件",
  T_46_META_WS_C_SPAWNBOX: "出生区域(矩形)",
  T_46_META_WS_C_SPAWNPOSITION: "出生点组件",
  T_46_META_WS_C_SPECIALITEMIDTYPE: "特殊道具ID枚举",
  T_46_META_WS_C_SPHERETRIGGER: "球体触发器",
  T_46_META_WS_C_SPORTSCAR: "四轮车",
  T_46_META_WS_C_SPRAYCOLOR: "喷漆颜色",
  T_46_META_WS_C_SPRAYGUN: "喷漆枪基础组件",
  T_46_META_WS_C_SPRAYRESULTUI: "喷漆结算",
  T_46_META_WS_C_SPRAYRIFLE: "喷漆枪（步枪）",
  T_46_META_WS_C_SPRITEID: "图集精灵ID",
  T_46_META_WS_C_STATICSCRIPTID: "静态脚本ID",
  T_46_META_WS_C_STRING: "字符串",
  T_46_META_WS_C_STRINGORLOCSTRING: "字符串或本地化字符串",
  T_46_META_WS_C_SUPPLYBOXTRIGGER: "补给箱",
  T_46_META_WS_C_SWINGGUN: "蛛丝发射器",
  T_46_META_WS_C_SWITCHEQUIPSLOT: "切换道具槽位",
  T_46_META_WS_C_TEAM: "队伍实体组件",
  T_46_META_WS_C_TERRAIN: "地面",
  T_46_META_WS_C_TEXT: "文本实体组件",
  T_46_META_WS_C_TEXTUREID: "贴图资产ID",
  T_46_META_WS_C_TEXTURETYPE: "物件贴图类型",
  T_46_META_WS_C_TIMER: "计时器",
  T_46_META_WS_C_TIMESTAMPFORMATSTYLETYPE: "时间戳格式化显示样式",
  T_46_META_WS_C_TIMESTAMPLOCSTRING: "时间戳本地化字符串",
  T_46_META_WS_C_TRAJECTORY: "弹道动画实体",
  T_46_META_WS_C_TRANSFORM: "变换",
  T_46_META_WS_C_TUKTUK: "突突车（三轮车）",
  T_46_META_WS_C_TURRET: "防御塔",
  T_46_META_WS_C_TWEEN: "Tween",
  T_46_META_WS_C_TWEENCURVE_DEPRECATED: "TweenCurve",
  T_46_META_WS_C_TWEENSTYLE: "插值类型",
  T_46_META_WS_C_TYPE: "类型",
  T_46_META_WS_C_TYPEENUM: "类型枚举",
  T_46_META_WS_C_TYPEORTYPELIST: "类型或类型列表",
  T_46_META_WS_C_UIADDSCORE: "添加积分动效UI实体组件",
  T_46_META_WS_C_UIANITRIGGERHUD: "动画触发器HUD组件",
  T_46_META_WS_C_UIBUILTINSWITCH: "通用UI开关UI实体",
  T_46_META_WS_C_UIBUILTINUISWITCHCONTROLLER: "内置UI开关",
  T_46_META_WS_C_UICARDSELECTIONPANEL: "选择卡牌UI实体",
  T_46_META_WS_C_UICHECKPOINTINDICATOR: "检查点管理器实体组件",
  T_46_META_WS_C_UICOMPASS: "罗盘",
  T_46_META_WS_C_UICOUNTDOWN5: "5秒倒计时UI实体",
  T_46_META_WS_C_UICOUNTDOWNHINT: "倒计时飘字提示实体组件",
  T_46_META_WS_C_UICOUNTDOWNREMINDER: "计时提示界面实体组件",
  T_46_META_WS_C_UIFOLLOWHEADLTHBAR: "角色跟随头顶描述",
  T_46_META_WS_C_UIHEALTHBAR: "血条实体",
  T_46_META_WS_C_UIHEARTBEAT: "心跳UI实体",
  T_46_META_WS_C_UIICONNOTIFICATION: "图标提示信息实体组件",
  T_46_META_WS_C_UIIDENTITYNOTIFICATION: "身份告知UI实体",
  T_46_META_WS_C_UIINTERACTIONBUTTON: "交互按钮界面实体组件",
  T_46_META_WS_C_UILEADERBOARDBUTTON: "打开计分板按钮UI组件",
  T_46_META_WS_C_UIMATCHSUBTITLE: "比赛信息子标题实体组件",
  T_46_META_WS_C_UIMONSTERLEVEL: "怪物等级组件",
  T_46_META_WS_C_UIMONSTERUI: "感染模式怪物UI特效组件",
  T_46_META_WS_C_UIMULTIPLETEAMLEADERBOARD: "多队比赛详情UI实体组件",
  T_46_META_WS_C_UIMULTITEAMRESULTPANEL: "多队结算界面",
  T_46_META_WS_C_UIOPENINGBANNER: "开局横幅实体组件",
  T_46_META_WS_C_UIPANEL: "面板",
  T_46_META_WS_C_UIPANELEMPTY: "简单面板",
  T_46_META_WS_C_UIPHASETIMER: "阶段倒计时实体组件",
  T_46_META_WS_C_UIPROGRESSBAR: "进度UI实体",
  T_46_META_WS_C_UIPROGRESSCIRCLE: "准备等待进度圈",
  T_46_META_WS_C_UIPROGRESSSKILLBUTTON: "进度技能按钮",
  T_46_META_WS_C_UIREQUESTPURCHASETYPE: "请求购买类型",
  T_46_META_WS_C_UIROUNDINFOBANNER: "回合信息HUD",
  T_46_META_WS_C_UIROUNDNUMBER: "回合数实体组件",
  T_46_META_WS_C_UIROUNDRESULTBANNER: "回合结果HUD",
  T_46_META_WS_C_UIROUNDSTARTBANNER: "两队回合开始横幅实体组件",
  T_46_META_WS_C_UIROUNDTRANSITION: "回合切换实体组件",
  T_46_META_WS_C_UISCOREBAR: "比分条",
  T_46_META_WS_C_UISCROLLPANEL: "滚动视图",
  T_46_META_WS_C_UISIMPLEROUNDSCOREBANNER: "队伍回合得分横幅实体组件",
  T_46_META_WS_C_UISIMPLEROUNDSTARTBANNER: "一般回合开始横幅实体组件",
  T_46_META_WS_C_UISIMPLETIP: "提示",
  T_46_META_WS_C_UISIMPLEVERSUSBANNER: "阵营信息实体组件",
  T_46_META_WS_C_UISKILLBUTTON: "技能按钮UI实体",
  T_46_META_WS_C_UISOCIALBUTTONWIDGET: "社交功能按钮",
  T_46_META_WS_C_UISOLOLEADERBOARD: "单人比赛详情UI实体组件",
  T_46_META_WS_C_UISTORE: "商店界面组件",
  T_46_META_WS_C_UITEAMMATCHINFO: "队伍比赛信息UI实体组件",
  T_46_META_WS_C_UITEXTTIP: "文本TipsUI组件",
  T_46_META_WS_C_UITIMERINFO: "计时界面实体组件",
  T_46_META_WS_C_UITIPBUTTON: "提示按钮",
  T_46_META_WS_C_UITITLEBANNER: "标题横幅UI实体",
  T_46_META_WS_C_UITWEENTIP: "飘字提示实体组件",
  T_46_META_WS_C_UITWOTEAMBRIEFINFO: "两个队伍比赛信息简版实体组件",
  T_46_META_WS_C_UITWOTEAMINFO: "两个队伍比赛信息实体组件",
  T_46_META_WS_C_UITWOTEAMLEADERBOARD: "两队比赛详情UI实体组件",
  T_46_META_WS_C_UITWOTEAMRESULTPANEL: "回合结束展示实体组件",
  T_46_META_WS_C_UITWOTEAMROUNDSCOREBANNER: "两队回合比分组件",
  T_46_META_WS_C_UITWOTEAMSCOREPANEL: "两队结算界面",
  T_46_META_WS_C_UIVERSUSBANNER: "两队对抗横幅组件",
  T_46_META_WS_C_UIWIDGET: "UI控件",
  T_46_META_WS_C_UIWIDGETBUTTON: "按钮控件",
  T_46_META_WS_C_UIWIDGETCONTAINER: "容器控件",
  T_46_META_WS_C_UIWIDGETEMPTY: "节点控件",
  T_46_META_WS_C_UIWIDGETIMAGE: "图片控件",
  T_46_META_WS_C_UIWIDGETINPUTLABLE: "文本输入控件",
  T_46_META_WS_C_UIWIDGETJOYSTICK: "摇杆控件",
  T_46_META_WS_C_UIWIDGETLABEL: "文本控件",
  T_46_META_WS_C_UIWIDGETLAYOUT: "布局控件",
  T_46_META_WS_C_UIWIDGETPROFILE: "名片控件",
  T_46_META_WS_C_UIWIDGETTEXTURE: "贴图控件",
  T_46_META_WS_C_UIWIDGETTOGGLE: "切换按钮控件",
  T_46_META_WS_C_UIWIDGETTOUCHPAD: "触摸板控件",
  T_46_META_WS_C_UIWINORLOSEBANNER: "最终结果胜败平组件",
  T_46_META_WS_C_UNITSPAWN: "单位生成器组件",
  T_46_META_WS_C_UUID: "UUID",
  T_46_META_WS_C_VAULTTRIGGER: "翻窗逻辑物件",
  T_46_META_WS_C_VECTOR2: "二维向量",
  T_46_META_WS_C_VECTOR3: "三维向量",
  T_46_META_WS_C_VEHICLE: "载具组件",
  T_46_META_WS_C_VEHICLEIDTYPE: "载具ID",
  T_46_META_WS_C_VEHICLESKINID: "载具皮肤ID",
  T_46_META_WS_C_VENDINGMACHINE: "自动贩卖机组件",
  T_46_META_WS_C_VEST: "防弹衣",
  T_46_META_WS_C_VFXREPLACETEXTPRESENT: "可替换贴图特效",
  T_46_META_WS_C_VFXTEXTURE: "不可替换贴图特效物件",
  T_46_META_WS_C_VISIBILITY: "可见组件",
  T_46_META_WS_C_WALLET: "钱包实体组件",
  T_46_META_WS_C_WALLETHUD: "钱包界面组件",
  T_46_META_WS_C_WATERZONE: "水域",
  T_46_META_WS_C_WAVECOUNTTYPE: "波次类型",
  T_46_META_WS_C_WAVEINTERVALTYPE: "生成器间隔类型",
  T_46_META_WS_C_WEAPON: "武器组件",
  T_46_META_WS_C_WEAPONGENERATOR: "武器生成器",
  T_46_META_WS_C_WEAPONSKINID: "枪皮ID",
  T_46_META_WS_C_WEAPONTYPE: "武器类型",
  T_46_META_WS_C_WIDGETTYPE: "控件类型",
  T_46_META_WS_C_ZIPLINE: "StropShelf",
  T_46_META_WS_CAMERADIRECTION: "相机朝向",
  T_46_META_WS_CAMERAPOSITION: "相机位置",
  T_46_META_WS_CAPSULECAST: "胶囊体检测",
  T_46_META_WS_CAPSULEOVERLAP: "胶囊体重叠检测",
  T_46_META_WS_CEIL: "向上取整",
  T_46_META_WS_CHATCHANNEL: "语音频道",
  T_46_META_WS_CHECKTRIGGERBYORDER: "检测玩家是否按顺序触发levelobeject",
  T_46_META_WS_CLAMP: "Clamp",
  T_46_META_WS_CLEAR: "清空",
  T_46_META_WS_CLEARALLCHILDREN: "删除所有子节点",
  T_46_META_WS_CLEARAOISPECIALFOLLOW: "清空AOI特别关注",
  T_46_META_WS_CLEARBACKPACK: "清空背包",
  T_46_META_WS_CLEARFORMULAPROPERTYFACTOR: "清除所有公式化属性因子",
  T_46_META_WS_CLEARRESIDUALLEVELOBJECTS: "清理地图物件残留",
  T_46_META_WS_CLIPNAME: "片段名字",
  T_46_META_WS_CLONE: "克隆",
  T_46_META_WS_COLLIDEDENTITY: "碰到的实体",
  T_46_META_WS_COLORGET: "构建一个颜色值",
  T_46_META_WS_COMPLETECUSTOMMISSION: "完成自定义任务",
  T_46_META_WS_CONNECT: "字符串连接",
  T_46_META_WS_CONSUMABLEID: "道具ID",
  T_46_META_WS_CONTAIN: "是否包含特定元素",
  T_46_META_WS_CONTAINKEY: "判断字典key是否存在",
  T_46_META_WS_COPYTOMORPH: "分身为某个场景物件",
  T_46_META_WS_COS: "Cos",
  T_46_META_WS_COSTMONEY: "消耗货币",
  T_46_META_WS_COSTTOKEN: "消耗token",
  T_46_META_WS_CREATEAIRDROP: "创建空投箱",
  T_46_META_WS_CREATEBOT: "添加Bot",
  T_46_META_WS_CREATEBUILTINUI: "创建内置UI",
  T_46_META_WS_CREATEBUILTINUICLIENT: "创建内置UI",
  T_46_META_WS_CREATECAMERA: "创建相机",
  T_46_META_WS_CREATECURVE: "创建曲线",
  T_46_META_WS_CREATECUSTOMUI: "创建自定义UI",
  T_46_META_WS_CREATECUSTOMUICLIENT: "创建自定义UI",
  T_46_META_WS_CREATECUSTOMUIWIDGET: "创建自定义UI控件",
  T_46_META_WS_CREATEDAMAGENUM: "创建伤害跳字",
  T_46_META_WS_CREATEEFFECT: "创建特效",
  T_46_META_WS_CREATEEFFECTCLIENT: "创建特效",
  T_46_META_WS_CREATEFACTION: "创建阵营",
  T_46_META_WS_CREATEFOLLOW: "创建位置跟随",
  T_46_META_WS_CREATEFRAMESELFRELATIVE: "创建每帧的相对自身运动",
  T_46_META_WS_CREATEFROMPREFAB: "创建预制体实例",
  T_46_META_WS_CREATELEVELOBJECT: "创建物件",
  T_46_META_WS_CREATELOOKAT: "创建注视跟随",
  T_46_META_WS_CREATEMINIMAPICON: "创建小地图图标",
  T_46_META_WS_CREATEMINIMAPPIXEL: "创建小地图像素",
  T_46_META_WS_CREATEMONSTER: "创建僵尸",
  T_46_META_WS_CREATEMORPH: "玩家创建一个自身外观的分身",
  T_46_META_WS_CREATESELFRELATIVE: "创建相对自身运动",
  T_46_META_WS_CREATESHOP: "创建商店",
  T_46_META_WS_CREATESHOPITEM: "创建商品",
  T_46_META_WS_CREATESHOPSHELF: "创建商店货架",
  T_46_META_WS_CREATESOUND: "创建音效",
  T_46_META_WS_CREATESOUNDCLIENT: "创建音效",
  T_46_META_WS_CREATETOKENINSCENE: "场景中创建Token",
  T_46_META_WS_CREATETRAJECTORY: "创建弹道运动",
  T_46_META_WS_CREATETWEEN: "创建插值运动",
  T_46_META_WS_CREATEWALLET: "创建钱包",
  T_46_META_WS_CROSS: "向量叉积",
  T_46_META_WS_CSVCOLUMNNAMETOINT: "通过列名获取列号",
  T_46_META_WS_CURRENTAMMOCOUNT: "当前余弹量",
  T_46_META_WS_DAMAGE: "伤害量",
  T_46_META_WS_DAMAGEDBODYPART: "伤害部位",
  T_46_META_WS_DAMAGEDPLAYERS: "被炸者",
  T_46_META_WS_DAMAGETYPE: "伤害类型",
  T_46_META_WS_DEALDAMAGE: "造成伤害",
  T_46_META_WS_DELETE: "删除",
  T_46_META_WS_DELETEAT: "删除列表元素",
  T_46_META_WS_DELETECUSTOMUI: "移除自定义UI",
  T_46_META_WS_DELETEFROMDATABASE: "删除数据库表值",
  T_46_META_WS_DELETEFROMDATASTORE: "删除数据库表值",
  T_46_META_WS_DELETEFROMLEADBOARDDATABASEBYKEY: "根据Key来删除数据库中排行榜表值",
  T_46_META_WS_DELETEFROMLEADBOARDDATABASEBYRANK: "根据名次来删除数据库中排行榜表值",
  T_46_META_WS_DELETEFROMLEADBOARDDATASTOREBYKEY: "根据Key来删除数据库中排行榜表值",
  T_46_META_WS_DELETEFROMLEADBOARDDATASTOREBYRANK: "根据名次来删除数据库中排行榜表值",
  T_46_META_WS_DELETETAG: "删除标签",
  T_46_META_WS_DELTA: "位移量",
  T_46_META_WS_DESTROY: "销毁",
  T_46_META_WS_DESTROYBOT: "销毁Bot",
  T_46_META_WS_DESTROYBUILTINUI: "移除内置UI",
  T_46_META_WS_DESTROYEQUIPMENT: "销毁装备",
  T_46_META_WS_DESTROYITEM: "销毁物品",
  T_46_META_WS_DIRECTIONTOEULERANGLE: "方向向量转欧拉角",
  T_46_META_WS_DISABLESAFEZONE: "关闭安全区",
  T_46_META_WS_DISPATCHEVENT: "发送玩家自定义事件",
  T_46_META_WS_DISPATCHEVENTWITHPLATFORM: "发送玩家自定义事件",
  T_46_META_WS_DISTANCE: "向量距离",
  T_46_META_WS_DOT: "向量点积",
  T_46_META_WS_DROPITEM: "丢弃物品",
  T_46_META_WS_DYEATAREA: "对区域染色",
  T_46_META_WS_DYEATPLANE: "对平面染色",
  T_46_META_WS_DYEATPOSITION: "对目标点染色",
  T_46_META_WS_E_ABNORMALGRAVZONE: "低重力区",
  T_46_META_WS_E_AC80: "AC80",
  T_46_META_WS_E_ACCELERATION: "加速度",
  T_46_META_WS_E_ACTIONNODE: "行为节点",
  T_46_META_WS_E_ACTIVE: "主动攻击",
  T_46_META_WS_E_ACTIVESKILL: "主动技能按钮UI开关",
  T_46_META_WS_E_ADBOARD: "广告牌",
  T_46_META_WS_E_ADD: "增加",
  T_46_META_WS_E_ADDFRIEND: "添加好友",
  T_46_META_WS_E_AGENCYFB: "AgencyFB",
  T_46_META_WS_E_AIM: "瞄准",
  T_46_META_WS_E_AIR: "空气",
  T_46_META_WS_E_AIRCONDITIONERA: "空调",
  T_46_META_WS_E_AIRDROP: "空投，僵尸自杀",
  T_46_META_WS_E_AK: "AK",
  T_46_META_WS_E_AK2: "AK2",
  T_46_META_WS_E_ALIVE: "活跃",
  T_46_META_WS_E_AMMO: "武器子弹特效",
  T_46_META_WS_E_AMPHIBIANCAR: "水陆两用车",
  T_46_META_WS_E_AN94: "AN94",
  T_46_META_WS_E_APPARITION: "小鬼嬉闹",
  T_46_META_WS_E_AR: "步枪",
  T_46_META_WS_E_AR15: "AR15",
  T_46_META_WS_E_ARAMMO: "AR子弹",
  T_46_META_WS_E_ARMAGAZINE: "ARMagazine",
  T_46_META_WS_E_ARMOR: "防具状态UI开关",
  T_46_META_WS_E_ARMORBUFF: "护甲buff",
  T_46_META_WS_E_ARMORLV1: "护甲Lv1",
  T_46_META_WS_E_ARMORLV2: "护甲Lv2",
  T_46_META_WS_E_ARMORLV3: "护甲Lv3",
  T_46_META_WS_E_ARMORPIERCING: "碎甲",
  T_46_META_WS_E_ARMORSPECIALIST: "技能1",
  T_46_META_WS_E_ARROW: "箭头",
  T_46_META_WS_E_ASC: "升序",
  T_46_META_WS_E_ASCIGNOREZERO: "升序忽略零值",
  T_46_META_WS_E_ATMOSPHEREEXPLOSION: "旋风气体爆炸",
  T_46_META_WS_E_ATTACHMENT1FORCOMPATIBILITY: "Attachment1ForCompatibility",
  T_46_META_WS_E_ATTACHMENT4FORCOMPATIBILITY: "Attachment4ForCompatibility",
  T_46_META_WS_E_ATTACHMENT5FORCOMPATIBILITY: "Attachment5ForCompatibility",
  T_46_META_WS_E_ATTACHMENT6FORCOMPATIBILITY: "Attachment6ForCompatibility",
  T_46_META_WS_E_ATTACHMENT8FORCOMPATIBILITY: "Attachment8ForCompatibility",
  T_46_META_WS_E_ATTACK: "攻击",
  T_46_META_WS_E_ATTACKGRENADE: "攻击投掷物UI",
  T_46_META_WS_E_AUG: "AUG",
  T_46_META_WS_E_AUTO: "全自动",
  T_46_META_WS_E_AWM: "AWM",
  T_46_META_WS_E_AWM2: "AWM2",
  T_46_META_WS_E_BACK: "返回",
  T_46_META_WS_E_BACKANDFORTH: "来回",
  T_46_META_WS_E_BAG: "背包",
  T_46_META_WS_E_BAG1: "Bag1",
  T_46_META_WS_E_BAG2: "Bag2",
  T_46_META_WS_E_BAG3: "Bag3",
  T_46_META_WS_E_BAMBOOA: "竹子A",
  T_46_META_WS_E_BANANATREE: "香蕉树",
  T_46_META_WS_E_BASEBALLPOLE: "BaseballPole",
  T_46_META_WS_E_BASECOEFFICIENT: "基础系数",
  T_46_META_WS_E_BASIC: "基础类型",
  T_46_META_WS_E_BASICCONE: "基础圆锥",
  T_46_META_WS_E_BASICCYLINDER: "基础圆柱",
  T_46_META_WS_E_BASICSPHERE: "基础球体",
  T_46_META_WS_E_BATTLEINSTYLE: "战斗潮流",
  T_46_META_WS_E_BELL: "铃铛",
  T_46_META_WS_E_BENCH: "长椅",
  T_46_META_WS_E_BIGHEADHAMMER: "BigHeadHammer",
  T_46_META_WS_E_BILLBOARD: "大屏幕",
  T_46_META_WS_E_BIPOD: "Bipod",
  T_46_META_WS_E_BISGRAFFITIWALL: "BIS主题墙壁",
  T_46_META_WS_E_BIZON: "Bizon",
  T_46_META_WS_E_BLACKHOLE: "黑洞爆炸特效",
  T_46_META_WS_E_BLACKHOLEBOOM: "水晶球特效",
  T_46_META_WS_E_BLAST: "爆炸",
  T_46_META_WS_E_BLOCK: "正方形",
  T_46_META_WS_E_BLOODBALL: "黑洞特效",
  T_46_META_WS_E_BLT: "BLT",
  T_46_META_WS_E_BLT2: "BLT2",
  T_46_META_WS_E_BLUE: "蓝色",
  T_46_META_WS_E_BLUEDOLL: "冰娃娃",
  T_46_META_WS_E_BOARD: "移動板",
  T_46_META_WS_E_BODY: "身体",
  T_46_META_WS_E_BOMBINDICATION: "炸弹提示",
  T_46_META_WS_E_BOMBPLIERS: "BombPliers",
  T_46_META_WS_E_BONFIRE: "燃烧的火堆",
  T_46_META_WS_E_BOOM: "圆环",
  T_46_META_WS_E_BOOYAH: "胜利",
  T_46_META_WS_E_BOTH: "双端",
  T_46_META_WS_E_BOUNCETIRE: "轮胎",
  T_46_META_WS_E_BOWAMMO: "Bow子弹",
  T_46_META_WS_E_BREAKABLEBOX: "可破坏木箱",
  T_46_META_WS_E_BREAKABLECONTAINER: "可破坏集装箱",
  T_46_META_WS_E_BREAKABLEFENCE: "可破坏栅栏",
  T_46_META_WS_E_BRICKA: "砖块A",
  T_46_META_WS_E_BRICKB: "砖块B",
  T_46_META_WS_E_BRICKC: "砖块C",
  T_46_META_WS_E_BRICKHOUSEA: "小矮房A",
  T_46_META_WS_E_BRIGHT: "亮色",
  T_46_META_WS_E_BUBBLE: "泡泡",
  T_46_META_WS_E_BUFFGENERATOR: "BuffGen",
  T_46_META_WS_E_BULLETBUFF: "子弹buff",
  T_46_META_WS_E_BULLETHITTING: "子弹命中",
  T_46_META_WS_E_BUMPERCAR: "碰碰车",
  T_46_META_WS_E_BUMPERCARFACTORY: "碰碰车厂",
  T_46_META_WS_E_BURNING: "载具爆炸后燃烧伤害",
  T_46_META_WS_E_BUSHES: "草丛",
  T_46_META_WS_E_BUSSTOP: "公交站",
  T_46_META_WS_E_BUTTOM: "下身服饰",
  T_46_META_WS_E_BUTTONWIDGET: "按钮控件",
  T_46_META_WS_E_BYHIERARCHY: "按层级结构",
  T_46_META_WS_E_CABINET: "储物柜",
  T_46_META_WS_E_CACTUS: "仙人掌",
  T_46_META_WS_E_CAMOUFLAGE: "技能6",
  T_46_META_WS_E_CAPSULETRIGGER: "胶囊体触发器",
  T_46_META_WS_E_CARDIOTONIC: "Cardiotonic",
  T_46_META_WS_E_CASUALGAMEBGM: "休闲游戏背景音乐",
  T_46_META_WS_E_CEMENTA: "水泥A",
  T_46_META_WS_E_CG15: "CG15",
  T_46_META_WS_E_CHANNELA: "空闲语音频道1",
  T_46_META_WS_E_CHANNELB: "空闲语音频道2",
  T_46_META_WS_E_CHANNELC: "空闲语音频道3",
  T_46_META_WS_E_CHANNELD: "空闲语音频道4",
  T_46_META_WS_E_CHANNELE: "空闲语音频道5",
  T_46_META_WS_E_CHANNELF: "空闲语音频道6",
  T_46_META_WS_E_CHARACTERSKILL: "角色技能",
  T_46_META_WS_E_CHARACTOR: "人物",
  T_46_META_WS_E_CHARGE: "充能1",
  T_46_META_WS_E_CHARGEBUSTER: "ChargeBuster",
  T_46_META_WS_E_CHECKPOINT: "检查点",
  T_46_META_WS_E_CHEER: "欢呼",
  T_46_META_WS_E_CHERRYBLOSSOM: "樱花树",
  T_46_META_WS_E_CIRCLE: "圆",
  T_46_META_WS_E_CIRCLEBACK: "循环",
  T_46_META_WS_E_CIRCLEOFHEAT: "脚底光柱",
  T_46_META_WS_E_CITY: "城市",
  T_46_META_WS_E_CLAPS: "拍手声",
  T_46_META_WS_E_CLEAR: "清除",
  T_46_META_WS_E_CLIENT: "客户端",
  T_46_META_WS_E_CLONE: "变身",
  T_46_META_WS_E_CLONEKILL: "分身死亡",
  T_46_META_WS_E_CLOSE: "关闭",
  T_46_META_WS_E_CLOTHES: "衣服",
  T_46_META_WS_E_COINGENERATOR: "金币生成器",
  T_46_META_WS_E_COLDAIR: "冷气",
  T_46_META_WS_E_COLORBLOCK: "染色方块",
  T_46_META_WS_E_COLOROILBARREL: "染色油桶",
  T_46_META_WS_E_COMBINEALL: "任意组合双持",
  T_46_META_WS_E_COMBINESELF: "和自己双持",
  T_46_META_WS_E_COMBOKEYA1: "乐符-合成器A",
  T_46_META_WS_E_COMBOKEYA2: "乐符-合成器A",
  T_46_META_WS_E_COMBOKEYB1: "乐符-合成器B",
  T_46_META_WS_E_COMBOKEYB2: "乐符-合成器B",
  T_46_META_WS_E_COMBOKEYC1: "乐符-合成器C",
  T_46_META_WS_E_COMBOKEYC2: "乐符-合成器C",
  T_46_META_WS_E_CONCRETEPILLAR: "水泥柱",
  T_46_META_WS_E_CONDITIONNODE: "条件节点",
  T_46_META_WS_E_CONTAINERA: "集装箱A",
  T_46_META_WS_E_CONTAINERB: "集装箱B",
  T_46_META_WS_E_CONTAINERC: "集装箱C",
  T_46_META_WS_E_CONTAINERWIDGET: "容器控件",
  T_46_META_WS_E_CONTINUOUS: "持续生成",
  T_46_META_WS_E_COUNTDOWN: "计时",
  T_46_META_WS_E_COUNTDOWNDENGDENG: "倒计时",
  T_46_META_WS_E_COUNTDOWNDIDI: "倒计时的滴滴声",
  T_46_META_WS_E_COUNTDOWNMECHANICAL: "倒计时",
  T_46_META_WS_E_COUNTDOWNWITHINGAME: "倒计时3",
  T_46_META_WS_E_CROSS: "十字",
  T_46_META_WS_E_CROSSBOW: "十字弩",
  T_46_META_WS_E_CROSSHAIR: "准星",
  T_46_META_WS_E_CROSSHAIRS: "准星UI开关",
  T_46_META_WS_E_CROUCH: "蹲下UI",
  T_46_META_WS_E_CROUCHING: "蹲",
  T_46_META_WS_E_CROWCAW: "乌鸦叫的环境音",
  T_46_META_WS_E_CROWN: "皇冠",
  T_46_META_WS_E_CUBE: "方塊機關",
  T_46_META_WS_E_CURSE: "符咒",
  T_46_META_WS_E_CURSEEXPLOSION: "符咒爆炸",
  T_46_META_WS_E_CUSTOM: "自定义相机",
  T_46_META_WS_E_CUSTOMTRIGGER: "自定义触发器",
  T_46_META_WS_E_CUSTOMWATERZONE: "自定义水域",
  T_46_META_WS_E_CYCLICCOMBUSTION: "循环燃烧",
  T_46_META_WS_E_CYLIC: "循环",
  T_46_META_WS_E_DAGGER: "飞刀",
  T_46_META_WS_E_DAMAGEDTRUCK: "损毁的卡车",
  T_46_META_WS_E_DAMAGEZONE: "伤害区",
  T_46_META_WS_E_DANGERALARM: "危险提示音2",
  T_46_META_WS_E_DANGERVIBRATING: "危险提示音1",
  T_46_META_WS_E_DARK: "暗色",
  T_46_META_WS_E_DARKNESS: "黑暗",
  T_46_META_WS_E_DASHATTACK: "冲撞攻击",
  T_46_META_WS_E_DATASTORAGELIMITEXCEEDED: "数据存储超出限制",
  T_46_META_WS_E_DATASTORAGEPARAMETERERROR: "数据存储参数错误",
  T_46_META_WS_E_DATASTORAGETIMEOUT: "数据存储超时",
  T_46_META_WS_E_DATETIME: "DateTime",
  T_46_META_WS_E_DAY: "白天",
  T_46_META_WS_E_DEAD: "死亡",
  T_46_META_WS_E_DEATH: "死亡状态",
  T_46_META_WS_E_DEFAULT: "默认",
  T_46_META_WS_E_DEFAULTFIST: "拳头",
  T_46_META_WS_E_DEFENCEGRENADE: "防御投掷物UI",
  T_46_META_WS_E_DESC: "降序",
  T_46_META_WS_E_DIALOGUE: "对话",
  T_46_META_WS_E_DIAMOND: "钻石",
  T_46_META_WS_E_DIRECTIONSIGN: "指示牌",
  T_46_META_WS_E_DIRVEVEHICLE: "操作载具",
  T_46_META_WS_E_DISABLE: "禁用",
  T_46_META_WS_E_DISABLED: "禁用",
  T_46_META_WS_E_DISAPPEARNOTIFICATION: "消失提示",
  T_46_META_WS_E_DISCONNECT: "断线",
  T_46_META_WS_E_DISGUISE: "分身",
  T_46_META_WS_E_DOGHOUSE: "狗狗屋",
  T_46_META_WS_E_DOOR: "门",
  T_46_META_WS_E_DOUBLE: "双个",
  T_46_META_WS_E_DOUBLEDOOR: "双扇门",
  T_46_META_WS_E_DOUBLEJUMPSHOE: "DoubleJumpShoe",
  T_46_META_WS_E_DOUBLEMAGEZINE: "DoubleMagezine",
  T_46_META_WS_E_DRAW: "平局",
  T_46_META_WS_E_DRILLZOMBIE: "钻地怪僵尸",
  T_46_META_WS_E_DRIVE: "驾驶",
  T_46_META_WS_E_DRIVER: "驾驶员",
  T_46_META_WS_E_DROPBEAT: "技能4",
  T_46_META_WS_E_DRUMKEY1: "乐符-鼓",
  T_46_META_WS_E_DRUMKEY2: "乐符-鼓",
  T_46_META_WS_E_DUEL: "决斗",
  T_46_META_WS_E_DUMMY: "Dummy",
  T_46_META_WS_E_DUMMYGRENADE: "假人",
  T_46_META_WS_E_DUMP: "扔",
  T_46_META_WS_E_DUSK: "黄昏",
  T_46_META_WS_E_DUST: "烟尘",
  T_46_META_WS_E_DYNAMIC: "动态",
  T_46_META_WS_E_E: "自然常数",
  T_46_META_WS_E_EAGLE: "EAGLE",
  T_46_META_WS_E_EASY: "容易的",
  T_46_META_WS_E_ELECTRICSHOCK: "电击",
  T_46_META_WS_E_ELECTRICSURFBOARD: "ElectricSurfboard",
  T_46_META_WS_E_ELECTRICZONE: "毒圈",
  T_46_META_WS_E_ELECTRONICBGM: "电子梦幻可爱背景音乐",
  T_46_META_WS_E_ELIMINATEDBOSS: "弹劾会长",
  T_46_META_WS_E_ELIMINATIONNOTIFICATION: "击杀提示讯息",
  T_46_META_WS_E_EMOTE: "表情UI开关",
  T_46_META_WS_E_ENABLE: "启用",
  T_46_META_WS_E_ENERGETIC: "充满能量",
  T_46_META_WS_E_ENTERVEHICLE: "进入载具",
  T_46_META_WS_E_EP: "EP条UI开关",
  T_46_META_WS_E_EXCLAMATIONMARK: "叹号",
  T_46_META_WS_E_EXIT: "退出",
  T_46_META_WS_E_EXITVEHICLE: "离开载具",
  T_46_META_WS_E_EXPLODE: "自爆",
  T_46_META_WS_E_EXPLOSION: "爆炸特效",
  T_46_META_WS_E_EXPLOSIVEBLAZE: "爆炸火光",
  T_46_META_WS_E_EXPLOSIVEPAINTSKILL: "元气弹技能",
  T_46_META_WS_E_EXPLOSIVEZOMBIE: "自爆僵尸",
  T_46_META_WS_E_EYE: "眼镜",
  T_46_META_WS_E_FACEPAINT: "妆容",
  T_46_META_WS_E_FACTION: "阵营",
  T_46_META_WS_E_FALLING: "掉落",
  T_46_META_WS_E_FALLINGSTAR: "获得道具",
  T_46_META_WS_E_FALSE: "否",
  T_46_META_WS_E_FAMAS: "FAMAS",
  T_46_META_WS_E_FAN: "螺旋槳機關",
  T_46_META_WS_E_FAR: "RangeFar",
  T_46_META_WS_E_FEATHER: "羽毛",
  T_46_META_WS_E_FEMALE: "女",
  T_46_META_WS_E_FENCE: "围栏",
  T_46_META_WS_E_FGL24: "FGL24",
  T_46_META_WS_E_FIGHTINGENTITY: "FightingEntity",
  T_46_META_WS_E_FILLED: "填充",
  T_46_META_WS_E_FINISH: "完成",
  T_46_META_WS_E_FINISHINGPOINT: "终点",
  T_46_META_WS_E_FINISHLINEARCH: "终点横幅",
  T_46_META_WS_E_FIRE: "火焰",
  T_46_META_WS_E_FIRECHARGE: "火焰弹",
  T_46_META_WS_E_FIREWORK: "烟花",
  T_46_META_WS_E_FIRINGEFFECT: "武器开火特效",
  T_46_META_WS_E_FIRSTPERSON: "第一人称视角相机",
  T_46_META_WS_E_FIRSTPERSONCLASSIC: "第一人称视角相机（FF经典）",
  T_46_META_WS_E_FIST: "FIST",
  T_46_META_WS_E_FIT: "自适应",
  T_46_META_WS_E_FLAG: "旗帜",
  T_46_META_WS_E_FLAME: "火焰",
  T_46_META_WS_E_FLAMEGUN: "FlameGun",
  T_46_META_WS_E_FLAMETHROWER: "喷火器",
  T_46_META_WS_E_FLASH: "闪光弹",
  T_46_META_WS_E_FLASHBANG: "Flashbang",
  T_46_META_WS_E_FLASHBANGSPARKS: "闪光弹烟火",
  T_46_META_WS_E_FLASHFREEZE: "冰冻手榴弹",
  T_46_META_WS_E_FLEXWALL: "伸縮牆",
  T_46_META_WS_E_FLICKER: "闪烁",
  T_46_META_WS_E_FLOWER: "花",
  T_46_META_WS_E_FLYBOMBBEE: "飞行僵尸",
  T_46_META_WS_E_FLYPAN: "平底鍋機關",
  T_46_META_WS_E_FLYSHOE: "Flyshoe",
  T_46_META_WS_E_FOLDER: "文件夹",
  T_46_META_WS_E_FOLDWINGS: "Foldwings",
  T_46_META_WS_E_FOODTRUCK: "小餐车",
  T_46_META_WS_E_FOODTRUCKB: "小餐车b",
  T_46_META_WS_E_FOOTBALL: "足球",
  T_46_META_WS_E_FOOTBALLGUN: "足球枪",
  T_46_META_WS_E_FOOTBALLICE: "FootballIce",
  T_46_META_WS_E_FOOTBALLSHIELD: "FootballShield",
  T_46_META_WS_E_FOOTBALLSHOOTER: "足球枪",
  T_46_META_WS_E_FORCE: "线性力",
  T_46_META_WS_E_FOREGRIP_MR: "FOREGRIP_MR",
  T_46_META_WS_E_FOREGRIP1: "Foregrip1",
  T_46_META_WS_E_FOREGRIP2: "Foregrip2",
  T_46_META_WS_E_FOREGRIP3: "Foregrip3",
  T_46_META_WS_E_FORWARD: "前方",
  T_46_META_WS_E_FOUNTAIN: "喷泉",
  T_46_META_WS_E_FREE: "自由视角相机",
  T_46_META_WS_E_FREEZEALL: "限制所有轴的平移和旋转",
  T_46_META_WS_E_FREEZEPOSITION: "限制所有轴的平移",
  T_46_META_WS_E_FREEZEPOSITIONX: "限制X轴方向平移",
  T_46_META_WS_E_FREEZEPOSITIONY: "限制Y轴方向平移",
  T_46_META_WS_E_FREEZEPOSITIONZ: "限制Z轴方向平移",
  T_46_META_WS_E_FREEZEROTATION: "限制所有轴的旋转",
  T_46_META_WS_E_FREEZEROTATIONX: "限制X轴方向旋转",
  T_46_META_WS_E_FREEZEROTATIONY: "限制Y轴方向旋转",
  T_46_META_WS_E_FREEZEROTATIONZ: "限制Z轴方向旋转",
  T_46_META_WS_E_FREEZEZONE: "冰冻区域",
  "T_46_META_WS_E_FROST GALAXY": "极地星空",
  T_46_META_WS_E_FROZEN: "冰冻",
  T_46_META_WS_E_FROZENGRENADE: "冰冻手雷",
  T_46_META_WS_E_FUNCTIONALITEMS: "功能型道具",
  T_46_META_WS_E_FZLANTINGHEI: "FZLanTingHei",
  T_46_META_WS_E_G18: "G18",
  T_46_META_WS_E_G36: "G36",
  T_46_META_WS_E_GAME: "游戏",
  T_46_META_WS_E_GAMEOVER: "游戏结束2",
  T_46_META_WS_E_GAMESTART: "游戏开始",
  T_46_META_WS_E_GARAGE: "车库",
  T_46_META_WS_E_GATLING: "Gatling",
  T_46_META_WS_E_GEARSWITCHEDON: "机关开启",
  T_46_META_WS_E_GENTLETAP: "弱点击",
  T_46_META_WS_E_GETITEM: "获得道具2",
  T_46_META_WS_E_GFFLATIN: "GFFLatin",
  T_46_META_WS_E_GHOST: "鬼魂",
  T_46_META_WS_E_GIANTDICE: "骰子",
  T_46_META_WS_E_GIANTLOLLIPOP: "大型棒棒糖",
  T_46_META_WS_E_GIFT: "礼物",
  T_46_META_WS_E_GLOOWALL: "凝胶护盾",
  T_46_META_WS_E_GOLD_HEATGUN_I: "GOLD_HEATGUN_I",
  T_46_META_WS_E_GOLD_HEATGUN_II: "GOLD_HEATGUN_II",
  T_46_META_WS_E_GOLD_HEATGUN_III: "GOLD_HEATGUN_III",
  T_46_META_WS_E_GOLD_M1014_I: "GOLD_M1014_I",
  T_46_META_WS_E_GOLD_M1014_II: "GOLD_M1014_II",
  T_46_META_WS_E_GOLD_M1014_III: "GOLD_M1014_III",
  T_46_META_WS_E_GOLD_SCAR_I: "GOLD_SCAR_I",
  T_46_META_WS_E_GOLD_SCAR_II: "GOLD_SCAR_II",
  T_46_META_WS_E_GOLD_SCAR_III: "GOLD_SCAR_III",
  T_46_META_WS_E_GOLDAWM: "GoldAWM",
  T_46_META_WS_E_GOLDFAMAS_I: "GoldFamas_I",
  T_46_META_WS_E_GOLDFAMAS_II: "GoldFamas_II",
  T_46_META_WS_E_GOLDFAMAS_III: "GoldFamas_III",
  T_46_META_WS_E_GOLDGROZA: "GoldGroza",
  T_46_META_WS_E_GOLDKAR98K_I: "GoldKar98K_I",
  T_46_META_WS_E_GOLDKAR98K_II: "GoldKar98K_II",
  T_46_META_WS_E_GOLDKAR98K_III: "GoldKar98K_III",
  T_46_META_WS_E_GOLDKAR98K_III_FORINFECTION: "GoldKar98K_III_ForInfection",
  T_46_META_WS_E_GOLDM14_I: "GoldM14_I",
  T_46_META_WS_E_GOLDM14_II: "GoldM14_II",
  T_46_META_WS_E_GOLDM14_III: "GoldM14_III",
  T_46_META_WS_E_GOLDM14_III_FORINFECTION: "GoldM14_III_ForInfection",
  T_46_META_WS_E_GOLDM4A1_I: "GoldM4A1_I",
  T_46_META_WS_E_GOLDM4A1_II: "GoldM4A1_II",
  T_46_META_WS_E_GOLDM4A1_III: "GoldM4A1_III",
  T_46_META_WS_E_GOLDM4A1_III_FORINFECTION: "GoldM4A1_III_ForInfection",
  T_46_META_WS_E_GOLDM60_I: "GoldM60_I",
  T_46_META_WS_E_GOLDM60_II: "GoldM60_II",
  T_46_META_WS_E_GOLDM60_III: "GoldM60_III",
  T_46_META_WS_E_GOLDM60_III_FORINFECTION: "GoldM60_III_ForInfection",
  T_46_META_WS_E_GOLDMP5_I: "GoldMP5_I",
  T_46_META_WS_E_GOLDMP5_II: "GoldMP5_II",
  T_46_META_WS_E_GOLDMP5_III: "GoldMP5_III",
  T_46_META_WS_E_GOLDMP5_III_FORINFECTION: "GoldMP5_III_ForInfection",
  T_46_META_WS_E_GOLDSVD: "GoldSVD",
  T_46_META_WS_E_GOLDVSS_I: "GoldVSS_I",
  T_46_META_WS_E_GOLDVSS_II: "GoldVSS_II",
  T_46_META_WS_E_GOLDVSS_III: "GoldVSS_III",
  T_46_META_WS_E_GRAFFITIFLOWERBED: "BIS主题花坛",
  T_46_META_WS_E_GRAFFITIWALL: "涂鸦墙",
  T_46_META_WS_E_GRAPPLINGHOOKGUN: "钩锁枪",
  T_46_META_WS_E_GREATCONDUCTOR: "伟大指挥",
  T_46_META_WS_E_GREEN: "绿色",
  T_46_META_WS_E_GRENADE: "手榴弹",
  T_46_META_WS_E_GRID: "网格",
  T_46_META_WS_E_GROZA: "GROZA",
  T_46_META_WS_E_GROZA2: "GROZA2",
  T_46_META_WS_E_GUARDTOWER: "哨塔",
  T_46_META_WS_E_GUILD: "公会",
  T_46_META_WS_E_GUN: "枪械",
  T_46_META_WS_E_GUNFIRE: "枪火",
  T_46_META_WS_E_HALO: "光环",
  T_46_META_WS_E_HAMMER: "巨槌機關",
  T_46_META_WS_E_HANDCANNON: "HandCannon",
  T_46_META_WS_E_HANGER: "晾衣架",
  T_46_META_WS_E_HARD: "困难的",
  T_46_META_WS_E_HATTRICK: "技能8",
  T_46_META_WS_E_HAYSTACK: "草垛",
  T_46_META_WS_E_HEAD: "头饰",
  T_46_META_WS_E_HEADSHOOT: "爆头",
  T_46_META_WS_E_HEALINGGUN_SNIPER: "Healinggun_Sniper",
  T_46_META_WS_E_HEALINGPISTOL_X: "HealingPistol_X",
  T_46_META_WS_E_HEALPISTOL: "治疗枪",
  T_46_META_WS_E_HEART: "爱心",
  T_46_META_WS_E_HEARTBEAT: "心跳",
  T_46_META_WS_E_HEATGUN: "HeatGun",
  T_46_META_WS_E_HEAVYWEAPON: "重武器",
  T_46_META_WS_E_HELL: "极难的",
  T_46_META_WS_E_HELMET: "头盔",
  T_46_META_WS_E_HELMET1: "Helmet1",
  T_46_META_WS_E_HELMET2: "Helmet2",
  T_46_META_WS_E_HELMET3: "Helmet3",
  T_46_META_WS_E_HEXAGON: "六边形",
  T_46_META_WS_E_HGAMMO: "HG子弹",
  T_46_META_WS_E_HIDEANDSEEKFLAMETHROWER: "喷火器躲猫猫",
  T_46_META_WS_E_HIDERKILL: "躲藏者被击杀",
  T_46_META_WS_E_HIHATS: "闭合踩镲",
  T_46_META_WS_E_HINDSILIGURI: "HindSiliguri",
  T_46_META_WS_E_HITBLUNT: "沉闷打击",
  T_46_META_WS_E_HITEFFECT: "子弹命中特效",
  T_46_META_WS_E_HITFEEDBACK: "射击反馈",
  T_46_META_WS_E_HOOK: "钩锁头",
  T_46_META_WS_E_HOOKGUN: "HookGun",
  T_46_META_WS_E_HOOKGUNAMMO: "HookGunAMMO",
  T_46_META_WS_E_HORIZALINE: "强心针",
  T_46_META_WS_E_HORIZONTAL: "水平",
  T_46_META_WS_E_HORN: "喇叭",
  T_46_META_WS_E_HORROR: "恐怖",
  T_46_META_WS_E_HOURGLASS: "沙漏",
  T_46_META_WS_E_HOUSE: "房屋",
  T_46_META_WS_E_HOUSEA: "一层民房",
  T_46_META_WS_E_HOUSEB: "二层民房",
  T_46_META_WS_E_HOUSEC: "三层民房",
  T_46_META_WS_E_HP: "血条UI开关",
  T_46_META_WS_E_HPBUFF: "血量buff",
  T_46_META_WS_E_HUT: "小屋",
  T_46_META_WS_E_ICEA: "冰块A",
  T_46_META_WS_E_ICEGUN: "IceGun",
  T_46_META_WS_E_ICEWALLMAKER: "凝胶生成器",
  T_46_META_WS_E_ICONOBJECT: "图标实体",
  T_46_META_WS_E_IMAGEWIDGET: "图片控件",
  T_46_META_WS_E_IMPULSE: "冲击",
  T_46_META_WS_E_INHALER: "呼吸器",
  T_46_META_WS_E_INJUREDFEMALE: "受击尖叫声女",
  T_46_META_WS_E_INJUREDMALE: "受击尖叫声男",
  T_46_META_WS_E_INK: "水墨特效",
  T_46_META_WS_E_INPUTLABLEWIDGET: "文本输入控件",
  T_46_META_WS_E_INSECTCHIRPING: "夜晚虫鸣",
  T_46_META_WS_E_INTERVAL10SECONDS: "10秒",
  T_46_META_WS_E_INTERVAL15SECONDS: "15秒",
  T_46_META_WS_E_INTERVAL30SECONDS: "30秒",
  T_46_META_WS_E_INTERVAL3SECONDS: "3秒",
  T_46_META_WS_E_INTERVAL5SECONDS: "5秒",
  T_46_META_WS_E_INTERVAL9999SECONDS: "9999秒",
  T_46_META_WS_E_INVISIBLE: "屏蔽",
  T_46_META_WS_E_IPIPE: "直管道",
  T_46_META_WS_E_IRONFENCE: "栅栏",
  T_46_META_WS_E_IRONFENCEB: "栅栏B",
  T_46_META_WS_E_IRONPLATFORM: "铁台",
  T_46_META_WS_E_ITEMENTITY: "道具生成器",
  T_46_META_WS_E_JEEP: "吉普车",
  T_46_META_WS_E_JERRYCAN: "油桶",
  T_46_META_WS_E_JERSEYMACHINE: "球衣机",
  T_46_META_WS_E_JOINEDGAMEDULL: "加入激战",
  T_46_META_WS_E_JOINGAME: "加入游戏",
  T_46_META_WS_E_JOYSTICKWIDGET: "摇杆控件",
  T_46_META_WS_E_JUMP: "跳跃",
  T_46_META_WS_E_JUMPATTACK: "跳斩",
  T_46_META_WS_E_JUSTPATROL: "只巡逻",
  T_46_META_WS_E_KAR98K: "Kar98K",
  T_46_META_WS_E_KATANA: "Katana",
  T_46_META_WS_E_KEY: "钥匙",
  T_46_META_WS_E_KICK: "底鼓",
  T_46_META_WS_E_KILLINGTIPS: "击杀提示UI",
  T_46_META_WS_E_KILLZONE: "死亡区域",
  T_46_META_WS_E_KINEMATIC: "运动学",
  T_46_META_WS_E_KNIFE: "Knife",
  T_46_META_WS_E_KNOCKDOWN: "倒地状态",
  T_46_META_WS_E_KNOCKEDDOWN: "击倒",
  T_46_META_WS_E_KORD: "Kord",
  T_46_META_WS_E_LABELWIDGET: "文本控件",
  T_46_META_WS_E_LANDINGA: "楼梯平台A",
  T_46_META_WS_E_LANDINGB: "楼梯平台B",
  T_46_META_WS_E_LANDINGC: "楼梯平台C",
  T_46_META_WS_E_LANDMINE: "Landmine",
  T_46_META_WS_E_LANUNCHERAMMO: "LanuncherAMMO",
  T_46_META_WS_E_LASER: "激光特效",
  T_46_META_WS_E_LASERSKILL: "激光技能",
  T_46_META_WS_E_LATTICESCREEN: "屏风",
  T_46_META_WS_E_LAWNA: "草坪A",
  T_46_META_WS_E_LAWNB: "草坪B",
  T_46_META_WS_E_LAYOUTWIDGET: "布局控件",
  T_46_META_WS_E_LEAD1A2: "Lead1A2",
  T_46_META_WS_E_LEAD1A2SHARP: "Lead1A2#",
  T_46_META_WS_E_LEAD1B2: "Lead1B2",
  T_46_META_WS_E_LEAD1C2: "Lead1C2",
  T_46_META_WS_E_LEAD1C2SHARP: "Lead1C2#",
  T_46_META_WS_E_LEAD1D2: "Lead1D2",
  T_46_META_WS_E_LEAD1D2SHARP: "Lead1D2#",
  T_46_META_WS_E_LEAD1E2: "Lead1E2",
  T_46_META_WS_E_LEAD1F2: "Lead1F2",
  T_46_META_WS_E_LEAD1F2SHARP: "Lead1F2#",
  T_46_META_WS_E_LEAD1G2: "Lead1G2",
  T_46_META_WS_E_LEAD1G2SHARP: "Lead1G2#",
  T_46_META_WS_E_LEAD2A2: "Lead2A2",
  T_46_META_WS_E_LEAD2A2SHARP: "Lead2A2#",
  T_46_META_WS_E_LEAD2B2: "Lead2B2",
  T_46_META_WS_E_LEAD2C2: "Lead2C2",
  T_46_META_WS_E_LEAD2C2SHARP: "Lead2C2#",
  T_46_META_WS_E_LEAD2D2: "Lead2D2",
  T_46_META_WS_E_LEAD2D2SHARP: "Lead2D2#",
  T_46_META_WS_E_LEAD2E2: "Lead2E2",
  T_46_META_WS_E_LEAD2F2: "Lead2F2",
  T_46_META_WS_E_LEAD2F2SHARP: "Lead2F2#",
  T_46_META_WS_E_LEAD2G2: "Lead2G2",
  T_46_META_WS_E_LEAD2G2SHARP: "Lead2G2#",
  T_46_META_WS_E_LEAD3A2: "Lead3A2",
  T_46_META_WS_E_LEAD3A2SHARP: "Lead3A2#",
  T_46_META_WS_E_LEAD3B2: "Lead3B2",
  T_46_META_WS_E_LEAD3C2: "Lead3C2",
  T_46_META_WS_E_LEAD3C2SHARP: "Lead3C2#",
  T_46_META_WS_E_LEAD3D2: "Lead3D2",
  T_46_META_WS_E_LEAD3D2SHARP: "Lead3D2#",
  T_46_META_WS_E_LEAD3E2: "Lead3E2",
  T_46_META_WS_E_LEAD3F2: "Lead3F2",
  T_46_META_WS_E_LEAD3F2SHARP: "Lead3F2#",
  T_46_META_WS_E_LEAD3G2: "Lead3G2",
  T_46_META_WS_E_LEAD3G2SHARP: "Lead3G2#",
  T_46_META_WS_E_LEAFLESSTREE: "枯木",
  T_46_META_WS_E_LEVELMAXED: "满级",
  T_46_META_WS_E_LEVELUP: "升级",
  T_46_META_WS_E_LEVELUPDISCARDED: "升级",
  T_46_META_WS_E_LIGHTBEAM: "光束",
  T_46_META_WS_E_LIGHTBEAMPREDISCARDED: "光柱",
  T_46_META_WS_E_LIGHTEFFECT: "光效",
  T_46_META_WS_E_LIGHTNING: "雷电",
  T_46_META_WS_E_LIMB: "四肢",
  T_46_META_WS_E_LINE: "线",
  T_46_META_WS_E_LIQUID: "液体",
  T_46_META_WS_E_LOCAL: "本地",
  T_46_META_WS_E_LOCALPOSITION: "本地坐标",
  T_46_META_WS_E_LOCK: "锁",
  T_46_META_WS_E_LONGBOX: "长木箱",
  T_46_META_WS_E_LOOP: "循环",
  T_46_META_WS_E_LOOTITEMBOX: "Loot点武器组件LootItemBox",
  T_46_META_WS_E_LOOTITEMBOXAMMO: "Loot点子弹组件LootItemBoxAmmo",
  T_46_META_WS_E_LOOTITEMBOXARMOR: "Loot点护甲组件LootItemBoxArmor",
  T_46_META_WS_E_LOOTITEMBOXCONSUMABLEITEM: "Loot点可消耗物品组件LootItemBoxConsumableItem",
  T_46_META_WS_E_LOOTITEMBOXPROJECTILE: "Loot点投掷物品组件LootItemBoxProjectile",
  T_46_META_WS_E_LOOTITEMBOXSIGHT: "Loot点倍镜组件LootItemBoxSight",
  T_46_META_WS_E_LOOTITEMBOXSOCCER: "Loot点足球组件LootItemBoxSoccer",
  T_46_META_WS_E_LOOTSOCCERICE: "冰冻手雷",
  T_46_META_WS_E_LOOTSOCCERRANDOM: "随机足球Loot",
  T_46_META_WS_E_LOOTSOCCERSHIELD: "足球凝胶护盾",
  T_46_META_WS_E_LOOTWEAPONRANDOM: "随机武器Loot",
  T_46_META_WS_E_LOSE: "失败",
  T_46_META_WS_E_LOUDSPEAKER: "喇叭",
  T_46_META_WS_E_LOWFALLING: "Lowfalling",
  T_46_META_WS_E_M1014: "M1014",
  T_46_META_WS_E_M10142: "M10142",
  T_46_META_WS_E_M14: "M14",
  T_46_META_WS_E_M1873: "M1873",
  T_46_META_WS_E_M1887: "M1887",
  T_46_META_WS_E_M18872: "M18872",
  T_46_META_WS_E_M1887X: "M1887X",
  T_46_META_WS_E_M1917: "M1917",
  T_46_META_WS_E_M21A5: "M21A5",
  T_46_META_WS_E_M24: "M24",
  T_46_META_WS_E_M249: "M249",
  T_46_META_WS_E_M2492: "M2492",
  T_46_META_WS_E_M4A1: "M4A1",
  T_46_META_WS_E_M500: "M500",
  T_46_META_WS_E_M60: "M60",
  T_46_META_WS_E_M79: "M79",
  T_46_META_WS_E_M79AMMO: "M79榴弹",
  T_46_META_WS_E_M79AMMO_EXCLUSIVE: "M79专用榴弹",
  T_46_META_WS_E_MAC10: "MAC10",
  T_46_META_WS_E_MACHETE: "Machete",
  T_46_META_WS_E_MACHINEGUN: "冲锋枪",
  T_46_META_WS_E_MAG7: "MAG7",
  T_46_META_WS_E_MAG72: "MAG72",
  T_46_META_WS_E_MAGEZINE1: "Magezine1",
  T_46_META_WS_E_MAGEZINE2: "Magezine2",
  T_46_META_WS_E_MAGEZINE3: "Magezine3",
  T_46_META_WS_E_MAGMAA: "岩浆A",
  T_46_META_WS_E_MAGNIFYINGGLASS: "放大镜",
  T_46_META_WS_E_MALE: "男",
  T_46_META_WS_E_MARK: "标记",
  T_46_META_WS_E_MARKER: "标记",
  T_46_META_WS_E_MASK: "脸饰",
  T_46_META_WS_E_MAXVALUE: "最大值",
  T_46_META_WS_E_MECHANICAL: "密集叮叮叮2",
  T_46_META_WS_E_MECHANICALDEVICEECHO: "机械装置回声",
  T_46_META_WS_E_MEDICALPROPS: "医疗道具UI",
  T_46_META_WS_E_MEDICALTENT: "医疗帐篷",
  T_46_META_WS_E_MEDIUMHEARTBEAT: "心跳中",
  T_46_META_WS_E_MEDKIT: "急救包",
  T_46_META_WS_E_MELEE: "近战武器",
  T_46_META_WS_E_MELEEWEAPONS: "近战武器",
  T_46_META_WS_E_MGL140: "MGL140",
  T_46_META_WS_E_MICROPHONE: "语音(麦克风)按钮UI开关",
  T_46_META_WS_E_MIDDLE: "RangeMiddle",
  T_46_META_WS_E_MINIHANDLE: "MiniHandle",
  T_46_META_WS_E_MINIMAP: "小地图UI",
  T_46_META_WS_E_MINISENTRY: "防御塔",
  T_46_META_WS_E_MINVALUE: "最小值",
  T_46_META_WS_E_MISSILEEXPLODE: "类导弹武器",
  T_46_META_WS_E_MISSIONCOMPLETE: "任务成功提示1",
  T_46_META_WS_E_MISTAKE: "失误",
  T_46_META_WS_E_MODERATE: "中等难度",
  T_46_META_WS_E_MONEY: "钱",
  T_46_META_WS_E_MONSTER: "僵尸",
  T_46_META_WS_E_MONSTERSPAWN: "怪物生成点",
  T_46_META_WS_E_MONSTERTRUCK: "Monster_Truck",
  T_46_META_WS_E_MOON: "月",
  T_46_META_WS_E_MOSQUITO: "蚊子",
  T_46_META_WS_E_MOTIONTRAIL: "追尾",
  T_46_META_WS_E_MOTOBIKE: "Motobike",
  T_46_META_WS_E_MOTORBIKE: "Motorbike",
  T_46_META_WS_E_MOVE: "移动",
  T_46_META_WS_E_MOVEMENT: "移动",
  T_46_META_WS_E_MOVINGJOYSTICK: "移动",
  T_46_META_WS_E_MP40: "MP40",
  T_46_META_WS_E_MP402: "MP402",
  T_46_META_WS_E_MP5: "MP5",
  T_46_META_WS_E_MRV: "黑衣人",
  T_46_META_WS_E_MULTIPLIER: "连乘器",
  T_46_META_WS_E_MULTIPLY: "相乘",
  T_46_META_WS_E_MULTIPLYACCUMULATE: "乘法累加器",
  T_46_META_WS_E_MUSHROOM1: "Mushroom1",
  T_46_META_WS_E_MUSHROOM2: "Mushroom2",
  T_46_META_WS_E_MUSHROOM3: "Mushroom3",
  T_46_META_WS_E_MUSHROOM4: "Mushroom4",
  T_46_META_WS_E_MUSHSHADE: "巨型蘑菇群",
  T_46_META_WS_E_MUSIC: "音乐",
  T_46_META_WS_E_MUZZLE1: "Muzzle1",
  T_46_META_WS_E_MUZZLE2: "Muzzle2",
  T_46_META_WS_E_MUZZLE3: "Muzzle3",
  T_46_META_WS_E_NEAR: "RangeNear",
  T_46_META_WS_E_NIGHT: "夜晚",
  T_46_META_WS_E_NOATTACK: "不攻击",
  T_46_META_WS_E_NODUALWIELDING: "不可双持",
  T_46_META_WS_E_NOERROR: "无错误",
  T_46_META_WS_E_NONE: "无限制",
  T_46_META_WS_E_NORMAL: "正常的",
  T_46_META_WS_E_NOSKIPKNOCKDOWN: "强制击倒",
  T_46_META_WS_E_NOTONASTALIQURDU: "NotoNastaliqUrdu",
  T_46_META_WS_E_NUTTYMOVEMENT: "技能7",
  T_46_META_WS_E_OBTAINEDCOINS: "获得中金币",
  T_46_META_WS_E_OBTAINEDMANYCOINS: "获得大金币",
  T_46_META_WS_E_OBTAINEDSOMECOINS: "获得小金币",
  T_46_META_WS_E_OILDRUMEXPLODE: "油桶爆炸",
  T_46_META_WS_E_ONCE: "单次",
  T_46_META_WS_E_ONEWAY: "单向一次",
  T_46_META_WS_E_OPENFOLDER: "打开的文件夹",
  T_46_META_WS_E_OPENHIHATS: "打开的踩镲",
  T_46_META_WS_E_OPENINGBOX: "打开盒子",
  T_46_META_WS_E_OPENINGGUILDSUPPLY: "工会福利红包",
  T_46_META_WS_E_OPENINGWARCHEST: "仓库保存",
  T_46_META_WS_E_ORANGE: "橙色",
  T_46_META_WS_E_ORTHOGONAL: "正交",
  T_46_META_WS_E_OUTPOST: "警卫室",
  T_46_META_WS_E_P90: "P90",
  T_46_META_WS_E_P902: "P902",
  T_46_META_WS_E_PAINTEDWALLS: "彩绘墙",
  T_46_META_WS_E_PAINTSHIELDSKILL: "血池技能",
  T_46_META_WS_E_PALM: "布",
  T_46_META_WS_E_PANEL: "面板",
  T_46_META_WS_E_PARAFAL: "PARAFAL",
  T_46_META_WS_E_PARAFAL2: "PARAFAL2",
  T_46_META_WS_E_PASSENGERA: "乘客1座位",
  T_46_META_WS_E_PASSENGERB: "乘客2座位",
  T_46_META_WS_E_PASSENGERC: "乘客3座位",
  T_46_META_WS_E_PASSIVE: "被动攻击",
  T_46_META_WS_E_PASSIVESKILL: "被动技能UI开关",
  T_46_META_WS_E_PATROLWHILEATTACK: "边巡逻，边攻击",
  T_46_META_WS_E_PERSONALUAV: "个人uav",
  T_46_META_WS_E_PERSPECTIVE: "透视",
  T_46_META_WS_E_PETTABBG: "宠物",
  T_46_META_WS_E_PHASESTART: "阶段开始",
  T_46_META_WS_E_PHONEBOOTH: "电话亭",
  T_46_META_WS_E_PI: "Π",
  T_46_META_WS_E_PIANOA3: "PianoA3",
  T_46_META_WS_E_PIANOA3SHARP: "PianoA3#",
  T_46_META_WS_E_PIANOA4: "PianoA4",
  T_46_META_WS_E_PIANOA4SHARP: "PianoA4#",
  T_46_META_WS_E_PIANOB3: "PianoB3",
  T_46_META_WS_E_PIANOB4: "PianoB4",
  T_46_META_WS_E_PIANOC3: "PianoC3",
  T_46_META_WS_E_PIANOC3SHARP: "PianoC3#",
  T_46_META_WS_E_PIANOC4: "PianoC4",
  T_46_META_WS_E_PIANOC4SHARP: "PianoC4#",
  T_46_META_WS_E_PIANOD3: "PianoD3",
  T_46_META_WS_E_PIANOD3SHARP: "PianoD3#",
  T_46_META_WS_E_PIANOD4: "PianoD4",
  T_46_META_WS_E_PIANOD4SHARP: "PianoD4#",
  T_46_META_WS_E_PIANOE3: "PianoE3",
  T_46_META_WS_E_PIANOE4: "PianoE4",
  T_46_META_WS_E_PIANOF3: "PianoF3",
  T_46_META_WS_E_PIANOF3SHARP: "PianoF3#",
  T_46_META_WS_E_PIANOF4: "PianoF4",
  T_46_META_WS_E_PIANOF4SHARP: "PianoF4#",
  T_46_META_WS_E_PIANOG3: "PianoG3",
  T_46_META_WS_E_PIANOG3SHARP: "PianoG3#",
  T_46_META_WS_E_PIANOG4: "PianoG4",
  T_46_META_WS_E_PIANOG4SHARP: "PianoG4#",
  T_46_META_WS_E_PIANOKEY1: "乐符-钢琴",
  T_46_META_WS_E_PIANOKEY2: "乐符-钢琴",
  T_46_META_WS_E_PICKUPS: "拾取列表UI开关",
  T_46_META_WS_E_PICKUPTRUCK: "suv",
  T_46_META_WS_E_PILLAR: "混凝土柱",
  T_46_META_WS_E_PIN: "标注",
  T_46_META_WS_E_PINGPONG: "PingPong",
  T_46_META_WS_E_PIPECORNER: "转折管道",
  T_46_META_WS_E_PIPEINTERSECTION: "十字管道",
  T_46_META_WS_E_PISTOL: "手枪",
  T_46_META_WS_E_PISTOLAMMO: "手枪子弹",
  T_46_META_WS_E_PLAIDAMUSEMENTPARKCUBE: "格纹游乐园方块",
  T_46_META_WS_E_PLASMA_X: "PLASMA_X",
  T_46_META_WS_E_PLAYER: "Player",
  T_46_META_WS_E_PLUS: "加",
  T_46_META_WS_E_PODIUM: "领奖台",
  T_46_META_WS_E_POISONGAS: "毒气",
  T_46_META_WS_E_POISONGASPREDISCARDED: "毒气",
  T_46_META_WS_E_PORTAL: "传送门",
  T_46_META_WS_E_POSTACCUMULATOR: "后置累加器",
  T_46_META_WS_E_POT: "Pot",
  T_46_META_WS_E_POUNDINGHEART: "心跳快",
  T_46_META_WS_E_PREACCUMULATOR: "前置累加器",
  T_46_META_WS_E_PRIMARYWEAPONA: "主武器1",
  T_46_META_WS_E_PRIMARYWEAPONB: "主武器2",
  T_46_META_WS_E_PRIOREXPLOSION: "炸弹爆炸前",
  T_46_META_WS_E_PROFILEWIDGET: "名片控件",
  T_46_META_WS_E_PRONE: "趴",
  T_46_META_WS_E_PUMPKIN: "南瓜",
  T_46_META_WS_E_PURPLE: "紫色",
  T_46_META_WS_E_QUADRILATERAL: "四边形",
  T_46_META_WS_E_QUESTIONMARK: "问号",
  T_46_META_WS_E_QUICKCHAT: "快速短语UI开关",
  T_46_META_WS_E_QUICKCHATSHOW: "队伍列表旁message UI开关",
  T_46_META_WS_E_RADIAL180: "180度扇形",
  T_46_META_WS_E_RADIAL360: "360度扇形",
  T_46_META_WS_E_RADIAL90: "90度扇形",
  T_46_META_WS_E_RAMPAGE: "暴走",
  T_46_META_WS_E_RANDOM: "随机",
  T_46_META_WS_E_RANDOMBUFF: "随机buff",
  T_46_META_WS_E_RANKDOWN: "降级",
  T_46_META_WS_E_REACTION: "响应",
  T_46_META_WS_E_RECOVER: "圆环",
  T_46_META_WS_E_RECYCLE: "回收",
  T_46_META_WS_E_RED: "红色",
  T_46_META_WS_E_REFINERYTANK: "大水罐",
  T_46_META_WS_E_REFLECTIVECUBE: "反射纯色基础方块1",
  T_46_META_WS_E_REFRESH: "刷新",
  T_46_META_WS_E_RELEASINGSKILL: "技能释放特效",
  T_46_META_WS_E_RELOAD: "换弹按钮状态UI开关",
  T_46_META_WS_E_REMINDER: "提醒",
  T_46_META_WS_E_REPAIR: "修复",
  T_46_META_WS_E_REPAIREQUIP: "装备修复",
  T_46_META_WS_E_REPAIRKIT: "护甲修理包",
  T_46_META_WS_E_REPLACER: "Replacer",
  T_46_META_WS_E_REPORT: "举报",
  T_46_META_WS_E_REST: "休息",
  T_46_META_WS_E_RG550: "RG550",
  T_46_META_WS_E_RIDES: "吊镲",
  T_46_META_WS_E_RIDICULE: "嘲笑",
  T_46_META_WS_E_RIDICULEFUNNY: "搞怪嘲笑",
  T_46_META_WS_E_RIFLE: "步枪",
  T_46_META_WS_E_RIFLEAMMO: "步枪子弹",
  T_46_META_WS_E_RIGHT: "对",
  T_46_META_WS_E_RIGHTTRAPEZOID: "直角梯形",
  T_46_META_WS_E_RING: "圓環機關",
  T_46_META_WS_E_RINGPREDISCARDED: "圆环",
  T_46_META_WS_E_RIPTIDERHYTHM: "技能9",
  T_46_META_WS_E_RISINGPARTICLE: "上升粒子",
  T_46_META_WS_E_ROADBLOCK: "路障",
  T_46_META_WS_E_ROTATE: "旋转",
  T_46_META_WS_E_RUNNING: "运行中",
  T_46_META_WS_E_RUSHTIME: "暴走",
  T_46_META_WS_E_SAMURAI: "武士僵尸",
  T_46_META_WS_E_SANDA: "沙子A",
  T_46_META_WS_E_SANDSTRUCTURE: "沙雕",
  T_46_META_WS_E_SCALE: "缩放",
  T_46_META_WS_E_SCAR: "SCAR",
  T_46_META_WS_E_SCAR2: "SCAR2",
  T_46_META_WS_E_SCARECROW: "稻草人",
  T_46_META_WS_E_SCISSORS: "剪刀",
  T_46_META_WS_E_SCOPE2X: "2倍镜",
  T_46_META_WS_E_SCOPE4X: "4倍镜",
  T_46_META_WS_E_SCROLLPANEL: "滚动视图",
  T_46_META_WS_E_SECONDARYWEAPON: "副武器",
  T_46_META_WS_E_SENSESSHOCKWAVE: "技能10",
  T_46_META_WS_E_SERVER: "服务端",
  T_46_META_WS_E_SET: "连体衣",
  T_46_META_WS_E_SETTING: "设置",
  T_46_META_WS_E_SETTINGS: "设置按钮UI开关",
  T_46_META_WS_E_SG: "散弹枪",
  T_46_META_WS_E_SGAMMO: "SN子弹",
  T_46_META_WS_E_SHARPMECHANICAL: "密集叮叮叮1",
  T_46_META_WS_E_SHIELD: "防守",
  T_46_META_WS_E_SHIELDBROKEN: "破盾攻击",
  T_46_META_WS_E_SHIELDGUN: "ShieldGun",
  T_46_META_WS_E_SHIELDUP: "举盾攻击",
  T_46_META_WS_E_SHOCKWAVE: "冲击波",
  T_46_META_WS_E_SHOES: "鞋",
  T_46_META_WS_E_SHOOTINGTARGET: "移動靶",
  T_46_META_WS_E_SHORTDATE: "ShortDate",
  T_46_META_WS_E_SHORTDATETIME: "ShortDateTime",
  T_46_META_WS_E_SHORTTIME: "ShortTime",
  T_46_META_WS_E_SHOTGUN: "霰弹",
  T_46_META_WS_E_SHOTGUNAMMO: "霰弹枪子弹",
  T_46_META_WS_E_SHOTGUNMUZZLE: "ShotgunMuzzle",
  T_46_META_WS_E_SHOW: "显示",
  T_46_META_WS_E_SHRUB: "灌木长木箱",
  T_46_META_WS_E_SICKLE: "Sickle",
  T_46_META_WS_E_SIDESCROLLING: "横版视角相机",
  T_46_META_WS_E_SIGNAL: "网络按钮UI开关",
  T_46_META_WS_E_SIGNOUT: "退出",
  T_46_META_WS_E_SILENCER: "Silencer",
  T_46_META_WS_E_SIMPLE: "简单",
  T_46_META_WS_E_SIMPLEWIDGET: "节点控件",
  T_46_META_WS_E_SIMPLIFIEDARABIC: "SimplifiedArabic",
  T_46_META_WS_E_SINGLE: "单个",
  T_46_META_WS_E_SITEHUT: "货柜屋",
  T_46_META_WS_E_SKILLCHARGINGCOMPLETE: "技能充能完成",
  T_46_META_WS_E_SKILLRECOVER: "技能恢复",
  T_46_META_WS_E_SKIPKNOCKDOWN: "跳过击倒",
  T_46_META_WS_E_SKS: "SKS",
  T_46_META_WS_E_SLICED: "九宫格",
  T_46_META_WS_E_SLOPE: "斜坡",
  T_46_META_WS_E_SLOWHEARTBEAT: "心跳慢",
  T_46_META_WS_E_SMG: "冲锋枪",
  T_46_META_WS_E_SMGAMMO: "SMG子弹",
  T_46_META_WS_E_SMGMUZZLE: "SMGMuzzle",
  T_46_META_WS_E_SMILEY: "笑脸",
  T_46_META_WS_E_SMOKE: "烟雾",
  T_46_META_WS_E_SMOKEGRENADE: "烟雾弹",
  T_46_META_WS_E_SMOKEY: "烟雾",
  T_46_META_WS_E_SMOOTH: "渐进",
  T_46_META_WS_E_SNAMMO: "SN子弹",
  T_46_META_WS_E_SNARES: "军鼓",
  T_46_META_WS_E_SNEAKERS: "跑鞋特效",
  T_46_META_WS_E_SNIPER: "狙击枪",
  T_46_META_WS_E_SNIPERAMMO: "狙击枪子弹",
  T_46_META_WS_E_SNOWA: "雪地A",
  T_46_META_WS_E_SNOWFLAKE: "雪花",
  T_46_META_WS_E_SOCCER: "足球",
  T_46_META_WS_E_SOCIALBUTTONWIDGET: "社交功能按钮控件",
  T_46_META_WS_E_SOLARPANEL: "太阳能板",
  T_46_META_WS_E_SORTBYPRIORITYHIGHTOLOW: "按优先级从高到低",
  T_46_META_WS_E_SORTBYPRIORITYLOWTOHIGH: "按优先级从低到高",
  T_46_META_WS_E_SPAS12: "SPAS12",
  T_46_META_WS_E_SPAS122: "SPAS122",
  T_46_META_WS_E_SPAWNPOINT: "重生点特效",
  T_46_META_WS_E_SPEAKER: "喇叭按钮UI开关",
  T_46_META_WS_E_SPECIALFIRINGSOUND: "特殊枪声",
  T_46_META_WS_E_SPECIALGUN: "特殊枪",
  T_46_META_WS_E_SPHERE: "球体",
  T_46_META_WS_E_SPHERETRIGGER: "球体冲触发器",
  T_46_META_WS_E_SPIDERWEB: "技能特效",
  T_46_META_WS_E_SPORTSCAR: "跑车",
  T_46_META_WS_E_SPOTLIGHT: "灯光",
  T_46_META_WS_E_SPREADOFPOISONGAS: "毒气扩散",
  T_46_META_WS_E_SPRINT: "快速移动",
  T_46_META_WS_E_SQUARE: "正方形",
  T_46_META_WS_E_SQUAREBOX: "方形木箱",
  T_46_META_WS_E_SR: "狙击枪",
  T_46_META_WS_E_STABLE: "草棚",
  T_46_META_WS_E_STAIRS: "楼梯",
  T_46_META_WS_E_STANDING: "站立",
  T_46_META_WS_E_STAR: "星星",
  T_46_META_WS_E_STATIC: "静态",
  T_46_META_WS_E_STATUSTRIGGER: "死亡或无敌触发器组件",
  T_46_META_WS_E_STEP: "脚步提示",
  T_46_META_WS_E_STEPTRIGGER: "踩机关",
  T_46_META_WS_E_STOCK_S: "STOCK_S",
  T_46_META_WS_E_STOCK_SR: "STOCK_SR",
  T_46_META_WS_E_STOCK1: "Stock1",
  T_46_META_WS_E_STOCK2: "Stock2",
  T_46_META_WS_E_STOCK3: "Stock3",
  T_46_META_WS_E_STONE: "石头",
  T_46_META_WS_E_STONEBRIDGE: "石拱桥",
  T_46_META_WS_E_STONELANTERN: "宫灯",
  T_46_META_WS_E_STONESPLASH: "石子飞溅",
  T_46_META_WS_E_STORE: "商店",
  T_46_META_WS_E_STREETLAMP: "路灯",
  T_46_META_WS_E_STYLEA: "样式一",
  T_46_META_WS_E_STYLEB: "样式二",
  T_46_META_WS_E_STYLEC: "样式三",
  T_46_META_WS_E_SUBMACHINEGUN: "冲锋枪",
  T_46_META_WS_E_SUBMACHINEGUNAMMO: "冲锋枪子弹",
  T_46_META_WS_E_SUCCESSFULHIT: "击中",
  T_46_META_WS_E_SUN: "太阳",
  T_46_META_WS_E_SUNSHADE: "伞桌组合",
  T_46_META_WS_E_SUPERCAR: "跑车",
  T_46_META_WS_E_SUPERMARKET: "Supermarket",
  T_46_META_WS_E_SURPRISEFIND: "发现惊喜",
  T_46_META_WS_E_SUV: "Suv",
  T_46_META_WS_E_SVD: "SVD",
  T_46_META_WS_E_SVD2: "SVD2",
  T_46_META_WS_E_SWEAPWEAPONQUICK: "换武器按钮状态UI开关",
  T_46_META_WS_E_SWIMRING: "泳圈",
  T_46_META_WS_E_SWORD: "剑",
  T_46_META_WS_E_SYMBOLIC: "地面印记",
  T_46_META_WS_E_TANKZOMBIE: "盾牌怪",
  T_46_META_WS_E_TAP: "点击",
  T_46_META_WS_E_TAPPINGBUTTON: "点击按钮",
  T_46_META_WS_E_TAPPINGDISABLEDBUTTON: "点击禁用按钮",
  T_46_META_WS_E_TEAM: "队伍",
  T_46_META_WS_E_TEAMMATESINFO: "队友信息UI",
  T_46_META_WS_E_TELEPORT: "圆环",
  T_46_META_WS_E_TELEPORTCORRECT: "用传送点传送到正确区域的声音",
  T_46_META_WS_E_TELEPORTWRONG: "用传送点传送到错误区域的声音",
  T_46_META_WS_E_TEXT: "文本",
  T_46_META_WS_E_TEXTOBJECT: "文本实体",
  T_46_META_WS_E_TEXTUREWIDGET: "贴图控件",
  T_46_META_WS_E_THERMALSCOPE: "热成像镜",
  T_46_META_WS_E_THIRDPERSON: "第三人称视角相机",
  T_46_META_WS_E_THIRDPERSONCLASSIC: "第三人称视角相机（FF经典）",
  T_46_META_WS_E_THIRDPERSONLOCK: "第三人称视角相机（追背相机）",
  T_46_META_WS_E_THOMPSON: "THOMPSON",
  T_46_META_WS_E_THOMPSON2: "THOMPSON2",
  T_46_META_WS_E_THOWINGKNIFE2FORCOMPATIBILITY: "ThowingKnife2ForCompatibility",
  T_46_META_WS_E_THRILLBATTLE: "技能5",
  T_46_META_WS_E_THROWATTACK: "手雷",
  T_46_META_WS_E_THROWINGKNIFE: "ThrowingKnife",
  T_46_META_WS_E_THROWREDZOMBIE: "变异投掷僵尸",
  T_46_META_WS_E_THROWZOMBIE: "投掷僵尸",
  T_46_META_WS_E_THUMBSUP: "点赞",
  T_46_META_WS_E_THUNDER: "电击",
  T_46_META_WS_E_TILEA: "瓷砖A",
  T_46_META_WS_E_TILEB: "瓷砖B",
  T_46_META_WS_E_TILEC: "瓷砖C",
  T_46_META_WS_E_TILED: "平铺",
  T_46_META_WS_E_TIPSSOUND: "显示Tips提示",
  T_46_META_WS_E_TOGGLEWIDGET: "切换按钮控件",
  T_46_META_WS_E_TOILETBOWL: "马桶",
  T_46_META_WS_E_TONEA: "石头A",
  T_46_META_WS_E_TOP: "上身服饰",
  T_46_META_WS_E_TOPDOWN: "俯视角相机",
  T_46_META_WS_E_TORII: "鸟居",
  T_46_META_WS_E_TOUCHPADWIDGET: "触摸板控件",
  T_46_META_WS_E_TOWER: "堡垒",
  T_46_META_WS_E_TPIPE: "T管道",
  T_46_META_WS_E_TRACINGSTEPS: "技能3",
  T_46_META_WS_E_TRAILER: "拖车",
  T_46_META_WS_E_TRANSFORMATION: "变身",
  T_46_META_WS_E_TRANSPARENT: "透视",
  T_46_META_WS_E_TRAPEZOID: "梯形",
  T_46_META_WS_E_TRASHCAN: "垃圾桶",
  T_46_META_WS_E_TRIANGLE: "三角形",
  T_46_META_WS_E_TRIGGERS: "触发器",
  T_46_META_WS_E_TRIPLE: "三连发",
  T_46_META_WS_E_TROPHY: "奖杯",
  T_46_META_WS_E_TRUE: "是",
  T_46_META_WS_E_TUKTUK: "TukTuk",
  T_46_META_WS_E_TUTUCAR: "tutu车",
  T_46_META_WS_E_TYRANTZOMBIE: "剪刀僵尸",
  T_46_META_WS_E_UAVLITE: "UAVLite",
  T_46_META_WS_E_UIFINISH: "结束",
  T_46_META_WS_E_UITAP: "界面点击",
  T_46_META_WS_E_UMP: "UMP",
  T_46_META_WS_E_UMP2: "UMP2",
  T_46_META_WS_E_UNITGENERATOR: "单位生成器",
  T_46_META_WS_E_UPWARDTURBULENCE: "上升气流",
  T_46_META_WS_E_USP: "USP",
  T_46_META_WS_E_USP_2: "USP_2",
  T_46_META_WS_E_UZI: "UZI",
  T_46_META_WS_E_VAULTOVER: "翻窗",
  T_46_META_WS_E_VECTOR: "VECTOR",
  T_46_META_WS_E_VEHICLE: "车辆",
  T_46_META_WS_E_VEHICLEEXPLODE: "载具爆炸",
  T_46_META_WS_E_VELOCITY: "速度",
  T_46_META_WS_E_VENDINGMACHINE: "贩卖机",
  T_46_META_WS_E_VERTICAL: "垂直",
  T_46_META_WS_E_VEST: "背心",
  T_46_META_WS_E_VEST1: "Vest1",
  T_46_META_WS_E_VEST2: "Vest2",
  T_46_META_WS_E_VEST3: "Vest3",
  T_46_META_WS_E_VEST4: "Vest4",
  T_46_META_WS_E_VISUALEFFECTS: "视觉效果",
  T_46_META_WS_E_VSK94: "VSK94",
  T_46_META_WS_E_VSS: "VSS",
  T_46_META_WS_E_WALLA: "墙壁A",
  T_46_META_WS_E_WALLBRAWL: "技能2",
  T_46_META_WS_E_WARNING: "警告",
  T_46_META_WS_E_WATERRING: "水花",
  T_46_META_WS_E_WAVE1: "Wave1",
  T_46_META_WS_E_WAVE2: "Wave2",
  T_46_META_WS_E_WAVE3: "Wave3",
  T_46_META_WS_E_WEAPONGENERATOR: "武器实体",
  T_46_META_WS_E_WEAPONSLOT: "武器栏UI",
  T_46_META_WS_E_WHISTLE: "打败敌人",
  T_46_META_WS_E_WIDERANGE: "宽范围",
  T_46_META_WS_E_WIN: "胜利",
  T_46_META_WS_E_WINDATTACK: "旋风斩",
  T_46_META_WS_E_WOODA: "木头A",
  T_46_META_WS_E_WOODCUTZOMBIE: "斧头僵尸",
  T_46_META_WS_E_WOODENPLANK: "木板桥",
  T_46_META_WS_E_WORLDPOSITION: "世界坐标",
  T_46_META_WS_E_WRECKEDBUS: "废巴士",
  T_46_META_WS_E_WRECKEDCAR: "废汽车",
  T_46_META_WS_E_WRONG: "错",
  T_46_META_WS_E_XM8: "XM8",
  T_46_META_WS_E_XM82: "XM82",
  T_46_META_WS_E_ZOMBIE: "僵尸实体",
  T_46_META_WS_E_ZOMBIES: "僵尸",
  T_46_META_WS_E_ZOOM: "推近",
  T_46_META_WS_ELIMINATE: "击杀",
  T_46_META_WS_ELIMINATEDENTITY: "被击杀对象",
  T_46_META_WS_ELIMINATEDPLAYER: "被击杀玩家",
  T_46_META_WS_ENABLEDEFAULTBTREE: "启用默认行为树",
  T_46_META_WS_ENABLEMOVINGSAFEZONE: "开启移动安全区",
  T_46_META_WS_ENABLESAFEZONE: "开启安全区",
  T_46_META_WS_ENDCURRENTPHASE: "结束当前阶段",
  T_46_META_WS_ENDMORPH: "复原为原来形象",
  T_46_META_WS_ENDPOSITION: "位置",
  T_46_META_WS_ENTERVEHICLE: "强制玩家上车",
  T_46_META_WS_ENTITY: "实体",
  T_46_META_WS_EQUIPMENTID: "装备ID",
  T_46_META_WS_EULERANGLETOQUATERNION: "欧拉角转四元数",
  T_46_META_WS_EXITVEHICLE: "强制下车",
  T_46_META_WS_EXPONENTIATION: "求幂运算",
  T_46_META_WS_FILTERENTITY: "筛选实体",
  T_46_META_WS_FILTERLEVELOBJECTS: "所有地图物件",
  T_46_META_WS_FIND: "字符串查找",
  T_46_META_WS_FINDAT: "访问字符串中的值",
  T_46_META_WS_FINDPATH: "寻路",
  T_46_META_WS_FLOOR: "向下取整",
  T_46_META_WS_FOOTBALLGOAL: "球门",
  T_46_META_WS_FORMAT: "格式化字符串",
  T_46_META_WS_GETALLKEYS: "获取字典的所有key",
  T_46_META_WS_GETALLPLAYERS: "所有玩家",
  T_46_META_WS_GETALLSHOPS: "获取所有商店",
  T_46_META_WS_GETALLTEAMS: "所有队伍",
  T_46_META_WS_GETATTACKABLEENTITY: "获取实体的可攻击目标",
  T_46_META_WS_GETATTACKABLEFACTIONS: "获取阵营的可攻击目标",
  T_46_META_WS_GETBACKPACKSKIN: "获取背包皮肤",
  T_46_META_WS_GETBLACKBOARDVALUE: "获取黑板变量",
  T_46_META_WS_GETBUFFS: "获取Buff",
  T_46_META_WS_GETCHATCHANNEL: "获取语音频道",
  T_46_META_WS_GETCHILDBYINDEX: "根据索引获取指定子节点",
  T_46_META_WS_GETCHILDBYNAME: "根据名称获取指定子节点",
  T_46_META_WS_GETCHILDREN: "获取所有子节点",
  T_46_META_WS_GETCOLORCHANNEL: "获得色值(RGBA)通道",
  T_46_META_WS_GETCONSUMABLES: "获取背包道具栏中物品",
  T_46_META_WS_GETCULLINGMASK: "获取相机层遮罩",
  T_46_META_WS_GETCURRENTCAMERA: "获取当前相机",
  T_46_META_WS_GETCURRENTCHATCHANNEL: "获取玩家当前频道",
  T_46_META_WS_GETCUSTOMMISSIONPROGRESS: "查询自定义任务进度",
  T_46_META_WS_GETDYEDCOUNT: "统计染色数量",
  T_46_META_WS_GETDYEDSTATUS: "获取染色状态",
  T_46_META_WS_GETEQUIPMENTS: "获取背包装备栏中物品",
  T_46_META_WS_GETFACTION: "获取阵营",
  T_46_META_WS_GETGLOBALSLEEPTHRESHOLD: "获取全局休眠阈值",
  T_46_META_WS_GETITEMCOUNT: "获取物品数量",
  T_46_META_WS_GETLOADEDSCENES: "获取已加载场景",
  T_46_META_WS_GETLOCALAIMDIRECTION: "获取本地的瞄准方向",
  T_46_META_WS_GETLOCALPLAYER: "当前玩家",
  T_46_META_WS_GETLOCALTIMESTAMP: "获取本地时间戳",
  T_46_META_WS_GETMAPID: "获取场景地图ID",
  T_46_META_WS_GETMINIMAP: "获得小地图",
  T_46_META_WS_GETMONEY: "获取货币",
  T_46_META_WS_GETMONEYCOUNT: "获取货币数量",
  T_46_META_WS_GETMORPH: "获取变身实体",
  T_46_META_WS_GETNODEVARIABLE: "获取节点参数",
  T_46_META_WS_GETOUTFIT: "获取服装",
  T_46_META_WS_GETOWNER: "获得实体的绑定玩家",
  T_46_META_WS_GETPARENT: "获取父节点",
  T_46_META_WS_GETPOSITIONNEARTEAMMATE: "获得队友附近的位置",
  T_46_META_WS_GETRANDOMSPAWNPOSITION: "获取随机出生点",
  T_46_META_WS_GETRESULTFROMCURVE: "通过Curve获取运算值",
  T_46_META_WS_GETSCENESKYBOX: "获取场景的天空盒",
  T_46_META_WS_GETSERVERREGION: "获取服务器区域",
  T_46_META_WS_GETSERVERTIMESTAMP: "获取服务器时间戳",
  T_46_META_WS_GETSKELETONPARTBYNAME: "通过名字获取骨骼部位",
  T_46_META_WS_GETSKILLS: "获取技能",
  T_46_META_WS_GETSLEEPTHRESHOLD: "获取休眠阈值",
  T_46_META_WS_GETTOKENCOUNT: "获取玩家token数据",
  T_46_META_WS_GETTOKENCOUNTTODAY: "获取玩家今日token数据",
  T_46_META_WS_GETTYPE: "获取变量类型",
  T_46_META_WS_GETVEHICLESKIN: "获取车皮",
  T_46_META_WS_GETWALLET: "获取钱包",
  T_46_META_WS_GETWEAPONSKIN: "获取枪皮",
  T_46_META_WS_GETWIDGETBYPATH: "通过路径获取控件",
  T_46_META_WS_GETWIDGETFROMCUSTOMUI: "获取控件",
  T_46_META_WS_GIVEJAILBREAKITEM: "GiveJailBreakItem",
  T_46_META_WS_GIVEJAILBREAKREWARD: "GiveJailBreakReward",
  T_46_META_WS_HASAOISPECIALFOLLOW: "是否存在AOI特别关注",
  T_46_META_WS_HASCOMPONENT: "是否存在组件",
  T_46_META_WS_HASSCRIPT: "是否存在脚本",
  T_46_META_WS_HASTAG: "是否包含标签",
  T_46_META_WS_HELPEDPLAYER: "被帮助的玩家玩家",
  T_46_META_WS_HELPPLAYER: "帮助购买的玩家",
  T_46_META_WS_HIDEAPPEARANCEGROUP: "隐藏外观组",
  T_46_META_WS_HITENTITY: "击中实体",
  T_46_META_WS_HITFLY: "击飞",
  T_46_META_WS_HITNORMAL: "命中法线",
  T_46_META_WS_HITOBJECT: "命中物件",
  T_46_META_WS_HITPOSITION: "击中位置",
  T_46_META_WS_INDEXOF: "获取元素最先出现的位置",
  T_46_META_WS_INFECTIONZOMBIEGROWUP: "感染模式僵尸进化",
  T_46_META_WS_INSERT: "列表插入",
  T_46_META_WS_ISATTACKABLE: "判断是否可以攻击",
  T_46_META_WS_ISCHATCHANNELEMPTY: "频道是否为空",
  T_46_META_WS_ISEQUAL: "列表内容是否相同",
  T_46_META_WS_ISFRIEND: "判断好友关系",
  T_46_META_WS_ISHIT: "是否击中",
  T_46_META_WS_ISINSIDEBOX: "立方体范围判定",
  T_46_META_WS_ISINSIDECYLINDER: "圆柱体范围判定",
  T_46_META_WS_ISINSIDESECTOR: "扇形范围判定",
  T_46_META_WS_ISINSIDESPHERE: "球形范围判定",
  T_46_META_WS_ISSLEEPING: "刚体是否处于休眠状态",
  T_46_META_WS_ISSUBTYPEOF: "是否类型一致或继承",
  T_46_META_WS_ITEM: "实体",
  T_46_META_WS_ITEMID: "道具类型",
  T_46_META_WS_JOIN: "以指定标识符链l接字符串",
  T_46_META_WS_JOINCHATCHANNEL: "玩家加入频道",
  T_46_META_WS_JOINFACTION: "加入阵营",
  T_46_META_WS_LASTINDEXOF: "获取元素最后出现的位置",
  T_46_META_WS_LENGTH: "长度",
  T_46_META_WS_LERP: "Lerp",
  T_46_META_WS_LOADSCENE: "加载场景",
  T_46_META_WS_LOGARITHM: "求对数算",
  T_46_META_WS_LOGERROR: "打印报错",
  T_46_META_WS_LOGINFO: "打印提示",
  T_46_META_WS_LOGWARNING: "打印警告",
  T_46_META_WS_LOOKROTATION: "创建朝目标方向看过去的旋转量。",
  T_46_META_WS_MAGNITUDE: "向量大小",
  T_46_META_WS_MAKER: "造成者",
  T_46_META_WS_MAX: "Max",
  T_46_META_WS_MECHANISM: "机关",
  T_46_META_WS_MIN: "Min",
  T_46_META_WS_MONSTERUSESKILL: "怪物释放技能",
  T_46_META_WS_MORPHOBJECT: "玩家变身实体",
  T_46_META_WS_MORPHTO: "玩家变身为某个场景物件",
  T_46_META_WS_MORPHTOBYITEMID: "玩家变身为某个场景物件",
  T_46_META_WS_MOVECCT: "将角色控制器位移一次",
  T_46_META_WS_MOVEPOSITION: "移动刚体",
  T_46_META_WS_MOVEROTATION: "旋转刚体",
  T_46_META_WS_MULTIPLYQUATERNION: "四元数相乘",
  T_46_META_WS_MULTIRAYCAST: "射线检测返回多个",
  T_46_META_WS_NEGATE: "负值",
  T_46_META_WS_NEW: "构造",
  T_46_META_WS_NODENAME: "节点名称",
  T_46_META_WS_NORMALIZE: "向量归一化",
  T_46_META_WS_NOTIFYPLAYEFFECT: "通知客户端播放特效",
  T_46_META_WS_NOTIFYPLAYICONANIMATION: "通知客户端播放图标动画效果",
  T_46_META_WS_NOTIFYPLAYSOUND: "通知客户端播放音效",
  T_46_META_WS_NOTIFYSHOWTIPS: "通知客户端显示飘字",
  T_46_META_WS_NUMTOSTRING: "数字转字符串",
  T_46_META_WS_ONACCESSEQUIPMENT: "当获得装备时",
  T_46_META_WS_ONACCESSITEM: "当获得物品时",
  T_46_META_WS_ONACCESSWEAPON: "当获得武器时",
  T_46_META_WS_ONACE: "当队伍团灭时",
  T_46_META_WS_ONAIMED: "当被瞄准时",
  T_46_META_WS_ONAIMING: "当瞄准时",
  T_46_META_WS_ONASSIST: "当助攻时",
  T_46_META_WS_ONATTACK: "当攻击时",
  T_46_META_WS_ONATTACKSTOP: "当停止攻击时",
  T_46_META_WS_ONAWAKE: "当实体创建时",
  T_46_META_WS_ONBEKNOCKEDDOWN: "当玩家被击倒",
  T_46_META_WS_ONBOUNCEDBYTIRE: "当被轮胎弹起时",
  T_46_META_WS_ONBOUNCEENTITY: "当弹起实体时",
  T_46_META_WS_ONBUILTINBUTTONTAPPED: "当内置UI中的按钮被点击时",
  T_46_META_WS_ONBULLETHIT: "当子弹击中时",
  T_46_META_WS_ONCAMERARAYCAST: "客户端触发相机射线检测",
  T_46_META_WS_ONCHARACTERCONTROLLERHIT: "当触碰实体时",
  T_46_META_WS_ONCHASE: "当追击时",
  T_46_META_WS_ONCHASESTOP: "当停止追击时",
  T_46_META_WS_ONCLIPEND: "当动画片段播放完成时",
  T_46_META_WS_ONCOLLISIONENTER: "当发生碰撞时",
  T_46_META_WS_ONCOLLISIONEXIT: "当碰撞结束时",
  T_46_META_WS_ONCOUNTDOWNFINISHED: "当倒计时结束时",
  T_46_META_WS_ONCREEP: "当玩家趴下",
  T_46_META_WS_ONCROUCH: "当玩家蹲下",
  T_46_META_WS_ONDEALDAMAGE: "当造成伤害时",
  T_46_META_WS_ONDESTROY: "当实体销毁",
  T_46_META_WS_ONDISABLE: "当实体不可用",
  T_46_META_WS_ONDISCONNECT: "当断开连接时",
  T_46_META_WS_ONDOUBLETAPPED: "当双击时",
  T_46_META_WS_ONDRAG: "当滑动时",
  T_46_META_WS_ONDRAGEND: "当滑动结束时",
  T_46_META_WS_ONDRAGSTART: "当开始滑动时",
  T_46_META_WS_ONDRIVED: "当载具被实体驾驶时",
  T_46_META_WS_ONDRIVEVEHICLE: "当驾驶载具时",
  T_46_META_WS_ONDROPCONSUMABLE: "当丢弃道具时",
  T_46_META_WS_ONDROPPED: "当被丢弃时",
  T_46_META_WS_ONDROPWEAPON: "当丢弃武器时",
  T_46_META_WS_ONEACHLOOP: "当每次循环时",
  T_46_META_WS_ONELIMINATE: "当击杀时",
  T_46_META_WS_ONELIMINATED: "当被击杀时",
  T_46_META_WS_ONENABLE: "当实体可用",
  T_46_META_WS_ONEND: "当结束播放时",
  T_46_META_WS_ONENTERED: "当载具被实体进入时",
  T_46_META_WS_ONENTERVEHICLE: "当进入载具时",
  T_46_META_WS_ONENTITYENTER: "当触发发生时",
  T_46_META_WS_ONENTITYEXIT: "当实体离开触发器",
  T_46_META_WS_ONEQUIPARMOR: "当装备防具时",
  T_46_META_WS_ONEQUIPED: "当被装备时",
  T_46_META_WS_ONEQUIPWEAPON: "当装备武器时",
  T_46_META_WS_ONEXPLODE: "当爆炸时",
  T_46_META_WS_ONFALL: "当坠落时",
  T_46_META_WS_ONFALLSTOP: "当坠落结束时",
  T_46_META_WS_ONFIRE: "当每次开火时",
  T_46_META_WS_ONFIXEDUPDATE: "当固定帧更新时",
  T_46_META_WS_ONFOOTBALLCOLLIDED: "当足球和实体碰撞时",
  T_46_META_WS_ONFRIENDSUPDATE: "当好友关系更新时",
  T_46_META_WS_ONGAMEEND: "当游戏结束时",
  T_46_META_WS_ONGAMEPAUSE: "当游戏暂停时",
  T_46_META_WS_ONGAMERESUME: "当游戏恢复时",
  T_46_META_WS_ONGAMESTART: "当游戏开始时",
  T_46_META_WS_ONGOAL: "当进球时",
  T_46_META_WS_ONHITBYBULLET: "当被子弹击中时",
  T_46_META_WS_ONHITFLY: "当被击飞时",
  T_46_META_WS_ONHITFLYENTITY: "当击飞实体时",
  T_46_META_WS_ONHOOKGUNFIRE: "当发射时",
  T_46_META_WS_ONIDLE: "当待机时",
  T_46_META_WS_ONJAILBREAKAREABEGIN: "JailBreakArea Begin",
  T_46_META_WS_ONJAILBREAKAREAEND: "JailBreakArea End",
  T_46_META_WS_ONJAILBREAKPLAYERJOIN: "JailBreak Player Join",
  T_46_META_WS_ONJAILBREAKPLAYERQUIT: "JailBreak Player Quit",
  T_46_META_WS_ONJOINCHATCHANNELSUCCESSFULLY: "当加入语音频道成功时",
  T_46_META_WS_ONJOYSTICKMOVE: "当摇杆移动时",
  T_46_META_WS_ONJOYSTICKPRESSED: "当按下时",
  T_46_META_WS_ONJOYSTICKRELEASED: "当释放时",
  T_46_META_WS_ONJUMP: "当玩家跳起",
  T_46_META_WS_ONJUMPSTOP: "当跳跃结束时",
  T_46_META_WS_ONLANDMINEACTIVE: "当地雷启动时",
  T_46_META_WS_ONLANDMINETRIGGER: "当地雷触发时",
  T_46_META_WS_ONLEAVECHATCHANNEL: "当玩家退出语音频道",
  T_46_META_WS_ONLEAVEVEHICLE: "当离开载具时",
  T_46_META_WS_ONLEFT: "当载具被实体离开时",
  T_46_META_WS_ONLEVELOBJECTBEMORPHED: "当场景物件被变身时",
  T_46_META_WS_ONMOVE: "当移动时",
  T_46_META_WS_ONNODEENTER: "当节点进入时",
  T_46_META_WS_ONNODEEXIT: "当节点退出时",
  T_46_META_WS_ONPAUSE: "当暂停播放时",
  T_46_META_WS_ONPHASEEND: "当阶段结束时",
  T_46_META_WS_ONPHASESTART: "当阶段开始时",
  T_46_META_WS_ONPICKEDUP: "当被拾取时",
  T_46_META_WS_ONPLAYERASSIST: "当玩家助攻时",
  T_46_META_WS_ONPLAYERBEELIMINATED: "当玩家死亡时",
  T_46_META_WS_ONPLAYERBEKNOCKEDDOWN: "当玩家被击倒时",
  T_46_META_WS_ONPLAYERDEALDAMAGE: "当玩家造成伤害时",
  T_46_META_WS_ONPLAYERELIMINATE: "当玩家造成击杀时",
  T_46_META_WS_ONPLAYERENTER: "当玩家进入触发器",
  T_46_META_WS_ONPLAYERJOIN: "当玩家加入游戏时",
  T_46_META_WS_ONPLAYERJOINCHATCHANNELFAILURE: "当加入语音频道失败时",
  T_46_META_WS_ONPLAYERLEAVE: "当玩家离开触发器",
  T_46_META_WS_ONPLAYERPURCHASEREQUEST: "当玩家请求购买商品时",
  T_46_META_WS_ONPLAYERQUIT: "当玩家中途退出时",
  T_46_META_WS_ONPLAYERRANKCHANGE: "当玩家排名改变时",
  T_46_META_WS_ONPLAYERREQUESTFORPURCHASEFULFILLED: "当玩家请求购买被满足时",
  T_46_META_WS_ONPLAYERREVIVED: "当玩家复活时",
  T_46_META_WS_ONPLAYERREVIVEDINSPAWNPOS: "当玩家复活时",
  T_46_META_WS_ONPLAYERSCORECHANGE: "当玩家积分改变时",
  T_46_META_WS_ONPLAYERSWITCHSCENE: "当玩家切换场景时",
  T_46_META_WS_ONPREDEALDAMAGE: "当造成伤害前",
  T_46_META_WS_ONPREPURCHASE: "当商店发生购买商品前",
  T_46_META_WS_ONPRESSED: "当按下时",
  T_46_META_WS_ONPRETAKEDAMAGE: "当受到伤害前",
  T_46_META_WS_ONPURCHASE: "当商店发生购买商品时",
  T_46_META_WS_ONRANKCHANGED: "当实体排名改变时",
  T_46_META_WS_ONRECONNECT: "当重新连接时",
  T_46_META_WS_ONRELEASED: "当抬起时",
  T_46_META_WS_ONRELOAD: "当武器更换子弹时",
  T_46_META_WS_ONRESUME: "当继续播放时",
  T_46_META_WS_ONREVIVED: "当复活时",
  T_46_META_WS_ONROUNDEND: "当回合结束时",
  T_46_META_WS_ONROUNDSTART: "当回合开始时",
  T_46_META_WS_ONSCENELOAD: "当场景加载时",
  T_46_META_WS_ONSCENESWITCH: "当场景切换时",
  T_46_META_WS_ONSCORECHANGE: "当实体积分改变时",
  T_46_META_WS_ONSHOTBYFOOTBALLSHOOTER: "当被足球枪击中时",
  T_46_META_WS_ONSLEEP: "当休眠时",
  T_46_META_WS_ONSPAWN: "当生成器生成实体",
  T_46_META_WS_ONSPRAY: "当喷漆枪命中",
  T_46_META_WS_ONSPRAYED: "被喷漆枪击中时",
  T_46_META_WS_ONSPRINT: "当疾跑时",
  T_46_META_WS_ONSPRINTSTOP: "当结束疾跑时",
  T_46_META_WS_ONSTANDUP: "当玩家站起",
  T_46_META_WS_ONSTART: "当开始播放时",
  T_46_META_WS_ONSTARTFIRE: "当开始开火时",
  T_46_META_WS_ONSTATEEND: "当动画状态播放完成时",
  T_46_META_WS_ONSURFING: "当水上滑板时",
  T_46_META_WS_ONSURFINGSTOP: "当结束水上滑板时",
  T_46_META_WS_ONSWITCHHANDHELD: "当切换手持物品时",
  T_46_META_WS_ONTAKEDAMAGE: "当被伤害时",
  T_46_META_WS_ONTAPPED: "当点击时",
  T_46_META_WS_ONTEAMACE: "当队伍团灭时",
  T_46_META_WS_ONTEAMADD: "当添加队伍时",
  T_46_META_WS_ONTEAMREMOVE: "当移除队伍时",
  T_46_META_WS_ONTEAMROUNDRANKCHANGE: "当队伍回合排名改变时",
  T_46_META_WS_ONTEAMSCORECHANGE: "当队伍积分改变时",
  T_46_META_WS_ONTELEPORTENTITY: "当传送实体时",
  T_46_META_WS_ONTEXTCHANGE: "当文本改变时",
  T_46_META_WS_ONTHROWABLEEXPLODE: "当投掷命中并爆炸时",
  T_46_META_WS_ONTOGGLE: "当状态改变时",
  T_46_META_WS_ONTOUCHDOWN: "当按下时",
  T_46_META_WS_ONTOUCHUP: "当抬起时",
  T_46_META_WS_ONUIHIDE: "当界面关闭时",
  T_46_META_WS_ONUISHOW: "当界面打开时",
  T_46_META_WS_ONUPDATE: "当更新时",
  T_46_META_WS_ONUSEAVATARSKILL: "当使用玩家技能时",
  T_46_META_WS_ONUSECONSUMABLE: "当使用道具时",
  T_46_META_WS_ONUSED: "当被使用时",
  T_46_META_WS_ONUSEPORTAL: "当使用传送门时",
  T_46_META_WS_ONWAKEUP: "当被唤醒时",
  T_46_META_WS_ONWEAPONBEEQUIPED: "当武器被装备时",
  T_46_META_WS_ONWEAPONDEALDAMAGE: "当武器造成伤害",
  T_46_META_WS_ONWEAPONELIMINATE: "当武器击杀单位",
  T_46_META_WS_ONWEAPONSTOPFIRING: "当武器停止射击时",
  T_46_META_WS_OWNER: "所属实体",
  T_46_META_WS_P_ACCELERATE: "加速度",
  T_46_META_WS_P_ACCELERATION: "加速度",
  T_46_META_WS_P_ACCOUNTID: "AccountID",
  T_46_META_WS_P_ACCURACY: "炮塔命中率",
  T_46_META_WS_P_ACTIONTYPE: "攻击模式",
  T_46_META_WS_P_ACTIVATEDALPHA: "激活透明度",
  T_46_META_WS_P_ACTIVE: "活动状态",
  T_46_META_WS_P_ACTIVEINHIERARCHY: "Active In Hierarchy",
  T_46_META_WS_P_ACTIVESELF: "Active Self",
  T_46_META_WS_P_ACTIVETEXT: "激活文本内容",
  T_46_META_WS_P_ACTUALPOSITION: "实际位置",
  T_46_META_WS_P_AFTERACCUMULATOR: "后置累加器",
  T_46_META_WS_P_AIMASSISTCENTEROFFSET: "可被辅助瞄准中心偏移量",
  T_46_META_WS_P_AIMASSISTDISTANCE: "可被辅助瞄准距离",
  T_46_META_WS_P_AIMASSISTTYPE: "瞄准辅助类型",
  T_46_META_WS_P_AIRDROPSTATE: "空投箱掉状态",
  T_46_META_WS_P_ALIGNMENTHORIZONTAL: "水平对齐",
  T_46_META_WS_P_ALIGNMENTVERTICAL: "垂直对齐",
  T_46_META_WS_P_ALLITEMS: "所有物品",
  T_46_META_WS_P_ALLMEMBERS: "所有成员",
  T_46_META_WS_P_ALLOWLOCKBYAIMASSIST: "是否可被辅助瞄准锁定",
  T_46_META_WS_P_ALLOWPRESSEDOUTSIDE: "区域外保持触发",
  T_46_META_WS_P_ALLPLAYERS: "所有玩家",
  T_46_META_WS_P_ALLTEAMMATES: "所有队员",
  T_46_META_WS_P_ALPHA: "透明度",
  T_46_META_WS_P_ALWAYSSHOWMARK: "标记点始终显示在标尺上",
  T_46_META_WS_P_AMBIENTCOLOR: "环境光颜色",
  T_46_META_WS_P_AMMOCLIPSIZE: "弹匣数量修正",
  T_46_META_WS_P_AMMOMAGSIZE: "弹夹子弹数量",
  T_46_META_WS_P_AMMOPERSHOT: "单次发射子弹数量",
  T_46_META_WS_P_AMMOTYPE: "子弹类型",
  T_46_META_WS_P_ANCHORMAX: "锚点最大值",
  T_46_META_WS_P_ANCHORMIN: "锚点最小值",
  T_46_META_WS_P_ANCHOROBJECT: "锚点对象",
  T_46_META_WS_P_ANCHORPOSITION: "锚点坐标",
  T_46_META_WS_P_ANCHORTYPE: "HUD锚点类型枚举",
  T_46_META_WS_P_ANGLE: "旋转角度",
  T_46_META_WS_P_ANGLEDOWN: "炮塔俯角",
  T_46_META_WS_P_ANGLEUP: "炮塔仰角",
  T_46_META_WS_P_ANGULARDRAG: "转动阻力系数",
  T_46_META_WS_P_ANGULARSPEED: "炮塔角速度",
  T_46_META_WS_P_ANGULARVELOCITY: "角速度（rad/s）",
  T_46_META_WS_P_ANIMATIONCLIP: "动画片段",
  T_46_META_WS_P_ANIMATIONCONTROLLER: "动画控制器",
  T_46_META_WS_P_ANIMATIONCONTROLLERRESID: "动画控制器资源UUID",
  T_46_META_WS_P_ARMORPENETRATION: "护甲穿透",
  T_46_META_WS_P_ARMORPENETRATIONFACTOR: "护甲穿透系数",
  T_46_META_WS_P_ARMORTYPE: "防具类型",
  T_46_META_WS_P_ARROWOFFSET: "方向箭头偏移",
  T_46_META_WS_P_ARROWSIZE: "方向箭头尺寸",
  T_46_META_WS_P_ARROWSPRITE: "方向箭头图片",
  T_46_META_WS_P_ASKBUYTARGET: "请求购买目标",
  T_46_META_WS_P_ATTACHTARGET: "行为树实体",
  T_46_META_WS_P_ATTACKABLEFACTIONS: "敌对阵营",
  T_46_META_WS_P_ATTACKDAMAGE: "攻击力",
  T_46_META_WS_P_ATTACKINTERVAL: "攻击间隔",
  T_46_META_WS_P_ATTACKRANGE: "攻击范围",
  T_46_META_WS_P_ATTACKTARGET: "被AI攻击的对象",
  T_46_META_WS_P_ATTTACKABLETARGETS: "敌对玩家",
  T_46_META_WS_P_AUTOPLAY: "自动播放状态",
  T_46_META_WS_P_AVAILABLEPOINT: "可用点",
  T_46_META_WS_P_AVATAR: "头像",
  T_46_META_WS_P_AVATARID: "头像ID",
  T_46_META_WS_P_BACKGROUND: "底图",
  T_46_META_WS_P_BACKGROUNDALPHA: "背景透明度",
  T_46_META_WS_P_BACKGROUNDCOLOR: "背景颜色",
  T_46_META_WS_P_BACKGROUNDCOLOR1: "背景颜色1",
  T_46_META_WS_P_BACKGROUNDCOLOR2: "背景颜色2",
  T_46_META_WS_P_BACKGROUNDFILL: "背景填充",
  T_46_META_WS_P_BACKGROUNDICONNAME: "背景图标名称",
  T_46_META_WS_P_BACKGROUNDNAME: "背景名称",
  T_46_META_WS_P_BACKGROUNDOFFSET: "底座偏移",
  T_46_META_WS_P_BACKGROUNDRADIUS: "底座半径",
  T_46_META_WS_P_BACKGROUNDSIZEDELTA: "BgSizeDelta",
  T_46_META_WS_P_BACKGROUNDSPRITE: "底座图片",
  T_46_META_WS_P_BACKPACK: "玩家背包",
  T_46_META_WS_P_BACKPACKSKINID: "背包皮肤ID",
  T_46_META_WS_P_BACKWARDSPEED: "后退速度（力）",
  T_46_META_WS_P_BANNERID: "横幅ID",
  T_46_META_WS_P_BASEHORIZONTALSPEED: "基础水平速度",
  T_46_META_WS_P_BASEMULTIPLIER: "基础系数",
  T_46_META_WS_P_BASETIME: "开始时刻",
  T_46_META_WS_P_BASEVERTICALSPEED: "基础垂直速度",
  T_46_META_WS_P_BEFOREACCUMULATOR: "前置累加器",
  T_46_META_WS_P_BEVTREEID: "行为树ID",
  T_46_META_WS_P_BINDPROPERTYID: "目标属性",
  T_46_META_WS_P_BODY: "躯干",
  T_46_META_WS_P_BODYDAMAGEFACTOR: "躯干伤害倍率偏移",
  T_46_META_WS_P_BONEPOSITION: "骨骼位置",
  T_46_META_WS_P_BONESCALE: "骨骼缩放",
  T_46_META_WS_P_BOOSTCD: "冲刺冷却时间",
  T_46_META_WS_P_BOOSTDURATION: "冲刺持续时间",
  T_46_META_WS_P_BOOSTSPEED: "冲刺速度",
  T_46_META_WS_P_BORDERLR: "左右边界",
  T_46_META_WS_P_BORDERTB: "上下边界",
  T_46_META_WS_P_BOTTOMALPHA: "底部透明度",
  T_46_META_WS_P_BOUNDWALLET: "绑定钱包",
  T_46_META_WS_P_BRAKEHORSEPOWER: "刹车马力",
  T_46_META_WS_P_BRAKETORQUE: "刹车马力",
  T_46_META_WS_P_BRRANK: "BR段位",
  T_46_META_WS_P_BUFFTYPE: "Buff生成器类型",
  T_46_META_WS_P_BURNDAMAGE: "燃烧伤害",
  T_46_META_WS_P_BURNINGDAMAGEINTERVAL: "燃烧伤害间隔",
  T_46_META_WS_P_BURNTIME: "燃烧时间",
  T_46_META_WS_P_BUTTOM: "下身服饰",
  T_46_META_WS_P_BUTTONCOLORS: "按钮颜色数组",
  T_46_META_WS_P_BUTTONNAMES: "按钮名字数组",
  T_46_META_WS_P_BUTTONSTYLE: "按钮样式",
  T_46_META_WS_P_CAMERABLOCKMODE: "相机遮蔽模式",
  T_46_META_WS_P_CAMERAPROJECTIONMODE: "相机投影类型",
  T_46_META_WS_P_CAMERATYPE: "相机类型",
  T_46_META_WS_P_CANCELDRAGIFFITS: "内容不超过视口时不可滚动",
  T_46_META_WS_P_CANCOSTDURABILITY: "是否会破损",
  T_46_META_WS_P_CANDAMAGED: "是否会破损",
  T_46_META_WS_P_CANDESTROY: "是否会摧毁",
  T_46_META_WS_P_CANDESTROYED: "是否会摧毁",
  T_46_META_WS_P_CANSELFTRIGGER: "是否能自己触发",
  T_46_META_WS_P_CANTEAMTRIGGER: "是否队友能触发",
  "T_46_META_WS_P_CANTRIGGEREDBY SELF": "是否能自己触发",
  "T_46_META_WS_P_CANTRIGGEREDBY TEAM": "是否队友能触发",
  "T_46_META_WS_P_CANTRIGGEREDBY VEHICLE": "是否载具可以触发",
  T_46_META_WS_P_CANVEHICLETRIGGER: "是否载具可以触发",
  T_46_META_WS_P_CELLSIZE: "子项格子宽高",
  T_46_META_WS_P_CELLSPACE: "子项格子间距",
  T_46_META_WS_P_CENTER: "小地图中心",
  T_46_META_WS_P_CENTERINVISIBLE: "中心不可见",
  T_46_META_WS_P_CENTEROFFSET: "中心点偏移",
  T_46_META_WS_P_CENTEROFMASS: "重心坐标",
  T_46_META_WS_P_CENTERRANGE: "中心范围",
  T_46_META_WS_P_CENTRALFLASHTIME: "中心闪光时间",
  T_46_META_WS_P_CENTRALLINEACTIVE: "是否显示中间线",
  T_46_META_WS_P_CENTRALLINEPOSITION: "中间线位置",
  T_46_META_WS_P_CHANNELID: "聊天频道实体ID",
  T_46_META_WS_P_CHARGEMAX: "冰墙充能上限(矫正系数)",
  T_46_META_WS_P_CHASETARGET: "被AI追击的对象",
  T_46_META_WS_P_CHATCHANNEL: "频道实体",
  T_46_META_WS_P_CHECKPOINTID: "检查点ID",
  T_46_META_WS_P_CHILDINDEX: "在所属父节点的第几个孩子",
  T_46_META_WS_P_CHIPEXP: "凝胶生成器升级芯片提供经验",
  T_46_META_WS_P_CLICKSIZE: "点击区域",
  T_46_META_WS_P_CLIPLENGTH: "片段长度",
  T_46_META_WS_P_CLIPPINGTYPE: "ClippingType",
  T_46_META_WS_P_COLLIDERID: "碰撞资源ID",
  T_46_META_WS_P_CONSTRAIN: "刚体约束",
  T_46_META_WS_P_CONSTRAINT: "限制",
  T_46_META_WS_P_CONSTRAINTCOUNT: "限制数量",
  T_46_META_WS_P_CONSUMABLETYPE: "道具类型",
  T_46_META_WS_P_CONTENT: "内容",
  T_46_META_WS_P_CONTENTORIGIN: "初始方向",
  T_46_META_WS_P_CONTROLPOINTS: "ControlPoints",
  T_46_META_WS_P_COORDINATESYSTEM: "坐标系",
  T_46_META_WS_P_COUNT: "充能数量",
  T_46_META_WS_P_COUNTDOWNENDTIME: "倒计时结束时间 (s)",
  T_46_META_WS_P_COUNTDOWNKEY: "倒计时Key",
  T_46_META_WS_P_COUNTDOWNTIME: "倒计时长，以秒为单位",
  T_46_META_WS_P_COUNTPERWAVE: "每波生成数量",
  T_46_META_WS_P_CRASHMAXDAMAGE: "最高撞击伤害",
  T_46_META_WS_P_CRASHMAXSPEED: "撞击伤害速度上限",
  T_46_META_WS_P_CRASHMESSFACTOR: "撞击质量参数",
  T_46_META_WS_P_CRASHMINDAMAGE: "最低撞击伤害",
  T_46_META_WS_P_CRAWLSPEEDSCALE: "趴姿移动速度缩放比",
  T_46_META_WS_P_CREATEDENTITY: "创建的实体",
  T_46_META_WS_P_CROUCHWALKSPEEDSCALE: "蹲姿移动时速度缩放比",
  T_46_META_WS_P_CSRANK: "CS段位",
  "T_46_META_WS_P_CURRENT AMMO": "当前子弹数",
  T_46_META_WS_P_CURRENTANIMATIONRESOURCE: "当前播放的Emote动画资源ID",
  T_46_META_WS_P_CURRENTCLIP: "当前动画片段",
  T_46_META_WS_P_CURRENTCLIPPROGRESS: "当前动画片段播放进度",
  T_46_META_WS_P_CURRENTDURABILITY: "当前耐久度",
  T_46_META_WS_P_CURRENTENERGY: "当前能量值",
  T_46_META_WS_P_CURRENTHANDHELDITEM: "当前手持物品",
  T_46_META_WS_P_CURRENTHP: "生命值当前量",
  T_46_META_WS_P_CURRENTPHASEINDEX: "当前阶段索引",
  T_46_META_WS_P_CURRENTPROGRESS: "当前进度",
  T_46_META_WS_P_CURRENTROUNDINDEX: "当前回合索引",
  T_46_META_WS_P_CURRENTSTATE: "当前动画状态",
  T_46_META_WS_P_CURRENTVALUE: "当前进度值",
  T_46_META_WS_P_CURRENTWAVE: "当前波数",
  T_46_META_WS_P_CUSTOMCHARACTERRESOURCE: "预设玩家类型",
  T_46_META_WS_P_CUSTOMGAMERESULT: "自定义结算",
  T_46_META_WS_P_CUSTOMGRAVITY: "自定义重力",
  T_46_META_WS_P_CUSTOMPUSHFORCE: "自定义推力",
  T_46_META_WS_P_CUSTOMXY: "XY拖拽量",
  T_46_META_WS_P_DAMAGE: "伤害",
  "T_46_META_WS_P_DAMAGE RANGE": "炮塔范围",
  T_46_META_WS_P_DAMAGEFACTOR: "伤害系数",
  T_46_META_WS_P_DAMAGEINTERVAL: "伤害时间间隔 (s)",
  T_46_META_WS_P_DAMAGERADIUS: "伤害半径",
  T_46_META_WS_P_DAMAGERATIOHEAD: "头伤害系数变化",
  T_46_META_WS_P_DAMAGERATIOLIMB: "四肢伤害系数变化",
  T_46_META_WS_P_DAMAGEREDUCTIONFACTOR: "伤害减免系数",
  T_46_META_WS_P_DAMAGETAKENPCT: "受到伤害百分比",
  T_46_META_WS_P_DAMAGETAKENPERCENT: "受到伤害百分比",
  T_46_META_WS_P_DAMAGEVALUE: "每次伤害量",
  T_46_META_WS_P_DARKNESS: "全局暗度",
  T_46_META_WS_P_DECELERATIONPERCENT: "减速百分比",
  T_46_META_WS_P_DEFAULTTEXT: "占位文本内容",
  T_46_META_WS_P_DEFENSE: "防御百分比",
  T_46_META_WS_P_DEFENSERATE: "减伤率（0~1）",
  T_46_META_WS_P_DELTA: "Delta",
  T_46_META_WS_P_DELTATIME: "逻辑帧间隔",
  T_46_META_WS_P_DELTAVALUE: "变化值",
  T_46_META_WS_P_DEPTH: "Hud层级",
  T_46_META_WS_P_DESC: "描述",
  T_46_META_WS_P_DESCRIPTION: "描述文本",
  T_46_META_WS_P_DESCRIPTIONKEY: "描述信息Key",
  T_46_META_WS_P_DESCRIPTIONPARAMS: "提示信息描述参数",
  T_46_META_WS_P_DESTVAL: "DestVal",
  T_46_META_WS_P_DETECTRANGE: "追击范围",
  T_46_META_WS_P_DIFFUSEALPHA: "表面透明度",
  T_46_META_WS_P_DIFFUSECOLOR: "表面贴图颜色",
  T_46_META_WS_P_DIFFUSETEXTURE: "表面贴图",
  T_46_META_WS_P_DISABLECOLOR: "禁用色",
  T_46_META_WS_P_DISABLEFALLDAMAGE: "是否坠落时免伤",
  T_46_META_WS_P_DISABLEITEMDROP: "是否禁止丢弃物品",
  T_46_META_WS_P_DISABLEITEMPICKUP: "是否禁止拾取物品",
  T_46_META_WS_P_DISABLEMANUALCLOSING: "是否禁止手动关闭",
  T_46_META_WS_P_DISABLEQUICKCHAT: "开关快捷聊天",
  T_46_META_WS_P_DISABLERECIPROCATING: "不使用往返运动",
  T_46_META_WS_P_DISABLEVOICECHAT: "开关语音聊天",
  T_46_META_WS_P_DISTANCE: "射线距离",
  T_46_META_WS_P_DOUBLEGUNTYPE: "双持类型",
  T_46_META_WS_P_DOWNEDCRAWLSPEEDSCALE: "倒地爬行速度缩放比",
  T_46_META_WS_P_DOWNSPEED: "下降速度（力）",
  T_46_META_WS_P_DRAG: "移动阻力系数",
  T_46_META_WS_P_DRIVER: "驾驶者",
  T_46_META_WS_P_DROPITEMS: "空投箱携带物品",
  T_46_META_WS_P_DURABILITY: "耐久",
  T_46_META_WS_P_DURABILITYRECOVERY: "耐久恢复值",
  T_46_META_WS_P_DURATION: "持续时间",
  T_46_META_WS_P_EDGEFLASHTIME: "边缘闪光时间",
  T_46_META_WS_P_EFFECTACTIVE: "显示特效",
  T_46_META_WS_P_EFFECTCOLOR: "特效颜色",
  T_46_META_WS_P_EFFECTDURATION: "特效持续时间",
  T_46_META_WS_P_EFFECTIVETIMEINTERVAL: "生效时间间隔",
  T_46_META_WS_P_EFFECTRESID: "资源路径",
  T_46_META_WS_P_ENABLE: "Enable",
  T_46_META_WS_P_ENABLEATTACK: "是否开启攻击（为否时禁止攻击）",
  T_46_META_WS_P_ENABLEBOTREVIVE: "是否复活（Bot）",
  T_46_META_WS_P_ENABLEDEPTHMAP: "深度图开关",
  T_46_META_WS_P_ENABLEDROPONDEATH: "是否死亡时掉落",
  T_46_META_WS_P_ENABLELOCALIZATION: "本地化开关",
  T_46_META_WS_P_ENABLEMOVEINMIDAIR: "空中是否可水平移动",
  T_46_META_WS_P_ENABLEPLAYERREVIVE: "是否复活（玩家）",
  T_46_META_WS_P_ENABLEPLAYERVIEW: "开启玩家视角",
  T_46_META_WS_P_ENABLEROTATEWITHGRAVITY: "是否跟随重力旋转朝向",
  T_46_META_WS_P_ENABLESKINATTRIBUTES: "写入枪皮对枪的属性",
  T_46_META_WS_P_ENABLESWINGING: "开启荡摆",
  T_46_META_WS_P_ENABLETRACTION: "开启牵引",
  T_46_META_WS_P_ENDPOSITION: "终点位置",
  T_46_META_WS_P_ENDRADIUS: "结束半径",
  T_46_META_WS_P_ENDTIME: "失效时间 (s)",
  T_46_META_WS_P_ENDTIMES: "T_39_WZY_WS_PROCIRCLE_ENDTIME",
  T_46_META_WS_P_ENDVALUE: "最终值",
  T_46_META_WS_P_ENERGY: "EP修改值",
  T_46_META_WS_P_ENERGYCOST: "每秒能量消耗",
  T_46_META_WS_P_ENERGYRECOVERY: "每秒恢复能量",
  T_46_META_WS_P_ENGINEHORSEPOWER: "引擎马力",
  T_46_META_WS_P_ENGINETORQUE: "引擎马力",
  T_46_META_WS_P_EP: "EP",
  T_46_META_WS_P_EPMAX: "EPMAX",
  T_46_META_WS_P_EPRECOVERYAMOUNT: "能量(EP)恢复量",
  T_46_META_WS_P_EVENTS: "事件集合",
  T_46_META_WS_P_EXPLODEDAMAGE: "爆炸伤害",
  T_46_META_WS_P_EXPLODEDAMAGEREDUCTIONFACTOR: "爆炸伤害减免系数",
  T_46_META_WS_P_EXPLODEDELAY: "爆炸延迟",
  T_46_META_WS_P_EXPLODERANGE: "爆炸范围",
  T_46_META_WS_P_EXPLOSIONDELAY: "爆炸延时",
  T_46_META_WS_P_EXPLOSIONRANGE: "爆炸范围",
  T_46_META_WS_P_EXPLOSIONTIME: "爆炸延时",
  T_46_META_WS_P_EXPPERDAMAGE: "凝胶生成器每点伤害提供经验",
  T_46_META_WS_P_EXPPERMOVEMILE: "凝胶生成器移动每米提供经验",
  T_46_META_WS_P_EXPPERSECOND: "凝胶生成器每秒提供经验",
  T_46_META_WS_P_EXTRABACKPACKCAPACITY: "额外背包空间",
  T_46_META_WS_P_EXTRABAGCAPACITY: "额外背包空间",
  T_46_META_WS_P_EXTRAHPRATIO: "玩家血量倍率",
  T_46_META_WS_P_FACEPAINT: "妆容",
  T_46_META_WS_P_FACTION: "阵营实体",
  T_46_META_WS_P_FALLINGDAMAGERATIO: "掉落伤害比例",
  T_46_META_WS_P_FALLSPEED: "结束滑行下落速度",
  T_46_META_WS_P_FASTAUTORELOADSPEED: "自动换弹速度",
  T_46_META_WS_P_FILEID: "内部ID",
  T_46_META_WS_P_FILL: "填充",
  T_46_META_WS_P_FILLAMOUNT: "填充值",
  T_46_META_WS_P_FILLDIRECTION: "填充方向",
  T_46_META_WS_P_FILLTYPE: "填充类型",
  T_46_META_WS_P_FIREANGLELIMIT: "开火角度限制",
  T_46_META_WS_P_FIRETYPE: "开火类型",
  T_46_META_WS_P_FIRSTSCOREPARAMS: "第一种得分值参数数组",
  T_46_META_WS_P_FIRSTSCORETITLE: "第一种得分标题文本Key",
  T_46_META_WS_P_FIRSTSCOREVALUE: "第一种得分值Key",
  T_46_META_WS_P_FIXEDDELTATIME: "固定帧更新间隔",
  T_46_META_WS_P_FLASHBANGHITEFFECTSWITCH: "闪光弹命中效果开关",
  T_46_META_WS_P_FLIP: "翻转",
  T_46_META_WS_P_FLIPTYPE: "翻转类型",
  T_46_META_WS_P_FLYMAXHEIGHT: "最大飞行高度",
  T_46_META_WS_P_FLYSPEEDHORIZONTAL: "滑行速度",
  T_46_META_WS_P_FLYSPEEDVERTICAL: "滑行下降速度",
  T_46_META_WS_P_FOGCOLOR: "雾气颜色",
  T_46_META_WS_P_FOLLOWTARGET: "跟随的目标实体",
  T_46_META_WS_P_FONT: "字体",
  T_46_META_WS_P_FONTSIZE: "字体大小",
  T_46_META_WS_P_FONTSTYLE: "字体风格",
  T_46_META_WS_P_FONTTYPE: "字体",
  T_46_META_WS_P_FORCESYNCTOCLIENT: "强制同步GS状态",
  T_46_META_WS_P_FORWARD: "前方",
  T_46_META_WS_P_FORWARDSPEED: "前进速度（力）",
  T_46_META_WS_P_FOV: "视野",
  T_46_META_WS_P_FREEZEDURATION: "冰冻时间 (s)",
  T_46_META_WS_P_FRIENDFACTIONS: "友好阵营",
  T_46_META_WS_P_FRIENDLYPLAYERS: "友好玩家",
  T_46_META_WS_P_FULLDAMAGEDISTANCE: "满伤害距离",
  T_46_META_WS_P_FUNCTIONTYPE: "功能类型",
  T_46_META_WS_P_GAINHPCOLOR: "增加生命值颜色",
  T_46_META_WS_P_GAMEFRAMECOUNT: "累计运行帧",
  T_46_META_WS_P_GAMETIMECOUNT: "游戏时间",
  T_46_META_WS_P_GEARSHIFTINGDELAY: "档位切换延迟",
  T_46_META_WS_P_GENDER: "性別",
  T_46_META_WS_P_GETONBOOSTCD: "上滑板后冲刺CD",
  T_46_META_WS_P_GETONBOOSTCDSWITCH: "上滑板后冲刺CD开关",
  T_46_META_WS_P_GETONSKATEBOARDCD: "上滑板CD",
  T_46_META_WS_P_GRADIENT: "渐变",
  T_46_META_WS_P_GRADIENTBOTTOM: "底部渐变色",
  T_46_META_WS_P_GRADIENTTOP: "顶部渐变色",
  T_46_META_WS_P_GRAVITY: "重力",
  T_46_META_WS_P_GRENADEMAXDAMAGE: "载具导弹最大伤害",
  T_46_META_WS_P_GRENADEMINDAMAGE: "载具导弹最小伤害",
  T_46_META_WS_P_GRENADERANGE: "载具导弹范围",
  T_46_META_WS_P_GROUPID: "GroupID",
  T_46_META_WS_P_HEAD: "头饰",
  T_46_META_WS_P_HEADDAMAGEFACTOR: "头部伤害倍率偏移",
  T_46_META_WS_P_HEADSHOTDAMAGEREDUCTION: "爆头减伤率",
  T_46_META_WS_P_HEIGHT: "高度",
  T_46_META_WS_P_HELMET: "当前头盔",
  T_46_META_WS_P_HIGHESTBRRANK: "BR巅峰段位",
  T_46_META_WS_P_HIGHESTCSRANK: "CS巅峰段位",
  T_46_META_WS_P_HIGHSHOOTANGLEMIN: "高射最小角度",
  T_46_META_WS_P_HIGHSPEEDSTEERANGLE: "高速转向限制",
  T_46_META_WS_P_HIGHSPEEDSTEERANGLEATSPEED: "高速转向限制速度阈值",
  T_46_META_WS_P_HITPOINTEFFECT: "目标点对象",
  T_46_META_WS_P_HORIZONTALBAR: "水平显示类型",
  T_46_META_WS_P_HORIZONTALOFFSET: "水平方向偏移量",
  T_46_META_WS_P_HOSTILETEAMS: "敌对队伍",
  T_46_META_WS_P_HOSTTEAM: "所属队伍",
  T_46_META_WS_P_HP: "当前血量",
  T_46_META_WS_P_HPMAX: "炮塔最大生命值",
  T_46_META_WS_P_HPRECOVERYAMOUNT: "生命恢复量",
  T_46_META_WS_P_HPRECOVERYSPEED: "恢复速度 (ms)",
  T_46_META_WS_P_ICON: "图标",
  T_46_META_WS_P_ICONCOLOR: "图标颜色",
  T_46_META_WS_P_ICONNAME: "图标名称",
  T_46_META_WS_P_ICONRESOURCE: "资源路径",
  T_46_META_WS_P_ID: "编号",
  "T_46_META_WS_P_IDAMAGE NTERVAL": "炮塔攻击间隔（秒）",
  T_46_META_WS_P_IDLEBRAKEINPUT: "无操控停车马力比例",
  T_46_META_WS_P_INACTIVATEDALPHA: "未激活透明度",
  T_46_META_WS_P_INDEX: "阶段索引",
  T_46_META_WS_P_INITIALMAGCOUNT: "初始弹夹数量",
  T_46_META_WS_P_INITIALSPEED: "初速度",
  T_46_META_WS_P_INITIALVALUE: "初始值[0, 1](瞬切)",
  T_46_META_WS_P_INITIALWORLDPOSITION: "初始世界坐标",
  T_46_META_WS_P_INSCENE: "在场景中",
  T_46_META_WS_P_INSTANCEID: "实例ID",
  T_46_META_WS_P_INTENSITY: "光照强度",
  T_46_META_WS_P_INVERTFILL: "反向填充",
  T_46_META_WS_P_INVINCIBLE: "无敌",
  "T_46_META_WS_P_IS SHOW": "是否显示触发器",
  T_46_META_WS_P_IS3D: "是否3D",
  T_46_META_WS_P_ISACE: "是否团灭",
  T_46_META_WS_P_ISACED: "是否团灭",
  T_46_META_WS_P_ISAI: "是否是AI",
  T_46_META_WS_P_ISALWAYSINSCREEN: "总在屏幕内",
  T_46_META_WS_P_ISAPPLYSHADOW: "投影",
  T_46_META_WS_P_ISATTACKABLE: "是否可被攻击",
  T_46_META_WS_P_ISAUTOCHASEENEMY: "自动索敌",
  T_46_META_WS_P_ISAUTOPLAY: "自动播放",
  T_46_META_WS_P_ISAUTOTELEPORT: "是否是自动传送",
  T_46_META_WS_P_ISBILLBOARD: "总是面向摄像机",
  T_46_META_WS_P_ISBOLD: "加粗",
  T_46_META_WS_P_ISBOTTOMCOLLIDING: "底部是否发生了触碰",
  T_46_META_WS_P_ISCENTERPOS: "是否使用中心点播放",
  T_46_META_WS_P_ISCONSUMEAMMO: "是否消耗弹药",
  T_46_META_WS_P_ISCONTINUOUS: "是否是连续生成",
  T_46_META_WS_P_ISCOUNTDOWN: "是否为倒计时",
  T_46_META_WS_P_ISCURRENTANIMATIONLOOP: "当前播放的Emote动画是否循环",
  T_46_META_WS_P_ISDEADDROP: "是否支持死亡掉落",
  T_46_META_WS_P_ISDEATHTRIGGER: "是否为死亡触发器",
  T_46_META_WS_P_ISDEBUG: "开启调试",
  T_46_META_WS_P_ISDEFAULTSPAWNPOINT: "是否是默认出生点",
  T_46_META_WS_P_ISDROPONELIMINATED: "死亡时遗失所有装备",
  T_46_META_WS_P_ISEND: "isEnd",
  T_46_META_WS_P_ISFEBUTTON: "是否是FE的按钮",
  T_46_META_WS_P_ISGREY: "按钮变灰",
  T_46_META_WS_P_ISGROUNDED: "是否着地",
  T_46_META_WS_P_ISIGNOREDEPTH: "是否忽略深度",
  T_46_META_WS_P_ISINVINCIBLE: "无敌",
  T_46_META_WS_P_ISITALIC: "斜体",
  T_46_META_WS_P_ISLASTROUND: "是否最终回合",
  T_46_META_WS_P_ISLOCALPOS: "启用偏移坐标局部坐标系",
  T_46_META_WS_P_ISLOOP: "是否循环",
  T_46_META_WS_P_ISMATCHPOINT: "是否决胜局",
  T_46_META_WS_P_ISMOVEABLE: "是否允许移动",
  T_46_META_WS_P_ISOCCUPIED: "是否已被占用",
  T_46_META_WS_P_ISOPENTWEEN: "启用生命值变化效果",
  T_46_META_WS_P_ISPLAYING: "播放状态",
  T_46_META_WS_P_ISPURCHASABLE: "能否购买",
  T_46_META_WS_P_ISREVERSE: "反转",
  T_46_META_WS_P_ISSERVERDRIVEN: "是否由服务器驱动",
  T_46_META_WS_P_ISSHOW: "是否显示触发器",
  T_46_META_WS_P_ISSHOWHUDNAME: "是否显示HudName",
  T_46_META_WS_P_ISSHOWMAPINFO: "是否显示MapInfo",
  T_46_META_WS_P_ISSHOWQUICKMESSAGE: "是否显示快速消息",
  T_46_META_WS_P_ISSHOWSCAN: "是否显示Scan",
  T_46_META_WS_P_ISSHOWTAG: "是否显示Tag",
  T_46_META_WS_P_ISSIDECOLLIDING: "侧边是否发生了触碰",
  T_46_META_WS_P_ISSILENCE: "是否消音",
  T_46_META_WS_P_ISSINGLESHOT: "是否单发",
  T_46_META_WS_P_ISSKIPSTAGGERANIMATION: "跳过坠落时的僵直动画",
  T_46_META_WS_P_ISSLIDING: "是否正在滑落",
  T_46_META_WS_P_ISTOPCOLLIDING: "上部是否发生了触碰",
  T_46_META_WS_P_ISUNDERLINE: "下划线",
  T_46_META_WS_P_ISVISIBLE: "是否可见",
  T_46_META_WS_P_ITEMBACKGROUNDCOLORS: "卡牌背景颜色数组",
  T_46_META_WS_P_ITEMBACKGROUNDS: "卡牌背景Sprite数组",
  T_46_META_WS_P_ITEMCOUNTS: "商品数量列表",
  T_46_META_WS_P_ITEMDESCRIPTIONS: "卡牌描述数组",
  T_46_META_WS_P_ITEMICONS: "卡牌IconSprite数组",
  T_46_META_WS_P_ITEMID: "武器对应的道具id",
  T_46_META_WS_P_ITEMIDS: "商品ID列表",
  T_46_META_WS_P_ITEMNAMES: "卡牌名字数组",
  T_46_META_WS_P_ITEMPICKUPBANLIST: "禁止拾取物品列表",
  T_46_META_WS_P_JOYSTICKDRAGRADIUS: "操纵杆拖拽半径",
  T_46_META_WS_P_JOYSTICKIMAGE: "操纵杆图片",
  T_46_META_WS_P_JOYSTICKRADIUS: "操纵杆半径",
  T_46_META_WS_P_JUMPCD: "跳跃cd",
  T_46_META_WS_P_JUMPHEIGHT: "跳跃高度",
  T_46_META_WS_P_JUMPHEIGHTSCALE: "跳跃高度缩放比",
  T_46_META_WS_P_KNOCKDOWNDAMAGEBONUS: "对倒地玩家伤害偏移",
  T_46_META_WS_P_KNOCKDOWNSTATUS: "击倒设置",
  T_46_META_WS_P_LABEL: "文本内容",
  T_46_META_WS_P_LABELCOLOR: "文本颜色",
  T_46_META_WS_P_LABELKEY: "文本内容Key",
  T_46_META_WS_P_LABELPARAMS: "文本内容参数数组",
  T_46_META_WS_P_LASTCHECKPOINTID: "当前检查点ID",
  T_46_META_WS_P_LASTSURVIVALTIME: "存活时间",
  T_46_META_WS_P_LAYERTYPE: "层级",
  T_46_META_WS_P_LAYOUTTYPE: "LayoutType",
  T_46_META_WS_P_LEFTARM: "左臂",
  T_46_META_WS_P_LEFTBACKGROUNDCOLOR: "左边背景颜色",
  T_46_META_WS_P_LEFTCOLOR: "左边颜色",
  T_46_META_WS_P_LEFTDESCRIPTION: "左边队伍描述",
  T_46_META_WS_P_LEFTEFFECTACTIVE: "是否显示左侧特效",
  T_46_META_WS_P_LEFTFIRINGARCANGLE: "左侧射界角度",
  T_46_META_WS_P_LEFTFOOT: "左脚",
  T_46_META_WS_P_LEFTHAND: "左手",
  T_46_META_WS_P_LEFTICON: "左侧图标",
  T_46_META_WS_P_LEFTICONNAME: "左边图标名称",
  T_46_META_WS_P_LEFTLEG: "左腿",
  T_46_META_WS_P_LEFTPLAYERS: "左边玩家数组",
  T_46_META_WS_P_LEFTSCORE: "左边得分",
  T_46_META_WS_P_LEFTSCOREAFTER: "左边最后得分",
  T_46_META_WS_P_LEFTSCORETEXT: "左侧得分文本",
  T_46_META_WS_P_LEFTTEAM: "左边队伍/阵营",
  T_46_META_WS_P_LEFTTEAMINDEX: "左边队伍索引",
  T_46_META_WS_P_LEFTTEAMMATEALIVENUM: "左边队员存活数",
  T_46_META_WS_P_LEFTTEAMMATEFLAGCOUNT: "左边队员旗子数",
  T_46_META_WS_P_LEFTTEAMMATESTATES: "左边队员状态数组",
  T_46_META_WS_P_LEFTTEAMNAME: "左边队伍名",
  T_46_META_WS_P_LEFTTEAMSCORE: "左边队伍得分",
  T_46_META_WS_P_LEFTTEXT: "左侧文本",
  T_46_META_WS_P_LENGTH: "HUD长度",
  T_46_META_WS_P_LENSFLARE: "光晕强度",
  T_46_META_WS_P_LEVEL: "当前等级",
  T_46_META_WS_P_LIFETIME: "炮塔持续时间(秒)",
  T_46_META_WS_P_LIGHTCOLOR: "主光源颜色",
  T_46_META_WS_P_LIGHTINTENSITY: "主光源强度",
  T_46_META_WS_P_LIMBDAMAGEFACTOR: "伤害倍率偏移",
  T_46_META_WS_P_LINESPACING: "行间距",
  T_46_META_WS_P_LOCALPOSITION: "相对位置",
  T_46_META_WS_P_LOCALROTATION: "本地旋转欧拉角(角度制)",
  T_46_META_WS_P_LOCALROTATIONQ: "本地旋转四元数",
  T_46_META_WS_P_LOCALSCALE: "本地缩放大小，默认为1",
  T_46_META_WS_P_LOCKEY: "本地化Key",
  T_46_META_WS_P_LOOPCOUNT: "循环次数",
  T_46_META_WS_P_LOOTSOCCER: "Loot足球点",
  T_46_META_WS_P_LOSEHPCOLOR: "失去生命值颜色",
  T_46_META_WS_P_LOSEMVPS: "失败MVP列表",
  T_46_META_WS_P_LOSETEXT: "失败提示文本",
  "T_46_META_WS_P_MAIN CAMERA": "主相机",
  T_46_META_WS_P_MAINCOLOR: "主要颜色",
  T_46_META_WS_P_MAINSCORELIST: "总积分列表",
  T_46_META_WS_P_MAINSCORETITLE: "总积分名",
  T_46_META_WS_P_MAINWEAPON: "当前主武器",
  T_46_META_WS_P_MAPSIZE: "地图尺寸大小",
  T_46_META_WS_P_MASK: "脸饰",
  T_46_META_WS_P_MASKNAME: "MaskName",
  T_46_META_WS_P_MASS: "质量(kg)",
  T_46_META_WS_P_MATCHTITLELEFT: "对局标题1",
  T_46_META_WS_P_MATCHTITLERIGHT: "对局标题2",
  T_46_META_WS_P_MAXCAPACITY: "空间",
  T_46_META_WS_P_MAXCOUNT: "最大数量",
  T_46_META_WS_P_MAXDAMAGE: "最大伤害",
  T_46_META_WS_P_MAXDEPRESSIONANGLE: "最大俯角",
  T_46_META_WS_P_MAXDISPLACEMENT: "最大位移",
  T_46_META_WS_P_MAXDISTANCE: "最大距离",
  T_46_META_WS_P_MAXDURABILITY: "最大耐久度",
  T_46_META_WS_P_MAXDURABILITYRATIO: "耐久上限倍率",
  T_46_META_WS_P_MAXENERGY: "最大能量",
  T_46_META_WS_P_MAXEP: "总能量值",
  T_46_META_WS_P_MAXHP: "最大血量",
  T_46_META_WS_P_MAXJUMPCOUNT: "最大连续跳跃次数",
  T_46_META_WS_P_MAXJUMPHEIGHT: "二段跳最大跳跃高度",
  T_46_META_WS_P_MAXLENGTH: "最大长度",
  T_46_META_WS_P_MAXPROGRESS: "最大进度",
  T_46_META_WS_P_MAXSCATTERRATIO: "散射时准星最大倍数",
  T_46_META_WS_P_MAXSPEED: "最大绝对运动速度",
  T_46_META_WS_P_MAXTURRETCOUNT: "最大炮塔数量",
  T_46_META_WS_P_MAXVALUE: "最大数值",
  T_46_META_WS_P_MAXWIDGETID: "当前最大WidgetID",
  T_46_META_WS_P_MINDAMAGE: "最小伤害",
  T_46_META_WS_P_MINDAMAGEDISTANCE: "最小伤害开始距离",
  T_46_META_WS_P_MINDISTANCE: "最小距离",
  T_46_META_WS_P_MINELEVATIONANGLE: "最小仰角",
  T_46_META_WS_P_MINENDHEIGHT: "最小结束高度",
  T_46_META_WS_P_MINFLYHEIGHT: "最小起飞高度",
  T_46_META_WS_P_MINMOVEDISTANCE: "最小移动距离",
  T_46_META_WS_P_MINVALUE: "最小值",
  T_46_META_WS_P_MISSILEMAXDAMAGE: "载具导弹最大伤害",
  T_46_META_WS_P_MISSILEMINDAMAGE: "载具导弹最小伤害",
  T_46_META_WS_P_MISSILERANGE: "载具导弹范围",
  T_46_META_WS_P_MODEL: "外观类型",
  T_46_META_WS_P_MODELVISIBILITY: "模型显隐",
  T_46_META_WS_P_MODELVISIBLE: "模型显隐",
  T_46_META_WS_P_MONEY: "绑定的货币实体",
  T_46_META_WS_P_MONEYLIST: "绑定的货币实体列表",
  T_46_META_WS_P_MONEYS: "货币",
  T_46_META_WS_P_MONEYTYPE: "货币类型",
  T_46_META_WS_P_MONSTERTYPE: "怪物类型",
  T_46_META_WS_P_MOTIONTYPE: "运动方式",
  T_46_META_WS_P_MOTIONVALUEX: "X轴方向的增量",
  T_46_META_WS_P_MOTIONVALUEY: "Y轴方向的增量",
  T_46_META_WS_P_MOTIONVALUEZ: "Z轴方向的增量",
  T_46_META_WS_P_MOVEMENTDURATION: "移动时长",
  T_46_META_WS_P_MULTIPLIER: "连乘器",
  T_46_META_WS_P_MUSICELEMENTTYPE: "音乐类型",
  T_46_META_WS_P_MUZZLEVELOCITY: "出膛速度",
  T_46_META_WS_P_MVP: "MVP 玩家昵称",
  T_46_META_WS_P_NAME: "物件名字",
  T_46_META_WS_P_NEXTROUNDINDEX: "下回合Index",
  T_46_META_WS_P_NICKNAME: "昵称",
  T_46_META_WS_P_NORMALCOLOR: "默认颜色",
  T_46_META_WS_P_NORMALIZEDPOSITION: "HUD位置",
  T_46_META_WS_P_NUMBERINFACTION: "玩家在阵营中的序号",
  T_46_META_WS_P_OBJECTID: "名字拼接对象编号",
  T_46_META_WS_P_OFFSET: "偏移",
  T_46_META_WS_P_OPTIONS: "选项",
  T_46_META_WS_P_OTHERDAMAGEFACTOR: "对其他物件伤害系数",
  T_46_META_WS_P_OUTFIT: "玩家服饰",
  T_46_META_WS_P_OVERFLOW: "文本溢出",
  T_46_META_WS_P_OVERHEIGHTFALLSPEED: "超高之后的下落速度",
  T_46_META_WS_P_OVERLOADBYPLAYERCONFIGURATION: "玩家配置优先",
  T_46_META_WS_P_OWNER: "所有者",
  T_46_META_WS_P_PARAMS: "信息提示描述参数数组",
  T_46_META_WS_P_PARENT: "父节点实体",
  T_46_META_WS_P_PARENTID: "父节点控件EntityID",
  T_46_META_WS_P_PARENTUI: "所属UI",
  T_46_META_WS_P_PARENTWIDGETENTITYID: "父节点控件EntityID",
  T_46_META_WS_P_PARENTWIDGETFILEID: "父节点控件FileID",
  T_46_META_WS_P_PARTMASKA: "部件显示掩码1",
  T_46_META_WS_P_PASSENGERS: "乘客",
  T_46_META_WS_P_PATHID: "路径的场景物件ID",
  T_46_META_WS_P_PAUSEEVENT: "暂停事件",
  T_46_META_WS_P_PERSONAID: "智能体ID",
  T_46_META_WS_P_PHASEDURATION: "持续时间 (ms)",
  T_46_META_WS_P_PHASEENDTIME: "结束时间 (ms)",
  T_46_META_WS_P_PHYSICALLAYER: "物理层级",
  T_46_META_WS_P_PINID: "纪念章ID",
  T_46_META_WS_P_PITCH: "俯仰角",
  T_46_META_WS_P_PIVOT: "支点",
  T_46_META_WS_P_PLAYER: "当前绑定的玩家",
  T_46_META_WS_P_PLAYERAIMINGSPEEDFACTOR: "开镜移动速度修正系数",
  T_46_META_WS_P_PLAYERLIST: "玩家列表",
  T_46_META_WS_P_PLAYERNAME: "名称",
  T_46_META_WS_P_PLAYERRANK: "玩家排名",
  T_46_META_WS_P_PLAYERRANKS: "玩家排行数组",
  T_46_META_WS_P_PLAYERS: "玩家列表",
  T_46_META_WS_P_PLAYERSCORETYPES: "玩家积分类型数组",
  T_46_META_WS_P_PLAYERSPEEDFACTOR: "影响玩家移速系数",
  T_46_META_WS_P_PLAYERSPEEDFACTORWHILEFIRING: "攻击时的玩家速度系数",
  T_46_META_WS_P_PLAYERSTATUS: "玩家状态",
  T_46_META_WS_P_PLAYERTRACTIONSPEED: "牵引玩家速度",
  T_46_META_WS_P_PLAYINGSTATUS: "播放状态",
  T_46_META_WS_P_PLAYSPEED: "播放速度",
  T_46_META_WS_P_POINTPOSITION: "点位置",
  T_46_META_WS_P_POINTS: "积分",
  T_46_META_WS_P_POSITION: "位置",
  T_46_META_WS_P_PREFABID: "模板ID",
  T_46_META_WS_P_PRESSEDCOLOR: "按压色",
  T_46_META_WS_P_PRESSEDSPRITE: "按下图片",
  T_46_META_WS_P_PRESSEDSPRITETYPE: "按下图片类型",
  T_46_META_WS_P_PRICE: "价格",
  T_46_META_WS_P_PRIORITY: "优先级",
  T_46_META_WS_P_PROFILEINFO: "玩家名片",
  T_46_META_WS_P_PROGRESS: "进度[0,1]",
  T_46_META_WS_P_PROGRESSICON: "进度图标",
  T_46_META_WS_P_PROGRESSICONNAME: "进度图标名",
  T_46_META_WS_P_PROPID: "属性ID",
  T_46_META_WS_P_PURCHASELIMIT: "限购数量",
  T_46_META_WS_P_RADIUS: "半径",
  T_46_META_WS_P_RANGE: "光照范围",
  T_46_META_WS_P_RANK: "排名",
  T_46_META_WS_P_RATIOSELFFACTOR: "自己伤害系数",
  T_46_META_WS_P_RATIOTEAMMATEFACTOR: "队友伤害系数",
  T_46_META_WS_P_RATIOVEHICLEFACTOR: "车辆伤害系数",
  T_46_META_WS_P_REFRESHTIME: "Buff刷新时间 (s)",
  T_46_META_WS_P_RELOADSPEED: "换弹夹速度",
  T_46_META_WS_P_RELOADSPEEDFACTOR: "换弹速度系数",
  T_46_META_WS_P_REMAINJUMPCOUNT: "剩余可连续跳跃次数",
  T_46_META_WS_P_REMAINQUANTITY: "当前数量",
  T_46_META_WS_P_RENDERTYPE: "显示方式",
  T_46_META_WS_P_REPEATTIMES: "播放次数",
  T_46_META_WS_P_REPLACEMENTPRIORITY: "替换优先级",
  T_46_META_WS_P_REQUESTEDITEMLIST: "被请求的物品列表",
  T_46_META_WS_P_REQUESTTYPE: "请求类型",
  T_46_META_WS_P_RESETPERROUND: "每回合重置",
  T_46_META_WS_P_RESETPOSITION: "复位位置",
  T_46_META_WS_P_RESETTIME: "复位时间",
  T_46_META_WS_P_RESOURCE: "资源",
  T_46_META_WS_P_RESOURCEID: "资源UUID",
  T_46_META_WS_P_RESTRICTWITHINPANEL: "限制内容在视口内",
  T_46_META_WS_P_RESULT: "胜败平",
  T_46_META_WS_P_RESULTTYPE: "显示结果",
  T_46_META_WS_P_REVIVALPOINT: "复活点",
  T_46_META_WS_P_REVIVECD: "复活时长",
  T_46_META_WS_P_RIGHT: "右方",
  T_46_META_WS_P_RIGHTARM: "右臂",
  T_46_META_WS_P_RIGHTBACKGROUNDCOLOR: "右边背景颜色",
  T_46_META_WS_P_RIGHTCOLOR: "右边颜色",
  T_46_META_WS_P_RIGHTDESCRIPTION: "右边队伍描述",
  T_46_META_WS_P_RIGHTEFFECTACTIVE: "是否显示右侧特效",
  T_46_META_WS_P_RIGHTFIRINGARCANGLE: "右侧射界角度",
  T_46_META_WS_P_RIGHTFOOT: "右脚",
  T_46_META_WS_P_RIGHTHAND: "右手",
  T_46_META_WS_P_RIGHTICON: "右侧图标",
  T_46_META_WS_P_RIGHTICONNAME: "右边图标名称",
  T_46_META_WS_P_RIGHTLEG: "右腿",
  T_46_META_WS_P_RIGHTPLAYERS: "右边玩家数组",
  T_46_META_WS_P_RIGHTSCORE: "右边得分",
  T_46_META_WS_P_RIGHTSCOREAFTER: "右边最后得分",
  T_46_META_WS_P_RIGHTSCORETEXT: "右侧得分文本",
  T_46_META_WS_P_RIGHTTEAM: "右边队伍/阵营",
  T_46_META_WS_P_RIGHTTEAMINDEX: "右边队伍索引",
  T_46_META_WS_P_RIGHTTEAMMATEALIVENUM: "右边队员存活数",
  T_46_META_WS_P_RIGHTTEAMMATEFLAGCOUNT: "右边队员旗子数",
  T_46_META_WS_P_RIGHTTEAMMATESTATES: "右边队员状态数组",
  T_46_META_WS_P_RIGHTTEAMNAME: "右边队伍名",
  T_46_META_WS_P_RIGHTTEAMSCORE: "右边队伍得分",
  T_46_META_WS_P_RIGHTTEXT: "右侧文本",
  T_46_META_WS_P_RIMALPHA: "边缘透明度",
  T_46_META_WS_P_RIMCOLOR: "边缘颜色",
  T_46_META_WS_P_RIMTEXTURE: "边缘贴图",
  T_46_META_WS_P_ROLLINGFRICTIONCOEFF: "摩擦系数",
  T_46_META_WS_P_ROLLINGFRICTIONCOEFFRUSHING: "摩擦系数(冲击)",
  T_46_META_WS_P_ROTATION: "旋转",
  T_46_META_WS_P_ROTATIONANGLE: "旋转角度",
  T_46_META_WS_P_ROTATIONQ: "旋转四元数",
  T_46_META_WS_P_ROUNDINCOME: "回合收入数值",
  T_46_META_WS_P_ROUNDINCOMEDETAILNUMS: "回合收入数值详情列表",
  T_46_META_WS_P_ROUNDINCOMEDETAILTITLES: "回合收入详情标题列表",
  T_46_META_WS_P_ROUNDINCOMETITLE: "回合收入标题",
  T_46_META_WS_P_ROUNDNUM: "第几回合",
  T_46_META_WS_P_ROUNDNUMKEY: "回合数文本Key",
  T_46_META_WS_P_ROUNDNUMLOCKEYPARAMS: "回合数参数数组",
  T_46_META_WS_P_RUNSPEED: "行动速度",
  T_46_META_WS_P_RUNSPEEDSCALE: "移动速度缩放比",
  T_46_META_WS_P_RUSHDISTANCE: "冲刺距离",
  T_46_META_WS_P_RUSHENERGYCOST: "每秒冲刺能量消耗",
  T_46_META_WS_P_RUSHVERTICALSPEED: "上冲垂直速度",
  T_46_META_WS_P_SCALE: "缩放",
  T_46_META_WS_P_SCATTERINCREASESPEED: "散射准星扩大倍数",
  T_46_META_WS_P_SCATTERMAX: "最大扩散阈值",
  T_46_META_WS_P_SCATTERMULTIPLIERWHILEMOVING: "移动散射时准星扩散倍数",
  T_46_META_WS_P_SCATTERRECOVERSPEED: "散射准星恢复速度系数",
  T_46_META_WS_P_SCATTERSPEED: "扩散增加速度",
  T_46_META_WS_P_SCATTERSPEEDCROUCHPRONE: "蹲下,趴下减少散射",
  T_46_META_WS_P_SCATTERTHRESHOLD: "开始散射阈值",
  T_46_META_WS_P_SCOPETYPE: "倍镜类型",
  T_46_META_WS_P_SCORE: "积分数",
  T_46_META_WS_P_SCORES1: "积分列表1",
  T_46_META_WS_P_SCORES2: "积分列表2",
  T_46_META_WS_P_SCORES3: "积分列表3",
  T_46_META_WS_P_SCORES4: "积分列表4",
  T_46_META_WS_P_SCORES5: "积分列表5",
  T_46_META_WS_P_SCORETEXTKEY: "得分文本Key",
  T_46_META_WS_P_SCORETEXTKEYPARAMS: "得分文本参数数组",
  T_46_META_WS_P_SCROLLCONTINUITY: "惯性因子",
  T_46_META_WS_P_SCROLLDIRECTION: "滚动方向",
  T_46_META_WS_P_SCROLLEFFECT: "拖动效果",
  T_46_META_WS_P_SCROLLWHEELSPEED: "滚轮因子",
  T_46_META_WS_P_SECONDSCORETITLE: "第二种得分标题文本Key",
  T_46_META_WS_P_SECONDSCOREVALUE: "第二种得分值Key",
  T_46_META_WS_P_SECONDSCOREVALUEPARAMS: "第二种得分值参数数组",
  T_46_META_WS_P_SELECTEDCOLOR: "选中图片颜色",
  T_46_META_WS_P_SELECTEDINDEX: "选择Item的索引",
  T_46_META_WS_P_SELECTEDSPRITE: "选中图片",
  T_46_META_WS_P_SELECTEDTYPE: "选中图片填充类型",
  T_46_META_WS_P_SELF: "自身实体",
  T_46_META_WS_P_SELFDAMAGEFACTOR: "自己伤害系数",
  T_46_META_WS_P_SET: "连体衣",
  T_46_META_WS_P_SHADERNAME: "Shader名称",
  T_46_META_WS_P_SHADOWCOLOR: "投影颜色",
  T_46_META_WS_P_SHADOWOFFSET: "投影偏移量",
  T_46_META_WS_P_SHADOWSTRENGTH: "阴影暗度",
  T_46_META_WS_P_SHELFS: "货架列表",
  T_46_META_WS_P_SHOES: "鞋",
  T_46_META_WS_P_SHOOTANGLEMAX: "射门最大角度",
  T_46_META_WS_P_SHOOTANGLEMIN: "最小射门角度",
  T_46_META_WS_P_SHOP: "绑定商店",
  T_46_META_WS_P_SHOPITEMS: "商品列表",
  T_46_META_WS_P_SHOWADDFRIEND: "显示加好友",
  T_46_META_WS_P_SHOWATTACKGRENADE: "攻击投掷物",
  T_46_META_WS_P_SHOWBACKGROUND: "显示背景",
  T_46_META_WS_P_SHOWCROUCH: "蹲下",
  T_46_META_WS_P_SHOWDAMAGENUMBER: "开启FF伤害跳字",
  T_46_META_WS_P_SHOWDEFENCEGRENADE: "防御投掷物",
  T_46_META_WS_P_SHOWECCONOMY: "显示局外经济",
  T_46_META_WS_P_SHOWECONOMY: "显示局外经济",
  T_46_META_WS_P_SHOWFIRE: "开火",
  T_46_META_WS_P_SHOWFRAME: "显示边框",
  T_46_META_WS_P_SHOWGIFT: "显示送礼",
  T_46_META_WS_P_SHOWHITPOINTEFFECT: "显示目标点对象",
  T_46_META_WS_P_SHOWJUMP: "跳",
  T_46_META_WS_P_SHOWLIKE: "显示点赞",
  T_46_META_WS_P_SHOWLOBBY: "显示回到大厅",
  T_46_META_WS_P_SHOWMAPEVALUATE: "显示地图评价",
  T_46_META_WS_P_SHOWMATCHDETAIL: "显示对局详情",
  T_46_META_WS_P_SHOWMOVINGJOYSTICK: "移动摇杆HUD开关",
  T_46_META_WS_P_SHOWNAME: "显示昵称",
  T_46_META_WS_P_SHOWPIN: "显示纪念章",
  T_46_META_WS_P_SHOWPRONE: "爬行",
  T_46_META_WS_P_SHOWRANK: "显示段位",
  T_46_META_WS_P_SHOWREPLAY: "显示回放",
  T_46_META_WS_P_SHOWREPORT: "显示举报",
  T_46_META_WS_P_SHOWSHARE: "显示分享",
  T_46_META_WS_P_SHOWSPRINT: "疾跑HUD开关",
  T_46_META_WS_P_SHOWTAG: "是否显示队伍或阵营的标记点",
  T_46_META_WS_P_SHOWTEAMMATESINFO: "队友信息",
  T_46_META_WS_P_SHOWTEAMMATESTATE: "显示队员状态",
  T_46_META_WS_P_SHOWTEAMSCORE: "显示队伍比分",
  T_46_META_WS_P_SHOWTIMETYPE: "显示结果",
  T_46_META_WS_P_SHOWTWOTEAMSCORE: "显示2个队伍比分",
  T_46_META_WS_P_SHRINKDURATION: "缩圈用时 (ms)",
  T_46_META_WS_P_SHRINKENDTIME: "缩圈结束时间 (ms)",
  T_46_META_WS_P_SHRINKSPEED: "收敛速度",
  T_46_META_WS_P_SHRINKSTARTTIME: "缩圈开始时间 (s)",
  T_46_META_WS_P_SIGHTAIMASSIST: "允许开镜时辅助瞄准",
  T_46_META_WS_P_SIGHTAIMASSISTDISTFALLOFF: "辅助瞄准距离衰减影响系数(0-1)",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOCOEF: "辅助瞄准距离优先影响系数(>=1)",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOMAX: "辅助瞄准距离优先最大距离",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOMIN: "辅助瞄准距离优先最小距离",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIORITY: "允许辅助瞄准距离优先",
  T_46_META_WS_P_SIGHTAIMASSISTSNAPRANGE: "辅助瞄准准星屏幕范围吸引比率(0-1)",
  T_46_META_WS_P_SIGHTAMPLIFYRATIO: "瞄准镜名义放大倍率",
  T_46_META_WS_P_SIGHTFOVAMPLIFYRATIO: "FOV放大倍率",
  T_46_META_WS_P_SIGHTROTSENSITIVENESS: "瞄镜旋转敏感度系数",
  T_46_META_WS_P_SIGHTSHOOTMINDAMAGE: "瞄镜最小伤害距离修正系数X",
  T_46_META_WS_P_SIGHTUIACTIONEXPAND: "瞄镜UI射击放大时间(s)",
  T_46_META_WS_P_SIGHTUIACTIONRATIO: "瞄镜射击UI放大倍率",
  T_46_META_WS_P_SIGHTUIACTIONRECOVERY: "瞄镜UI射击恢复时间(s)",
  T_46_META_WS_P_SIZE: "尺寸大小",
  T_46_META_WS_P_SIZEDELTA: "与锚框尺寸差",
  T_46_META_WS_P_SKELETON: "骨骼",
  T_46_META_WS_P_SKIN: "皮肤",
  T_46_META_WS_P_SKINID: "皮肤",
  T_46_META_WS_P_SKINWIDTH: "皮肤厚度",
  T_46_META_WS_P_SKYBOXENV: "天空盒",
  T_46_META_WS_P_SKYBOXRESOURCE: "基础天空盒资源",
  T_46_META_WS_P_SLOPELIMIT: "最大上坡角度",
  T_46_META_WS_P_SMOOTHSCROLLSTART: "开始滚动时缓动",
  T_46_META_WS_P_SOFTNESS: "Softness",
  T_46_META_WS_P_SORTTYPE: "排序方式",
  T_46_META_WS_P_SPAWNCOUNTPERWAVE: "每波生成数量",
  T_46_META_WS_P_SPAWNPOINT: "出生点",
  T_46_META_WS_P_SPAWNPOINTCOUNT: "出生点个数",
  T_46_META_WS_P_SPAWNPOSITION: "出生点坐标",
  T_46_META_WS_P_SPEED: "速度",
  T_46_META_WS_P_SPEEDWHILEAIMING: "开镜移速倍率",
  T_46_META_WS_P_SPRAYCOLOR: "喷漆颜色",
  T_46_META_WS_P_SPRINTENERGYCOST: "每秒快跑能量消耗",
  T_46_META_WS_P_SPRINTHORIZONTALSPEED: "快跑水平速度",
  T_46_META_WS_P_SPRINTSPEEDSCALE: "疾跑速度缩放比",
  T_46_META_WS_P_SPRITENAME: "图片形状",
  T_46_META_WS_P_SPRITERESOURCE: "图片形状",
  T_46_META_WS_P_SRCVAL: "SrcVal",
  T_46_META_WS_P_STARTDROPTIME: "空投箱掉落时间 (ms)",
  T_46_META_WS_P_STARTEVENT: "开始事件",
  T_46_META_WS_P_STARTPOSITION: "起始位置",
  T_46_META_WS_P_STARTRADIUS: "开始半径",
  T_46_META_WS_P_STARTSPAWNTIME: "开始生成时间",
  T_46_META_WS_P_STARTTIME: "开始时间（秒）",
  T_46_META_WS_P_STARTVALUE: "初始值",
  T_46_META_WS_P_STATICICONCOLORS: "在某刻度上显示的icon叠加色",
  T_46_META_WS_P_STATICICONS: "在某刻度上显示的icon样式",
  T_46_META_WS_P_STATUS: "防御塔状态",
  T_46_META_WS_P_STEPOFFSET: "步距垂直偏移",
  T_46_META_WS_P_STOPDURATION: "停止时长",
  T_46_META_WS_P_STOPEVENT: "停止事件",
  T_46_META_WS_P_STORE: "绑定商店实体",
  T_46_META_WS_P_STROPID: "StropID",
  T_46_META_WS_P_STYLE: "样式",
  T_46_META_WS_P_SUBTITLE: "副标题",
  T_46_META_WS_P_SUMMULTIPLIER: "乘法累加器",
  T_46_META_WS_P_SWINGEXITACCELERATION: "离开荡摆的加速度",
  T_46_META_WS_P_SWINGINGSPEED: "荡摆速度",
  T_46_META_WS_P_TAGS: "标签列表",
  T_46_META_WS_P_TARGETCHECKPOINTID: "目标检查点ID",
  T_46_META_WS_P_TARGETICONCOLORS: "标记目标显示的icon的叠加色",
  T_46_META_WS_P_TARGETICONS: "标记目标显示的icon样式",
  T_46_META_WS_P_TARGETID: "目标实体ID",
  T_46_META_WS_P_TARGETITEMID: "模仿的目标物品ID，参照SceneEditPrefab中的第一列",
  T_46_META_WS_P_TARGETROTATION: "模仿的目标的朝向",
  T_46_META_WS_P_TARGETSCALE: "模仿的目标的缩放",
  T_46_META_WS_P_TEAMCOLOR: "队伍颜色",
  T_46_META_WS_P_TEAMCOLORS: "队伍颜色数组",
  T_46_META_WS_P_TEAMINDEXS: "队伍索引数组",
  T_46_META_WS_P_TEAMMATEDAMAGEFACTOR: "队友伤害系数",
  T_46_META_WS_P_TEAMMEMBERNUM: "队伍成员数",
  T_46_META_WS_P_TEAMNUM: "队伍数",
  T_46_META_WS_P_TEAMRANK: "队伍/阵营排名",
  T_46_META_WS_P_TEAMRANKDISPLAY: "队伍名次显示",
  T_46_META_WS_P_TEAMRANKS: "队伍排行数组",
  T_46_META_WS_P_TEAMSCORES: "队伍得分数组",
  T_46_META_WS_P_TEAMSEQ: "队伍索引",
  T_46_META_WS_P_TEMPLATEENTITY: "生成的单位实体的模板",
  T_46_META_WS_P_TEMPORARYSHIELDPOINTS: "临时护盾值",
  T_46_META_WS_P_TERRAINWETNESS: "地面湿度",
  T_46_META_WS_P_TEXT: "提示文字",
  T_46_META_WS_P_TEXTCOLOR: "提示文字颜色",
  T_46_META_WS_P_TEXTKEY: "文本key",
  T_46_META_WS_P_TEXTKEYPARAMS: "文本key对应的参数",
  T_46_META_WS_P_TEXTURERESOURCE: "Texture名称",
  T_46_META_WS_P_THEMECOLOR: "主题颜色",
  T_46_META_WS_P_THROWABLETYPE: "投掷物类型",
  T_46_META_WS_P_THROWINGSPEED: "投掷速度",
  T_46_META_WS_P_THROWSPEED: "钩锁飞行速度",
  T_46_META_WS_P_TICKINTERVAL: "刷新间隔",
  T_46_META_WS_P_TIMEREQUIRED: "使用所需时间 (ms)",
  T_46_META_WS_P_TIPSTYPE: "飘字提示类型",
  T_46_META_WS_P_TITLE: "标题文本",
  T_46_META_WS_P_TITLELIST: "标题列表",
  T_46_META_WS_P_TITLES: "标题列表",
  T_46_META_WS_P_TOP: "上身服饰",
  T_46_META_WS_P_TOPALPHA: "顶部透明度",
  T_46_META_WS_P_TOTALHP: "生命值总量",
  T_46_META_WS_P_TOTALLEVEL: "总等级数",
  T_46_META_WS_P_TOTALROUNDCOUNT: "游戏总回合数",
  T_46_META_WS_P_TOWSPEED: "牵引玩家速度",
  T_46_META_WS_P_TRANSITIONSTAGE: "切换阶段",
  T_46_META_WS_P_TRANSITIONTYPE: "Transition Type",
  T_46_META_WS_P_TRIGGERPLAYERID: "触发的实体ID",
  T_46_META_WS_P_TRIGGERRADIUS: "触发范围",
  T_46_META_WS_P_TRIGGERRANGE: "触发范围",
  T_46_META_WS_P_TRIGGERTIME: "触发时间",
  T_46_META_WS_P_TURNSPEED: "转弯速度（每秒度）",
  T_46_META_WS_P_TWEENERENABLED: "是否启用UITweener脚本",
  T_46_META_WS_P_TWEENSTYLE: "播放方式",
  T_46_META_WS_P_TYPE: "类型",
  T_46_META_WS_P_UNSELECTEDCOLOR: "未选中图片颜色",
  T_46_META_WS_P_UNSELECTEDSPRITE: "未选中图片",
  T_46_META_WS_P_UNSELECTEDTYPE: "未选中图片填充类型",
  T_46_META_WS_P_UP: "上方",
  T_46_META_WS_P_UPDATETYPE: "更新类型",
  T_46_META_WS_P_UPENERGYCOST: "每秒向上能量消耗",
  T_46_META_WS_P_UPSPEED: "上升速度（力）",
  T_46_META_WS_P_USECUSTOMPUSHFORCE: "是否使用自定义推力大小",
  T_46_META_WS_P_USECUSTOMRESOURCE: "是否使用自定义资源",
  T_46_META_WS_P_USEDCAPACITY: "已占用空间",
  T_46_META_WS_P_USEGRAVITY: "是否受重力",
  T_46_META_WS_P_USEPHYSICALCCT: "使用带物理效果的CCT",
  T_46_META_WS_P_USERUID: "UserUID",
  T_46_META_WS_P_UVOFFSET: "UV偏移量",
  T_46_META_WS_P_UVSIZE: "UV宽高",
  T_46_META_WS_P_VALUE: "值[0, 1]",
  T_46_META_WS_P_VAULTDISTANCE: "翻越距离",
  T_46_META_WS_P_VAULTHEIGHT: "翻越高度",
  T_46_META_WS_P_VEHICLEDAMAGEFACTOR: "车辆伤害系数",
  T_46_META_WS_P_VEHICLESKINID: "车皮ID",
  T_46_META_WS_P_VEHICLESKINIDS: "车皮ID",
  T_46_META_WS_P_VELOCITY: "线速度（m/s)",
  T_46_META_WS_P_VELOCITYXZ: "XZ轴速度",
  T_46_META_WS_P_VELOCITYY: "Y轴速度",
  T_46_META_WS_P_VERTICALBAR: "垂直显示类型",
  T_46_META_WS_P_VERTICALOFFSET: "垂直方向偏移量",
  T_46_META_WS_P_VEST: "当前防弹衣",
  T_46_META_WS_P_VFXTEXTURETYPE: "特效贴图类型",
  T_46_META_WS_P_VIEWINGANGLERESTRICTION: "视角限制",
  T_46_META_WS_P_VISIBILITYLAYER: "可见层级（0~15）",
  T_46_META_WS_P_VISIBLE: "是否可见",
  T_46_META_WS_P_VISIBLEONBACK: "背在身上是否显示",
  T_46_META_WS_P_VISIBLEPLAYERS: "玩家实体列表 可见属性",
  T_46_META_WS_P_VOLUME: "音量",
  T_46_META_WS_P_WALLETID: "绑定的钱包实体ID",
  T_46_META_WS_P_WANDERRANGE: "游荡距离",
  T_46_META_WS_P_WAVECOUNT: "波数",
  T_46_META_WS_P_WAVEINTERVAL: "间隔时间",
  T_46_META_WS_P_WEAPONDAMAGERATE: "伤害倍率",
  T_46_META_WS_P_WEAPONSKINIDS: "玩家枪皮",
  T_46_META_WS_P_WEAPONSUBTYPE: "武器子类型",
  T_46_META_WS_P_WEAPONTYPE: "武器类型",
  T_46_META_WS_P_WIDTH: "宽度",
  T_46_META_WS_P_WINMVPS: "获胜MVP列表",
  T_46_META_WS_P_WINTEXT: "胜利提示文本",
  T_46_META_WS_P_WORDWRAP: "自动换行",
  T_46_META_WS_P_WORLDPOSITION: "世界坐标",
  T_46_META_WS_P_YAW: "水平角",
  T_46_META_WS_PATROLALONG: "巡逻",
  T_46_META_WS_PATROLTO: "巡逻至",
  T_46_META_WS_PAUSE: "暂停",
  T_46_META_WS_PAUSEEMOTE: "暂停动作",
  T_46_META_WS_PAUSEFIXEDUPDATE: "暂停固定帧更新",
  T_46_META_WS_PHASE: "阶段",
  T_46_META_WS_PLAY: "播放",
  T_46_META_WS_PLAYANIMATION: "播放动画",
  T_46_META_WS_PLAYCHARACTERANIMATIONCLIP: "播放角色动画片段",
  T_46_META_WS_PLAYEMOTE: "播放Emote",
  T_46_META_WS_PLAYER: "玩家",
  T_46_META_WS_PORTAL: "使用的传送门",
  T_46_META_WS_POSE: "姿态",
  T_46_META_WS_POSITION: "位置",
  T_46_META_WS_PREPOSE: "姿态",
  T_46_META_WS_PROFANITYFILTER: "脏字过滤",
  T_46_META_WS_PURSUITTARGET: "追击目标",
  T_46_META_WS_QUATERNIONTOAXISANGLE: "四元数转轴角",
  T_46_META_WS_QUATERNIONTOEULERANGLE: "四元数转欧拉角",
  T_46_META_WS_QUITCHATCHANNEL: "玩家退出频道",
  T_46_META_WS_QUITFACTION: "退出阵营",
  T_46_META_WS_QUITGAME: "退出游戏",
  T_46_META_WS_QUITJAILBREAKMINIGAME: "QuitJailBreakMiniGame",
  T_46_META_WS_RANDOMFLOAT: "随机小数",
  T_46_META_WS_RANDOMINT: "随机整数",
  T_46_META_WS_RANK: "排名",
  T_46_META_WS_READCSV: "读取表",
  T_46_META_WS_READCSVCELL: "读取表某一单元格的内容",
  T_46_META_WS_READCSVCELLBYNAME: "通过行数和列名读取表某一单元格的内容",
  T_46_META_WS_READCSVCELLFROMSERVER: "读取服务器表某一单元格的内容",
  T_46_META_WS_READCSVCOLUMN: "读取表的某一列",
  T_46_META_WS_READCSVCOLUMNFROMSERVER: "读取服务器表的某一列",
  T_46_META_WS_READCSVFROMSERVER: "读取服务器表内容",
  T_46_META_WS_READCSVROW: "读取表的某一行",
  T_46_META_WS_READCSVROWBYKEY: "获取目标值所在行",
  T_46_META_WS_READCSVROWFROMSERVER: "读取服务器表的某一行",
  T_46_META_WS_READFROMACCUMULATEDDATASTORE: "读取累计数据库表值",
  T_46_META_WS_READFROMDATASTORE: "读取数据库表值",
  T_46_META_WS_READFROMLEADBOARDDATASTORE: "读取数据库中排行榜表值",
  T_46_META_WS_READFROMLEADBOARDDATASTOREBYRANK: "根据名次区间读取数据库中排行榜表值",
  T_46_META_WS_REMOVEAOISPECIALFOLLOW: "移除AOI特别关注",
  T_46_META_WS_REMOVEBACKPACKSKIN: "去除背包皮肤",
  T_46_META_WS_REMOVEBUFF: "移除buff",
  T_46_META_WS_REMOVECOMPONENT: "移除组件",
  T_46_META_WS_REMOVEFORMULAPROPERTYFACTOR: "移除单个公式化属性因子",
  T_46_META_WS_REMOVEOUTFIT: "去除服装",
  T_46_META_WS_REMOVESCRIPT: "移除脚本",
  T_46_META_WS_REMOVEVEHICLESKIN: "去除车皮",
  T_46_META_WS_REMOVEWEAPONSKIN: "去除枪皮",
  T_46_META_WS_REPLACE: "字符串替换",
  T_46_META_WS_REQUESTMATCHMAKING: "请求匹配",
  T_46_META_WS_RESET: "重置",
  T_46_META_WS_RESETBACKPACKSKIN: "恢复背包皮肤",
  T_46_META_WS_RESETDYEING: "重置染色",
  T_46_META_WS_RESETJERSEY: "清除球衣",
  T_46_META_WS_RESETOUTFIT: "恢复默认服装",
  T_46_META_WS_RESETVEHICLESKIN: "恢复默认车皮",
  T_46_META_WS_RESETWEAPONSKIN: "恢复默认枪皮",
  T_46_META_WS_RESUMEFIXEDUPDATE: "恢复固定帧更新",
  T_46_META_WS_REVERSE: "列表返转",
  T_46_META_WS_REVIVALSOURCE: "复活来源",
  T_46_META_WS_REVIVE: "复活",
  T_46_META_WS_ROUND: "四舍五入",
  T_46_META_WS_ROUNDINDEX: "回合索引",
  T_46_META_WS_SAMPLEONCURVE: "在Curve上采样",
  T_46_META_WS_SCENENAME: "场景名字",
  T_46_META_WS_SCORE: "积分",
  T_46_META_WS_SCORER: "最近一次触球者",
  T_46_META_WS_SCORETYPE: "积分类型",
  T_46_META_WS_SCREENMULTIRAYCAST: "屏幕触控多返回射线检测",
  T_46_META_WS_SCREENSINGLERAYCAST: "屏幕触控单返回射线检测",
  T_46_META_WS_SCREENTOUCHRAY: "通过屏幕触控获得射线",
  T_46_META_WS_SCREENTOWORLDPOINT: "屏幕坐标转世界坐标",
  T_46_META_WS_SENDEVENT: "发送玩家自定义事件",
  T_46_META_WS_SETACTIVE: "设置活动状态",
  T_46_META_WS_SETALLPLAYERSMOVESTATUS: "设置玩家是否可以移动",
  T_46_META_WS_SETATTACKABLEENTITY: "设置实体的可攻击目标",
  T_46_META_WS_SETATTACKABLEFACTION: "设置阵营的可攻击目标",
  T_46_META_WS_SETATTACKABLETEAM: "设置队伍的可攻击目标",
  T_46_META_WS_SETBACKPACKSKIN: "设置背包皮肤",
  T_46_META_WS_SETBEHAVIORSTATUS: "设置行为状态",
  T_46_META_WS_SETBLACKBOARDVALUE: "设置黑板变量",
  T_46_META_WS_SETBUNDLE: "设置套装",
  T_46_META_WS_SETCAMERAFOCUS: "相机注视目标",
  T_46_META_WS_SETCAMERAFOLLOW: "相机跟随目标",
  T_46_META_WS_SETCHARACTER: "设置角色",
  T_46_META_WS_SETCULLINGMASK: "设置相机层遮罩",
  T_46_META_WS_SETCULLINGMASKLAYER: "设置相机的渲染层遮罩",
  T_46_META_WS_SETDEFAULTUISTATUS: "设置默认界面状态",
  T_46_META_WS_SETDROPSTATUS: "设置丢弃状态",
  T_46_META_WS_SETFALLINGDAMAGE: "设置坠落伤害",
  T_46_META_WS_SETFOOTBALLPOSITION: "设置足球位置",
  T_46_META_WS_SETFORMULAPROPERTYABSOLUTE: "设置公式化属性",
  T_46_META_WS_SETFORMULAPROPERTYRELATIVE: "修改公式化属性",
  T_46_META_WS_SETFORWARD: "设置朝向",
  T_46_META_WS_SETGLOBALSLEEPTHRESHOLD: "设置全局休眠阈值",
  T_46_META_WS_SETINVINCIBILITY: "设置无敌状态",
  T_46_META_WS_SETJERSEY: "替换球衣",
  T_46_META_WS_SETOUTFIT: "设置服装",
  T_46_META_WS_SETPARENT: "设置父节点",
  T_46_META_WS_SETPARENTCLIENT: "设置物件实体的父节点",
  T_46_META_WS_SETPICKUPSTATUS: "设置拾取状态",
  T_46_META_WS_SETPLAYERQUICKMESSAGESTATUS: "设置玩家快捷聊天状态",
  T_46_META_WS_SETPLAYERVOICESTATUS: "设置玩家语音聊天状态",
  T_46_META_WS_SETPROPERTYSMOOTHLY: "设置实体属性（平滑）",
  T_46_META_WS_SETSKILLS: "设置技能",
  T_46_META_WS_SETSKYBOX: "设置天空盒",
  T_46_META_WS_SETSLEEPTHRESHOLD: "设置休眠阈值",
  T_46_META_WS_SETSPECIALITEMSTATUS: "设置特殊物品状态",
  T_46_META_WS_SETVEHICLESKIN: "设置车皮",
  T_46_META_WS_SETWEAPONSKIN: "设定枪皮",
  T_46_META_WS_SETWIDGETPARENT: "设置控件的父节点",
  T_46_META_WS_SHOPITEM: "商品",
  T_46_META_WS_SHOWAPPEARANCEGROUP: "显示外观组",
  T_46_META_WS_SHUFFLE: "列表打乱",
  T_46_META_WS_SIN: "Sin",
  T_46_META_WS_SINGLERAYCAST: "单次射线检测",
  T_46_META_WS_SKILL: "技能",
  T_46_META_WS_SLEEP: "强制休眠",
  T_46_META_WS_SLERPQUATERNION: "四元数插值",
  T_46_META_WS_SPAWNABLES: "单位实体列表",
  T_46_META_WS_SPAWNEDITEM: "后创建实体",
  T_46_META_WS_SPAWNNEXTWAVE: "刷新下一波",
  T_46_META_WS_SPHERECAST: "球形检测",
  T_46_META_WS_SPHEREOVERLAP: "球形重叠检测",
  T_46_META_WS_SPLIT: "字符串切割",
  T_46_META_WS_SQRT: "平方根",
  T_46_META_WS_STARTPARACHUTE: "开启跳伞",
  T_46_META_WS_STARTPOSITION: "位置",
  T_46_META_WS_STATENAME: "状态名字",
  T_46_META_WS_STATUS: "状态",
  T_46_META_WS_STRINGTOFLOAT: "字符串转浮点数",
  T_46_META_WS_STRINGTOINT: "字符串转整型",
  T_46_META_WS_STRIP: "移除字符串两侧空白字符",
  T_46_META_WS_SUB: "字符串截取",
  T_46_META_WS_SWITCHAOIPROXYOBSERVER: "切换AOI代理观察者",
  T_46_META_WS_SWITCHAPPEARANCEGROUP: "切换外观组",
  T_46_META_WS_SWITCHAREA: "切换玩家区域",
  T_46_META_WS_SWITCHCAMERA: "切换相机",
  T_46_META_WS_SWITCHPHASE: "切换游戏阶段",
  T_46_META_WS_SWITCHSCENE: "切换场景",
  T_46_META_WS_SWITCHWEAPON: "切换玩家武器",
  T_46_META_WS_TAN: "Tan",
  T_46_META_WS_TARGET: "目标",
  T_46_META_WS_TEAM: "队伍",
  T_46_META_WS_TELEPORT: "传送",
  T_46_META_WS_TELEPORTCCT: "将角色控制器强制移动到某位置",
  T_46_META_WS_TEXT: "文本内容",
  "T_46_META_WS_TIMESTAMPTO LOCALSTRING": "时间戳本地化字符串",
  T_46_META_WS_TIRE: "使用的弹跳物件",
  T_46_META_WS_TOLOWER: "转换小写",
  T_46_META_WS_TOSTRING: "转字符串",
  T_46_META_WS_TOUPPER: "转换大写",
  T_46_META_WS_TRANSFERMONEY: "交易货币",
  T_46_META_WS_TRIGGER: "触发器",
  T_46_META_WS_TYPEIS: "是否类型一致",
  T_46_META_WS_UNLOADSCENE: "卸载场景",
  T_46_META_WS_UPDATEJAILBREAKMISSION: "UpdateJailBreakMission",
  T_46_META_WS_UPLOADGAMERESULT: "上传游戏结算信息",
  T_46_META_WS_VALUE: "伤害量",
  T_46_META_WS_VECTOR2ANGLE: "二维向量夹角",
  T_46_META_WS_VECTOR2DISTANCE: "二维向量距离",
  T_46_META_WS_VECTOR2DOT: "二维向量点积",
  T_46_META_WS_VECTOR2MAGNITUDE: "二维向量大小",
  T_46_META_WS_VECTOR2NORMALIZE: "二维向量归一化",
  T_46_META_WS_VECTOR2REFLECT: "二维向量反射",
  T_46_META_WS_VECTOR2TOVECTOR3: "二维向量转三维向量",
  T_46_META_WS_VECTOR3REFLECT: "三维向量反射",
  T_46_META_WS_VECTOR3TOVECTOR2: "三维向量转二维向量",
  T_46_META_WS_VEHICLE: "进入的载具",
  T_46_META_WS_VELOCITY: "速度",
  T_46_META_WS_WAITFORMILESECOND: "等待",
  T_46_META_WS_WAITFORNEXTFRAME: "等待直到下一帧",
  T_46_META_WS_WAKEUP: "唤醒刚体",
  T_46_META_WS_WAVES: "波数",
  T_46_META_WS_WEAPON: "武器",
  T_46_META_WS_WORLDTOSCREENPOINT: "世界坐标转屏幕坐标",
  T_46_META_WS_WRITETOACCUMULATEDDATASTORE: "写入累计数据库表偏移值",
  T_46_META_WS_WRITETODATASTORE: "写入数据库表值",
  T_46_META_WS_WRITETOLEADBOARDDATASTORE: "写入数据库中排行榜表值",
  T_48_META_API_1_D: "获取当前游戏中所有玩家，返回玩家列表。",
  T_48_META_API_1_R_D: "玩家列表",
  T_48_META_API_10_D: "获取场景物件",
  T_48_META_API_10_P0_D: "筛选何种类型的场景物件",
  T_48_META_API_10_R_D: "场景物件列表",
  T_48_META_API_100_D: "加载场景，不会自动卸载已经加载的场景",
  T_48_META_API_100_P0_D: "要加载的场景ID",
  T_48_META_API_10000_D: "返回当前脚本绑定的实体",
  T_48_META_API_10000_R_D: "当前脚本绑定的实体",
  T_48_META_API_10001_D: "使用实体ID查找对应的实体，该API仅限编辑器使用，用户侧使用该API无法保证它的兼容性，比如移除或者调整",
  T_48_META_API_10001_P0_D: "目标实体ID",
  T_48_META_API_10001_R_D: "实体",
  T_48_META_API_10002_D: "获取该局游戏全局实体",
  T_48_META_API_10002_R_D: "全局实体",
  T_48_META_API_10003_D: "把玩家传送到具体坐标（已废弃，请使用Teleport）",
  T_48_META_API_10003_P0_D: "被传送的玩家",
  T_48_META_API_10003_P1_D: "被传送点的坐标",
  T_48_META_API_10004_D: "获得队友附近位置，会规避开无法站立玩家的位置（已废弃，请使用GetTeammateNearPosition）",
  T_48_META_API_10004_P0_D: "目标玩家",
  T_48_META_API_10004_R_D: "队友附近坐标",
  T_48_META_API_10005_D: "获得实体的所属玩家",
  T_48_META_API_10005_P0_D: "目标实体，实体只会和所属玩家进行同步",
  T_48_META_API_10005_R_D: "目标实体的所属玩家",
  T_48_META_API_10006_D: "将玩家设为无敌状态",
  T_48_META_API_10006_P0_D: "目标玩家",
  T_48_META_API_10006_P1_D: "无敌效果持续时长，单位秒",
  T_48_META_API_10007_D: "在原位置克隆选中的实体及其所有属性",
  T_48_META_API_10007_P0_D: "创建的实体",
  T_48_META_API_10007_P1_D: "待克隆的实体",
  T_48_META_API_10008_D: "对玩家造成伤害，若不选择伤害来源，则目标受到来自系统的伤害",
  T_48_META_API_10008_P0_D: "受到伤害的游戏实体",
  T_48_META_API_10008_P1_D: "造成伤害的游戏实体",
  T_48_META_API_10008_P2_D: "伤害类型",
  T_48_META_API_10008_P3_D: "伤害量",
  T_48_META_API_10009_D: "复活指定玩家",
  T_48_META_API_10009_P0_D: "被复活的玩家",
  T_48_META_API_1001_D: "满足条件则运行IF下的节点。不满足条件时，若有ELSE则运行ELSE下方节点，否则结束IF语句。",
  T_48_META_API_1001_P0_D: "条件列表需和子过程列表（逻辑分支列表）数量保持一致",
  T_48_META_API_10010_D: "在指定位置创建物品或物品列表。",
  T_48_META_API_10010_P0_D: "物品创建位置",
  T_48_META_API_10010_P1_D: "创建的物品或物品列表",
  T_48_META_API_10010_P2_D: "创建的物品数量，创建物品列表时需要填入与物品列表顺序对应物品数量列表",
  T_48_META_API_10011_D: "AI实体向目标点巡逻",
  T_48_META_API_10011_P0_D: "目标AI实体",
  T_48_META_API_10011_P1_D: "移动的目标点",
  T_48_META_API_10011_P2_D: "是否返回出发点",
  T_48_META_API_10011_P3_D: "巡逻时是否检测并攻击敌对目标",
  T_48_META_API_10012_D: "AI实体按照坐标列表顺序依次巡逻",
  T_48_META_API_10012_P0_D: "目标AI实体",
  T_48_META_API_10012_P1_D: "移动的坐标点列表",
  T_48_META_API_10012_P2_D: "巡逻类型，可以选择单次、往返循环或循环",
  T_48_META_API_10012_P3_D: "巡逻时是否检测并攻击敌对目标",
  T_48_META_API_10013_D: "生成器立刻刷新下一波单位实体",
  T_48_META_API_10013_P0_D: "生成器实体",
  T_48_META_API_10014_D: "增加可计算属性计算因子，可计算属性将会通过因子组成的公式运算出最终结果",
  T_48_META_API_10014_P0_D: "目标实体",
  T_48_META_API_10014_P1_D: "可计算属性类型",
  T_48_META_API_10014_P2_D: "计算因子类型",
  T_48_META_API_10014_P3_D: "计算因子值",
  T_48_META_API_10015_D: "清除可计算属性的计算因子",
  T_48_META_API_10015_P0_D: "目标实体",
  T_48_META_API_10015_P1_D: "可计算属性类型",
  T_48_META_API_10016_D: "清除目标实体所有可计算属性的所有计算因子",
  T_48_META_API_10016_P0_D: "目标实体",
  T_48_META_API_10017_D: "修改属性",
  T_48_META_API_10017_P0_D: "目标实体",
  T_48_META_API_10017_P1_D: "属性类型",
  T_48_META_API_10017_P2_D: "修改方式",
  T_48_META_API_10017_P3_D: "值",
  T_48_META_API_10018_D: "设置可计算属性的值",
  T_48_META_API_10018_P0_D: "目标实体",
  T_48_META_API_10018_P1_D: "属性类型",
  T_48_META_API_10018_P2_D: "值",
  T_48_META_API_10019_D: "清除单个可计算属性修改",
  T_48_META_API_10019_P0_D: "目标实体",
  T_48_META_API_10019_P1_D: "属性类型",
  T_48_META_API_1002_D: "参数i从最小值开始，每运行一次下方节点则i增加步进值，直到i大于等于最大值。",
  T_48_META_API_1002_P0_D: "循环索引的名称，可以使用它获取到局部变量上的循环索引值",
  T_48_META_API_1002_P1_D: "循环初始值",
  T_48_META_API_1002_P2_D: "循环结束值",
  T_48_META_API_1002_P3_D: "循环步长，当起始值小于结束值时，步长应大于0；当起始值大于结束值时，步长应小于0",
  T_48_META_API_10020_D: "获取游戏中全部符合筛选条件的实体",
  T_48_META_API_10020_P0_D: "筛选结果必须包含这个参数内输入的类型",
  T_48_META_API_10020_P1_D: "筛选结果必须不包含这个参数内输入的类型",
  T_48_META_API_10020_P2_D: "筛选结果至少包含这个参数内输入的类型之一",
  T_48_META_API_10020_R_D: "筛选结果实体列表",
  T_48_META_API_10021_D: "为足球增加一个速度，速度会受同方向加速度的影响而变化",
  T_48_META_API_10021_P0_D: "目标足球",
  T_48_META_API_10021_P1_D: "添加的三维空间速度",
  T_48_META_API_10022_D: "销毁指定实体",
  T_48_META_API_10022_P0_D: "要销毁的目标实体",
  T_48_META_API_10023_D: "为实体添加标签",
  T_48_META_API_10023_P0_D: "目标实体",
  T_48_META_API_10023_P1_D: "自定义标签",
  T_48_META_API_10024_D: "为实体移除标签",
  T_48_META_API_10024_P0_D: "目标实体",
  T_48_META_API_10024_P1_D: "自定义标签",
  T_48_META_API_10025_D: "判断目标实体是否包含指定的标签",
  T_48_META_API_10025_P0_D: "目标实体",
  T_48_META_API_10025_P1_D: "自定义标签",
  T_48_META_API_10025_R_D: "是否包含指定标签",
  T_48_META_API_10026_D: "设置足球位置",
  T_48_META_API_10026_P0_D: "足球实体",
  T_48_META_API_10026_P1_D: "位置",
  T_48_META_API_10026_P2_D: "保持速度",
  T_48_META_API_10027_D: "获取目标玩家当前使用的摄像机实体",
  T_48_META_API_10027_P0_D: "目标玩家",
  T_48_META_API_10027_R_D: "当前使用的摄像机实体",
  T_48_META_API_10028_D: "将目标玩家的相机切换为目标相机，",
  T_48_META_API_10028_P0_D: "目标玩家",
  T_48_META_API_10028_P1_D: "目标相机",
  T_48_META_API_10028_P2_D: "切换方式，可以选择保持原逻辑或渐进",
  T_48_META_API_10028_P3_D: "切换时间是渐进模式下切换相机的时间",
  T_48_META_API_10029_D: "创建一个相机",
  T_48_META_API_10029_P0_D: "创建的相机类型",
  T_48_META_API_10029_P1_D: "创建出的相机实体",
  T_48_META_API_1003_D: "实现对一个数据容器的遍历，获取到每一个子元素，含有子过程，循环体就是子过程",
  T_48_META_API_1003_P0_D: "遍历到子元素的名称，可以使用它获取到局部变量上的子元素值",
  T_48_META_API_1003_P1_D: "循环索引的名称，可以使用它获取到局部变量上的循环索引值",
  T_48_META_API_1003_P2_D: "要遍历的数据容器，目前支持以下类型：数组类型",
  T_48_META_API_10030_D: "杀死可战斗实体",
  T_48_META_API_10030_P0_D: "目标实体，必须为可战斗实体",
  T_48_META_API_10031_D: "设置目标实体及其子节点的活动状态，不活动的物体的可用性、可见性、碰撞等均会关闭",
  T_48_META_API_10031_P0_D: "目标实体",
  T_48_META_API_10031_P1_D: "是否为活动状态",
  T_48_META_API_10032_D: "设置相机实体的位置始终跟随目标实体",
  T_48_META_API_10032_P0_D: "目标相机实体",
  T_48_META_API_10032_P1_D: "要跟随的目标实体",
  T_48_META_API_10032_P2_D: "距离目标实体坐标的偏移量",
  T_48_META_API_10032_P3_D: "偏移量的坐标系",
  T_48_META_API_10033_D: "设置相机实体始终朝向目标实体",
  T_48_META_API_10033_P0_D: "目标相机实体",
  T_48_META_API_10033_P1_D: "目标实体",
  T_48_META_API_10033_P2_D: "注视点距离目标坐标的偏移量",
  T_48_META_API_10033_P3_D: "偏移量的坐标系",
  T_48_META_API_10034_D: "创建Tween",
  T_48_META_API_10034_P0_D: "目标实体",
  T_48_META_API_10034_P1_D: "属性ID",
  T_48_META_API_10034_P2_D: "SrcVal",
  T_48_META_API_10034_P3_D: "DestVal",
  T_48_META_API_10034_P4_D: "Style",
  T_48_META_API_10034_P5_D: "Curve",
  T_48_META_API_10034_P6_D: "Duration",
  T_48_META_API_10034_P7_D: "tween实体",
  T_48_META_API_10035_D: "设置父节点，要求父子都具有Transform组件",
  T_48_META_API_10035_P0_D: "父节点",
  T_48_META_API_10035_P1_D: "子节点",
  T_48_META_API_10035_P2_D: "是否保留子节点当前世界位置、旋转和缩放，设置UI时该项无效",
  T_48_META_API_10036_D: "NewCurve（已废弃，请使用CreateTweenCurve）",
  T_48_META_API_10036_P0_D: "ControlPoints",
  T_48_META_API_10036_R_D: "TwennCurveEntity",
  T_48_META_API_10037_D: "尝试播放目标实体，目标实体必须具有可播放组件",
  T_48_META_API_10037_P0_D: "目标可播放实体",
  T_48_META_API_10037_P1_D: `是否重新播放
真：重新播放
假：继续播放`,
  T_48_META_API_10038_D: "暂停可播放实体",
  T_48_META_API_10038_P0_D: "目标可播放实体",
  T_48_META_API_10039_D: "创建弹道运动，会给予目标实体带有方向的初速度与加速度",
  T_48_META_API_10039_P0_D: "目标实体",
  T_48_META_API_10039_P1_D: "运动初速度",
  T_48_META_API_10039_P2_D: "运动加速度",
  T_48_META_API_10039_P3_D: "最大位移距离",
  T_48_META_API_10039_P4_D: "创建的弹道运动实体",
  T_48_META_API_10039_P5_D: "创建后是否自动开始播放",
  T_48_META_API_1004_D: "打断当前循环过程，退出循环",
  T_48_META_API_10040_D: "创建位置跟随运动，目标实体会跟随指定对象运动",
  T_48_META_API_10040_P0_D: "目标实体",
  T_48_META_API_10040_P1_D: "跟随运动的对象实体",
  T_48_META_API_10040_P2_D: "距离跟随目标坐标的偏移量",
  T_48_META_API_10040_P3_D: "使用的坐标系",
  T_48_META_API_10040_P4_D: "创建的跟随运动实体",
  T_48_META_API_10040_P5_D: "创建后是否自动开始播放",
  T_48_META_API_10041_D: "创建注视跟随运动，目标实体会保持朝向指定对象",
  T_48_META_API_10041_P0_D: "目标实体",
  T_48_META_API_10041_P1_D: "注视的对象实体",
  T_48_META_API_10041_P2_D: "注视点距离对象实体的偏移量",
  T_48_META_API_10041_P3_D: "使用的坐标系",
  T_48_META_API_10041_P4_D: "创建的注视跟随运动实体",
  T_48_META_API_10041_P5_D: "创建后是否自动开始播放",
  T_48_META_API_10042_D: "已废弃",
  T_48_META_API_10042_P0_D: "玩家实体",
  T_48_META_API_10042_P1_D: "比赛结果",
  T_48_META_API_10042_P2_D: "已废弃",
  T_48_META_API_10042_P3_D: "已废弃",
  T_48_META_API_10042_P4_D: "已废弃",
  T_48_META_API_10043_D: "平滑设置目标实体的属性，属性会立刻改变，但是客户端会播放一个平滑过渡表现",
  T_48_META_API_10043_P0_D: "目标实体",
  T_48_META_API_10043_P1_D: "目标实体的某个属性",
  T_48_META_API_10043_P2_D: "目标值，需要符合属性定义时要求的类型",
  T_48_META_API_10044_D: "进行一次射线检测，返回射线方向上命中的第一个实体，命中实体需要有碰撞组件，层级参若填空，则可以检测到地形",
  T_48_META_API_10044_P0_D: "开始位置坐标",
  T_48_META_API_10044_P1_D: "射线检测方向",
  T_48_META_API_10044_P2_D: "射线检测距离，只接受正值",
  T_48_META_API_10044_P3_D: "射线检测层遮罩，只有填入的层级会参与扫描，留空代表所有层级都参与扫描",
  T_48_META_API_10044_P4_D: "是否可以扫描出触发器",
  T_48_META_API_10044_P5_D: "命中实体",
  T_48_META_API_10044_P6_D: "命中点坐标",
  T_48_META_API_10044_P7_D: "命中点距离开始点距离",
  T_48_META_API_10044_P8_D: "命中表面法线",
  T_48_META_API_10045_D: "进行一次射线检测，从近到远地返回射线方向上命中的所有实体，层级参若填空，则可以检测到地形",
  T_48_META_API_10045_P0_D: "开始位置坐标",
  T_48_META_API_10045_P1_D: "射线检测方向",
  T_48_META_API_10045_P2_D: "射线检测距离，只接受正值",
  T_48_META_API_10045_P3_D: "层遮罩，只有填入的层级会参与扫描，留空代表所有层级都参与扫描",
  T_48_META_API_10045_P4_D: "是否可以检测出触发器",
  T_48_META_API_10045_P5_D: "命中的实体列表",
  T_48_META_API_10045_P6_D: "命中点列表",
  T_48_META_API_10045_P7_D: "命中点距离开始点距离列表",
  T_48_META_API_10045_P8_D: "命中表面法线",
  T_48_META_API_10046_D: "使用预制体为模板创建实体",
  T_48_META_API_10046_P0_D: "创建的实体",
  T_48_META_API_10046_P1_D: "预制体ID",
  T_48_META_API_10047_D: "染色",
  T_48_META_API_10047_P0_D: "设置物件法线",
  T_48_META_API_10047_P1_D: "设置染色点",
  T_48_META_API_10047_P2_D: "颜色",
  T_48_META_API_10048_D: "染色状态",
  T_48_META_API_10048_P0_D: "设置染色点",
  T_48_META_API_10048_P1_D: "设置方向",
  T_48_META_API_10048_P2_D: "设置距离",
  T_48_META_API_10048_R_D: "ColorDesc",
  T_48_META_API_10049_D: "染色统计",
  T_48_META_API_10049_P0_D: "颜色",
  T_48_META_API_10049_R_D: "染色数量",
  T_48_META_API_1005_D: "跳过剩余的循环体内容，直接进入下一次循环",
  T_48_META_API_10050_D: "平面范围染色",
  T_48_META_API_10050_P0_D: "设置物件法线",
  T_48_META_API_10050_P1_D: "设置染色点",
  T_48_META_API_10050_P2_D: "设置染色范围",
  T_48_META_API_10050_P3_D: "颜色",
  T_48_META_API_10050_P4_D: "染色数量",
  T_48_META_API_10051_D: "区域染色",
  T_48_META_API_10051_P0_D: "设置物件法线",
  T_48_META_API_10051_P1_D: "设置染色点",
  T_48_META_API_10051_P2_D: "设置染色范围",
  T_48_META_API_10051_P3_D: "颜色",
  T_48_META_API_10051_P4_D: "固定染色区域",
  T_48_META_API_10051_P5_D: "随机系数",
  T_48_META_API_10051_P6_D: "随机衰减系数",
  T_48_META_API_10051_P7_D: "染色数量",
  T_48_META_API_10052_D: "获取目标父节点实体的所有子节点",
  T_48_META_API_10052_P0_D: "父节点实体",
  T_48_META_API_10052_R_D: "子节点列表",
  T_48_META_API_10053_D: "根据索引获取目标父节点实体的指定子节点",
  T_48_META_API_10053_P0_D: "父节点实体",
  T_48_META_API_10053_P1_D: "子节点索引",
  T_48_META_API_10053_R_D: "子节点实体",
  T_48_META_API_10054_D: "获取目标子节点实体的父节点",
  T_48_META_API_10054_P0_D: "子节点实体",
  T_48_META_API_10054_R_D: "父节点实体",
  T_48_META_API_10055_D: "删除指定父节点实体下的所有子节点，节点必须具有Transform组件",
  T_48_META_API_10055_P0_D: "父节点实体",
  T_48_META_API_10056_D: "将目标传送至指定位置",
  T_48_META_API_10056_P0_D: "被传送的单位",
  T_48_META_API_10056_P1_D: "传送点坐标",
  T_48_META_API_10056_P2_D: "传送后单位朝向",
  T_48_META_API_10057_D: "获得随机队友附近位置，没有队友时返回自身附近的坐标，会规避开无法站立玩家的位",
  T_48_META_API_10057_P0_D: "目标玩家",
  T_48_META_API_10057_R_D: "目标玩家队友附近的坐标",
  T_48_META_API_10058_D: "清除染色状态",
  T_48_META_API_10059_D: "播放指定的音效，有更多需要设置的属性时则通过实体进一步设置它的实体属性",
  T_48_META_API_10059_P0_D: "代码中是用来表示创建音效实体的形参名称，其对应的局部变量值是创建音效的实体",
  T_48_META_API_10059_P1_D: "所属的玩家实体，只有该玩家可见",
  T_48_META_API_10059_P2_D: "音效类型，玩家可以选择的音效种类",
  T_48_META_API_1006_D: "结束当前执行过程，直接返回调用位置，可以携带数据一并返回",
  T_48_META_API_1006_P0_D: "希望返回给调用位置的数据",
  T_48_META_API_10060_D: "将目标玩家踢出游戏",
  T_48_META_API_10060_P0_D: "目标玩家",
  T_48_META_API_10060_P1_D: "是否显示结算信息",
  T_48_META_API_10061_D: "目标玩家请求匹配指定地图",
  T_48_META_API_10061_P0_D: "目标玩家",
  T_48_META_API_10061_P1_D: "战场码",
  T_48_META_API_10061_P2_D: "取消匹配时是否弹窗提示重回原游戏",
  T_48_META_API_10062_D: "中断播放中的音效实体",
  T_48_META_API_10062_P0_D: "需要被暂停的音效实体",
  T_48_META_API_10063_D: "继续播放音效,可选择是否从头开始播放",
  T_48_META_API_10063_P0_D: "被暂停后需要继续播放的音效实体",
  T_48_META_API_10063_P1_D: "是否从头开始",
  T_48_META_API_10064_D: "创建一个空投，空投具有三个阶段：1.准备、2.掉落中、3.落地，只有在状态1的时候可以修改空投属性",
  T_48_META_API_10064_P0_D: "创建的空投箱实体",
  T_48_META_API_1007_D: "实现根据条件是否为真持续执行的循环，直到条件为假结束循环",
  T_48_META_API_1007_P0_D: "当条件为真则继续循环，条件为假则结束循环",
  T_48_META_API_1008_D: `等待至下一逻辑帧开始时
在服务器上，开启低帧率模式，将会等待更长时间
在客户端上，等待时间受设备性能和当前帧逻辑复杂程度影响
使用该API的函数需要声明为async`,
  T_48_META_API_1009_D: "等待一定时间，使用该API的函数需要声明为async。",
  T_48_META_API_1009_P0_D: "等待的时长，单位毫秒",
  T_48_META_API_101_D: "卸载指定场景",
  T_48_META_API_101_P0_D: "要卸载的场景ID",
  T_48_META_API_1010: "事件回调",
  T_48_META_API_1010_D: "当某事件发生时触发的动作",
  T_48_META_API_1010_P0: "参数名称",
  T_48_META_API_1010_P0_D: "事件参数的形参名称，通过它可以在局部变量上获取到实参值",
  T_48_META_API_1011: "代码块",
  T_48_META_API_1011_D: "一段代码块，用以承载一系列API的组合",
  T_48_META_API_1011_P0: "参数名称",
  T_48_META_API_1011_P0_D: "当代码块是自定义函数时的形参名称",
  T_48_META_API_1012: "串行调用函数",
  T_48_META_API_1012_D: "以串行的方式调用自定义函数，如果自定义函数中存在等待，则调用位置也进行等待",
  T_48_META_API_1012_P0_D: "自定义函数所在的实体",
  T_48_META_API_1012_P1: "图ID",
  T_48_META_API_1012_P1_D: "自定义函数所在的脚本ID",
  T_48_META_API_1012_P2: "函数ID",
  T_48_META_API_1012_P2_D: "目标调用的函数ID",
  T_48_META_API_1012_P3_D: "传递给自定义函数的实参列表",
  T_48_META_API_1013: "并行调用函数",
  T_48_META_API_1013_D: "以并行的方式调用自定义函数，无论自定义函数中是否存在等待，都会立即返回调用位置继续向下执行",
  T_48_META_API_1013_P0_D: "自定义函数所在的实体",
  T_48_META_API_1013_P1: "图ID",
  T_48_META_API_1013_P1_D: "自定义函数所在的脚本ID",
  T_48_META_API_1013_P2: "函数ID",
  T_48_META_API_1013_P2_D: "目标调用的函数ID",
  T_48_META_API_1013_P3_D: "传递给自定义函数的实参列表",
  T_48_META_API_1014: "串行调用自身函数",
  T_48_META_API_1014_D: "以串行方式调用当前脚本中的自定义函数，如果自定义函数中存在等待，则调用位置也进行等待",
  T_48_META_API_1014_P0: "函数ID",
  T_48_META_API_1014_P0_D: "目标调用的函数ID",
  T_48_META_API_1014_P1_D: "传递给自定义函数的实参列表",
  T_48_META_API_1015: "并行调用自身函数",
  T_48_META_API_1015_D: "以并行的方式调用自定义函数，无论自定义函数中是否存在等待，都会立即返回调用位置继续向下执行",
  T_48_META_API_1015_P0: "设置局部变量",
  T_48_META_API_1015_P0_D: "目标调用的函数ID",
  T_48_META_API_1015_P1_D: "传递给自定义函数的实参列表",
  T_48_META_API_1016_D: "获取调用此API时目标的类型",
  T_48_META_API_1016_P0_D: "被查询的目标",
  T_48_META_API_1016_R_D: "变量类型",
  T_48_META_API_1017_D: "判断目标变量是否为指定类型",
  T_48_META_API_1017_P0_D: "被查询的目标",
  T_48_META_API_1017_P1_D: "被比较的类型",
  T_48_META_API_1017_R_D: "是否一致",
  T_48_META_API_1018_D: "判断目标变量是否是某一类型的子类，返回值是一个布尔值",
  T_48_META_API_1018_P0_D: "被查询的目标变量",
  T_48_META_API_1018_P1_D: "被比较的类型",
  T_48_META_API_1018_R_D: "是否为子类",
  T_48_META_API_1019_D: "使目标实体触发指定自定义事件",
  T_48_META_API_1019_P0_D: "发送的自定义事件ID",
  T_48_META_API_1019_P1_D: "目标实体",
  T_48_META_API_1019_P2_D: "参数列表",
  T_48_META_API_102_D: "切换到指定场景，会卸载其他已加载场景",
  T_48_META_API_102_P0_D: "要切换至的场景ID",
  T_48_META_API_1020_D: "实现对一个容器的遍历，获取到每一对键值对，含有子过程，循环体就是子过程",
  T_48_META_API_1020_P0_D: "遍历到键的名称，可以使用它获取到局部变量上的键值",
  T_48_META_API_1020_P1_D: "遍历到值的名称，可以使用它获取到局部变量上的值",
  T_48_META_API_1020_P2_D: "要遍历的容器",
  T_48_META_API_1021_D: "销毁指定Bot",
  T_48_META_API_1021_P0_D: "需要被销毁的Bot玩家",
  T_48_META_API_1022_D: "强制目标玩家离开载具",
  T_48_META_API_1022_P0_D: "目标玩家",
  T_48_META_API_1023_D: "创建伤害跳字",
  T_48_META_API_1023_P0_D: "跳字内容",
  T_48_META_API_1023_P1_D: "字体大小",
  T_48_META_API_1023_P2_D: "字体颜色",
  T_48_META_API_1023_P3_D: "停留时长，单位毫秒",
  T_48_META_API_1023_P4_D: "受到伤害的实体",
  T_48_META_API_1023_P5_D: "伤害跳字相对于目标实体世界坐标的偏移量",
  T_48_META_API_1023_P6_D: "在伤害跳字位置再次进行随机位置修正的范围大小",
  T_48_META_API_1023_P7_D: "是否执行补间动画",
  T_48_META_API_1024_D: "已废弃",
  T_48_META_API_1024_P0_D: "已废弃",
  T_48_META_API_1024_P1_D: "目标实体",
  T_48_META_API_1024_P2_D: "选中后,如果在服务端调用,则发送给客户端,客户端调用则发送给服务端",
  T_48_META_API_1024_P3_D: "参数列表",
  T_48_META_API_1025_D: "查询自定义任务进度",
  T_48_META_API_1025_P0_D: "目标玩家",
  T_48_META_API_1025_P1_D: "自定义任务ID",
  T_48_META_API_1025_R_D: "任务进度",
  T_48_META_API_1026_D: "获取目标玩家的背包皮肤",
  T_48_META_API_1026_P0_D: "目标玩家",
  T_48_META_API_1026_R_D: "背包皮肤ID",
  T_48_META_API_1027_D: "设置目标玩家的背包皮肤",
  T_48_META_API_1027_P0_D: "目标玩家",
  T_48_META_API_1027_P1_D: "背包皮肤ID",
  T_48_META_API_1028_D: "恢复目标玩家的背包皮肤为默认局外配置",
  T_48_META_API_1028_P0_D: "目标玩家",
  T_48_META_API_1029_D: "清空目标玩家的背包皮肤",
  T_48_META_API_1029_P0_D: "目标玩家",
  T_48_META_API_103_D: "更换游戏的天空盒环境样式，可以选择白天、黄昏、黑夜等",
  T_48_META_API_103_P0_D: "天空盒类型",
  T_48_META_API_1030_D: "通过名字获取骨骼挂点部位",
  T_48_META_API_1030_P0_D: "目标实体",
  T_48_META_API_1030_P1_D: "骨骼挂点名称",
  T_48_META_API_1030_R_D: "骨骼挂点",
  T_48_META_API_1031_D: "设置物件实体的父节点，支持挂载了Transform,SkeletonPart,Player,MountPoint组件的实体",
  T_48_META_API_1031_P0_D: "父节点",
  T_48_META_API_1031_P1_D: "子节点",
  T_48_META_API_1031_P2_D: "是否保留子节点当前世界位置、旋转和缩放，UI设置该项无效",
  T_48_META_API_1032_D: "播放图标动画效果，图标由起始位置以播放速度平移至结束位置",
  T_48_META_API_1032_P0_D: "图标资源ID",
  T_48_META_API_1032_P1_D: "颜色",
  T_48_META_API_1032_P2_D: "图标缩放",
  T_48_META_API_1032_P3_D: "起始位置中心",
  T_48_META_API_1032_P4_D: "起始区域范围",
  T_48_META_API_1032_P5_D: "结束位置中心",
  T_48_META_API_1032_P6_D: "结束位置范围",
  T_48_META_API_1032_P7_D: "播放速度，是图标移动的每秒距离",
  T_48_META_API_1033_D: "进行反正切运算获得角度",
  T_48_META_API_1033_P0_D: "Y轴坐标",
  T_48_META_API_1033_P1_D: "X轴坐标",
  T_48_META_API_1033_R_D: "角度，范围(-180, 180]",
  T_48_META_API_1034_D: "添加组件到实体上，仅支持用户创建的自定义组件",
  T_48_META_API_1034_P0_D: "目标实体",
  T_48_META_API_1034_P1_D: "组件类型ID，仅支持用户创建的自定义组件",
  T_48_META_API_1034_P2_D: "是否成功添加，已存在的组件或非自定义组件会添加失败",
  T_48_META_API_1035_D: "从实体上移除组件，仅支持自定义组件",
  T_48_META_API_1035_P0_D: "目标实体",
  T_48_META_API_1035_P1_D: "组件类型ID，仅支持用户创建的自定义组件",
  T_48_META_API_1035_P2_D: "是否成功移除，不存在的组件或非自定义组件会移除失败",
  T_48_META_API_1036_D: "自定义玩家中途退出界面",
  T_48_META_API_1036_P0_D: "标题",
  T_48_META_API_1036_P1_D: "内容",
  T_48_META_API_1036_P2_D: "选项",
  T_48_META_API_1036_P3_D: "是否显示背景",
  T_48_META_API_1037_D: "获取当前已加载的所有场景",
  T_48_META_API_1037_R_D: "场景列表",
  T_48_META_API_1038_D: "获取玩家本地的瞄准方向",
  T_48_META_API_1038_R_D: "瞄准方向",
  T_48_META_API_1039_D: "获取本地时间戳",
  T_48_META_API_1039_R_D: "时间戳",
  T_48_META_API_104_D: "将玩家切换至指定场景的指定位置，未加载的场景会自动加载，不会自动卸载已经加载的场景",
  T_48_META_API_104_P0_D: "玩家",
  T_48_META_API_104_P1_D: "要加载的场景ID",
  T_48_META_API_104_P2_D: "玩家在新场景的位置",
  T_48_META_API_104_P3_D: "玩家在新场景的朝向",
  T_48_META_API_1040_D: "暂停当前平台的固定帧更新，暂停后该平台的固定帧更新事件不再触发",
  T_48_META_API_1041_D: "恢复当前平台的固定帧更新，恢复后该平台的固定帧更新事件重新开始触发",
  T_48_META_API_1042_D: "判断目标玩家与当前客户端玩家的好友关系，当前客户端自身不是当前客户端的好友",
  T_48_META_API_1042_P0_D: "目标玩家",
  T_48_META_API_1042_R_D: "是否与当前客户端是好友",
  T_48_META_API_1043_D: "触发自定义事件",
  T_48_META_API_1043_P0_D: "自定义事件ID",
  T_48_META_API_1043_P1_D: "目标实体",
  T_48_META_API_1043_P2_D: "运行平台为服务端或客户端",
  T_48_META_API_1043_P3_D: "参数列表",
  T_48_META_API_1044_D: "开启跳伞",
  T_48_META_API_1044_P0_D: "目标玩家",
  T_48_META_API_1044_P1_D: "低于该高度会强制开伞",
  T_48_META_API_1044_P2_D: "滑翔时的速度，X分量代表水平速度，Y分量代表垂直速度；Y分量为负时玩家向下降落",
  T_48_META_API_1044_P3_D: "俯冲时的速度，X分量代表水平速度，Y分量代表垂直速度；Y分量为负时玩家向下降落",
  T_48_META_API_1044_P4_D: "开伞时的速度，X分量代表水平速度，Y分量代表垂直速度；Y分量为负时玩家向下降落",
  T_48_META_API_1045_D: "读取数据表中指定标识符对应的值",
  T_48_META_API_1045_P0_D: "数据库中表名",
  T_48_META_API_1045_P1_D: "玩家唯一ID",
  T_48_META_API_1045_P2_D: "指定标识符",
  T_48_META_API_1045_P3_D: "读取的结果",
  T_48_META_API_1045_P4_D: "数据库对应的战场码，允许填空，代表当前地图战场码",
  T_48_META_API_1045_P5_D: "错误码",
  T_48_META_API_1046_D: "读取排行榜数据表中指定标识符对应的值",
  T_48_META_API_1046_P0_D: "数据库中排行榜表名",
  T_48_META_API_1046_P1_D: "指定标识符",
  T_48_META_API_1046_P2_D: "读取的结果",
  T_48_META_API_1046_P3_D: "数据库对应的战场码，允许填空，代表当前地图战场码",
  T_48_META_API_1046_P4_D: "错误码",
  T_48_META_API_1047_D: "读取排行榜数据表中指定名次区间的值",
  T_48_META_API_1047_P0_D: "数据库中排行榜表名",
  T_48_META_API_1047_P1_D: "起始名次，须小于等于结束名次，名次从1开始计算",
  T_48_META_API_1047_P2_D: "结束名次",
  T_48_META_API_1047_P3_D: "读取的结果",
  T_48_META_API_1047_P4_D: "数据库对应的战场码，允许填空，代表当前地图战场码",
  T_48_META_API_1047_P5_D: "错误码",
  T_48_META_API_1048_D: "读取累计数据表中指定标识符对应的值",
  T_48_META_API_1048_P0_D: "数据库中累计数据表名",
  T_48_META_API_1048_P1_D: "指定标识符",
  T_48_META_API_1048_P2_D: "读取的结果",
  T_48_META_API_1048_P3_D: "数据库对应的战场码，允许填空，代表当前地图战场码",
  T_48_META_API_1048_P4_D: "错误码",
  T_48_META_API_1049_D: "写入数据表中指定标识符对应的值",
  T_48_META_API_1049_P0_D: "数据库中表名",
  T_48_META_API_1049_P1_D: "玩家唯一ID",
  T_48_META_API_1049_P2_D: "指定标识符",
  T_48_META_API_1049_P3_D: "写入的值",
  T_48_META_API_1049_P4_D: "数据库对应的战场码，允许填空，代表当前地图战场码",
  T_48_META_API_1049_P5_D: "错误码",
  T_48_META_API_105_D: "获取场景的天空盒",
  T_48_META_API_105_P0_D: "场景ID",
  T_48_META_API_105_R_D: "天空盒",
  T_48_META_API_1050_D: "获取列表的元素个数",
  T_48_META_API_1050_P0_D: "目标列表",
  T_48_META_API_1050_R_D: "元素个数",
  T_48_META_API_1051_D: "获取列表中指定索引的元素值",
  T_48_META_API_1051_P0_D: "目标列表",
  T_48_META_API_1051_P1_D: "索引值，从0开始",
  T_48_META_API_1051_R_D: "元素值",
  T_48_META_API_1052_D: "设置列表中指定索引对应的元素值",
  T_48_META_API_1052_P0_D: "目标列表",
  T_48_META_API_1052_P1_D: "索引值，从0开始",
  T_48_META_API_1052_P2_D: "元素值",
  T_48_META_API_1053_D: "向列表尾部追加元素",
  T_48_META_API_1053_P0_D: "目标列表",
  T_48_META_API_1053_P1_D: "要添加的元素",
  T_48_META_API_1054_D: "从列表中删除指定索引对应的元素",
  T_48_META_API_1054_P0_D: "目标列表",
  T_48_META_API_1054_P1_D: "索引值，从0开始",
  T_48_META_API_1055_D: "清空列表中所有元素",
  T_48_META_API_1055_P0_D: "目标列表",
  T_48_META_API_1056_D: "反转指定列表，列表中的元素顺序会反转",
  T_48_META_API_1056_P0_D: "目标列表",
  T_48_META_API_1057_D: "复制一个列表",
  T_48_META_API_1057_P0_D: "目标列表",
  T_48_META_API_1057_R_D: "复制出的新列表",
  T_48_META_API_1058_D: "在列表指定索引位置插入一个新元素，原先该索引位置及之后的元素会依次向后移动一位",
  T_48_META_API_1058_P0_D: "目标列表",
  T_48_META_API_1058_P1_D: "要插入的索引位置，索引从0开始计算",
  T_48_META_API_1058_P2_D: "要插入的新元素值",
  T_48_META_API_1059_D: "将列表中的元素重新随机排序",
  T_48_META_API_1059_P0_D: "目标列表",
  T_48_META_API_1060_D: "对两侧参数进行比较，返回true或false",
  T_48_META_API_1060_P0_D: "用来比较的左值",
  T_48_META_API_1060_P1_D: "比较方式，支持以下方式：>,>=,==,!=,<=,<,And(限定bool类型),Or(限定bool类型)",
  T_48_META_API_1060_P2_D: "用来比较的左值",
  T_48_META_API_1060_R_D: "比较结果",
  T_48_META_API_1061_D: "基本四则运算，包括加、减、乘、除和求余。求余运算仅支持整数，其余运算支持整数或小数",
  T_48_META_API_1061_P0_D: "运算的左值",
  T_48_META_API_1061_P1_D: "四则运算的类型，包括加、减、乘、除和求余，求余运算不支持小数",
  T_48_META_API_1061_P2_D: "运算的右值",
  T_48_META_API_1061_R_D: "计算结果",
  T_48_META_API_1062_D: "在最小值整数（包含）和最大值整数（不包含）之间随机生成一个整数",
  T_48_META_API_1062_P0_D: "随机范围左区间，有可能随机到填入的值",
  T_48_META_API_1062_P1_D: "随机范围右区间，不会随机到填入的值",
  T_48_META_API_1062_R_D: "随机结果，整数",
  T_48_META_API_1063_D: "在最小值小数（包含）和最大值小数（不包含）之间随机生成一个小数",
  T_48_META_API_1063_P0_D: "随机范围左区间，有很小可能随机到填入的值",
  T_48_META_API_1063_P1_D: "随机范围右区间，不会随机到填入的值",
  T_48_META_API_1063_R_D: "随机结果，小数，精确到小数点后7位",
  T_48_META_API_1064_D: "判断对象是否为空",
  T_48_META_API_1064_P0_D: "要判空的对象",
  T_48_META_API_1064_R_D: "是否为空",
  T_48_META_API_1065_D: "逻辑取反，输入值：真或假，返回值：假或真",
  T_48_META_API_1065_P0_D: "需要求非的值",
  T_48_META_API_1065_R_D: "求非的结果",
  T_48_META_API_1066_D: "取绝对值，支持整数和小数",
  T_48_META_API_1066_P0_D: "需要求绝对值的数值",
  T_48_META_API_1066_R_D: "取绝对值的结果",
  T_48_META_API_1067_D: "计算平方根",
  T_48_META_API_1067_P0_D: "需要求平方根的数值",
  T_48_META_API_1067_R_D: "求平方根的结果",
  T_48_META_API_1068_D: "计算负值",
  T_48_META_API_1068_P0_D: "需要求负值的数值",
  T_48_META_API_1068_R_D: "负值的结果",
  T_48_META_API_1069_D: "把两个字符串连接在一起",
  T_48_META_API_1069_P0_D: "字符串左值",
  T_48_META_API_1069_P1_D: "字符串右值",
  T_48_META_API_1069_R_D: "字符串连接结果",
  T_48_META_API_1070_D: "获取字符串长度",
  T_48_META_API_1070_P0_D: "字符串",
  T_48_META_API_1070_R_D: "字符串长度",
  T_48_META_API_1071_D: "对指定值按照向下取整方式取整",
  T_48_META_API_1071_P0_D: "需要向下取整的数值",
  T_48_META_API_1071_R_D: "向下取整的结果",
  T_48_META_API_1072_D: "对指定值按照向上取整方式取整",
  T_48_META_API_1072_P0_D: "需要向上取整的数值",
  T_48_META_API_1072_R_D: "向上取整的结果",
  T_48_META_API_1073_D: "对指定值按照四舍五入方式取整",
  T_48_META_API_1073_P0_D: "需要四舍五入的数值",
  T_48_META_API_1073_R_D: "四舍五入的结果",
  T_48_META_API_1074_D: "将目标字符串中的所有指定字符串替换后，输出新字符串",
  T_48_META_API_1074_P0_D: "目标字符串",
  T_48_META_API_1074_P1_D: "要替换掉的旧字符串",
  T_48_META_API_1074_P2_D: "要替换为的新字符串",
  T_48_META_API_1074_R_D: "替换完成的字符串",
  T_48_META_API_1075_D: "在目标字符串重查找一段指定字符串第一次出现的位置",
  T_48_META_API_1075_P0_D: "目标字符串",
  T_48_META_API_1075_P1_D: "要查找的指定字符串",
  T_48_META_API_1075_P2_D: "从起始位置查找字符串，字符串位置从0开始计算",
  T_48_META_API_1075_R_D: "指定字符串在目标字符串中第一次出现的位置，字符串位置从0开始计算",
  T_48_META_API_1076_D: "从指定位置开始截取指定长度的字符串后，输出新字符串",
  T_48_META_API_1076_P0_D: "目标字符串",
  T_48_META_API_1076_P1_D: "开始截取的位置，字符串位置从0开始计算",
  T_48_META_API_1076_P2_D: "截取长度，缺省时截取到字符串结束",
  T_48_META_API_1076_R_D: "截取到的字符串",
  T_48_META_API_1077_D: "比较两个列表元素是否完全相同，列表容量不影响比较结果",
  T_48_META_API_1077_P0_D: "用来比较的列表左值",
  T_48_META_API_1077_P1_D: "用来比较的列表右值",
  T_48_META_API_1077_R_D: "比较结果，内容一致返回True，内容不一致返回False",
  T_48_META_API_1078_D: "以指定字符串为分隔符，将目标字符串切割为若干个切片后输出新字符串，连续的N个分隔符会切割为N-1个半角空格作为字符串列表元素输出",
  T_48_META_API_1078_P0_D: "目标字符串",
  T_48_META_API_1078_P1_D: "分隔符字符串",
  T_48_META_API_1078_R_D: "输出的字符串列表，总是有一个半角空格元素作为结尾",
  T_48_META_API_1079_D: "根据字符串位置列表提取字符，组合为新的字符串输出",
  T_48_META_API_1079_P0_D: "目标字符串",
  T_48_META_API_1079_P1_D: "字符串位置列表，字符串位置从0开始计算",
  T_48_META_API_1079_R_D: "输出的字符串",
  T_48_META_API_1080_D: "将目标字符串字符全部转换为大写",
  T_48_META_API_1080_P0_D: "目标字符串",
  T_48_META_API_1080_R_D: "输出的字符串",
  T_48_META_API_1081_D: "将目标字符串字符全部转换为小写",
  T_48_META_API_1081_P0_D: "目标字符串",
  T_48_META_API_1081_R_D: "输出的字符串",
  T_48_META_API_1082_D: "去除目标字符串第一个非空格字符以前和最后一个非空格字符以后的所有空格",
  T_48_META_API_1082_P0_D: "目标字符串",
  T_48_META_API_1082_R_D: "输出的字符串",
  T_48_META_API_1083_D: "以指定标识符链接后输出新字符串",
  T_48_META_API_1083_P0_D: "目标字符串列表",
  T_48_META_API_1083_P1_D: "用来连接字符串的指定标识符",
  T_48_META_API_1083_R_D: "输出的字符串",
  T_48_META_API_1084_D: "写入排行榜数据表中指定标识符对应的值",
  T_48_META_API_1084_P0_D: "数据库中排行榜表名",
  T_48_META_API_1084_P1_D: "指定标识符",
  T_48_META_API_1084_P2_D: "写入的值",
  T_48_META_API_1084_P3_D: "数据库对应的战场码，允许填空，代表当前地图战场码",
  T_48_META_API_1084_P4_D: "错误码",
  T_48_META_API_1085_D: "写入累计数据表中指定标识符对应的偏移值",
  T_48_META_API_1085_P0_D: "数据库中累计数据表名",
  T_48_META_API_1085_P1_D: "指定标识符",
  T_48_META_API_1085_P2_D: "四则运算的类型",
  T_48_META_API_1085_P3_D: "写入的偏移值",
  T_48_META_API_1085_P4_D: "数据库对应的战场码，允许填空，代表当前地图战场码",
  T_48_META_API_1085_P5_D: "错误码",
  T_48_META_API_1086_D: "删除数据表中指定标识符对应的值",
  T_48_META_API_1086_P0_D: "数据库中表名",
  T_48_META_API_1086_P1_D: "玩家唯一ID",
  T_48_META_API_1086_P2_D: "指定标识符",
  T_48_META_API_1086_P3_D: "数据库对应的战场码，允许填空，代表当前地图战场码",
  T_48_META_API_1086_P4_D: "错误码",
  T_48_META_API_1087_D: "删除排行榜数据表中指定标识符对应的值",
  T_48_META_API_1087_P0_D: "数据库中排行榜表名",
  T_48_META_API_1087_P1_D: "指定标识符",
  T_48_META_API_1087_P2_D: "数据库对应的战场码，允许填空，代表当前地图战场码",
  T_48_META_API_1087_P3_D: "错误码",
  T_48_META_API_1088_D: "删除排行榜数据表中指定名次对应的值",
  T_48_META_API_1088_P0_D: "数据库中排行榜表名",
  T_48_META_API_1088_P1_D: "指定名次",
  T_48_META_API_1088_P2_D: "数据库对应的战场码，允许填空，代表当前地图战场码",
  T_48_META_API_1088_P3_D: "错误码",
  T_48_META_API_1089_D: "发送用户消息给Persona",
  T_48_META_API_1089_P0_D: "目标PersonaID",
  T_48_META_API_1089_P1_D: "消息内容",
  T_48_META_API_1090_D: "发送系统消息给Persona",
  T_48_META_API_1090_P0_D: "目标PersonaID",
  T_48_META_API_1090_P1_D: "消息内容",
  T_48_META_API_1091_D: "清除Persona记忆",
  T_48_META_API_1091_P0_D: "错误码",
  T_48_META_API_1092_D: "唤起会员中心",
  T_48_META_API_1092_P0_D: "错误码",
  T_48_META_API_1093_D: "获取会员到期时间戳",
  T_48_META_API_1093_P0_D: "目标玩家",
  T_48_META_API_1093_P1_D: "时间戳",
  T_48_META_API_1093_P2_D: "错误码",
  T_48_META_API_1094_D: "判断玩家是否是会员",
  T_48_META_API_1094_P0_D: "错误码",
  T_48_META_API_1094_P1_D: "是否是会员",
  T_48_META_API_1095_D: "获取会员到期时间戳",
  T_48_META_API_1095_P0_D: "时间戳",
  T_48_META_API_1095_P1_D: "错误码",
  T_48_META_API_1096_D: "判断玩家是否是会员",
  T_48_META_API_1096_P0_D: "目标玩家",
  T_48_META_API_1096_P1_D: "错误码",
  T_48_META_API_1096_P2_D: "是否是会员",
  T_48_META_API_1097_D: "唤起会员中心",
  T_48_META_API_1097_P0_D: "目标玩家",
  T_48_META_API_1097_P1_D: "错误码",
  T_48_META_API_1099_D: "设置Persona观察者，此后和Persona的对话也会发送给观察者",
  T_48_META_API_1099_P0_D: "目标PersonaID",
  T_48_META_API_1099_P1_D: "观察者列表",
  T_48_META_API_11_D: "结束当前阶段，并进入下一阶段",
  T_48_META_API_1100_D: "使用流式传输发送用户消息给Persona",
  T_48_META_API_1100_P0_D: "目标PersonaID",
  T_48_META_API_1100_P1_D: "消息内容",
  T_48_META_API_1101_D: "使用流式传输发送系统消息给Persona",
  T_48_META_API_1101_P0_D: "目标PersonaID",
  T_48_META_API_1101_P1_D: "消息内容",
  T_48_META_API_1101_P2_D: "是否应回复",
  T_48_META_API_1103_D: "创建随机种子",
  T_48_META_API_1103_P0_D: "种子",
  T_48_META_API_1103_R_D: "随机数生成器",
  T_48_META_API_1104_D: "获取指定随机数生成器的下一个随机数，最大值32767",
  T_48_META_API_1104_P0_D: "随机数生成器",
  T_48_META_API_1104_P1_D: "范围最小值",
  T_48_META_API_1104_P2_D: "范围最大值",
  T_48_META_API_1104_R_D: "随机数",
  T_48_META_API_1108_D: "获取玩家使用的客户端语言",
  T_48_META_API_12_D: "打印日志到控制台",
  T_48_META_API_12_P0_D: "需要打印的内容",
  T_48_META_API_13_D: "输出带有参数的字符串",
  T_48_META_API_13_P0_D: "使用%v占位符代表一个参数，%v的个数和参数个数需要保持一致",
  T_48_META_API_13_P1_D: "参与输出的参数列表，需要和格式描述中的%v个数保持一致",
  T_48_META_API_13_R_D: "输出的字符串",
  T_48_META_API_14_D: "清理地图物件残留，包含死亡盒子、创建的物件、摆放的物件、投掷物残留等",
  T_48_META_API_15_D: "自定义比赛埋点日志，用于用户体验数据分析",
  T_48_META_API_15_P0_D: "要上报字段名的列表",
  T_48_META_API_15_P1_D: "要上报字段值的列表",
  T_48_META_API_1500_D: "获取三维向量的X分量",
  T_48_META_API_1500_P0_D: "三维向量",
  T_48_META_API_1500_R_D: "三维向量X分量",
  T_48_META_API_1501_D: "获取三维向量的Y分量",
  T_48_META_API_1501_P0_D: "三维向量",
  T_48_META_API_1501_R_D: "三维向量Y分量",
  T_48_META_API_1502_D: "获取三维向量的Z分量",
  T_48_META_API_1502_P0_D: "三维向量",
  T_48_META_API_1502_R_D: "三维向量Z分量",
  T_48_META_API_1503_D: "设置三维向量的X分量",
  T_48_META_API_1503_P0_D: "三维向量",
  T_48_META_API_1503_P1_D: "X分量",
  T_48_META_API_1504_D: "设置三维向量的Y分量",
  T_48_META_API_1504_P0_D: "三维向量",
  T_48_META_API_1504_P1_D: "Y分量",
  T_48_META_API_1505_D: "设置三维向量的Z分量",
  T_48_META_API_1505_P0_D: "三维向量",
  T_48_META_API_1505_P1_D: "Z分量",
  T_48_META_API_1506_D: "将两个三维向量相加",
  T_48_META_API_1506_P0_D: "左值",
  T_48_META_API_1506_P1_D: "右值",
  T_48_META_API_1506_R_D: "三维向量相加结果",
  T_48_META_API_1507_D: "将两个三维向量相减",
  T_48_META_API_1507_P0_D: "左值",
  T_48_META_API_1507_P1_D: "右值",
  T_48_META_API_1507_R_D: "三维向量左值减去右值的结果",
  T_48_META_API_1508_D: "将三维向量进行缩放",
  T_48_META_API_1508_P0_D: "需要缩放的三维向量",
  T_48_META_API_1508_P1_D: "三维向量缩放量",
  T_48_META_API_1508_R_D: "三维向量缩放结果",
  T_48_META_API_1509_D: "将两个三维向量点乘，点乘结果为标量",
  T_48_META_API_1509_P0_D: "左值",
  T_48_META_API_1509_P1_D: "右值",
  T_48_META_API_1509_R_D: "点乘结果",
  T_48_META_API_1510_D: "将两个三维向量叉乘，叉乘结果为向量，垂直于两个向量所在的平面",
  T_48_META_API_1510_P0_D: "左值",
  T_48_META_API_1510_P1_D: "右值",
  T_48_META_API_1510_R_D: "叉乘结果，方向垂直于参与运算的两个向量所在的平面",
  T_48_META_API_1511_D: "对三维向量归一化",
  T_48_META_API_1511_P0_D: "三维向量",
  T_48_META_API_1511_R_D: "返回一个新的归一化向量。模长为1",
  T_48_META_API_1512_D: "对三维向量取模",
  T_48_META_API_1512_P0_D: "三维向量",
  T_48_META_API_1512_R_D: "取模结果，为向量模的长度",
  T_48_META_API_1513_D: "计算两个三维向量的欧氏距离",
  T_48_META_API_1513_P0_D: "左值",
  T_48_META_API_1513_P1_D: "右值",
  T_48_META_API_1513_R_D: "两向量相减后，所得向量的模长",
  T_48_META_API_1514_D: "计算两个三维向量的夹角",
  T_48_META_API_1514_P0_D: "左值",
  T_48_META_API_1514_P1_D: "右值",
  T_48_META_API_1514_R_D: "向量夹角，角度范围0-180",
  T_48_META_API_1515_D: "创建一个三维向量",
  T_48_META_API_1515_P0_D: "三维向量的X分量",
  T_48_META_API_1515_P1_D: "三维向量的Y分量",
  T_48_META_API_1515_P2_D: "三维向量的Z分量",
  T_48_META_API_1515_R_D: "创建出的三维向量",
  T_48_META_API_1516_D: "获取一个新构造的方向点（已废弃，请勿使用）",
  T_48_META_API_1516_P0_D: "位置",
  T_48_META_API_1516_P1_D: "朝向",
  T_48_META_API_1516_R_D: "DirectPoint",
  T_48_META_API_1517_D: "取方向点位置（已废弃，请勿使用）",
  T_48_META_API_1517_P0_D: "方向点",
  T_48_META_API_1517_R_D: "Position",
  T_48_META_API_1518_D: "取方向点朝向（已废弃，请勿使用）",
  T_48_META_API_1518_P0_D: "方向点",
  T_48_META_API_1518_R_D: "Forward",
  T_48_META_API_1519_D: "创建一个列表",
  T_48_META_API_1519_P0_D: "列表的初始长度，必须小于等于初始容量",
  T_48_META_API_1519_P1_D: "列表的初始容量，必须大于等于初始长度。容量可以动态扩充，但是会消耗一定性能，建议构造时就设定一个合适的值。",
  T_48_META_API_1519_R_D: "创建出的列表",
  T_48_META_API_1520_D: "检查列表是否包含指定元素",
  T_48_META_API_1520_P0_D: "目标列表",
  T_48_META_API_1520_P1_D: "要检查的指定元素",
  T_48_META_API_1520_R_D: "是否包含指定元素",
  T_48_META_API_1521_D: "向目标列表尾部追加多个元素",
  T_48_META_API_1521_P0_D: "目标列表",
  T_48_META_API_1521_P1_D: "追加列表",
  T_48_META_API_1522_D: "从列表中移除指定元素",
  T_48_META_API_1522_P0_D: "目标列表",
  T_48_META_API_1522_P1_D: "要移除的元素值",
  T_48_META_API_1523_D: "获取列表中元素最先出现的位置索引，列表中无目标元素则返回-1",
  T_48_META_API_1523_P0_D: "目标列表",
  T_48_META_API_1523_P1_D: "元素值",
  T_48_META_API_1523_R_D: "位置索引",
  T_48_META_API_1524_D: "获取列表中元素最后出现的位置索引，列表中无目标元素则返回-1",
  T_48_META_API_1524_P0_D: "目标列表",
  T_48_META_API_1524_P1_D: "元素值",
  T_48_META_API_1524_R_D: "位置索引",
  T_48_META_API_1525_D: "求角度的正弦值",
  T_48_META_API_1525_P0_D: "角度，360代表360度",
  T_48_META_API_1525_R_D: "正弦值",
  T_48_META_API_1526_D: "求角度的余弦值",
  T_48_META_API_1526_P0_D: "角度，360代表360度",
  T_48_META_API_1526_R_D: "余弦值",
  T_48_META_API_1527_D: "求角度的正切值",
  T_48_META_API_1527_P0_D: "角度，360代表360度",
  T_48_META_API_1527_R_D: "正切值",
  T_48_META_API_1528_D: "构建一个颜色值，透明度固定为十进制255，先将通道转换为二进制数，每8位代表一个通道，按照R、G、B、透明度拼接，然后将该二进制数转换为Int32型返回",
  T_48_META_API_1528_P0_D: "颜色的红色通道值，取值范围[0,255]，超过范围会clamp至合法值",
  T_48_META_API_1528_P1_D: "颜色的绿色通道值，取值范围[0,255]，超过范围会clamp至合法值",
  T_48_META_API_1528_P2_D: "颜色的蓝色通道值，取值范围[0,255]，超过范围会clamp至合法值",
  T_48_META_API_1528_R_D: "构建的颜色值",
  T_48_META_API_1529_D: "进行反正弦运算获得角度",
  T_48_META_API_1529_P0_D: "进行反正弦运算的值，取值范围[-1,1]",
  T_48_META_API_1529_R_D: "角度",
  T_48_META_API_1530_D: "进行反余弦运算获得角度",
  T_48_META_API_1530_P0_D: "进行反余弦运算的值，取值范围[-1,1]",
  T_48_META_API_1530_R_D: "角度",
  T_48_META_API_1531_D: "进行反正切运算获得角度",
  T_48_META_API_1531_P0_D: "进行反正切运算的值",
  T_48_META_API_1531_R_D: "角度",
  T_48_META_API_1532_D: "判断目标实体是否在规定的球体范围内，如果实体没有位置属性，会返回假",
  T_48_META_API_1532_P0_D: "目标实体",
  T_48_META_API_1532_P1_D: "规定球体的球心",
  T_48_META_API_1532_P2_D: "规定球体的半径",
  T_48_META_API_1532_R_D: "判定结果",
  T_48_META_API_1533_D: "判断目标实体是否在规定的圆柱体范围内，如果实体没有位置属性，会返回假",
  T_48_META_API_1533_P0_D: "目标实体",
  T_48_META_API_1533_P1_D: "规定圆柱体的中心点",
  T_48_META_API_1533_P2_D: "规定圆柱体的截面半径",
  T_48_META_API_1533_P3_D: "规定圆柱体的高度",
  T_48_META_API_1533_P4_D: "规定圆柱体绕中心点的三维旋转欧拉角",
  T_48_META_API_1533_R_D: "判定结果",
  T_48_META_API_1534_D: "判断目标实体是否在规定的立方体范围内",
  T_48_META_API_1534_P0_D: "目标实体",
  T_48_META_API_1534_P1_D: "规定立方体的中心点",
  T_48_META_API_1534_P2_D: "规定立方体的长",
  T_48_META_API_1534_P3_D: "规定立方体的宽",
  T_48_META_API_1534_P4_D: "规定立方体的高",
  T_48_META_API_1534_P5_D: "规定立方体绕中心点的三维旋转欧拉角",
  T_48_META_API_1534_R_D: "判定结果",
  T_48_META_API_1535_D: "判断目标实体是否在规定的扇形柱体范围内",
  T_48_META_API_1535_P0_D: "目标实体",
  T_48_META_API_1535_P1_D: "规定扇形柱体的中截面圆心",
  T_48_META_API_1535_P2_D: "规定扇形柱体的中截面半径",
  T_48_META_API_1535_P3_D: "不进行检测的扇形柱体截面半径，以中心点为圆心，该小扇形柱体区域不会进行检测，只会检测规定扇形柱体和小扇形柱体的差",
  T_48_META_API_1535_P4_D: "规定扇形柱体的高度",
  T_48_META_API_1535_P5_D: "进行检测的扇形柱体截面圆心角，大于360时以圆柱形进行检测，小于0时检测区域大小为0",
  T_48_META_API_1535_P6_D: "规定扇形柱体绕中心点的三位旋转欧拉角",
  T_48_META_API_1535_R_D: "判定结果",
  T_48_META_API_1536_D: "比较两个数字的值，返回较大的一个",
  T_48_META_API_1536_P0_D: "左值",
  T_48_META_API_1536_P1_D: "右值",
  T_48_META_API_1536_R_D: "较大的数字",
  T_48_META_API_1537_D: "返回列表中的最大值",
  T_48_META_API_1537_P0_D: "目标列表，只接受列表元素类型为数字",
  T_48_META_API_1537_P1_D: "比较结果，列表中存在非数字等情况时比较失败，返回假",
  T_48_META_API_1537_P2_D: "比较成功时返回列表中最大的值，比较失败时返回0",
  T_48_META_API_1538_D: "比较两个数字的值，返回较小的一个",
  T_48_META_API_1538_P0_D: "左值",
  T_48_META_API_1538_P1_D: "右值",
  T_48_META_API_1538_R_D: "较小的数字",
  T_48_META_API_1539_D: "返回列表中的最小值。",
  T_48_META_API_1539_P0_D: "目标列表，只接受列表元素类型为数字",
  T_48_META_API_1539_P1_D: "比较结果，列表中存在非数字等情况时比较失败，返回假",
  T_48_META_API_1539_P2_D: "比较成功时返回列表中最小的值，比较失败时返回0",
  T_48_META_API_1540_D: "线性插值，在开始值到目标值之间返回插值进度对应的值，插值系数[0,1]",
  T_48_META_API_1540_P0_D: "线性插值开始值，插值进度为0时返回该值",
  T_48_META_API_1540_P1_D: "线性插值目标值，插值进度为1时返回该值",
  T_48_META_API_1540_P2_D: "插值进度，取值范围[0,1]，取值为0时返回开始值、取值为1时返回目标值、取值为0.5时返回开始值和目标值的平均值",
  T_48_META_API_1540_R_D: "线性插值返回值",
  T_48_META_API_1541_D: "限制目标值的范围，取得三个入参中大小处于中间的值；其作用是将目标值限制到指定范围内，目标值比最小值小时返回最小值，比最大值大时返回最大值，处于范围中时返回自身",
  T_48_META_API_1541_P0_D: "目标值",
  T_48_META_API_1541_P1_D: "限定范围的最小值",
  T_48_META_API_1541_P2_D: "限定范围的最大值",
  T_48_META_API_1541_R_D: "限制后的返回值",
  T_48_META_API_1542_D: "取得目标颜色的各通道值",
  T_48_META_API_1542_P0_D: "目标颜色",
  T_48_META_API_1542_P1_D: "颜色的R值，范围[0 , 255]",
  T_48_META_API_1542_P2_D: "颜色的G值，范围[0 , 255]",
  T_48_META_API_1542_P3_D: "颜色的B值，范围[0 , 255]",
  T_48_META_API_1542_P4_D: "颜色的A值，范围[0 , 255]",
  T_48_META_API_1543_D: "求幂运算",
  T_48_META_API_1543_P0_D: "底数",
  T_48_META_API_1543_P1_D: "指数",
  T_48_META_API_1543_R_D: "计算结果",
  T_48_META_API_1544_D: "对数运算",
  T_48_META_API_1544_P0_D: "底数",
  T_48_META_API_1544_P1_D: "真数",
  T_48_META_API_1544_R_D: "计算结果",
  T_48_META_API_1545_D: "方向向量转欧拉角",
  T_48_META_API_1545_P0_D: "方向向量",
  T_48_META_API_1545_R_D: "欧拉角",
  T_48_META_API_1546_D: "欧拉角转方向向量",
  T_48_META_API_1546_P0_D: "欧拉角",
  T_48_META_API_1546_R_D: "方向向量",
  T_48_META_API_1547_D: "整数转浮点数",
  T_48_META_API_1547_P0_D: "整数",
  T_48_META_API_1547_R_D: "浮点数",
  T_48_META_API_1548_D: "根据四元数旋转目标向量",
  T_48_META_API_1548_P0_D: "目标向量",
  T_48_META_API_1548_P1_D: "旋转四元数",
  T_48_META_API_1548_R_D: "旋转后的向量",
  T_48_META_API_1549_D: "将目标数字转换为字符串",
  T_48_META_API_1549_P0_D: "要转字符串的目标数字",
  T_48_META_API_1549_P1_D: "输出的数字字符串格式",
  T_48_META_API_1549_R_D: "字符串",
  T_48_META_API_1598_D: "获取服务器时间戳",
  T_48_META_API_1598_R_D: "返回从1970年1月1日0时0分0秒开始的秒数",
  T_48_META_API_1599_D: "获取服务器区域",
  T_48_META_API_1599_R_D: "返回区域缩写(BR,SAC,ID,NA,US,IND,SG,BD,VN,TH,ME,RU,EU,PK,TW)",
  T_48_META_API_16_D: "自定义用户埋点日志，用于用户体验数据分析",
  T_48_META_API_16_P0_D: "要记录上报的玩家",
  T_48_META_API_16_P1_D: "要上报字段名的列表",
  T_48_META_API_16_P2_D: "要上报字段值的列表",
  T_48_META_API_1601_D: "创建一个字典",
  T_48_META_API_1601_R_D: "创建出的字典",
  T_48_META_API_1602_D: "获取字典中指定键对应的值",
  T_48_META_API_1602_P0_D: "目标字典",
  T_48_META_API_1602_P1_D: "键",
  T_48_META_API_1602_R_D: "值",
  T_48_META_API_1603_D: "设置字典中指定键对应的值",
  T_48_META_API_1603_P0_D: "目标字典",
  T_48_META_API_1603_P1_D: "键",
  T_48_META_API_1603_P2_D: "值",
  T_48_META_API_1604_D: "移除字典指定键值对",
  T_48_META_API_1604_P0_D: "目标字典",
  T_48_META_API_1604_P1_D: "键",
  T_48_META_API_1605_D: "清空字典中所有键值对",
  T_48_META_API_1605_P0_D: "目标字典",
  T_48_META_API_1606_D: "获取字典中键值对的数量",
  T_48_META_API_1606_P0_D: "目标字典",
  T_48_META_API_1606_R_D: "字典长度",
  T_48_META_API_1607_D: "判断字典中某个键是否存在",
  T_48_META_API_1607_P0_D: "目标字典",
  T_48_META_API_1607_P1_D: "键",
  T_48_META_API_1607_R_D: "是否存在",
  T_48_META_API_1608_D: "获取字典的所有键，以列表形式返回",
  T_48_META_API_1608_P0_D: "目标字典",
  T_48_META_API_1608_R_D: "所有键值的列表",
  T_48_META_API_17_D: "使用一个直线运动的盒形区域进行检测，从近到远地返回盒形区域路线上碰到的所有实体，初始即在盒形范围内则不会检测出来；层级参若填空，则可以检测到地形",
  T_48_META_API_17_P0_D: "盒形区域三条边长的一半，只接受正值",
  T_48_META_API_17_P1_D: "盒形区域中心点",
  T_48_META_API_17_P2_D: "盒形区域旋转",
  T_48_META_API_17_P3_D: "盒形区域行进方向",
  T_48_META_API_17_P4_D: "盒形区域行进距离，只接受正值",
  T_48_META_API_17_P5_D: "层遮罩，只有填入的层级会参与扫描，留空代表所有层级都参与扫描",
  T_48_META_API_17_P6_D: "是否可以检测出触发器",
  T_48_META_API_17_P7_D: "命中的实体列表",
  T_48_META_API_1700_D: "将指定字符串转为整数",
  T_48_META_API_1700_P0_D: "目标字符串",
  T_48_META_API_1700_P1_D: "结果整数",
  T_48_META_API_1700_P2_D: "是否转化成功",
  T_48_META_API_1701_D: "将指定字符串转为浮点数",
  T_48_META_API_1701_P0_D: "目标字符串",
  T_48_META_API_1701_P1_D: "结果浮点数",
  T_48_META_API_1701_P2_D: "是否转化成功",
  T_48_META_API_18_D: "使用一个直线运动的球形区域进行检测，从近到远地返回球形区域路线上碰到的所有实体，初始即在球形区域内则不会检测出来；层级参若填空，则可以检测到地形",
  T_48_META_API_18_P0_D: "球形区域半径，只接受正值",
  T_48_META_API_18_P1_D: "球形区域中心点",
  T_48_META_API_18_P2_D: "球形区域行进方向",
  T_48_META_API_18_P3_D: "球形区域行进距离，只接受正值",
  T_48_META_API_18_P4_D: "层遮罩，只有填入的层级会参与扫描，留空代表所有层级都参与扫描",
  T_48_META_API_18_P5_D: "是否可以检测出触发器",
  T_48_META_API_18_P6_D: "命中的实体列表",
  T_48_META_API_19_D: "使用一个直线运动的胶囊体区域进行检测，从近到远地返回胶囊体区域路线上碰到的所有实体，初始即在胶囊体区域内则不会检测出来；层级参若填空，则可以检测到地形",
  T_48_META_API_19_P0_D: "胶囊体区域两端半球半径，只接受正值",
  T_48_META_API_19_P1_D: "胶囊体区域两端半球球心距离，该值必须大于两端半球半径的二倍",
  T_48_META_API_19_P2_D: "胶囊体区域的中心点",
  T_48_META_API_19_P3_D: "胶囊体区域的旋转",
  T_48_META_API_19_P4_D: "胶囊体区域的行进方向",
  T_48_META_API_19_P5_D: "胶囊体区域的行进距离，只接受正值",
  T_48_META_API_19_P6_D: "层遮罩，只有填入的层级会参与扫描，留空代表所有层级都参与扫描",
  T_48_META_API_19_P7_D: "是否可以检测出触发器",
  T_48_META_API_19_P8_D: "命中的实体列表",
  T_48_META_API_2_D: "获取当前游戏中所有队伍，返回队伍列表。",
  T_48_META_API_2_R_D: "队伍列表",
  T_48_META_API_20_D: "使用一个静止的盒形区域进行检测，返回盒形区域内的所有实体，层级参若填空，则可以检测到地形",
  T_48_META_API_20_P0_D: "盒形区域三条边长的一半，只接受正值",
  T_48_META_API_20_P1_D: "盒形区域中心点",
  T_48_META_API_20_P2_D: "盒形区域旋转",
  T_48_META_API_20_P3_D: "层遮罩，只有填入的层级会参与扫描，留空代表所有层级都参与扫描",
  T_48_META_API_20_P4_D: "是否可以检测出触发器",
  T_48_META_API_20_P5_D: "命中的实体列表",
  T_48_META_API_2000_D: "设置目标实体的属性值，需要该属性已经被定义过",
  T_48_META_API_2000_P0_D: "目标实体",
  T_48_META_API_2000_P1_D: "目标实体的某个属性",
  T_48_META_API_2000_P2_D: "目标值，需要符合属性定义时要求的类型",
  T_48_META_API_2000_P3_D: "运算方式，所有类型都支持赋值，数字类型还支持自加、自减、自乘、自除、自余",
  T_48_META_API_2001_D: "获取一个实体的属性值",
  T_48_META_API_2001_P0_D: "目标实体",
  T_48_META_API_2001_P1_D: "该实体的某个属性ID",
  T_48_META_API_2001_R_D: "属性值",
  T_48_META_API_2002: "设置Graph属性",
  T_48_META_API_2002_D: "设置脚本变量",
  T_48_META_API_2002_P0_D: "目标实体",
  T_48_META_API_2002_P1: "图ID",
  T_48_META_API_2002_P1_D: "目标脚本ID",
  T_48_META_API_2002_P2: "属性ID",
  T_48_META_API_2002_P2_D: "脚本中定义的成员属性ID",
  T_48_META_API_2002_P3: "属性值",
  T_48_META_API_2002_P3_D: "目标值，需要符合属性定义时要求的类型",
  T_48_META_API_2002_P4_D: "运算方式，所有类型都支持赋值，数字类型还支持自加、自减、自乘、自除、自余",
  T_48_META_API_2003: "获取Graph属性",
  T_48_META_API_2003_D: "获取脚本变量",
  T_48_META_API_2003_P0_D: "目标实体",
  T_48_META_API_2003_P1: "图ID",
  T_48_META_API_2003_P1_D: "目标脚本ID",
  T_48_META_API_2003_P2: "属性ID",
  T_48_META_API_2003_P2_D: "目标属性ID",
  T_48_META_API_2003_R_D: "属性值",
  T_48_META_API_2004_D: "定义并初始化一个局部变量，局部变量作用域为从声明位置开始到所在语句块结束",
  T_48_META_API_2004_P0_D: "变量名称",
  T_48_META_API_2004_P1_D: "变量初始值",
  T_48_META_API_2004_P2_D: "变量声明类型，赋值时需要符合声明的类型",
  T_48_META_API_2005_D: "设置局部变量值，局部变量作用域为从声明位置开始到所在语句块结束",
  T_48_META_API_2005_P0_D: "变量名称",
  T_48_META_API_2005_P1: "变量值",
  T_48_META_API_2005_P1_D: "变量值",
  T_48_META_API_2005_P2_D: "运算方式，所有类型都支持赋值，数字类型还支持自加、自减、自乘、自除、自余",
  T_48_META_API_2006: "获取局部变量值",
  T_48_META_API_2006_D: "获取局部变量值，局部变量作用域为从声明位置开始到所在语句块结束",
  T_48_META_API_2006_P0: "变量名",
  T_48_META_API_2006_P0_D: "变量名称",
  T_48_META_API_2006_R_D: "变量值",
  T_48_META_API_2009: "串行调用全局函数",
  T_48_META_API_2009_D: "以串行的方式调用全局自定义函数，如果自定义函数中存在等待，则调用位置也进行等待",
  T_48_META_API_2009_P0: "图ID",
  T_48_META_API_2009_P0_D: "自定义函数所在的脚本ID",
  T_48_META_API_2009_P1: "函数ID",
  T_48_META_API_2009_P1_D: "调用的自定义函数ID",
  T_48_META_API_2009_P2_D: "传递给自定义函数的参数列表",
  T_48_META_API_2010: "并行调用全局函数",
  T_48_META_API_2010_D: "以并行的方式调用全局自定义函数，无论自定义函数中是否存在等待，都会立即返回调用位置继续向下执行",
  T_48_META_API_2010_P0: "图ID",
  T_48_META_API_2010_P0_D: "自定义函数所在的脚本ID",
  T_48_META_API_2010_P1: "函数ID",
  T_48_META_API_2010_P1_D: "调用的自定义函数ID",
  T_48_META_API_2010_P2_D: "传递给自定义函数的参数列表",
  T_48_META_API_2013: "设置当前Graph属性",
  T_48_META_API_2013_D: "设置当前脚本的变量",
  T_48_META_API_2013_P0: "属性ID",
  T_48_META_API_2013_P0_D: "目标属性ID",
  T_48_META_API_2013_P1: "属性值",
  T_48_META_API_2013_P1_D: "目标值",
  T_48_META_API_2013_P2_D: "运算方式，所有类型都支持赋值，数字类型还支持自加、自减、自乘、自除、自余",
  T_48_META_API_2014: "获取当前Graph属性",
  T_48_META_API_2014_D: "获取当前脚本的变量",
  T_48_META_API_2014_P0: "属性ID",
  T_48_META_API_2014_P0_D: "目标属性ID",
  T_48_META_API_2014_R_D: "属性值",
  T_48_META_API_21_D: "使用一个静止的球形区域进行检测，返回球形区域内的所有实体，层级参若填空，则可以检测到地形",
  T_48_META_API_21_P0_D: "球形区域半径，只接受正值",
  T_48_META_API_21_P1_D: "球形区域中心点",
  T_48_META_API_21_P2_D: "层遮罩，只有填入的层级会参与扫描，留空代表所有层级都参与扫描",
  T_48_META_API_21_P3_D: "是否可以检测出触发器",
  T_48_META_API_21_P4_D: "命中的实体列表",
  T_48_META_API_22_D: "使用一个静止的胶囊体区域进行检测，返回胶囊体区域内的所有实体，层级参若填空，则可以检测到地形",
  T_48_META_API_22_P0_D: "胶囊体区域两端半球半径，只接受正值",
  T_48_META_API_22_P1_D: "胶囊体区域两端半球球心距离，该值必须大于两端半球半径的二倍",
  T_48_META_API_22_P2_D: "胶囊体区域的中心点",
  T_48_META_API_22_P3_D: "胶囊体区域的旋转",
  T_48_META_API_22_P4_D: "层遮罩，只有填入的层级会参与扫描，留空代表所有层级都参与扫描",
  T_48_META_API_22_P5_D: "是否可以检测出触发器",
  T_48_META_API_22_P6_D: "命中的实体列表",
  T_48_META_API_23_D: "为玩家设置特殊物品状态，特殊物品只能拥有一个",
  T_48_META_API_23_P0_D: "玩家",
  T_48_META_API_23_P1_D: "物品ID",
  T_48_META_API_23_P2_D: "是否启用该物品",
  T_48_META_API_23_P3_D: "特殊物品实体",
  T_48_META_API_24_D: "对目标施加一次力，目标必须为物理物件",
  T_48_META_API_24_P0_D: "目标物理物件",
  T_48_META_API_24_P1_D: "力矢量",
  T_48_META_API_24_P2_D: "力的类型",
  T_48_META_API_25_D: "在某点施加一次力，目标必须为刚体",
  T_48_META_API_25_P0_D: "目标刚体",
  T_48_META_API_25_P1_D: "力矢量",
  T_48_META_API_25_P2_D: "施力位置",
  T_48_META_API_25_P3_D: "力的类型",
  T_48_META_API_26_D: "对目标施加一次扭矩，目标必须为刚体",
  T_48_META_API_26_P0_D: "目标刚体",
  T_48_META_API_26_P1_D: "扭矩",
  T_48_META_API_26_P2_D: "施力类型",
  T_48_META_API_27_D: "移动目标刚体到指定位置",
  T_48_META_API_27_P0_D: "目标刚体",
  T_48_META_API_27_P1_D: "指定位置",
  T_48_META_API_28_D: "旋转目标刚体",
  T_48_META_API_28_P0_D: "目标刚体",
  T_48_META_API_28_P1_D: "旋转四元数",
  T_48_META_API_29_D: "创建插值运动，目标实体的指定属性将按照设定进行平滑运动",
  T_48_META_API_29_P0_D: "目标实体",
  T_48_META_API_29_P1_D: "需要进行运动变化的属性ID",
  T_48_META_API_29_P2_D: "属性起始值",
  T_48_META_API_29_P3_D: "属性结束值",
  T_48_META_API_29_P4_D: `可以选择单次、循环和往复。
循环表示每次运动完成后，实体会从起始值再进行一次运动。往复表示从起始值到目标值运动完成后，实体会从目标值再向起始值运动一次，然后重复这个过程`,
  T_48_META_API_29_P5_D: "贝塞尔曲线控制点",
  T_48_META_API_29_P6_D: "一次变化的时长，单位是毫秒",
  T_48_META_API_29_P7_D: "创建出的插值运动实体",
  T_48_META_API_29_P8_D: "创建后是否自动开始播放",
  T_48_META_API_3_D: "切换游戏至目标阶段，回合也是一种特殊阶段。切换至回合中的阶段时，回合计数为0。",
  T_48_META_API_3_P0_D: "目标回合或阶段的索引",
  T_48_META_API_30_D: "强制目标玩家进入指定载具",
  T_48_META_API_30_P0_D: "目标玩家",
  T_48_META_API_30_P1_D: "载具实体",
  T_48_META_API_30_P2_D: "座位编号",
  T_48_META_API_30_P3_D: "是否成功使玩家进入载具",
  T_48_META_API_3001_D: "使目标玩家丢弃物品",
  T_48_META_API_3001_P0_D: "目标玩家",
  T_48_META_API_3001_P1_D: "物品实体",
  T_48_META_API_3002_D: "获取当前可用没有完全占满的随机出生点内可用坐标（已废弃，请使用GetRandomSpawnPosition）",
  T_48_META_API_3002_P0_D: "需要分配出生点区域的玩家",
  T_48_META_API_3002_R_D: "随机分配到的随机点坐标",
  T_48_META_API_3003_D: "获取玩家指定积分类型的总分值",
  T_48_META_API_3003_P0_D: "玩家",
  T_48_META_API_3003_P1_D: "积分类型",
  T_48_META_API_3003_R_D: "积分值",
  T_48_META_API_3004_D: "设置玩家指定积分类型的回合分值",
  T_48_META_API_3004_P0_D: "玩家实体",
  T_48_META_API_3004_P1_D: "积分类型",
  T_48_META_API_3004_P2_D: "积分值",
  T_48_META_API_3005_D: "获取队伍指定积分类型的总分值",
  T_48_META_API_3005_P0_D: "队伍实体",
  T_48_META_API_3005_P1_D: "积分类型",
  T_48_META_API_3005_R_D: "积分值",
  T_48_META_API_3006_D: "设置队伍指定积分类型的回合分值",
  T_48_META_API_3006_P0_D: "队伍实体",
  T_48_META_API_3006_P1_D: "积分类型",
  T_48_META_API_3006_P2_D: "积分值",
  T_48_META_API_3007_D: "获取玩家指定回合、积分类型的分值",
  T_48_META_API_3007_P0_D: "玩家实体",
  T_48_META_API_3007_P1_D: "回合索引",
  T_48_META_API_3007_P2_D: "积分类型",
  T_48_META_API_3007_R_D: "积分值",
  T_48_META_API_3008_D: "获取队伍指定回合、积分类型的分值",
  T_48_META_API_3008_P0_D: "队伍实体",
  T_48_META_API_3008_P1_D: "回合索引",
  T_48_META_API_3008_P2_D: "积分类型",
  T_48_META_API_3008_R_D: "积分值",
  T_48_META_API_3009_D: "获取玩家游戏总排名",
  T_48_META_API_3009_P0_D: "玩家实体",
  T_48_META_API_3009_R_D: "名次",
  T_48_META_API_3011_D: "获取队伍游戏总排名",
  T_48_META_API_3011_P0_D: "已废弃",
  T_48_META_API_3011_R_D: "名次",
  T_48_META_API_3013_D: "获取玩家指定回合排名",
  T_48_META_API_3013_P0_D: "玩家实体",
  T_48_META_API_3013_P1_D: "回合索引",
  T_48_META_API_3013_R_D: "名次",
  T_48_META_API_3014_D: "获取队伍指定回合排名",
  T_48_META_API_3014_P0_D: "已废弃",
  T_48_META_API_3014_P1_D: "回合索引",
  T_48_META_API_3014_R_D: "名次",
  T_48_META_API_3015_D: "获取目标实体的钱包",
  T_48_META_API_3015_P0_D: "目标实体",
  T_48_META_API_3015_P1_D: "是否存在钱包",
  T_48_META_API_3015_P2_D: "取得的钱包实体",
  T_48_META_API_3016_D: "为目标玩家创建钱包，若玩家已有钱包则无效",
  T_48_META_API_3016_P0_D: "目标玩家",
  T_48_META_API_3016_P1_D: "钱包绑定的实体，钱包的拥有者",
  T_48_META_API_3016_P2_D: "钱包实体",
  T_48_META_API_3017_D: "为指定钱包增加货币",
  T_48_META_API_3017_P0_D: "目标钱包",
  T_48_META_API_3017_P1_D: "增加的货币类型",
  T_48_META_API_3017_P2_D: "增加的货币数量",
  T_48_META_API_3018_D: "为指定钱包减少货币",
  T_48_META_API_3018_P0_D: "目标钱包",
  T_48_META_API_3018_P1_D: "减少的货币类型",
  T_48_META_API_3018_P2_D: "减少的货币数量",
  T_48_META_API_3019_D: "将一个钱包中的货币转移到另一个钱包中",
  T_48_META_API_3019_P0_D: "转出货币的钱包",
  T_48_META_API_3019_P1_D: "转移货币的类型",
  T_48_META_API_3019_P2_D: "转移货币的数量",
  T_48_META_API_3019_P3_D: "转入货币的钱包",
  T_48_META_API_3020_D: "获得指定钱包中指定类型货币的数量",
  T_48_META_API_3020_P0_D: "目标钱包",
  T_48_META_API_3020_P1_D: "查询的货币类型",
  T_48_META_API_3020_R_D: "货币数量",
  T_48_META_API_3021_D: "获取指定钱包中指定类型货币的实体",
  T_48_META_API_3021_P0_D: "目标钱包",
  T_48_META_API_3021_P1_D: "查询的货币类型",
  T_48_META_API_3021_R_D: "货币实体",
  T_48_META_API_3022_D: "获取游戏中的所有商店，以列表形式返回",
  T_48_META_API_3022_R_D: "商店实体列表",
  T_48_META_API_3023_D: "将目标玩家的外形替换为指定场景物件的外形",
  T_48_META_API_3023_P0_D: "目标玩家",
  T_48_META_API_3023_P1_D: "替换的目标场景物件",
  T_48_META_API_3023_P2_D: "替换后创建出的玩家变身伪装组件",
  T_48_META_API_3024_D: "取消玩家的伪装状态",
  T_48_META_API_3024_P0_D: "目标玩家",
  T_48_META_API_3025_D: "在目标玩家处创建一个场景实体外形的分身",
  T_48_META_API_3025_P0_D: "目标玩家",
  T_48_META_API_3025_P1_D: "用于分身形象的场景实体",
  T_48_META_API_3025_P2_D: "创建出的分身实体",
  T_48_META_API_3026_D: "获取玩家的伪装实体",
  T_48_META_API_3026_P0_D: "玩家",
  T_48_META_API_3026_R_D: "玩家伪装实体",
  T_48_META_API_3027_D: "根据索引获取聊天频道实体",
  T_48_META_API_3027_P0_D: "聊天频道索引，范围[1,8]",
  T_48_META_API_3027_R_D: "聊天频道实体",
  T_48_META_API_3028_D: "获取指定玩家当前所在的聊天频道实体",
  T_48_META_API_3028_P0_D: "目标玩家",
  T_48_META_API_3028_R_D: "聊天频道实体",
  T_48_META_API_3029_D: "使玩家加入指定聊天频道，玩家已经处于其他聊天频道时会切换至目标频道",
  T_48_META_API_3029_P0_D: "目标玩家",
  T_48_META_API_3029_P1_D: "聊天频道实体",
  T_48_META_API_3030_D: "使玩家退出当前所在频道，之后处于不在任何聊天频道的状态",
  T_48_META_API_3030_P0_D: "目标玩家",
  T_48_META_API_3031_D: "已废弃",
  T_48_META_API_3031_P0_D: "聊天频道实体，频道中无玩家时为空",
  T_48_META_API_3032_D: "设置玩家的行为状态",
  T_48_META_API_3032_P0_D: "目标玩家",
  T_48_META_API_3032_P1_D: "玩家行为类型",
  T_48_META_API_3032_P2_D: `启用：有HUD按钮，正常可用
禁用：HUD按钮为禁止状态，无法主动或被动进入该行为状态
屏蔽：HUD按钮隐藏，无法主动进入该行为状态，但是可以被动进入该行为状态`,
  T_48_META_API_3033_D: "玩家变身为指定场景物件",
  T_48_META_API_3033_P0_D: "目标玩家",
  T_48_META_API_3033_P1_D: "要变身为的物件",
  T_48_META_API_3033_P2_D: "变身后创建的实体",
  T_48_META_API_3034_D: "玩家创建一个自身外观的分身",
  T_48_META_API_3034_P0_D: "目标玩家",
  T_48_META_API_3034_P1_D: "创建的分身实体",
  T_48_META_API_3035_D: "创建一个自定义商店，商店的下一层级是货架",
  T_48_META_API_3035_P0_D: "创建的商店实体",
  T_48_META_API_3036_D: "创建一个自定义货架，货架的上一层级是商店，下一层级是商品",
  T_48_META_API_3036_P0_D: "创建的货架实体",
  T_48_META_API_3037_D: "创建一个自定义商品，商品可以添加物品",
  T_48_META_API_3037_P0_D: "创建的商品实体",
  T_48_META_API_3038_D: "添加物品到商品，可以通过多次使用该图元将复数个物品加入一个商品中",
  T_48_META_API_3038_P0_D: "商品实体",
  T_48_META_API_3038_P1_D: "要添加的物品",
  T_48_META_API_3038_P2_D: "物品数量",
  T_48_META_API_3039_D: "给予越狱奖励",
  T_48_META_API_3039_P0_D: "玩家实体",
  T_48_META_API_3039_P1_D: "数量",
  T_48_META_API_3039_P2_D: "真实货币",
  T_48_META_API_3040_D: "更新越狱任务",
  T_48_META_API_3040_P0_D: "玩家实体",
  T_48_META_API_3040_P1_D: "任务ID",
  T_48_META_API_3040_P2_D: "值",
  T_48_META_API_3041_D: "获取随机出生点坐标，只会从没有完全占满的可用出生点中随机",
  T_48_META_API_3041_P0_D: "目标玩家",
  T_48_META_API_3041_R_D: "随机出生点坐标，没有符合条件的出生点时会返回靠近(0, 0, 0)的位置",
  T_48_META_API_3042_D: "退出越狱小游戏",
  T_48_META_API_3042_P0_D: "玩家实体",
  T_48_META_API_3042_P1_D: "任务ID",
  T_48_META_API_3043_D: "基于越狱道具",
  T_48_META_API_3043_P0_D: "玩家实体",
  T_48_META_API_3043_P1_D: "道具类型",
  T_48_META_API_3043_P2_D: "道具ID",
  T_48_META_API_31_D: "创建相对自身运动，目标实体每次相对自身当前属性值进行变化",
  T_48_META_API_31_P0_D: "目标实体",
  T_48_META_API_31_P1_D: "需要进行运动变化的属性",
  T_48_META_API_31_P2_D: "每次运动的变化量",
  T_48_META_API_31_P3_D: "贝塞尔曲线控制点",
  T_48_META_API_31_P4_D: `单次：属性变化Delta量即停止
循环：重复进行运动，每次属性变化Delta量`,
  T_48_META_API_31_P5_D: "一次变化的时长，单位是毫秒",
  T_48_META_API_31_P6_D: "创建出的相对自身运动实体",
  T_48_META_API_31_P7_D: "创建后是否自动开始播放",
  T_48_META_API_3100_D: "目标播放指定状态下的动画",
  T_48_META_API_3100_P0_D: "播放动画的可挂载动画控制器的实体组件",
  T_48_META_API_3100_P1_D: "动画控制器的指定状态",
  T_48_META_API_3100_P2_D: "动画播放速度缩放",
  T_48_META_API_3100_P3_D: "循环类型，可以保持动画原逻辑、只播放一次或循环播放",
  T_48_META_API_3101_D: "播放角色动画，支持自定义动画资源",
  T_48_META_API_3101_P0_D: "目标玩家",
  T_48_META_API_3101_P1_D: "自定义动画资源ID",
  T_48_META_API_3101_P2_D: "是否循环播放",
  T_48_META_API_3102_D: "设置指定玩家的角色资源",
  T_48_META_API_3102_P0_D: "目标玩家",
  T_48_META_API_3102_P1_D: "自定义角色资源ID",
  T_48_META_API_3109_D: "开启会平滑移动至终点的安全区",
  T_48_META_API_3109_P0_D: "安全区起始位置",
  T_48_META_API_3109_P1_D: "安全区终点位置",
  T_48_META_API_3109_P2_D: "安全区初始半径",
  T_48_META_API_3109_P3_D: "安全区最终半径",
  T_48_META_API_3109_P4_D: "安全区达到最终状态所需的时间，单位为秒",
  T_48_META_API_3109_P5_D: "在安全区外承受的每秒伤害量",
  T_48_META_API_3110_D: "切换角色外观组",
  T_48_META_API_3110_P0_D: "目标",
  T_48_META_API_3110_P1_D: "外观组",
  T_48_META_API_3111_D: "显示角色外观组",
  T_48_META_API_3111_P0_D: "目标",
  T_48_META_API_3111_P1_D: "外观组",
  T_48_META_API_3112_D: "隐藏角色外观组",
  T_48_META_API_3112_P0_D: "目标",
  T_48_META_API_3112_P1_D: "外观组",
  T_48_META_API_3121_D: "发送断言结果给Craftland Studio PC统计使用",
  T_48_META_API_3121_P0_D: "断言表达式",
  T_48_META_API_3121_P1_D: "提示",
  T_48_META_API_32_D: "获取玩家今日token数据",
  T_48_META_API_32_P0_D: "目标玩家",
  T_48_META_API_32_P1_D: "tokenID",
  T_48_META_API_32_P2_D: "token数量",
  T_48_META_API_32_P3_D: "图元是否成功调用",
  T_48_META_API_3200_D: "为玩家添加物品，返回发放的物品列表",
  T_48_META_API_3200_P0_D: "玩家",
  T_48_META_API_3200_P1_D: "物品ID",
  T_48_META_API_3200_P2_D: "物品数量",
  T_48_META_API_3200_P3_D: "为玩家添加的物品列表，即使只添加一个物品也以列表返回",
  T_48_META_API_3201_D: "为指定玩家回复血量，不会超过血量上限",
  T_48_META_API_3201_P0_D: "目标玩家",
  T_48_META_API_3201_P1_D: "为玩家加血的值，只接受正数",
  T_48_META_API_3202_D: "设置目标玩家的技能列表",
  T_48_META_API_3202_P0_D: "目标玩家",
  T_48_META_API_3202_P1_D: "技能列表",
  T_48_META_API_3203_D: "获取目标玩家的技能列表",
  T_48_META_API_3203_P0_D: "目标玩家",
  T_48_META_API_3203_R_D: "技能列表",
  T_48_META_API_3205_D: "删除玩家一定数量的物品",
  T_48_META_API_3205_P0_D: "目标玩家",
  T_48_META_API_3205_P1_D: "要删除的物品类型",
  T_48_META_API_3205_P2_D: "要删除的数量，超过玩家持有数量则只删除持有的物品",
  T_48_META_API_3206_D: "获取玩家持有的指定物品数量",
  T_48_META_API_3206_P0_D: "目标玩家",
  T_48_META_API_3206_P1_D: "物品类型",
  T_48_META_API_3206_R_D: "玩家持有的数量",
  T_48_META_API_3207_D: "检测玩家是否可触发当前检查点",
  T_48_META_API_3207_P0_D: "目标玩家",
  T_48_META_API_3207_P1_D: "触发器",
  T_48_META_API_3207_R_D: "真: 可以触发，假: 不可以触发",
  T_48_META_API_3208_D: "感染模式僵尸进化",
  T_48_META_API_3208_P0_D: "目标玩家",
  T_48_META_API_3209_D: "AI实体停止/执行默认的行为树",
  T_48_META_API_3209_P0_D: "要启用行为树的目标",
  T_48_META_API_3209_P1_D: "是否执行默认行为树",
  T_48_META_API_3210_D: "AI实体追击指定目标",
  T_48_META_API_3210_P0_D: "执行追击的AI实体",
  T_48_META_API_3210_P1_D: "被追击的目标",
  T_48_META_API_3211_D: "摧毁玩家物品（已废弃，请使用DeleteEquipment）",
  T_48_META_API_3211_P0_D: "被摧毁物品的玩家",
  T_48_META_API_3211_P1_D: "被摧毁物品类型",
  T_48_META_API_3211_P2_D: "武器槽位,仅对武器生效",
  T_48_META_API_3212_D: "更换球衣",
  T_48_META_API_3212_P0_D: "目标玩家",
  T_48_META_API_3212_P1_D: "衣服样式",
  T_48_META_API_3212_P2_D: "主要颜色一",
  T_48_META_API_3212_P3_D: "主要颜色二",
  T_48_META_API_3212_P4_D: "配置",
  T_48_META_API_3213_D: "将玩家球衣恢复成初始状态",
  T_48_META_API_3213_P0_D: "目标玩家",
  T_48_META_API_3214_D: "开关玩家语音聊天",
  T_48_META_API_3214_P0_D: "目标玩家",
  T_48_META_API_3214_P1_D: "是否关闭语音聊天，True:关闭 False:打开",
  T_48_META_API_3215_D: "开关玩家快捷聊天",
  T_48_META_API_3215_P0_D: "目标玩家",
  T_48_META_API_3215_P1_D: "是否关闭快捷聊天，True:关闭 False:打开",
  T_48_META_API_3216_D: "设置目标玩家是否可以拾取物品",
  T_48_META_API_3216_P0_D: "目标玩家",
  T_48_META_API_3216_P1_D: "是否禁止拾取物品，真：禁止拾取 假：可以拾取",
  T_48_META_API_3217_D: "设置目标玩家是否可以丢弃物品",
  T_48_META_API_3217_P0_D: "目标玩家",
  T_48_META_API_3217_P1_D: "是否禁止丢弃物品，真：禁止拾取 假：可以拾取",
  T_48_META_API_3218_D: "摧毁玩家指定槽位内的武器",
  T_48_META_API_3218_P0_D: "目标玩家",
  T_48_META_API_3218_P1_D: "要摧毁的武器槽位",
  T_48_META_API_3218_P2_D: "要摧毁的数量",
  T_48_META_API_3218_P3_D: "是否成功销毁，武器槽位上没有装备武器时会销毁失败",
  T_48_META_API_3219_D: "清空目标玩家背包中所有物品，包括已装备物品",
  T_48_META_API_3219_P0_D: "目标玩家",
  T_48_META_API_3220_D: "设置玩家朝向",
  T_48_META_API_3220_P0_D: "目标玩家",
  T_48_META_API_3220_P1_D: "玩家朝向",
  T_48_META_API_3221_D: "（已废弃，请勿使用，相关信息见属性<Player>:Skeleton）",
  T_48_META_API_3221_P0_D: "玩家实体",
  T_48_META_API_3221_P1_D: "缩放部位",
  T_48_META_API_3221_P2_D: "缩放值",
  T_48_META_API_3222_D: "给予玩家击飞效果，目标玩家会以固定的加速度下坠、并且空中发生撞击后会强制停止击飞",
  T_48_META_API_3222_P0_D: "目标玩家",
  T_48_META_API_3222_P1_D: "击飞方向",
  T_48_META_API_3222_P2_D: "击飞时长",
  T_48_META_API_3222_P3_D: "击飞时Y轴的初速度",
  T_48_META_API_3222_P4_D: "击飞时XZ平面的初速度",
  T_48_META_API_3222_P5_D: "是否改变玩家朝向",
  T_48_META_API_3223_D: "获取目标玩家或NPC的服装ID",
  T_48_META_API_3223_P0_D: "目标玩家或NPC",
  T_48_META_API_3223_P1_D: "服装类型",
  T_48_META_API_3223_R_D: "服装ID",
  T_48_META_API_3224_D: "设置目标玩家或NPC的服装ID",
  T_48_META_API_3224_P0_D: "目标玩家或NPC",
  T_48_META_API_3224_P1_D: "服装ID",
  T_48_META_API_3225_D: "恢复目标玩家的默认服装，无法作用于NPC",
  T_48_META_API_3225_P0_D: "目标玩家",
  T_48_META_API_3226_D: "AI实体攻击指定目标",
  T_48_META_API_3226_P0_D: "执行攻击的AI实体",
  T_48_META_API_3226_P1_D: "被攻击的目标",
  T_48_META_API_3227_D: "切换玩家武器为指定槽位的武器",
  T_48_META_API_3227_P0_D: "目标玩家",
  T_48_META_API_3227_P1_D: "要切换的武器槽位",
  T_48_META_API_3227_P2_D: "是否成功切换，武器槽位上没有装备武器时会切换失败",
  T_48_META_API_3228_D: "获取目标玩家或NPC的武器皮肤",
  T_48_META_API_3228_P0_D: "目标玩家或NPC",
  T_48_META_API_3228_P1_D: "武器皮肤ID",
  T_48_META_API_3228_R_D: "武器皮肤ID",
  T_48_META_API_3229_D: "设置目标玩家或NPC的武器皮肤",
  T_48_META_API_3229_P0_D: "目标玩家或NPC",
  T_48_META_API_3229_P1_D: "武器皮肤ID",
  T_48_META_API_3230_D: "恢复目标玩家的默认武器皮肤，无法作用于NPC",
  T_48_META_API_3230_P0_D: "目标玩家",
  T_48_META_API_3230_P1_D: "武器ID",
  T_48_META_API_3231_D: "设置玩家的套装",
  T_48_META_API_3231_P0_D: "目标玩家",
  T_48_META_API_3231_P1_D: "服装列表",
  T_48_META_API_3232_D: "去除目标玩家或NPC指定服装类型的所有服装",
  T_48_META_API_3232_P0_D: "目标玩家或NPC",
  T_48_META_API_3232_P1_D: "服装类型",
  T_48_META_API_3233_D: "去除玩家或NPC指定武器的皮肤",
  T_48_META_API_3233_P0_D: "目标玩家或NPC",
  T_48_META_API_3233_P1_D: "武器ID",
  T_48_META_API_3234_D: "为目标添加Buff",
  T_48_META_API_3234_P0_D: "目标实体，必须为可添加Buff的实体",
  T_48_META_API_3234_P1_D: "Buff id",
  T_48_META_API_3235_D: "为目标移除Buff",
  T_48_META_API_3235_P0_D: "目标实体，必须为可添加Buff的实体",
  T_48_META_API_3235_P1_D: "Buff id",
  T_48_META_API_3236_D: "获取目标当前的Buff",
  T_48_META_API_3236_P0_D: "目标实体，必须为可添加Buff的实体",
  T_48_META_API_3236_R_D: "Buff列表",
  T_48_META_API_3237_D: "获取目标玩家背包道具栏中的道具",
  T_48_META_API_3237_P0_D: "目标玩家",
  T_48_META_API_3237_P1_D: "道具列表",
  T_48_META_API_3238_D: "为指定槽位的武器添加配件，与该槽位不匹配的配件会添加失败；匹配但重复的配件会替换掉原有的配件，原配件会送入玩家背包，玩家背包已满时原配件会掉落在玩家当时的位置",
  T_48_META_API_3238_P0_D: "目标玩家",
  T_48_META_API_3238_P1_D: "装备栏槽位",
  T_48_META_API_3238_P2_D: "配件",
  T_48_META_API_3238_P3_D: `是否成功添加配件
真：配件已装备到对应槽位的武器上
假：配件添加失败，不会出现在玩家背包`,
  T_48_META_API_3238_P4_D: "添加的配件，失败时为空",
  T_48_META_API_3239_D: "获取背包装备栏中的装备",
  T_48_META_API_3239_P0_D: "目标玩家",
  T_48_META_API_3239_P1_D: "装备栏槽位",
  T_48_META_API_3239_P2_D: "指定槽位的装备，没有装备时为空",
  T_48_META_API_3239_P3_D: "该装备的所有配件",
  T_48_META_API_3240_D: "二维向量取X分量",
  T_48_META_API_3240_P0_D: "二维向量",
  T_48_META_API_3240_R_D: "二维向量X分量",
  T_48_META_API_3241_D: "二维向量取Y分量",
  T_48_META_API_3241_P0_D: "二维向量",
  T_48_META_API_3241_R_D: "二维向量Y分量",
  T_48_META_API_3242_D: "二维向量设置X分量",
  T_48_META_API_3242_P0_D: "二维向量",
  T_48_META_API_3242_P1_D: "二维向量X分量",
  T_48_META_API_3243_D: "二维向量设置Y分量",
  T_48_META_API_3243_P0_D: "二维向量",
  T_48_META_API_3243_P1_D: "二维向量Y分量",
  T_48_META_API_3244_D: "将两个二维向量相加",
  T_48_META_API_3244_P0_D: "左值",
  T_48_META_API_3244_P1_D: "右值",
  T_48_META_API_3244_R_D: "二维向量相加结果",
  T_48_META_API_3245_D: "将两个二维向量相减",
  T_48_META_API_3245_P0_D: "左值",
  T_48_META_API_3245_P1_D: "右值",
  T_48_META_API_3245_R_D: "二维向量相减结果",
  T_48_META_API_3246_D: "将二维向量数乘",
  T_48_META_API_3246_P0_D: "二维向量",
  T_48_META_API_3246_P1_D: "二维向量缩放值",
  T_48_META_API_3246_R_D: "二维向量数乘结果",
  T_48_META_API_3247_D: "将两个二维向量点乘，点乘结果为标量，表征两个向量间的夹角",
  T_48_META_API_3247_P0_D: "左值",
  T_48_META_API_3247_P1_D: "右值",
  T_48_META_API_3247_R_D: "点乘结果",
  T_48_META_API_3248_D: "计算两个二维向量的欧氏距离",
  T_48_META_API_3248_P0_D: "左值",
  T_48_META_API_3248_P1_D: "右值",
  T_48_META_API_3248_R_D: "两向量相减后，所得向量的模长",
  T_48_META_API_3249_D: "计算两个二维向量的夹角",
  T_48_META_API_3249_P0_D: "左值",
  T_48_META_API_3249_P1_D: "右值",
  T_48_META_API_3249_R_D: "向量夹角，角度范围0-180",
  T_48_META_API_3250_D: "对二维向量归一化",
  T_48_META_API_3250_P0_D: "二维向量",
  T_48_META_API_3250_R_D: "归一化结果，为向量同方向长度为1米的向量",
  T_48_META_API_3251_D: "对二维向量取模",
  T_48_META_API_3251_P0_D: "二维向量",
  T_48_META_API_3251_R_D: "取模结果，为向量长度",
  T_48_META_API_3252_D: "计算二维向量经法线垂直直线反射后的向量",
  T_48_META_API_3252_P0_D: "入射二维向量",
  T_48_META_API_3252_P1_D: "法线二维向量",
  T_48_META_API_3252_R_D: "反射二维向量",
  T_48_META_API_3253_D: "计算三维向量经法线垂直平面反射后的向量",
  T_48_META_API_3253_P0_D: "入射三维向量",
  T_48_META_API_3253_P1_D: "法线三维向量",
  T_48_META_API_3253_R_D: "反射三维向量",
  T_48_META_API_3254_D: "三维向量转二维向量，删除三维向量的Z分量",
  T_48_META_API_3254_P0_D: "目标三维向量",
  T_48_META_API_3254_R_D: "转换后的二维向量",
  T_48_META_API_3255_D: "二维向量转三维向量，三维向量的Z分量设置为0",
  T_48_META_API_3255_P0_D: "目标二维向量",
  T_48_META_API_3255_R_D: "转换后的三维向量",
  T_48_META_API_3256_D: "创建一个二维向量",
  T_48_META_API_3256_P0_D: "二维向量的X分量",
  T_48_META_API_3256_P1_D: "二维向量的Y分量",
  T_48_META_API_3256_R_D: "创建出的二维向量",
  T_48_META_API_3257_D: "自定义比赛埋点日志，用于用户体验数据分析",
  T_48_META_API_3257_P0_D: "日志",
  T_48_META_API_3258_D: "自定义比赛埋点日志，用于用户体验数据分析",
  T_48_META_API_3258_P0_D: "要记录上报的玩家",
  T_48_META_API_3258_P1_D: "日志",
  T_48_META_API_33_D: "脏字过滤",
  T_48_META_API_33_P0_D: "需要进行脏字过滤的原文本",
  T_48_META_API_33_R_D: "过滤后的文本",
  T_48_META_API_3301_D: "创建一个阵营实体",
  T_48_META_API_3301_P0_D: "阵营实体",
  T_48_META_API_3302_D: "目标实体加入指定阵营",
  T_48_META_API_3302_P0_D: "目标实体",
  T_48_META_API_3302_P1_D: "阵营实体",
  T_48_META_API_3303_D: "获取阵营的可攻击阵营",
  T_48_META_API_3303_P0_D: "攻击阵营",
  T_48_META_API_3303_R_D: "阵营实体列表",
  T_48_META_API_3304_D: "设置阵营的可攻击阵营",
  T_48_META_API_3304_P0_D: "攻击阵营",
  T_48_META_API_3304_P1_D: "目标阵营",
  T_48_META_API_3304_P2_D: "是否可攻击",
  T_48_META_API_3305_D: "设置可攻击玩家",
  T_48_META_API_3305_P0_D: "玩家",
  T_48_META_API_3305_P1_D: "可攻击玩家",
  T_48_META_API_3305_P2_D: "是否可攻击",
  T_48_META_API_3306_D: "设置队伍的可攻击队伍",
  T_48_META_API_3306_P0_D: "攻击队伍",
  T_48_META_API_3306_P1_D: "目标队伍",
  T_48_META_API_3306_P2_D: "是否可攻击",
  T_48_META_API_3307_D: "已废弃",
  T_48_META_API_3307_P0_D: "已废弃",
  T_48_META_API_3307_R_D: "玩家实体列表",
  T_48_META_API_3308_D: "指定实体退出当前阵营",
  T_48_META_API_3308_P0_D: "目标实体",
  T_48_META_API_3309_D: "获取目标的阵营",
  T_48_META_API_3309_P0_D: "目标实体",
  T_48_META_API_3309_R_D: "阵营实体",
  T_48_META_API_3310_D: "判断是否可以攻击目标",
  T_48_META_API_3310_P0_D: "攻击者",
  T_48_META_API_3310_P1_D: "目标实体",
  T_48_META_API_3310_R_D: "是否可攻击",
  T_48_META_API_3311_D: "设置实体的可攻击目标",
  T_48_META_API_3311_P0_D: "攻击者",
  T_48_META_API_3311_P1_D: "目标实体",
  T_48_META_API_3311_P2_D: "是否可攻击",
  T_48_META_API_3312_D: "获取实体的可攻击目标",
  T_48_META_API_3312_P0_D: "攻击者",
  T_48_META_API_3312_R_D: "可攻击的实体列表",
  T_48_META_API_34_D: "判断目标实体是否存在组件",
  T_48_META_API_34_P0_D: "目标实体",
  T_48_META_API_34_P1_D: "组件类型",
  T_48_META_API_34_R_D: "是否存在",
  T_48_META_API_35_D: "添加Bot",
  T_48_META_API_35_P0_D: "Bot难度等级",
  T_48_META_API_35_P1_D: "Bot所属队伍",
  T_48_META_API_35_P2_D: "创建出的Bot玩家实体",
  T_48_META_API_3500_D: "获取玩家token数据",
  T_48_META_API_3500_P0_D: "目标玩家",
  T_48_META_API_3500_P1_D: "tokenID",
  T_48_META_API_3500_P2_D: "token数量",
  T_48_META_API_3500_P3_D: "是否成功",
  T_48_META_API_3501_D: "给玩家添加token数据",
  T_48_META_API_3501_P0_D: "目标玩家",
  T_48_META_API_3501_P1_D: "tokenID",
  T_48_META_API_3501_P2_D: "token数量",
  T_48_META_API_3501_P3_D: "图元是否成功调用",
  T_48_META_API_3502_D: "消耗目标玩家token",
  T_48_META_API_3502_P0_D: "目标玩家",
  T_48_META_API_3502_P1_D: "tokenID",
  T_48_META_API_3502_P2_D: "token数量",
  T_48_META_API_3502_P3_D: "图元是否成功调用",
  T_48_META_API_3503_D: "在指定位置添加token",
  T_48_META_API_3503_P0_D: "位置",
  T_48_META_API_3503_P1_D: "tokenID",
  T_48_META_API_3503_P2_D: "token数量",
  T_48_META_API_3503_P3_D: "图元是否成功调用",
  T_48_META_API_3504_D: "目标AI释放指定技能",
  T_48_META_API_3504_P0_D: "目标AI",
  T_48_META_API_3504_P1_D: "技能",
  T_48_META_API_3504_P2_D: "技能目标",
  T_48_META_API_3504_P3_D: "是否成功释放技能",
  T_48_META_API_3505_D: "创建从起点到终点的寻路路径，会绕开阻挡，可以用于AI寻路",
  T_48_META_API_3505_P0_D: "起点坐标",
  T_48_META_API_3505_P1_D: "终点坐标",
  T_48_META_API_3505_P2_D: "是否成功建立寻路路径",
  T_48_META_API_3505_P3_D: "寻路点集合",
  T_48_META_API_3506_D: "设置行为树黑板变量",
  T_48_META_API_3506_P0_D: "目标行为树",
  T_48_META_API_3506_P1_D: "变量名",
  T_48_META_API_3506_P2_D: "变量值",
  T_48_META_API_3507_D: "获取行为树黑板变量",
  T_48_META_API_3507_P0_D: "目标行为树",
  T_48_META_API_3507_P1_D: "变量名",
  T_48_META_API_3507_P2_D: "变量值",
  T_48_META_API_3508_D: "获取行为树节点参数",
  T_48_META_API_3508_P0_D: "目标行为树节点",
  T_48_META_API_3508_P1_D: "参数名",
  T_48_META_API_3508_P2_D: "参数值",
  T_48_META_API_3509_D: "获取目标玩家的载具皮肤",
  T_48_META_API_3509_P0_D: "目标玩家",
  T_48_META_API_3509_P1_D: "载具ID",
  T_48_META_API_3509_R_D: "载具皮肤",
  T_48_META_API_3510_D: "设置目标玩家的载具皮肤",
  T_48_META_API_3510_P0_D: "目标玩家",
  T_48_META_API_3510_P1_D: "载具皮肤ID",
  T_48_META_API_3511_D: "清除目标玩家指定载具的皮肤",
  T_48_META_API_3511_P0_D: "目标玩家",
  T_48_META_API_3511_P1_D: "载具ID",
  T_48_META_API_3512_D: "恢复目标玩家默认的载具皮肤",
  T_48_META_API_3512_P0_D: "目标玩家",
  T_48_META_API_3512_P1_D: "载具ID",
  T_48_META_API_36_D: "休眠目标，只能用于Dynamic类型刚体",
  T_48_META_API_36_P0_D: "目标刚体",
  T_48_META_API_37_D: "唤醒目标，只能用于Dynamic类型刚体",
  T_48_META_API_37_P0_D: "目标刚体",
  T_48_META_API_38_D: "检查目标刚体是否处于休眠状态",
  T_48_META_API_38_P0_D: "目标刚体",
  T_48_META_API_38_R_D: "是否正在休眠",
  T_48_META_API_39_D: "设置休眠阈值",
  T_48_META_API_39_P0_D: "目标刚体",
  T_48_META_API_39_P1_D: "休眠阈值，刚体的运动和旋转小于该值一段时间后进入休眠状态，休眠状态的刚体不再进行物理计算",
  T_48_META_API_4_D: "设置全体玩家是否可以移动",
  T_48_META_API_4_P0_D: `真：可以移动
假：不可移动`,
  T_48_META_API_40_D: "获取休眠阈值",
  T_48_META_API_40_P0_D: "目标刚体",
  T_48_META_API_40_R_D: "休眠阈值，刚体的运动和旋转小于该值一段时间后进入休眠状态，休眠状态的刚体不再进行物理计算",
  T_48_META_API_4000_D: "读取整张表的内容，按照行的顺序返回二维数组",
  T_48_META_API_4000_P0_D: "表名",
  T_48_META_API_4000_R_D: "表的内容",
  T_48_META_API_4001_D: "读取表的某一行内容，返回数组",
  T_48_META_API_4001_P0_D: "表名",
  T_48_META_API_4001_P1_D: "要读取的行数，从1开始计算",
  T_48_META_API_4001_R_D: "表指定一行的内容",
  T_48_META_API_4002_D: "读取表某一列的内容，返回数组",
  T_48_META_API_4002_P0_D: "表名",
  T_48_META_API_4002_P1_D: "要读取的列数，从1开始计算",
  T_48_META_API_4002_R_D: "表指定一列的内容",
  T_48_META_API_4003_D: "读取表某一单元格的内容",
  T_48_META_API_4003_P0_D: "表名",
  T_48_META_API_4003_P1_D: "要读取的行数，从1开始计算",
  T_48_META_API_4003_P2_D: "要读取的列数，从1开始计算",
  T_48_META_API_4003_R_D: "表指定单元格的内容",
  T_48_META_API_4004_D: "通过行数和列名读取表某一单元格的内容",
  T_48_META_API_4004_P0_D: "表名",
  T_48_META_API_4004_P1_D: "要读取的行数，从1开始计算",
  T_48_META_API_4004_P2_D: "要读取的列名",
  T_48_META_API_4004_R_D: "表指定单元格的内容",
  T_48_META_API_4005_D: "读取整张表的内容，返回二维数组",
  T_48_META_API_4005_P0_D: "表名",
  T_48_META_API_4005_R_D: "表的内容，二维数组",
  T_48_META_API_4006_D: "读取整张表的某一行内容，返回数组",
  T_48_META_API_4006_P0_D: "表名",
  T_48_META_API_4006_P1_D: "要读取的行数，从1开始计算",
  T_48_META_API_4006_R_D: "表指定一行的内容，数组",
  T_48_META_API_4007_D: "读取整张表某一列的内容，返回数组",
  T_48_META_API_4007_P0_D: "表名",
  T_48_META_API_4007_P1_D: "要读取的列数，从1开始计算",
  T_48_META_API_4007_R_D: "表指定一列的内容，数组",
  T_48_META_API_4008_D: "读取表某一单元格的内容",
  T_48_META_API_4008_P0_D: "表名",
  T_48_META_API_4008_P1_D: "要读取的行数，从1开始计算",
  T_48_META_API_4008_P2_D: "要读取的列数，从1开始计算",
  T_48_META_API_4008_R_D: "表指定单元格的内容",
  T_48_META_API_4009_D: "通过列数和单元格的值找到指定行",
  T_48_META_API_4009_P0_D: "表名",
  T_48_META_API_4009_P1_D: "要读取的列数",
  T_48_META_API_4009_P2_D: "要查找的单元格值",
  T_48_META_API_4009_R_D: "查找到的行的内容，数组",
  T_48_META_API_4010_D: "通过列名获取列序号",
  T_48_META_API_4010_P0_D: "表名",
  T_48_META_API_4010_P1_D: "要查序号的列名称",
  T_48_META_API_4010_R_D: "列数，从1开始计算",
  T_48_META_API_41_D: "设置全局休眠阈值，仅对于新生成的Dynamic类型的刚体有效",
  T_48_META_API_41_P0_D: "休眠阈值，刚体的运动和旋转小于该值一段时间后进入休眠状态，休眠状态的刚体不再进行物理计算",
  T_48_META_API_42_D: "获取全局休眠阈值",
  T_48_META_API_42_R_D: "休眠阈值，默认为0.005，刚体的运动和旋转小于该值一段时间后进入休眠状态，休眠状态的刚体不再进行物理计算",
  T_48_META_API_43_D: "将给定四元数转化为欧拉角，欧拉角的旋转次序为YXZ，若传入的四元数不合法，返回(0,0,0)",
  T_48_META_API_43_P0_D: "输入的四元数",
  T_48_META_API_43_R_D: "返回的欧拉角",
  T_48_META_API_44_D: "将给定欧拉角转化为四元数",
  T_48_META_API_44_P0_D: "输入的欧拉角",
  T_48_META_API_44_R_D: "返回的四元数",
  T_48_META_API_45_D: "将轴角表示的旋转转化为四元数",
  T_48_META_API_45_P0_D: "旋转轴",
  T_48_META_API_45_P1_D: "绕旋转轴顺时针转动的角度",
  T_48_META_API_45_R_D: "返回的四元数",
  T_48_META_API_46_D: "将四元数转化为轴角表示",
  T_48_META_API_46_P0_D: "输入的四元数",
  T_48_META_API_46_P1_D: "旋转轴",
  T_48_META_API_46_P2_D: "绕旋转轴顺时针转动的角度",
  T_48_META_API_47_D: "设置自定义任务完成进度",
  T_48_META_API_47_P0_D: "目标玩家",
  T_48_META_API_47_P1_D: "任务ID",
  T_48_META_API_47_P2_D: "完成进度，不允许为负数",
  T_48_META_API_48_D: "创建一个贝塞尔曲线，可以用于插值运动",
  T_48_META_API_48_P0_D: "曲线控制点",
  T_48_META_API_48_R_D: "贝塞尔曲线",
  T_48_META_API_49_D: "获取场景地图ID",
  T_48_META_API_49_P0_D: "场景ID",
  T_48_META_API_49_R_D: "地图ID",
  T_48_META_API_5_D: "删除场景中的摆放物件（已废弃，请使用DeleteEntity）",
  T_48_META_API_5_P0_D: "待删除的物件实体",
  T_48_META_API_50_D: "创建相对自身每帧运动，目标实体每帧变化一次自身属性，每次相对自身当前属性值进行变化",
  T_48_META_API_50_P0_D: "目标实体",
  T_48_META_API_50_P1_D: "需要进行运动变化的属性",
  T_48_META_API_50_P2_D: "每次运动的变化量",
  T_48_META_API_50_P3_D: `与其他运动模式组合使用时的配置
真：可以与相对运动组合使用
假：可以与绝对运动组合使用`,
  T_48_META_API_50_P4_D: "创建出的相对自身每帧运动实体",
  T_48_META_API_50_P5_D: "创建后是否自动开始播放",
  T_48_META_API_5000_D: "读取数据库某个表中某个Key对应的值",
  T_48_META_API_5000_P0_D: "数据库中表名",
  T_48_META_API_5000_P1_D: "标记玩家，处理并发情况",
  T_48_META_API_5000_P2_D: "用于标识数据的自定义名",
  T_48_META_API_5000_P3_D: "返回读取的结果",
  T_48_META_API_5000_P4_D: "数据库对应的战场码",
  T_48_META_API_5001_D: "写入数据库某个表中某个Key对应的值",
  T_48_META_API_5001_P0_D: "数据库中表名",
  T_48_META_API_5001_P1_D: "标记玩家，处理并发情况",
  T_48_META_API_5001_P2_D: "用于标识数据的自定义名",
  T_48_META_API_5001_P3_D: "写入的值",
  T_48_META_API_5001_P4_D: "数据库对应的战场码，允许填空，代表当前地图战场码",
  T_48_META_API_5002_D: "删除数据库某个表中某个Key对应的值",
  T_48_META_API_5002_P0_D: "数据库中表名",
  T_48_META_API_5002_P1_D: "标记玩家，处理并发情况",
  T_48_META_API_5002_P2_D: "用于标识数据的自定义名",
  T_48_META_API_5002_P3_D: "数据库对应的战场码",
  T_48_META_API_5003_D: "读取数据库中个排行榜表中某个Key对应的值",
  T_48_META_API_5003_P0_D: "数据库中排行榜表名",
  T_48_META_API_5003_P1_D: "用于标识数据的自定义名",
  T_48_META_API_5003_P2_D: "返回读取的结果",
  T_48_META_API_5003_P3_D: "数据库对应的战场码",
  T_48_META_API_5004_D: "写入数据库某个排行榜表中某个Key对应的值",
  T_48_META_API_5004_P0_D: "数据库中排行榜表名",
  T_48_META_API_5004_P1_D: "用于标识数据的自定义名",
  T_48_META_API_5004_P2_D: "写入的值",
  T_48_META_API_5004_P3_D: "数据库对应的战场码",
  T_48_META_API_5005_D: "删除数据库某个排行榜表中某个Key对应的值",
  T_48_META_API_5005_P0_D: "数据库中表名",
  T_48_META_API_5005_P1_D: "用于标识数据的自定义名",
  T_48_META_API_5005_P2_D: "数据库对应的战场码",
  T_48_META_API_5006_D: "删除数据库某个排行榜表中某个名次对应的值",
  T_48_META_API_5006_P0_D: "数据库中表名",
  T_48_META_API_5006_P1_D: "排行榜中的名次",
  T_48_META_API_5006_P2_D: "数据库对应的战场码",
  T_48_META_API_5007_D: "读取数据库某个排行榜表中从某名次到某名次之间的值",
  T_48_META_API_5007_P0_D: "数据库中表名",
  T_48_META_API_5007_P1_D: "起始名次",
  T_48_META_API_5007_P2_D: "结束名次",
  T_48_META_API_5007_P3_D: "返回读取的结果",
  T_48_META_API_5007_P4_D: "数据库对应的战场码",
  T_48_META_API_5008_D: "读取累计数据库某个表中某个Key对应的值",
  T_48_META_API_5008_P0_D: "数据库中表名",
  T_48_META_API_5008_P1_D: "用于标识数据的自定义名",
  T_48_META_API_5008_P2_D: "返回读取的结果",
  T_48_META_API_5008_P3_D: "数据库对应的战场码",
  T_48_META_API_5009_D: "写入累计数据库某个表中某个Key对应的偏移值",
  T_48_META_API_5009_P0_D: "数据库中表名",
  T_48_META_API_5009_P1_D: "用于标识数据的自定义名",
  T_48_META_API_5009_P2_D: "四则运算的类型，目前支持以下类型：Int类型支持加、减、乘、除、余；Float类型支持加、减、乘、除",
  T_48_META_API_5009_P3_D: "写入的偏移值",
  T_48_META_API_5009_P4_D: "数据库对应的战场码",
  T_48_META_API_51_D: "重置可播放实体，将可播放实体恢复到初始形态，不改变播放状态",
  T_48_META_API_51_P0_D: "目标可播放实体",
  T_48_META_API_52_D: "将两个四元数相乘，A*B表示先旋转A再旋转B，旋转顺序不同会导致结果不同",
  T_48_META_API_52_P0_D: "左值四元数",
  T_48_META_API_52_P1_D: "右值四元数",
  T_48_META_API_52_R_D: "结果四元数",
  T_48_META_API_53_D: "创建一个朝向指定方向的旋转四元数",
  T_48_META_API_53_P0_D: "指定方向",
  T_48_META_API_53_P1_D: "上方方向",
  T_48_META_API_53_R_D: "朝指定方向对齐所需要的旋转量",
  T_48_META_API_54_D: "从A到B进行四元数球形插值",
  T_48_META_API_54_P0_D: "A值",
  T_48_META_API_54_P1_D: "B值",
  T_48_META_API_54_P2_D: "插值进度，取值范围[0,1]，取值为0时返回开始值、取值为1时返回目标值",
  T_48_META_API_54_R_D: "结果四元数",
  T_48_META_API_57_D: "将目标数据以警告形式打印到控制台",
  T_48_META_API_57_P0_D: "需要打印的内容",
  T_48_META_API_58_D: "将目标数据以报错形式打印到控制台",
  T_48_META_API_58_P0_D: "需要打印的内容",
  T_48_META_API_59_D: "获取曲线上的值",
  T_48_META_API_59_P0_D: "曲线",
  T_48_META_API_59_P1_D: "采样点，取值范围[0,1]",
  T_48_META_API_59_R_D: "结果",
  T_48_META_API_6_D: "创建场景物件到指定坐标",
  T_48_META_API_6_P0_D: "创建的场景物件实体",
  T_48_META_API_6_P1_D: "物件生成的位置",
  T_48_META_API_6_P2_D: "创建的物件类型ID，在代码脚本中使用时，需要事先在资产注册中注册关卡物件枚举",
  T_48_META_API_60_D: "根据曲线进行插值",
  T_48_META_API_60_P0_D: "值类型",
  T_48_META_API_60_P1_D: "起始值",
  T_48_META_API_60_P2_D: "目标值",
  T_48_META_API_60_P3_D: "曲线",
  T_48_META_API_60_P4_D: "采样点，取值范围[0,1]",
  T_48_META_API_60_R_D: "结果",
  T_48_META_API_6000_D: "为目标实体添加脚本",
  T_48_META_API_6000_P0_D: "目标实体",
  T_48_META_API_6000_P1_D: "脚本ID",
  T_48_META_API_6001_D: "为目标实体卸载脚本",
  T_48_META_API_6001_P0_D: "目标实体",
  T_48_META_API_6001_P1_D: "脚本ID",
  T_48_META_API_6002_D: "检查目标实体是否存在指定脚本",
  T_48_META_API_6002_P0_D: "目标实体",
  T_48_META_API_6002_P1_D: "脚本ID",
  T_48_META_API_6002_R_D: "是否存在指定脚本",
  T_48_META_API_61_D: "设置UI控件的父节点",
  T_48_META_API_61_P0_D: "父节点，可以指定UI控件或自定义UI",
  T_48_META_API_61_P1_D: "子节点",
  T_48_META_API_62_D: "已废弃",
  T_48_META_API_62_P0_D: "已废弃",
  T_48_META_API_62_P1_D: "已废弃",
  T_48_META_API_62_P2_D: "已废弃",
  T_48_META_API_62_P3_D: "已废弃",
  T_48_META_API_62_P4_D: "已废弃",
  T_48_META_API_63_D: "从当前相机到屏幕触控点创建一条射线",
  T_48_META_API_63_P0_D: "屏幕触点",
  T_48_META_API_63_P1_D: "起始点",
  T_48_META_API_63_P2_D: "射线方向",
  T_48_META_API_64_D: "上传自定义结算信息",
  T_48_META_API_64_P0_D: "玩家实体",
  T_48_META_API_64_P1_D: "比赛结果",
  T_48_META_API_64_P2_D: "积分标题",
  T_48_META_API_64_P3_D: "积分值",
  T_48_META_API_65_D: "播放指定的音效，有更多需要设置的属性时可设置它的实体属性",
  T_48_META_API_65_P0_D: "创建的音效实体",
  T_48_META_API_65_P1_D: "目标玩家，只有目标玩家可听到音效",
  T_48_META_API_65_P2_D: "音效类型",
  T_48_META_API_65_P3_D: "循环类型",
  T_48_META_API_65_P4_D: "是否立即播放",
  T_48_META_API_66_D: "创建指定视觉特效，有更多需要设置的属性时可设置它的实体属性",
  T_48_META_API_66_P0_D: "创建的特效实体",
  T_48_META_API_66_P1_D: "目标玩家，只有目标玩家可见",
  T_48_META_API_66_P2_D: "特效类型",
  T_48_META_API_66_P3_D: "循环类型",
  T_48_META_API_66_P4_D: "是否立即播放",
  T_48_META_API_67_D: "创建指定的音效，有更多需要设置的属性时可设置它的实体属性",
  T_48_META_API_67_P0_D: "创建的音效实体",
  T_48_META_API_67_P1_D: "音效类型",
  T_48_META_API_67_P2_D: "循环类型",
  T_48_META_API_67_P3_D: "是否立即播放",
  T_48_META_API_68_D: "世界坐标转换为屏幕坐标",
  T_48_META_API_68_P0_D: "世界坐标",
  T_48_META_API_68_P1_D: "是否映射在屏幕内",
  T_48_META_API_68_P2_D: "映射位置",
  T_48_META_API_69_D: "屏幕坐标转世界坐标",
  T_48_META_API_69_P0_D: "屏幕坐标",
  T_48_META_API_69_P1_D: "距屏幕距离",
  T_48_META_API_69_P2_D: "世界坐标",
  T_48_META_API_7_D: "将目标值转换为字符串",
  T_48_META_API_7_P0_D: "要转字符串的目标值",
  T_48_META_API_7_R_D: "字符串",
  T_48_META_API_70_D: "通过屏幕触控进行射线检测，返回第一个命中实体",
  T_48_META_API_70_P0_D: "起始屏幕触点",
  T_48_META_API_70_P1_D: "检测距离",
  T_48_META_API_70_P2_D: "层遮罩，只有填入的层级会参与扫描，留空代表所有层级都参与扫描",
  T_48_META_API_70_P3_D: "是否可以检测出触发器",
  T_48_META_API_70_P4_D: "命中的实体",
  T_48_META_API_70_P5_D: "命中点坐标",
  T_48_META_API_70_P6_D: "命中点距离开始点距离",
  T_48_META_API_70_P7_D: "命中表面法线",
  T_48_META_API_71_D: "通过屏幕触控进行射线检测，返回所有命中实体",
  T_48_META_API_71_P0_D: "起始屏幕触点",
  T_48_META_API_71_P1_D: "检测距离",
  T_48_META_API_71_P2_D: "层遮罩，只有填入的层级会参与扫描，留空代表所有层级都参与扫描",
  T_48_META_API_71_P3_D: "是否可以检测出触发器",
  T_48_META_API_71_P4_D: "命中的实体列表",
  T_48_META_API_71_P5_D: "命中点坐标列表",
  T_48_META_API_71_P6_D: "命中点距离开始点的距离列表",
  T_48_META_API_71_P7_D: "命中表面法线列表",
  T_48_META_API_72_D: "创建指定视觉特效，有更多需要设置的属性时可设置它的实体属性",
  T_48_META_API_72_P0_D: "创建的特效实体",
  T_48_META_API_72_P1_D: "特效类型",
  T_48_META_API_72_P2_D: "循环类型",
  T_48_META_API_72_P3_D: "是否立即播放",
  T_48_META_API_73_D: "创建内置UI，该UI不会同步给其他客户端",
  T_48_META_API_73_P0_D: "创建出的内置UI实体",
  T_48_META_API_73_P1_D: "内置UI类型",
  T_48_META_API_74_D: "创建自定义UI，该UI不会同步给其他客户端",
  T_48_META_API_74_P0_D: "创建出的自定义UI实体",
  T_48_META_API_74_P1_D: "自定义UI索引",
  T_48_META_API_75_D: "获取当前客户端对应玩家",
  T_48_META_API_75_R_D: "玩家实体",
  T_48_META_API_76_D: "创建AI怪物",
  T_48_META_API_76_P0_D: "目标AI",
  T_48_META_API_76_P1_D: "创建位置",
  T_48_META_API_76_P2_D: "AI类型",
  T_48_META_API_76_P3_D: "所属队伍",
  T_48_META_API_76_P4_D: "是否自动索敌",
  T_48_META_API_76_P5_D: "攻击模式",
  T_48_META_API_76_P6_D: "行进路径",
  T_48_META_API_77_D: "设置向量的第一个分量",
  T_48_META_API_77_P0_D: "向量",
  T_48_META_API_77_P1_D: "第一个分量值",
  T_48_META_API_77_R_D: "修改第一个分量后的向量",
  T_48_META_API_78_D: "设置向量的第二个分量",
  T_48_META_API_78_P0_D: "向量",
  T_48_META_API_78_P1_D: "第二个分量值",
  T_48_META_API_78_R_D: "修改第二个分量后的向量",
  T_48_META_API_79_D: "设置向量的第三个分量",
  T_48_META_API_79_P0_D: "向量",
  T_48_META_API_79_P1_D: "第三个分量值",
  T_48_META_API_79_R_D: "修改第三个分量后的向量",
  T_48_META_API_8_D: "开启会缩至中心坐标点的安全区",
  T_48_META_API_8_P0_D: "安全区的中心点",
  T_48_META_API_8_P1_D: "安全区的半径",
  T_48_META_API_8_P2_D: "等待时间，单位为秒，结束后安全区会开始向中心点收缩",
  T_48_META_API_8_P3_D: "安全区缩至中心点所需的时间，单位为秒",
  T_48_META_API_8_P4_D: "在安全区外承受的每秒伤害量",
  T_48_META_API_80_D: "设置二维向量的第一个分量",
  T_48_META_API_80_P0_D: "二维向量",
  T_48_META_API_80_P1_D: "第一个分量值",
  T_48_META_API_80_R_D: "修改第一个分量后的二维向量",
  T_48_META_API_81_D: "设置二维向量的第二个分量",
  T_48_META_API_81_P0_D: "二维向量",
  T_48_META_API_81_P1_D: "第二个分量值",
  T_48_META_API_81_R_D: "修改第二个分量后的二维向量",
  T_48_META_API_82_D: "将角色控制器移动到指定位置，如果作用于玩家，则玩家必须打开使用物理效果的玩家控制器才能生效",
  T_48_META_API_82_P0_D: "目标角色控制器",
  T_48_META_API_82_P1_D: "指定位置",
  T_48_META_API_83_D: "根据名称获取目标父节点实体的指定子节点",
  T_48_META_API_83_P0_D: "父节点实体",
  T_48_META_API_83_P1_D: "子节点名称",
  T_48_META_API_83_R_D: "子节点实体",
  T_48_META_API_84_D: "添加AOI特别关注，无视距离始终同步",
  T_48_META_API_84_P0_D: "特别关注的目标",
  T_48_META_API_84_P1_D: "观察者",
  T_48_META_API_85_D: "移除AOI特别关注，取消视距外AOI同步",
  T_48_META_API_85_P0_D: "特别关注的目标",
  T_48_META_API_85_P1_D: "观察者",
  T_48_META_API_86_D: "清空指定目标的全部AOI特别关注",
  T_48_META_API_86_P0_D: "特别关注的目标",
  T_48_META_API_87_D: "判断是否存在AOI特别关注",
  T_48_META_API_87_P0_D: "特别关注的目标",
  T_48_META_API_87_P1_D: "已废弃",
  T_48_META_API_87_R_D: "是否存在",
  T_48_META_API_88_D: "切换玩家的代理观察者",
  T_48_META_API_88_P0_D: "玩家",
  T_48_META_API_88_P1_D: "代理观察者",
  T_48_META_API_89_D: "将角色控制器位移一次，如果作用于玩家，则玩家必须打开使用物理效果的玩家控制器才能生效",
  T_48_META_API_89_P0_D: "目标对象，如果是玩家，则玩家必须打开使用物理效果的玩家控制器才能生效",
  T_48_META_API_89_P1_D: "位移矢量",
  T_48_META_API_9_D: "关闭安全区机制，当安全区缩到最小后，安全区外的玩家会持续受到伤害，关闭安全区机制后玩家恢复安全",
  T_48_META_API_90_D: "设置玩家是否可以自由退出",
  T_48_META_API_90_P0_D: "目标玩家",
  T_48_META_API_90_P1_D: "是否可以自由退出",
  T_48_META_API_9000_D: "创建内置UI，只有指定的玩家可以看到该UI",
  T_48_META_API_9000_P0_D: "创建出的内置UI实体",
  T_48_META_API_9000_P1_D: "UI所属的玩家实体，只有该玩家可见",
  T_48_META_API_9000_P2_D: "内置UI类型",
  T_48_META_API_9001_D: "移除内置游戏UI",
  T_48_META_API_9001_P0_D: "要移除的内置UI实体",
  T_48_META_API_9002_D: "使用指定的图标类型创建一个图标，有更多需要设置的属性时则通过实体进一步设置它的实体属性（已废弃，请使用CreateLevelObject）",
  T_48_META_API_9002_P0_D: "代码中是用来表示创建图标实体的形参名称，其对应的局部变量值是创建图标的实体",
  T_48_META_API_9002_P1_D: "所属的玩家实体，只有该玩家可见",
  T_48_META_API_9002_P2_D: "资源路径，玩家选择的图标对应的资源路径",
  T_48_META_API_9003_D: "移除指定的图标（已废弃，请使用DeleteEntity）",
  T_48_META_API_9003_P0_D: "要移除的图标实体",
  T_48_META_API_9004_D: "使用指定的文本内容创建一个文本，有更多需要设置的属性时则通过实体进一步设置它的实体属性（已废弃，请使用CreateLevelObject）",
  T_48_META_API_9004_P0_D: "代码中是用来表示创建文本实体的形参名称，其对应的局部变量值是创建文本的实体",
  T_48_META_API_9004_P1_D: "所属的玩家实体，只有该玩家可见",
  T_48_META_API_9004_P2_D: "需要呈现的文本内容",
  T_48_META_API_9005_D: "移除指定的文本（已废弃，请使用DeleteEntity）",
  T_48_META_API_9005_P0_D: "要移除的文本实体",
  T_48_META_API_9006_D: "使用指定的特效类型创建一个图标，有更多需要设置的属性时则通过实体进一步设置它的实体属性（已废弃，请使用CreateEffect）",
  T_48_META_API_9006_P0_D: "代码中是用来表示创建特效实体的形参名称，其对应的局部变量值是创建特效的实体",
  T_48_META_API_9006_P1_D: "所属的玩家实体，只有该玩家可见",
  T_48_META_API_9006_P2_D: "特效类型，玩家可以选择的特效种类",
  T_48_META_API_9007_D: "移除指定的特效（已废弃，请使用DeleteEntity）",
  T_48_META_API_9007_P0_D: "要移除的特效实体",
  T_48_META_API_9008_D: "创建自定义UI，只有指定的玩家可以看到该UI",
  T_48_META_API_9008_P0_D: "创建出的自定义UI实体",
  T_48_META_API_9008_P1_D: "UI所属的玩家实体，只有该玩家可见",
  T_48_META_API_9008_P2_D: "自定义UI索引",
  T_48_META_API_9009_D: "移除自定义游戏UI",
  T_48_META_API_9009_P0_D: "要移除的自定义UI实体",
  T_48_META_API_9010_D: "从自定义UI中获取UI控件",
  T_48_META_API_9010_P0_D: "UI所属的玩家实体",
  T_48_META_API_9010_P1_D: "自定义UI实体",
  T_48_META_API_9010_P2_D: "控件唯一索引",
  T_48_META_API_9010_R_D: "UI控件实体",
  T_48_META_API_9011_D: "播放指定的音效，有更多需要设置的属性时则通过实体进一步设置它的实体属性（已废弃，请使用CreateSound）",
  T_48_META_API_9011_P0_D: "代码中是用来表示创建音效实体的形参名称，其对应的局部变量值是创建音效的实体",
  T_48_META_API_9011_P1_D: "所属的玩家实体，只有该玩家可见",
  T_48_META_API_9011_P2_D: "音效类型，玩家可以选择的音效种类",
  T_48_META_API_9012_D: "移除指定的音效（已废弃，请使用DeleteEntity）",
  T_48_META_API_9012_P0_D: "要移除的音效实体",
  T_48_META_API_9013_D: "从自定义UI中使用路径获取一个UI控件",
  T_48_META_API_9013_P0_D: "UI所属的玩家实体",
  T_48_META_API_9013_P1_D: "自定义UI",
  T_48_META_API_9013_P2_D: "控件路径",
  T_48_META_API_9013_R_D: "UI控件实体",
  T_48_META_API_9014_D: "中断播放中的音效实体（已废弃，请使用PauseSound）",
  T_48_META_API_9014_P0_D: "需要被暂停的音效实体",
  T_48_META_API_9015_D: "继续播放音效,可选择是否从头开始播放（已废弃，请使用ResumeSound）",
  T_48_META_API_9015_P0_D: "被暂停后需要继续播放的音效实体",
  T_48_META_API_9015_P1_D: "是否从头开始",
  T_48_META_API_9016_D: "创建自定义UI控件",
  T_48_META_API_9016_P0_D: "创建的自定义控件实体",
  T_48_META_API_9016_P1_D: "创建的控件类型",
  T_48_META_API_9016_P2_D: "所属UI实体",
  T_48_META_API_9016_P3_D: "所属父控件，如果不填则以所属UI实体为父节点",
  T_48_META_API_9017_D: "设置目标相机层遮罩",
  T_48_META_API_9017_P0_D: "目标相机实体",
  T_48_META_API_9017_P1_D: "层遮罩，只有填入的层级会显示在目标相机中，留空代表所有层级都显示",
  T_48_META_API_9018_D: "获取目标相机层遮罩",
  T_48_META_API_9018_P0_D: "目标相机实体",
  T_48_META_API_9018_R_D: "层遮罩，只有层遮罩内的层级会显示在目标相机中",
  T_48_META_API_9019_D: "设置指定层级对目标相机是否可见",
  T_48_META_API_9019_P0_D: "目标相机实体",
  T_48_META_API_9019_P1_D: "可见性层级",
  T_48_META_API_9019_P2_D: "是否可见",
  T_48_META_API_9020_D: "设置目标玩家默认界面显隐状态",
  T_48_META_API_9020_P0_D: "目标玩家",
  T_48_META_API_9020_P1_D: "玩家界面类型，玩家界面类型是用于操控玩家及玩家相关内容的UI元素",
  T_48_META_API_9020_P2_D: "开关值，决定玩家界面显隐",
  T_48_META_API_9021_D: "创建一个时间戳本地化字符串",
  T_48_META_API_9021_P0_D: "时间戳",
  T_48_META_API_9021_P1_D: "格式化样式",
  T_48_META_API_9021_R_D: "时间戳本地化字符串",
  T_48_META_API_9022_D: "创建小地图图标",
  T_48_META_API_9022_P0_D: "创建的小地图图标实体",
  T_48_META_API_9022_P1_D: "所属玩家，创建的小地图图标只有该玩家可见",
  T_48_META_API_9022_P2_D: "小地图图标资源路径",
  T_48_META_API_9023_D: "使用指定的特效类型创建一个图标，有更多需要设置的属性时则通过实体进一步设置它的实体属性",
  T_48_META_API_9023_P0_D: "代码中是用来表示创建特效实体的形参名称，其对应的局部变量值是创建特效的实体",
  T_48_META_API_9023_P1_D: "所属的玩家实体，只有该玩家可见",
  T_48_META_API_9023_P2_D: "特效类型，玩家可以选择的特效种类",
  T_48_META_API_9024_D: "移除指定的特效（已废弃，请使用DeleteEntity）",
  T_48_META_API_9024_P0_D: "要移除的特效实体",
  T_48_META_API_9025_D: "为目标物件在地图上生成静态像素，静态像素不会随着目标物件移动",
  T_48_META_API_9025_P0_D: "创建的静态像素实体",
  T_48_META_API_9025_P1_D: "所属玩家，创建的静态像素只有该玩家可见",
  T_48_META_API_9025_P2_D: "目标物件实体",
  T_48_META_API_9026_D: "获得目标玩家的小地图实体",
  T_48_META_API_9026_P0_D: "目标玩家",
  T_48_META_API_9026_R_D: "当前玩家小地图",
  T_48_META_API_9027_D: "设置玩家坠落伤害，可根据高度分段设置不同伤害",
  T_48_META_API_9027_P0_D: "目标玩家",
  T_48_META_API_9027_P1_D: "高度分段列表",
  T_48_META_API_9027_P2_D: "伤害分段列表",
  T_48_META_API_91_D: "使目标加入指定队伍，会使目标退出原先所属队伍",
  T_48_META_API_91_P0_D: "需要加入队伍的目标",
  T_48_META_API_91_P1_D: "加入的队伍",
  T_48_META_API_91_P2_D: "是否成功",
  T_48_META_API_92_D: "使目标加入一支新建队伍，会使目标退出原先所属队伍",
  T_48_META_API_92_P0_D: "需要加入队伍的目标",
  T_48_META_API_92_P1_D: "新队伍的名字",
  T_48_META_API_92_P2_D: "是否成功",
  T_48_META_API_94_D: "设置局部变量值，在设置之前需要在当前调用过程中已定义该变量",
  T_48_META_API_94_P0: "索引",
  T_48_META_API_94_P0_D: "根据索引获取变量",
  T_48_META_API_94_P1: "变量值",
  T_48_META_API_94_P1_D: "目标变量值",
  T_48_META_API_94_P2: "运算方式",
  T_48_META_API_94_P2_D: "运算方式，所有类型都支持赋值，数字类型还支持自加、自减、自乘、自除、自余",
  T_48_META_API_94_P3: "变量名",
  T_48_META_API_94_P3_D: "目标变量名称.仅用于错误时输出",
  T_48_META_API_95: "获取局部变量值",
  T_48_META_API_95_D: "获取局部变量值，在获取之前需要在当前调用过程中已定义该变量",
  T_48_META_API_95_P0: "变量索引",
  T_48_META_API_95_P0_D: "变量索引",
  T_48_META_API_95_P1: "变量名",
  T_48_META_API_95_P1_D: "目标变量名称.仅用于错误时输出",
  T_48_META_API_9500_D: "通知目标玩家的客户端播放特效",
  T_48_META_API_9500_P0_D: "目标玩家",
  T_48_META_API_9500_P1_D: "特效资源路径",
  T_48_META_API_9500_P2_D: "颜色",
  T_48_META_API_9500_P3_D: "缩放大小，默认为1",
  T_48_META_API_9500_P4_D: "绑定对象，特效会附加为它的子节点",
  T_48_META_API_9500_P5_D: "相对于绑定对象的世界坐标偏移",
  T_48_META_API_9501_D: "通知目标玩家的客户端播放音效",
  T_48_META_API_9501_P0_D: "目标玩家",
  T_48_META_API_9501_P1_D: "音效类型",
  T_48_META_API_9502_D: "通知目标玩家的客户端显示飘字",
  T_48_META_API_9502_P0_D: "目标玩家",
  T_48_META_API_9502_P1_D: "飘字内容",
  T_48_META_API_9502_P2_D: "飘字颜色，类型为颜色",
  T_48_META_API_9502_P3_D: "飘字持续时间，单位为毫秒",
  T_48_META_API_9503_D: "使目标单位播放一次Emote动作表情",
  T_48_META_API_9503_P0_D: "播放Emote的目标",
  T_48_META_API_9503_P1_D: "Emote类型",
  T_48_META_API_9504_D: "暂停/恢复单位的Emote动作表情",
  T_48_META_API_9504_P0_D: "暂停/恢复Emote的目标",
  T_48_META_API_9504_P1_D: "True: 暂停播放，False: 恢复播放",
  T_48_META_EVT_1_D: "在游戏开始时触发，服务端会早于客户端一段时间准备好",
  T_48_META_EVT_10_D: "在当前实体受到伤害前触发",
  T_48_META_EVT_10_P0_D: "攻击者实体，可能为空",
  T_48_META_EVT_10_P1_D: "伤害类型",
  T_48_META_EVT_10_P2_D: "造成的伤害量",
  T_48_META_EVT_10_P3_D: "伤害部位",
  T_48_META_EVT_1000_D: "在玩家积分改变时触发",
  T_48_META_EVT_1000_P0_D: "积分变化的玩家",
  T_48_META_EVT_1000_P1_D: "变化积分的类型",
  T_48_META_EVT_1000_P2_D: "积分变化后的积分值",
  T_48_META_EVT_1001_D: "在队伍积分改变时触发",
  T_48_META_EVT_1001_P0_D: "积分变化的队伍",
  T_48_META_EVT_1001_P1_D: "变化积分的类型",
  T_48_META_EVT_1001_P2_D: "积分变化后的积分值",
  T_48_META_EVT_1002_D: "在玩家排名改变时触发",
  T_48_META_EVT_1002_P0_D: "排名变化的玩家",
  T_48_META_EVT_1002_P1_D: "排名变化后的名次",
  T_48_META_EVT_1003_D: "已废弃",
  T_48_META_EVT_1003_P0_D: "已废弃",
  T_48_META_EVT_1003_P1_D: "排名变化后的名次",
  T_48_META_EVT_11_D: "在玩家中途退出时触发",
  T_48_META_EVT_11_P0_D: "中途退出的玩家",
  T_48_META_EVT_12_D: "在玩家控制器触碰到实体时触发，只有当控制器主动发生运动时才会触发",
  T_48_META_EVT_12_P0_D: "碰到的实体",
  T_48_META_EVT_13_D: "在当前实体造成伤害前触发",
  T_48_META_EVT_13_P0_D: "承受伤害的实体",
  T_48_META_EVT_13_P1_D: "伤害类型",
  T_48_META_EVT_13_P2_D: "造成的伤害量",
  T_48_META_EVT_13_P3_D: "伤害部位",
  T_48_META_EVT_14_D: "在可播放实体每次循环时触发，可播放实体为音效、特效等实体时此事件只在客户端生效",
  T_48_META_EVT_2_D: "在逻辑帧更新时触发，根据使用平台和设置，该事件触发频率会有不同",
  T_48_META_EVT_2002_D: "在玩家死亡时触发",
  T_48_META_EVT_2002_P0_D: "死亡的玩家",
  T_48_META_EVT_2003_D: "在玩家助攻时触发",
  T_48_META_EVT_2003_P0_D: "获得助攻的玩家",
  T_48_META_EVT_2003_P1_D: "被击杀的玩家",
  T_48_META_EVT_2004_D: "在玩家造成伤害时触发",
  T_48_META_EVT_2004_P0_D: "造成伤害的玩家",
  T_48_META_EVT_2004_P1_D: "受到伤害的玩家",
  T_48_META_EVT_2004_P2_D: "伤害类型",
  T_48_META_EVT_2004_P3_D: "伤害量",
  T_48_META_EVT_2004_P4_D: "伤害部位",
  T_48_META_EVT_2005_D: "在玩家造成击杀时触发",
  T_48_META_EVT_2005_P0_D: "造成击杀的玩家",
  T_48_META_EVT_2005_P1_D: "被击杀的玩家",
  T_48_META_EVT_2005_P2_D: "伤害类型",
  T_48_META_EVT_2006_D: "在玩家加入游戏时触发",
  T_48_META_EVT_2006_P0_D: "加入游戏的玩家",
  T_48_META_EVT_2007_D: "在玩家复活时触发",
  T_48_META_EVT_2007_P0_D: "复活的玩家",
  T_48_META_EVT_2007_P1_D: "复活来源",
  T_48_META_EVT_2008_D: "在玩家被击倒时触发",
  T_48_META_EVT_2008_P0_D: "被击倒的玩家",
  T_48_META_EVT_2008_P1_D: "进行攻击的玩家",
  T_48_META_EVT_2009_D: "在玩家断开连接时触发",
  T_48_META_EVT_2009_P0_D: "断开连接的玩家",
  T_48_META_EVT_2010_D: "在玩家重新连接时触发",
  T_48_META_EVT_2010_P0_D: "重新连接的玩家",
  T_48_META_EVT_2100_D: "在队伍被移除时触发",
  T_48_META_EVT_2100_P0_D: "被移除的队伍",
  T_48_META_EVT_2101_D: "在添加队伍时触发",
  T_48_META_EVT_2101_P0_D: "添加的队伍",
  T_48_META_EVT_2102_D: "在队伍被团灭时触发",
  T_48_META_EVT_2102_P0_D: "被团灭的队伍",
  T_48_META_EVT_3_D: "在游戏结束时触发，游戏在服务器上结束前触发此事件",
  T_48_META_EVT_30_D: "在场景加载成功时触发",
  T_48_META_EVT_30_P0_D: "场景名",
  T_48_META_EVT_3000_D: "在当前实体创建后触发",
  T_48_META_EVT_3001_D: "在当前实体销毁前触发",
  T_48_META_EVT_3002_D: "在玩家进入触发器时触发",
  T_48_META_EVT_3002_P0_D: "进入触发器的玩家",
  T_48_META_EVT_3003_D: "在玩家离开触发器时触发",
  T_48_META_EVT_3003_P0_D: "离开触发器的玩家",
  T_48_META_EVT_3004_D: "在点击UI按钮控件后触发",
  T_48_META_EVT_3004_P0_D: "点击的玩家",
  T_48_META_EVT_3005_D: "在点击内置UI中的按钮时触发",
  T_48_META_EVT_3005_P0_D: "点击的按钮控件名字",
  T_48_META_EVT_3006_D: "在玩家使用水上滑板时触发",
  T_48_META_EVT_3007_D: "在当前实体可用后触发",
  T_48_META_EVT_3008_D: "在当前实体不可用后触发",
  T_48_META_EVT_3009_D: "在实体进入触发器时触发，触发事件时双方均接收该事件，其中一方须为刚体，另一方须为触发器；特别地，当触发器为自定义触发器物件时，仅触发器会接收该事件",
  T_48_META_EVT_3009_P0_D: "发生触发事件时的对方实体",
  T_48_META_EVT_3010_D: "在实体离开触发器时触发，触发事件时双方均接收该事件，其中一方须为刚体，另一方须为触发器；特别地，当触发器为自定义触发器物件时，仅触发器会接收该事件",
  T_48_META_EVT_3010_P0_D: "发生触发事件时的对方实体",
  T_48_META_EVT_3011_D: "在当前实体被消灭后触发",
  T_48_META_EVT_3011_P0_D: "攻击者实体，可能为空",
  T_48_META_EVT_3011_P1_D: "伤害类型",
  T_48_META_EVT_3011_P2_D: "伤害部位",
  T_48_META_EVT_3012_D: "在当前实体被攻击后触发",
  T_48_META_EVT_3012_P0_D: "攻击者实体，可能为空",
  T_48_META_EVT_3012_P1_D: "伤害类型",
  T_48_META_EVT_3012_P2_D: "造成的伤害量",
  T_48_META_EVT_3012_P3_D: "伤害部位",
  T_48_META_EVT_3013_D: "在当前实体造成伤害后触发",
  T_48_META_EVT_3013_P0_D: "承受伤害的实体",
  T_48_META_EVT_3013_P1_D: "伤害类型",
  T_48_META_EVT_3013_P2_D: "造成的伤害量",
  T_48_META_EVT_3013_P3_D: "伤害部位",
  T_48_META_EVT_3014_D: "在当前实体消灭其他实体后触发",
  T_48_META_EVT_3014_P0_D: "被消灭的实体",
  T_48_META_EVT_3014_P1_D: "伤害部位",
  T_48_META_EVT_3015_D: "在该玩家复活时触发",
  T_48_META_EVT_3015_P0_D: "玩家复活来源类型",
  T_48_META_EVT_3016_D: "在生成器生成实体时触发",
  T_48_META_EVT_3016_P0_D: "生成的实体列表",
  T_48_META_EVT_3016_P1_D: "波数",
  T_48_META_EVT_3017_D: "当玩家进入击倒跪姿时调用",
  T_48_META_EVT_3018_D: "在队伍成员全部死亡时触发",
  T_48_META_EVT_3019_D: "在装备头盔、防弹衣或者背包时触发",
  T_48_META_EVT_3019_P0_D: "装备ID",
  T_48_META_EVT_3020_D: "在手持主武器、副武器或近战武器时触发，包括切换为拳头时",
  T_48_META_EVT_3020_P0_D: "触发时装备的武器实体",
  T_48_META_EVT_3021_D: "在使用道具后触发，需要使用时间的道具会在完成使用后触发此事件",
  T_48_META_EVT_3021_P0_D: "道具ID",
  T_48_META_EVT_3021_P1_D: "道具实体，可能为空",
  T_48_META_EVT_3021_P2_D: "使用道具创建的新道具实体，可能为空",
  T_48_META_EVT_3022_D: "在获得物品时触发",
  T_48_META_EVT_3022_P0_D: "物品类型",
  T_48_META_EVT_3022_P1_D: "物品实体，可能为空",
  T_48_META_EVT_3023_D: "在实体积分改变时触发",
  T_48_META_EVT_3023_P0_D: "变化积分的类型",
  T_48_META_EVT_3023_P1_D: "积分变化后的积分值",
  T_48_META_EVT_3024_D: "在实体排名改变时触发",
  T_48_META_EVT_3024_P0_D: "排名变化后的名次",
  T_48_META_EVT_3025_D: "在助攻时触发",
  T_48_META_EVT_3025_P0_D: "被击杀的对象",
  T_48_META_EVT_3026_D: "实体进入载具时触发，包括作为司机和乘客",
  T_48_META_EVT_3026_P0_D: "进入载具的实体",
  T_48_META_EVT_3026_P1_D: "进入的载具",
  T_48_META_EVT_3027_D: "实体离开载具时触发",
  T_48_META_EVT_3027_P0_D: "离开载具的实体",
  T_48_META_EVT_3027_P1_D: "离开的载具",
  T_48_META_EVT_3028_D: "实体驾驶载具时触发，在车上为司机时",
  T_48_META_EVT_3028_P0_D: "驾驶载具的实体",
  T_48_META_EVT_3028_P1_D: "驾驶的载具",
  T_48_META_EVT_3029_D: "在载具被实体进入时触发",
  T_48_META_EVT_3029_P0_D: "触发实体",
  T_48_META_EVT_3030_D: "在载具有实体离开时触发",
  T_48_META_EVT_3030_P0_D: "触发实体",
  T_48_META_EVT_3031_D: "在载具被实体驾驶时触发",
  T_48_META_EVT_3031_P0_D: "触发实体",
  T_48_META_EVT_3032_D: "实体使用传送门发生传送后触发（已废弃，请使用OnBouncesOffTire）",
  T_48_META_EVT_3032_P0_D: "使用传送门的实体",
  T_48_META_EVT_3032_P1_D: "使用的传送门",
  T_48_META_EVT_3033_D: "实体发生弹跳行为时触发",
  T_48_META_EVT_3033_P0_D: "触发实体",
  T_48_META_EVT_3033_P1_D: "使用的弹跳物件",
  T_48_META_EVT_3034_D: "在传送门使实体进行传送后触发",
  T_48_META_EVT_3034_P0_D: "进行传送的实体",
  T_48_META_EVT_3035_D: "在轮胎将实体弹起后触发",
  T_48_META_EVT_3035_P0_D: "被弹起的实体",
  T_48_META_EVT_3036_D: "在机关将实体击飞时触发",
  T_48_META_EVT_3036_P0_D: "被击飞的实体",
  T_48_META_EVT_3036_P1_D: "机关物件",
  T_48_META_EVT_3037_D: "在实体进入触发器时触发",
  T_48_META_EVT_3037_P0_D: "进入的触发器",
  T_48_META_EVT_3038_D: "在实体离开触发器时触发",
  T_48_META_EVT_3038_P0_D: "离开的触发器",
  T_48_META_EVT_3039_D: "在获得武器实体时触发",
  T_48_META_EVT_3039_P0_D: "武器实体",
  T_48_META_EVT_3040_D: "实体被机关击飞时触发",
  T_48_META_EVT_3040_P0_D: "被击飞的实体",
  T_48_META_EVT_3040_P1_D: "机关物件",
  T_48_META_EVT_3041_D: "在瞄准一个可瞄准实体时触发",
  T_48_META_EVT_3041_P0_D: "被瞄准的实体",
  T_48_META_EVT_3042_D: "在被玩家瞄准时触发",
  T_48_META_EVT_3042_P0_D: "进行瞄准的玩家",
  T_48_META_EVT_3043_D: "在子弹击中目标时触发",
  T_48_META_EVT_3043_P0_D: "被击中的目标",
  T_48_META_EVT_3043_P1_D: "子弹击中位置的世界坐标",
  T_48_META_EVT_3044_D: "在被武器击中时触发",
  T_48_META_EVT_3044_P0_D: "武器",
  T_48_META_EVT_3044_P1_D: "击中部位的世界坐标",
  T_48_META_EVT_3045_D: "在玩家选择变身为该关卡物件时触发",
  T_48_META_EVT_3045_P0_D: "玩家变身实体，并非场景物件本身",
  T_48_META_EVT_3046_D: "玩家在该复活点复活时触发",
  T_48_META_EVT_3046_P0_D: "在此复活点复活的玩家",
  T_48_META_EVT_3047_D: "在玩家丢弃武器时触发",
  T_48_META_EVT_3047_P0_D: "丢弃的武器实体",
  T_48_META_EVT_3048_D: "在玩家丢弃武器以外的物品时触发",
  T_48_META_EVT_3048_P0_D: "物品类型",
  T_48_META_EVT_3048_P1_D: "物品实体，可能为空",
  T_48_META_EVT_3049_D: "在被足球枪击中时触发",
  T_48_META_EVT_3049_P0_D: "玩家",
  T_48_META_EVT_3049_P1_D: "被击中后的速度",
  T_48_META_EVT_3050_D: "在足球和实体碰撞时触发",
  T_48_META_EVT_3050_P0_D: "碰撞对象",
  T_48_META_EVT_3050_P1_D: "碰撞后的速度",
  T_48_META_EVT_3051_D: "在玩家加入语音频道成功时触发",
  T_48_META_EVT_3051_P0_D: "语音频道实体",
  T_48_META_EVT_3052_D: "在玩家加入语音频道失败时触发",
  T_48_META_EVT_3052_P0_D: "语音频道实体",
  T_48_META_EVT_3053_D: "在玩家退出语音频道时触发",
  T_48_META_EVT_3053_P0_D: "语音频道实体",
  T_48_META_EVT_3054_D: "在足球进入球门时触发",
  T_48_META_EVT_3054_P0_D: "球门",
  T_48_META_EVT_3054_P1_D: "得分者，进门前最后一位触球玩家",
  T_48_META_EVT_3054_P2_D: "助攻者，进门前倒数第二位触球玩家",
  T_48_META_EVT_3055_D: "在玩家按下开火键时触发",
  T_48_META_EVT_3056_D: "在玩家跳起时触发",
  T_48_META_EVT_3057_D: "在玩家蹲下时触发",
  T_48_META_EVT_3058_D: "在玩家趴下时触发",
  T_48_META_EVT_3059_D: "在玩家疾跑时触发",
  T_48_META_EVT_3060_D: "商店中成功购买商品时触发",
  T_48_META_EVT_3060_P0_D: "购买商品的玩家",
  T_48_META_EVT_3060_P1_D: "商品",
  T_48_META_EVT_3061_D: "在武器被玩家装备时触发",
  T_48_META_EVT_3061_P0_D: "装备武器的玩家",
  T_48_META_EVT_3062_D: "在使用该武器击杀单位时触发",
  T_48_META_EVT_3062_P0_D: "被击杀的实体",
  T_48_META_EVT_3063_D: "在使用该武器对单位造成伤害时触发",
  T_48_META_EVT_3063_P0_D: "受到伤害的实体",
  T_48_META_EVT_3063_P1_D: "伤害量",
  T_48_META_EVT_3064_D: "在武器更换子弹时触发",
  T_48_META_EVT_3065_D: "在实体进入载具时触发，作为司机或乘客都可以触发此事件",
  T_48_META_EVT_3065_P0_D: "进入的载具",
  T_48_META_EVT_3066_D: "在实体离开载具时触发",
  T_48_META_EVT_3066_P0_D: "离开的载具",
  T_48_META_EVT_3067_D: "在实体驾驶载具时触发",
  T_48_META_EVT_3067_P0_D: "驾驶的载具",
  T_48_META_EVT_3068_D: "在实体使用传送门发生传送后触发",
  T_48_META_EVT_3068_P0_D: "使用的传送门",
  T_48_META_EVT_3069_D: "在实体被轮胎弹起后触发",
  T_48_META_EVT_3069_P0_D: "使用的轮胎",
  T_48_META_EVT_3070_D: "在实体被机关击飞时触发",
  T_48_META_EVT_3070_P0_D: "机关物件",
  T_48_META_EVT_3071_D: "在UI按钮控件被玩家按下后触发",
  T_48_META_EVT_3071_P0_D: "触发玩家",
  T_48_META_EVT_3072_D: "在UI按钮控件抬起后触发",
  T_48_META_EVT_3072_P0_D: "触发玩家",
  T_48_META_EVT_3073_D: "在UI按钮控件被玩家双击后触发",
  T_48_META_EVT_3073_P0_D: "触发玩家",
  T_48_META_EVT_3074_D: "越狱区域开始",
  T_48_META_EVT_3075_D: "越狱区域结束",
  T_48_META_EVT_3076_D: "在玩家停止使用水上滑板时触发",
  T_48_META_EVT_3077_D: "在UI输入框控件的文本内容被玩家改变时触发",
  T_48_META_EVT_3077_P0_D: "触发玩家",
  T_48_META_EVT_3077_P1_D: "改变后的文本内容",
  T_48_META_EVT_3078_D: "在可播放实体开始播放时触发",
  T_48_META_EVT_3078_P0_D: "可播放实体",
  T_48_META_EVT_3079_D: "在可播放实体结束播放时触发，可播放实体为音效、特效等实体时此事件只在客户端生效",
  T_48_META_EVT_3079_P0_D: "可播放实体",
  T_48_META_EVT_3080_D: "在可播放实体继续播放时触发",
  T_48_META_EVT_3080_P0_D: "可播放实体",
  T_48_META_EVT_3081_D: "在可播放实体暂停播放时触发",
  T_48_META_EVT_3081_P0_D: "可播放实体",
  T_48_META_EVT_3082_D: "越狱玩家加入",
  T_48_META_EVT_3082_P0_D: "触发玩家",
  T_48_META_EVT_3083_D: "越狱玩家退出",
  T_48_META_EVT_3083_P0_D: "触发玩家",
  T_48_META_EVT_3084_D: "在倒计时结束时触发",
  T_48_META_EVT_3084_P0_D: "所属实体",
  T_48_META_EVT_3085_D: "在物品被拾取时触发",
  T_48_META_EVT_3085_P0_D: "拾取物品的玩家",
  T_48_META_EVT_3086_D: "在物品被丢弃时触发",
  T_48_META_EVT_3086_P0_D: "丢弃物品的玩家",
  T_48_META_EVT_3087_D: "在此物品被装备时触发",
  T_48_META_EVT_3088_D: "在地雷创建后对象启动时触发",
  T_48_META_EVT_3089_D: "在地雷创建后对象触发时触发",
  T_48_META_EVT_3089_P0_D: "触发地雷创建后对象的目标",
  T_48_META_EVT_3090_D: "商店中购买商品前触发",
  T_48_META_EVT_3090_P0_D: "购买商品的玩家",
  T_48_META_EVT_3090_P1_D: "商品",
  T_48_META_EVT_3091_D: "在此装置被使用时触发",
  T_48_META_EVT_3092_D: "在钩锁枪被发射时触发",
  T_48_META_EVT_3093_D: "在掷出投掷物后投掷物爆炸时触发",
  T_48_META_EVT_3093_P0_D: "爆炸点",
  T_48_META_EVT_3094_D: "在被喷漆枪击中时触发",
  T_48_META_EVT_3094_P0_D: "喷漆枪实体",
  T_48_META_EVT_3094_P1_D: "命中点",
  T_48_META_EVT_3094_P2_D: "命中法线",
  T_48_META_EVT_3095_D: "在使用喷漆枪命中时触发",
  T_48_META_EVT_3095_P0_D: "命中的物件",
  T_48_META_EVT_3095_P1_D: "命中点",
  T_48_META_EVT_3095_P2_D: "命中法线",
  T_48_META_EVT_3096_D: "在载具或染色桶爆炸时触发",
  T_48_META_EVT_3096_P0_D: "造成爆炸的玩家",
  T_48_META_EVT_3096_P1_D: "被爆炸波及的玩家列表",
  T_48_META_EVT_3097_D: "在武器停止开火时触发",
  T_48_META_EVT_3097_P0_D: "停止开火时当前弹匣余弹量",
  T_48_META_EVT_3098_D: "在追击目标进入追击范围时触发",
  T_48_META_EVT_3099_D: "在追击目标离开追击范围时触发",
  T_48_META_EVT_31_D: "在场景切换成功时触发",
  T_48_META_EVT_31_P0_D: "场景名",
  T_48_META_EVT_3100_D: "在攻击目标进入攻击范围时触发",
  T_48_META_EVT_3101_D: "在攻击目标离开攻击范围时触发",
  T_48_META_EVT_3102_D: "通过客户端点击事件触发相机射线检测时触发此事件",
  T_48_META_EVT_3102_P0_D: "触发玩家",
  T_48_META_EVT_3102_P1_D: "相机射线是否击中对象",
  T_48_META_EVT_3102_P2_D: "相机射线击中位置",
  T_48_META_EVT_3102_P3_D: "客户端相机朝向",
  T_48_META_EVT_3102_P4_D: "客户端相机位置",
  T_48_META_EVT_3102_P5_D: "击中实体",
  T_48_META_EVT_3103_D: "在商店界面被打开时触发",
  T_48_META_EVT_3103_P0_D: "触发玩家",
  T_48_META_EVT_3104_D: "在商店界面被关闭时触发",
  T_48_META_EVT_3104_P0_D: "触发玩家",
  T_48_META_EVT_3105_D: "在行为树逻辑进入该节点时触发",
  T_48_META_EVT_3105_P0_D: "节点名称",
  T_48_META_EVT_3105_P1_D: "所属实体",
  T_48_META_EVT_3106_D: "在行为树逻辑退出该节点时触发",
  T_48_META_EVT_3106_P0_D: "节点名称",
  T_48_META_EVT_3106_P1_D: "所属实体",
  T_48_META_EVT_3107_D: "在刚体被唤醒时触发",
  T_48_META_EVT_3108_D: "在刚体进入休眠时触发",
  T_48_META_EVT_3109_D: "在玩家移动时触发",
  T_48_META_EVT_3109_P0_D: "姿态",
  T_48_META_EVT_3110_D: "在玩家待机时触发",
  T_48_META_EVT_3110_P0_D: "姿态",
  T_48_META_EVT_3111_D: "在玩家使用技能时触发",
  T_48_META_EVT_3111_P0_D: "使用的技能",
  T_48_META_EVT_3112_D: "在玩家结束冲刺时触发",
  T_48_META_EVT_3113_D: "在获得SwitchEquipSlot枚举下的槽位对应的物品时触发",
  T_48_META_EVT_3113_P0_D: "获得的物品实体",
  T_48_META_EVT_3114_D: "在切换手持物品时触发，包括切换为拳头时",
  T_48_META_EVT_3114_P0_D: "切换后手持的的物品实体",
  T_48_META_EVT_3115_D: "商店中有玩家请求他人购买商品时触发",
  T_48_META_EVT_3115_P0_D: "请求购买商品的玩家",
  T_48_META_EVT_3115_P1_D: "商品",
  T_48_META_EVT_3116_D: "商店中有玩家请求他人购买商品且请求被接受时触发",
  T_48_META_EVT_3116_P0_D: "帮助购买的玩家",
  T_48_META_EVT_3116_P1_D: "请求帮助购买的玩家",
  T_48_META_EVT_3116_P2_D: "商品",
  T_48_META_EVT_3117_D: "在固定帧更新时触发，频率固定为每秒30次",
  T_48_META_EVT_3118_D: "在调用暂停游戏API后触发",
  T_48_META_EVT_3119_D: "在调用恢复游戏API后触发",
  T_48_META_EVT_3120_D: "在玩家新增、删除好友时触发",
  T_48_META_EVT_3121_D: "在收到Persona信息时触发",
  T_48_META_EVT_3121_P0_D: "信息内容",
  T_48_META_EVT_3121_P1_D: "发送方Persona",
  T_48_META_EVT_3122_D: "在玩家跳跃结束时触发",
  T_48_META_EVT_3123_D: "在玩家坠落时触发",
  T_48_META_EVT_3124_D: "在玩家坠落结束时触发",
  T_48_META_EVT_3125_D: "在收到Persona行为时触发",
  T_48_META_EVT_3125_P0_D: "行为",
  T_48_META_EVT_3125_P1_D: "发送方Persona",
  T_48_META_EVT_3126_D: "在会员信息改变时触发",
  T_48_META_EVT_3126_P0_D: "会员改变后的状态",
  T_48_META_EVT_3127_D: "在进入会员中心时触发",
  T_48_META_EVT_3128_D: "在离开会员中心时触发",
  T_48_META_EVT_3129_D: "在玩家进入击倒状态时触发",
  T_48_META_EVT_3129_P0_D: "攻击者实体，可能为空",
  T_48_META_EVT_3130_D: "在收到Persona状态时触发",
  T_48_META_EVT_3130_P0_D: "发送方Persona",
  T_48_META_EVT_3130_P1_D: "错误码",
  T_48_META_EVT_3131_D: "在通过UI发送信息给Persona时触发",
  T_48_META_EVT_3131_P0_D: "信息内容",
  T_48_META_EVT_3131_P1_D: "发送方Persona",
  T_48_META_EVT_3132_D: "在收到Persona结束时触发",
  T_48_META_EVT_3132_P0_D: "发送方Persona",
  T_48_META_EVT_3132_P1_D: "错误码",
  T_48_META_EVT_32_D: "在玩家切换场景时触发",
  T_48_META_EVT_32_P0_D: "场景名",
  T_48_META_EVT_3200_D: "在动画片段播放完成时触发",
  T_48_META_EVT_3200_P0_D: "动画片段名",
  T_48_META_EVT_3201_D: "在动画状态播放完成时触发",
  T_48_META_EVT_3201_P0_D: "动画状态名",
  T_48_META_EVT_3204_D: "在Toggle控件状态变化时触发",
  T_48_META_EVT_3204_P0_D: "触发玩家",
  T_48_META_EVT_3204_P1_D: "状态",
  T_48_META_EVT_3260_D: "在触摸板被玩家按下时触发",
  T_48_META_EVT_3260_P0_D: "触发玩家",
  T_48_META_EVT_3260_P1_D: "按下位置",
  T_48_META_EVT_3261_D: "在触摸板抬起时触发",
  T_48_META_EVT_3261_P0_D: "触发玩家",
  T_48_META_EVT_3261_P1_D: "抬起位置",
  T_48_META_EVT_3262_D: "在触摸板开始滑动时触发",
  T_48_META_EVT_3262_P0_D: "触发玩家",
  T_48_META_EVT_3262_P1_D: "开始滑动位置",
  T_48_META_EVT_3263_D: "在触摸板滑动中触发，在滑动中，每帧都会触发一次此事件",
  T_48_META_EVT_3263_P0_D: "触发玩家",
  T_48_META_EVT_3263_P1_D: "开始滑动位置",
  T_48_META_EVT_3263_P2_D: "位移量",
  T_48_META_EVT_3264_D: "在触摸板滑动结束时触发",
  T_48_META_EVT_3264_P0_D: "触发玩家",
  T_48_META_EVT_3264_P1_D: "结束滑动位置",
  T_48_META_EVT_3265_D: "在JoyStick按下时触发",
  T_48_META_EVT_3265_P0_D: "触发玩家",
  T_48_META_EVT_3266_D: "在JoyStick抬起时触发",
  T_48_META_EVT_3266_P0_D: "触发玩家",
  T_48_META_EVT_3267_D: "在使用JoyStick摇杆时触发",
  T_48_META_EVT_3267_P0_D: "触发玩家",
  T_48_META_EVT_3267_P1_D: "输出位移",
  T_48_META_EVT_3268_D: "在玩家从其他姿态站起时触发",
  T_48_META_EVT_3268_P0_D: "玩家站起前的姿态",
  T_48_META_EVT_3269_D: "在武器进行开火操作时触发",
  T_48_META_EVT_4_D: "在每一回合开始时触发",
  T_48_META_EVT_4_P0_D: "回合索引，从0开始计算",
  T_48_META_EVT_5_D: "在每一回合结束时触发",
  T_48_META_EVT_5_P0_D: "回合索引，从0开始计算",
  T_48_META_EVT_6_D: "在实体发生了碰撞时触发，只有挂载了刚体组件的实体支持该事件",
  T_48_META_EVT_6_P0_D: "碰到的实体",
  T_48_META_EVT_7_D: "在每一阶段开始时触发",
  T_48_META_EVT_7_P0_D: "阶段实体",
  T_48_META_EVT_8_D: "在每一阶段结束时触发",
  T_48_META_EVT_8_P0_D: "阶段实体",
  T_48_META_EVT_9_D: "在实体碰撞结束时触发，只有挂载了刚体组件的实体支持该事件",
  T_48_META_EVT_9_P0_D: "碰到的实体",
  T_49_META_TYP_10_I1_D: "标签列表",
  T_49_META_TYP_10_I2_D: "自身是否可用",
  T_49_META_TYP_10_I3_D: "所有父节点是否都可用",
  T_49_META_TYP_10_I4_D: "在场景中是否可用",
  T_49_META_TYP_10_I5_D: "是否开启逻辑更新，关闭时，该实体上的脚本会停止每帧更新",
  T_49_META_TYP_10_I6_D: "实体名称",
  T_49_META_TYP_10_I7_D: "区域过滤选项，0表示自动计算是否受控，1表示不受控制始终同步，2表示受控制",
  T_49_META_TYP_100_I0_D: "设置触发范围",
  T_49_META_TYP_100_I1_D: "模型显隐",
  T_49_META_TYP_101_I0_D: "当前绑定的玩家",
  T_49_META_TYP_101_I1_D: "模仿的目标物品ID，参照SceneEditPrefab中的第一列",
  T_49_META_TYP_101_I2_D: "模仿的目标的朝向",
  T_49_META_TYP_101_I3_D: "模仿的目标的缩放",
  T_49_META_TYP_1010_I1_D: "计时的时长，单位秒",
  T_49_META_TYP_1010_I2_D: "计时的开始时刻，以秒为单位的游戏时刻",
  T_49_META_TYP_1010_I3_D: "计时的更新类型，参见`EUITimeUpdateType`，可选静止、计时、倒计时",
  T_49_META_TYP_1010_I4_D: "显示位置,当有跟随目标时是相对目标原点的偏移,当没有跟随目标时是屏幕坐标",
  T_49_META_TYP_1011_I10_D: "进度图标名",
  T_49_META_TYP_1011_I2_D: "主题颜色",
  T_49_META_TYP_1011_I3_D: "是否开启本地化显示",
  T_49_META_TYP_1011_I4_D: "标题文本",
  T_49_META_TYP_1011_I5_D: "描述文本",
  T_49_META_TYP_1011_I6_D: "图标资源名",
  T_49_META_TYP_1011_I7_D: "最大进度",
  T_49_META_TYP_1011_I8_D: "当前进度",
  T_49_META_TYP_1011_I9_D: "进度图标",
  T_49_META_TYP_1012_I1_D: "是否开启本地化",
  T_49_META_TYP_1012_I2_D: "回合数文本",
  T_49_META_TYP_1012_I3_D: "回合数参数数组",
  T_49_META_TYP_1012_I5_D: "左边颜色",
  T_49_META_TYP_1012_I6_D: "右边颜色",
  T_49_META_TYP_1013_I2_D: "回合数文本",
  T_49_META_TYP_1013_I3_D: "回合数参数数组",
  T_49_META_TYP_1014_I2_D: "第一种得分标题文本",
  T_49_META_TYP_1014_I3_D: "第一种得分值",
  T_49_META_TYP_1014_I4_D: "第一种得分值参数数组",
  T_49_META_TYP_1014_I5_D: "第二种得分标题文本",
  T_49_META_TYP_1014_I6_D: "第二种得分值",
  T_49_META_TYP_1014_I7_D: "第二种得分值参数数组",
  T_49_META_TYP_1016_I1_D: "根据值显示对应的状态，胜利（1）、失败（2）、平局（3）、Booyah（4）",
  T_49_META_TYP_1016_I2_D: "显示2个队伍比分为true时则显示，否则隐藏",
  T_49_META_TYP_1016_I3_D: "左边队伍得分",
  T_49_META_TYP_1016_I4_D: "右边队伍得分",
  T_49_META_TYP_1016_I5_D: "阶段结束时间戳",
  T_49_META_TYP_1017_I1_D: "左边队伍名",
  T_49_META_TYP_1017_I2_D: "左边队伍描述",
  T_49_META_TYP_1017_I3_D: "右边队伍名",
  T_49_META_TYP_1017_I4_D: "右边队伍描述",
  T_49_META_TYP_1018_I1_D: "第几回合",
  T_49_META_TYP_1018_I4_D: "左边队伍分数",
  T_49_META_TYP_1018_I6_D: "右边队伍分数",
  T_49_META_TYP_1019_I1_D: "胜败平分别对应 1 2 3",
  T_49_META_TYP_102_I0_D: "复活来源类型, 玩家从死亡状态复活",
  T_49_META_TYP_102_I1_D: "复活源类型, 玩家从倒地状态复活",
  T_49_META_TYP_1020_I2_D: "所要显示的文本key",
  T_49_META_TYP_1020_I3_D: "文本key对应的参数数组",
  T_49_META_TYP_1021_I1_D: "基础时间，以秒为单位",
  T_49_META_TYP_1021_I2_D: "持续时间，以秒为单位",
  T_49_META_TYP_1021_I3_D: "显示位置,当有跟随目标时是相对目标原点的偏移,当没有跟随目标时是屏幕坐标,默认为Vector3(0)",
  T_49_META_TYP_1022_I2_D: "所要显示的文本key",
  T_49_META_TYP_1022_I3_D: "文本key对应的参数数组",
  T_49_META_TYP_1023_I1_D: "显示队伍比分为true时则显示，否则关闭",
  T_49_META_TYP_1023_I4_D: "显示队员状态为true时则显示，否则关闭",
  T_49_META_TYP_1023_I5_D: "左边队员状态数组, 0：存活数，1：死亡数，2：倒地数",
  T_49_META_TYP_1023_I6_D: "右边队员状态数组, 0：存活数，1：死亡数，2：倒地数",
  T_49_META_TYP_1023_I7_D: "左边队员旗子数",
  T_49_META_TYP_1023_I8_D: "右边队员旗子数",
  T_49_META_TYP_1024_I2_D: "偏移量",
  T_49_META_TYP_1024_I3_D: "排名",
  T_49_META_TYP_1024_I4_D: "队伍颜色",
  T_49_META_TYP_1024_I5_D: "图标名称",
  T_49_META_TYP_1024_I6_D: "显示边框为true时则显示，否则关闭",
  T_49_META_TYP_1024_I7_D: "得分文本Key",
  T_49_META_TYP_1024_I8_D: "得分文本参数数组",
  T_49_META_TYP_1028_I1_D: "左边队员存活数",
  T_49_META_TYP_1028_I2_D: "右边队员存活数",
  T_49_META_TYP_1028_I3_D: "左边背景颜色",
  T_49_META_TYP_1028_I4_D: "右边背景颜色",
  T_49_META_TYP_1028_I5_D: "左边图标名称",
  T_49_META_TYP_1028_I6_D: "右边图标名称",
  T_49_META_TYP_1029_I1_D: "图标名称",
  T_49_META_TYP_1029_I2_D: "背景图标名称",
  T_49_META_TYP_103_I0_D: "主武器1",
  T_49_META_TYP_103_I1_D: "主武器2",
  T_49_META_TYP_103_I10_D: "冰冻弹",
  T_49_META_TYP_103_I11_D: "冰墙",
  T_49_META_TYP_103_I12_D: "地雷",
  T_49_META_TYP_103_I13_D: "自动炮塔",
  T_49_META_TYP_103_I14_D: "假人",
  T_49_META_TYP_103_I16_D: "滑板、迷彩....",
  T_49_META_TYP_103_I2_D: "副武器",
  T_49_META_TYP_103_I3_D: "爆破武器",
  T_49_META_TYP_103_I5_D: "重武器",
  T_49_META_TYP_1030_I3_D: "左边队员存活数",
  T_49_META_TYP_1030_I4_D: "右边队员存活数",
  T_49_META_TYP_1030_I5_D: "左边队伍图标名称",
  T_49_META_TYP_1030_I6_D: "右边队伍图标名称",
  T_49_META_TYP_1031_I2_D: "提示信息描述",
  T_49_META_TYP_1031_I3_D: "倒计时开始时间戳，以秒为单位",
  T_49_META_TYP_1031_I4_D: "提示信息描述参数",
  T_49_META_TYP_1032_I1_D: "飘字提示类型",
  T_49_META_TYP_1032_I3_D: "信息提示描述参数数组",
  T_49_META_TYP_1033_I1_D: "切换阶段，0 为当前回合结算，1为下回合开始",
  T_49_META_TYP_1033_I10_D: "失败提示文本，不填为默认",
  T_49_META_TYP_1033_I11_D: "回合收入标题",
  T_49_META_TYP_1033_I12_D: "回合收入数值",
  T_49_META_TYP_1033_I13_D: "回合收入详情标题列表",
  T_49_META_TYP_1033_I14_D: "回合收入数值详情列表，与以上详情标题列表一一对应",
  T_49_META_TYP_1033_I15_D: "MVP玩家昵称",
  T_49_META_TYP_1033_I16_D: "下回合Index",
  T_49_META_TYP_1033_I17_D: "是否决胜局",
  T_49_META_TYP_1033_I18_D: "是否最终回合",
  T_49_META_TYP_1033_I6_D: "左边队伍图标名称",
  T_49_META_TYP_1033_I7_D: "右边队伍图标名称",
  T_49_META_TYP_1033_I8_D: "根据值显示对应的状态，胜利（1）、失败（2）",
  T_49_META_TYP_1033_I9_D: "胜利提示文本，不填为默认",
  T_49_META_TYP_1036_I1_D: "表示一共有多少个等级",
  T_49_META_TYP_1036_I2_D: "表示当前的僵尸等级",
  T_49_META_TYP_1037_I1_D: "表示显示多少积分",
  T_49_META_TYP_1039_I3_D: "倒计时开始时间戳，以秒为单位",
  T_49_META_TYP_104_I0_D: "样式一",
  T_49_META_TYP_104_I1_D: "样式二",
  T_49_META_TYP_104_I2_D: "样式三",
  T_49_META_TYP_1040_I10_D: "卡牌描述数组",
  T_49_META_TYP_1040_I11_D: "选择Item的索引,从0开始，小于0表示取消选择",
  T_49_META_TYP_1040_I12_D: "按钮名字数组",
  T_49_META_TYP_1040_I13_D: "按钮颜色数组",
  T_49_META_TYP_1040_I2_D: "倒计时Key",
  T_49_META_TYP_1040_I3_D: "倒计时长，以秒为单位",
  T_49_META_TYP_1040_I4_D: "描述信息Key",
  T_49_META_TYP_1040_I5_D: "描述信息参数数组",
  T_49_META_TYP_1040_I6_D: "卡牌背景Sprite数组",
  T_49_META_TYP_1040_I7_D: "卡牌背景颜色数组",
  T_49_META_TYP_1040_I8_D: "卡牌IconSprite数组",
  T_49_META_TYP_1040_I9_D: "卡牌名字数组",
  T_49_META_TYP_1041_I2_D: "位置",
  T_49_META_TYP_1041_I3_D: "Icon图片",
  T_49_META_TYP_1041_I4_D: "文本内容",
  T_49_META_TYP_1041_I5_D: "背景颜色",
  T_49_META_TYP_1042_I1_D: "相对位置",
  T_49_META_TYP_1043_I4_D: "文本颜色",
  T_49_META_TYP_1043_I5_D: "文本内容Key",
  T_49_META_TYP_1043_I6_D: "文本内容参数数组",
  T_49_META_TYP_1045_I2_D: "按钮图标",
  T_49_META_TYP_1045_I3_D: "图标颜色",
  T_49_META_TYP_1045_I4_D: "尺寸大小，宽高相同",
  T_49_META_TYP_1045_I5_D: "相对于右下角锚点的位置",
  T_49_META_TYP_1045_I6_D: "充能数量,小于0就隐藏",
  T_49_META_TYP_1045_I7_D: "CD开始时间,以毫秒为单位",
  T_49_META_TYP_1045_I8_D: "CD持续时间,以毫秒为单位",
  T_49_META_TYP_1045_I9_D: "为True，按钮变灰， False则还原",
  T_49_META_TYP_106_I1_D: "启用",
  T_49_META_TYP_106_I2_D: "禁用",
  T_49_META_TYP_109_I0_D: "聊天频道实体ID",
  T_49_META_TYP_109_I1_D: "玩家列表",
  T_49_META_TYP_11_I0_D: "当前游戏是否处于非法状态，当处于非法状态时意味着游戏已失去对抗价值，建议直接结束游戏",
  T_49_META_TYP_11_I1_D: "当前游戏已经进行的游戏时长，单位毫秒",
  T_49_META_TYP_11_I10_D: "是否每回合重置装备",
  T_49_META_TYP_11_I11_D: "是否启用毒圈机制",
  T_49_META_TYP_11_I12_D: "毒圈大小",
  T_49_META_TYP_11_I13_D: "开始缩圈时间",
  T_49_META_TYP_11_I14_D: "缩圈时长",
  T_49_META_TYP_11_I15_D: "毒圈伤害",
  T_49_META_TYP_11_I18_D: "复活类型",
  T_49_META_TYP_11_I2_D: "当前回合索引，通过该值可以获取到目前的回合实体",
  T_49_META_TYP_11_I27_D: "游戏总回合数",
  T_49_META_TYP_11_I3_D: "当前阶段索引，通过该值可以获取到目前的阶段实体",
  T_49_META_TYP_11_I32_D: "回合开始时获得金币数量",
  T_49_META_TYP_11_I33_D: "击杀时获得金币数量",
  T_49_META_TYP_11_I34_D: "获胜时获得金币数量",
  T_49_META_TYP_11_I35_D: "是否显示钱包UI",
  T_49_META_TYP_11_I36_D: "天空盒实体",
  T_49_META_TYP_11_I37_D: "自游戏启动后的累计运行帧",
  T_49_META_TYP_11_I38_D: "是否允许移动",
  T_49_META_TYP_11_I39_D: "是否自定义结算",
  T_49_META_TYP_11_I4_D: "预设UGC模式的模板ID",
  T_49_META_TYP_11_I40_D: "是否允许中途加入",
  T_49_META_TYP_11_I41_D: "开启低帧率模式，游戏将以15FPS运行，否则30FPS",
  T_49_META_TYP_11_I42_D: "游戏服务器两次逻辑帧更新间隔",
  T_49_META_TYP_11_I43_D: "固定帧更新间隔，以毫秒为单位",
  T_49_META_TYP_11_I5_D: "若关闭则禁用玩家复活",
  T_49_META_TYP_11_I6_D: "若关闭则禁用Bot复活",
  T_49_META_TYP_11_I7_D: "复活时长，单位秒",
  T_49_META_TYP_11_I8_D: "游戏中总队伍数",
  T_49_META_TYP_11_I9_D: "每支队伍的成员数",
  T_49_META_TYP_110_I0_D: "空闲语音频道1",
  T_49_META_TYP_110_I1_D: "空闲语音频道2",
  T_49_META_TYP_110_I2_D: "空闲语音频道3",
  T_49_META_TYP_110_I3_D: "空闲语音频道4",
  T_49_META_TYP_110_I4_D: "空闲语音频道5",
  T_49_META_TYP_110_I5_D: "空闲语音频道6",
  T_49_META_TYP_111_I1_D: "冲刺",
  T_49_META_TYP_111_I2_D: "攻击",
  T_49_META_TYP_111_I3_D: "跳跃",
  T_49_META_TYP_111_I4_D: "翻窗",
  T_49_META_TYP_111_I5_D: "驾驶",
  T_49_META_TYP_111_I6_D: "进入载具",
  T_49_META_TYP_111_I7_D: "离开载具",
  T_49_META_TYP_111_I8_D: "操作载具",
  T_49_META_TYP_112_I0_D: "启用",
  T_49_META_TYP_112_I1_D: "禁用",
  T_49_META_TYP_112_I2_D: "屏蔽",
  T_49_META_TYP_117_I0_D: "拍手声",
  T_49_META_TYP_117_I1_D: "闭合踩镲",
  T_49_META_TYP_117_I2_D: "底鼓",
  T_49_META_TYP_117_I3_D: "打开的踩镲",
  T_49_META_TYP_117_I4_D: "吊镲",
  T_49_META_TYP_117_I5_D: "军鼓",
  T_49_META_TYP_118_I0_D: "阵营所有成员是否处于死亡",
  T_49_META_TYP_118_I1_D: "所有队员列表",
  T_49_META_TYP_118_I2_D: "友好阵营",
  T_49_META_TYP_118_I3_D: "敌对阵营",
  T_49_META_TYP_118_I4_D: "是否显示UI名字",
  T_49_META_TYP_118_I5_D: "是否显示地图信息",
  T_49_META_TYP_118_I6_D: "是否“显示”",
  T_49_META_TYP_118_I7_D: "是否“显示”",
  T_49_META_TYP_118_I8_D: "所有成员",
  T_49_META_TYP_118_I9_D: "是否显示快速消息",
  T_49_META_TYP_119_I0_D: "是",
  T_49_META_TYP_119_I1_D: "否",
  T_49_META_TYP_120_I1_D: "跟随的目标实体，默认为空",
  T_49_META_TYP_120_I2_D: "UI颜色",
  T_49_META_TYP_120_I3_D: "UI长度",
  T_49_META_TYP_120_I4_D: "当前进度值,0到1.0",
  T_49_META_TYP_120_I5_D: "显示位置,当有跟随目标时是相对目标原点的偏移,当没有跟随目标时是屏幕坐标,默认为Vector3(0)",
  T_49_META_TYP_121_I0_D: "3秒",
  T_49_META_TYP_121_I1_D: "5秒",
  T_49_META_TYP_121_I2_D: "10秒",
  T_49_META_TYP_121_I3_D: "15秒",
  T_49_META_TYP_121_I4_D: "30秒",
  T_49_META_TYP_121_I5_D: "9999秒",
  T_49_META_TYP_122_I0_D: "基础天空盒资源",
  T_49_META_TYP_122_I1_D: "主光源颜色",
  T_49_META_TYP_122_I10_D: "所属的子场景GUID",
  T_49_META_TYP_122_I11_D: "雾效功能开关",
  T_49_META_TYP_122_I12_D: "雾效模式",
  T_49_META_TYP_122_I13_D: "指数雾的密度",
  T_49_META_TYP_122_I14_D: "线性雾的起始距离",
  T_49_META_TYP_122_I15_D: "线性雾的结束距离",
  T_49_META_TYP_122_I16_D: "开启雾效特性",
  T_49_META_TYP_122_I17_D: "主光源旋转角度",
  T_49_META_TYP_122_I18_D: "开启主光源旋转角度特性",
  T_49_META_TYP_122_I2_D: "主光源强度",
  T_49_META_TYP_122_I3_D: "全局暗度",
  T_49_META_TYP_122_I4_D: "阴影暗度",
  T_49_META_TYP_122_I5_D: "地面湿度",
  T_49_META_TYP_122_I6_D: "光晕强度",
  T_49_META_TYP_122_I7_D: "雾气颜色",
  T_49_META_TYP_122_I8_D: "环境光颜色",
  T_49_META_TYP_123_I0_D: "白天",
  T_49_META_TYP_123_I1_D: "夜晚",
  T_49_META_TYP_123_I2_D: "黄昏",
  T_49_META_TYP_123_I3_D: "城市",
  T_49_META_TYP_123_I4_D: "彩色魔方",
  T_49_META_TYP_123_I5_D: "极地星空",
  T_49_META_TYP_124_I0_D: "近距离",
  T_49_META_TYP_124_I1_D: "中距离",
  T_49_META_TYP_124_I2_D: "远距离",
  T_49_META_TYP_125_I0_D: "表面贴图颜色",
  T_49_META_TYP_125_I2_D: "表面贴图",
  T_49_META_TYP_125_I4_D: "表面透明度",
  T_49_META_TYP_126_I1_D: "物件名字",
  T_49_META_TYP_126_I2_D: "当前进度数值",
  T_49_META_TYP_126_I3_D: "最大进度数值",
  T_49_META_TYP_126_I4_D: "屏幕坐标,默认为Vector3(0)",
  T_49_META_TYP_126_I5_D: "进度条长度，目前默认值为prefab上UI的长度",
  T_49_META_TYP_127_I0_D: "沿着某个轴平移，可以三个轴组合",
  T_49_META_TYP_127_I1_D: "沿着某个轴旋转，可以三个轴组合",
  T_49_META_TYP_127_I2_D: "沿着某个轴缩放，可以三个轴组合",
  T_49_META_TYP_128_I0_D: "草丛",
  T_49_META_TYP_128_I1_D: "南瓜",
  T_49_META_TYP_128_I2_D: "稻草人",
  T_49_META_TYP_128_I3_D: "储物柜",
  T_49_META_TYP_129_I0_D: "随机Loot",
  T_49_META_TYP_129_I1_D: "AR子弹",
  T_49_META_TYP_129_I2_D: "SMG子弹",
  T_49_META_TYP_129_I3_D: "SN子弹",
  T_49_META_TYP_129_I4_D: "HG子弹",
  T_49_META_TYP_129_I5_D: "SG子弹",
  T_49_META_TYP_129_I6_D: "Bow子弹",
  T_49_META_TYP_13_I1_D: "相对于父节点的锚点坐标",
  T_49_META_TYP_13_I10_D: "Widget与锚框尺寸差",
  T_49_META_TYP_13_I11_D: "支点",
  T_49_META_TYP_13_I12_D: "深度",
  T_49_META_TYP_13_I14_D: "在同一个父节点所有子节点的顺序",
  T_49_META_TYP_13_I15_D: "父节点控件EntityID",
  T_49_META_TYP_13_I16_D: "UniqueID",
  T_49_META_TYP_13_I17_D: "优先级",
  T_49_META_TYP_13_I18_D: "实际位置",
  T_49_META_TYP_13_I2_D: "宽度",
  T_49_META_TYP_13_I4_D: "Z轴旋转角度",
  T_49_META_TYP_13_I6_D: "控件在Prefab中的内部ID",
  T_49_META_TYP_13_I7_D: "所在UI实体",
  T_49_META_TYP_13_I8_D: "锚点最小值",
  T_49_META_TYP_13_I9_D: "锚点最大值",
  T_49_META_TYP_130_I0_D: "随机消耗品Loot",
  T_49_META_TYP_130_I1_D: "急救包",
  T_49_META_TYP_130_I2_D: "护甲修理包",
  T_49_META_TYP_130_I3_D: "强心针",
  T_49_META_TYP_130_I4_D: "呼吸器",
  T_49_META_TYP_131_I0_D: "随机护甲Loot",
  T_49_META_TYP_131_I1_D: "一级护甲",
  T_49_META_TYP_131_I2_D: "二级护甲",
  T_49_META_TYP_131_I3_D: "三级护甲",
  T_49_META_TYP_132_I0_D: "随机投掷物Loot",
  T_49_META_TYP_132_I1_D: "手榴弹",
  T_49_META_TYP_132_I4_D: "冰冻手榴弹",
  T_49_META_TYP_133_I0_D: "随机倍镜Loot",
  T_49_META_TYP_133_I1_D: "2倍镜",
  T_49_META_TYP_133_I2_D: "4倍镜",
  T_49_META_TYP_133_I3_D: "热成像镜",
  T_49_META_TYP_134_I0_D: "随机武器Loot",
  T_49_META_TYP_134_I5_D: "散弹枪",
  T_49_META_TYP_134_I8_D: "足球枪",
  T_49_META_TYP_135_I0_D: "Loot子弹点",
  T_49_META_TYP_136_I0_D: "Loot消耗物品点",
  T_49_META_TYP_137_I0_D: "Loot消耗物品点",
  T_49_META_TYP_138_I0_D: "Loot倍镜点",
  T_49_META_TYP_139_I0_D: "Loot护甲点",
  T_49_META_TYP_14_I0_D: "玩家当前的血量",
  T_49_META_TYP_14_I1_D: "玩家当前的血量最大值",
  T_49_META_TYP_14_I11_D: "玩家的阵营",
  T_49_META_TYP_14_I12_D: "玩家的伤害倍率，如2倍配置为2.0",
  T_49_META_TYP_14_I13_D: "使用和男性或者女性角色完全一致的骨骼，0表示不替换模型",
  T_49_META_TYP_14_I14_D: "与现有的速度缩放比例不会冲突",
  T_49_META_TYP_14_I15_D: "与现有的跳跃高度缩放比例不会冲突",
  T_49_META_TYP_14_I16_D: "身份,0 普通玩家，1 猎手,2 母体僵尸,3 普通僵尸，4 进化僵尸类型1, 5 进化僵尸类型2,6进化僵尸类型3",
  T_49_META_TYP_14_I17_D: "僵尸等级，1~3",
  T_49_META_TYP_14_I19_D: "玩家的昵称",
  T_49_META_TYP_14_I2_D: "判断当前玩家是AI玩家，AI一般为NPC或者PVE的怪物",
  T_49_META_TYP_14_I20_D: "当受到伤害时伤害量百分比，可减伤或增伤",
  T_49_META_TYP_14_I21_D: "玩家当前的EP",
  T_49_META_TYP_14_I22_D: "玩家EP最大值",
  T_49_META_TYP_14_I23_D: "当前手持中的主武器",
  T_49_META_TYP_14_I24_D: "死亡时遗失所有装备",
  T_49_META_TYP_14_I26_D: "瞄准辅助类型",
  T_49_META_TYP_14_I27_D: "是否可被辅助瞄准锁定",
  T_49_META_TYP_14_I28_D: "开关语音聊天: true关闭语音, false打开语音",
  T_49_META_TYP_14_I29_D: "开关快捷聊天: true关闭语音, false打开语音",
  T_49_META_TYP_14_I3_D: "玩家状态",
  T_49_META_TYP_14_I30_D: "频道实体",
  T_49_META_TYP_14_I35_D: "开关拾取物品: true不能拾取, false可以拾取",
  T_49_META_TYP_14_I36_D: "开关丢弃物品: true不能丢弃, false可以丢弃",
  T_49_META_TYP_14_I37_D: "敌对玩家",
  T_49_META_TYP_14_I38_D: "友好玩家",
  T_49_META_TYP_14_I39_D: "阵营实体",
  T_49_META_TYP_14_I4_D: "玩家的存活时间，如果玩家死亡，该时间重新计算",
  T_49_META_TYP_14_I40_D: "玩家在阵营中的序号",
  T_49_META_TYP_14_I41_D: "玩家正在使用的相机",
  T_49_META_TYP_14_I42_D: "自定义重力",
  T_49_META_TYP_14_I43_D: "当前头盔",
  T_49_META_TYP_14_I44_D: "当前防弹衣",
  T_49_META_TYP_14_I5_D: "玩家的无敌状态",
  T_49_META_TYP_14_I52_D: "用户UID",
  T_49_META_TYP_14_I53_D: "爆头减伤率",
  T_49_META_TYP_14_I54_D: "玩家绑定的AVATAR",
  T_49_META_TYP_14_I55_D: "性別",
  T_49_META_TYP_14_I56_D: "玩家枪皮",
  T_49_META_TYP_14_I57_D: "玩家的出生点",
  T_49_META_TYP_14_I58_D: "玩家的复活点，如果没有检查点记录则使用出生点，否则使用检查点",
  T_49_META_TYP_14_I59_D: "玩家当前的位置",
  T_49_META_TYP_14_I6_D: "玩家所属队伍的实体",
  T_49_META_TYP_14_I60_D: "玩家当前的朝向",
  T_49_META_TYP_14_I61_D: "用来访问蒙皮骨骼的节点",
  T_49_META_TYP_14_I62_D: "玩家背包",
  T_49_META_TYP_14_I63_D: "临时护盾值",
  T_49_META_TYP_14_I64_D: "车皮ID",
  T_49_META_TYP_14_I65_D: "跳过坠落时的僵直动画",
  T_49_META_TYP_14_I66_D: "是否坠落时免伤",
  T_49_META_TYP_14_I67_D: "当前手持物品",
  T_49_META_TYP_14_I68_D: "禁止拾取物品列表",
  T_49_META_TYP_14_I69_D: "玩家资源ID",
  T_49_META_TYP_14_I7_D: "当前的检查点ID",
  T_49_META_TYP_14_I70_D: "发送请求购买消息的目标",
  T_49_META_TYP_14_I71_D: "当前播放的Emote资源ID",
  T_49_META_TYP_14_I72_D: "当前播放的Emote是否循环",
  T_49_META_TYP_14_I73_D: "对击倒状态的处理",
  T_49_META_TYP_14_I74_D: "是否开启伤害跳字，默认为True，表示开启",
  T_49_META_TYP_14_I76_D: "能否中途退出",
  T_49_META_TYP_14_I77_D: "玩家变身为其他角色时需要保留的服饰信息",
  T_49_META_TYP_14_I8_D: "目标前往的检查点ID",
  T_49_META_TYP_140_I0_D: "波次1",
  T_49_META_TYP_140_I1_D: "波次2",
  T_49_META_TYP_140_I2_D: "波次3",
  T_49_META_TYP_140_I3_D: "持续生成",
  T_49_META_TYP_141_I0_D: "随机足球Loot",
  T_49_META_TYP_141_I1_D: "足球凝胶护盾",
  T_49_META_TYP_141_I2_D: "冰冻手雷",
  T_49_META_TYP_142_I0_D: "Loot足球点",
  T_49_META_TYP_143_I0_D: "Lead1C2",
  T_49_META_TYP_143_I1_D: "Lead1C2#",
  T_49_META_TYP_143_I10_D: "Lead1A2#",
  T_49_META_TYP_143_I11_D: "Lead1B2",
  T_49_META_TYP_143_I2_D: "Lead1D2",
  T_49_META_TYP_143_I3_D: "Lead1D2#",
  T_49_META_TYP_143_I4_D: "Lead1E2",
  T_49_META_TYP_143_I5_D: "Lead1F2",
  T_49_META_TYP_143_I6_D: "Lead1F2#",
  T_49_META_TYP_143_I7_D: "Lead1G2",
  T_49_META_TYP_143_I8_D: "Lead1G2#",
  T_49_META_TYP_143_I9_D: "Lead1A2",
  T_49_META_TYP_144_I0_D: "Lead2C2",
  T_49_META_TYP_144_I1_D: "Lead2C2#",
  T_49_META_TYP_144_I10_D: "Lead2A2#",
  T_49_META_TYP_144_I11_D: "Lead2B2",
  T_49_META_TYP_144_I2_D: "Lead2D2",
  T_49_META_TYP_144_I3_D: "Lead2D2#",
  T_49_META_TYP_144_I4_D: "Lead2E2",
  T_49_META_TYP_144_I5_D: "Lead2F2",
  T_49_META_TYP_144_I6_D: "Lead2F2#",
  T_49_META_TYP_144_I7_D: "Lead2G2",
  T_49_META_TYP_144_I8_D: "Lead2G2#",
  T_49_META_TYP_144_I9_D: "Lead2A2",
  T_49_META_TYP_145_I0_D: "Lead3C2",
  T_49_META_TYP_145_I1_D: "Lead3C2#",
  T_49_META_TYP_145_I10_D: "Lead3A2#",
  T_49_META_TYP_145_I11_D: "Lead3B2",
  T_49_META_TYP_145_I2_D: "Lead3D2",
  T_49_META_TYP_145_I3_D: "Lead3D2#",
  T_49_META_TYP_145_I4_D: "Lead3E2",
  T_49_META_TYP_145_I5_D: "Lead3F2",
  T_49_META_TYP_145_I6_D: "Lead3F2#",
  T_49_META_TYP_145_I7_D: "Lead3G2",
  T_49_META_TYP_145_I8_D: "Lead3G2#",
  T_49_META_TYP_145_I9_D: "Lead3A2",
  T_49_META_TYP_146_I0_D: "PianoC3",
  T_49_META_TYP_146_I1_D: "PianoC3#",
  T_49_META_TYP_146_I10_D: "PianoA3#",
  T_49_META_TYP_146_I11_D: "PianoB3",
  T_49_META_TYP_146_I12_D: "PianoC4",
  T_49_META_TYP_146_I13_D: "PianoC4#",
  T_49_META_TYP_146_I14_D: "PianoD4",
  T_49_META_TYP_146_I15_D: "PianoD4#",
  T_49_META_TYP_146_I16_D: "PianoE4",
  T_49_META_TYP_146_I17_D: "PianoF4",
  T_49_META_TYP_146_I18_D: "PianoF4#",
  T_49_META_TYP_146_I19_D: "PianoG4",
  T_49_META_TYP_146_I2_D: "PianoD3",
  T_49_META_TYP_146_I20_D: "PianoG4#",
  T_49_META_TYP_146_I21_D: "PianoA4",
  T_49_META_TYP_146_I22_D: "PianoA4#",
  T_49_META_TYP_146_I23_D: "PianoB4",
  T_49_META_TYP_146_I3_D: "PianoD3#",
  T_49_META_TYP_146_I4_D: "PianoE3",
  T_49_META_TYP_146_I5_D: "PianoF3",
  T_49_META_TYP_146_I6_D: "PianoF3#",
  T_49_META_TYP_146_I7_D: "PianoG3",
  T_49_META_TYP_146_I8_D: "PianoG3#",
  T_49_META_TYP_146_I9_D: "PianoA3",
  T_49_META_TYP_147_I0_D: "FF经典（射击）",
  T_49_META_TYP_147_I1_D: "第三人称",
  T_49_META_TYP_147_I2_D: "第一人称（射击）",
  T_49_META_TYP_147_I3_D: "俯视角",
  T_49_META_TYP_147_I4_D: "横向滚轴",
  T_49_META_TYP_147_I5_D: "自定义相机",
  T_49_META_TYP_147_I6_D: "追背",
  T_49_META_TYP_147_I7_D: "由玩家控制，自由移动的相机",
  T_49_META_TYP_147_I8_D: "新版第一人称视角相机",
  T_49_META_TYP_148_I0_D: "提供多种预设相机类型，以及自定义相机类型",
  T_49_META_TYP_148_I1_D: "视野范围为相机的观察角度",
  T_49_META_TYP_148_I10_D: "相机切换动画的类型",
  T_49_META_TYP_148_I11_D: "仅切换类型为平滑时生效，切换至该相机的过渡时间，单位毫秒",
  T_49_META_TYP_148_I12_D: "当相机与跟随对象中间有遮挡物时，相机的运动模式",
  T_49_META_TYP_148_I13_D: "相机渲染画面时的成像方式",
  T_49_META_TYP_148_I14_D: "跟随对象偏移参考坐标系",
  T_49_META_TYP_148_I15_D: "观察对象偏移参考坐标系",
  T_49_META_TYP_148_I16_D: "相机的渲染层遮罩，可以通过可见性层级筛选相机的渲染对象",
  T_49_META_TYP_148_I17_D: "视角限制",
  T_49_META_TYP_148_I2_D: "一般指相机位置相对于玩家原点位置的偏移量，不同相机类型具体含义不同",
  T_49_META_TYP_148_I3_D: "一般指相机聚焦点相对于玩家原点位置的偏移量，不同相机类型具体含义不同",
  T_49_META_TYP_148_I4_D: "相机在垂直方向上的旋转角",
  T_49_META_TYP_148_I5_D: "相机在水平方向上的旋转角",
  T_49_META_TYP_148_I7_D: "相机跟随的目标",
  T_49_META_TYP_148_I8_D: "相机观察的目标",
  T_49_META_TYP_148_I9_D: "正在使用该相机的玩家",
  T_49_META_TYP_15_I0_D: "队伍当前是否所有队员都处于死亡状态",
  T_49_META_TYP_15_I1_D: "队伍的所有队员列表",
  T_49_META_TYP_15_I3_D: "敌对队伍列表",
  T_49_META_TYP_15_I4_D: "友好队伍列表",
  T_49_META_TYP_15_I5_D: "队伍序号",
  T_49_META_TYP_150_I0_D: "耐久",
  T_49_META_TYP_150_I1_D: "胶囊体两端半球的半径",
  T_49_META_TYP_150_I2_D: "伤害系数",
  T_49_META_TYP_152_I1_D: "自定义重力",
  T_49_META_TYP_152_I2_D: "是否需要显示触发器，True为显示",
  T_49_META_TYP_154_I0_D: "不可以双持",
  T_49_META_TYP_154_I1_D: "只可以和同一种枪进行组合双持",
  T_49_META_TYP_154_I2_D: "可以和另一种武器也可以和自己组合双持",
  T_49_META_TYP_155_I0_D: "等级",
  T_49_META_TYP_155_I1_D: "最大耐久度",
  T_49_META_TYP_155_I2_D: "当前耐久度",
  T_49_META_TYP_155_I3_D: "伤害减免系数",
  T_49_META_TYP_155_I4_D: "爆炸伤害减免系数",
  T_49_META_TYP_155_I5_D: "是否会破损",
  T_49_META_TYP_155_I6_D: "是否会摧毁",
  T_49_META_TYP_156_I1_D: "最大耐久度",
  T_49_META_TYP_156_I2_D: "当前耐久度",
  T_49_META_TYP_156_I3_D: "伤害减免系数",
  T_49_META_TYP_156_I4_D: "爆炸伤害减免系数",
  T_49_META_TYP_156_I5_D: "是否会破损",
  T_49_META_TYP_156_I6_D: "是否会摧毁",
  T_49_META_TYP_157_I0_D: "无动画",
  T_49_META_TYP_157_I1_D: "渐进",
  T_49_META_TYP_158_I2_D: "UI锚点类型枚举,默认值为9（Center）",
  T_49_META_TYP_158_I6_D: "文本内容Key",
  T_49_META_TYP_158_I7_D: "文本内容参数数组",
  T_49_META_TYP_158_I8_D: "是否启用UITweener脚本",
  T_49_META_TYP_16_I1_D: "实体对应的物品ID",
  T_49_META_TYP_16_I2_D: "仅用于静态加载物件时，判断是静态生成NavMesh",
  T_49_META_TYP_16_I3_D: "是否是NavMesh的动态阻挡",
  T_49_META_TYP_16_I4_D: "异步加载",
  T_49_META_TYP_160_I0_D: "砖块A",
  T_49_META_TYP_160_I1_D: "瓷砖A",
  T_49_META_TYP_160_I10_D: "沙子A",
  T_49_META_TYP_160_I11_D: "雪地A",
  T_49_META_TYP_160_I12_D: "木头A",
  T_49_META_TYP_160_I13_D: "石头A",
  T_49_META_TYP_160_I14_D: "草坪B",
  T_49_META_TYP_160_I15_D: "砖块B",
  T_49_META_TYP_160_I16_D: "砖块C",
  T_49_META_TYP_160_I17_D: "清除",
  T_49_META_TYP_160_I2_D: "瓷砖B",
  T_49_META_TYP_160_I3_D: "瓷砖C",
  T_49_META_TYP_160_I4_D: "竹子A",
  T_49_META_TYP_160_I5_D: "水泥A",
  T_49_META_TYP_160_I6_D: "集装箱A",
  T_49_META_TYP_160_I7_D: "草坪A",
  T_49_META_TYP_160_I8_D: "冰块A",
  T_49_META_TYP_160_I9_D: "岩浆A",
  T_49_META_TYP_165_I0_D: "是否开启碰撞",
  T_49_META_TYP_165_I1_D: "是否作为触发器",
  T_49_META_TYP_165_I2_D: "物理层级，在物理模组里配置层级，最多16个",
  T_49_META_TYP_166_I0_D: "Emote1",
  T_49_META_TYP_166_I1_D: "Emote2",
  T_49_META_TYP_166_I2_D: "Emote3",
  T_49_META_TYP_166_I3_D: "Emote4",
  T_49_META_TYP_166_I4_D: "Emote5",
  T_49_META_TYP_167_I0_D: "特效贴图类型",
  T_49_META_TYP_170_I0_D: "是否可见，当不可见时客户端停止渲染目标",
  T_49_META_TYP_170_I1_D: "可见层级，取值范围[0,15]，影响在相机中的可见性",
  T_49_META_TYP_171_I0_D: "EP修改值",
  T_49_META_TYP_172_I0_D: "子弹数量",
  T_49_META_TYP_173_I0_D: "额外背包空间",
  T_49_META_TYP_173_I1_D: "玩家局外的皮肤配置优先",
  T_49_META_TYP_173_I2_D: "背包皮肤ID,背包自身的皮肤配置",
  T_49_META_TYP_174_I2_D: "最大伤害",
  T_49_META_TYP_174_I4_D: "投掷速度",
  T_49_META_TYP_174_I5_D: "爆炸延时，单位秒",
  T_49_META_TYP_174_I6_D: "自己伤害系数",
  T_49_META_TYP_174_I7_D: "队友伤害系数",
  T_49_META_TYP_174_I8_D: "车辆伤害系数",
  T_49_META_TYP_174_I9_D: "皮肤",
  T_49_META_TYP_175_I0_D: "冰冻区域半径",
  T_49_META_TYP_175_I1_D: "冰冻区域时长，单位秒",
  T_49_META_TYP_176_I0_D: "武器的主类型",
  T_49_META_TYP_176_I1_D: "武器子类型",
  T_49_META_TYP_177_I0_D: "当相机与跟随对象中间有遮挡物时，相机不做任何变化",
  T_49_META_TYP_177_I1_D: "当相机与跟随对象中间有遮挡物时，相机将推近跟随对象",
  T_49_META_TYP_177_I2_D: "当相机与跟随对象中间有遮挡物时，遮挡物将变为半透明",
  T_49_META_TYP_178_I0_D: "相机观察对象时，近大远小",
  T_49_META_TYP_178_I1_D: "相机观察对象时，远近物体大小一样",
  T_49_META_TYP_184_I0_D: "指定要渲染的资源UUID",
  T_49_META_TYP_185_I0_D: "渲染要使用的模型网格",
  T_49_META_TYP_185_I1_D: "渲染要使用的材质列表",
  T_49_META_TYP_187_I0_D: "道具ID",
  T_49_META_TYP_190_I0_D: "开启状态",
  T_49_META_TYP_190_I1_D: "对局结果",
  T_49_META_TYP_190_I10_D: "积分列表1",
  T_49_META_TYP_190_I11_D: "积分列表2",
  T_49_META_TYP_190_I12_D: "积分列表3",
  T_49_META_TYP_190_I13_D: "获胜MVP列表",
  T_49_META_TYP_190_I14_D: "失败MVP列表",
  T_49_META_TYP_190_I15_D: "显示对局详情",
  T_49_META_TYP_190_I16_D: "显示地图评价",
  T_49_META_TYP_190_I17_D: "显示送礼",
  T_49_META_TYP_190_I18_D: "显示举报",
  T_49_META_TYP_190_I19_D: "显示回放",
  T_49_META_TYP_190_I20_D: "显示分享",
  T_49_META_TYP_190_I21_D: "显示回到大厅",
  T_49_META_TYP_190_I22_D: "显示点赞",
  T_49_META_TYP_190_I23_D: "显示加好友",
  T_49_META_TYP_190_I24_D: "显示局外经济",
  T_49_META_TYP_190_I4_D: "左边队伍/阵营",
  T_49_META_TYP_190_I5_D: "右边队伍/阵营",
  T_49_META_TYP_190_I6_D: "玩家排名",
  T_49_META_TYP_190_I9_D: "标题列表",
  T_49_META_TYP_191_I0_D: "中心范围",
  T_49_META_TYP_191_I4_D: "中心闪光时间，单位毫秒",
  T_49_META_TYP_191_I5_D: "边缘闪光时间，单位毫秒",
  T_49_META_TYP_191_I6_D: "闪光弹命中效果开关",
  T_49_META_TYP_192_I3_D: "特效持续时间，单位秒",
  T_49_META_TYP_193_I1_D: "对局标题1",
  T_49_META_TYP_193_I10_D: "积分列表1",
  T_49_META_TYP_193_I11_D: "积分列表2",
  T_49_META_TYP_193_I12_D: "积分列表3",
  T_49_META_TYP_193_I13_D: "积分列表4",
  T_49_META_TYP_193_I14_D: "积分列表5",
  T_49_META_TYP_193_I15_D: "获胜MVP列表",
  T_49_META_TYP_193_I16_D: "失败MVP列表",
  T_49_META_TYP_193_I17_D: "显示对局详情",
  T_49_META_TYP_193_I18_D: "显示地图评价",
  T_49_META_TYP_193_I19_D: "显示送礼",
  T_49_META_TYP_193_I2_D: "对局标题2",
  T_49_META_TYP_193_I20_D: "显示举报",
  T_49_META_TYP_193_I21_D: "显示回放",
  T_49_META_TYP_193_I22_D: "显示分享",
  T_49_META_TYP_193_I23_D: "显示回到大厅",
  T_49_META_TYP_193_I24_D: "显示点赞",
  T_49_META_TYP_193_I25_D: "显示加好友",
  T_49_META_TYP_193_I26_D: "显示局外经济",
  T_49_META_TYP_193_I3_D: "对局结果",
  T_49_META_TYP_193_I4_D: "队伍/阵营排名",
  T_49_META_TYP_193_I5_D: "玩家排名",
  T_49_META_TYP_193_I6_D: "队伍名次",
  T_49_META_TYP_193_I7_D: "总积分名",
  T_49_META_TYP_193_I8_D: "总积分列表",
  T_49_META_TYP_193_I9_D: "标题列表",
  T_49_META_TYP_194_I0_D: "地雷开始生效的时间，单位秒",
  T_49_META_TYP_194_I1_D: "触发半径",
  T_49_META_TYP_194_I2_D: "在地雷范围内触发地雷需要的时长，单位秒",
  T_49_META_TYP_194_I3_D: "是否能自己触发",
  T_49_META_TYP_194_I4_D: "是否队友能触发",
  T_49_META_TYP_194_I5_D: "是否载具可以触发",
  T_49_META_TYP_194_I6_D: "地雷的存在时间，结束后自动爆炸，从放下地雷开始计时，单位秒",
  T_49_META_TYP_194_I7_D: "是否可被攻击",
  T_49_META_TYP_194_I8_D: "生命值",
  T_49_META_TYP_195_I0_D: "单次",
  T_49_META_TYP_195_I2_D: "往复",
  T_49_META_TYP_197_I0_D: "是否正在播放",
  T_49_META_TYP_197_I1_D: "标记位",
  T_49_META_TYP_197_I2_D: "勾选则创建时自动播放",
  T_49_META_TYP_198_I0_D: "附件对应的道具id",
  T_49_META_TYP_199_I0_D: "总能量值",
  T_49_META_TYP_199_I1_D: "每秒能量消耗",
  T_49_META_TYP_199_I10_D: "掉落伤害比例",
  T_49_META_TYP_199_I11_D: "当前能量值",
  T_49_META_TYP_199_I2_D: "每秒向上能量消耗",
  T_49_META_TYP_199_I3_D: "每秒快跑能量消耗",
  T_49_META_TYP_199_I4_D: "每秒冲刺能量消耗",
  T_49_META_TYP_199_I5_D: "基础水平速度",
  T_49_META_TYP_199_I6_D: "快跑水平速度",
  T_49_META_TYP_199_I7_D: "基础垂直速度",
  T_49_META_TYP_199_I8_D: "冲刺垂直速度",
  T_49_META_TYP_199_I9_D: "冲刺距离",
  T_49_META_TYP_200_I0_D: "区域ID",
  T_49_META_TYP_200_I1_D: "游戏ID",
  T_49_META_TYP_201_I0_D: "减速百分比：水域物件开放水中移速减缓百分比",
  T_49_META_TYP_203_I0_D: "目标实体",
  T_49_META_TYP_203_I1_D: "属性ID",
  T_49_META_TYP_203_I10_D: "游戏服务器开始tick的时刻",
  T_49_META_TYP_203_I11_D: "初始值",
  T_49_META_TYP_203_I12_D: "最终值",
  T_49_META_TYP_203_I13_D: "已过百分比",
  T_49_META_TYP_203_I4_D: "播放方式",
  T_49_META_TYP_203_I6_D: "持续时间 (s)",
  T_49_META_TYP_203_I7_D: "反转",
  T_49_META_TYP_203_I8_D: "控制点",
  T_49_META_TYP_203_I9_D: "强制同步游戏服务器状态",
  T_49_META_TYP_204_I0_D: "二段跳最大跳跃高度",
  T_49_META_TYP_204_I1_D: "跌落伤害百分比",
  T_49_META_TYP_204_I2_D: "每秒恢复能量",
  T_49_META_TYP_204_I3_D: "消耗能量",
  T_49_META_TYP_204_I4_D: "最大能量",
  T_49_META_TYP_205_I0_D: "最小起飞高度",
  T_49_META_TYP_205_I1_D: "最小结束高度",
  T_49_META_TYP_205_I2_D: "滑行速度",
  T_49_META_TYP_205_I3_D: "滑行下降速度",
  T_49_META_TYP_205_I4_D: "结束滑行下落速度",
  T_49_META_TYP_205_I5_D: "转弯速度（每秒度）",
  T_49_META_TYP_205_I6_D: "最大飞行高度",
  T_49_META_TYP_205_I7_D: "超高之后的下落速度",
  T_49_META_TYP_205_I8_D: "变速加速度",
  T_49_META_TYP_206_I0_D: "速度",
  T_49_META_TYP_206_I1_D: "加速度",
  T_49_META_TYP_206_I10_D: "在高速状态下，最大转向角度",
  T_49_META_TYP_206_I11_D: "高速转向角插值基率",
  T_49_META_TYP_206_I2_D: "冲刺速度",
  T_49_META_TYP_206_I3_D: "冲刺持续时间，单位秒",
  T_49_META_TYP_206_I4_D: "冲刺冷却时间，单位秒",
  T_49_META_TYP_206_I6_D: "跳跃cd，单位秒",
  T_49_META_TYP_206_I7_D: "上滑板后冲刺CD，单位秒",
  T_49_META_TYP_206_I8_D: "上滑板后冲刺CD开关",
  T_49_META_TYP_206_I9_D: "上滑板CD，单位秒",
  T_49_META_TYP_207_I1_D: "起始位置",
  T_49_META_TYP_207_I2_D: "终点位置",
  T_49_META_TYP_207_I3_D: "滑索ID",
  T_49_META_TYP_207_I4_D: "群组ID",
  T_49_META_TYP_207_I5_D: "是否结束",
  T_49_META_TYP_21_I0_D: "UI的基础层级",
  T_49_META_TYP_210_I1_D: "初速度",
  T_49_META_TYP_210_I2_D: "加速度",
  T_49_META_TYP_210_I3_D: "最大位移",
  T_49_META_TYP_210_I4_D: "初始世界坐标",
  T_49_META_TYP_210_I5_D: "游戏服务器强制同步位置信息",
  T_49_META_TYP_211_I0_D: "本地坐标",
  T_49_META_TYP_211_I1_D: "世界坐标",
  T_49_META_TYP_212_I0_D: "自身实体",
  T_49_META_TYP_212_I2_D: "偏移坐标",
  T_49_META_TYP_213_I0_D: "自身实体",
  T_49_META_TYP_213_I2_D: "偏移坐标",
  T_49_META_TYP_215_I0_D: "胜利",
  T_49_META_TYP_215_I1_D: "失败",
  T_49_META_TYP_215_I2_D: "Booyah",
  T_49_META_TYP_215_I3_D: "平局",
  T_49_META_TYP_218_I0_D: "光照强度",
  T_49_META_TYP_218_I1_D: "光照范围",
  T_49_META_TYP_218_I2_D: "光照颜色",
  T_49_META_TYP_22_I0_D: "打开状态为true时则显示，否则关闭",
  T_49_META_TYP_22_I1_D: "模板ID",
  T_49_META_TYP_22_I2_D: "当前最大控件ID",
  T_49_META_TYP_22_I3_D: "UI的基础层级",
  T_49_META_TYP_22_I4_D: "开启玩家视角",
  T_49_META_TYP_22_I5_D: "世界坐标",
  T_49_META_TYP_22_I6_D: "是否在场景中",
  T_49_META_TYP_22_I7_D: "世界坐标系中的旋转",
  T_49_META_TYP_22_I8_D: "世界坐标系中的缩放",
  T_49_META_TYP_221_I0_D: "档位切换延迟,该值越大，档位变化速度越慢",
  T_49_META_TYP_222_I0_D: "档位切换延迟,该值越大，档位变化速度越慢",
  T_49_META_TYP_225_I0_D: "炮塔伤害",
  T_49_META_TYP_225_I1_D: "炮塔攻击间隔（秒）",
  T_49_META_TYP_225_I10_D: "角度内才开火",
  T_49_META_TYP_225_I11_D: "减伤率",
  T_49_META_TYP_225_I12_D: "护甲穿透",
  T_49_META_TYP_225_I2_D: "炮塔命中率",
  T_49_META_TYP_225_I3_D: "炮塔范围",
  T_49_META_TYP_225_I4_D: "炮塔角速度",
  T_49_META_TYP_225_I5_D: "炮塔仰角",
  T_49_META_TYP_225_I6_D: "炮塔俯角",
  T_49_META_TYP_225_I7_D: "炮塔最大生命值",
  T_49_META_TYP_225_I8_D: "炮塔持续时间(秒)",
  T_49_META_TYP_225_I9_D: "最大炮塔数量",
  T_49_META_TYP_226_I0_D: "炮塔当前生命值",
  T_49_META_TYP_226_I1_D: "是否开启攻击（为否时禁止攻击）",
  T_49_META_TYP_227_I0_D: "节点控件",
  T_49_META_TYP_227_I1_D: "图片控件",
  T_49_META_TYP_227_I10_D: "贴图控件",
  T_49_META_TYP_227_I11_D: "名片控件",
  T_49_META_TYP_227_I12_D: "切换按钮控件",
  T_49_META_TYP_227_I13_D: "触摸板控件",
  T_49_META_TYP_227_I14_D: "摇杆控件",
  T_49_META_TYP_227_I15_D: "社交功能按钮控件",
  T_49_META_TYP_227_I2_D: "文本控件",
  T_49_META_TYP_227_I3_D: "按钮控件",
  T_49_META_TYP_227_I4_D: "文本输入控件",
  T_49_META_TYP_227_I5_D: "面板",
  T_49_META_TYP_227_I6_D: "滚动视图",
  T_49_META_TYP_227_I7_D: "网格",
  T_49_META_TYP_227_I8_D: "布局控件",
  T_49_META_TYP_227_I9_D: "容器控件",
  T_49_META_TYP_231_I0_D: "耐久恢复值",
  T_49_META_TYP_231_I1_D: "生效时间间隔，单位秒",
  T_49_META_TYP_233_I2_D: "计时结束时间，以秒为单位",
  T_49_META_TYP_233_I4_D: "图标资源名",
  T_49_META_TYP_234_I0_D: "触发时间，单位秒",
  T_49_META_TYP_234_I1_D: "是否能自己触发",
  T_49_META_TYP_234_I10_D: "当前生命值",
  T_49_META_TYP_234_I2_D: "是否队友能触发",
  T_49_META_TYP_234_I3_D: "是否载具可以触发",
  T_49_META_TYP_234_I4_D: "持续时间，单位秒",
  T_49_META_TYP_234_I5_D: "是否可被攻击",
  T_49_META_TYP_234_I6_D: "生命值",
  T_49_META_TYP_235_I0_D: "最大生命值",
  T_49_META_TYP_235_I2_D: "最大数量",
  T_49_META_TYP_237_I0_D: "钩锁飞行速度",
  T_49_META_TYP_237_I1_D: "牵引玩家速度",
  T_49_META_TYP_238_I0_D: "喷漆颜色",
  T_49_META_TYP_239_I0_D: "初始速度",
  T_49_META_TYP_239_I1_D: "加速度（如重力）",
  T_49_META_TYP_24_I0_D: "近战",
  T_49_META_TYP_24_I1_D: "枪械",
  T_49_META_TYP_24_I10_D: "空投砸中伤害，怪物自杀伤害",
  T_49_META_TYP_24_I11_D: "载具爆炸后燃烧伤害",
  T_49_META_TYP_24_I12_D: "油桶爆炸",
  T_49_META_TYP_24_I13_D: "类导弹武器",
  T_49_META_TYP_24_I14_D: "怪物伤害",
  T_49_META_TYP_24_I15_D: "伤害区",
  T_49_META_TYP_24_I17_D: "角色技能",
  T_49_META_TYP_24_I2_D: "手雷",
  T_49_META_TYP_24_I3_D: "毒圈",
  T_49_META_TYP_24_I4_D: "车辆",
  T_49_META_TYP_24_I5_D: "掉落",
  T_49_META_TYP_24_I6_D: "死亡区域",
  T_49_META_TYP_24_I7_D: "退出",
  T_49_META_TYP_24_I8_D: "断线",
  T_49_META_TYP_24_I9_D: "载具爆炸",
  T_49_META_TYP_241_I0_D: "牵引速度",
  T_49_META_TYP_241_I1_D: "摆荡速度",
  T_49_META_TYP_241_I2_D: "开启牵引按钮",
  T_49_META_TYP_241_I3_D: "开启摆荡按钮",
  T_49_META_TYP_241_I4_D: "运动锚点",
  T_49_META_TYP_241_I5_D: "离开荡摆的加速度",
  T_49_META_TYP_242_I2_D: "是否显示左侧特效",
  T_49_META_TYP_242_I3_D: "是否显示右侧特效",
  T_49_META_TYP_242_I4_D: "是否显示中间线",
  T_49_META_TYP_242_I5_D: "值[0, 1]",
  T_49_META_TYP_242_I7_D: "UI位置，只有XY分量有效",
  T_49_META_TYP_242_I8_D: "中间线位置[0,1]",
  T_49_META_TYP_243_I0_D: "上身服饰",
  T_49_META_TYP_243_I1_D: "下身服饰",
  T_49_META_TYP_243_I2_D: "鞋",
  T_49_META_TYP_243_I3_D: "妆容",
  T_49_META_TYP_243_I4_D: "头饰",
  T_49_META_TYP_243_I5_D: "连体衣",
  T_49_META_TYP_243_I6_D: "脸饰",
  T_49_META_TYP_244_I0_D: "要显示的文本内容",
  T_49_META_TYP_244_I10_D: "可以看见该实体的玩家列表",
  T_49_META_TYP_244_I11_D: "显示层级",
  T_49_META_TYP_244_I2_D: "跟随的目标实体",
  T_49_META_TYP_244_I3_D: "当忽略深度时可以穿透墙体显示，否则不行",
  T_49_META_TYP_244_I4_D: "总是面向摄像机",
  T_49_META_TYP_244_I5_D: "当设置为true时，当位置在屏幕外会贴边显示在屏幕内",
  T_49_META_TYP_244_I6_D: "字体风格",
  T_49_META_TYP_244_I7_D: "字体类型",
  T_49_META_TYP_244_I8_D: "字体尺寸",
  T_49_META_TYP_245_I0_D: "资源路径",
  T_49_META_TYP_245_I11_D: "显示层级",
  T_49_META_TYP_245_I3_D: "当忽略深度时可以穿透墙体显示，否则不行",
  T_49_META_TYP_245_I4_D: "当设置为true时，当位置在屏幕外会贴边显示在屏幕内",
  T_49_META_TYP_245_I5_D: "总是面向摄像机",
  T_49_META_TYP_245_I6_D: "显示方式",
  T_49_META_TYP_245_I7_D: "宽度",
  T_49_META_TYP_246_I0_D: "橙色",
  T_49_META_TYP_246_I1_D: "紫色",
  T_49_META_TYP_246_I2_D: "红色",
  T_49_META_TYP_246_I3_D: "绿色",
  T_49_META_TYP_246_I4_D: "蓝色",
  T_49_META_TYP_247_I1_D: "冲刺",
  T_49_META_TYP_247_I14_D: "表情UI开关",
  T_49_META_TYP_247_I15_D: "快速短语UI开关",
  T_49_META_TYP_247_I16_D: "拾取列表UI开关",
  T_49_META_TYP_247_I17_D: "队伍列表旁message UI开关",
  T_49_META_TYP_247_I18_D: "血条UI开关",
  T_49_META_TYP_247_I19_D: "EP条UI开关",
  T_49_META_TYP_247_I2_D: "攻击",
  T_49_META_TYP_247_I20_D: "防具状态UI开关",
  T_49_META_TYP_247_I21_D: "换弹按钮状态UI开关",
  T_49_META_TYP_247_I22_D: "快速换枪按钮",
  T_49_META_TYP_247_I23_D: "可开启/关闭载具喇叭按钮",
  T_49_META_TYP_247_I24_D: "可开启/关闭语音（麦克风）按钮",
  T_49_META_TYP_247_I25_D: "可开启/关闭标记按钮",
  T_49_META_TYP_247_I27_D: "可开启/关闭网络信号按钮",
  T_49_META_TYP_247_I28_D: "主动技能按钮UI开关",
  T_49_META_TYP_247_I29_D: "准星UI开关",
  T_49_META_TYP_247_I3_D: "跳跃",
  T_49_META_TYP_247_I30_D: "被动技能UI开关",
  T_49_META_TYP_247_I4_D: "击杀提示UI",
  T_49_META_TYP_247_I5_D: "武器栏UI",
  T_49_META_TYP_247_I6_D: "小地图UI",
  T_49_META_TYP_247_I7_D: "背包UI",
  T_49_META_TYP_247_I8_D: "医疗道具UI",
  T_49_META_TYP_247_I9_D: "true时则显示，否则关闭",
  T_49_META_TYP_249_I3_D: "爆破武器",
  T_49_META_TYP_249_I5_D: "重武器",
  T_49_META_TYP_249_I8_D: "冰冻弹",
  T_49_META_TYP_249_I9_D: "假人",
  T_49_META_TYP_25_I0_D: "当前阶段的索引，和流程编辑器中的索引对应",
  T_49_META_TYP_25_I1_D: "当前阶段的开始时间，单位ms",
  T_49_META_TYP_25_I2_D: "当前阶段的结束时间，单位ms",
  T_49_META_TYP_25_I3_D: "当前阶段的持续时间，单位ms",
  T_49_META_TYP_250_I1_D: "特效颜色，RGBA四通道，单通道取值范围0~255，存储在一个Int32中",
  T_49_META_TYP_250_I3_D: "特效贴图类型",
  T_49_META_TYP_250_I4_D: "表面透明度",
  T_49_META_TYP_2500_I1_D: "是否是默认出生点",
  T_49_META_TYP_2500_I3_D: "是否已经有玩家在该出生点区域内出生",
  T_49_META_TYP_2500_I4_D: "当前可分配的出生点点位坐标",
  T_49_META_TYP_2502_I0_D: "是否为死亡触发器，当不是死亡触发器时就是无敌触发器。（这是来自OB32的遗留问题，以后请拆分功能！）",
  T_49_META_TYP_2502_I1_D: "是否显示触发器边框，true为显示",
  T_49_META_TYP_2503_I0_D: "检查点ID",
  T_49_META_TYP_2503_I2_D: "检查点的位置",
  T_49_META_TYP_2507_I0_D: "该防御塔属于哪个阵营，和玩家相同则不会攻击玩家",
  T_49_META_TYP_2507_I1_D: "当前血量",
  T_49_META_TYP_2507_I10_D: "名字拼接对象编号",
  T_49_META_TYP_2507_I2_D: "最大血量",
  T_49_META_TYP_2507_I3_D: "攻击伤害，单次攻击对玩家能造成的伤害",
  T_49_META_TYP_2507_I4_D: "两次攻击之间的间隔，以秒为单位",
  T_49_META_TYP_2507_I5_D: "以中心为圆心，多大范围为半径的区域内均可被攻击",
  T_49_META_TYP_2507_I6_D: "减伤率，小于1的小数，最终伤害为伤害乘以（1-减伤率）",
  T_49_META_TYP_2507_I7_D: "攻击目标",
  T_49_META_TYP_2507_I8_D: "旋转角度",
  T_49_META_TYP_2507_I9_D: "防御塔状态",
  T_49_META_TYP_2508_I0_D: "每一波会生成的僵尸数",
  T_49_META_TYP_2508_I1_D: "一共会产生多少波僵尸",
  T_49_META_TYP_2508_I2_D: "是否连续生成，但是会有同屏上限",
  T_49_META_TYP_2508_I3_D: "当前生成到第几波了",
  T_49_META_TYP_2508_I5_D: "当前波次生成哪种僵尸",
  T_49_META_TYP_2508_I6_D: "AI在死亡的时候是否会掉落装备或者物品",
  T_49_META_TYP_2508_I7_D: "开始生成时间",
  T_49_META_TYP_2508_I8_D: "下一波和上一波之间的时间间隔",
  T_49_META_TYP_2509_I0_D: "每一波会生成的单位体数量",
  T_49_META_TYP_2509_I1_D: "一共会产生多少波单位生成器",
  T_49_META_TYP_2509_I2_D: "当前生成到第几波了",
  T_49_META_TYP_2509_I4_D: "每一波会按照哪个实体为模板来生成",
  T_49_META_TYP_2509_I5_D: "单位开始生成时间",
  T_49_META_TYP_2509_I6_D: "是否连续生成，但是会有同屏上限",
  T_49_META_TYP_2509_I7_D: "下一波和上一波之间的时间间隔",
  T_49_META_TYP_2509_I8_D: "模板的prefabID",
  T_49_META_TYP_2510_I0_D: "出生点个数",
  T_49_META_TYP_252_I1_D: "左侧图标",
  T_49_META_TYP_252_I2_D: "左侧文本",
  T_49_META_TYP_252_I3_D: "左侧得分文本",
  T_49_META_TYP_252_I5_D: "右侧图标",
  T_49_META_TYP_252_I6_D: "右侧文本",
  T_49_META_TYP_252_I7_D: "右侧得分文本",
  T_49_META_TYP_252_I8_D: "进度[0,1]",
  T_49_META_TYP_253_I0_D: "选择图标",
  T_49_META_TYP_253_I1_D: "提示文字",
  T_49_META_TYP_253_I2_D: "显示特效",
  T_49_META_TYP_253_I3_D: "UI位置",
  T_49_META_TYP_254_I1_D: "例如1.25表示正常速度的1.25倍",
  T_49_META_TYP_254_I2_D: "颜色",
  T_49_META_TYP_256_I0_D: "完全静止。最省性能",
  T_49_META_TYP_256_I1_D: "正常受力施力。最费性能",
  T_49_META_TYP_256_I2_D: "可通过脚本控制运动，可视为质量无限大",
  T_49_META_TYP_257_I0_D: "不同类型刚体功能不同",
  T_49_META_TYP_257_I1_D: "是否受重力",
  T_49_META_TYP_257_I2_D: "质量(kg)，最小有效质量0.001kg，如果为0则表示无限大质量，不会受力移动",
  T_49_META_TYP_257_I3_D: "重心位置，本地坐标系",
  T_49_META_TYP_257_I4_D: "刚体运动的线速度",
  T_49_META_TYP_257_I5_D: "刚体运动的角速度",
  T_49_META_TYP_257_I6_D: "线速度自然衰减系数，系数越大，运动速度衰减的越快",
  T_49_META_TYP_257_I7_D: "角速度自然衰减系数，系数越大，运动速度衰减的越快",
  T_49_META_TYP_257_I8_D: "对刚体施加的限制，是RigidbodyConstrainType的集合",
  T_49_META_TYP_258_I0_D: "2017-10-10 13:38:10 ",
  T_49_META_TYP_258_I1_D: "13:45 ",
  T_49_META_TYP_258_I2_D: "10/10/2017 1:45 PM ",
  T_49_META_TYP_258_I3_D: "10/10/2017",
  T_49_META_TYP_259_I0_D: "底图",
  T_49_META_TYP_259_I1_D: "提示文字",
  T_49_META_TYP_259_I2_D: "UI位置",
  T_49_META_TYP_259_I4_D: "提示文字颜色",
  T_49_META_TYP_260_I0_D: "选择图标",
  T_49_META_TYP_260_I1_D: "进度条颜色",
  T_49_META_TYP_260_I2_D: "值[0, 1]",
  T_49_META_TYP_260_I3_D: "速度，单位m/s",
  T_49_META_TYP_260_I4_D: "是否显示特效",
  T_49_META_TYP_260_I5_D: "UI位置[0,1]",
  T_49_META_TYP_260_I6_D: "技能初始进度，取值[0, 1]，UI创建后进度会立刻同步至当前进度",
  T_49_META_TYP_260_I7_D: "特效颜色",
  T_49_META_TYP_260_I8_D: "设置物件缩放值",
  T_49_META_TYP_265_I1_D: "是否进行背景填充",
  T_49_META_TYP_265_I2_D: "背景名称",
  T_49_META_TYP_265_I3_D: "背景颜色",
  T_49_META_TYP_265_I5_D: "BgAlpha",
  T_49_META_TYP_265_I6_D: "裁切类型",
  T_49_META_TYP_265_I7_D: "遮罩类型是遮罩时选用的图片名称",
  T_49_META_TYP_265_I8_D: "边缘柔和单位",
  T_49_META_TYP_267_I0_D: "滚动起点，默认为左上角",
  T_49_META_TYP_267_I1_D: "支持多种滚动方向",
  T_49_META_TYP_267_I10_D: "水平显示类型",
  T_49_META_TYP_267_I11_D: "显示位置",
  T_49_META_TYP_267_I2_D: "XY方向拖拽分量",
  T_49_META_TYP_267_I3_D: "支持多种拖动效果",
  T_49_META_TYP_267_I4_D: "滚轮因子，值越大滚动越快",
  T_49_META_TYP_267_I5_D: "惯性因子，值越大滚动时惯性越大",
  T_49_META_TYP_267_I6_D: "拖拽是否被限制在视口内，默认选中",
  T_49_META_TYP_267_I7_D: "勾选时拖拽开始会有缓动，不勾选则开始拖动就是鼠标移动的速度",
  T_49_META_TYP_267_I8_D: "当刚好合适视口时则退出拖拽",
  T_49_META_TYP_267_I9_D: "垂直显示类型",
  T_49_META_TYP_268_I0_D: "保持原逻辑",
  T_49_META_TYP_268_I1_D: "关闭",
  T_49_META_TYP_268_I2_D: "显示",
  T_49_META_TYP_269_I0_D: "所有者",
  T_49_META_TYP_269_I1_D: "套装ID",
  T_49_META_TYP_269_I2_D: "头饰ID",
  T_49_META_TYP_269_I3_D: "脸饰ID",
  T_49_META_TYP_269_I4_D: "妆容ID",
  T_49_META_TYP_269_I5_D: "上身ID",
  T_49_META_TYP_269_I6_D: "下身ID",
  T_49_META_TYP_269_I7_D: "鞋ID",
  T_49_META_TYP_272_I0_D: "女",
  T_49_META_TYP_272_I1_D: "男",
  T_49_META_TYP_273_I0_D: "小地图中心对应的世界坐标",
  T_49_META_TYP_273_I1_D: "小地图尺寸大小，宽高相同",
  T_49_META_TYP_273_I2_D: "是否启用小地图深度图显示模式",
  T_49_META_TYP_274_I1_D: "缩放大小",
  T_49_META_TYP_274_I4_D: "图标显示层级",
  T_49_META_TYP_275_I0_D: "骨骼缩放",
  T_49_META_TYP_275_I1_D: "骨骼节点的世界坐标",
  T_49_META_TYP_276_I0_D: "头部",
  T_49_META_TYP_276_I1_D: "左臂",
  T_49_META_TYP_276_I2_D: "左手",
  T_49_META_TYP_276_I3_D: "右臂",
  T_49_META_TYP_276_I4_D: "右手",
  T_49_META_TYP_276_I5_D: "躯干",
  T_49_META_TYP_276_I6_D: "左腿",
  T_49_META_TYP_276_I7_D: "左脚",
  T_49_META_TYP_276_I8_D: "右腿",
  T_49_META_TYP_276_I9_D: "右脚",
  T_49_META_TYP_277_I1_D: "相机射线检测的距离",
  T_49_META_TYP_277_I2_D: "相机射线检测的碰撞层遮罩",
  T_49_META_TYP_277_I3_D: "按钮的位置偏移",
  T_49_META_TYP_277_I4_D: "图标资源ID",
  T_49_META_TYP_277_I5_D: "点击区域大小",
  T_49_META_TYP_277_I6_D: "是否在目标点显示对象",
  T_49_META_TYP_277_I7_D: "目标点显示的对象",
  T_49_META_TYP_278_I0_D: "生成地图像素的目标实体",
  T_49_META_TYP_28_I0_D: "每回合能否重置",
  T_49_META_TYP_280_I0_D: "球体半径",
  T_49_META_TYP_281_I0_D: "胶囊体两端半球的半径",
  T_49_META_TYP_29_I0_D: "球体",
  T_49_META_TYP_29_I1_D: "光柱",
  T_49_META_TYP_29_I10_D: "脚底光柱，现用于进入终点的反馈",
  T_49_META_TYP_29_I11_D: "冰冻",
  T_49_META_TYP_29_I12_D: "灯光",
  T_49_META_TYP_29_I13_D: "上升气流",
  T_49_META_TYP_29_I14_D: "旋风气体爆炸",
  T_49_META_TYP_29_I15_D: "躲藏者被击杀",
  T_49_META_TYP_29_I16_D: "暴走",
  T_49_META_TYP_29_I17_D: "分身死亡",
  T_49_META_TYP_29_I18_D: "射击反馈",
  T_49_META_TYP_29_I19_D: "分身死亡",
  T_49_META_TYP_29_I2_D: "圆环",
  T_49_META_TYP_29_I20_D: "分身",
  T_49_META_TYP_29_I21_D: "传送门",
  T_49_META_TYP_29_I22_D: "闪光弹烟火",
  T_49_META_TYP_29_I23_D: "火焰弹",
  T_49_META_TYP_29_I24_D: "循环燃烧",
  T_49_META_TYP_29_I25_D: "毒气",
  T_49_META_TYP_29_I26_D: "爱心",
  T_49_META_TYP_29_I29_D: "门",
  T_49_META_TYP_29_I30_D: "烟花",
  T_49_META_TYP_29_I31_D: "跑鞋特效",
  T_49_META_TYP_29_I32_D: "爆炸特效",
  T_49_META_TYP_29_I33_D: "重生点特效",
  T_49_META_TYP_29_I34_D: "激光特效",
  T_49_META_TYP_29_I35_D: "技能释放特效",
  T_49_META_TYP_29_I36_D: "武器子弹特效",
  T_49_META_TYP_29_I37_D: "子弹命中特效",
  T_49_META_TYP_29_I38_D: "武器开火特效",
  T_49_META_TYP_29_I39_D: "技能特效",
  T_49_META_TYP_29_I40_D: "光环",
  T_49_META_TYP_29_I41_D: "气泡",
  T_49_META_TYP_29_I42_D: "烟尘",
  T_49_META_TYP_29_I43_D: "石子飞溅",
  T_49_META_TYP_29_I44_D: "线条",
  T_49_META_TYP_29_I45_D: "闪烁",
  T_49_META_TYP_29_I47_D: "上升粒子",
  T_49_META_TYP_29_I48_D: "烟雾",
  T_49_META_TYP_29_I49_D: "符咒",
  T_49_META_TYP_29_I50_D: "冰冻区域",
  T_49_META_TYP_29_I51_D: "冷气",
  T_49_META_TYP_29_I52_D: "雪花",
  T_49_META_TYP_29_I53_D: "火焰",
  T_49_META_TYP_29_I54_D: "光束",
  T_49_META_TYP_29_I55_D: "毒气扩散",
  T_49_META_TYP_29_I56_D: "毒气",
  T_49_META_TYP_29_I57_D: "爆炸火光",
  T_49_META_TYP_29_I58_D: "光效",
  T_49_META_TYP_29_I59_D: "星星",
  T_49_META_TYP_29_I6_D: "脚下光环",
  T_49_META_TYP_29_I60_D: "燃烧的火堆",
  T_49_META_TYP_29_I61_D: "水花",
  T_49_META_TYP_29_I62_D: "电击",
  T_49_META_TYP_29_I63_D: "水墨特效",
  T_49_META_TYP_29_I64_D: "黑洞特效",
  T_49_META_TYP_29_I65_D: "黑洞爆炸特效",
  T_49_META_TYP_29_I66_D: "水晶球特效",
  T_49_META_TYP_29_I67_D: "激光弹特效",
  T_49_META_TYP_29_I68_D: "拖尾特效",
  T_49_META_TYP_29_I69_D: "云雾特效",
  T_49_META_TYP_29_I7_D: "地面印记",
  T_49_META_TYP_29_I8_D: "烟雾",
  T_49_META_TYP_29_I9_D: "符咒爆炸",
  T_49_META_TYP_290_I0_D: "刷新间隔,数字越大刷新越慢，单位毫秒",
  T_49_META_TYP_290_I1_D: "是否开启调试",
  T_49_META_TYP_291_I0_D: "条件节点",
  T_49_META_TYP_291_I1_D: "行为节点",
  T_49_META_TYP_293_I0_D: "行为树ID",
  T_49_META_TYP_293_I1_D: "行为树实体",
  T_49_META_TYP_294_I1_D: "布局类型",
  T_49_META_TYP_294_I10_D: "排序方式",
  T_49_META_TYP_294_I2_D: "初始方向",
  T_49_META_TYP_294_I3_D: "排列方向",
  T_49_META_TYP_294_I4_D: "子项格子的宽高",
  T_49_META_TYP_294_I5_D: "子项格子间距",
  T_49_META_TYP_294_I6_D: "限制",
  T_49_META_TYP_294_I7_D: "限制数量",
  T_49_META_TYP_294_I8_D: "垂直偏移量",
  T_49_META_TYP_294_I9_D: "水平偏移量",
  T_49_META_TYP_295_I2_D: "播放速度",
  T_49_META_TYP_296_I1_D: "片段长度",
  T_49_META_TYP_297_I0_D: "绑定的对象",
  T_49_META_TYP_297_I4_D: "资源UUID",
  T_49_META_TYP_298_I0_D: "保持原逻辑",
  T_49_META_TYP_298_I2_D: "单次",
  T_49_META_TYP_30_I0_D: "正方形",
  T_49_META_TYP_30_I1_D: "四边形",
  T_49_META_TYP_30_I10_D: "箭头",
  T_49_META_TYP_30_I11_D: "标注",
  T_49_META_TYP_30_I12_D: "石头",
  T_49_META_TYP_30_I13_D: "剪刀",
  T_49_META_TYP_30_I14_D: "布",
  T_49_META_TYP_30_I15_D: "点赞",
  T_49_META_TYP_30_I16_D: "对",
  T_49_META_TYP_30_I17_D: "错",
  T_49_META_TYP_30_I18_D: "加",
  T_49_META_TYP_30_I19_D: "闪电",
  T_49_META_TYP_30_I2_D: "直角梯形",
  T_49_META_TYP_30_I20_D: "心",
  T_49_META_TYP_30_I21_D: "星",
  T_49_META_TYP_30_I22_D: "月",
  T_49_META_TYP_30_I23_D: "太阳",
  T_49_META_TYP_30_I24_D: "眼镜",
  T_49_META_TYP_30_I25_D: "钥匙",
  T_49_META_TYP_30_I26_D: "奖杯",
  T_49_META_TYP_30_I27_D: "旗帜",
  T_49_META_TYP_30_I28_D: "沙漏",
  T_49_META_TYP_30_I29_D: "文件夹",
  T_49_META_TYP_30_I3_D: "梯形",
  T_49_META_TYP_30_I30_D: "打开的文件夹",
  T_49_META_TYP_30_I31_D: "房屋",
  T_49_META_TYP_30_I32_D: "休息",
  T_49_META_TYP_30_I33_D: "刷新",
  T_49_META_TYP_30_I34_D: "循环",
  T_49_META_TYP_30_I35_D: "放大镜",
  T_49_META_TYP_30_I36_D: "垃圾桶",
  T_49_META_TYP_30_I37_D: "返回",
  T_49_META_TYP_30_I38_D: "钻石",
  T_49_META_TYP_30_I39_D: "泳圈",
  T_49_META_TYP_30_I4_D: "六边形",
  T_49_META_TYP_30_I40_D: "钱",
  T_49_META_TYP_30_I41_D: "锁",
  T_49_META_TYP_30_I42_D: "设置",
  T_49_META_TYP_30_I43_D: "退出",
  T_49_META_TYP_30_I44_D: "对话",
  T_49_META_TYP_30_I45_D: "准星",
  T_49_META_TYP_30_I46_D: "枪",
  T_49_META_TYP_30_I47_D: "剑",
  T_49_META_TYP_30_I48_D: "爆炸",
  T_49_META_TYP_30_I49_D: "瞄准",
  T_49_META_TYP_30_I5_D: "圆形",
  T_49_META_TYP_30_I50_D: "十字",
  T_49_META_TYP_30_I51_D: "防守",
  T_49_META_TYP_30_I52_D: "僵尸",
  T_49_META_TYP_30_I53_D: "回收",
  T_49_META_TYP_30_I54_D: "礼物",
  T_49_META_TYP_30_I55_D: "衣服",
  T_49_META_TYP_30_I56_D: "游戏",
  T_49_META_TYP_30_I57_D: "玩家",
  T_49_META_TYP_30_I58_D: "商店",
  T_49_META_TYP_30_I59_D: "出口",
  T_49_META_TYP_30_I6_D: "三角形",
  T_49_META_TYP_30_I60_D: "警告",
  T_49_META_TYP_30_I61_D: "文本",
  T_49_META_TYP_30_I62_D: "计时器物件",
  T_49_META_TYP_30_I63_D: "铃铛",
  T_49_META_TYP_30_I64_D: "宠物",
  T_49_META_TYP_30_I65_D: "炸弹",
  T_49_META_TYP_30_I66_D: "修复",
  T_49_META_TYP_30_I67_D: "笑脸",
  T_49_META_TYP_30_I68_D: "喇叭",
  T_49_META_TYP_30_I7_D: "叹号",
  T_49_META_TYP_30_I70_D: "皇冠",
  T_49_META_TYP_30_I71_D: "决斗",
  T_49_META_TYP_30_I72_D: "公会",
  T_49_META_TYP_30_I73_D: "心跳",
  T_49_META_TYP_30_I74_D: "音乐",
  T_49_META_TYP_30_I75_D: "载具",
  T_49_META_TYP_30_I76_D: "近战武器",
  T_49_META_TYP_30_I77_D: "手枪",
  T_49_META_TYP_30_I78_D: "步枪",
  T_49_META_TYP_30_I79_D: "狙击枪",
  T_49_META_TYP_30_I8_D: "问号",
  T_49_META_TYP_30_I80_D: "霰弹",
  T_49_META_TYP_30_I81_D: "冲锋枪",
  T_49_META_TYP_30_I82_D: "治疗枪",
  T_49_META_TYP_30_I83_D: "碎甲",
  T_49_META_TYP_30_I84_D: "爆头",
  T_49_META_TYP_30_I85_D: "技能1",
  T_49_META_TYP_30_I86_D: "技能2",
  T_49_META_TYP_30_I87_D: "技能3",
  T_49_META_TYP_30_I88_D: "技能4",
  T_49_META_TYP_30_I89_D: "技能5",
  T_49_META_TYP_30_I9_D: "标记",
  T_49_META_TYP_30_I90_D: "技能6",
  T_49_META_TYP_30_I91_D: "技能7",
  T_49_META_TYP_30_I92_D: "技能8",
  T_49_META_TYP_30_I93_D: "技能9",
  T_49_META_TYP_30_I94_D: "技能10",
  T_49_META_TYP_300_I0_D: "资源UUID",
  T_49_META_TYP_300_I2_D: "旋转",
  T_49_META_TYP_300_I3_D: "创建的实体",
  T_49_META_TYP_301_I1_D: "自爆",
  T_49_META_TYP_301_I2_D: "冲撞攻击",
  T_49_META_TYP_301_I3_D: "冲击波",
  T_49_META_TYP_301_I4_D: "旋风斩",
  T_49_META_TYP_301_I5_D: "跳斩",
  T_49_META_TYP_301_I6_D: "举盾攻击",
  T_49_META_TYP_301_I7_D: "破盾攻击",
  T_49_META_TYP_302_I5_D: "背包",
  T_49_META_TYP_302_I7_D: "滑板、迷彩....",
  T_49_META_TYP_303_I0_D: "增加最大血量",
  T_49_META_TYP_303_I1_D: "持续恢复血量",
  T_49_META_TYP_305_I0_D: "完成",
  T_49_META_TYP_305_I1_D: "运行中",
  T_49_META_TYP_307_I0_D: "凝胶生成器每点伤害提供经验",
  T_49_META_TYP_307_I1_D: "凝胶生成器移动每米提供经验",
  T_49_META_TYP_307_I2_D: "凝胶生成器每秒提供经验",
  T_49_META_TYP_307_I3_D: "凝胶生成器升级芯片提供经验",
  T_49_META_TYP_307_I4_D: "冰墙充能上限(矫正系数)",
  T_49_META_TYP_308_I0_D: "凝胶制造器",
  T_49_META_TYP_31_I0_D: "手雷爆炸",
  T_49_META_TYP_31_I1_D: "枪声",
  T_49_META_TYP_31_I10_D: "击中造成伤害音效",
  T_49_META_TYP_31_I11_D: "升级音效",
  T_49_META_TYP_31_I12_D: "弱点击音效",
  T_49_META_TYP_31_I13_D: "玩家踩机关音效",
  T_49_META_TYP_31_I14_D: "装备修复音效",
  T_49_META_TYP_31_I15_D: "装备修复音效",
  T_49_META_TYP_31_I16_D: "失误或丢失音效",
  T_49_META_TYP_31_I17_D: "提醒音效",
  T_49_META_TYP_31_I18_D: "足球落地音效",
  T_49_META_TYP_31_I19_D: "欢呼声音效",
  T_49_META_TYP_31_I2_D: "倒计时的滴滴声",
  T_49_META_TYP_31_I20_D: "炸弹提示音效",
  T_49_META_TYP_31_I21_D: "炸弹爆炸前音效",
  T_49_META_TYP_31_I22_D: "猎人出现音效",
  T_49_META_TYP_31_I23_D: "最终bgm音效",
  T_49_META_TYP_31_I24_D: "补给箱刷新音效",
  T_49_META_TYP_31_I25_D: "加速装置音效",
  T_49_META_TYP_31_I26_D: "消失提示音效",
  T_49_META_TYP_31_I27_D: "视觉效果音效",
  T_49_META_TYP_31_I28_D: "夜晚虫鸣音效",
  T_49_META_TYP_31_I29_D: "沉闷打击音效",
  T_49_META_TYP_31_I3_D: "界面点击",
  T_49_META_TYP_31_I30_D: "响应音效",
  T_49_META_TYP_31_I31_D: "发现惊喜音效",
  T_49_META_TYP_31_I32_D: "小鬼嬉闹音效",
  T_49_META_TYP_31_I33_D: "阶段开始音效",
  T_49_META_TYP_31_I34_D: "僵尸音效",
  T_49_META_TYP_31_I35_D: "恐怖音效",
  T_49_META_TYP_31_I36_D: "变身音效",
  T_49_META_TYP_31_I37_D: "快速心跳音效",
  T_49_META_TYP_31_I38_D: "中速心跳音效",
  T_49_META_TYP_31_I39_D: "慢速心跳音效",
  T_49_META_TYP_31_I4_D: "受击尖叫声女",
  T_49_META_TYP_31_I40_D: "暴走音效",
  T_49_META_TYP_31_I41_D: "点击音效",
  T_49_META_TYP_31_I42_D: "技能恢复音效",
  T_49_META_TYP_31_I43_D: "加入游戏音效",
  T_49_META_TYP_31_I44_D: "机械装置回声音效",
  T_49_META_TYP_31_I45_D: "蚊子音效",
  T_49_META_TYP_31_I46_D: "密集叮叮叮1音效",
  T_49_META_TYP_31_I47_D: "密集叮叮叮2音效",
  T_49_META_TYP_31_I48_D: "机关开启音效",
  T_49_META_TYP_31_I49_D: "充能音效1",
  T_49_META_TYP_31_I5_D: "受击尖叫声男",
  T_49_META_TYP_31_I50_D: "脚步提示音效",
  T_49_META_TYP_31_I51_D: "任务成功提示1音效",
  T_49_META_TYP_31_I52_D: "危险提示音1音效",
  T_49_META_TYP_31_I53_D: "危险提示音2音效",
  T_49_META_TYP_31_I54_D: "倒计时3音效",
  T_49_META_TYP_31_I55_D: "显示Tips提示音效",
  T_49_META_TYP_31_I56_D: "乌鸦叫的环境音音效",
  T_49_META_TYP_31_I57_D: "用传送点传送到错误区域的声音音效",
  T_49_META_TYP_31_I58_D: "用传送点传送到正确区域的声音音效",
  T_49_META_TYP_31_I59_D: "传送音效",
  T_49_META_TYP_31_I6_D: "金币拾取音效",
  T_49_META_TYP_31_I60_D: "电击音效",
  T_49_META_TYP_31_I61_D: "获得道具音效",
  T_49_META_TYP_31_I62_D: "电子梦幻可爱背景音乐音效",
  T_49_META_TYP_31_I63_D: "休闲游戏背景音乐音效",
  T_49_META_TYP_31_I64_D: "打开盒子",
  T_49_META_TYP_31_I65_D: "升级",
  T_49_META_TYP_31_I66_D: "满级",
  T_49_META_TYP_31_I67_D: "点击按钮",
  T_49_META_TYP_31_I68_D: "倒计时",
  T_49_META_TYP_31_I69_D: "打败敌人",
  T_49_META_TYP_31_I7_D: "竞速赛中经过终点的触发音效",
  T_49_META_TYP_31_I70_D: "结束",
  T_49_META_TYP_31_I71_D: "前进",
  T_49_META_TYP_31_I72_D: "胜利",
  T_49_META_TYP_31_I73_D: "训练基地检查点",
  T_49_META_TYP_31_I74_D: "倒计时",
  T_49_META_TYP_31_I75_D: "游戏开始",
  T_49_META_TYP_31_I76_D: "获得大金币",
  T_49_META_TYP_31_I77_D: "获得中金币",
  T_49_META_TYP_31_I78_D: "获得小金币",
  T_49_META_TYP_31_I79_D: "加入激战",
  T_49_META_TYP_31_I8_D: "触发器触发音效",
  T_49_META_TYP_31_I80_D: "工会福利红包",
  T_49_META_TYP_31_I81_D: "喇叭",
  T_49_META_TYP_31_I82_D: "弹劾会长",
  T_49_META_TYP_31_I83_D: "仓库保存",
  T_49_META_TYP_31_I84_D: "特殊枪声",
  T_49_META_TYP_31_I85_D: "子弹命中",
  T_49_META_TYP_31_I86_D: "移动",
  T_49_META_TYP_31_I87_D: "点击禁用按钮",
  T_49_META_TYP_31_I88_D: "技能充能完成",
  T_49_META_TYP_31_I89_D: "激光技能",
  T_49_META_TYP_31_I9_D: "降级音效",
  T_49_META_TYP_31_I90_D: "获得道具2",
  T_49_META_TYP_31_I91_D: "倒计时3",
  T_49_META_TYP_31_I92_D: "游戏结束2",
  T_49_META_TYP_31_I93_D: "击杀提示讯息",
  T_49_META_TYP_31_I94_D: "爆炸",
  T_49_META_TYP_31_I95_D: "元气弹技能",
  T_49_META_TYP_31_I96_D: "血池技能",
  T_49_META_TYP_311_I1_D: "最大伤害",
  T_49_META_TYP_311_I3_D: "投掷物脱手后的飞行速度，单位m/s",
  T_49_META_TYP_311_I4_D: "投掷物脱手后到生效的时长间隔，单位秒",
  T_49_META_TYP_313_I0_D: "反制区域半径",
  T_49_META_TYP_313_I1_D: "反制区域持续时长，单位秒",
  T_49_META_TYP_314_I0_D: "动画控制器资源ID",
  T_49_META_TYP_314_I1_D: "动画控制器",
  T_49_META_TYP_315_I0_D: "背包所有者",
  T_49_META_TYP_315_I1_D: "背包空间",
  T_49_META_TYP_315_I2_D: "已占用空间",
  T_49_META_TYP_315_I3_D: "所有物品",
  T_49_META_TYP_316_I0_D: "Texture名称",
  T_49_META_TYP_316_I1_D: "Shader名称",
  T_49_META_TYP_316_I11_D: "翻转方式",
  T_49_META_TYP_316_I2_D: "UV偏移量",
  T_49_META_TYP_316_I3_D: "UV宽高",
  T_49_META_TYP_316_I4_D: "填充类型",
  T_49_META_TYP_316_I5_D: "左右边界",
  T_49_META_TYP_316_I6_D: "上下边界",
  T_49_META_TYP_317_I0_D: "无限制",
  T_49_META_TYP_317_I1_D: "限制X轴方向平移",
  T_49_META_TYP_317_I2_D: "限制Y轴方向平移",
  T_49_META_TYP_317_I3_D: "限制Z轴方向平移",
  T_49_META_TYP_317_I4_D: "限制绕X轴旋转",
  T_49_META_TYP_317_I5_D: "限制绕Y轴旋转",
  T_49_META_TYP_317_I6_D: "限制绕Z轴旋转",
  T_49_META_TYP_317_I7_D: "限制所有轴的平移",
  T_49_META_TYP_317_I8_D: "限制所有轴的旋转",
  T_49_META_TYP_317_I9_D: "限制所有轴的平移和旋转",
  T_49_META_TYP_318_I0_D: "射程",
  T_49_META_TYP_318_I1_D: "满伤害距离",
  T_49_META_TYP_318_I10_D: "开镜移动速度修正系数",
  T_49_META_TYP_318_I11_D: "瞄准镜名义放大倍率",
  T_49_META_TYP_318_I12_D: "FOV放大倍率",
  T_49_META_TYP_318_I13_D: "瞄镜射击UI放大倍率",
  T_49_META_TYP_318_I14_D: "瞄镜UI射击放大时间(s)",
  T_49_META_TYP_318_I15_D: "瞄镜UI射击恢复时间(s)",
  T_49_META_TYP_318_I16_D: "瞄镜最小伤害距离修正系数",
  T_49_META_TYP_318_I17_D: "允许开镜时辅助瞄准",
  T_49_META_TYP_318_I18_D: "辅助瞄准准星屏幕范围吸引比率(0-1)",
  T_49_META_TYP_318_I19_D: "辅助瞄准距离衰减影响系数(0-1)",
  T_49_META_TYP_318_I2_D: "最小伤害开始距离",
  T_49_META_TYP_318_I20_D: "允许辅助瞄准距离优先",
  T_49_META_TYP_318_I21_D: "辅助瞄准距离优先最小距离",
  T_49_META_TYP_318_I22_D: "辅助瞄准距离优先最大距离",
  T_49_META_TYP_318_I23_D: "辅助瞄准距离优先影响系数(>=1)",
  T_49_META_TYP_318_I24_D: "瞄镜旋转敏感度系数",
  T_49_META_TYP_318_I25_D: "收敛速度",
  T_49_META_TYP_318_I3_D: "弹匣数量修正",
  T_49_META_TYP_318_I4_D: "攻击间隔",
  T_49_META_TYP_318_I5_D: "换弹夹速度",
  T_49_META_TYP_318_I6_D: "自动换弹速度",
  T_49_META_TYP_318_I7_D: "扩散增加速度",
  T_49_META_TYP_318_I8_D: "蹲下,趴下时的散射速率，每0.1表示每发子弹准星增加10%范围",
  T_49_META_TYP_318_I9_D: "最大扩散阈值",
  T_49_META_TYP_319_I0_D: "简单",
  T_49_META_TYP_319_I1_D: "九宫格",
  T_49_META_TYP_319_I2_D: "平铺",
  T_49_META_TYP_319_I3_D: "填充",
  T_49_META_TYP_319_I4_D: "自适应",
  T_49_META_TYP_32_I0_D: "玩家处于正常活跃状态",
  T_49_META_TYP_32_I1_D: "玩家处于击倒状态",
  T_49_META_TYP_32_I2_D: "玩家处于死亡状态",
  T_49_META_TYP_320_I0_D: "水平",
  T_49_META_TYP_320_I1_D: "垂直",
  T_49_META_TYP_320_I2_D: "90度扇形",
  T_49_META_TYP_320_I3_D: "180度扇形",
  T_49_META_TYP_320_I4_D: "360度扇形",
  T_49_META_TYP_321_I0_D: "触发辅助瞄准的最大距离",
  T_49_META_TYP_321_I1_D: "触发辅助瞄准时准星偏移量，如偏移后的点不在实体中则辅助瞄准会失效",
  T_49_META_TYP_322_I0_D: "无",
  T_49_META_TYP_322_I1_D: "头",
  T_49_META_TYP_322_I2_D: "身体",
  T_49_META_TYP_322_I3_D: "四肢",
  T_49_META_TYP_323_I0_D: "缩放",
  T_49_META_TYP_323_I1_D: "AccountID",
  T_49_META_TYP_323_I2_D: "玩家简介信息",
  T_49_META_TYP_323_I3_D: "样式",
  T_49_META_TYP_323_I4_D: "显示段位",
  T_49_META_TYP_323_I5_D: "显示纪念章",
  T_49_META_TYP_323_I6_D: "显示昵称",
  T_49_META_TYP_324_I0_D: "产生指定大小的力",
  T_49_META_TYP_324_I1_D: "产生指定大小的加速度",
  T_49_META_TYP_324_I2_D: "产生指定大小的冲量",
  T_49_META_TYP_324_I3_D: "产生指定大小的速度",
  T_49_META_TYP_326_I0_D: "账号ID",
  T_49_META_TYP_326_I1_D: "头像ID",
  T_49_META_TYP_326_I2_D: "横幅ID",
  T_49_META_TYP_326_I3_D: "纪念章ID",
  T_49_META_TYP_326_I4_D: "玩家的昵称",
  T_49_META_TYP_326_I5_D: "BR段位",
  T_49_META_TYP_326_I6_D: "BR巅峰段位",
  T_49_META_TYP_326_I7_D: "CS段位",
  T_49_META_TYP_326_I8_D: "CS巅峰段位",
  T_49_META_TYP_327_I0_D: "资源ID",
  T_49_META_TYP_327_I1_D: "部件显示掩码1",
  T_49_META_TYP_327_I2_D: "部件显示掩码2",
  T_49_META_TYP_327_I3_D: "部件显示掩码3",
  T_49_META_TYP_327_I4_D: "部件显示掩码4",
  T_49_META_TYP_329_I0_D: "驾驶员",
  T_49_META_TYP_329_I1_D: "乘客1座位",
  T_49_META_TYP_329_I2_D: "乘客2座位",
  T_49_META_TYP_329_I3_D: "乘客3座位",
  T_49_META_TYP_33_I0_D: "升序忽略零值，零值排在最后",
  T_49_META_TYP_33_I1_D: "降序，大到小",
  T_49_META_TYP_33_I2_D: "升序，小到大",
  T_49_META_TYP_330_I4_D: "无敌效果持续时长（单位s）",
  T_49_META_TYP_330_I5_D: "控制点",
  T_49_META_TYP_330_I8_D: "变化值",
  T_49_META_TYP_332_I0_D: "是否循环",
  T_49_META_TYP_333_I0_D: "FZLanTingHei",
  T_49_META_TYP_333_I1_D: "SimplifiedArabic",
  T_49_META_TYP_333_I2_D: "NotoNastaliqUrdu",
  T_49_META_TYP_333_I3_D: "GFFLatin",
  T_49_META_TYP_333_I4_D: "AgencyFB",
  T_49_META_TYP_333_I5_D: "Supermarket",
  T_49_META_TYP_333_I6_D: "HindSiliguri",
  T_49_META_TYP_335_I0_D: "资源路径, 默认为空",
  T_49_META_TYP_335_I1_D: "播放次数，默认为1",
  T_49_META_TYP_335_I2_D: "音量大小，默认为50",
  T_49_META_TYP_335_I3_D: "最大距离",
  T_49_META_TYP_335_I4_D: "最小距离",
  T_49_META_TYP_335_I5_D: "是否是3D音乐",
  T_49_META_TYP_335_I6_D: "优先级",
  T_49_META_TYP_335_I7_D: "开始前等待时长，单位秒",
  T_49_META_TYP_335_I8_D: "播放状态",
  T_49_META_TYP_338_I0_D: "移动状态",
  T_49_META_TYP_338_I1_D: "冲刺状态",
  T_49_META_TYP_338_I2_D: "攻击状态",
  T_49_META_TYP_338_I3_D: "跳跃状态",
  T_49_META_TYP_338_I4_D: "翻越状态",
  T_49_META_TYP_338_I5_D: "进入载具(司机)",
  T_49_META_TYP_338_I6_D: "进入载具(乘客)",
  T_49_META_TYP_338_I7_D: "离开载具",
  T_49_META_TYP_338_I8_D: "驾驶",
  T_49_META_TYP_339_I0_D: "四肢伤害系数变化",
  T_49_META_TYP_339_I1_D: "头伤害系数变化",
  T_49_META_TYP_339_I2_D: "耐久上限倍率",
  T_49_META_TYP_339_I3_D: "玩家血量倍率",
  T_49_META_TYP_339_I4_D: "额外爆炸减伤系数（%）",
  T_49_META_TYP_339_I5_D: "额外背包空间",
  T_49_META_TYP_339_I6_D: "替换优先级",
  T_49_META_TYP_34_I0_D: "默认拳头",
  T_49_META_TYP_34_I1_D: "KAR98K",
  T_49_META_TYP_34_I10_D: "AWM2",
  T_49_META_TYP_34_I100_D: "Famas-I",
  T_49_META_TYP_34_I101_D: "Groza-X",
  T_49_META_TYP_34_I102_D: "SVD-Y",
  T_49_META_TYP_34_I103_D: "G36",
  T_49_META_TYP_34_I104_D: "M24",
  T_49_META_TYP_34_I105_D: "M4A1-I",
  T_49_META_TYP_34_I106_D: "M4A1-II",
  T_49_META_TYP_34_I107_D: "M4A1-III",
  T_49_META_TYP_34_I108_D: "M4A1-III",
  T_49_META_TYP_34_I109_D: "蓄力霰弹枪",
  T_49_META_TYP_34_I11_D: "M1014",
  T_49_META_TYP_34_I110_D: "MAC10",
  T_49_META_TYP_34_I111_D: "手炮",
  T_49_META_TYP_34_I112_D: "IceGun",
  T_49_META_TYP_34_I113_D: "护盾枪",
  T_49_META_TYP_34_I114_D: "MP5-II",
  T_49_META_TYP_34_I115_D: "MP5-III",
  T_49_META_TYP_34_I116_D: "MP5-III",
  T_49_META_TYP_34_I117_D: "M60-II",
  T_49_META_TYP_34_I118_D: "M60-III",
  T_49_META_TYP_34_I119_D: "M60-III",
  T_49_META_TYP_34_I12_D: "M10142",
  T_49_META_TYP_34_I120_D: "VSS-II",
  T_49_META_TYP_34_I121_D: "VSS-III",
  T_49_META_TYP_34_I122_D: "M14-II",
  T_49_META_TYP_34_I123_D: "M14-III",
  T_49_META_TYP_34_I124_D: "M14-III",
  T_49_META_TYP_34_I125_D: "Kar98K-II",
  T_49_META_TYP_34_I126_D: "Kar98K-III",
  T_49_META_TYP_34_I127_D: "Kar98K-III",
  T_49_META_TYP_34_I128_D: "Famas-II",
  T_49_META_TYP_34_I129_D: "Famas-III",
  T_49_META_TYP_34_I13_D: "火焰榴弹枪",
  T_49_META_TYP_34_I133_D: "闪光弹",
  T_49_META_TYP_34_I134_D: "烟雾弹",
  T_49_META_TYP_34_I135_D: "冰冻手雷",
  T_49_META_TYP_34_I136_D: "防弹衣Lv1",
  T_49_META_TYP_34_I137_D: "防弹衣Lv2",
  T_49_META_TYP_34_I138_D: "防弹衣Lv3",
  T_49_META_TYP_34_I139_D: "头盔Lv1",
  T_49_META_TYP_34_I14_D: "AK",
  T_49_META_TYP_34_I140_D: "头盔Lv2",
  T_49_META_TYP_34_I141_D: "头盔Lv3",
  T_49_META_TYP_34_I142_D: "防爆甲",
  T_49_META_TYP_34_I143_D: "背包Lv1",
  T_49_META_TYP_34_I144_D: "背包Lv2",
  T_49_META_TYP_34_I145_D: "背包Lv3",
  T_49_META_TYP_34_I146_D: "枪口Lv1",
  T_49_META_TYP_34_I147_D: "枪口Lv2",
  T_49_META_TYP_34_I148_D: "枪口Lv3",
  T_49_META_TYP_34_I149_D: "消音器",
  T_49_META_TYP_34_I15_D: "AK2",
  T_49_META_TYP_34_I150_D: "突击枪口",
  T_49_META_TYP_34_I151_D: "宽式枪口",
  T_49_META_TYP_34_I152_D: "弹匣Lv1",
  T_49_META_TYP_34_I153_D: "弹匣Lv2",
  T_49_META_TYP_34_I154_D: "弹匣Lv3",
  T_49_META_TYP_34_I155_D: "双捆弹夹",
  T_49_META_TYP_34_I156_D: "链式弹夹",
  T_49_META_TYP_34_I157_D: "握把Lv1",
  T_49_META_TYP_34_I158_D: "握把Lv2",
  T_49_META_TYP_34_I159_D: "握把Lv3",
  T_49_META_TYP_34_I16_D: "UMP",
  T_49_META_TYP_34_I160_D: "折叠支架",
  T_49_META_TYP_34_I161_D: "射手步枪握把",
  T_49_META_TYP_34_I162_D: "霰弹枪枪托",
  T_49_META_TYP_34_I163_D: "狙击枪枪托",
  T_49_META_TYP_34_I164_D: "热成像瞄镜",
  T_49_META_TYP_34_I165_D: "枪托Lv1",
  T_49_META_TYP_34_I166_D: "枪托Lv2",
  T_49_META_TYP_34_I167_D: "枪托Lv3",
  T_49_META_TYP_34_I168_D: "护盾扩充器",
  T_49_META_TYP_34_I169_D: "全身护甲",
  T_49_META_TYP_34_I17_D: "UMP2",
  T_49_META_TYP_34_I170_D: "过量夹层",
  T_49_META_TYP_34_I171_D: "防爆夹层",
  T_49_META_TYP_34_I172_D: "背包扩容",
  T_49_META_TYP_34_I173_D: "治疗呼吸器",
  T_49_META_TYP_34_I174_D: "强心针",
  T_49_META_TYP_34_I175_D: "急救包",
  T_49_META_TYP_34_I176_D: "防具修理包",
  T_49_META_TYP_34_I177_D: "高科技材料制成的人工智能哨塔，会主动搜索并攻击一定范围内的敌人",
  T_49_META_TYP_34_I178_D: "1级蘑菇",
  T_49_META_TYP_34_I179_D: "2级蘑菇",
  T_49_META_TYP_34_I18_D: "MP5",
  T_49_META_TYP_34_I180_D: "3级蘑菇",
  T_49_META_TYP_34_I181_D: "4级蘑菇",
  T_49_META_TYP_34_I182_D: "个人uav",
  T_49_META_TYP_34_I184_D: "感应地雷",
  T_49_META_TYP_34_I185_D: "喷气飞行鞋",
  T_49_META_TYP_34_I186_D: "弹跳动力鞋",
  T_49_META_TYP_34_I187_D: "滑翔翼",
  T_49_META_TYP_34_I188_D: "诱饵手榴弹",
  T_49_META_TYP_34_I189_D: "磁浮滑板",
  T_49_META_TYP_34_I19_D: "Desert Eagle",
  T_49_META_TYP_34_I190_D: "拆弹钳",
  T_49_META_TYP_34_I191_D: "枪械升级器",
  T_49_META_TYP_34_I192_D: "步枪子弹",
  T_49_META_TYP_34_I193_D: "手枪子弹",
  T_49_META_TYP_34_I194_D: "狙击枪子弹",
  T_49_META_TYP_34_I195_D: "霰弹枪子弹",
  T_49_META_TYP_34_I196_D: "冲锋枪子弹",
  T_49_META_TYP_34_I197_D: "箭矢",
  T_49_META_TYP_34_I198_D: "M79榴弹",
  T_49_META_TYP_34_I199_D: "喷火器子弹",
  T_49_META_TYP_34_I2_D: "CROSSBOW",
  T_49_META_TYP_34_I20_D: "G18",
  T_49_META_TYP_34_I200_D: "THROWINGKNIFE2",
  T_49_META_TYP_34_I201_D: "钩锁头",
  T_49_META_TYP_34_I202_D: "足球枪",
  T_49_META_TYP_34_I203_D: "拳击",
  T_49_META_TYP_34_I204_D: "喷火器",
  T_49_META_TYP_34_I205_D: "MonkeygodCard",
  T_49_META_TYP_34_I206_D: "MadeManACard",
  T_49_META_TYP_34_I207_D: "DjmaleCard",
  T_49_META_TYP_34_I208_D: "GraffitistCard",
  T_49_META_TYP_34_I209_D: "DetectiveCard",
  T_49_META_TYP_34_I21_D: "M14",
  T_49_META_TYP_34_I210_D: "ProfessorCard",
  T_49_META_TYP_34_I211_D: "BountyHunterCard",
  T_49_META_TYP_34_I212_D: "SuperstarCard",
  T_49_META_TYP_34_I213_D: "XtremeCard",
  T_49_META_TYP_34_I214_D: "MusicBroCard",
  T_49_META_TYP_34_I215_D: "KentaCard",
  T_49_META_TYP_34_I216_D: "TRACKERCard",
  T_49_META_TYP_34_I217_D: "CrazygirlCard",
  T_49_META_TYP_34_I218_D: "RunSpeedUpCard",
  T_49_META_TYP_34_I219_D: "SantinoCard",
  T_49_META_TYP_34_I22_D: "SCAR",
  T_49_META_TYP_34_I220_D: "VillainCard",
  T_49_META_TYP_34_I23_D: "SCAR",
  T_49_META_TYP_34_I24_D: "SCAR-I",
  T_49_META_TYP_34_I25_D: "SCAR-II",
  T_49_META_TYP_34_I26_D: "SCAR-III",
  T_49_META_TYP_34_I27_D: "M1014-I",
  T_49_META_TYP_34_I28_D: "M1014-II",
  T_49_META_TYP_34_I29_D: "M1014-III",
  T_49_META_TYP_34_I3_D: "足球凝胶护盾",
  T_49_META_TYP_34_I30_D: "过热能量枪",
  T_49_META_TYP_34_I31_D: "过热枪-I",
  T_49_META_TYP_34_I32_D: "过热枪-II",
  T_49_META_TYP_34_I33_D: "过热枪-III",
  T_49_META_TYP_34_I34_D: "PLASMA-X",
  T_49_META_TYP_34_I35_D: "治疗手枪-Y",
  T_49_META_TYP_34_I36_D: "Heal Sniper",
  T_49_META_TYP_34_I37_D: "治疗手枪",
  T_49_META_TYP_34_I38_D: "VSS",
  T_49_META_TYP_34_I39_D: "GROZA",
  T_49_META_TYP_34_I4_D: "FootballIce",
  T_49_META_TYP_34_I40_D: "GROZA",
  T_49_META_TYP_34_I41_D: "MP40",
  T_49_META_TYP_34_I42_D: "MP40",
  T_49_META_TYP_34_I43_D: "平底锅",
  T_49_META_TYP_34_I44_D: "大砍刀",
  T_49_META_TYP_34_I45_D: "SKS",
  T_49_META_TYP_34_I46_D: "M249",
  T_49_META_TYP_34_I47_D: "M249-X",
  T_49_META_TYP_34_I48_D: "M1873",
  T_49_META_TYP_34_I49_D: "M79",
  T_49_META_TYP_34_I5_D: "Bizon",
  T_49_META_TYP_34_I50_D: "FAMAS",
  T_49_META_TYP_34_I51_D: "M500",
  T_49_META_TYP_34_I52_D: "SVD",
  T_49_META_TYP_34_I53_D: "SVD",
  T_49_META_TYP_34_I54_D: "AC80",
  T_49_META_TYP_34_I55_D: "棒球棍",
  T_49_META_TYP_34_I56_D: "XM8",
  T_49_META_TYP_34_I57_D: "XM8",
  T_49_META_TYP_34_I58_D: "SPAS12",
  T_49_META_TYP_34_I59_D: "SPAS12",
  T_49_META_TYP_34_I6_D: "VSK94",
  T_49_META_TYP_34_I60_D: "M60",
  T_49_META_TYP_34_I61_D: "MGL140",
  T_49_META_TYP_34_I62_D: "P90",
  T_49_META_TYP_34_I63_D: "P90",
  T_49_META_TYP_34_I64_D: "AN94",
  T_49_META_TYP_34_I65_D: "武士刀",
  T_49_META_TYP_34_I66_D: "CG15",
  T_49_META_TYP_34_I67_D: "RG550",
  T_49_META_TYP_34_I68_D: "加特林",
  T_49_META_TYP_34_I7_D: "M4A1",
  T_49_META_TYP_34_I70_D: "强力钩锁枪",
  T_49_META_TYP_34_I71_D: "FF Knife",
  T_49_META_TYP_34_I72_D: "M1887",
  T_49_META_TYP_34_I73_D: "3发子弹的1887",
  T_49_META_TYP_34_I74_D: "M18872",
  T_49_META_TYP_34_I75_D: "Thompson",
  T_49_META_TYP_34_I76_D: "Thompson",
  T_49_META_TYP_34_I77_D: "M82B",
  T_49_META_TYP_34_I78_D: "M82B",
  T_49_META_TYP_34_I79_D: "AUG",
  T_49_META_TYP_34_I8_D: "USP",
  T_49_META_TYP_34_I80_D: "PARAFAL",
  T_49_META_TYP_34_I81_D: "PARAFAL",
  T_49_META_TYP_34_I82_D: "Woodpecker",
  T_49_META_TYP_34_I83_D: "Vector",
  T_49_META_TYP_34_I84_D: "MAG-7",
  T_49_META_TYP_34_I85_D: "MAG-7",
  T_49_META_TYP_34_I86_D: "Scythe",
  T_49_META_TYP_34_I87_D: "大头锤",
  T_49_META_TYP_34_I88_D: "飞刀(可拾取)",
  T_49_META_TYP_34_I89_D: "Kord",
  T_49_META_TYP_34_I9_D: "AWM",
  T_49_META_TYP_34_I90_D: "M1917",
  T_49_META_TYP_34_I91_D: "USP-2",
  T_49_META_TYP_34_I92_D: "Kingfisher",
  T_49_META_TYP_34_I93_D: "Uzi",
  T_49_META_TYP_34_I94_D: "MP5-I",
  T_49_META_TYP_34_I95_D: "M60-I",
  T_49_META_TYP_34_I96_D: "VSS-I",
  T_49_META_TYP_34_I97_D: "M14-I",
  T_49_META_TYP_34_I98_D: "Kar98K-I",
  T_49_META_TYP_34_I99_D: "AWM_Y",
  T_49_META_TYP_340_I0_D: "容易的",
  T_49_META_TYP_340_I1_D: "简单的",
  T_49_META_TYP_340_I2_D: "正常的",
  T_49_META_TYP_340_I3_D: "中等难度",
  T_49_META_TYP_340_I4_D: "困难的",
  T_49_META_TYP_340_I5_D: "地狱的",
  T_49_META_TYP_342_I0_D: "开始事件",
  T_49_META_TYP_342_I1_D: "停止事件",
  T_49_META_TYP_342_I2_D: "暂停事件",
  T_49_META_TYP_342_I3_D: "被创建后等待多久开始计时，单位毫秒",
  T_49_META_TYP_342_I4_D: "循环次数",
  T_49_META_TYP_342_I5_D: "事件集合",
  T_49_META_TYP_342_I6_D: "倒计时或正计时",
  T_49_META_TYP_342_I7_D: "玩家状态",
  T_49_META_TYP_342_I8_D: "计时结束时间，以秒为单位",
  T_49_META_TYP_345_I10_D: "手炮",
  T_49_META_TYP_345_I12_D: "冰墙枪",
  T_49_META_TYP_345_I13_D: "喷火器",
  T_49_META_TYP_345_I4_D: "霰弹枪",
  T_49_META_TYP_345_I6_D: "特殊枪",
  T_49_META_TYP_345_I8_D: "蓄力枪",
  T_49_META_TYP_346_I0_D: "步枪子弹",
  T_49_META_TYP_346_I1_D: "手枪子弹",
  T_49_META_TYP_346_I2_D: "狙击枪子弹",
  T_49_META_TYP_346_I3_D: "霰弹枪子弹",
  T_49_META_TYP_346_I4_D: "冲锋枪子弹",
  T_49_META_TYP_346_I5_D: "箭矢",
  T_49_META_TYP_346_I6_D: "M79榴弹",
  T_49_META_TYP_346_I7_D: "钩锁头",
  T_49_META_TYP_346_I8_D: "M79专用榴弹",
  T_49_META_TYP_347_I3_D: "为真的时候可以和相对运动组合，为假的时候必须和绝对运动组合否则属性会不正确生效",
  T_49_META_TYP_347_I6_D: "变化值",
  T_49_META_TYP_350_I0_D: "跑车",
  T_49_META_TYP_350_I1_D: "摩托车",
  T_49_META_TYP_350_I2_D: "吉普车",
  T_49_META_TYP_350_I3_D: "SUV",
  T_49_META_TYP_350_I4_D: "怪兽卡车",
  T_49_META_TYP_350_I5_D: "突突车",
  T_49_META_TYP_352_I1_D: "未选中图片",
  T_49_META_TYP_352_I2_D: "未选中图片类型",
  T_49_META_TYP_352_I3_D: "未选中图片颜色",
  T_49_META_TYP_352_I4_D: "选中图片",
  T_49_META_TYP_352_I5_D: "选中图片类型",
  T_49_META_TYP_352_I6_D: "选中图片颜色",
  T_49_META_TYP_353_I0_D: "生命恢复量",
  T_49_META_TYP_353_I1_D: "恢复速度 (ms)",
  T_49_META_TYP_353_I2_D: "使用所需时间 (ms)",
  T_49_META_TYP_354_I0_D: "能量(EP)恢复量",
  T_49_META_TYP_355_I0_D: "生命恢复量",
  T_49_META_TYP_355_I1_D: "能量(EP)恢复量",
  T_49_META_TYP_355_I2_D: "使用所需时间 (ms)",
  T_49_META_TYP_356_I0_D: "空投箱携带物品",
  T_49_META_TYP_356_I1_D: "空投箱掉落时间 ms",
  T_49_META_TYP_356_I2_D: "空投箱掉状态",
  T_49_META_TYP_357_I0_D: "表面",
  T_49_META_TYP_357_I1_D: "边界",
  T_49_META_TYP_359_I0_D: "是否使用带物理效果的玩家控制器",
  T_49_META_TYP_359_I1_D: "放置在超过该角度的坡面上，会向下滑动",
  T_49_META_TYP_359_I10_D: "该重力加速度仅作用于该玩家控制器",
  T_49_META_TYP_359_I11_D: "质量，单位kg",
  T_49_META_TYP_359_I12_D: "所处坡面超过最大上坡角度时会向下滑落",
  T_49_META_TYP_359_I16_D: "开启后，由服务端图元或脚本控制移动",
  T_49_META_TYP_359_I17_D: "开启后，角色推动刚体时施加的力可以自定义",
  T_49_META_TYP_359_I18_D: "角色推动刚体时施加的力大小",
  T_49_META_TYP_359_I19_D: "下半部分接触碰撞体时为真，通常用于判断玩家是否在地面上",
  T_49_META_TYP_359_I2_D: "只有超过该高度的障碍物才会有阻挡效果，取值范围 [0,Height]",
  T_49_META_TYP_359_I20_D: "自定义物理层级，取值[0,15]",
  T_49_META_TYP_359_I21_D: "是否跟随重力旋转朝向",
  T_49_META_TYP_359_I3_D: "允许嵌入改胶囊体的深度。可以防止角色被卡住或抖动，无特殊需要不建议修改。取值范围(0,Radius]",
  T_49_META_TYP_359_I4_D: "最小移动距离，小于该值的移动不会被执行。如非特殊需求建议保持为0",
  T_49_META_TYP_359_I5_D: "碰撞盒中心距离本地坐标原点的偏移",
  T_49_META_TYP_359_I6_D: "胶囊体半径，最小值0.01",
  T_49_META_TYP_359_I7_D: "胶囊体总高度，包含上下半球，最小值2*Radius",
  T_49_META_TYP_359_I8_D: "当前线速度，单位m/s",
  T_49_META_TYP_360_I0_D: "左侧射界角度",
  T_49_META_TYP_360_I1_D: "右侧射界角度",
  T_49_META_TYP_360_I2_D: "最小仰角",
  T_49_META_TYP_360_I3_D: "最大俯角",
  T_49_META_TYP_360_I4_D: "出膛速度",
  T_49_META_TYP_362_I0_D: "命中玩家后造成的冻结时间，单位秒",
  T_49_META_TYP_363_I0_D: "禁用Hud请求购买",
  T_49_META_TYP_363_I1_D: "向队伍请求帮助购买",
  T_49_META_TYP_363_I2_D: "向阵营请求帮助购买",
  T_49_META_TYP_364_I0_D: "是否使用中心点播放",
  T_49_META_TYP_364_I1_D: "是否循环播放",
  T_49_META_TYP_364_I2_D: "动画名",
  T_49_META_TYP_364_I3_D: "是否自动播放",
  T_49_META_TYP_364_I4_D: "是否使用自定义资源",
  T_49_META_TYP_366_I0_D: "指定要渲染的Batch资源UUID",
  T_49_META_TYP_367_I1_D: "是否显示队伍或阵营的标记点",
  T_49_META_TYP_367_I2_D: "标记目标显示的图标样式",
  T_49_META_TYP_367_I3_D: "标记目标显示的图标的叠加色",
  T_49_META_TYP_367_I4_D: "在某刻度上显示的图标样式",
  T_49_META_TYP_367_I5_D: "在某刻度上显示的图标叠加色",
  T_49_META_TYP_367_I6_D: "标记点始终显示在标尺上",
  T_49_META_TYP_370_I0_D: "主标题",
  T_49_META_TYP_370_I1_D: "副标题",
  T_49_META_TYP_370_I2_D: "上面背景颜色",
  T_49_META_TYP_370_I3_D: "下面背景颜色",
  T_49_META_TYP_371_I2_D: "左边得分",
  T_49_META_TYP_371_I3_D: "右边得分",
  T_49_META_TYP_371_I4_D: "左边最后得分，用于播放得分切换动画",
  T_49_META_TYP_371_I5_D: "右边最后得分，用于播放得分切换动画",
  T_49_META_TYP_372_I0_D: "站立",
  T_49_META_TYP_372_I1_D: "蹲下",
  T_49_META_TYP_372_I10_D: "高高度坠落",
  T_49_META_TYP_372_I11_D: "低高度坠落，如跳跃",
  T_49_META_TYP_372_I12_D: "飞行鞋",
  T_49_META_TYP_372_I13_D: "二段跳跳跃",
  T_49_META_TYP_372_I14_D: "坐在椅子上",
  T_49_META_TYP_372_I15_D: "被弹射器弹射出去",
  T_49_META_TYP_372_I16_D: "弹射器准备阶段",
  T_49_META_TYP_372_I17_D: "滑翔道具滑翔",
  T_49_META_TYP_372_I18_D: "滑翔道具下落",
  T_49_META_TYP_372_I19_D: "被轮胎弹起",
  T_49_META_TYP_372_I2_D: "跑步",
  T_49_META_TYP_372_I20_D: "被人体轮胎弹起",
  T_49_META_TYP_372_I21_D: "在派对区域中的一种动作",
  T_49_META_TYP_372_I22_D: "乘坐飞行器",
  T_49_META_TYP_372_I23_D: "进入加农炮",
  T_49_META_TYP_372_I24_D: "从加农炮、载具等出来时，如果乘坐对象是飞行的，就是这个状态",
  T_49_META_TYP_372_I25_D: "从跳板上跳起后",
  T_49_META_TYP_372_I26_D: "从滑索上下来",
  T_49_META_TYP_372_I27_D: "未使用",
  T_49_META_TYP_372_I3_D: "趴下爬行",
  T_49_META_TYP_372_I4_D: "快速游泳",
  T_49_META_TYP_372_I5_D: "垂直下落",
  T_49_META_TYP_372_I6_D: "翻过墙壁",
  T_49_META_TYP_372_I7_D: "未使用",
  T_49_META_TYP_372_I8_D: "被击倒但没有死亡",
  T_49_META_TYP_372_I9_D: "水上使用滑板",
  T_49_META_TYP_374_I0_D: "生命值、等级和描边的颜色",
  T_49_META_TYP_374_I1_D: "生命值减少时，失去的部分短暂地显示这个颜色",
  T_49_META_TYP_374_I10_D: "相对于跟随目标的偏移",
  T_49_META_TYP_374_I11_D: "每两个隔断线之间的生命值量，小于等于0则不显示",
  T_49_META_TYP_374_I12_D: "生命值总量",
  T_49_META_TYP_374_I13_D: "生命值当前量",
  T_49_META_TYP_374_I14_D: "启用时，血量变化才会有不同颜色表现",
  T_49_META_TYP_374_I15_D: "启用时，偏移属性会使用局部坐标系转到世界坐标系",
  T_49_META_TYP_374_I2_D: "生命值增加时，增加的部分短暂地显示这个颜色",
  T_49_META_TYP_374_I3_D: "生命值边框和虚化底部的颜色",
  T_49_META_TYP_374_I4_D: "范围0~1，整体UI的透明度",
  T_49_META_TYP_374_I5_D: "决定整体UI缩放大小,字体也一同缩放",
  T_49_META_TYP_374_I6_D: "表示当前血条拥有者的名字信息",
  T_49_META_TYP_374_I8_D: "血条部分在画面上显示的长度",
  T_49_META_TYP_374_I9_D: "必须跟随一个带有Transform组件的实体",
  T_49_META_TYP_375_I1_D: "战斗实体",
  T_49_META_TYP_376_I1_D: "战斗实体",
  T_49_META_TYP_38_I0_D: "透明度",
  T_49_META_TYP_382_I0_D: "默认",
  T_49_META_TYP_382_I1_D: "跳过击倒状态，直接死亡",
  T_49_META_TYP_382_I2_D: "强制击倒",
  T_49_META_TYP_387_I1_D: "区域外保持触发",
  T_49_META_TYP_389_I0_D: "底座默认偏移量",
  T_49_META_TYP_389_I1_D: "底座图片",
  T_49_META_TYP_389_I10_D: "未激活透明度",
  T_49_META_TYP_389_I2_D: "底座半径",
  T_49_META_TYP_389_I3_D: "操纵杆图片",
  T_49_META_TYP_389_I4_D: "操纵杆半径",
  T_49_META_TYP_389_I5_D: "操纵杆拖拽半径",
  T_49_META_TYP_389_I6_D: "方向箭头图片",
  T_49_META_TYP_389_I7_D: "方向箭头尺寸",
  T_49_META_TYP_389_I8_D: "方向箭头偏移",
  T_49_META_TYP_389_I9_D: "激活透明度",
  T_49_META_TYP_39_I1_D: "图片形状",
  T_49_META_TYP_39_I10_D: "顶部渐变色",
  T_49_META_TYP_39_I11_D: "底部渐变色",
  T_49_META_TYP_39_I12_D: "顶部透明度",
  T_49_META_TYP_39_I13_D: "底部透明度",
  T_49_META_TYP_39_I3_D: "翻转",
  T_49_META_TYP_39_I4_D: "填充",
  T_49_META_TYP_39_I5_D: "中心不可见",
  T_49_META_TYP_39_I6_D: "填充方向",
  T_49_META_TYP_39_I7_D: "填充值",
  T_49_META_TYP_39_I8_D: "反向填充",
  T_49_META_TYP_39_I9_D: "渐变",
  T_49_META_TYP_392_I0_D: "安全区在局内每回合出现的时间，默认为 0，单位ms",
  T_49_META_TYP_392_I1_D: "缩圈用时，单位ms",
  T_49_META_TYP_392_I10_D: "缩圈结束时间，单位ms",
  T_49_META_TYP_392_I12_D: "毒圈结束圈半径",
  T_49_META_TYP_392_I13_D: "开始缩圈时间",
  T_49_META_TYP_392_I14_D: "伤害时间间隔 (ms)",
  T_49_META_TYP_392_I3_D: "对毒圈内的玩家单次的伤害量",
  T_49_META_TYP_392_I4_D: "安全区内的玩家列表",
  T_49_META_TYP_392_I5_D: "安全区消失时间，安全区消失时间小于生效时间时不生成安全区",
  T_49_META_TYP_392_I6_D: "GroupID",
  T_49_META_TYP_392_I7_D: "毒圈起始圈半径",
  T_49_META_TYP_392_I8_D: "结束状态",
  T_49_META_TYP_392_I9_D: "状态",
  T_49_META_TYP_394_I0_D: "值约为3.1416",
  T_49_META_TYP_394_I1_D: "值约为2.7183",
  T_49_META_TYP_396_I0_D: "标题",
  T_49_META_TYP_396_I1_D: "内容",
  T_49_META_TYP_396_I2_D: "选项",
  T_49_META_TYP_396_I3_D: "显示背景",
  T_49_META_TYP_399_I0_D: "跳跃高度",
  T_49_META_TYP_399_I1_D: "落地前可以进行的连续跳跃次数",
  T_49_META_TYP_399_I2_D: "落地前还能进行几次跳跃",
  T_49_META_TYP_399_I3_D: "空中是否可水平移动",
  T_49_META_TYP_40_I1_D: "文本内容",
  T_49_META_TYP_40_I10_D: "行间距",
  T_49_META_TYP_40_I11_D: "溢出方式",
  T_49_META_TYP_40_I12_D: "字体风格",
  T_49_META_TYP_40_I13_D: "投影",
  T_49_META_TYP_40_I14_D: "投影颜色",
  T_49_META_TYP_40_I15_D: "投影偏移量",
  T_49_META_TYP_40_I3_D: "本地化Key，可用于多语言",
  T_49_META_TYP_40_I5_D: "对齐方式",
  T_49_META_TYP_40_I6_D: "垂直对齐",
  T_49_META_TYP_40_I7_D: "加粗",
  T_49_META_TYP_40_I8_D: "斜体",
  T_49_META_TYP_40_I9_D: "下划线",
  T_49_META_TYP_400_I0_D: "主动攻击",
  T_49_META_TYP_400_I1_D: "被动攻击",
  T_49_META_TYP_400_I2_D: "不攻击",
  T_49_META_TYP_401_I0_D: "不能开火",
  T_49_META_TYP_401_I1_D: "可以持续开火",
  T_49_META_TYP_401_I2_D: "每次攻击指令发射一次",
  T_49_META_TYP_401_I3_D: "每次攻击指令发射三次",
  T_49_META_TYP_401_I4_D: "每次攻击指令发射两次",
  T_49_META_TYP_401_I5_D: "抛射",
  T_49_META_TYP_402_I0_D: "要添加为好友的目标",
  T_49_META_TYP_402_I1_D: "功能类型",
  T_49_META_TYP_402_I2_D: "样式",
  T_49_META_TYP_403_I0_D: "添加好友",
  T_49_META_TYP_403_I1_D: "举报",
  T_49_META_TYP_404_I0_D: "亮色",
  T_49_META_TYP_404_I1_D: "暗色",
  T_49_META_TYP_405_I0_D: "按层级结构",
  T_49_META_TYP_405_I1_D: "按优先级从高到低",
  T_49_META_TYP_405_I2_D: "按优先级从低到高",
  T_49_META_TYP_406_I0_D: "控制玩家翻越动作的距离",
  T_49_META_TYP_406_I1_D: "控制玩家翻越时身体上下移动的高度",
  T_49_META_TYP_407_I0_D: "本地",
  T_49_META_TYP_407_I1_D: "客户端",
  T_49_META_TYP_407_I2_D: "服务端",
  T_49_META_TYP_407_I3_D: "双端",
  T_49_META_TYP_409_I0_D: "没有错误",
  T_49_META_TYP_409_I1_D: "数据存储超时，主要针对读取操作",
  T_49_META_TYP_409_I10_D: "换队失败-无效的目标队伍",
  T_49_META_TYP_409_I11_D: "换队失败-死亡玩家不允许换队",
  T_49_META_TYP_409_I12_D: "换队失败-不允许在载具中换队",
  T_49_META_TYP_409_I2_D: "数据存储读写频次超出限制",
  T_49_META_TYP_409_I3_D: "参数异常",
  T_49_META_TYP_409_I4_D: "创建房间失败：无有效PersonaIDs",
  T_49_META_TYP_409_I5_D: "未定义的错误状态",
  T_49_META_TYP_409_I6_D: "商业化服务关闭，用户不再能使用开发者的服务",
  T_49_META_TYP_409_I7_D: "换队失败-模式不支持",
  T_49_META_TYP_409_I8_D: "换队失败-当前已经在目标队伍中",
  T_49_META_TYP_409_I9_D: "换队失败-无效的对象",
  T_49_META_TYP_41_I0_D: "图片形状",
  T_49_META_TYP_41_I19_D: "禁用碰撞盒",
  T_49_META_TYP_41_I3_D: "禁用色",
  T_49_META_TYP_41_I4_D: "按压色",
  T_49_META_TYP_41_I5_D: "填充类型",
  T_49_META_TYP_41_I6_D: "是否是FE的按钮",
  T_49_META_TYP_41_I7_D: "按下图片",
  T_49_META_TYP_41_I8_D: "按下图片类型",
  T_49_META_TYP_41_I9_D: "翻转类型",
  T_49_META_TYP_411_I0_D: "前进速度（力）",
  T_49_META_TYP_411_I1_D: "后退速度（力）",
  T_49_META_TYP_411_I2_D: "上升速度（力）",
  T_49_META_TYP_411_I3_D: "下降速度（力）",
  T_49_META_TYP_411_I4_D: "载具导弹最小伤害",
  T_49_META_TYP_411_I5_D: "载具导弹最大伤害",
  T_49_META_TYP_411_I6_D: "载具导弹范围",
  T_49_META_TYP_412_I0_D: "使用油门键时，载具获得的马力",
  T_49_META_TYP_412_I1_D: "使用倒车/刹车键时，载具获得的马力",
  T_49_META_TYP_412_I2_D: "在高速状态下，最大转向角度",
  T_49_META_TYP_412_I3_D: "高速最大转向角度应用的速度阈值",
  T_49_META_TYP_412_I4_D: "达到最大速度后，载具不会再提供马力，但载具可能超过该最大速度（例如通过下坡）",
  T_49_META_TYP_412_I5_D: "未对载具进行操控时，以IdleBrakeInput乘以BrakeTorque对载具进行减速",
  T_49_META_TYP_412_I6_D: "用于撞人的伤害计算，运用伤害公式的参数",
  T_49_META_TYP_412_I7_D: "用于撞人的伤害计算，超过该速度后，伤害也不会提升",
  T_49_META_TYP_412_I8_D: "用于撞人的伤害计算，最低伤害",
  T_49_META_TYP_412_I9_D: "用于撞人的伤害计算，最高伤害",
  T_49_META_TYP_413_I0_D: "玩家（NPC）变身后服饰",
  T_49_META_TYP_414_I1_D: "宽范围",
  T_49_META_TYP_415_I0_D: "智能体ID",
  T_49_META_TYP_415_I1_D: "昵称",
  T_49_META_TYP_415_I2_D: "头像",
  T_49_META_TYP_416_I1_D: "绑定的Persona",
  T_49_META_TYP_416_I2_D: "偏移量",
  T_49_META_TYP_416_I3_D: "高度",
  T_49_META_TYP_416_I4_D: "是否回复系统消息",
  T_49_META_TYP_416_I5_D: "Persona昵称",
  T_49_META_TYP_416_I6_D: "PersonaAvatar",
  T_49_META_TYP_416_I7_D: "用户昵称",
  T_49_META_TYP_416_I8_D: "用户Avatar",
  T_49_META_TYP_417_I0_D: "资源ID",
  T_49_META_TYP_418_I0_D: "会员到期",
  T_49_META_TYP_418_I1_D: "成为会员",
  T_49_META_TYP_418_I2_D: "会员续费",
  T_49_META_TYP_42_I0_D: "占位文本内容",
  T_49_META_TYP_42_I1_D: "激活文本内容",
  T_49_META_TYP_42_I10_D: "最大长度",
  T_49_META_TYP_42_I14_D: "按压色",
  T_49_META_TYP_42_I16_D: "本地化Key，可用于多语言",
  T_49_META_TYP_42_I3_D: "对齐方式",
  T_49_META_TYP_42_I4_D: "垂直对齐",
  T_49_META_TYP_42_I5_D: "加粗",
  T_49_META_TYP_42_I6_D: "斜体",
  T_49_META_TYP_42_I7_D: "下划线",
  T_49_META_TYP_42_I8_D: "行间距",
  T_49_META_TYP_42_I9_D: "自动换行",
  T_49_META_TYP_424_I0_D: "线性雾效",
  T_49_META_TYP_424_I1_D: "指数雾效",
  T_49_META_TYP_424_I2_D: "指数平方雾效",
  T_49_META_TYP_426_I0_D: "光照强度",
  T_49_META_TYP_426_I1_D: "光照范围",
  T_49_META_TYP_426_I2_D: "聚光锥的角度以度为单位",
  T_49_META_TYP_426_I3_D: "光照颜色",
  T_49_META_TYP_428_I0_D: "玩家枪皮",
  T_49_META_TYP_428_I2_D: "套装ID",
  T_49_META_TYP_428_I3_D: "头饰ID",
  T_49_META_TYP_428_I4_D: "脸饰ID",
  T_49_META_TYP_428_I5_D: "妆容ID",
  T_49_META_TYP_428_I6_D: "上身ID",
  T_49_META_TYP_428_I7_D: "下身ID",
  T_49_META_TYP_428_I8_D: "鞋ID",
  T_49_META_TYP_431_I1_D: "目标实体的运动轨迹",
  T_49_META_TYP_431_I3_D: "运动速度，单位m/s",
  T_49_META_TYP_431_I4_D: `运动时是否朝向路径切线
默认为False，运动对象的朝向不变
为True时，运动对象会面向路径前进方向`,
  T_49_META_TYP_431_I5_D: "已播放百分比",
  T_49_META_TYP_432_I0_D: "翻滚角，影响从此点两侧路径的径向旋转",
  T_49_META_TYP_432_I1_D: "切线控制点与路点的相对位置，决定了路径切线",
  T_49_META_TYP_433_I0_D: "在路径点间直线插值",
  T_49_META_TYP_433_I1_D: "在路径点间曲线插值，平滑运动",
  T_49_META_TYP_433_I2_D: "支持手动调整曲线点的切线",
  T_49_META_TYP_434_I0_D: "路径类型",
  T_49_META_TYP_434_I1_D: "路径的总长度",
  T_49_META_TYP_434_I2_D: "是否首尾衔接",
  T_49_META_TYP_434_I3_D: "路点集合",
  T_49_META_TYP_437_I3_D: "左边玩家数组",
  T_49_META_TYP_437_I4_D: "右边玩家数组",
  T_49_META_TYP_437_I5_D: "积分类型名数组",
  T_49_META_TYP_437_I6_D: "左边积分数组（List一维：玩家；List二维：根据自定义积分类型填入的积分数据）",
  T_49_META_TYP_437_I7_D: "右边积分数组（List一维：玩家；List二维：根据自定义积分类型填入的积分数据）",
  T_49_META_TYP_438_I1_D: "分组玩家数组",
  T_49_META_TYP_438_I2_D: "分组排名数组",
  T_49_META_TYP_438_I3_D: "分组得分数组",
  T_49_META_TYP_438_I4_D: "积分类型名数组",
  T_49_META_TYP_438_I5_D: "分组颜色数组",
  T_49_META_TYP_438_I6_D: "玩家积分数组（对应未分组时的顺序）",
  T_49_META_TYP_442_I1_D: "左边得分",
  T_49_META_TYP_442_I10_D: "右边死亡图标",
  T_49_META_TYP_442_I2_D: "右边得分",
  T_49_META_TYP_442_I3_D: "左边存活人数",
  T_49_META_TYP_442_I4_D: "右边存活人数",
  T_49_META_TYP_442_I5_D: "左边死亡人数",
  T_49_META_TYP_442_I6_D: "右边死亡人数",
  T_49_META_TYP_442_I7_D: "左边存活图标",
  T_49_META_TYP_442_I8_D: "右边存活图标",
  T_49_META_TYP_442_I9_D: "左边死亡图标",
  T_49_META_TYP_444_I0_D: "英语",
  T_49_META_TYP_444_I1_D: "简体中文",
  T_49_META_TYP_444_I10_D: "法语",
  T_49_META_TYP_444_I11_D: "德语",
  T_49_META_TYP_444_I12_D: "土耳其语",
  T_49_META_TYP_444_I13_D: "印地语",
  T_49_META_TYP_444_I14_D: "日语",
  T_49_META_TYP_444_I15_D: "罗马尼亚语",
  T_49_META_TYP_444_I16_D: "阿拉伯语",
  T_49_META_TYP_444_I17_D: "缅甸语",
  T_49_META_TYP_444_I18_D: "乌尔都语",
  T_49_META_TYP_444_I19_D: "孟加拉语",
  T_49_META_TYP_444_I2_D: "繁体中文",
  T_49_META_TYP_444_I3_D: "泰语",
  T_49_META_TYP_444_I4_D: "越南语",
  T_49_META_TYP_444_I5_D: "印度尼西亚语",
  T_49_META_TYP_444_I6_D: "葡萄牙语",
  T_49_META_TYP_444_I7_D: "西班牙语",
  T_49_META_TYP_444_I8_D: "俄语",
  T_49_META_TYP_444_I9_D: "韩语",
  T_49_META_TYP_51_I0_D: "普通僵尸",
  T_49_META_TYP_51_I1_D: "斧头僵尸",
  T_49_META_TYP_51_I10_D: "飞行僵尸",
  T_49_META_TYP_51_I11_D: "僵尸龙",
  T_49_META_TYP_51_I2_D: "投掷僵尸",
  T_49_META_TYP_51_I3_D: "自爆僵尸",
  T_49_META_TYP_51_I4_D: "剪刀僵尸",
  T_49_META_TYP_51_I5_D: "变异投掷僵尸",
  T_49_META_TYP_51_I6_D: "黑衣人",
  T_49_META_TYP_51_I7_D: "盾牌怪",
  T_49_META_TYP_51_I8_D: "钻地怪僵尸",
  T_49_META_TYP_51_I9_D: "武士僵尸",
  T_49_META_TYP_56_I10_D: "爆炸延迟",
  T_49_META_TYP_56_I11_D: "爆炸范围",
  T_49_META_TYP_56_I12_D: "爆炸伤害",
  T_49_META_TYP_56_I13_D: "燃烧时间",
  T_49_META_TYP_56_I14_D: "燃烧伤害",
  T_49_META_TYP_56_I15_D: "燃烧伤害间隔",
  T_49_META_TYP_56_I17_D: "载具驾驶者",
  T_49_META_TYP_56_I18_D: "载具上所有乘客",
  T_49_META_TYP_56_I19_D: "车皮ID",
  T_49_META_TYP_56_I20_D: "玩家配置优先",
  T_49_META_TYP_56_I21_D: "最大血量",
  T_49_META_TYP_56_I22_D: "当前血量",
  T_49_META_TYP_57_I0_D: "是手动传送还是自动传送（默认为手动）",
  T_49_META_TYP_58_I0_D: "生成的BUFF类型",
  T_49_META_TYP_58_I1_D: "从BUFF被拾取到下一个BUFF生成的时间，单位为秒",
  T_49_META_TYP_59_I0_D: "运动方式",
  T_49_META_TYP_59_I1_D: "X轴方向的增量",
  T_49_META_TYP_59_I2_D: "Y轴方向的增量",
  T_49_META_TYP_59_I3_D: "Z轴方向的增量",
  T_49_META_TYP_59_I4_D: "移动时长",
  T_49_META_TYP_59_I5_D: "停止时长",
  T_49_META_TYP_59_I6_D: "不使用往返运动",
  T_49_META_TYP_60_I0_D: "Loot武器点",
  T_49_META_TYP_61_I0_D: "绑定商店实体",
  T_49_META_TYP_61_I1_D: "设置触发范围",
  T_49_META_TYP_61_I2_D: "模型显隐",
  T_49_META_TYP_62_I0_D: "XZ轴速度",
  T_49_META_TYP_62_I1_D: "Y轴速度",
  T_49_META_TYP_64_I0_D: "音乐组件类型",
  T_49_META_TYP_66_I0_D: "InstanceID",
  T_49_META_TYP_66_I1_D: "路径点",
  T_49_META_TYP_68_I0_D: "AI当前的血量",
  T_49_META_TYP_68_I1_D: "AI当前的血量最大值",
  T_49_META_TYP_68_I10_D: "AI在死亡的时候是否会掉落装备或者物品",
  T_49_META_TYP_68_I11_D: "AI当前是否在无敌状态",
  T_49_META_TYP_68_I12_D: "当受到伤害时伤害量百分比，可减伤或增伤",
  T_49_META_TYP_68_I13_D: "AI的类型",
  T_49_META_TYP_68_I14_D: "是否自动索敌",
  T_49_META_TYP_68_I15_D: "0为自动攻击，1为防御攻击，2为完全不攻击",
  T_49_META_TYP_68_I16_D: "路径的场景物件ID",
  T_49_META_TYP_68_I17_D: "被AI追击的对象",
  T_49_META_TYP_68_I18_D: "被AI攻击的对象",
  T_49_META_TYP_68_I19_D: "AI的出生点坐标",
  T_49_META_TYP_68_I2_D: "获取AI所属队伍的实体",
  T_49_META_TYP_68_I20_D: "队伍阵营序号",
  T_49_META_TYP_68_I4_D: "只能修改普通攻击的攻击力，技能的攻击不算",
  T_49_META_TYP_68_I7_D: "AI自由移动的范围， 只能修改基础值，如果有额外加成会在该值的就基础上加成",
  T_49_META_TYP_68_I8_D: "AI检测敌人的范围，只能修改基础值，如果有额外加成会在该值的就基础上加成",
  T_49_META_TYP_68_I9_D: "真实的行动速度，如果有技能加速会和它相乘",
  T_49_META_TYP_70_I0_D: "公式作用的目标实体ID，内部实现使用，对玩家不可见",
  T_49_META_TYP_70_I1_D: "公式作用的目标实体属性ID，内部实现使用，对玩家不可见",
  T_49_META_TYP_70_I2_D: "数值允许的最小值",
  T_49_META_TYP_70_I3_D: "数值允许的最大值",
  T_49_META_TYP_70_I4_D: "基础系数",
  T_49_META_TYP_70_I5_D: "前置累加器",
  T_49_META_TYP_70_I6_D: "连乘器",
  T_49_META_TYP_70_I7_D: "乘法累加器",
  T_49_META_TYP_70_I8_D: "后置累加器",
  T_49_META_TYP_71_I0_D: "商品编号",
  T_49_META_TYP_71_I1_D: "价格",
  T_49_META_TYP_71_I10_D: "能否购买",
  T_49_META_TYP_71_I2_D: "货币类型",
  T_49_META_TYP_71_I3_D: "总体限购",
  T_49_META_TYP_71_I4_D: "当前总体限购",
  T_49_META_TYP_71_I5_D: "商品名字",
  T_49_META_TYP_71_I6_D: "商品描述",
  T_49_META_TYP_71_I7_D: "商品物品列表",
  T_49_META_TYP_71_I8_D: "商品数量列表",
  T_49_META_TYP_71_I9_D: "资源路径, 默认为空",
  T_49_META_TYP_72_I1_D: "商品列表",
  T_49_META_TYP_73_I1_D: "货架列表",
  T_49_META_TYP_74_I0_D: "武器",
  T_49_META_TYP_74_I1_D: "头盔",
  T_49_META_TYP_74_I2_D: "背心",
  T_49_META_TYP_74_I3_D: "手榴弹",
  T_49_META_TYP_75_I0_D: "单向一次",
  T_49_META_TYP_75_I1_D: "来回",
  T_49_META_TYP_76_I0_D: "只巡逻，不攻击沿途目标",
  T_49_META_TYP_76_I1_D: "边巡逻，边攻击",
  T_49_META_TYP_79_I0_D: "武器攻击力",
  T_49_META_TYP_79_I1_D: "攻击范围",
  T_49_META_TYP_79_I10_D: "开始散射阈值",
  T_49_META_TYP_79_I11_D: "武器对应的道具id",
  T_49_META_TYP_79_I12_D: "两次开火间至少等待的时长，单位秒，每次开火根据开火类型可能会射出多枚子弹",
  T_49_META_TYP_79_I13_D: "拥有该武器的玩家",
  T_49_META_TYP_79_I14_D: "是否消耗弹药",
  T_49_META_TYP_79_I15_D: "双持类型（0不双持1和自己2和任意武器）",
  T_49_META_TYP_79_I16_D: "护甲伤害系数",
  T_49_META_TYP_79_I17_D: "玩家移动速度影响",
  T_49_META_TYP_79_I18_D: "打躯干的伤害比例",
  T_49_META_TYP_79_I19_D: "打头的伤害比例",
  T_49_META_TYP_79_I2_D: "两发子弹间至少等待的时长，单位秒",
  T_49_META_TYP_79_I20_D: "打四肢的伤害比例",
  T_49_META_TYP_79_I21_D: "额外伤害比例(车、油桶 冰墙)",
  T_49_META_TYP_79_I22_D: "背在身上是否显示",
  T_49_META_TYP_79_I23_D: "击中倒地额外伤害",
  T_49_META_TYP_79_I24_D: "单次发射子弹数量",
  T_49_META_TYP_79_I25_D: "换弹速度（基础速度*系数）",
  T_49_META_TYP_79_I26_D: "当前余弹量",
  T_49_META_TYP_79_I27_D: "枪皮的ID",
  T_49_META_TYP_79_I28_D: "玩家配置优先时，玩家身上的枪皮配置会覆盖武器本身的枪皮属性",
  T_49_META_TYP_79_I29_D: "写入枪皮对武器的属性时，武器的基本值会受枪皮影响",
  T_49_META_TYP_79_I3_D: "弹夹子弹数量",
  T_49_META_TYP_79_I30_D: "扩散增加速度(0.1 = 每多一次连发准星扩大10%)",
  T_49_META_TYP_79_I31_D: "散射恢复速度",
  T_49_META_TYP_79_I32_D: "射击时的玩家速度影响",
  T_49_META_TYP_79_I33_D: "移动情况下扩散大小(1.5 = 1.5 * 基本准星大小)",
  T_49_META_TYP_79_I34_D: "武器类型",
  T_49_META_TYP_79_I36_D: "开火类型",
  T_49_META_TYP_79_I37_D: "是否单发",
  T_49_META_TYP_79_I38_D: "是否消音",
  T_49_META_TYP_79_I39_D: "开镜移速倍率",
  T_49_META_TYP_79_I4_D: "初始弹夹数量",
  T_49_META_TYP_79_I5_D: "护甲穿透",
  T_49_META_TYP_79_I6_D: "满伤害距离",
  T_49_META_TYP_79_I7_D: "最小伤害开始距离",
  T_49_META_TYP_79_I8_D: "最小伤害",
  T_49_META_TYP_79_I9_D: "散射开始前可以射出的子弹数",
  T_49_META_TYP_80_I1_D: "为true时,禁止手动关闭",
  T_49_META_TYP_80_I2_D: "绑定的商店实体",
  T_49_META_TYP_80_I4_D: "绑定的货币实体列表",
  T_49_META_TYP_80_I5_D: "绑定的钱包实体ID",
  T_49_META_TYP_80_I6_D: "当前UI玩家请求目标的类型",
  T_49_META_TYP_80_I7_D: "被请求的物品列表",
  T_49_META_TYP_81_I0_D: "随机buff",
  T_49_META_TYP_81_I1_D: "血量buff",
  T_49_META_TYP_81_I2_D: "子弹buff",
  T_49_META_TYP_81_I3_D: "护甲buff",
  T_49_META_TYP_82_I1_D: "按钮图标",
  T_49_META_TYP_82_I3_D: "相对于锚点的位置",
  T_49_META_TYP_83_I1_D: "触发的实体ID",
  T_49_META_TYP_83_I2_D: "传递参数",
  T_49_META_TYP_86_I0_D: "最小值",
  T_49_META_TYP_86_I1_D: "最大值",
  T_49_META_TYP_86_I2_D: "基础系数,在所有计算前乘以原始值",
  T_49_META_TYP_86_I3_D: "前置累加器，在进行乘法运算前累加，参与乘法计算",
  T_49_META_TYP_86_I4_D: "连乘器，连续乘法，比如（降低到90%、加强为110%）的效果是Value*90%*110%",
  T_49_META_TYP_86_I5_D: "乘法累加器，比如（加10%、加5%）的效果是Value*(1+10%+5%)",
  T_49_META_TYP_86_I6_D: "后置累加器，不参与乘法计算，在最后进行叠加",
  T_49_META_TYP_88_I0_D: "基础类型，最基本的游戏币，目前版本中一般商品的定价类型",
  T_49_META_TYP_89_I0_D: "目前版本中暂只有基础货币",
  T_49_META_TYP_89_I1_D: "货币数量",
  T_49_META_TYP_89_I2_D: "货币图标",
  T_49_META_TYP_89_I3_D: "货币图标颜色",
  T_49_META_TYP_90_I0_D: "钱包内容是一堆货币",
  T_49_META_TYP_92_I0_D: "方形木箱",
  T_49_META_TYP_92_I1_D: "长木箱",
  T_49_META_TYP_92_I10_D: "哨塔",
  T_49_META_TYP_92_I100_D: "楼梯",
  T_49_META_TYP_92_I101_D: "楼梯平台B",
  T_49_META_TYP_92_I102_D: "楼梯平台A",
  T_49_META_TYP_92_I103_D: "电话亭",
  T_49_META_TYP_92_I104_D: "BIS主题墙壁",
  T_49_META_TYP_92_I105_D: "BIS主题花坛",
  T_49_META_TYP_92_I106_D: "贩卖机",
  T_49_META_TYP_92_I107_D: "怪物实体",
  T_49_META_TYP_92_I108_D: "单位生成器",
  T_49_META_TYP_92_I109_D: "跑车",
  T_49_META_TYP_92_I11_D: "警卫室",
  T_49_META_TYP_92_I110_D: "tutu车",
  T_49_META_TYP_92_I111_D: "可破坏木箱",
  T_49_META_TYP_92_I112_D: "SUV",
  T_49_META_TYP_92_I113_D: "摩托车",
  T_49_META_TYP_92_I114_D: "怪兽卡车",
  T_49_META_TYP_92_I115_D: "金币生成器",
  T_49_META_TYP_92_I116_D: "楼梯平台C",
  T_49_META_TYP_92_I117_D: "指示牌",
  T_49_META_TYP_92_I118_D: "栅栏",
  T_49_META_TYP_92_I119_D: "球衣机",
  T_49_META_TYP_92_I12_D: "二层民房",
  T_49_META_TYP_92_I121_D: "水泥柱",
  T_49_META_TYP_92_I122_D: "Loot点足球组件",
  T_49_META_TYP_92_I123_D: "油桶",
  T_49_META_TYP_92_I124_D: "低重力区",
  T_49_META_TYP_92_I125_D: "武器实体",
  T_49_META_TYP_92_I126_D: "栅栏B",
  T_49_META_TYP_92_I127_D: "小矮房A",
  T_49_META_TYP_92_I128_D: "损毁的卡车",
  T_49_META_TYP_92_I129_D: "基础球体",
  T_49_META_TYP_92_I13_D: "沙雕",
  T_49_META_TYP_92_I130_D: "基础圆锥",
  T_49_META_TYP_92_I131_D: "基础圆柱",
  T_49_META_TYP_92_I132_D: "道具生成器",
  T_49_META_TYP_92_I133_D: "自定义水域",
  T_49_META_TYP_92_I134_D: "箭头",
  T_49_META_TYP_92_I135_D: "染色方块",
  T_49_META_TYP_92_I136_D: "染色油桶",
  T_49_META_TYP_92_I137_D: "文本实体",
  T_49_META_TYP_92_I138_D: "图标实体",
  T_49_META_TYP_92_I139_D: "冰娃娃",
  T_49_META_TYP_92_I14_D: "喷泉",
  T_49_META_TYP_92_I140_D: "胶囊体触发器",
  T_49_META_TYP_92_I141_D: "球体冲触发器",
  T_49_META_TYP_92_I142_D: "反射纯色基础方块1",
  T_49_META_TYP_92_I143_D: "碰碰车厂",
  T_49_META_TYP_92_I144_D: "格纹游乐园方块",
  T_49_META_TYP_92_I145_D: "大屏幕",
  T_49_META_TYP_92_I146_D: "领奖台",
  T_49_META_TYP_92_I147_D: "大型棒棒糖",
  T_49_META_TYP_92_I148_D: "小餐车b",
  T_49_META_TYP_92_I15_D: "樱花树",
  T_49_META_TYP_92_I16_D: "一层民房",
  T_49_META_TYP_92_I17_D: "三层民房",
  T_49_META_TYP_92_I18_D: "香蕉树",
  T_49_META_TYP_92_I19_D: "马桶",
  T_49_META_TYP_92_I2_D: "灌木长木箱",
  T_49_META_TYP_92_I20_D: "围栏",
  T_49_META_TYP_92_I21_D: "可破坏集装箱",
  T_49_META_TYP_92_I22_D: "可破坏栅栏",
  T_49_META_TYP_92_I23_D: "轮胎",
  T_49_META_TYP_92_I24_D: "碰碰车",
  T_49_META_TYP_92_I25_D: "水陆两用车",
  T_49_META_TYP_92_I26_D: "吉普车",
  T_49_META_TYP_92_I27_D: "垃圾桶",
  T_49_META_TYP_92_I28_D: "医疗帐篷",
  T_49_META_TYP_92_I29_D: "车库",
  T_49_META_TYP_92_I3_D: "草垛",
  T_49_META_TYP_92_I30_D: "彩绘墙",
  T_49_META_TYP_92_I31_D: "鸟居",
  T_49_META_TYP_92_I32_D: "铁台",
  T_49_META_TYP_92_I33_D: "货柜屋",
  T_49_META_TYP_92_I34_D: "拖车",
  T_49_META_TYP_92_I35_D: "墙壁A",
  T_49_META_TYP_92_I36_D: "乐符-钢琴",
  T_49_META_TYP_92_I37_D: "乐符-钢琴",
  T_49_META_TYP_92_I38_D: "乐符-鼓",
  T_49_META_TYP_92_I39_D: "乐符-鼓",
  T_49_META_TYP_92_I4_D: "废汽车",
  T_49_META_TYP_92_I40_D: "乐符-合成器A",
  T_49_META_TYP_92_I41_D: "乐符-合成器A",
  T_49_META_TYP_92_I42_D: "乐符-合成器B",
  T_49_META_TYP_92_I43_D: "乐符-合成器B",
  T_49_META_TYP_92_I44_D: "乐符-合成器C",
  T_49_META_TYP_92_I45_D: "乐符-合成器C",
  T_49_META_TYP_92_I46_D: "BUFF生成器",
  T_49_META_TYP_92_I47_D: "螺旋桨机关",
  T_49_META_TYP_92_I48_D: "平底锅机关",
  T_49_META_TYP_92_I49_D: "方块机关",
  T_49_META_TYP_92_I5_D: "废巴士",
  T_49_META_TYP_92_I50_D: "圆环机关",
  T_49_META_TYP_92_I51_D: "巨槌机关",
  T_49_META_TYP_92_I52_D: "移动板",
  T_49_META_TYP_92_I53_D: "移动靶",
  T_49_META_TYP_92_I54_D: "伸缩墙",
  T_49_META_TYP_92_I55_D: "Loot点武器组件",
  T_49_META_TYP_92_I56_D: "Loot点子弹组件",
  T_49_META_TYP_92_I57_D: "Loot点可消耗物品组件",
  T_49_META_TYP_92_I58_D: "Loot点投掷物品组件",
  T_49_META_TYP_92_I59_D: "Loot点倍镜组件",
  T_49_META_TYP_92_I6_D: "集装箱A",
  T_49_META_TYP_92_I60_D: "Loot点护甲组件",
  T_49_META_TYP_92_I61_D: "直管道",
  T_49_META_TYP_92_I62_D: "T管道",
  T_49_META_TYP_92_I63_D: "十字管道",
  T_49_META_TYP_92_I64_D: "转折管道",
  T_49_META_TYP_92_I65_D: "巨型蘑菇群",
  T_49_META_TYP_92_I66_D: "晾衣架",
  T_49_META_TYP_92_I67_D: "木板桥",
  T_49_META_TYP_92_I68_D: "屏风",
  T_49_META_TYP_92_I69_D: "混凝土柱",
  T_49_META_TYP_92_I7_D: "集装箱B",
  T_49_META_TYP_92_I70_D: "仙人掌",
  T_49_META_TYP_92_I71_D: "枯木",
  T_49_META_TYP_92_I72_D: "宫灯",
  T_49_META_TYP_92_I73_D: "路灯",
  T_49_META_TYP_92_I74_D: "太阳能板",
  T_49_META_TYP_92_I75_D: "空调",
  T_49_META_TYP_92_I76_D: "正方形",
  T_49_META_TYP_92_I77_D: "斜坡",
  T_49_META_TYP_92_I78_D: "小餐车",
  T_49_META_TYP_92_I79_D: "死亡或无敌触发器组件",
  T_49_META_TYP_92_I8_D: "集装箱C",
  T_49_META_TYP_92_I80_D: "检查点",
  T_49_META_TYP_92_I81_D: "终点",
  T_49_META_TYP_92_I82_D: "骰子",
  T_49_META_TYP_92_I83_D: "长椅",
  T_49_META_TYP_92_I84_D: "公交站",
  T_49_META_TYP_92_I85_D: "狗狗屋",
  T_49_META_TYP_92_I86_D: "广告牌",
  T_49_META_TYP_92_I87_D: "大水罐",
  T_49_META_TYP_92_I88_D: "涂鸦墙",
  T_49_META_TYP_92_I89_D: "草棚",
  T_49_META_TYP_92_I9_D: "小屋",
  T_49_META_TYP_92_I90_D: "石拱桥",
  T_49_META_TYP_92_I91_D: "伞桌组合",
  T_49_META_TYP_92_I92_D: "终点横幅",
  T_49_META_TYP_92_I93_D: "堡垒",
  T_49_META_TYP_92_I94_D: "怪物生成点",
  T_49_META_TYP_92_I95_D: "标记",
  T_49_META_TYP_92_I97_D: "自定义触发器",
  T_49_META_TYP_92_I98_D: "双扇门",
  T_49_META_TYP_92_I99_D: "路障",
  T_49_META_TYP_94_I0_D: "增加",
  T_49_META_TYP_94_I1_D: "相乘",
  T_49_META_TYP_95_I0_D: "货币类型",
  T_49_META_TYP_95_I1_D: "货币数量",
  T_49_META_TYP_96_I0_D: "获取钱包",
  T_49_META_TYP_96_I1_D: "显示位置(锚点为右上角）",
  T_49_META_TYP_97_I0_D: "世界坐标系中的位置",
  T_49_META_TYP_97_I1_D: "世界坐标系中的旋转角，XYZ分量分别是俯仰角、偏航角、翻滚角，旋转顺序YXZ。",
  T_49_META_TYP_97_I10_D: "本地坐标轴x轴朝向",
  T_49_META_TYP_97_I11_D: "本地坐标轴z轴朝向",
  T_49_META_TYP_97_I2_D: "世界坐标系中缩放尺寸",
  T_49_META_TYP_97_I3_D: "该节点的父节点",
  T_49_META_TYP_97_I4_D: "世界坐标系中的旋转，用四元数表示",
  T_49_META_TYP_97_I5_D: "本地坐标系中的位置",
  T_49_META_TYP_97_I6_D: "本地坐标系中的旋转，用四元数表示",
  T_49_META_TYP_97_I7_D: "本地坐标系中的旋转角，XYZ分量分别是俯仰角、偏航角、翻滚角，旋转顺序YXZ。",
  T_49_META_TYP_97_I8_D: "本地坐标系中的缩放尺寸",
  T_49_META_TYP_97_I9_D: "本地坐标轴y轴朝向",
  T_49_META_TYP_99_I0_D: "足球半径",
  T_49_META_TYP_99_I1_D: "普通状态下摩擦系数",
  T_49_META_TYP_99_I2_D: "冲击状态下摩擦系数",
  T_49_META_TYP_99_I3_D: "最小射门角度",
  T_49_META_TYP_99_I4_D: "高射最小角度",
  T_49_META_TYP_99_I5_D: "复位时间",
  T_49_META_TYP_99_I6_D: "射门最大角度",
  T_49_META_TYP_99_I7_D: "复位位置",
  T_49_META_TYPE_0_D: "对象，类型层次结构的根",
  T_49_META_TYPE_1_D: "列表一组数据的容器",
  T_49_META_TYPE_10_D: "实体基础组件，所有组件都会组合该组件",
  T_49_META_TYPE_100_D: "换衣机",
  T_49_META_TYPE_101_D: "玩家变身伪装组件",
  T_49_META_TYPE_1010_D: "计时界面实体组件",
  T_49_META_TYPE_1011_D: "开局横幅实体组件",
  T_49_META_TYPE_1012_D: "两队回合开始横幅实体，修改实体属性则影响对应UI上的显示内容",
  T_49_META_TYPE_1013_D: "一般回合开始横幅实体，修改实体属性则影响对应UI上的显示内容",
  T_49_META_TYPE_1014_D: "队伍回合得分横幅实体，修改实体属性则影响对应UI上的显示内容",
  T_49_META_TYPE_1015_D: "检查点管理器实体，修改实体属性则影响对应UI上的显示内容",
  T_49_META_TYPE_1016_D: "回合结束展示实体，修改实体属性则影响对应UI上的显示内容",
  T_49_META_TYPE_1017_D: "开局时如果是两队，展示两个队伍对抗横幅",
  T_49_META_TYPE_1018_D: "两队回合比分",
  T_49_META_TYPE_1019_D: "最终结果胜败平",
  T_49_META_TYPE_102_D: "复活来源类型:死亡,倒地",
  T_49_META_TYPE_1020_D: "回合数实体，修改实体属性则影响对应UI上的显示内容",
  T_49_META_TYPE_1021_D: "阶段倒计时实体，修改实体属性则影响对应UI上的显示内容",
  T_49_META_TYPE_1022_D: "比赛信息子标题实体，修改实体属性则影响对应UI上的显示内容",
  T_49_META_TYPE_1023_D: "两个队伍比赛信息实体，修改实体属性则影响对应UI上的显示内容",
  T_49_META_TYPE_1024_D: "队伍比赛信息UI实体，修改实体属性则影响对应UI上的显示内容",
  T_49_META_TYPE_1027_D: "描述类型的类型，当使用Typeof时返回该类型",
  T_49_META_TYPE_1028_D: "阵营信息实体，修改实体属性则影响对应UI上的显示内容",
  T_49_META_TYPE_1029_D: "图标提示信息实体，修改实体属性则影响对应UI上的显示内容",
  T_49_META_TYPE_103_D: "物品槽位类型枚举",
  T_49_META_TYPE_1030_D: "两个队伍比赛信息简版实体，修改实体属性则影响对应UI上的显示内容",
  T_49_META_TYPE_1031_D: "计时提示界面实体，修改实体属性则影响对应UI上的显示内容",
  T_49_META_TYPE_1032_D: "飘字提示实体，修改实体属性则影响对应UI上的显示内容",
  T_49_META_TYPE_1033_D: "回合切换实体，包括当前回合结算和下回合开始信息，修改实体属性则影响对应UI上的显示内容",
  T_49_META_TYPE_1035_D: "打开计分板按钮UI实体，修改实体属性则影响对应UI上的显示内容",
  T_49_META_TYPE_1036_D: "感染模式，显示当前僵尸等级的UI",
  T_49_META_TYPE_1037_D: "添加积分动效UI实体，修改实体属性则影响对应UI上的显示内容",
  T_49_META_TYPE_1038_D: "感染模式僵尸UI特效",
  T_49_META_TYPE_1039_D: "倒计时飘字提示实体，修改实体属性则影响对应UI上的显示内容",
  T_49_META_TYPE_104_D: "球衣样式",
  T_49_META_TYPE_1040_D: "选择卡牌UI实体",
  T_49_META_TYPE_1041_D: "身份告知UI实体",
  T_49_META_TYPE_1042_D: "5秒倒计时UI实体",
  T_49_META_TYPE_1043_D: "标题横幅UI实体",
  T_49_META_TYPE_1044_D: "通用UI开关UI实体",
  T_49_META_TYPE_1045_D: "技能按钮UI实体",
  T_49_META_TYPE_105_D: "球门",
  T_49_META_TYPE_106_D: "瞄准辅助类型类型",
  T_49_META_TYPE_107_D: "可以被瞄准以及受击，不一定会受到伤害",
  T_49_META_TYPE_108_D: "整数类型，64位带符号整型",
  T_49_META_TYPE_109_D: "聊天频道实体是一个包含了自身频道ID和玩家的容器",
  T_49_META_TYPE_11_D: "全局实体，整场游戏唯一",
  T_49_META_TYPE_110_D: "空闲语音频道",
  T_49_META_TYPE_111_D: "行为类型",
  T_49_META_TYPE_112_D: "玩家行为状态类型",
  T_49_META_TYPE_113_D: "鼓点音乐组件",
  T_49_META_TYPE_114_D: "离合器1音乐组件",
  T_49_META_TYPE_115_D: "离合器2音乐组件",
  T_49_META_TYPE_116_D: "离合器3音乐组件",
  T_49_META_TYPE_117_D: "鼓点音乐组件类型",
  T_49_META_TYPE_118_D: "阵营实体",
  T_49_META_TYPE_119_D: "可攻击选项",
  T_49_META_TYPE_12_D: "可战斗实体，能够进行攻击、受击、击杀等",
  T_49_META_TYPE_120_D: "进度UI实体",
  T_49_META_TYPE_121_D: "每波间隔时间",
  T_49_META_TYPE_122_D: "天空盒",
  T_49_META_TYPE_123_D: "天空盒基础类型枚举",
  T_49_META_TYPE_124_D: "索敌范围",
  T_49_META_TYPE_125_D: "可修改物件的基础外观，如贴图和透明度",
  T_49_META_TYPE_126_D: "血条实体",
  T_49_META_TYPE_127_D: "移动物件的移动方式",
  T_49_META_TYPE_128_D: "可被变身物件",
  T_49_META_TYPE_129_D: "Loot点子弹类型",
  T_49_META_TYPE_13_D: "UI控件实体",
  T_49_META_TYPE_130_D: "Loot点消耗品类型",
  T_49_META_TYPE_131_D: "Loot点护甲类型",
  T_49_META_TYPE_132_D: "Loot点投掷物类型",
  T_49_META_TYPE_133_D: "Loot点倍镜类型",
  T_49_META_TYPE_134_D: "Loot点武器类型",
  T_49_META_TYPE_135_D: "会产生所选类型的弹药掉落",
  T_49_META_TYPE_136_D: "会产生所选类型的道具掉落",
  T_49_META_TYPE_137_D: "会产生所选类型的投掷物掉落",
  T_49_META_TYPE_138_D: "会产生所选类型的瞄准镜掉落",
  T_49_META_TYPE_139_D: "会产生所选类型的防具掉落",
  T_49_META_TYPE_14_D: "游戏中的玩家实体，每位用户一个",
  T_49_META_TYPE_140_D: "波次",
  T_49_META_TYPE_141_D: "Loot点足球物件",
  T_49_META_TYPE_142_D: "Loot点足球组件",
  T_49_META_TYPE_143_D: "Lead1音乐组件类型",
  T_49_META_TYPE_144_D: "Lead2音乐组件类型",
  T_49_META_TYPE_145_D: "Lead3音乐组件类型",
  T_49_META_TYPE_146_D: "琴键音乐组件类型",
  T_49_META_TYPE_147_D: "提供多种预设相机类型，以及自定义相机类型",
  T_49_META_TYPE_148_D: "相机组件",
  T_49_META_TYPE_149_D: "本地化字符串",
  T_49_META_TYPE_15_D: "游戏中的队伍实体，每支队伍一个",
  T_49_META_TYPE_150_D: "油桶",
  T_49_META_TYPE_151_D: "四元数是一个特殊的四维向量，仅用于表示旋转",
  T_49_META_TYPE_152_D: "低重力区",
  T_49_META_TYPE_153_D: "实体容器，会在所在位置生成对应类型的实体",
  T_49_META_TYPE_154_D: "武器双持类型",
  T_49_META_TYPE_155_D: "头盔实体",
  T_49_META_TYPE_156_D: "防弹衣实体",
  T_49_META_TYPE_157_D: "相机切换动画类型",
  T_49_META_TYPE_158_D: "文字提示界面",
  T_49_META_TYPE_159_D: "二维向量",
  T_49_META_TYPE_16_D: "关卡物件实体",
  T_49_META_TYPE_160_D: "贴图类型",
  T_49_META_TYPE_161_D: "不可替换贴图特效物件",
  T_49_META_TYPE_162_D: "类型列表",
  T_49_META_TYPE_163_D: "类型或类型列表",
  T_49_META_TYPE_164_D: "组件是所有实体组件或具体组件类的基类",
  T_49_META_TYPE_165_D: "碰撞盒组件",
  T_49_META_TYPE_166_D: "Emote",
  T_49_META_TYPE_167_D: "特效实体表示一个显示的特效(删除，可回收复用)",
  T_49_META_TYPE_17_D: "关卡物件列表",
  T_49_META_TYPE_170_D: "表示是否可以设置可见性",
  T_49_META_TYPE_171_D: "蘑菇组件",
  T_49_META_TYPE_172_D: "子弹组件",
  T_49_META_TYPE_173_D: "背包组件",
  T_49_META_TYPE_174_D: "手雷组件",
  T_49_META_TYPE_175_D: "冰冻手雷组件",
  T_49_META_TYPE_176_D: "武器生成器",
  T_49_META_TYPE_177_D: "当相机与跟随对象中间有遮挡物时，相机的运动模式",
  T_49_META_TYPE_178_D: "相机渲染画面时的成像方式",
  T_49_META_TYPE_179_D: "基础球体",
  T_49_META_TYPE_18_D: "（已废弃，请勿使用）",
  T_49_META_TYPE_180_D: "指代某组件的某个属性",
  T_49_META_TYPE_181_D: "用以描述网格资产的类型",
  T_49_META_TYPE_182_D: "用以描述材质资产的类型",
  T_49_META_TYPE_183_D: "用以描述贴图资产的类型",
  T_49_META_TYPE_184_D: "桥接渲染组件，用于使用内置模型资源进行呈现",
  T_49_META_TYPE_185_D: "自定义渲染组件，用于使用自定义模型资源进行呈现",
  T_49_META_TYPE_186_D: "一个空白物件组件，可以配合渲染器组件、碰撞器组件等使用。",
  T_49_META_TYPE_187_D: "实体容器",
  T_49_META_TYPE_188_D: "基础圆锥或圆柱",
  T_49_META_TYPE_189_D: "本地化字符串列表",
  T_49_META_TYPE_19_D: "列表模板，可通过T指定内容的类型",
  T_49_META_TYPE_190_D: "两队结算界面",
  T_49_META_TYPE_191_D: "战术性投掷武器，可以让一定范围内的敌人陷入短暂失明",
  T_49_META_TYPE_192_D: "使用后可以产生遮蔽事件的烟雾，是打扰敌人进攻的利器",
  T_49_META_TYPE_193_D: "多队结算界面",
  T_49_META_TYPE_194_D: "可以布置在地上的感应地雷，敌人靠近就会爆炸，注意自己不要踩到",
  T_49_META_TYPE_195_D: "插值运动的播放方式",
  T_49_META_TYPE_197_D: "可播放组件",
  T_49_META_TYPE_198_D: "道具资产基类",
  T_49_META_TYPE_199_D: "实施空中作战的辅助装备，但需要随时注意能量的消耗",
  T_49_META_TYPE_2_D: "布尔类型，用以表示真、假或者是、否",
  T_49_META_TYPE_20_D: "内置界面类型枚举, 该枚举会依据类型系统自动生成",
  T_49_META_TYPE_200_D: "越狱区域",
  T_49_META_TYPE_201_D: "进入后可以游泳的区域",
  T_49_META_TYPE_202_D: "碰撞资源ID",
  T_49_META_TYPE_203_D: "插值运动",
  T_49_META_TYPE_204_D: "装配了科技动力装置的鞋，可以让你在空中二段跳跃",
  T_49_META_TYPE_205_D: "可以在天空飞行的滑翔翼，用它从高处降落可以移动到更远的地方",
  T_49_META_TYPE_206_D: "滑板",
  T_49_META_TYPE_207_D: "滑索",
  T_49_META_TYPE_208_D: "由Playable组成的列表",
  T_49_META_TYPE_209_D: "Playable或由Playable组成的列表",
  T_49_META_TYPE_21_D: "内置界面实体，封装好特定功能的界面",
  T_49_META_TYPE_210_D: "弹道动画是对弹道运动的模拟动画",
  T_49_META_TYPE_211_D: "坐标系",
  T_49_META_TYPE_212_D: "一对象跟着另一对象",
  T_49_META_TYPE_213_D: "一对象的正面始终朝向另一对象",
  T_49_META_TYPE_214_D: "用以描述图集精灵资产的ID",
  T_49_META_TYPE_215_D: "比赛结果",
  T_49_META_TYPE_216_D: "字典数据容器，数据元素是一对Key、Value",
  T_49_META_TYPE_217_D: "字典数据模板，可通过T1、T2指定内容的类型",
  T_49_META_TYPE_218_D: "光源的一种，从光源位置向所有方向发射强度相等的光线",
  T_49_META_TYPE_219_D: "摩托车载具",
  T_49_META_TYPE_22_D: "自定义界面，玩家通过界面编辑器创建的界面",
  T_49_META_TYPE_220_D: "突突车（三轮车）载具",
  T_49_META_TYPE_221_D: "两栖/机枪摩托载具",
  T_49_META_TYPE_222_D: "四轮车载具",
  T_49_META_TYPE_224_D: "技能列表",
  T_49_META_TYPE_225_D: "高科技材料制成的人工智能炮塔，会主动搜索并攻击一定范围内的敌人",
  T_49_META_TYPE_226_D: "使用炮塔道具后生成的炮塔",
  T_49_META_TYPE_227_D: "自定义UI控件类型枚举",
  T_49_META_TYPE_23_D: "关卡物件类型枚举, 该枚举会依据类型系统自动生成",
  T_49_META_TYPE_231_D: "护甲修理包",
  T_49_META_TYPE_233_D: "准备等待进度圈",
  T_49_META_TYPE_234_D: "地雷创建后的对象",
  T_49_META_TYPE_235_D: "凝胶护盾",
  T_49_META_TYPE_236_D: "冰墙(凝胶手雷)创建后的对象",
  T_49_META_TYPE_237_D: "钩锁枪",
  T_49_META_TYPE_238_D: "彩虹喷漆枪",
  T_49_META_TYPE_239_D: "喷漆枪（步枪）",
  T_49_META_TYPE_24_D: "目前系统定义的伤害类型",
  T_49_META_TYPE_240_D: "实体是所有组件的载体，组件必须附加到实体上才能产生实例",
  T_49_META_TYPE_241_D: "强力钩锁枪",
  T_49_META_TYPE_242_D: "比分条",
  T_49_META_TYPE_243_D: "服装槽位",
  T_49_META_TYPE_244_D: "文本实体表示一个显示的文本",
  T_49_META_TYPE_245_D: "图标实体表示一个显示的图标",
  T_49_META_TYPE_246_D: "喷漆颜色",
  T_49_META_TYPE_247_D: "玩家界面类型",
  T_49_META_TYPE_248_D: "通用UI开关实体",
  T_49_META_TYPE_249_D: "切换道具槽位",
  T_49_META_TYPE_25_D: "游戏过程中的阶段，比如游戏开始、游戏准备、游戏结束等",
  T_49_META_TYPE_250_D: "特效实体表示一个显示的特效",
  T_49_META_TYPE_2500_D: "玩家的出生点",
  T_49_META_TYPE_2501_D: "触发器用于触发玩家（或其它物体）的进入离开事件",
  T_49_META_TYPE_2502_D: "死亡或无敌触发器，当玩家进入时根据属性控制是死亡还是无敌效果",
  T_49_META_TYPE_2503_D: "竞速模式检查点",
  T_49_META_TYPE_2504_D: "通常是用在竞速模式中，用来识别玩家进入指定终点。这是一个特定的触发器，后期将开放自定义触发器，这个终点只是自定义触发器的封装。",
  T_49_META_TYPE_2505_D: "出生点四周的栅栏，关闭后可离开出生点",
  T_49_META_TYPE_2507_D: "防御塔",
  T_49_META_TYPE_2508_D: "僵尸生成器",
  T_49_META_TYPE_2509_D: "可按需生成对应类型的实例",
  T_49_META_TYPE_251_D: "特效物件",
  T_49_META_TYPE_2510_D: "玩家出生区域(矩形)",
  T_49_META_TYPE_252_D: "喷漆结算",
  T_49_META_TYPE_253_D: "提示按钮",
  T_49_META_TYPE_254_D: "屏幕心跳特效实体",
  T_49_META_TYPE_255_D: "时间戳本地化字符串",
  T_49_META_TYPE_256_D: "刚体类型枚举",
  T_49_META_TYPE_257_D: "刚体组件",
  T_49_META_TYPE_258_D: "时间戳格式化显示样式",
  T_49_META_TYPE_259_D: "提示",
  T_49_META_TYPE_26_D: "游戏过程中的回合，往往是一小局，包含数个阶段",
  T_49_META_TYPE_260_D: "进度技能按钮",
  T_49_META_TYPE_261_D: "唯一标识",
  T_49_META_TYPE_262_D: "枪皮ID",
  T_49_META_TYPE_263_D: "服装ID",
  T_49_META_TYPE_264_D: "道具ID，当版本只有武器ID",
  T_49_META_TYPE_265_D: "UI面板实体",
  T_49_META_TYPE_267_D: "UI滚动视图实体，玩家通过UI编辑器编辑的UI",
  T_49_META_TYPE_268_D: "具有三种状态的开关，除开启和关闭外可选择保持原有逻辑",
  T_49_META_TYPE_269_D: "玩家装备的服饰",
  T_49_META_TYPE_270_D: "逻辑实体或者PrefabID",
  T_49_META_TYPE_271_D: "UI面板实体，玩家通过UI编辑器编辑的UI",
  T_49_META_TYPE_272_D: "性别枚举",
  T_49_META_TYPE_273_D: "小地图实体组件",
  T_49_META_TYPE_274_D: "在小地图上显示的Icon，可以跟随目标移动",
  T_49_META_TYPE_275_D: "骨架中的单个部位节点",
  T_49_META_TYPE_276_D: "用来访问蒙皮骨骼的节点",
  T_49_META_TYPE_277_D: "客户端相机射线检测",
  T_49_META_TYPE_278_D: "在小地图上显示的像素块，代表该位置物件的碰撞大小",
  T_49_META_TYPE_279_D: "染色桶",
  T_49_META_TYPE_28_D: "每回合开始的时候会把状态重置",
  T_49_META_TYPE_280_D: "球体触发器",
  T_49_META_TYPE_281_D: "胶囊体触发器",
  T_49_META_TYPE_282_D: "描述资产配置ID的类型，用于表示母包自带资产配置ID，需通过配置表解析后再加载",
  T_49_META_TYPE_283_D: "描述资产的类型，用于表示资产的标识符，可直接进行加载",
  T_49_META_TYPE_284_D: "表示人形模型资源，可替换到玩家角色",
  T_49_META_TYPE_285_D: "列表或者字典，可以被循环遍历",
  T_49_META_TYPE_286_D: "用以描述脚本资产的ID",
  T_49_META_TYPE_287_D: "用以描述静态脚本资产的ID",
  T_49_META_TYPE_288_D: "用以描述自定义界面资产的ID",
  T_49_META_TYPE_289_D: "用以描述预置资产体的ID",
  T_49_META_TYPE_29_D: "特效",
  T_49_META_TYPE_290_D: "行为树",
  T_49_META_TYPE_291_D: "行为树节点类型",
  T_49_META_TYPE_292_D: "行为树自定义节点",
  T_49_META_TYPE_293_D: "可挂载行为树实体",
  T_49_META_TYPE_294_D: "UI布局实体，玩家通过UI编辑器编辑的UI",
  T_49_META_TYPE_295_D: "动画状态",
  T_49_META_TYPE_296_D: "动画片段",
  T_49_META_TYPE_297_D: "动画控制器",
  T_49_META_TYPE_298_D: "循环类型",
  T_49_META_TYPE_3_D: "整数类型，32位带符号整型",
  T_49_META_TYPE_30_D: "图标",
  T_49_META_TYPE_300_D: "UI3DContainer实体，玩家通过UI编辑器编辑的UI",
  T_49_META_TYPE_301_D: "僵尸技能类型",
  T_49_META_TYPE_302_D: "装备栏槽位枚举",
  T_49_META_TYPE_303_D: "对应BuffData.csv中Id列，增加新项前请和GPP确认是否适用",
  T_49_META_TYPE_304_D: "Buff列表",
  T_49_META_TYPE_305_D: "行为树节点运行状态",
  T_49_META_TYPE_306_D: "可以添加buff,移除buff,获得已加的buff列表",
  T_49_META_TYPE_307_D: "凝胶生成器",
  T_49_META_TYPE_308_D: "特殊道具ID枚举",
  T_49_META_TYPE_309_D: "投掷物道具",
  T_49_META_TYPE_31_D: "音效",
  T_49_META_TYPE_310_D: "十字弩",
  T_49_META_TYPE_311_D: "投掷物道具基类",
  T_49_META_TYPE_312_D: "投掷物道具",
  T_49_META_TYPE_313_D: "反制冰墙手雷组件",
  T_49_META_TYPE_314_D: "管理动画控制器与资源",
  T_49_META_TYPE_315_D: "玩家背包实体",
  T_49_META_TYPE_316_D: "UITexture实体，玩家通过UI编辑器编辑的UI",
  T_49_META_TYPE_317_D: "刚体运动限制，每种限制可组合使用",
  T_49_META_TYPE_318_D: "配件道具",
  T_49_META_TYPE_319_D: "填充类型枚举",
  T_49_META_TYPE_32_D: "玩家状态类型",
  T_49_META_TYPE_320_D: "填充方向枚举",
  T_49_META_TYPE_321_D: "可以被辅助瞄准的实体",
  T_49_META_TYPE_322_D: "击中身体部位类型",
  T_49_META_TYPE_323_D: "UIProfileInfo实体，玩家通过UI编辑器编辑的UI",
  T_49_META_TYPE_324_D: "刚体受力的几种不同效果。注意只对Dynamic类型的刚体有效",
  T_49_META_TYPE_325_D: "用以描述自定义界面资产中的控件的ID",
  T_49_META_TYPE_326_D: "玩家简介信息",
  T_49_META_TYPE_327_D: "按照各部件配置换装",
  T_49_META_TYPE_328_D: "行为树资产ID",
  T_49_META_TYPE_329_D: "载具座位枚举",
  T_49_META_TYPE_33_D: "排序方式：升序忽略零值、降序、升序",
  T_49_META_TYPE_330_D: "相对自身进行的运动",
  T_49_META_TYPE_331_D: "贝塞尔曲线",
  T_49_META_TYPE_332_D: "可循环组件",
  T_49_META_TYPE_333_D: "字体枚举",
  T_49_META_TYPE_334_D: "载具皮肤ID",
  T_49_META_TYPE_335_D: "音效实体表示一个播放的音效",
  T_49_META_TYPE_336_D: "音效实体列表",
  T_49_META_TYPE_337_D: "SoundEntity或SoundEntity数组",
  T_49_META_TYPE_338_D: "玩家行为属性同步实体",
  T_49_META_TYPE_339_D: "装备配件道具",
  T_49_META_TYPE_34_D: "道具类型",
  T_49_META_TYPE_340_D: "Bot难度枚举",
  T_49_META_TYPE_341_D: "整数字典",
  T_49_META_TYPE_342_D: "计时器物件",
  T_49_META_TYPE_343_D: "飞刀(可拾取)",
  T_49_META_TYPE_344_D: "飞刀",
  T_49_META_TYPE_345_D: "武器类型",
  T_49_META_TYPE_346_D: "子弹类型",
  T_49_META_TYPE_347_D: "相对自身每帧运动",
  T_49_META_TYPE_348_D: "函数指针指向某个函数实例，用以实现虚函数或者委托机制",
  T_49_META_TYPE_349_D: "指代某个协程的句柄，可以进行一些句柄操作",
  T_49_META_TYPE_350_D: "载具枚举",
  T_49_META_TYPE_351_D: "描述物件的类型",
  T_49_META_TYPE_352_D: "UIToggle实体，玩家通过UI编辑器编辑的UI",
  T_49_META_TYPE_353_D: "医疗包",
  T_49_META_TYPE_354_D: "呼吸器",
  T_49_META_TYPE_355_D: "急救针",
  T_49_META_TYPE_356_D: "空投，准备时间结束后会开始从高处掉落",
  T_49_META_TYPE_357_D: "物件的描述性颜色，如边框、表面等（删除，可回收复用）",
  T_49_META_TYPE_358_D: "指代某个事件",
  T_49_META_TYPE_359_D: "带物理效果的玩家控制器，可施力受力",
  T_49_META_TYPE_360_D: "随身人间大炮",
  T_49_META_TYPE_361_D: "折叠后的大炮，展开后可以用来把人发射出去，要小心不要把自己发射出安全区！",
  T_49_META_TYPE_362_D: "打雪仗！冲啊！",
  T_49_META_TYPE_363_D: "商店请求购买",
  T_49_META_TYPE_364_D: "动画触发器",
  T_49_META_TYPE_365_D: "动画触发器界面组件",
  T_49_META_TYPE_366_D: "合并子物件节点渲染组件",
  T_49_META_TYPE_367_D: "顶部罗盘",
  T_49_META_TYPE_368_D: "自定义角色资源ID",
  T_49_META_TYPE_369_D: "自定义动画资源ID",
  T_49_META_TYPE_370_D: "回合开始展示的信息",
  T_49_META_TYPE_371_D: "每回合结束，展示结果",
  T_49_META_TYPE_372_D: "玩家姿态类型",
  T_49_META_TYPE_373_D: "藏品ID，用于资源信息收集",
  T_49_META_TYPE_374_D: "角色跟随头顶描述",
  T_49_META_TYPE_375_D: "怪物攻击目标类型枚举",
  T_49_META_TYPE_376_D: "防御塔攻击目标类型枚举",
  T_49_META_TYPE_377_D: "指代玩家实体、载具实体类型的别名",
  T_49_META_TYPE_378_D: "用以描述音频资产的ID",
  T_49_META_TYPE_379_D: "用以描述配置表资产的ID",
  T_49_META_TYPE_38_D: "UI空Widget实体，玩家通过UI编辑器编辑的UI",
  T_49_META_TYPE_380_D: "用以描述特效资产的ID",
  T_49_META_TYPE_381_D: "用以描述动画控制器资产的ID",
  T_49_META_TYPE_382_D: "击倒状态处理方式",
  T_49_META_TYPE_383_D: "地图本身的地表或装饰物",
  T_49_META_TYPE_384_D: "物品列表",
  T_49_META_TYPE_385_D: "人物技能ID",
  T_49_META_TYPE_386_D: "技能ID列表",
  T_49_META_TYPE_387_D: "UITouchPad实体，玩家通过UI编辑器编辑的UI",
  T_49_META_TYPE_388_D: "背包皮肤ID",
  T_49_META_TYPE_389_D: "Joystick实体，玩家通过UI编辑器编辑的UI",
  T_49_META_TYPE_39_D: "UI图片实体，玩家通过UI编辑器编辑的UI",
  T_49_META_TYPE_390_D: "可以挂载子节点的实体",
  T_49_META_TYPE_391_D: "UI或UI控件",
  T_49_META_TYPE_392_D: "可摆放的毒圈物件",
  T_49_META_TYPE_393_D: "带有PhysicalCCT或Rigidbody组件的实体",
  T_49_META_TYPE_394_D: "数学常数",
  T_49_META_TYPE_395_D: "带有PhysicalCCT或PlayerCCT组件的实体可以随其一起运动",
  T_49_META_TYPE_396_D: "中途退出配置",
  T_49_META_TYPE_397_D: "用于描述碰撞形状的组件",
  T_49_META_TYPE_398_D: "字符串或本地化字符串",
  T_49_META_TYPE_399_D: "带物理效果的角色控制器，仅用于FF角色",
  T_49_META_TYPE_4_D: "浮点类型，32位单精度浮点数",
  T_49_META_TYPE_40_D: "UI文本实体，玩家通过UI编辑器编辑的UI",
  T_49_META_TYPE_400_D: "如何进行攻击行为",
  T_49_META_TYPE_401_D: "开火类型",
  T_49_META_TYPE_402_D: "社交功能按钮",
  T_49_META_TYPE_403_D: "社交按钮类型",
  T_49_META_TYPE_404_D: "社交按钮样式",
  T_49_META_TYPE_405_D: "布局排序类型",
  T_49_META_TYPE_406_D: "可触发翻越障碍物",
  T_49_META_TYPE_407_D: "平台类型",
  T_49_META_TYPE_408_D: "基础数据类型别名",
  T_49_META_TYPE_409_D: "错误码枚举",
  T_49_META_TYPE_41_D: "UI按钮实体，玩家通过UI编辑器编辑的UI",
  T_49_META_TYPE_410_D: "指代玩家实体或Transform实体类型的别名",
  T_49_META_TYPE_411_D: "直升机载具",
  T_49_META_TYPE_412_D: "汽车组件，是载具组件的功能扩充",
  T_49_META_TYPE_413_D: "NPC物件",
  T_49_META_TYPE_414_D: "限制摄像机转动的角度范围",
  T_49_META_TYPE_415_D: "Persona",
  T_49_META_TYPE_416_D: "Persona聊天窗口界面",
  T_49_META_TYPE_417_D: "粒子实体组件",
  T_49_META_TYPE_418_D: "会员状态枚举",
  T_49_META_TYPE_419_D: "枪械皮肤类型",
  T_49_META_TYPE_42_D: "UI输入实体，玩家通过UI编辑器编辑的UI",
  T_49_META_TYPE_420_D: "载具皮肤类型",
  T_49_META_TYPE_421_D: "皮肤类型",
  T_49_META_TYPE_422_D: "背包皮肤类型",
  T_49_META_TYPE_423_D: "智能体ID",
  T_49_META_TYPE_424_D: "雾效基础类型",
  T_49_META_TYPE_425_D: "粒子资产ID",
  T_49_META_TYPE_426_D: "光源的一种，从光源开始向光源的Y轴负向发射锥形光线，默认照射地面",
  T_49_META_TYPE_427_D: "NPC物件",
  T_49_META_TYPE_428_D: "玩家变身为其他角色时需要保留的服饰信息",
  T_49_META_TYPE_429_D: "玩家或NPC实体",
  T_49_META_TYPE_43_D: "元素类型须为玩家实体的列表",
  T_49_META_TYPE_430_D: "随机数生成器",
  T_49_META_TYPE_431_D: "运动对象沿着自定义路径运动",
  T_49_META_TYPE_432_D: "自定义曲线路径路点",
  T_49_META_TYPE_433_D: "自定义曲线路径路点类型",
  T_49_META_TYPE_434_D: "自定义曲线路径",
  T_49_META_TYPE_435_D: "玩家唯一标识列表",
  T_49_META_TYPE_436_D: "错误码列表",
  T_49_META_TYPE_437_D: "两队比赛详情UI实体，修改实体属性则影响对应UI上的显示内容",
  T_49_META_TYPE_438_D: "多队比赛详情UI实体，修改实体属性则影响对应UI上的显示内容",
  T_49_META_TYPE_439_D: "组合",
  T_49_META_TYPE_44_D: "元素类型须为队伍实体的列表",
  T_49_META_TYPE_440_D: "时间轴",
  T_49_META_TYPE_441_D: "时间轴资源ID",
  T_49_META_TYPE_442_D: "新两队比赛信息简版实体组件，支持完全自定义的人数显示",
  T_49_META_TYPE_443_D: "对话流资产ID",
  T_49_META_TYPE_444_D: "语言类型",
  T_49_META_TYPE_45_D: "布尔列表",
  T_49_META_TYPE_46_D: "整数列表",
  T_49_META_TYPE_47_D: "小数列表",
  T_49_META_TYPE_48_D: "字符串列表",
  T_49_META_TYPE_49_D: "三维向量列表",
  T_49_META_TYPE_5_D: "字符串类型，值是文本内容",
  T_49_META_TYPE_50_D: "元素类型须为实体的列表",
  T_49_META_TYPE_51_D: "僵尸类型",
  T_49_META_TYPE_53_D: "普通关卡物件",
  T_49_META_TYPE_54_D: "可破坏物件",
  T_49_META_TYPE_55_D: "通用出生点",
  T_49_META_TYPE_56_D: "载具组件",
  T_49_META_TYPE_57_D: "玩家进入时可被传送到指定地点",
  T_49_META_TYPE_58_D: "可按需生成buff",
  T_49_META_TYPE_59_D: "移动平台",
  T_49_META_TYPE_6_D: "三维向量，可表示空间坐标或空间方向",
  T_49_META_TYPE_60_D: "会产生所选类型的武器掉落",
  T_49_META_TYPE_61_D: "进入触发范围可以打开绑定商店",
  T_49_META_TYPE_62_D: "弹跳性极佳的骰子",
  T_49_META_TYPE_63_D: "玩家踩上去会被弹飞到指定位置",
  T_49_META_TYPE_64_D: "玩家踩上去会发出声音",
  T_49_META_TYPE_65_D: "基础方块或斜坡",
  T_49_META_TYPE_66_D: "自定义路径",
  T_49_META_TYPE_67_D: "路径点",
  T_49_META_TYPE_68_D: "AI怪物实体，例如僵尸",
  T_49_META_TYPE_69_D: "大数是高精度浮点数",
  T_49_META_TYPE_7_D: "数字是类型别名，指代整数、64位整数或浮点类型",
  T_49_META_TYPE_70_D: "属性公式用于计算实体属性值，暂只支持部分玩家属性、武器属性",
  T_49_META_TYPE_71_D: "仅用于商店出售的实体，商品与购买商品得到的物品概念不同",
  T_49_META_TYPE_72_D: "包含若干个商品",
  T_49_META_TYPE_73_D: "包含若干个货架",
  T_49_META_TYPE_74_D: "道具类型",
  T_49_META_TYPE_75_D: "巡逻方式",
  T_49_META_TYPE_76_D: "巡逻风格",
  T_49_META_TYPE_77_D: "可以生成，刷新物件的生成器实体",
  T_49_META_TYPE_78_D: "可以被单位生成器用来吸取，并按批次生成的单位实体",
  T_49_META_TYPE_79_D: "武器实体",
  T_49_META_TYPE_8_D: "条件是特殊的Bool类型",
  T_49_META_TYPE_80_D: "商店界面",
  T_49_META_TYPE_81_D: "BUFF类型",
  T_49_META_TYPE_82_D: "心跳UI实体",
  T_49_META_TYPE_83_D: "交互按钮界面实体组件",
  T_49_META_TYPE_84_D: "可排名实体，能够进行排名",
  T_49_META_TYPE_85_D: "可积分实体，有自己的积分",
  T_49_META_TYPE_86_D: "属性公式因子类型",
  T_49_META_TYPE_87_D: "描述RGBA颜色的类型，每个通道取值范围0~255",
  T_49_META_TYPE_88_D: "货币类型，目前只有基础货币类型",
  T_49_META_TYPE_89_D: "货币实体，用以描述货币的种类和数量",
  T_49_META_TYPE_9_D: "一组条件",
  T_49_META_TYPE_90_D: "钱包实体是一堆货币实体的容器",
  T_49_META_TYPE_91_D: "指代整数或整数数组类型",
  T_49_META_TYPE_92_D: "可动态创建物件类型",
  T_49_META_TYPE_93_D: "可公式化属性的实体",
  T_49_META_TYPE_94_D: "属性修改方式",
  T_49_META_TYPE_95_D: "金币生成器",
  T_49_META_TYPE_96_D: "钱包",
  T_49_META_TYPE_97_D: "位置旋转缩放，支持父子结构",
  T_49_META_TYPE_98_D: "列举出所有可用的类型",
  T_49_META_TYPE_99_D: "足球"
};
export {
  _ as default
};
